var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], e) : "object" == typeof exports ? exports["calliope-mermaid"] = e(require("react"), require("react-dom")) : t["calliope-mermaid"] = e(t.react, t["react-dom"]);
}(window, function (t, e) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 6);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;

    var r,
        i = function (t) {
      if (t && t.__esModule) return t;
      if (null === t || "object" != typeof t && "function" != typeof t) return {
        default: t
      };
      var e = o();
      if (e && e.has(t)) return e.get(t);
      var n = {},
          r = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var i in t) {
        if (Object.prototype.hasOwnProperty.call(t, i)) {
          var a = r ? Object.getOwnPropertyDescriptor(t, i) : null;
          a && (a.get || a.set) ? Object.defineProperty(n, i, a) : n[i] = t[i];
        }
      }

      n.default = t, e && e.set(t, n);
      return n;
    }(n(0)),
        a = (r = n(7)) && r.__esModule ? r : {
      default: r
    };

    function o() {
      if ("function" != typeof WeakMap) return null;
      var t = new WeakMap();
      return o = function o() {
        return t;
      }, t;
    }

    function s(t, e) {
      var n = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function c(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var u = {
      startOnLoad: !0,
      theme: "forest",
      logLevel: "fatal",
      securityLevel: "strict",
      arrowMarkerAbsolute: !1,
      flowchart: {
        htmlLabels: !0,
        curve: "linear"
      },
      sequence: {
        diagramMarginX: 50,
        diagramMarginY: 10,
        actorMargin: 50,
        width: 150,
        height: 65,
        boxMargin: 10,
        boxTextMargin: 5,
        noteMargin: 10,
        messageMargin: 35,
        mirrorActors: !0,
        bottomMarginAdj: 1,
        useMaxWidth: !0,
        rightAngles: !1,
        showSequenceNumbers: !1
      },
      gantt: {
        titleTopMargin: 25,
        barHeight: 20,
        barGap: 4,
        topPadding: 50,
        leftPadding: 75,
        gridLineStartPadding: 35,
        fontSize: 11,
        fontFamily: '"Open-Sans", "sans-serif"',
        numberSectionStyles: 4,
        axisFormat: "%Y-%m-%d"
      }
    },
        l = function l(t) {
      var e = t.name,
          n = t.chart,
          r = t.config;
      return a.default.initialize(function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(n), !0).forEach(function (e) {
            c(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }

        return t;
      }({}, u, {}, r)), (0, i.useEffect)(function () {
        a.default.contentLoaded();
      }, [r]), n ? i.default.createElement("div", {
        className: "mermaid",
        name: e
      }, n) : null;
    };

    e.default = l;
  }, function (t, e, n) {
    t.exports = n(12);
  }, function (t, n) {
    t.exports = e;
  }, function (t, e, n) {
    "use strict";

    var r = n(8),
        i = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0
    },
        a = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0
    },
        o = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0
    },
        s = {};

    function c(t) {
      return r.isMemo(t) ? o : s[t.$$typeof] || i;
    }

    s[r.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    }, s[r.Memo] = o;
    var u = Object.defineProperty,
        l = Object.getOwnPropertyNames,
        h = Object.getOwnPropertySymbols,
        f = Object.getOwnPropertyDescriptor,
        d = Object.getPrototypeOf,
        p = Object.prototype;

    t.exports = function t(e, n, r) {
      if ("string" != typeof n) {
        if (p) {
          var i = d(n);
          i && i !== p && t(e, i, r);
        }

        var o = l(n);
        h && (o = o.concat(h(n)));

        for (var s = c(e), y = c(n), g = 0; g < o.length; ++g) {
          var m = o[g];

          if (!(a[m] || r && r[m] || y && y[m] || s && s[m])) {
            var v = f(n, m);

            try {
              u(e, m, v);
            } catch (t) {}
          }
        }
      }

      return e;
    };
  }, function (t, e, n) {
    t.exports = n(10)();
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0),
        i = n.n(r),
        a = n(1),
        o = n.n(a),
        s = n(2);

    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function u(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function l(t, e) {
      return (l = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function h(t) {
      var e = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }();

      return function () {
        var n,
            r = d(t);

        if (e) {
          var i = d(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return f(this, n);
      };
    }

    function f(t, e) {
      if (e && ("object" === c(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t);
    }

    function d(t) {
      return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    var p = function (t) {
      !function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && l(t, e);
      }(s, t);
      var e,
          n,
          r,
          a = h(s);

      function s(t) {
        var e;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, s), (e = a.call(this, t)).state = {
          diagram: t.diagram,
          updated: Date.now()
        }, e;
      }

      return e = s, (n = [{
        key: "componentWillReceiveProps",
        value: function value(t) {
          console.log(t), JSON.stringify(this.props.diagram) != JSON.stringify(t.diagram) && this.setState({
            diagram: t.diagram,
            updated: Date.now()
          });
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.state,
              e = t.diagram,
              n = t.updated;
          return i.a.createElement(i.a.Fragment, null, i.a.createElement(o.a, {
            key: n,
            chart: String(e).replaceAll("\\n", "\n")
          }));
        }
      }]) && u(e.prototype, n), r && u(e, r), s;
    }(r.Component);

    e.default = Object(s.collect)(p);
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "default", function () {
      return o;
    });
    /*! For license information please see mermaid.esm.min.mjs.LICENSE.txt */

    var r = {
      5051: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t2, e, n, r) {
            for (n = n || {}, r = _t2.length; r--; n[_t2[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 6],
              n = [1, 7],
              r = [1, 8],
              i = [1, 9],
              a = [1, 12],
              o = [1, 11],
              s = [1, 15, 24],
              c = [1, 19],
              u = [1, 31],
              l = [1, 34],
              h = [1, 32],
              f = [1, 33],
              d = [1, 35],
              p = [1, 36],
              y = [1, 37],
              g = [1, 38],
              m = [1, 41],
              v = [1, 42],
              b = [1, 43],
              _ = [1, 44],
              x = [15, 24],
              w = [1, 56],
              k = [1, 57],
              T = [1, 58],
              E = [1, 59],
              C = [1, 60],
              S = [1, 61],
              A = [15, 24, 31, 38, 39, 47, 50, 51, 52, 53, 54, 55, 60, 62],
              M = [15, 24, 29, 31, 38, 39, 43, 47, 50, 51, 52, 53, 54, 55, 60, 62, 77, 78, 79, 80],
              N = [7, 8, 9, 10, 15, 18, 22, 24],
              D = [47, 77, 78, 79, 80],
              O = [47, 54, 55, 77, 78, 79, 80],
              B = [47, 50, 51, 52, 53, 77, 78, 79, 80],
              L = [15, 24, 31],
              I = [1, 93],
              R = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              mermaidDoc: 4,
              direction: 5,
              directive: 6,
              direction_tb: 7,
              direction_bt: 8,
              direction_rl: 9,
              direction_lr: 10,
              graphConfig: 11,
              openDirective: 12,
              typeDirective: 13,
              closeDirective: 14,
              NEWLINE: 15,
              ":": 16,
              argDirective: 17,
              open_directive: 18,
              type_directive: 19,
              arg_directive: 20,
              close_directive: 21,
              CLASS_DIAGRAM: 22,
              statements: 23,
              EOF: 24,
              statement: 25,
              className: 26,
              alphaNumToken: 27,
              classLiteralName: 28,
              GENERICTYPE: 29,
              relationStatement: 30,
              LABEL: 31,
              classStatement: 32,
              methodStatement: 33,
              annotationStatement: 34,
              clickStatement: 35,
              cssClassStatement: 36,
              CLASS: 37,
              STYLE_SEPARATOR: 38,
              STRUCT_START: 39,
              members: 40,
              STRUCT_STOP: 41,
              ANNOTATION_START: 42,
              ANNOTATION_END: 43,
              MEMBER: 44,
              SEPARATOR: 45,
              relation: 46,
              STR: 47,
              relationType: 48,
              lineType: 49,
              AGGREGATION: 50,
              EXTENSION: 51,
              COMPOSITION: 52,
              DEPENDENCY: 53,
              LINE: 54,
              DOTTED_LINE: 55,
              CALLBACK: 56,
              LINK: 57,
              LINK_TARGET: 58,
              CLICK: 59,
              CALLBACK_NAME: 60,
              CALLBACK_ARGS: 61,
              HREF: 62,
              CSSCLASS: 63,
              commentToken: 64,
              textToken: 65,
              graphCodeTokens: 66,
              textNoTagsToken: 67,
              TAGSTART: 68,
              TAGEND: 69,
              "==": 70,
              "--": 71,
              PCT: 72,
              DEFAULT: 73,
              SPACE: 74,
              MINUS: 75,
              keywords: 76,
              UNICODE_TEXT: 77,
              NUM: 78,
              ALPHA: 79,
              BQUOTE_STR: 80,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              7: "direction_tb",
              8: "direction_bt",
              9: "direction_rl",
              10: "direction_lr",
              15: "NEWLINE",
              16: ":",
              18: "open_directive",
              19: "type_directive",
              20: "arg_directive",
              21: "close_directive",
              22: "CLASS_DIAGRAM",
              24: "EOF",
              29: "GENERICTYPE",
              31: "LABEL",
              37: "CLASS",
              38: "STYLE_SEPARATOR",
              39: "STRUCT_START",
              41: "STRUCT_STOP",
              42: "ANNOTATION_START",
              43: "ANNOTATION_END",
              44: "MEMBER",
              45: "SEPARATOR",
              47: "STR",
              50: "AGGREGATION",
              51: "EXTENSION",
              52: "COMPOSITION",
              53: "DEPENDENCY",
              54: "LINE",
              55: "DOTTED_LINE",
              56: "CALLBACK",
              57: "LINK",
              58: "LINK_TARGET",
              59: "CLICK",
              60: "CALLBACK_NAME",
              61: "CALLBACK_ARGS",
              62: "HREF",
              63: "CSSCLASS",
              66: "graphCodeTokens",
              68: "TAGSTART",
              69: "TAGEND",
              70: "==",
              71: "--",
              72: "PCT",
              73: "DEFAULT",
              74: "SPACE",
              75: "MINUS",
              76: "keywords",
              77: "UNICODE_TEXT",
              78: "NUM",
              79: "ALPHA",
              80: "BQUOTE_STR"
            },
            productions_: [0, [3, 1], [3, 1], [3, 2], [5, 1], [5, 1], [5, 1], [5, 1], [4, 1], [6, 4], [6, 6], [12, 1], [13, 1], [17, 1], [14, 1], [11, 4], [23, 1], [23, 2], [23, 3], [26, 1], [26, 1], [26, 2], [26, 2], [26, 2], [25, 1], [25, 2], [25, 1], [25, 1], [25, 1], [25, 1], [25, 1], [25, 1], [25, 1], [32, 2], [32, 4], [32, 5], [32, 7], [34, 4], [40, 1], [40, 2], [33, 1], [33, 2], [33, 1], [33, 1], [30, 3], [30, 4], [30, 4], [30, 5], [46, 3], [46, 2], [46, 2], [46, 1], [48, 1], [48, 1], [48, 1], [48, 1], [49, 1], [49, 1], [35, 3], [35, 4], [35, 3], [35, 4], [35, 4], [35, 5], [35, 3], [35, 4], [35, 4], [35, 5], [35, 3], [35, 4], [35, 4], [35, 5], [36, 3], [64, 1], [64, 1], [65, 1], [65, 1], [65, 1], [65, 1], [65, 1], [65, 1], [65, 1], [67, 1], [67, 1], [67, 1], [67, 1], [27, 1], [27, 1], [27, 1], [28, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 4:
                  r.setDirection("TB");
                  break;

                case 5:
                  r.setDirection("BT");
                  break;

                case 6:
                  r.setDirection("RL");
                  break;

                case 7:
                  r.setDirection("LR");
                  break;

                case 11:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 12:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 13:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 14:
                  r.parseDirective("}%%", "close_directive", "class");
                  break;

                case 19:
                case 20:
                  this.$ = a[s];
                  break;

                case 21:
                  this.$ = a[s - 1] + a[s];
                  break;

                case 22:
                case 23:
                  this.$ = a[s - 1] + "~" + a[s];
                  break;

                case 24:
                  r.addRelation(a[s]);
                  break;

                case 25:
                  a[s - 1].title = r.cleanupLabel(a[s]), r.addRelation(a[s - 1]);
                  break;

                case 33:
                  r.addClass(a[s]);
                  break;

                case 34:
                  r.addClass(a[s - 2]), r.setCssClass(a[s - 2], a[s]);
                  break;

                case 35:
                  r.addClass(a[s - 3]), r.addMembers(a[s - 3], a[s - 1]);
                  break;

                case 36:
                  r.addClass(a[s - 5]), r.setCssClass(a[s - 5], a[s - 3]), r.addMembers(a[s - 5], a[s - 1]);
                  break;

                case 37:
                  r.addAnnotation(a[s], a[s - 2]);
                  break;

                case 38:
                  this.$ = [a[s]];
                  break;

                case 39:
                  a[s].push(a[s - 1]), this.$ = a[s];
                  break;

                case 40:
                  break;

                case 41:
                  r.addMember(a[s - 1], r.cleanupLabel(a[s]));
                  break;

                case 42:
                case 43:
                  break;

                case 44:
                  this.$ = {
                    id1: a[s - 2],
                    id2: a[s],
                    relation: a[s - 1],
                    relationTitle1: "none",
                    relationTitle2: "none"
                  };
                  break;

                case 45:
                  this.$ = {
                    id1: a[s - 3],
                    id2: a[s],
                    relation: a[s - 1],
                    relationTitle1: a[s - 2],
                    relationTitle2: "none"
                  };
                  break;

                case 46:
                  this.$ = {
                    id1: a[s - 3],
                    id2: a[s],
                    relation: a[s - 2],
                    relationTitle1: "none",
                    relationTitle2: a[s - 1]
                  };
                  break;

                case 47:
                  this.$ = {
                    id1: a[s - 4],
                    id2: a[s],
                    relation: a[s - 2],
                    relationTitle1: a[s - 3],
                    relationTitle2: a[s - 1]
                  };
                  break;

                case 48:
                  this.$ = {
                    type1: a[s - 2],
                    type2: a[s],
                    lineType: a[s - 1]
                  };
                  break;

                case 49:
                  this.$ = {
                    type1: "none",
                    type2: a[s],
                    lineType: a[s - 1]
                  };
                  break;

                case 50:
                  this.$ = {
                    type1: a[s - 1],
                    type2: "none",
                    lineType: a[s]
                  };
                  break;

                case 51:
                  this.$ = {
                    type1: "none",
                    type2: "none",
                    lineType: a[s]
                  };
                  break;

                case 52:
                  this.$ = r.relationType.AGGREGATION;
                  break;

                case 53:
                  this.$ = r.relationType.EXTENSION;
                  break;

                case 54:
                  this.$ = r.relationType.COMPOSITION;
                  break;

                case 55:
                  this.$ = r.relationType.DEPENDENCY;
                  break;

                case 56:
                  this.$ = r.lineType.LINE;
                  break;

                case 57:
                  this.$ = r.lineType.DOTTED_LINE;
                  break;

                case 58:
                case 64:
                  this.$ = a[s - 2], r.setClickEvent(a[s - 1], a[s]);
                  break;

                case 59:
                case 65:
                  this.$ = a[s - 3], r.setClickEvent(a[s - 2], a[s - 1]), r.setTooltip(a[s - 2], a[s]);
                  break;

                case 60:
                case 68:
                  this.$ = a[s - 2], r.setLink(a[s - 1], a[s]);
                  break;

                case 61:
                  this.$ = a[s - 3], r.setLink(a[s - 2], a[s - 1], a[s]);
                  break;

                case 62:
                case 70:
                  this.$ = a[s - 3], r.setLink(a[s - 2], a[s - 1]), r.setTooltip(a[s - 2], a[s]);
                  break;

                case 63:
                case 71:
                  this.$ = a[s - 4], r.setLink(a[s - 3], a[s - 2], a[s]), r.setTooltip(a[s - 3], a[s - 1]);
                  break;

                case 66:
                  this.$ = a[s - 3], r.setClickEvent(a[s - 2], a[s - 1], a[s]);
                  break;

                case 67:
                  this.$ = a[s - 4], r.setClickEvent(a[s - 3], a[s - 2], a[s - 1]), r.setTooltip(a[s - 3], a[s]);
                  break;

                case 69:
                  this.$ = a[s - 3], r.setLink(a[s - 2], a[s - 1], a[s]);
                  break;

                case 72:
                  r.setCssClass(a[s - 1], a[s]);
              }
            },
            table: [{
              3: 1,
              4: 2,
              5: 3,
              6: 4,
              7: e,
              8: n,
              9: r,
              10: i,
              11: 5,
              12: 10,
              18: a,
              22: o
            }, {
              1: [3]
            }, {
              1: [2, 1]
            }, {
              1: [2, 2]
            }, {
              3: 13,
              4: 2,
              5: 3,
              6: 4,
              7: e,
              8: n,
              9: r,
              10: i,
              11: 5,
              12: 10,
              18: a,
              22: o
            }, {
              1: [2, 8]
            }, t(s, [2, 4]), t(s, [2, 5]), t(s, [2, 6]), t(s, [2, 7]), {
              13: 14,
              19: [1, 15]
            }, {
              15: [1, 16]
            }, {
              19: [2, 11]
            }, {
              1: [2, 3]
            }, {
              14: 17,
              16: [1, 18],
              21: c
            }, t([16, 21], [2, 12]), {
              5: 29,
              6: 28,
              7: e,
              8: n,
              9: r,
              10: i,
              12: 10,
              18: a,
              23: 20,
              25: 21,
              26: 30,
              27: 39,
              28: 40,
              30: 22,
              32: 23,
              33: 24,
              34: 25,
              35: 26,
              36: 27,
              37: u,
              42: l,
              44: h,
              45: f,
              56: d,
              57: p,
              59: y,
              63: g,
              77: m,
              78: v,
              79: b,
              80: _
            }, {
              15: [1, 45]
            }, {
              17: 46,
              20: [1, 47]
            }, {
              15: [2, 14]
            }, {
              24: [1, 48]
            }, {
              15: [1, 49],
              24: [2, 16]
            }, t(x, [2, 24], {
              31: [1, 50]
            }), t(x, [2, 26]), t(x, [2, 27]), t(x, [2, 28]), t(x, [2, 29]), t(x, [2, 30]), t(x, [2, 31]), t(x, [2, 32]), t(x, [2, 40], {
              46: 51,
              48: 54,
              49: 55,
              31: [1, 53],
              47: [1, 52],
              50: w,
              51: k,
              52: T,
              53: E,
              54: C,
              55: S
            }), {
              26: 62,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, t(x, [2, 42]), t(x, [2, 43]), {
              27: 63,
              77: m,
              78: v,
              79: b
            }, {
              26: 64,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, {
              26: 65,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, {
              26: 66,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, {
              47: [1, 67]
            }, t(A, [2, 19], {
              27: 39,
              28: 40,
              26: 68,
              29: [1, 69],
              77: m,
              78: v,
              79: b,
              80: _
            }), t(A, [2, 20], {
              29: [1, 70]
            }), t(M, [2, 86]), t(M, [2, 87]), t(M, [2, 88]), t([15, 24, 29, 31, 38, 39, 47, 50, 51, 52, 53, 54, 55, 60, 62], [2, 89]), t(N, [2, 9]), {
              14: 71,
              21: c
            }, {
              21: [2, 13]
            }, {
              1: [2, 15]
            }, {
              5: 29,
              6: 28,
              7: e,
              8: n,
              9: r,
              10: i,
              12: 10,
              18: a,
              23: 72,
              24: [2, 17],
              25: 21,
              26: 30,
              27: 39,
              28: 40,
              30: 22,
              32: 23,
              33: 24,
              34: 25,
              35: 26,
              36: 27,
              37: u,
              42: l,
              44: h,
              45: f,
              56: d,
              57: p,
              59: y,
              63: g,
              77: m,
              78: v,
              79: b,
              80: _
            }, t(x, [2, 25]), {
              26: 73,
              27: 39,
              28: 40,
              47: [1, 74],
              77: m,
              78: v,
              79: b,
              80: _
            }, {
              46: 75,
              48: 54,
              49: 55,
              50: w,
              51: k,
              52: T,
              53: E,
              54: C,
              55: S
            }, t(x, [2, 41]), {
              49: 76,
              54: C,
              55: S
            }, t(D, [2, 51], {
              48: 77,
              50: w,
              51: k,
              52: T,
              53: E
            }), t(O, [2, 52]), t(O, [2, 53]), t(O, [2, 54]), t(O, [2, 55]), t(B, [2, 56]), t(B, [2, 57]), t(x, [2, 33], {
              38: [1, 78],
              39: [1, 79]
            }), {
              43: [1, 80]
            }, {
              47: [1, 81]
            }, {
              47: [1, 82]
            }, {
              60: [1, 83],
              62: [1, 84]
            }, {
              27: 85,
              77: m,
              78: v,
              79: b
            }, t(A, [2, 21]), t(A, [2, 22]), t(A, [2, 23]), {
              15: [1, 86]
            }, {
              24: [2, 18]
            }, t(L, [2, 44]), {
              26: 87,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, {
              26: 88,
              27: 39,
              28: 40,
              47: [1, 89],
              77: m,
              78: v,
              79: b,
              80: _
            }, t(D, [2, 50], {
              48: 90,
              50: w,
              51: k,
              52: T,
              53: E
            }), t(D, [2, 49]), {
              27: 91,
              77: m,
              78: v,
              79: b
            }, {
              40: 92,
              44: I
            }, {
              26: 94,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, t(x, [2, 58], {
              47: [1, 95]
            }), t(x, [2, 60], {
              47: [1, 97],
              58: [1, 96]
            }), t(x, [2, 64], {
              47: [1, 98],
              61: [1, 99]
            }), t(x, [2, 68], {
              47: [1, 101],
              58: [1, 100]
            }), t(x, [2, 72]), t(N, [2, 10]), t(L, [2, 46]), t(L, [2, 45]), {
              26: 102,
              27: 39,
              28: 40,
              77: m,
              78: v,
              79: b,
              80: _
            }, t(D, [2, 48]), t(x, [2, 34], {
              39: [1, 103]
            }), {
              41: [1, 104]
            }, {
              40: 105,
              41: [2, 38],
              44: I
            }, t(x, [2, 37]), t(x, [2, 59]), t(x, [2, 61]), t(x, [2, 62], {
              58: [1, 106]
            }), t(x, [2, 65]), t(x, [2, 66], {
              47: [1, 107]
            }), t(x, [2, 69]), t(x, [2, 70], {
              58: [1, 108]
            }), t(L, [2, 47]), {
              40: 109,
              44: I
            }, t(x, [2, 35]), {
              41: [2, 39]
            }, t(x, [2, 63]), t(x, [2, 67]), t(x, [2, 71]), {
              41: [1, 110]
            }, t(x, [2, 36])],
            defaultActions: {
              2: [2, 1],
              3: [2, 2],
              5: [2, 8],
              12: [2, 11],
              13: [2, 3],
              19: [2, 14],
              47: [2, 13],
              48: [2, 15],
              72: [2, 18],
              105: [2, 39]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              P = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {},
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 18;

                case 1:
                  return 7;

                case 2:
                  return 8;

                case 3:
                  return 9;

                case 4:
                  return 10;

                case 5:
                  return this.begin("type_directive"), 19;

                case 6:
                  return this.popState(), this.begin("arg_directive"), 16;

                case 7:
                  return this.popState(), this.popState(), 21;

                case 8:
                  return 20;

                case 9:
                case 10:
                  break;

                case 11:
                  return 15;

                case 12:
                  break;

                case 13:
                case 14:
                  return 22;

                case 15:
                  return this.begin("struct"), 39;

                case 16:
                  return "EOF_IN_STRUCT";

                case 17:
                  return "OPEN_IN_STRUCT";

                case 18:
                  return this.popState(), 41;

                case 19:
                  break;

                case 20:
                  return "MEMBER";

                case 21:
                  return 37;

                case 22:
                  return 63;

                case 23:
                  return 56;

                case 24:
                  return 57;

                case 25:
                  return 59;

                case 26:
                  return 42;

                case 27:
                  return 43;

                case 28:
                  this.begin("generic");
                  break;

                case 29:
                  this.popState();
                  break;

                case 30:
                  return "GENERICTYPE";

                case 31:
                  this.begin("string");
                  break;

                case 32:
                  this.popState();
                  break;

                case 33:
                  return "STR";

                case 34:
                  this.begin("bqstring");
                  break;

                case 35:
                  this.popState();
                  break;

                case 36:
                  return "BQUOTE_STR";

                case 37:
                  this.begin("href");
                  break;

                case 38:
                  this.popState();
                  break;

                case 39:
                  return 62;

                case 40:
                  this.begin("callback_name");
                  break;

                case 41:
                  this.popState();
                  break;

                case 42:
                  this.popState(), this.begin("callback_args");
                  break;

                case 43:
                  return 60;

                case 44:
                  this.popState();
                  break;

                case 45:
                  return 61;

                case 46:
                case 47:
                case 48:
                case 49:
                  return 58;

                case 50:
                case 51:
                  return 51;

                case 52:
                case 53:
                  return 53;

                case 54:
                  return 52;

                case 55:
                  return 50;

                case 56:
                  return 54;

                case 57:
                  return 55;

                case 58:
                  return 31;

                case 59:
                  return 38;

                case 60:
                  return 75;

                case 61:
                  return "DOT";

                case 62:
                  return "PLUS";

                case 63:
                  return 72;

                case 64:
                case 65:
                  return "EQUALS";

                case 66:
                  return 79;

                case 67:
                  return "PUNCTUATION";

                case 68:
                  return 78;

                case 69:
                  return 77;

                case 70:
                  return 74;

                case 71:
                  return 24;
              }
            },
            rules: [/^(?:%%\{)/, /^(?:.*direction\s+TB[^\n]*)/, /^(?:.*direction\s+BT[^\n]*)/, /^(?:.*direction\s+RL[^\n]*)/, /^(?:.*direction\s+LR[^\n]*)/, /^(?:((?:(?!\}%%)[^:.])*))/, /^(?::)/, /^(?:\}%%)/, /^(?:((?:(?!\}%%).|\n)*))/, /^(?:%%(?!\{)*[^\n]*(\r?\n?)+)/, /^(?:%%[^\n]*(\r?\n)*)/, /^(?:\s*(\r?\n)+)/, /^(?:\s+)/, /^(?:classDiagram-v2\b)/, /^(?:classDiagram\b)/, /^(?:[{])/, /^(?:$)/, /^(?:[{])/, /^(?:[}])/, /^(?:[\n])/, /^(?:[^{}\n]*)/, /^(?:class\b)/, /^(?:cssClass\b)/, /^(?:callback\b)/, /^(?:link\b)/, /^(?:click\b)/, /^(?:<<)/, /^(?:>>)/, /^(?:[~])/, /^(?:[~])/, /^(?:[^~]*)/, /^(?:["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:[`])/, /^(?:[`])/, /^(?:[^`]+)/, /^(?:href[\s]+["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:call[\s]+)/, /^(?:\([\s]*\))/, /^(?:\()/, /^(?:[^(]*)/, /^(?:\))/, /^(?:[^)]*)/, /^(?:_self\b)/, /^(?:_blank\b)/, /^(?:_parent\b)/, /^(?:_top\b)/, /^(?:\s*<\|)/, /^(?:\s*\|>)/, /^(?:\s*>)/, /^(?:\s*<)/, /^(?:\s*\*)/, /^(?:\s*o\b)/, /^(?:--)/, /^(?:\.\.)/, /^(?::{1}[^:\n;]+)/, /^(?::{3})/, /^(?:-)/, /^(?:\.)/, /^(?:\+)/, /^(?:%)/, /^(?:=)/, /^(?:=)/, /^(?:\w+)/, /^(?:[!"#$%&'*+,-.`?\\/])/, /^(?:[0-9]+)/, /^(?:[\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6]|[\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377]|[\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5]|[\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA]|[\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE]|[\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA]|[\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0]|[\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977]|[\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2]|[\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A]|[\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39]|[\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8]|[\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C]|[\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C]|[\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99]|[\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0]|[\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D]|[\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3]|[\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10]|[\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1]|[\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81]|[\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3]|[\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6]|[\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A]|[\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081]|[\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D]|[\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0]|[\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310]|[\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C]|[\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711]|[\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7]|[\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C]|[\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16]|[\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF]|[\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC]|[\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D]|[\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D]|[\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3]|[\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F]|[\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128]|[\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184]|[\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3]|[\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6]|[\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE]|[\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C]|[\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D]|[\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC]|[\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B]|[\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788]|[\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805]|[\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB]|[\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28]|[\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5]|[\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4]|[\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E]|[\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D]|[\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36]|[\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D]|[\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC]|[\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF]|[\uFFD2-\uFFD7\uFFDA-\uFFDC])/, /^(?:\s)/, /^(?:$)/],
            conditions: {
              arg_directive: {
                rules: [7, 8],
                inclusive: !1
              },
              type_directive: {
                rules: [6, 7],
                inclusive: !1
              },
              open_directive: {
                rules: [5],
                inclusive: !1
              },
              callback_args: {
                rules: [44, 45],
                inclusive: !1
              },
              callback_name: {
                rules: [41, 42, 43],
                inclusive: !1
              },
              href: {
                rules: [38, 39],
                inclusive: !1
              },
              struct: {
                rules: [16, 17, 18, 19, 20],
                inclusive: !1
              },
              generic: {
                rules: [29, 30],
                inclusive: !1
              },
              bqstring: {
                rules: [35, 36],
                inclusive: !1
              },
              string: {
                rules: [32, 33],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15, 21, 22, 23, 24, 25, 26, 27, 28, 31, 34, 37, 40, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71],
                inclusive: !0
              }
            }
          };

          function F() {
            this.yy = {};
          }

          return R.lexer = P, F.prototype = R, R.Parser = F, new F();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(8218).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      4701: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t3, e, n, r) {
            for (n = n || {}, r = _t3.length; r--; n[_t3[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 2],
              n = [1, 5],
              r = [6, 9, 11, 23, 40],
              i = [1, 17],
              a = [1, 20],
              o = [1, 25],
              s = [1, 26],
              c = [1, 27],
              u = [1, 28],
              l = [1, 37],
              h = [23, 37, 38],
              f = [4, 6, 9, 11, 23, 40],
              d = [33, 34, 35, 36],
              p = [22, 29],
              y = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              ER_DIAGRAM: 4,
              document: 5,
              EOF: 6,
              directive: 7,
              line: 8,
              SPACE: 9,
              statement: 10,
              NEWLINE: 11,
              openDirective: 12,
              typeDirective: 13,
              closeDirective: 14,
              ":": 15,
              argDirective: 16,
              entityName: 17,
              relSpec: 18,
              role: 19,
              BLOCK_START: 20,
              attributes: 21,
              BLOCK_STOP: 22,
              ALPHANUM: 23,
              attribute: 24,
              attributeType: 25,
              attributeName: 26,
              attributeKeyType: 27,
              COMMENT: 28,
              ATTRIBUTE_WORD: 29,
              ATTRIBUTE_KEY: 30,
              cardinality: 31,
              relType: 32,
              ZERO_OR_ONE: 33,
              ZERO_OR_MORE: 34,
              ONE_OR_MORE: 35,
              ONLY_ONE: 36,
              NON_IDENTIFYING: 37,
              IDENTIFYING: 38,
              WORD: 39,
              open_directive: 40,
              type_directive: 41,
              arg_directive: 42,
              close_directive: 43,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              4: "ER_DIAGRAM",
              6: "EOF",
              9: "SPACE",
              11: "NEWLINE",
              15: ":",
              20: "BLOCK_START",
              22: "BLOCK_STOP",
              23: "ALPHANUM",
              28: "COMMENT",
              29: "ATTRIBUTE_WORD",
              30: "ATTRIBUTE_KEY",
              33: "ZERO_OR_ONE",
              34: "ZERO_OR_MORE",
              35: "ONE_OR_MORE",
              36: "ONLY_ONE",
              37: "NON_IDENTIFYING",
              38: "IDENTIFYING",
              39: "WORD",
              40: "open_directive",
              41: "type_directive",
              42: "arg_directive",
              43: "close_directive"
            },
            productions_: [0, [3, 3], [3, 2], [5, 0], [5, 2], [8, 2], [8, 1], [8, 1], [8, 1], [7, 4], [7, 6], [10, 1], [10, 5], [10, 4], [10, 3], [10, 1], [17, 1], [21, 1], [21, 2], [24, 2], [24, 3], [24, 3], [24, 4], [25, 1], [26, 1], [27, 1], [18, 3], [31, 1], [31, 1], [31, 1], [31, 1], [32, 1], [32, 1], [19, 1], [19, 1], [12, 1], [13, 1], [16, 1], [14, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 1:
                  break;

                case 3:
                  this.$ = [];
                  break;

                case 4:
                  a[s - 1].push(a[s]), this.$ = a[s - 1];
                  break;

                case 5:
                case 6:
                  this.$ = a[s];
                  break;

                case 7:
                case 8:
                  this.$ = [];
                  break;

                case 12:
                  r.addEntity(a[s - 4]), r.addEntity(a[s - 2]), r.addRelationship(a[s - 4], a[s], a[s - 2], a[s - 3]);
                  break;

                case 13:
                  r.addEntity(a[s - 3]), r.addAttributes(a[s - 3], a[s - 1]);
                  break;

                case 14:
                  r.addEntity(a[s - 2]);
                  break;

                case 15:
                  r.addEntity(a[s]);
                  break;

                case 16:
                  this.$ = a[s];
                  break;

                case 17:
                  this.$ = [a[s]];
                  break;

                case 18:
                  a[s].push(a[s - 1]), this.$ = a[s];
                  break;

                case 19:
                  this.$ = {
                    attributeType: a[s - 1],
                    attributeName: a[s]
                  };
                  break;

                case 20:
                  this.$ = {
                    attributeType: a[s - 2],
                    attributeName: a[s - 1],
                    attributeKeyType: a[s]
                  };
                  break;

                case 21:
                  this.$ = {
                    attributeType: a[s - 2],
                    attributeName: a[s - 1],
                    attributeComment: a[s]
                  };
                  break;

                case 22:
                  this.$ = {
                    attributeType: a[s - 3],
                    attributeName: a[s - 2],
                    attributeKeyType: a[s - 1],
                    attributeComment: a[s]
                  };
                  break;

                case 23:
                case 24:
                case 25:
                  this.$ = a[s];
                  break;

                case 26:
                  this.$ = {
                    cardA: a[s],
                    relType: a[s - 1],
                    cardB: a[s - 2]
                  };
                  break;

                case 27:
                  this.$ = r.Cardinality.ZERO_OR_ONE;
                  break;

                case 28:
                  this.$ = r.Cardinality.ZERO_OR_MORE;
                  break;

                case 29:
                  this.$ = r.Cardinality.ONE_OR_MORE;
                  break;

                case 30:
                  this.$ = r.Cardinality.ONLY_ONE;
                  break;

                case 31:
                  this.$ = r.Identification.NON_IDENTIFYING;
                  break;

                case 32:
                  this.$ = r.Identification.IDENTIFYING;
                  break;

                case 33:
                  this.$ = a[s].replace(/"/g, "");
                  break;

                case 34:
                  this.$ = a[s];
                  break;

                case 35:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 36:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 37:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 38:
                  r.parseDirective("}%%", "close_directive", "er");
              }
            },
            table: [{
              3: 1,
              4: e,
              7: 3,
              12: 4,
              40: n
            }, {
              1: [3]
            }, t(r, [2, 3], {
              5: 6
            }), {
              3: 7,
              4: e,
              7: 3,
              12: 4,
              40: n
            }, {
              13: 8,
              41: [1, 9]
            }, {
              41: [2, 35]
            }, {
              6: [1, 10],
              7: 15,
              8: 11,
              9: [1, 12],
              10: 13,
              11: [1, 14],
              12: 4,
              17: 16,
              23: i,
              40: n
            }, {
              1: [2, 2]
            }, {
              14: 18,
              15: [1, 19],
              43: a
            }, t([15, 43], [2, 36]), t(r, [2, 8], {
              1: [2, 1]
            }), t(r, [2, 4]), {
              7: 15,
              10: 21,
              12: 4,
              17: 16,
              23: i,
              40: n
            }, t(r, [2, 6]), t(r, [2, 7]), t(r, [2, 11]), t(r, [2, 15], {
              18: 22,
              31: 24,
              20: [1, 23],
              33: o,
              34: s,
              35: c,
              36: u
            }), t([6, 9, 11, 15, 20, 23, 33, 34, 35, 36, 40], [2, 16]), {
              11: [1, 29]
            }, {
              16: 30,
              42: [1, 31]
            }, {
              11: [2, 38]
            }, t(r, [2, 5]), {
              17: 32,
              23: i
            }, {
              21: 33,
              22: [1, 34],
              24: 35,
              25: 36,
              29: l
            }, {
              32: 38,
              37: [1, 39],
              38: [1, 40]
            }, t(h, [2, 27]), t(h, [2, 28]), t(h, [2, 29]), t(h, [2, 30]), t(f, [2, 9]), {
              14: 41,
              43: a
            }, {
              43: [2, 37]
            }, {
              15: [1, 42]
            }, {
              22: [1, 43]
            }, t(r, [2, 14]), {
              21: 44,
              22: [2, 17],
              24: 35,
              25: 36,
              29: l
            }, {
              26: 45,
              29: [1, 46]
            }, {
              29: [2, 23]
            }, {
              31: 47,
              33: o,
              34: s,
              35: c,
              36: u
            }, t(d, [2, 31]), t(d, [2, 32]), {
              11: [1, 48]
            }, {
              19: 49,
              23: [1, 51],
              39: [1, 50]
            }, t(r, [2, 13]), {
              22: [2, 18]
            }, t(p, [2, 19], {
              27: 52,
              28: [1, 53],
              30: [1, 54]
            }), t([22, 28, 29, 30], [2, 24]), {
              23: [2, 26]
            }, t(f, [2, 10]), t(r, [2, 12]), t(r, [2, 33]), t(r, [2, 34]), t(p, [2, 20], {
              28: [1, 55]
            }), t(p, [2, 21]), t([22, 28, 29], [2, 25]), t(p, [2, 22])],
            defaultActions: {
              5: [2, 35],
              7: [2, 2],
              20: [2, 38],
              31: [2, 37],
              37: [2, 23],
              44: [2, 18],
              47: [2, 26]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              g = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 40;

                case 1:
                  return this.begin("type_directive"), 41;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 15;

                case 3:
                  return this.popState(), this.popState(), 43;

                case 4:
                  return 42;

                case 5:
                case 6:
                  break;

                case 7:
                  return 11;

                case 8:
                  break;

                case 9:
                  return 9;

                case 10:
                  return 39;

                case 11:
                  return 4;

                case 12:
                  return this.begin("block"), 20;

                case 13:
                  break;

                case 14:
                  return 30;

                case 15:
                  return 29;

                case 16:
                  return 28;

                case 17:
                  break;

                case 18:
                  return this.popState(), 22;

                case 19:
                  return e.yytext[0];

                case 20:
                  return 33;

                case 21:
                  return 34;

                case 22:
                  return 35;

                case 23:
                  return 36;

                case 24:
                  return 33;

                case 25:
                  return 34;

                case 26:
                  return 35;

                case 27:
                  return 37;

                case 28:
                  return 38;

                case 29:
                case 30:
                  return 37;

                case 31:
                  return 23;

                case 32:
                  return e.yytext[0];

                case 33:
                  return 6;
              }
            },
            rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:[\s]+)/i, /^(?:"[^"]*")/i, /^(?:erDiagram\b)/i, /^(?:\{)/i, /^(?:\s+)/i, /^(?:(?:PK)|(?:FK))/i, /^(?:[A-Za-z][A-Za-z0-9\-_]*)/i, /^(?:"[^"]*")/i, /^(?:[\n]+)/i, /^(?:\})/i, /^(?:.)/i, /^(?:\|o\b)/i, /^(?:\}o\b)/i, /^(?:\}\|)/i, /^(?:\|\|)/i, /^(?:o\|)/i, /^(?:o\{)/i, /^(?:\|\{)/i, /^(?:\.\.)/i, /^(?:--)/i, /^(?:\.-)/i, /^(?:-\.)/i, /^(?:[A-Za-z][A-Za-z0-9\-_]*)/i, /^(?:.)/i, /^(?:$)/i],
            conditions: {
              open_directive: {
                rules: [1],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4],
                inclusive: !1
              },
              block: {
                rules: [13, 14, 15, 16, 17, 18, 19],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33],
                inclusive: !0
              }
            }
          };

          function m() {
            this.yy = {};
          }

          return y.lexer = g, m.prototype = y, y.Parser = m, new m();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(8009).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      7805: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t4, e, n, r) {
            for (n = n || {}, r = _t4.length; r--; n[_t4[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 9],
              n = [1, 7],
              r = [1, 6],
              i = [1, 8],
              a = [1, 20, 21, 22, 23, 38, 47, 76, 77, 78, 79, 80, 81, 95, 96, 99, 100, 101, 103, 104, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119],
              o = [2, 10],
              s = [1, 20],
              c = [1, 21],
              u = [1, 22],
              l = [1, 23],
              h = [1, 30],
              f = [1, 59],
              d = [1, 33],
              p = [1, 34],
              y = [1, 35],
              g = [1, 36],
              m = [1, 37],
              v = [1, 53],
              b = [1, 48],
              _ = [1, 50],
              x = [1, 45],
              w = [1, 49],
              k = [1, 52],
              T = [1, 56],
              E = [1, 57],
              C = [1, 38],
              S = [1, 39],
              A = [1, 40],
              M = [1, 41],
              N = [1, 58],
              D = [1, 47],
              O = [1, 51],
              B = [1, 54],
              L = [1, 55],
              I = [1, 46],
              R = [1, 62],
              P = [1, 67],
              F = [1, 20, 21, 22, 23, 38, 42, 47, 76, 77, 78, 79, 80, 81, 95, 96, 99, 100, 101, 103, 104, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119],
              j = [1, 71],
              Y = [1, 70],
              U = [1, 72],
              z = [20, 21, 23, 70, 71],
              q = [1, 93],
              $ = [1, 98],
              H = [1, 95],
              W = [1, 100],
              V = [1, 103],
              G = [1, 101],
              X = [1, 102],
              Z = [1, 96],
              K = [1, 108],
              Q = [1, 107],
              J = [1, 97],
              tt = [1, 99],
              et = [1, 104],
              nt = [1, 105],
              rt = [1, 106],
              it = [1, 109],
              at = [20, 21, 22, 23, 70, 71],
              ot = [20, 21, 22, 23, 48, 70, 71],
              st = [20, 21, 22, 23, 40, 47, 48, 50, 52, 54, 56, 58, 60, 62, 63, 65, 70, 71, 81, 95, 96, 99, 100, 101, 103, 104, 114, 115, 116, 117, 118, 119],
              ct = [20, 21, 23],
              ut = [20, 21, 23, 47, 70, 71, 81, 95, 96, 99, 100, 101, 103, 104, 114, 115, 116, 117, 118, 119],
              lt = [1, 12, 20, 21, 22, 23, 24, 38, 42, 47, 76, 77, 78, 79, 80, 81, 95, 96, 99, 100, 101, 103, 104, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119],
              ht = [47, 81, 95, 96, 99, 100, 101, 103, 104, 114, 115, 116, 117, 118, 119],
              ft = [1, 141],
              dt = [1, 149],
              pt = [1, 150],
              yt = [1, 151],
              gt = [1, 152],
              mt = [1, 136],
              vt = [1, 137],
              bt = [1, 133],
              _t = [1, 144],
              xt = [1, 145],
              wt = [1, 146],
              kt = [1, 147],
              Tt = [1, 148],
              Et = [1, 153],
              Ct = [1, 154],
              St = [1, 139],
              At = [1, 142],
              Mt = [1, 138],
              Nt = [1, 135],
              Dt = [20, 21, 22, 23, 38, 42, 47, 76, 77, 78, 79, 80, 81, 95, 96, 99, 100, 101, 103, 104, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119],
              Ot = [1, 157],
              Bt = [20, 21, 22, 23, 26, 47, 81, 95, 96, 99, 100, 101, 103, 104, 114, 115, 116, 117, 118, 119],
              Lt = [20, 21, 22, 23, 24, 26, 38, 40, 41, 42, 47, 51, 53, 55, 57, 59, 61, 62, 64, 66, 70, 71, 72, 76, 77, 78, 79, 80, 81, 82, 85, 95, 96, 99, 100, 101, 103, 104, 105, 106, 114, 115, 116, 117, 118, 119],
              It = [12, 21, 22, 24],
              Rt = [22, 96],
              Pt = [1, 238],
              Ft = [1, 242],
              jt = [1, 239],
              Yt = [1, 236],
              Ut = [1, 233],
              zt = [1, 234],
              qt = [1, 235],
              $t = [1, 237],
              Ht = [1, 240],
              Wt = [1, 241],
              Vt = [1, 243],
              Gt = [1, 260],
              Xt = [20, 21, 23, 96],
              Zt = [20, 21, 22, 23, 76, 92, 95, 96, 99, 100, 101, 102, 103, 104, 105],
              Kt = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              mermaidDoc: 4,
              directive: 5,
              openDirective: 6,
              typeDirective: 7,
              closeDirective: 8,
              separator: 9,
              ":": 10,
              argDirective: 11,
              open_directive: 12,
              type_directive: 13,
              arg_directive: 14,
              close_directive: 15,
              graphConfig: 16,
              document: 17,
              line: 18,
              statement: 19,
              SEMI: 20,
              NEWLINE: 21,
              SPACE: 22,
              EOF: 23,
              GRAPH: 24,
              NODIR: 25,
              DIR: 26,
              FirstStmtSeperator: 27,
              ending: 28,
              endToken: 29,
              spaceList: 30,
              spaceListNewline: 31,
              verticeStatement: 32,
              styleStatement: 33,
              linkStyleStatement: 34,
              classDefStatement: 35,
              classStatement: 36,
              clickStatement: 37,
              subgraph: 38,
              text: 39,
              SQS: 40,
              SQE: 41,
              end: 42,
              direction: 43,
              link: 44,
              node: 45,
              vertex: 46,
              AMP: 47,
              STYLE_SEPARATOR: 48,
              idString: 49,
              PS: 50,
              PE: 51,
              "(-": 52,
              "-)": 53,
              STADIUMSTART: 54,
              STADIUMEND: 55,
              SUBROUTINESTART: 56,
              SUBROUTINEEND: 57,
              CYLINDERSTART: 58,
              CYLINDEREND: 59,
              DIAMOND_START: 60,
              DIAMOND_STOP: 61,
              TAGEND: 62,
              TRAPSTART: 63,
              TRAPEND: 64,
              INVTRAPSTART: 65,
              INVTRAPEND: 66,
              linkStatement: 67,
              arrowText: 68,
              TESTSTR: 69,
              START_LINK: 70,
              LINK: 71,
              PIPE: 72,
              textToken: 73,
              STR: 74,
              keywords: 75,
              STYLE: 76,
              LINKSTYLE: 77,
              CLASSDEF: 78,
              CLASS: 79,
              CLICK: 80,
              DOWN: 81,
              UP: 82,
              textNoTags: 83,
              textNoTagsToken: 84,
              DEFAULT: 85,
              stylesOpt: 86,
              alphaNum: 87,
              CALLBACKNAME: 88,
              CALLBACKARGS: 89,
              HREF: 90,
              LINK_TARGET: 91,
              HEX: 92,
              numList: 93,
              INTERPOLATE: 94,
              NUM: 95,
              COMMA: 96,
              style: 97,
              styleComponent: 98,
              ALPHA: 99,
              COLON: 100,
              MINUS: 101,
              UNIT: 102,
              BRKT: 103,
              DOT: 104,
              PCT: 105,
              TAGSTART: 106,
              alphaNumToken: 107,
              idStringToken: 108,
              alphaNumStatement: 109,
              direction_tb: 110,
              direction_bt: 111,
              direction_rl: 112,
              direction_lr: 113,
              PUNCTUATION: 114,
              UNICODE_TEXT: 115,
              PLUS: 116,
              EQUALS: 117,
              MULT: 118,
              UNDERSCORE: 119,
              graphCodeTokens: 120,
              ARROW_CROSS: 121,
              ARROW_POINT: 122,
              ARROW_CIRCLE: 123,
              ARROW_OPEN: 124,
              QUOTE: 125,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              10: ":",
              12: "open_directive",
              13: "type_directive",
              14: "arg_directive",
              15: "close_directive",
              20: "SEMI",
              21: "NEWLINE",
              22: "SPACE",
              23: "EOF",
              24: "GRAPH",
              25: "NODIR",
              26: "DIR",
              38: "subgraph",
              40: "SQS",
              41: "SQE",
              42: "end",
              47: "AMP",
              48: "STYLE_SEPARATOR",
              50: "PS",
              51: "PE",
              52: "(-",
              53: "-)",
              54: "STADIUMSTART",
              55: "STADIUMEND",
              56: "SUBROUTINESTART",
              57: "SUBROUTINEEND",
              58: "CYLINDERSTART",
              59: "CYLINDEREND",
              60: "DIAMOND_START",
              61: "DIAMOND_STOP",
              62: "TAGEND",
              63: "TRAPSTART",
              64: "TRAPEND",
              65: "INVTRAPSTART",
              66: "INVTRAPEND",
              69: "TESTSTR",
              70: "START_LINK",
              71: "LINK",
              72: "PIPE",
              74: "STR",
              76: "STYLE",
              77: "LINKSTYLE",
              78: "CLASSDEF",
              79: "CLASS",
              80: "CLICK",
              81: "DOWN",
              82: "UP",
              85: "DEFAULT",
              88: "CALLBACKNAME",
              89: "CALLBACKARGS",
              90: "HREF",
              91: "LINK_TARGET",
              92: "HEX",
              94: "INTERPOLATE",
              95: "NUM",
              96: "COMMA",
              99: "ALPHA",
              100: "COLON",
              101: "MINUS",
              102: "UNIT",
              103: "BRKT",
              104: "DOT",
              105: "PCT",
              106: "TAGSTART",
              110: "direction_tb",
              111: "direction_bt",
              112: "direction_rl",
              113: "direction_lr",
              114: "PUNCTUATION",
              115: "UNICODE_TEXT",
              116: "PLUS",
              117: "EQUALS",
              118: "MULT",
              119: "UNDERSCORE",
              121: "ARROW_CROSS",
              122: "ARROW_POINT",
              123: "ARROW_CIRCLE",
              124: "ARROW_OPEN",
              125: "QUOTE"
            },
            productions_: [0, [3, 1], [3, 2], [5, 4], [5, 6], [6, 1], [7, 1], [11, 1], [8, 1], [4, 2], [17, 0], [17, 2], [18, 1], [18, 1], [18, 1], [18, 1], [18, 1], [16, 2], [16, 2], [16, 2], [16, 3], [28, 2], [28, 1], [29, 1], [29, 1], [29, 1], [27, 1], [27, 1], [27, 2], [31, 2], [31, 2], [31, 1], [31, 1], [30, 2], [30, 1], [19, 2], [19, 2], [19, 2], [19, 2], [19, 2], [19, 2], [19, 9], [19, 6], [19, 4], [19, 1], [9, 1], [9, 1], [9, 1], [32, 3], [32, 4], [32, 2], [32, 1], [45, 1], [45, 5], [45, 3], [46, 4], [46, 6], [46, 4], [46, 4], [46, 4], [46, 4], [46, 4], [46, 4], [46, 6], [46, 4], [46, 4], [46, 4], [46, 4], [46, 4], [46, 1], [44, 2], [44, 3], [44, 3], [44, 1], [44, 3], [67, 1], [68, 3], [39, 1], [39, 2], [39, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [75, 1], [83, 1], [83, 2], [35, 5], [35, 5], [36, 5], [37, 2], [37, 4], [37, 3], [37, 5], [37, 2], [37, 4], [37, 4], [37, 6], [37, 2], [37, 4], [37, 2], [37, 4], [37, 4], [37, 6], [33, 5], [33, 5], [34, 5], [34, 5], [34, 9], [34, 9], [34, 7], [34, 7], [93, 1], [93, 3], [86, 1], [86, 3], [97, 1], [97, 2], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [98, 1], [73, 1], [73, 1], [73, 1], [73, 1], [73, 1], [73, 1], [84, 1], [84, 1], [84, 1], [84, 1], [49, 1], [49, 2], [87, 1], [87, 2], [109, 1], [109, 1], [109, 1], [109, 1], [43, 1], [43, 1], [43, 1], [43, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [107, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [108, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1], [120, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 5:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 6:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 7:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 8:
                  r.parseDirective("}%%", "close_directive", "flowchart");
                  break;

                case 10:
                  this.$ = [];
                  break;

                case 11:
                  a[s] !== [] && a[s - 1].push(a[s]), this.$ = a[s - 1];
                  break;

                case 12:
                case 77:
                case 79:
                case 91:
                case 147:
                case 149:
                case 150:
                  this.$ = a[s];
                  break;

                case 19:
                  r.setDirection("TB"), this.$ = "TB";
                  break;

                case 20:
                  r.setDirection(a[s - 1]), this.$ = a[s - 1];
                  break;

                case 35:
                  this.$ = a[s - 1].nodes;
                  break;

                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                  this.$ = [];
                  break;

                case 41:
                  this.$ = r.addSubGraph(a[s - 6], a[s - 1], a[s - 4]);
                  break;

                case 42:
                  this.$ = r.addSubGraph(a[s - 3], a[s - 1], a[s - 3]);
                  break;

                case 43:
                  this.$ = r.addSubGraph(void 0, a[s - 1], void 0);
                  break;

                case 48:
                  r.addLink(a[s - 2].stmt, a[s], a[s - 1]), this.$ = {
                    stmt: a[s],
                    nodes: a[s].concat(a[s - 2].nodes)
                  };
                  break;

                case 49:
                  r.addLink(a[s - 3].stmt, a[s - 1], a[s - 2]), this.$ = {
                    stmt: a[s - 1],
                    nodes: a[s - 1].concat(a[s - 3].nodes)
                  };
                  break;

                case 50:
                  this.$ = {
                    stmt: a[s - 1],
                    nodes: a[s - 1]
                  };
                  break;

                case 51:
                  this.$ = {
                    stmt: a[s],
                    nodes: a[s]
                  };
                  break;

                case 52:
                  this.$ = [a[s]];
                  break;

                case 53:
                  this.$ = a[s - 4].concat(a[s]);
                  break;

                case 54:
                  this.$ = [a[s - 2]], r.setClass(a[s - 2], a[s]);
                  break;

                case 55:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "square");
                  break;

                case 56:
                  this.$ = a[s - 5], r.addVertex(a[s - 5], a[s - 2], "circle");
                  break;

                case 57:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "ellipse");
                  break;

                case 58:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "stadium");
                  break;

                case 59:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "subroutine");
                  break;

                case 60:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "cylinder");
                  break;

                case 61:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "round");
                  break;

                case 62:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "diamond");
                  break;

                case 63:
                  this.$ = a[s - 5], r.addVertex(a[s - 5], a[s - 2], "hexagon");
                  break;

                case 64:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "odd");
                  break;

                case 65:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "trapezoid");
                  break;

                case 66:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "inv_trapezoid");
                  break;

                case 67:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "lean_right");
                  break;

                case 68:
                  this.$ = a[s - 3], r.addVertex(a[s - 3], a[s - 1], "lean_left");
                  break;

                case 69:
                  this.$ = a[s], r.addVertex(a[s]);
                  break;

                case 70:
                  a[s - 1].text = a[s], this.$ = a[s - 1];
                  break;

                case 71:
                case 72:
                  a[s - 2].text = a[s - 1], this.$ = a[s - 2];
                  break;

                case 73:
                  this.$ = a[s];
                  break;

                case 74:
                  var c = r.destructLink(a[s], a[s - 2]);
                  this.$ = {
                    type: c.type,
                    stroke: c.stroke,
                    length: c.length,
                    text: a[s - 1]
                  };
                  break;

                case 75:
                  c = r.destructLink(a[s]), this.$ = {
                    type: c.type,
                    stroke: c.stroke,
                    length: c.length
                  };
                  break;

                case 76:
                  this.$ = a[s - 1];
                  break;

                case 78:
                case 92:
                case 148:
                  this.$ = a[s - 1] + "" + a[s];
                  break;

                case 93:
                case 94:
                  this.$ = a[s - 4], r.addClass(a[s - 2], a[s]);
                  break;

                case 95:
                  this.$ = a[s - 4], r.setClass(a[s - 2], a[s]);
                  break;

                case 96:
                case 104:
                  this.$ = a[s - 1], r.setClickEvent(a[s - 1], a[s]);
                  break;

                case 97:
                case 105:
                  this.$ = a[s - 3], r.setClickEvent(a[s - 3], a[s - 2]), r.setTooltip(a[s - 3], a[s]);
                  break;

                case 98:
                  this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s - 1], a[s]);
                  break;

                case 99:
                  this.$ = a[s - 4], r.setClickEvent(a[s - 4], a[s - 3], a[s - 2]), r.setTooltip(a[s - 4], a[s]);
                  break;

                case 100:
                case 106:
                  this.$ = a[s - 1], r.setLink(a[s - 1], a[s]);
                  break;

                case 101:
                case 107:
                  this.$ = a[s - 3], r.setLink(a[s - 3], a[s - 2]), r.setTooltip(a[s - 3], a[s]);
                  break;

                case 102:
                case 108:
                  this.$ = a[s - 3], r.setLink(a[s - 3], a[s - 2], a[s]);
                  break;

                case 103:
                case 109:
                  this.$ = a[s - 5], r.setLink(a[s - 5], a[s - 4], a[s]), r.setTooltip(a[s - 5], a[s - 2]);
                  break;

                case 110:
                  this.$ = a[s - 4], r.addVertex(a[s - 2], void 0, void 0, a[s]);
                  break;

                case 111:
                case 113:
                  this.$ = a[s - 4], r.updateLink(a[s - 2], a[s]);
                  break;

                case 112:
                  this.$ = a[s - 4], r.updateLink([a[s - 2]], a[s]);
                  break;

                case 114:
                  this.$ = a[s - 8], r.updateLinkInterpolate([a[s - 6]], a[s - 2]), r.updateLink([a[s - 6]], a[s]);
                  break;

                case 115:
                  this.$ = a[s - 8], r.updateLinkInterpolate(a[s - 6], a[s - 2]), r.updateLink(a[s - 6], a[s]);
                  break;

                case 116:
                  this.$ = a[s - 6], r.updateLinkInterpolate([a[s - 4]], a[s]);
                  break;

                case 117:
                  this.$ = a[s - 6], r.updateLinkInterpolate(a[s - 4], a[s]);
                  break;

                case 118:
                case 120:
                  this.$ = [a[s]];
                  break;

                case 119:
                case 121:
                  a[s - 2].push(a[s]), this.$ = a[s - 2];
                  break;

                case 123:
                  this.$ = a[s - 1] + a[s];
                  break;

                case 145:
                  this.$ = a[s];
                  break;

                case 146:
                  this.$ = a[s - 1] + "" + a[s];
                  break;

                case 151:
                  this.$ = "v";
                  break;

                case 152:
                  this.$ = "-";
                  break;

                case 153:
                  this.$ = {
                    stmt: "dir",
                    value: "TB"
                  };
                  break;

                case 154:
                  this.$ = {
                    stmt: "dir",
                    value: "BT"
                  };
                  break;

                case 155:
                  this.$ = {
                    stmt: "dir",
                    value: "RL"
                  };
                  break;

                case 156:
                  this.$ = {
                    stmt: "dir",
                    value: "LR"
                  };
              }
            },
            table: [{
              3: 1,
              4: 2,
              5: 3,
              6: 5,
              12: e,
              16: 4,
              21: n,
              22: r,
              24: i
            }, {
              1: [3]
            }, {
              1: [2, 1]
            }, {
              3: 10,
              4: 2,
              5: 3,
              6: 5,
              12: e,
              16: 4,
              21: n,
              22: r,
              24: i
            }, t(a, o, {
              17: 11
            }), {
              7: 12,
              13: [1, 13]
            }, {
              16: 14,
              21: n,
              22: r,
              24: i
            }, {
              16: 15,
              21: n,
              22: r,
              24: i
            }, {
              25: [1, 16],
              26: [1, 17]
            }, {
              13: [2, 5]
            }, {
              1: [2, 2]
            }, {
              1: [2, 9],
              18: 18,
              19: 19,
              20: s,
              21: c,
              22: u,
              23: l,
              32: 24,
              33: 25,
              34: 26,
              35: 27,
              36: 28,
              37: 29,
              38: h,
              43: 31,
              45: 32,
              46: 42,
              47: f,
              49: 43,
              76: d,
              77: p,
              78: y,
              79: g,
              80: m,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              110: C,
              111: S,
              112: A,
              113: M,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, {
              8: 60,
              10: [1, 61],
              15: R
            }, t([10, 15], [2, 6]), t(a, [2, 17]), t(a, [2, 18]), t(a, [2, 19]), {
              20: [1, 64],
              21: [1, 65],
              22: P,
              27: 63,
              30: 66
            }, t(F, [2, 11]), t(F, [2, 12]), t(F, [2, 13]), t(F, [2, 14]), t(F, [2, 15]), t(F, [2, 16]), {
              9: 68,
              20: j,
              21: Y,
              23: U,
              44: 69,
              67: 73,
              70: [1, 74],
              71: [1, 75]
            }, {
              9: 76,
              20: j,
              21: Y,
              23: U
            }, {
              9: 77,
              20: j,
              21: Y,
              23: U
            }, {
              9: 78,
              20: j,
              21: Y,
              23: U
            }, {
              9: 79,
              20: j,
              21: Y,
              23: U
            }, {
              9: 80,
              20: j,
              21: Y,
              23: U
            }, {
              9: 82,
              20: j,
              21: Y,
              22: [1, 81],
              23: U
            }, t(F, [2, 44]), t(z, [2, 51], {
              30: 83,
              22: P
            }), {
              22: [1, 84]
            }, {
              22: [1, 85]
            }, {
              22: [1, 86]
            }, {
              22: [1, 87]
            }, {
              26: q,
              47: $,
              74: [1, 91],
              81: H,
              87: 90,
              88: [1, 88],
              90: [1, 89],
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(F, [2, 153]), t(F, [2, 154]), t(F, [2, 155]), t(F, [2, 156]), t(at, [2, 52], {
              48: [1, 110]
            }), t(ot, [2, 69], {
              108: 121,
              40: [1, 111],
              47: f,
              50: [1, 112],
              52: [1, 113],
              54: [1, 114],
              56: [1, 115],
              58: [1, 116],
              60: [1, 117],
              62: [1, 118],
              63: [1, 119],
              65: [1, 120],
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }), t(st, [2, 145]), t(st, [2, 170]), t(st, [2, 171]), t(st, [2, 172]), t(st, [2, 173]), t(st, [2, 174]), t(st, [2, 175]), t(st, [2, 176]), t(st, [2, 177]), t(st, [2, 178]), t(st, [2, 179]), t(st, [2, 180]), t(st, [2, 181]), t(st, [2, 182]), t(st, [2, 183]), t(st, [2, 184]), {
              9: 122,
              20: j,
              21: Y,
              23: U
            }, {
              11: 123,
              14: [1, 124]
            }, t(ct, [2, 8]), t(a, [2, 20]), t(a, [2, 26]), t(a, [2, 27]), {
              21: [1, 125]
            }, t(ut, [2, 34], {
              30: 126,
              22: P
            }), t(F, [2, 35]), {
              45: 127,
              46: 42,
              47: f,
              49: 43,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, t(lt, [2, 45]), t(lt, [2, 46]), t(lt, [2, 47]), t(ht, [2, 73], {
              68: 128,
              69: [1, 129],
              72: [1, 130]
            }), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 131,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t([47, 69, 72, 81, 95, 96, 99, 100, 101, 103, 104, 114, 115, 116, 117, 118, 119], [2, 75]), t(F, [2, 36]), t(F, [2, 37]), t(F, [2, 38]), t(F, [2, 39]), t(F, [2, 40]), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 155,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(Dt, o, {
              17: 156
            }), t(z, [2, 50], {
              47: Ot
            }), {
              26: q,
              47: $,
              81: H,
              87: 158,
              92: [1, 159],
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              85: [1, 160],
              93: 161,
              95: [1, 162]
            }, {
              26: q,
              47: $,
              81: H,
              85: [1, 163],
              87: 164,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              26: q,
              47: $,
              81: H,
              87: 165,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(ct, [2, 96], {
              22: [1, 166],
              89: [1, 167]
            }), t(ct, [2, 100], {
              22: [1, 168]
            }), t(ct, [2, 104], {
              107: 94,
              109: 170,
              22: [1, 169],
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }), t(ct, [2, 106], {
              22: [1, 171]
            }), t(Bt, [2, 147]), t(Bt, [2, 149]), t(Bt, [2, 150]), t(Bt, [2, 151]), t(Bt, [2, 152]), t(Lt, [2, 157]), t(Lt, [2, 158]), t(Lt, [2, 159]), t(Lt, [2, 160]), t(Lt, [2, 161]), t(Lt, [2, 162]), t(Lt, [2, 163]), t(Lt, [2, 164]), t(Lt, [2, 165]), t(Lt, [2, 166]), t(Lt, [2, 167]), t(Lt, [2, 168]), t(Lt, [2, 169]), {
              47: f,
              49: 172,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 173,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 175,
              42: gt,
              47: $,
              50: [1, 174],
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 176,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 177,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 178,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 179,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 180,
              42: gt,
              47: $,
              60: [1, 181],
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 182,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 183,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 184,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(st, [2, 146]), t(It, [2, 3]), {
              8: 185,
              15: R
            }, {
              15: [2, 7]
            }, t(a, [2, 28]), t(ut, [2, 33]), t(z, [2, 48], {
              30: 186,
              22: P
            }), t(ht, [2, 70], {
              22: [1, 187]
            }), {
              22: [1, 188]
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 189,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              71: [1, 190],
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(Lt, [2, 77]), t(Lt, [2, 79]), t(Lt, [2, 135]), t(Lt, [2, 136]), t(Lt, [2, 137]), t(Lt, [2, 138]), t(Lt, [2, 139]), t(Lt, [2, 140]), t(Lt, [2, 141]), t(Lt, [2, 142]), t(Lt, [2, 143]), t(Lt, [2, 144]), t(Lt, [2, 80]), t(Lt, [2, 81]), t(Lt, [2, 82]), t(Lt, [2, 83]), t(Lt, [2, 84]), t(Lt, [2, 85]), t(Lt, [2, 86]), t(Lt, [2, 87]), t(Lt, [2, 88]), t(Lt, [2, 89]), t(Lt, [2, 90]), {
              9: 193,
              20: j,
              21: Y,
              22: ft,
              23: U,
              24: dt,
              26: pt,
              38: yt,
              40: [1, 192],
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              18: 18,
              19: 19,
              20: s,
              21: c,
              22: u,
              23: l,
              32: 24,
              33: 25,
              34: 26,
              35: 27,
              36: 28,
              37: 29,
              38: h,
              42: [1, 194],
              43: 31,
              45: 32,
              46: 42,
              47: f,
              49: 43,
              76: d,
              77: p,
              78: y,
              79: g,
              80: m,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              110: C,
              111: S,
              112: A,
              113: M,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, {
              22: P,
              30: 195
            }, {
              22: [1, 196],
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 170,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: [1, 197]
            }, {
              22: [1, 198]
            }, {
              22: [1, 199],
              96: [1, 200]
            }, t(Rt, [2, 118]), {
              22: [1, 201]
            }, {
              22: [1, 202],
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 170,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: [1, 203],
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 170,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              74: [1, 204]
            }, t(ct, [2, 98], {
              22: [1, 205]
            }), {
              74: [1, 206],
              91: [1, 207]
            }, {
              74: [1, 208]
            }, t(Bt, [2, 148]), {
              74: [1, 209],
              91: [1, 210]
            }, t(at, [2, 54], {
              108: 121,
              47: f,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              41: [1, 211],
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 212,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              51: [1, 213],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              53: [1, 214],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              55: [1, 215],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              57: [1, 216],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              59: [1, 217],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              61: [1, 218],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 219,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              41: [1, 220],
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              62: mt,
              64: [1, 221],
              66: [1, 222],
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              62: mt,
              64: [1, 224],
              66: [1, 223],
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              9: 225,
              20: j,
              21: Y,
              23: U
            }, t(z, [2, 49], {
              47: Ot
            }), t(ht, [2, 72]), t(ht, [2, 71]), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              72: [1, 226],
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(ht, [2, 74]), t(Lt, [2, 78]), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              39: 227,
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 132,
              74: bt,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(Dt, o, {
              17: 228
            }), t(F, [2, 43]), {
              46: 229,
              47: f,
              49: 43,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, {
              22: Pt,
              76: Ft,
              86: 230,
              92: jt,
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              22: Pt,
              76: Ft,
              86: 244,
              92: jt,
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              22: Pt,
              76: Ft,
              86: 245,
              92: jt,
              94: [1, 246],
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              22: Pt,
              76: Ft,
              86: 247,
              92: jt,
              94: [1, 248],
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              95: [1, 249]
            }, {
              22: Pt,
              76: Ft,
              86: 250,
              92: jt,
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              22: Pt,
              76: Ft,
              86: 251,
              92: jt,
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              26: q,
              47: $,
              81: H,
              87: 252,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(ct, [2, 97]), {
              74: [1, 253]
            }, t(ct, [2, 101], {
              22: [1, 254]
            }), t(ct, [2, 102]), t(ct, [2, 105]), t(ct, [2, 107], {
              22: [1, 255]
            }), t(ct, [2, 108]), t(ot, [2, 55]), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              51: [1, 256],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(ot, [2, 61]), t(ot, [2, 57]), t(ot, [2, 58]), t(ot, [2, 59]), t(ot, [2, 60]), t(ot, [2, 62]), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              42: gt,
              47: $,
              61: [1, 257],
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(ot, [2, 64]), t(ot, [2, 65]), t(ot, [2, 67]), t(ot, [2, 66]), t(ot, [2, 68]), t(It, [2, 4]), t([22, 47, 81, 95, 96, 99, 100, 101, 103, 104, 114, 115, 116, 117, 118, 119], [2, 76]), {
              22: ft,
              24: dt,
              26: pt,
              38: yt,
              41: [1, 258],
              42: gt,
              47: $,
              62: mt,
              70: vt,
              73: 191,
              75: 143,
              76: _t,
              77: xt,
              78: wt,
              79: kt,
              80: Tt,
              81: Et,
              82: Ct,
              84: 134,
              85: St,
              95: W,
              96: V,
              99: G,
              100: X,
              101: At,
              103: K,
              104: Q,
              105: Mt,
              106: Nt,
              107: 140,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              18: 18,
              19: 19,
              20: s,
              21: c,
              22: u,
              23: l,
              32: 24,
              33: 25,
              34: 26,
              35: 27,
              36: 28,
              37: 29,
              38: h,
              42: [1, 259],
              43: 31,
              45: 32,
              46: 42,
              47: f,
              49: 43,
              76: d,
              77: p,
              78: y,
              79: g,
              80: m,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              110: C,
              111: S,
              112: A,
              113: M,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, t(at, [2, 53]), t(ct, [2, 110], {
              96: Gt
            }), t(Xt, [2, 120], {
              98: 261,
              22: Pt,
              76: Ft,
              92: jt,
              95: Yt,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }), t(Zt, [2, 122]), t(Zt, [2, 124]), t(Zt, [2, 125]), t(Zt, [2, 126]), t(Zt, [2, 127]), t(Zt, [2, 128]), t(Zt, [2, 129]), t(Zt, [2, 130]), t(Zt, [2, 131]), t(Zt, [2, 132]), t(Zt, [2, 133]), t(Zt, [2, 134]), t(ct, [2, 111], {
              96: Gt
            }), t(ct, [2, 112], {
              96: Gt
            }), {
              22: [1, 262]
            }, t(ct, [2, 113], {
              96: Gt
            }), {
              22: [1, 263]
            }, t(Rt, [2, 119]), t(ct, [2, 93], {
              96: Gt
            }), t(ct, [2, 94], {
              96: Gt
            }), t(ct, [2, 95], {
              107: 94,
              109: 170,
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }), t(ct, [2, 99]), {
              91: [1, 264]
            }, {
              91: [1, 265]
            }, {
              51: [1, 266]
            }, {
              61: [1, 267]
            }, {
              9: 268,
              20: j,
              21: Y,
              23: U
            }, t(F, [2, 42]), {
              22: Pt,
              76: Ft,
              92: jt,
              95: Yt,
              97: 269,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, t(Zt, [2, 123]), {
              26: q,
              47: $,
              81: H,
              87: 270,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, {
              26: q,
              47: $,
              81: H,
              87: 271,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              107: 94,
              109: 92,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }, t(ct, [2, 103]), t(ct, [2, 109]), t(ot, [2, 56]), t(ot, [2, 63]), t(Dt, o, {
              17: 272
            }), t(Xt, [2, 121], {
              98: 261,
              22: Pt,
              76: Ft,
              92: jt,
              95: Yt,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }), t(ct, [2, 116], {
              107: 94,
              109: 170,
              22: [1, 273],
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }), t(ct, [2, 117], {
              107: 94,
              109: 170,
              22: [1, 274],
              26: q,
              47: $,
              81: H,
              95: W,
              96: V,
              99: G,
              100: X,
              101: Z,
              103: K,
              104: Q,
              114: J,
              115: tt,
              116: et,
              117: nt,
              118: rt,
              119: it
            }), {
              18: 18,
              19: 19,
              20: s,
              21: c,
              22: u,
              23: l,
              32: 24,
              33: 25,
              34: 26,
              35: 27,
              36: 28,
              37: 29,
              38: h,
              42: [1, 275],
              43: 31,
              45: 32,
              46: 42,
              47: f,
              49: 43,
              76: d,
              77: p,
              78: y,
              79: g,
              80: m,
              81: v,
              95: b,
              96: _,
              99: x,
              100: w,
              101: k,
              103: T,
              104: E,
              108: 44,
              110: C,
              111: S,
              112: A,
              113: M,
              114: N,
              115: D,
              116: O,
              117: B,
              118: L,
              119: I
            }, {
              22: Pt,
              76: Ft,
              86: 276,
              92: jt,
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, {
              22: Pt,
              76: Ft,
              86: 277,
              92: jt,
              95: Yt,
              97: 231,
              98: 232,
              99: Ut,
              100: zt,
              101: qt,
              102: $t,
              103: Ht,
              104: Wt,
              105: Vt
            }, t(F, [2, 41]), t(ct, [2, 114], {
              96: Gt
            }), t(ct, [2, 115], {
              96: Gt
            })],
            defaultActions: {
              2: [2, 1],
              9: [2, 5],
              10: [2, 2],
              124: [2, 7]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              Qt = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {},
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 12;

                case 1:
                  return this.begin("type_directive"), 13;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 10;

                case 3:
                  return this.popState(), this.popState(), 15;

                case 4:
                  return 14;

                case 5:
                case 6:
                  break;

                case 7:
                  this.begin("string");
                  break;

                case 8:
                  this.popState();
                  break;

                case 9:
                  return "STR";

                case 10:
                  return 76;

                case 11:
                  return 85;

                case 12:
                  return 77;

                case 13:
                  return 94;

                case 14:
                  return 78;

                case 15:
                  return 79;

                case 16:
                  this.begin("href");
                  break;

                case 17:
                  this.popState();
                  break;

                case 18:
                  return 90;

                case 19:
                  this.begin("callbackname");
                  break;

                case 20:
                  this.popState();
                  break;

                case 21:
                  this.popState(), this.begin("callbackargs");
                  break;

                case 22:
                  return 88;

                case 23:
                  this.popState();
                  break;

                case 24:
                  return 89;

                case 25:
                  this.begin("click");
                  break;

                case 26:
                  this.popState();
                  break;

                case 27:
                  return 80;

                case 28:
                case 29:
                  return t.lex.firstGraph() && this.begin("dir"), 24;

                case 30:
                  return 38;

                case 31:
                  return 42;

                case 32:
                case 33:
                case 34:
                case 35:
                  return 91;

                case 36:
                  return this.popState(), 25;

                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 45:
                case 46:
                  return this.popState(), 26;

                case 47:
                  return 110;

                case 48:
                  return 111;

                case 49:
                  return 112;

                case 50:
                  return 113;

                case 51:
                  return 95;

                case 52:
                  return 103;

                case 53:
                  return 48;

                case 54:
                  return 100;

                case 55:
                  return 47;

                case 56:
                  return 20;

                case 57:
                  return 96;

                case 58:
                  return 118;

                case 59:
                case 60:
                case 61:
                  return 71;

                case 62:
                case 63:
                case 64:
                  return 70;

                case 65:
                  return 52;

                case 66:
                  return 53;

                case 67:
                  return 54;

                case 68:
                  return 55;

                case 69:
                  return 56;

                case 70:
                  return 57;

                case 71:
                  return 58;

                case 72:
                  return 59;

                case 73:
                  return 101;

                case 74:
                  return 104;

                case 75:
                  return 119;

                case 76:
                  return 116;

                case 77:
                  return 105;

                case 78:
                case 79:
                  return 117;

                case 80:
                  return 106;

                case 81:
                  return 62;

                case 82:
                  return 82;

                case 83:
                  return "SEP";

                case 84:
                  return 81;

                case 85:
                  return 99;

                case 86:
                  return 64;

                case 87:
                  return 63;

                case 88:
                  return 66;

                case 89:
                  return 65;

                case 90:
                  return 114;

                case 91:
                  return 115;

                case 92:
                  return 72;

                case 93:
                  return 50;

                case 94:
                  return 51;

                case 95:
                  return 40;

                case 96:
                  return 41;

                case 97:
                  return 60;

                case 98:
                  return 61;

                case 99:
                  return 125;

                case 100:
                  return 21;

                case 101:
                  return 22;

                case 102:
                  return 23;
              }
            },
            rules: [/^(?:%%\{)/, /^(?:((?:(?!\}%%)[^:.])*))/, /^(?::)/, /^(?:\}%%)/, /^(?:((?:(?!\}%%).|\n)*))/, /^(?:%%(?!\{)[^\n]*)/, /^(?:[^\}]%%[^\n]*)/, /^(?:["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:style\b)/, /^(?:default\b)/, /^(?:linkStyle\b)/, /^(?:interpolate\b)/, /^(?:classDef\b)/, /^(?:class\b)/, /^(?:href[\s]+["])/, /^(?:["])/, /^(?:[^"]*)/, /^(?:call[\s]+)/, /^(?:\([\s]*\))/, /^(?:\()/, /^(?:[^(]*)/, /^(?:\))/, /^(?:[^)]*)/, /^(?:click[\s]+)/, /^(?:[\s\n])/, /^(?:[^\s\n]*)/, /^(?:graph\b)/, /^(?:flowchart\b)/, /^(?:subgraph\b)/, /^(?:end\b\s*)/, /^(?:_self\b)/, /^(?:_blank\b)/, /^(?:_parent\b)/, /^(?:_top\b)/, /^(?:(\r?\n)*\s*\n)/, /^(?:\s*LR\b)/, /^(?:\s*RL\b)/, /^(?:\s*TB\b)/, /^(?:\s*BT\b)/, /^(?:\s*TD\b)/, /^(?:\s*BR\b)/, /^(?:\s*<)/, /^(?:\s*>)/, /^(?:\s*\^)/, /^(?:\s*v\b)/, /^(?:.*direction\s+TB[^\n]*)/, /^(?:.*direction\s+BT[^\n]*)/, /^(?:.*direction\s+RL[^\n]*)/, /^(?:.*direction\s+LR[^\n]*)/, /^(?:[0-9]+)/, /^(?:#)/, /^(?::::)/, /^(?::)/, /^(?:&)/, /^(?:;)/, /^(?:,)/, /^(?:\*)/, /^(?:\s*[xo<]?--+[-xo>]\s*)/, /^(?:\s*[xo<]?==+[=xo>]\s*)/, /^(?:\s*[xo<]?-?\.+-[xo>]?\s*)/, /^(?:\s*[xo<]?--\s*)/, /^(?:\s*[xo<]?==\s*)/, /^(?:\s*[xo<]?-\.\s*)/, /^(?:\(-)/, /^(?:-\))/, /^(?:\(\[)/, /^(?:\]\))/, /^(?:\[\[)/, /^(?:\]\])/, /^(?:\[\()/, /^(?:\)\])/, /^(?:-)/, /^(?:\.)/, /^(?:[\_])/, /^(?:\+)/, /^(?:%)/, /^(?:=)/, /^(?:=)/, /^(?:<)/, /^(?:>)/, /^(?:\^)/, /^(?:\\\|)/, /^(?:v\b)/, /^(?:[A-Za-z]+)/, /^(?:\\\])/, /^(?:\[\/)/, /^(?:\/\])/, /^(?:\[\\)/, /^(?:[!"#$%&'*+,-.`?\\_/])/, /^(?:[\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6]|[\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377]|[\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5]|[\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA]|[\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE]|[\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA]|[\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0]|[\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977]|[\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2]|[\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A]|[\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39]|[\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8]|[\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C]|[\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C]|[\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99]|[\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0]|[\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D]|[\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3]|[\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10]|[\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1]|[\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81]|[\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3]|[\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6]|[\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A]|[\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081]|[\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D]|[\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0]|[\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310]|[\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C]|[\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711]|[\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7]|[\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C]|[\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16]|[\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF]|[\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC]|[\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D]|[\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D]|[\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3]|[\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F]|[\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128]|[\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184]|[\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3]|[\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6]|[\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE]|[\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C]|[\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D]|[\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC]|[\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B]|[\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788]|[\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805]|[\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB]|[\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28]|[\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5]|[\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4]|[\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E]|[\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D]|[\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36]|[\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D]|[\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC]|[\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF]|[\uFFD2-\uFFD7\uFFDA-\uFFDC])/, /^(?:\|)/, /^(?:\()/, /^(?:\))/, /^(?:\[)/, /^(?:\])/, /^(?:\{)/, /^(?:\})/, /^(?:")/, /^(?:(\r?\n)+)/, /^(?:\s)/, /^(?:$)/],
            conditions: {
              close_directive: {
                rules: [],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3],
                inclusive: !1
              },
              open_directive: {
                rules: [1],
                inclusive: !1
              },
              callbackargs: {
                rules: [23, 24],
                inclusive: !1
              },
              callbackname: {
                rules: [20, 21, 22],
                inclusive: !1
              },
              href: {
                rules: [17, 18],
                inclusive: !1
              },
              click: {
                rules: [26, 27],
                inclusive: !1
              },
              vertex: {
                rules: [],
                inclusive: !1
              },
              dir: {
                rules: [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
                inclusive: !1
              },
              string: {
                rules: [8, 9],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 7, 10, 11, 12, 13, 14, 15, 16, 19, 25, 28, 29, 30, 31, 32, 33, 34, 35, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102],
                inclusive: !0
              }
            }
          };

          function Jt() {
            this.yy = {};
          }

          return Kt.lexer = Qt, Jt.prototype = Kt, Kt.Parser = Jt, new Jt();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(5354).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      2055: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t5, e, n, r) {
            for (n = n || {}, r = _t5.length; r--; n[_t5[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 3],
              n = [1, 5],
              r = [7, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 29, 34],
              i = [1, 15],
              a = [1, 16],
              o = [1, 17],
              s = [1, 18],
              c = [1, 19],
              u = [1, 20],
              l = [1, 21],
              h = [1, 22],
              f = [1, 23],
              d = [1, 25],
              p = [1, 27],
              y = [1, 30],
              g = [5, 7, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 29, 34],
              m = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              directive: 4,
              gantt: 5,
              document: 6,
              EOF: 7,
              line: 8,
              SPACE: 9,
              statement: 10,
              NL: 11,
              dateFormat: 12,
              inclusiveEndDates: 13,
              topAxis: 14,
              axisFormat: 15,
              excludes: 16,
              includes: 17,
              todayMarker: 18,
              title: 19,
              section: 20,
              clickStatement: 21,
              taskTxt: 22,
              taskData: 23,
              openDirective: 24,
              typeDirective: 25,
              closeDirective: 26,
              ":": 27,
              argDirective: 28,
              click: 29,
              callbackname: 30,
              callbackargs: 31,
              href: 32,
              clickStatementDebug: 33,
              open_directive: 34,
              type_directive: 35,
              arg_directive: 36,
              close_directive: 37,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              5: "gantt",
              7: "EOF",
              9: "SPACE",
              11: "NL",
              12: "dateFormat",
              13: "inclusiveEndDates",
              14: "topAxis",
              15: "axisFormat",
              16: "excludes",
              17: "includes",
              18: "todayMarker",
              19: "title",
              20: "section",
              22: "taskTxt",
              23: "taskData",
              27: ":",
              29: "click",
              30: "callbackname",
              31: "callbackargs",
              32: "href",
              34: "open_directive",
              35: "type_directive",
              36: "arg_directive",
              37: "close_directive"
            },
            productions_: [0, [3, 2], [3, 3], [6, 0], [6, 2], [8, 2], [8, 1], [8, 1], [8, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 1], [10, 2], [10, 1], [4, 4], [4, 6], [21, 2], [21, 3], [21, 3], [21, 4], [21, 3], [21, 4], [21, 2], [33, 2], [33, 3], [33, 3], [33, 4], [33, 3], [33, 4], [33, 2], [24, 1], [25, 1], [28, 1], [26, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 2:
                  return a[s - 1];

                case 3:
                  this.$ = [];
                  break;

                case 4:
                  a[s - 1].push(a[s]), this.$ = a[s - 1];
                  break;

                case 5:
                case 6:
                  this.$ = a[s];
                  break;

                case 7:
                case 8:
                  this.$ = [];
                  break;

                case 9:
                  r.setDateFormat(a[s].substr(11)), this.$ = a[s].substr(11);
                  break;

                case 10:
                  r.enableInclusiveEndDates(), this.$ = a[s].substr(18);
                  break;

                case 11:
                  r.TopAxis(), this.$ = a[s].substr(8);
                  break;

                case 12:
                  r.setAxisFormat(a[s].substr(11)), this.$ = a[s].substr(11);
                  break;

                case 13:
                  r.setExcludes(a[s].substr(9)), this.$ = a[s].substr(9);
                  break;

                case 14:
                  r.setIncludes(a[s].substr(9)), this.$ = a[s].substr(9);
                  break;

                case 15:
                  r.setTodayMarker(a[s].substr(12)), this.$ = a[s].substr(12);
                  break;

                case 16:
                  r.setTitle(a[s].substr(6)), this.$ = a[s].substr(6);
                  break;

                case 17:
                  r.addSection(a[s].substr(8)), this.$ = a[s].substr(8);
                  break;

                case 19:
                  r.addTask(a[s - 1], a[s]), this.$ = "task";
                  break;

                case 23:
                  this.$ = a[s - 1], r.setClickEvent(a[s - 1], a[s], null);
                  break;

                case 24:
                  this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s - 1], a[s]);
                  break;

                case 25:
                  this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s - 1], null), r.setLink(a[s - 2], a[s]);
                  break;

                case 26:
                  this.$ = a[s - 3], r.setClickEvent(a[s - 3], a[s - 2], a[s - 1]), r.setLink(a[s - 3], a[s]);
                  break;

                case 27:
                  this.$ = a[s - 2], r.setClickEvent(a[s - 2], a[s], null), r.setLink(a[s - 2], a[s - 1]);
                  break;

                case 28:
                  this.$ = a[s - 3], r.setClickEvent(a[s - 3], a[s - 1], a[s]), r.setLink(a[s - 3], a[s - 2]);
                  break;

                case 29:
                  this.$ = a[s - 1], r.setLink(a[s - 1], a[s]);
                  break;

                case 30:
                case 36:
                  this.$ = a[s - 1] + " " + a[s];
                  break;

                case 31:
                case 32:
                case 34:
                  this.$ = a[s - 2] + " " + a[s - 1] + " " + a[s];
                  break;

                case 33:
                case 35:
                  this.$ = a[s - 3] + " " + a[s - 2] + " " + a[s - 1] + " " + a[s];
                  break;

                case 37:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 38:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 39:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 40:
                  r.parseDirective("}%%", "close_directive", "gantt");
              }
            },
            table: [{
              3: 1,
              4: 2,
              5: e,
              24: 4,
              34: n
            }, {
              1: [3]
            }, {
              3: 6,
              4: 2,
              5: e,
              24: 4,
              34: n
            }, t(r, [2, 3], {
              6: 7
            }), {
              25: 8,
              35: [1, 9]
            }, {
              35: [2, 37]
            }, {
              1: [2, 1]
            }, {
              4: 26,
              7: [1, 10],
              8: 11,
              9: [1, 12],
              10: 13,
              11: [1, 14],
              12: i,
              13: a,
              14: o,
              15: s,
              16: c,
              17: u,
              18: l,
              19: h,
              20: f,
              21: 24,
              22: d,
              24: 4,
              29: p,
              34: n
            }, {
              26: 28,
              27: [1, 29],
              37: y
            }, t([27, 37], [2, 38]), t(r, [2, 8], {
              1: [2, 2]
            }), t(r, [2, 4]), {
              4: 26,
              10: 31,
              12: i,
              13: a,
              14: o,
              15: s,
              16: c,
              17: u,
              18: l,
              19: h,
              20: f,
              21: 24,
              22: d,
              24: 4,
              29: p,
              34: n
            }, t(r, [2, 6]), t(r, [2, 7]), t(r, [2, 9]), t(r, [2, 10]), t(r, [2, 11]), t(r, [2, 12]), t(r, [2, 13]), t(r, [2, 14]), t(r, [2, 15]), t(r, [2, 16]), t(r, [2, 17]), t(r, [2, 18]), {
              23: [1, 32]
            }, t(r, [2, 20]), {
              30: [1, 33],
              32: [1, 34]
            }, {
              11: [1, 35]
            }, {
              28: 36,
              36: [1, 37]
            }, {
              11: [2, 40]
            }, t(r, [2, 5]), t(r, [2, 19]), t(r, [2, 23], {
              31: [1, 38],
              32: [1, 39]
            }), t(r, [2, 29], {
              30: [1, 40]
            }), t(g, [2, 21]), {
              26: 41,
              37: y
            }, {
              37: [2, 39]
            }, t(r, [2, 24], {
              32: [1, 42]
            }), t(r, [2, 25]), t(r, [2, 27], {
              31: [1, 43]
            }), {
              11: [1, 44]
            }, t(r, [2, 26]), t(r, [2, 28]), t(g, [2, 22])],
            defaultActions: {
              5: [2, 37],
              6: [2, 1],
              30: [2, 40],
              37: [2, 39]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              v = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 34;

                case 1:
                  return this.begin("type_directive"), 35;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 27;

                case 3:
                  return this.popState(), this.popState(), 37;

                case 4:
                  return 36;

                case 5:
                case 6:
                case 7:
                  break;

                case 8:
                  return 11;

                case 9:
                case 10:
                case 11:
                  break;

                case 12:
                  this.begin("href");
                  break;

                case 13:
                  this.popState();
                  break;

                case 14:
                  return 32;

                case 15:
                  this.begin("callbackname");
                  break;

                case 16:
                  this.popState();
                  break;

                case 17:
                  this.popState(), this.begin("callbackargs");
                  break;

                case 18:
                  return 30;

                case 19:
                  this.popState();
                  break;

                case 20:
                  return 31;

                case 21:
                  this.begin("click");
                  break;

                case 22:
                  this.popState();
                  break;

                case 23:
                  return 29;

                case 24:
                  return 5;

                case 25:
                  return 12;

                case 26:
                  return 13;

                case 27:
                  return 14;

                case 28:
                  return 15;

                case 29:
                  return 17;

                case 30:
                  return 16;

                case 31:
                  return 18;

                case 32:
                  return "date";

                case 33:
                  return 19;

                case 34:
                  return 20;

                case 35:
                  return 22;

                case 36:
                  return 23;

                case 37:
                  return 27;

                case 38:
                  return 7;

                case 39:
                  return "INVALID";
              }
            },
            rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%%(?!\{)*[^\n]*)/i, /^(?:[^\}]%%*[^\n]*)/i, /^(?:%%*[^\n]*[\n]*)/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:href[\s]+["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:call[\s]+)/i, /^(?:\([\s]*\))/i, /^(?:\()/i, /^(?:[^(]*)/i, /^(?:\))/i, /^(?:[^)]*)/i, /^(?:click[\s]+)/i, /^(?:[\s\n])/i, /^(?:[^\s\n]*)/i, /^(?:gantt\b)/i, /^(?:dateFormat\s[^#\n;]+)/i, /^(?:inclusiveEndDates\b)/i, /^(?:topAxis\b)/i, /^(?:axisFormat\s[^#\n;]+)/i, /^(?:includes\s[^#\n;]+)/i, /^(?:excludes\s[^#\n;]+)/i, /^(?:todayMarker\s[^\n;]+)/i, /^(?:\d\d\d\d-\d\d-\d\d\b)/i, /^(?:title\s[^#\n;]+)/i, /^(?:section\s[^#:\n;]+)/i, /^(?:[^#:\n;]+)/i, /^(?::[^#\n;]+)/i, /^(?::)/i, /^(?:$)/i, /^(?:.)/i],
            conditions: {
              close_directive: {
                rules: [],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3],
                inclusive: !1
              },
              open_directive: {
                rules: [1],
                inclusive: !1
              },
              callbackargs: {
                rules: [19, 20],
                inclusive: !1
              },
              callbackname: {
                rules: [16, 17, 18],
                inclusive: !1
              },
              href: {
                rules: [13, 14],
                inclusive: !1
              },
              click: {
                rules: [22, 23],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 15, 21, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
                inclusive: !0
              }
            }
          };

          function b() {
            this.yy = {};
          }

          return m.lexer = v, b.prototype = m, m.Parser = b, new b();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(6878).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      8454: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t6, e, n, r) {
            for (n = n || {}, r = _t6.length; r--; n[_t6[r]] = e) {
              ;
            }

            return n;
          },
              e = [2, 3],
              n = [1, 7],
              r = [7, 12, 15, 17, 19, 20, 21],
              i = [7, 11, 12, 15, 17, 19, 20, 21],
              a = [2, 20],
              o = [1, 32],
              s = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              GG: 4,
              ":": 5,
              document: 6,
              EOF: 7,
              DIR: 8,
              options: 9,
              body: 10,
              OPT: 11,
              NL: 12,
              line: 13,
              statement: 14,
              COMMIT: 15,
              commit_arg: 16,
              BRANCH: 17,
              ID: 18,
              CHECKOUT: 19,
              MERGE: 20,
              RESET: 21,
              reset_arg: 22,
              STR: 23,
              HEAD: 24,
              reset_parents: 25,
              CARET: 26,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              4: "GG",
              5: ":",
              7: "EOF",
              8: "DIR",
              11: "OPT",
              12: "NL",
              15: "COMMIT",
              17: "BRANCH",
              18: "ID",
              19: "CHECKOUT",
              20: "MERGE",
              21: "RESET",
              23: "STR",
              24: "HEAD",
              26: "CARET"
            },
            productions_: [0, [3, 4], [3, 5], [6, 0], [6, 2], [9, 2], [9, 1], [10, 0], [10, 2], [13, 2], [13, 1], [14, 2], [14, 2], [14, 2], [14, 2], [14, 2], [16, 0], [16, 1], [22, 2], [22, 2], [25, 0], [25, 2]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 1:
                  return a[s - 1];

                case 2:
                  return r.setDirection(a[s - 3]), a[s - 1];

                case 4:
                  r.setOptions(a[s - 1]), this.$ = a[s];
                  break;

                case 5:
                  a[s - 1] += a[s], this.$ = a[s - 1];
                  break;

                case 7:
                  this.$ = [];
                  break;

                case 8:
                  a[s - 1].push(a[s]), this.$ = a[s - 1];
                  break;

                case 9:
                  this.$ = a[s - 1];
                  break;

                case 11:
                  r.commit(a[s]);
                  break;

                case 12:
                  r.branch(a[s]);
                  break;

                case 13:
                  r.checkout(a[s]);
                  break;

                case 14:
                  r.merge(a[s]);
                  break;

                case 15:
                  r.reset(a[s]);
                  break;

                case 16:
                  this.$ = "";
                  break;

                case 17:
                  this.$ = a[s];
                  break;

                case 18:
                  this.$ = a[s - 1] + ":" + a[s];
                  break;

                case 19:
                  this.$ = a[s - 1] + ":" + r.count, r.count = 0;
                  break;

                case 20:
                  r.count = 0;
                  break;

                case 21:
                  r.count += 1;
              }
            },
            table: [{
              3: 1,
              4: [1, 2]
            }, {
              1: [3]
            }, {
              5: [1, 3],
              8: [1, 4]
            }, {
              6: 5,
              7: e,
              9: 6,
              12: n
            }, {
              5: [1, 8]
            }, {
              7: [1, 9]
            }, t(r, [2, 7], {
              10: 10,
              11: [1, 11]
            }), t(i, [2, 6]), {
              6: 12,
              7: e,
              9: 6,
              12: n
            }, {
              1: [2, 1]
            }, {
              7: [2, 4],
              12: [1, 15],
              13: 13,
              14: 14,
              15: [1, 16],
              17: [1, 17],
              19: [1, 18],
              20: [1, 19],
              21: [1, 20]
            }, t(i, [2, 5]), {
              7: [1, 21]
            }, t(r, [2, 8]), {
              12: [1, 22]
            }, t(r, [2, 10]), {
              12: [2, 16],
              16: 23,
              23: [1, 24]
            }, {
              18: [1, 25]
            }, {
              18: [1, 26]
            }, {
              18: [1, 27]
            }, {
              18: [1, 30],
              22: 28,
              24: [1, 29]
            }, {
              1: [2, 2]
            }, t(r, [2, 9]), {
              12: [2, 11]
            }, {
              12: [2, 17]
            }, {
              12: [2, 12]
            }, {
              12: [2, 13]
            }, {
              12: [2, 14]
            }, {
              12: [2, 15]
            }, {
              12: a,
              25: 31,
              26: o
            }, {
              12: a,
              25: 33,
              26: o
            }, {
              12: [2, 18]
            }, {
              12: a,
              25: 34,
              26: o
            }, {
              12: [2, 19]
            }, {
              12: [2, 21]
            }],
            defaultActions: {
              9: [2, 1],
              21: [2, 2],
              23: [2, 11],
              24: [2, 17],
              25: [2, 12],
              26: [2, 13],
              27: [2, 14],
              28: [2, 15],
              31: [2, 18],
              33: [2, 19],
              34: [2, 21]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              c = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return 12;

                case 1:
                case 2:
                case 3:
                  break;

                case 4:
                  return 4;

                case 5:
                  return 15;

                case 6:
                  return 17;

                case 7:
                  return 20;

                case 8:
                  return 21;

                case 9:
                  return 19;

                case 10:
                case 11:
                  return 8;

                case 12:
                  return 5;

                case 13:
                  return 26;

                case 14:
                  this.begin("options");
                  break;

                case 15:
                  this.popState();
                  break;

                case 16:
                  return 11;

                case 17:
                  this.begin("string");
                  break;

                case 18:
                  this.popState();
                  break;

                case 19:
                  return 23;

                case 20:
                  return 18;

                case 21:
                  return 7;
              }
            },
            rules: [/^(?:(\r?\n)+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:gitGraph\b)/i, /^(?:commit\b)/i, /^(?:branch\b)/i, /^(?:merge\b)/i, /^(?:reset\b)/i, /^(?:checkout\b)/i, /^(?:LR\b)/i, /^(?:BT\b)/i, /^(?::)/i, /^(?:\^)/i, /^(?:options\r?\n)/i, /^(?:end\r?\n)/i, /^(?:[^\n]+\r?\n)/i, /^(?:["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[a-zA-Z][-_\.a-zA-Z0-9]*[-_a-zA-Z0-9])/i, /^(?:$)/i],
            conditions: {
              options: {
                rules: [15, 16],
                inclusive: !1
              },
              string: {
                rules: [18, 19],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 17, 20, 21],
                inclusive: !0
              }
            }
          };

          function u() {
            this.yy = {};
          }

          return s.lexer = c, u.prototype = s, s.Parser = u, new u();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(8183).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      4645: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t7, e, n, r) {
            for (n = n || {}, r = _t7.length; r--; n[_t7[r]] = e) {
              ;
            }

            return n;
          },
              e = [6, 9, 10],
              n = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              info: 4,
              document: 5,
              EOF: 6,
              line: 7,
              statement: 8,
              NL: 9,
              showInfo: 10,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              4: "info",
              6: "EOF",
              9: "NL",
              10: "showInfo"
            },
            productions_: [0, [3, 3], [5, 0], [5, 2], [7, 1], [7, 1], [8, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              switch (a.length, i) {
                case 1:
                  return r;

                case 4:
                  break;

                case 6:
                  r.setInfo(!0);
              }
            },
            table: [{
              3: 1,
              4: [1, 2]
            }, {
              1: [3]
            }, t(e, [2, 2], {
              5: 3
            }), {
              6: [1, 4],
              7: 5,
              8: 6,
              9: [1, 7],
              10: [1, 8]
            }, {
              1: [2, 1]
            }, t(e, [2, 3]), t(e, [2, 4]), t(e, [2, 5]), t(e, [2, 6])],
            defaultActions: {
              4: [2, 1]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              r = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return 4;

                case 1:
                  return 9;

                case 2:
                  return "space";

                case 3:
                  return 10;

                case 4:
                  return 6;

                case 5:
                  return "TXT";
              }
            },
            rules: [/^(?:info\b)/i, /^(?:[\s\n\r]+)/i, /^(?:[\s]+)/i, /^(?:showInfo\b)/i, /^(?:$)/i, /^(?:.)/i],
            conditions: {
              INITIAL: {
                rules: [0, 1, 2, 3, 4, 5],
                inclusive: !0
              }
            }
          };

          function i() {
            this.yy = {};
          }

          return n.lexer = r, i.prototype = n, n.Parser = i, new i();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(1428).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      5963: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t8, e, n, r) {
            for (n = n || {}, r = _t8.length; r--; n[_t8[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 4],
              n = [1, 5],
              r = [1, 6],
              i = [1, 7],
              a = [1, 9],
              o = [1, 11, 13, 20, 21, 22, 23],
              s = [2, 5],
              c = [1, 6, 11, 13, 20, 21, 22, 23],
              u = [20, 21, 22],
              l = [2, 8],
              h = [1, 18],
              f = [1, 19],
              d = [1, 24],
              p = [6, 20, 21, 22, 23],
              y = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              eol: 4,
              directive: 5,
              PIE: 6,
              document: 7,
              showData: 8,
              line: 9,
              statement: 10,
              txt: 11,
              value: 12,
              title: 13,
              title_value: 14,
              openDirective: 15,
              typeDirective: 16,
              closeDirective: 17,
              ":": 18,
              argDirective: 19,
              NEWLINE: 20,
              ";": 21,
              EOF: 22,
              open_directive: 23,
              type_directive: 24,
              arg_directive: 25,
              close_directive: 26,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              6: "PIE",
              8: "showData",
              11: "txt",
              12: "value",
              13: "title",
              14: "title_value",
              18: ":",
              20: "NEWLINE",
              21: ";",
              22: "EOF",
              23: "open_directive",
              24: "type_directive",
              25: "arg_directive",
              26: "close_directive"
            },
            productions_: [0, [3, 2], [3, 2], [3, 2], [3, 3], [7, 0], [7, 2], [9, 2], [10, 0], [10, 2], [10, 2], [10, 1], [5, 3], [5, 5], [4, 1], [4, 1], [4, 1], [15, 1], [16, 1], [19, 1], [17, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 4:
                  r.setShowData(!0);
                  break;

                case 7:
                  this.$ = a[s - 1];
                  break;

                case 9:
                  r.addSection(a[s - 1], r.cleanupValue(a[s]));
                  break;

                case 10:
                  this.$ = a[s].trim(), r.setTitle(this.$);
                  break;

                case 17:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 18:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 19:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 20:
                  r.parseDirective("}%%", "close_directive", "pie");
              }
            },
            table: [{
              3: 1,
              4: 2,
              5: 3,
              6: e,
              15: 8,
              20: n,
              21: r,
              22: i,
              23: a
            }, {
              1: [3]
            }, {
              3: 10,
              4: 2,
              5: 3,
              6: e,
              15: 8,
              20: n,
              21: r,
              22: i,
              23: a
            }, {
              3: 11,
              4: 2,
              5: 3,
              6: e,
              15: 8,
              20: n,
              21: r,
              22: i,
              23: a
            }, t(o, s, {
              7: 12,
              8: [1, 13]
            }), t(c, [2, 14]), t(c, [2, 15]), t(c, [2, 16]), {
              16: 14,
              24: [1, 15]
            }, {
              24: [2, 17]
            }, {
              1: [2, 1]
            }, {
              1: [2, 2]
            }, t(u, l, {
              15: 8,
              9: 16,
              10: 17,
              5: 20,
              1: [2, 3],
              11: h,
              13: f,
              23: a
            }), t(o, s, {
              7: 21
            }), {
              17: 22,
              18: [1, 23],
              26: d
            }, t([18, 26], [2, 18]), t(o, [2, 6]), {
              4: 25,
              20: n,
              21: r,
              22: i
            }, {
              12: [1, 26]
            }, {
              14: [1, 27]
            }, t(u, [2, 11]), t(u, l, {
              15: 8,
              9: 16,
              10: 17,
              5: 20,
              1: [2, 4],
              11: h,
              13: f,
              23: a
            }), t(p, [2, 12]), {
              19: 28,
              25: [1, 29]
            }, t(p, [2, 20]), t(o, [2, 7]), t(u, [2, 9]), t(u, [2, 10]), {
              17: 30,
              26: d
            }, {
              26: [2, 19]
            }, t(p, [2, 13])],
            defaultActions: {
              9: [2, 17],
              10: [2, 1],
              11: [2, 2],
              29: [2, 19]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              g = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 23;

                case 1:
                  return this.begin("type_directive"), 24;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 18;

                case 3:
                  return this.popState(), this.popState(), 26;

                case 4:
                  return 25;

                case 5:
                case 6:
                  break;

                case 7:
                  return 20;

                case 8:
                case 9:
                  break;

                case 10:
                  return this.begin("title"), 13;

                case 11:
                  return this.popState(), "title_value";

                case 12:
                  this.begin("string");
                  break;

                case 13:
                  this.popState();
                  break;

                case 14:
                  return "txt";

                case 15:
                  return 6;

                case 16:
                  return 8;

                case 17:
                  return "value";

                case 18:
                  return 22;
              }
            },
            rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n\r]+)/i, /^(?:%%[^\n]*)/i, /^(?:[\s]+)/i, /^(?:title\b)/i, /^(?:(?!\n||)*[^\n]*)/i, /^(?:["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:pie\b)/i, /^(?:showData\b)/i, /^(?::[\s]*[\d]+(?:\.[\d]+)?)/i, /^(?:$)/i],
            conditions: {
              close_directive: {
                rules: [],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3],
                inclusive: !1
              },
              open_directive: {
                rules: [1],
                inclusive: !1
              },
              title: {
                rules: [11],
                inclusive: !1
              },
              string: {
                rules: [13, 14],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 7, 8, 9, 10, 12, 15, 16, 17, 18],
                inclusive: !0
              }
            }
          };

          function m() {
            this.yy = {};
          }

          return y.lexer = g, m.prototype = y, y.Parser = m, new m();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(4551).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      6463: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t9, e, n, r) {
            for (n = n || {}, r = _t9.length; r--; n[_t9[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 3],
              n = [1, 5],
              r = [1, 17],
              i = [2, 10],
              a = [1, 21],
              o = [1, 22],
              s = [1, 23],
              c = [1, 24],
              u = [1, 25],
              l = [1, 26],
              h = [1, 19],
              f = [1, 27],
              d = [1, 28],
              p = [1, 31],
              y = [66, 67],
              g = [5, 8, 14, 35, 36, 37, 38, 39, 40, 48, 55, 57, 66, 67],
              m = [5, 6, 8, 14, 35, 36, 37, 38, 39, 40, 48, 66, 67],
              v = [1, 51],
              b = [1, 52],
              _ = [1, 53],
              x = [1, 54],
              w = [1, 55],
              k = [1, 56],
              T = [1, 57],
              E = [57, 58],
              C = [1, 69],
              S = [1, 65],
              A = [1, 66],
              M = [1, 67],
              N = [1, 68],
              D = [1, 70],
              O = [1, 74],
              B = [1, 75],
              L = [1, 72],
              I = [1, 73],
              R = [5, 8, 14, 35, 36, 37, 38, 39, 40, 48, 66, 67],
              P = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              directive: 4,
              NEWLINE: 5,
              RD: 6,
              diagram: 7,
              EOF: 8,
              openDirective: 9,
              typeDirective: 10,
              closeDirective: 11,
              ":": 12,
              argDirective: 13,
              open_directive: 14,
              type_directive: 15,
              arg_directive: 16,
              close_directive: 17,
              requirementDef: 18,
              elementDef: 19,
              relationshipDef: 20,
              requirementType: 21,
              requirementName: 22,
              STRUCT_START: 23,
              requirementBody: 24,
              ID: 25,
              COLONSEP: 26,
              id: 27,
              TEXT: 28,
              text: 29,
              RISK: 30,
              riskLevel: 31,
              VERIFYMTHD: 32,
              verifyType: 33,
              STRUCT_STOP: 34,
              REQUIREMENT: 35,
              FUNCTIONAL_REQUIREMENT: 36,
              INTERFACE_REQUIREMENT: 37,
              PERFORMANCE_REQUIREMENT: 38,
              PHYSICAL_REQUIREMENT: 39,
              DESIGN_CONSTRAINT: 40,
              LOW_RISK: 41,
              MED_RISK: 42,
              HIGH_RISK: 43,
              VERIFY_ANALYSIS: 44,
              VERIFY_DEMONSTRATION: 45,
              VERIFY_INSPECTION: 46,
              VERIFY_TEST: 47,
              ELEMENT: 48,
              elementName: 49,
              elementBody: 50,
              TYPE: 51,
              type: 52,
              DOCREF: 53,
              ref: 54,
              END_ARROW_L: 55,
              relationship: 56,
              LINE: 57,
              END_ARROW_R: 58,
              CONTAINS: 59,
              COPIES: 60,
              DERIVES: 61,
              SATISFIES: 62,
              VERIFIES: 63,
              REFINES: 64,
              TRACES: 65,
              unqString: 66,
              qString: 67,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              5: "NEWLINE",
              6: "RD",
              8: "EOF",
              12: ":",
              14: "open_directive",
              15: "type_directive",
              16: "arg_directive",
              17: "close_directive",
              23: "STRUCT_START",
              25: "ID",
              26: "COLONSEP",
              28: "TEXT",
              30: "RISK",
              32: "VERIFYMTHD",
              34: "STRUCT_STOP",
              35: "REQUIREMENT",
              36: "FUNCTIONAL_REQUIREMENT",
              37: "INTERFACE_REQUIREMENT",
              38: "PERFORMANCE_REQUIREMENT",
              39: "PHYSICAL_REQUIREMENT",
              40: "DESIGN_CONSTRAINT",
              41: "LOW_RISK",
              42: "MED_RISK",
              43: "HIGH_RISK",
              44: "VERIFY_ANALYSIS",
              45: "VERIFY_DEMONSTRATION",
              46: "VERIFY_INSPECTION",
              47: "VERIFY_TEST",
              48: "ELEMENT",
              51: "TYPE",
              53: "DOCREF",
              55: "END_ARROW_L",
              57: "LINE",
              58: "END_ARROW_R",
              59: "CONTAINS",
              60: "COPIES",
              61: "DERIVES",
              62: "SATISFIES",
              63: "VERIFIES",
              64: "REFINES",
              65: "TRACES",
              66: "unqString",
              67: "qString"
            },
            productions_: [0, [3, 3], [3, 2], [3, 4], [4, 3], [4, 5], [9, 1], [10, 1], [13, 1], [11, 1], [7, 0], [7, 2], [7, 2], [7, 2], [7, 2], [7, 2], [18, 5], [24, 5], [24, 5], [24, 5], [24, 5], [24, 2], [24, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [21, 1], [31, 1], [31, 1], [31, 1], [33, 1], [33, 1], [33, 1], [33, 1], [19, 5], [50, 5], [50, 5], [50, 2], [50, 1], [20, 5], [20, 5], [56, 1], [56, 1], [56, 1], [56, 1], [56, 1], [56, 1], [56, 1], [22, 1], [22, 1], [27, 1], [27, 1], [29, 1], [29, 1], [49, 1], [49, 1], [52, 1], [52, 1], [54, 1], [54, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 6:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 7:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 8:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 9:
                  r.parseDirective("}%%", "close_directive", "pie");
                  break;

                case 10:
                  this.$ = [];
                  break;

                case 16:
                  r.addRequirement(a[s - 3], a[s - 4]);
                  break;

                case 17:
                  r.setNewReqId(a[s - 2]);
                  break;

                case 18:
                  r.setNewReqText(a[s - 2]);
                  break;

                case 19:
                  r.setNewReqRisk(a[s - 2]);
                  break;

                case 20:
                  r.setNewReqVerifyMethod(a[s - 2]);
                  break;

                case 23:
                  this.$ = r.RequirementType.REQUIREMENT;
                  break;

                case 24:
                  this.$ = r.RequirementType.FUNCTIONAL_REQUIREMENT;
                  break;

                case 25:
                  this.$ = r.RequirementType.INTERFACE_REQUIREMENT;
                  break;

                case 26:
                  this.$ = r.RequirementType.PERFORMANCE_REQUIREMENT;
                  break;

                case 27:
                  this.$ = r.RequirementType.PHYSICAL_REQUIREMENT;
                  break;

                case 28:
                  this.$ = r.RequirementType.DESIGN_CONSTRAINT;
                  break;

                case 29:
                  this.$ = r.RiskLevel.LOW_RISK;
                  break;

                case 30:
                  this.$ = r.RiskLevel.MED_RISK;
                  break;

                case 31:
                  this.$ = r.RiskLevel.HIGH_RISK;
                  break;

                case 32:
                  this.$ = r.VerifyType.VERIFY_ANALYSIS;
                  break;

                case 33:
                  this.$ = r.VerifyType.VERIFY_DEMONSTRATION;
                  break;

                case 34:
                  this.$ = r.VerifyType.VERIFY_INSPECTION;
                  break;

                case 35:
                  this.$ = r.VerifyType.VERIFY_TEST;
                  break;

                case 36:
                  r.addElement(a[s - 3]);
                  break;

                case 37:
                  r.setNewElementType(a[s - 2]);
                  break;

                case 38:
                  r.setNewElementDocRef(a[s - 2]);
                  break;

                case 41:
                  r.addRelationship(a[s - 2], a[s], a[s - 4]);
                  break;

                case 42:
                  r.addRelationship(a[s - 2], a[s - 4], a[s]);
                  break;

                case 43:
                  this.$ = r.Relationships.CONTAINS;
                  break;

                case 44:
                  this.$ = r.Relationships.COPIES;
                  break;

                case 45:
                  this.$ = r.Relationships.DERIVES;
                  break;

                case 46:
                  this.$ = r.Relationships.SATISFIES;
                  break;

                case 47:
                  this.$ = r.Relationships.VERIFIES;
                  break;

                case 48:
                  this.$ = r.Relationships.REFINES;
                  break;

                case 49:
                  this.$ = r.Relationships.TRACES;
              }
            },
            table: [{
              3: 1,
              4: 2,
              6: e,
              9: 4,
              14: n
            }, {
              1: [3]
            }, {
              3: 7,
              4: 2,
              5: [1, 6],
              6: e,
              9: 4,
              14: n
            }, {
              5: [1, 8]
            }, {
              10: 9,
              15: [1, 10]
            }, {
              15: [2, 6]
            }, {
              3: 11,
              4: 2,
              6: e,
              9: 4,
              14: n
            }, {
              1: [2, 2]
            }, {
              4: 16,
              5: r,
              7: 12,
              8: i,
              9: 4,
              14: n,
              18: 13,
              19: 14,
              20: 15,
              21: 18,
              27: 20,
              35: a,
              36: o,
              37: s,
              38: c,
              39: u,
              40: l,
              48: h,
              66: f,
              67: d
            }, {
              11: 29,
              12: [1, 30],
              17: p
            }, t([12, 17], [2, 7]), {
              1: [2, 1]
            }, {
              8: [1, 32]
            }, {
              4: 16,
              5: r,
              7: 33,
              8: i,
              9: 4,
              14: n,
              18: 13,
              19: 14,
              20: 15,
              21: 18,
              27: 20,
              35: a,
              36: o,
              37: s,
              38: c,
              39: u,
              40: l,
              48: h,
              66: f,
              67: d
            }, {
              4: 16,
              5: r,
              7: 34,
              8: i,
              9: 4,
              14: n,
              18: 13,
              19: 14,
              20: 15,
              21: 18,
              27: 20,
              35: a,
              36: o,
              37: s,
              38: c,
              39: u,
              40: l,
              48: h,
              66: f,
              67: d
            }, {
              4: 16,
              5: r,
              7: 35,
              8: i,
              9: 4,
              14: n,
              18: 13,
              19: 14,
              20: 15,
              21: 18,
              27: 20,
              35: a,
              36: o,
              37: s,
              38: c,
              39: u,
              40: l,
              48: h,
              66: f,
              67: d
            }, {
              4: 16,
              5: r,
              7: 36,
              8: i,
              9: 4,
              14: n,
              18: 13,
              19: 14,
              20: 15,
              21: 18,
              27: 20,
              35: a,
              36: o,
              37: s,
              38: c,
              39: u,
              40: l,
              48: h,
              66: f,
              67: d
            }, {
              4: 16,
              5: r,
              7: 37,
              8: i,
              9: 4,
              14: n,
              18: 13,
              19: 14,
              20: 15,
              21: 18,
              27: 20,
              35: a,
              36: o,
              37: s,
              38: c,
              39: u,
              40: l,
              48: h,
              66: f,
              67: d
            }, {
              22: 38,
              66: [1, 39],
              67: [1, 40]
            }, {
              49: 41,
              66: [1, 42],
              67: [1, 43]
            }, {
              55: [1, 44],
              57: [1, 45]
            }, t(y, [2, 23]), t(y, [2, 24]), t(y, [2, 25]), t(y, [2, 26]), t(y, [2, 27]), t(y, [2, 28]), t(g, [2, 52]), t(g, [2, 53]), t(m, [2, 4]), {
              13: 46,
              16: [1, 47]
            }, t(m, [2, 9]), {
              1: [2, 3]
            }, {
              8: [2, 11]
            }, {
              8: [2, 12]
            }, {
              8: [2, 13]
            }, {
              8: [2, 14]
            }, {
              8: [2, 15]
            }, {
              23: [1, 48]
            }, {
              23: [2, 50]
            }, {
              23: [2, 51]
            }, {
              23: [1, 49]
            }, {
              23: [2, 56]
            }, {
              23: [2, 57]
            }, {
              56: 50,
              59: v,
              60: b,
              61: _,
              62: x,
              63: w,
              64: k,
              65: T
            }, {
              56: 58,
              59: v,
              60: b,
              61: _,
              62: x,
              63: w,
              64: k,
              65: T
            }, {
              11: 59,
              17: p
            }, {
              17: [2, 8]
            }, {
              5: [1, 60]
            }, {
              5: [1, 61]
            }, {
              57: [1, 62]
            }, t(E, [2, 43]), t(E, [2, 44]), t(E, [2, 45]), t(E, [2, 46]), t(E, [2, 47]), t(E, [2, 48]), t(E, [2, 49]), {
              58: [1, 63]
            }, t(m, [2, 5]), {
              5: C,
              24: 64,
              25: S,
              28: A,
              30: M,
              32: N,
              34: D
            }, {
              5: O,
              34: B,
              50: 71,
              51: L,
              53: I
            }, {
              27: 76,
              66: f,
              67: d
            }, {
              27: 77,
              66: f,
              67: d
            }, t(R, [2, 16]), {
              26: [1, 78]
            }, {
              26: [1, 79]
            }, {
              26: [1, 80]
            }, {
              26: [1, 81]
            }, {
              5: C,
              24: 82,
              25: S,
              28: A,
              30: M,
              32: N,
              34: D
            }, t(R, [2, 22]), t(R, [2, 36]), {
              26: [1, 83]
            }, {
              26: [1, 84]
            }, {
              5: O,
              34: B,
              50: 85,
              51: L,
              53: I
            }, t(R, [2, 40]), t(R, [2, 41]), t(R, [2, 42]), {
              27: 86,
              66: f,
              67: d
            }, {
              29: 87,
              66: [1, 88],
              67: [1, 89]
            }, {
              31: 90,
              41: [1, 91],
              42: [1, 92],
              43: [1, 93]
            }, {
              33: 94,
              44: [1, 95],
              45: [1, 96],
              46: [1, 97],
              47: [1, 98]
            }, t(R, [2, 21]), {
              52: 99,
              66: [1, 100],
              67: [1, 101]
            }, {
              54: 102,
              66: [1, 103],
              67: [1, 104]
            }, t(R, [2, 39]), {
              5: [1, 105]
            }, {
              5: [1, 106]
            }, {
              5: [2, 54]
            }, {
              5: [2, 55]
            }, {
              5: [1, 107]
            }, {
              5: [2, 29]
            }, {
              5: [2, 30]
            }, {
              5: [2, 31]
            }, {
              5: [1, 108]
            }, {
              5: [2, 32]
            }, {
              5: [2, 33]
            }, {
              5: [2, 34]
            }, {
              5: [2, 35]
            }, {
              5: [1, 109]
            }, {
              5: [2, 58]
            }, {
              5: [2, 59]
            }, {
              5: [1, 110]
            }, {
              5: [2, 60]
            }, {
              5: [2, 61]
            }, {
              5: C,
              24: 111,
              25: S,
              28: A,
              30: M,
              32: N,
              34: D
            }, {
              5: C,
              24: 112,
              25: S,
              28: A,
              30: M,
              32: N,
              34: D
            }, {
              5: C,
              24: 113,
              25: S,
              28: A,
              30: M,
              32: N,
              34: D
            }, {
              5: C,
              24: 114,
              25: S,
              28: A,
              30: M,
              32: N,
              34: D
            }, {
              5: O,
              34: B,
              50: 115,
              51: L,
              53: I
            }, {
              5: O,
              34: B,
              50: 116,
              51: L,
              53: I
            }, t(R, [2, 17]), t(R, [2, 18]), t(R, [2, 19]), t(R, [2, 20]), t(R, [2, 37]), t(R, [2, 38])],
            defaultActions: {
              5: [2, 6],
              7: [2, 2],
              11: [2, 1],
              32: [2, 3],
              33: [2, 11],
              34: [2, 12],
              35: [2, 13],
              36: [2, 14],
              37: [2, 15],
              39: [2, 50],
              40: [2, 51],
              42: [2, 56],
              43: [2, 57],
              47: [2, 8],
              88: [2, 54],
              89: [2, 55],
              91: [2, 29],
              92: [2, 30],
              93: [2, 31],
              95: [2, 32],
              96: [2, 33],
              97: [2, 34],
              98: [2, 35],
              100: [2, 58],
              101: [2, 59],
              103: [2, 60],
              104: [2, 61]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              F = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 14;

                case 1:
                  return this.begin("type_directive"), 15;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 12;

                case 3:
                  return this.popState(), this.popState(), 17;

                case 4:
                  return 16;

                case 5:
                  return 5;

                case 6:
                case 7:
                case 8:
                  break;

                case 9:
                  return 8;

                case 10:
                  return 6;

                case 11:
                  return 23;

                case 12:
                  return 34;

                case 13:
                  return 26;

                case 14:
                  return 25;

                case 15:
                  return 28;

                case 16:
                  return 30;

                case 17:
                  return 32;

                case 18:
                  return 35;

                case 19:
                  return 36;

                case 20:
                  return 37;

                case 21:
                  return 38;

                case 22:
                  return 39;

                case 23:
                  return 40;

                case 24:
                  return 41;

                case 25:
                  return 42;

                case 26:
                  return 43;

                case 27:
                  return 44;

                case 28:
                  return 45;

                case 29:
                  return 46;

                case 30:
                  return 47;

                case 31:
                  return 48;

                case 32:
                  return 59;

                case 33:
                  return 60;

                case 34:
                  return 61;

                case 35:
                  return 62;

                case 36:
                  return 63;

                case 37:
                  return 64;

                case 38:
                  return 65;

                case 39:
                  return 51;

                case 40:
                  return 53;

                case 41:
                  return 55;

                case 42:
                  return 58;

                case 43:
                  return 57;

                case 44:
                  this.begin("string");
                  break;

                case 45:
                  this.popState();
                  break;

                case 46:
                  return "qString";

                case 47:
                  return e.yytext = e.yytext.trim(), 66;
              }
            },
            rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:(\r?\n)+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:$)/i, /^(?:requirementDiagram\b)/i, /^(?:\{)/i, /^(?:\})/i, /^(?::)/i, /^(?:id\b)/i, /^(?:text\b)/i, /^(?:risk\b)/i, /^(?:verifyMethod\b)/i, /^(?:requirement\b)/i, /^(?:functionalRequirement\b)/i, /^(?:interfaceRequirement\b)/i, /^(?:performanceRequirement\b)/i, /^(?:physicalRequirement\b)/i, /^(?:designConstraint\b)/i, /^(?:low\b)/i, /^(?:medium\b)/i, /^(?:high\b)/i, /^(?:analysis\b)/i, /^(?:demonstration\b)/i, /^(?:inspection\b)/i, /^(?:test\b)/i, /^(?:element\b)/i, /^(?:contains\b)/i, /^(?:copies\b)/i, /^(?:derives\b)/i, /^(?:satisfies\b)/i, /^(?:verifies\b)/i, /^(?:refines\b)/i, /^(?:traces\b)/i, /^(?:type\b)/i, /^(?:docref\b)/i, /^(?:<-)/i, /^(?:->)/i, /^(?:-)/i, /^(?:["])/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[\w][^\r\n\{\<\>\-\=]*)/i],
            conditions: {
              close_directive: {
                rules: [],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3],
                inclusive: !1
              },
              open_directive: {
                rules: [1],
                inclusive: !1
              },
              unqString: {
                rules: [],
                inclusive: !1
              },
              token: {
                rules: [],
                inclusive: !1
              },
              string: {
                rules: [45, 46],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 47],
                inclusive: !0
              }
            }
          };

          function j() {
            this.yy = {};
          }

          return P.lexer = F, j.prototype = P, P.Parser = j, new j();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(8800).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      9923: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t10, e, n, r) {
            for (n = n || {}, r = _t10.length; r--; n[_t10[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 2],
              n = [1, 3],
              r = [1, 5],
              i = [1, 7],
              a = [2, 5],
              o = [1, 15],
              s = [1, 17],
              c = [1, 18],
              u = [1, 19],
              l = [1, 21],
              h = [1, 22],
              f = [1, 23],
              d = [1, 29],
              p = [1, 30],
              y = [1, 31],
              g = [1, 32],
              m = [1, 33],
              v = [1, 34],
              b = [1, 37],
              _ = [1, 38],
              x = [1, 39],
              w = [1, 40],
              k = [1, 41],
              T = [1, 42],
              E = [1, 45],
              C = [1, 4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 40, 41, 42, 46, 47, 48, 49, 57, 67],
              S = [1, 58],
              A = [4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 42, 46, 47, 48, 49, 57, 67],
              M = [4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 41, 42, 46, 47, 48, 49, 57, 67],
              N = [4, 5, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 40, 42, 46, 47, 48, 49, 57, 67],
              D = [55, 56, 57],
              O = [1, 4, 5, 7, 16, 20, 22, 23, 24, 30, 32, 33, 34, 35, 36, 38, 40, 41, 42, 46, 47, 48, 49, 57, 67],
              B = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              SPACE: 4,
              NEWLINE: 5,
              directive: 6,
              SD: 7,
              document: 8,
              line: 9,
              statement: 10,
              openDirective: 11,
              typeDirective: 12,
              closeDirective: 13,
              ":": 14,
              argDirective: 15,
              participant: 16,
              actor: 17,
              AS: 18,
              restOfLine: 19,
              participant_actor: 20,
              signal: 21,
              autonumber: 22,
              activate: 23,
              deactivate: 24,
              note_statement: 25,
              links_statement: 26,
              link_statement: 27,
              properties_statement: 28,
              details_statement: 29,
              title: 30,
              text2: 31,
              loop: 32,
              end: 33,
              rect: 34,
              opt: 35,
              alt: 36,
              else_sections: 37,
              par: 38,
              par_sections: 39,
              and: 40,
              else: 41,
              note: 42,
              placement: 43,
              over: 44,
              actor_pair: 45,
              links: 46,
              link: 47,
              properties: 48,
              details: 49,
              spaceList: 50,
              ",": 51,
              left_of: 52,
              right_of: 53,
              signaltype: 54,
              "+": 55,
              "-": 56,
              ACTOR: 57,
              SOLID_OPEN_ARROW: 58,
              DOTTED_OPEN_ARROW: 59,
              SOLID_ARROW: 60,
              DOTTED_ARROW: 61,
              SOLID_CROSS: 62,
              DOTTED_CROSS: 63,
              SOLID_POINT: 64,
              DOTTED_POINT: 65,
              TXT: 66,
              open_directive: 67,
              type_directive: 68,
              arg_directive: 69,
              close_directive: 70,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              4: "SPACE",
              5: "NEWLINE",
              7: "SD",
              14: ":",
              16: "participant",
              18: "AS",
              19: "restOfLine",
              20: "participant_actor",
              22: "autonumber",
              23: "activate",
              24: "deactivate",
              30: "title",
              32: "loop",
              33: "end",
              34: "rect",
              35: "opt",
              36: "alt",
              38: "par",
              40: "and",
              41: "else",
              42: "note",
              44: "over",
              46: "links",
              47: "link",
              48: "properties",
              49: "details",
              51: ",",
              52: "left_of",
              53: "right_of",
              55: "+",
              56: "-",
              57: "ACTOR",
              58: "SOLID_OPEN_ARROW",
              59: "DOTTED_OPEN_ARROW",
              60: "SOLID_ARROW",
              61: "DOTTED_ARROW",
              62: "SOLID_CROSS",
              63: "DOTTED_CROSS",
              64: "SOLID_POINT",
              65: "DOTTED_POINT",
              66: "TXT",
              67: "open_directive",
              68: "type_directive",
              69: "arg_directive",
              70: "close_directive"
            },
            productions_: [0, [3, 2], [3, 2], [3, 2], [3, 2], [8, 0], [8, 2], [9, 2], [9, 1], [9, 1], [6, 4], [6, 6], [10, 5], [10, 3], [10, 5], [10, 3], [10, 2], [10, 1], [10, 3], [10, 3], [10, 2], [10, 2], [10, 2], [10, 2], [10, 2], [10, 3], [10, 4], [10, 4], [10, 4], [10, 4], [10, 4], [10, 1], [39, 1], [39, 4], [37, 1], [37, 4], [25, 4], [25, 4], [26, 3], [27, 3], [28, 3], [29, 3], [50, 2], [50, 1], [45, 3], [45, 1], [43, 1], [43, 1], [21, 5], [21, 5], [21, 4], [17, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [54, 1], [31, 1], [11, 1], [12, 1], [15, 1], [13, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 4:
                  return r.apply(a[s]), a[s];

                case 5:
                  this.$ = [];
                  break;

                case 6:
                  a[s - 1].push(a[s]), this.$ = a[s - 1];
                  break;

                case 7:
                case 8:
                  this.$ = a[s];
                  break;

                case 9:
                  this.$ = [];
                  break;

                case 12:
                  a[s - 3].type = "addParticipant", a[s - 3].description = r.parseMessage(a[s - 1]), this.$ = a[s - 3];
                  break;

                case 13:
                  a[s - 1].type = "addParticipant", this.$ = a[s - 1];
                  break;

                case 14:
                  a[s - 3].type = "addActor", a[s - 3].description = r.parseMessage(a[s - 1]), this.$ = a[s - 3];
                  break;

                case 15:
                  a[s - 1].type = "addActor", this.$ = a[s - 1];
                  break;

                case 17:
                  r.enableSequenceNumbers();
                  break;

                case 18:
                  this.$ = {
                    type: "activeStart",
                    signalType: r.LINETYPE.ACTIVE_START,
                    actor: a[s - 1]
                  };
                  break;

                case 19:
                  this.$ = {
                    type: "activeEnd",
                    signalType: r.LINETYPE.ACTIVE_END,
                    actor: a[s - 1]
                  };
                  break;

                case 25:
                  this.$ = [{
                    type: "setTitle",
                    text: a[s - 1]
                  }];
                  break;

                case 26:
                  a[s - 1].unshift({
                    type: "loopStart",
                    loopText: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.LOOP_START
                  }), a[s - 1].push({
                    type: "loopEnd",
                    loopText: a[s - 2],
                    signalType: r.LINETYPE.LOOP_END
                  }), this.$ = a[s - 1];
                  break;

                case 27:
                  a[s - 1].unshift({
                    type: "rectStart",
                    color: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.RECT_START
                  }), a[s - 1].push({
                    type: "rectEnd",
                    color: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.RECT_END
                  }), this.$ = a[s - 1];
                  break;

                case 28:
                  a[s - 1].unshift({
                    type: "optStart",
                    optText: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.OPT_START
                  }), a[s - 1].push({
                    type: "optEnd",
                    optText: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.OPT_END
                  }), this.$ = a[s - 1];
                  break;

                case 29:
                  a[s - 1].unshift({
                    type: "altStart",
                    altText: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.ALT_START
                  }), a[s - 1].push({
                    type: "altEnd",
                    signalType: r.LINETYPE.ALT_END
                  }), this.$ = a[s - 1];
                  break;

                case 30:
                  a[s - 1].unshift({
                    type: "parStart",
                    parText: r.parseMessage(a[s - 2]),
                    signalType: r.LINETYPE.PAR_START
                  }), a[s - 1].push({
                    type: "parEnd",
                    signalType: r.LINETYPE.PAR_END
                  }), this.$ = a[s - 1];
                  break;

                case 33:
                  this.$ = a[s - 3].concat([{
                    type: "and",
                    parText: r.parseMessage(a[s - 1]),
                    signalType: r.LINETYPE.PAR_AND
                  }, a[s]]);
                  break;

                case 35:
                  this.$ = a[s - 3].concat([{
                    type: "else",
                    altText: r.parseMessage(a[s - 1]),
                    signalType: r.LINETYPE.ALT_ELSE
                  }, a[s]]);
                  break;

                case 36:
                  this.$ = [a[s - 1], {
                    type: "addNote",
                    placement: a[s - 2],
                    actor: a[s - 1].actor,
                    text: a[s]
                  }];
                  break;

                case 37:
                  a[s - 2] = [].concat(a[s - 1], a[s - 1]).slice(0, 2), a[s - 2][0] = a[s - 2][0].actor, a[s - 2][1] = a[s - 2][1].actor, this.$ = [a[s - 1], {
                    type: "addNote",
                    placement: r.PLACEMENT.OVER,
                    actor: a[s - 2].slice(0, 2),
                    text: a[s]
                  }];
                  break;

                case 38:
                  this.$ = [a[s - 1], {
                    type: "addLinks",
                    actor: a[s - 1].actor,
                    text: a[s]
                  }];
                  break;

                case 39:
                  this.$ = [a[s - 1], {
                    type: "addALink",
                    actor: a[s - 1].actor,
                    text: a[s]
                  }];
                  break;

                case 40:
                  this.$ = [a[s - 1], {
                    type: "addProperties",
                    actor: a[s - 1].actor,
                    text: a[s]
                  }];
                  break;

                case 41:
                  this.$ = [a[s - 1], {
                    type: "addDetails",
                    actor: a[s - 1].actor,
                    text: a[s]
                  }];
                  break;

                case 44:
                  this.$ = [a[s - 2], a[s]];
                  break;

                case 45:
                  this.$ = a[s];
                  break;

                case 46:
                  this.$ = r.PLACEMENT.LEFTOF;
                  break;

                case 47:
                  this.$ = r.PLACEMENT.RIGHTOF;
                  break;

                case 48:
                  this.$ = [a[s - 4], a[s - 1], {
                    type: "addMessage",
                    from: a[s - 4].actor,
                    to: a[s - 1].actor,
                    signalType: a[s - 3],
                    msg: a[s]
                  }, {
                    type: "activeStart",
                    signalType: r.LINETYPE.ACTIVE_START,
                    actor: a[s - 1]
                  }];
                  break;

                case 49:
                  this.$ = [a[s - 4], a[s - 1], {
                    type: "addMessage",
                    from: a[s - 4].actor,
                    to: a[s - 1].actor,
                    signalType: a[s - 3],
                    msg: a[s]
                  }, {
                    type: "activeEnd",
                    signalType: r.LINETYPE.ACTIVE_END,
                    actor: a[s - 4]
                  }];
                  break;

                case 50:
                  this.$ = [a[s - 3], a[s - 1], {
                    type: "addMessage",
                    from: a[s - 3].actor,
                    to: a[s - 1].actor,
                    signalType: a[s - 2],
                    msg: a[s]
                  }];
                  break;

                case 51:
                  this.$ = {
                    type: "addParticipant",
                    actor: a[s]
                  };
                  break;

                case 52:
                  this.$ = r.LINETYPE.SOLID_OPEN;
                  break;

                case 53:
                  this.$ = r.LINETYPE.DOTTED_OPEN;
                  break;

                case 54:
                  this.$ = r.LINETYPE.SOLID;
                  break;

                case 55:
                  this.$ = r.LINETYPE.DOTTED;
                  break;

                case 56:
                  this.$ = r.LINETYPE.SOLID_CROSS;
                  break;

                case 57:
                  this.$ = r.LINETYPE.DOTTED_CROSS;
                  break;

                case 58:
                  this.$ = r.LINETYPE.SOLID_POINT;
                  break;

                case 59:
                  this.$ = r.LINETYPE.DOTTED_POINT;
                  break;

                case 60:
                  this.$ = r.parseMessage(a[s].trim().substring(1));
                  break;

                case 61:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 62:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 63:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 64:
                  r.parseDirective("}%%", "close_directive", "sequence");
              }
            },
            table: [{
              3: 1,
              4: e,
              5: n,
              6: 4,
              7: r,
              11: 6,
              67: i
            }, {
              1: [3]
            }, {
              3: 8,
              4: e,
              5: n,
              6: 4,
              7: r,
              11: 6,
              67: i
            }, {
              3: 9,
              4: e,
              5: n,
              6: 4,
              7: r,
              11: 6,
              67: i
            }, {
              3: 10,
              4: e,
              5: n,
              6: 4,
              7: r,
              11: 6,
              67: i
            }, t([1, 4, 5, 16, 20, 22, 23, 24, 30, 32, 34, 35, 36, 38, 42, 46, 47, 48, 49, 57, 67], a, {
              8: 11
            }), {
              12: 12,
              68: [1, 13]
            }, {
              68: [2, 61]
            }, {
              1: [2, 1]
            }, {
              1: [2, 2]
            }, {
              1: [2, 3]
            }, {
              1: [2, 4],
              4: o,
              5: s,
              6: 35,
              9: 14,
              10: 16,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              34: y,
              35: g,
              36: m,
              38: v,
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, {
              13: 43,
              14: [1, 44],
              70: E
            }, t([14, 70], [2, 62]), t(C, [2, 6]), {
              6: 35,
              10: 46,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              34: y,
              35: g,
              36: m,
              38: v,
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, t(C, [2, 8]), t(C, [2, 9]), {
              17: 47,
              57: T
            }, {
              17: 48,
              57: T
            }, {
              5: [1, 49]
            }, t(C, [2, 17]), {
              17: 50,
              57: T
            }, {
              17: 51,
              57: T
            }, {
              5: [1, 52]
            }, {
              5: [1, 53]
            }, {
              5: [1, 54]
            }, {
              5: [1, 55]
            }, {
              5: [1, 56]
            }, {
              31: 57,
              66: S
            }, {
              19: [1, 59]
            }, {
              19: [1, 60]
            }, {
              19: [1, 61]
            }, {
              19: [1, 62]
            }, {
              19: [1, 63]
            }, t(C, [2, 31]), {
              54: 64,
              58: [1, 65],
              59: [1, 66],
              60: [1, 67],
              61: [1, 68],
              62: [1, 69],
              63: [1, 70],
              64: [1, 71],
              65: [1, 72]
            }, {
              43: 73,
              44: [1, 74],
              52: [1, 75],
              53: [1, 76]
            }, {
              17: 77,
              57: T
            }, {
              17: 78,
              57: T
            }, {
              17: 79,
              57: T
            }, {
              17: 80,
              57: T
            }, t([5, 18, 51, 58, 59, 60, 61, 62, 63, 64, 65, 66], [2, 51]), {
              5: [1, 81]
            }, {
              15: 82,
              69: [1, 83]
            }, {
              5: [2, 64]
            }, t(C, [2, 7]), {
              5: [1, 85],
              18: [1, 84]
            }, {
              5: [1, 87],
              18: [1, 86]
            }, t(C, [2, 16]), {
              5: [1, 88]
            }, {
              5: [1, 89]
            }, t(C, [2, 20]), t(C, [2, 21]), t(C, [2, 22]), t(C, [2, 23]), t(C, [2, 24]), {
              5: [1, 90]
            }, {
              5: [2, 60]
            }, t(A, a, {
              8: 91
            }), t(A, a, {
              8: 92
            }), t(A, a, {
              8: 93
            }), t(M, a, {
              37: 94,
              8: 95
            }), t(N, a, {
              39: 96,
              8: 97
            }), {
              17: 100,
              55: [1, 98],
              56: [1, 99],
              57: T
            }, t(D, [2, 52]), t(D, [2, 53]), t(D, [2, 54]), t(D, [2, 55]), t(D, [2, 56]), t(D, [2, 57]), t(D, [2, 58]), t(D, [2, 59]), {
              17: 101,
              57: T
            }, {
              17: 103,
              45: 102,
              57: T
            }, {
              57: [2, 46]
            }, {
              57: [2, 47]
            }, {
              31: 104,
              66: S
            }, {
              31: 105,
              66: S
            }, {
              31: 106,
              66: S
            }, {
              31: 107,
              66: S
            }, t(O, [2, 10]), {
              13: 108,
              70: E
            }, {
              70: [2, 63]
            }, {
              19: [1, 109]
            }, t(C, [2, 13]), {
              19: [1, 110]
            }, t(C, [2, 15]), t(C, [2, 18]), t(C, [2, 19]), t(C, [2, 25]), {
              4: o,
              5: s,
              6: 35,
              9: 14,
              10: 16,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              33: [1, 111],
              34: y,
              35: g,
              36: m,
              38: v,
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, {
              4: o,
              5: s,
              6: 35,
              9: 14,
              10: 16,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              33: [1, 112],
              34: y,
              35: g,
              36: m,
              38: v,
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, {
              4: o,
              5: s,
              6: 35,
              9: 14,
              10: 16,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              33: [1, 113],
              34: y,
              35: g,
              36: m,
              38: v,
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, {
              33: [1, 114]
            }, {
              4: o,
              5: s,
              6: 35,
              9: 14,
              10: 16,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              33: [2, 34],
              34: y,
              35: g,
              36: m,
              38: v,
              41: [1, 115],
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, {
              33: [1, 116]
            }, {
              4: o,
              5: s,
              6: 35,
              9: 14,
              10: 16,
              11: 6,
              16: c,
              17: 36,
              20: u,
              21: 20,
              22: l,
              23: h,
              24: f,
              25: 24,
              26: 25,
              27: 26,
              28: 27,
              29: 28,
              30: d,
              32: p,
              33: [2, 32],
              34: y,
              35: g,
              36: m,
              38: v,
              40: [1, 117],
              42: b,
              46: _,
              47: x,
              48: w,
              49: k,
              57: T,
              67: i
            }, {
              17: 118,
              57: T
            }, {
              17: 119,
              57: T
            }, {
              31: 120,
              66: S
            }, {
              31: 121,
              66: S
            }, {
              31: 122,
              66: S
            }, {
              51: [1, 123],
              66: [2, 45]
            }, {
              5: [2, 38]
            }, {
              5: [2, 39]
            }, {
              5: [2, 40]
            }, {
              5: [2, 41]
            }, {
              5: [1, 124]
            }, {
              5: [1, 125]
            }, {
              5: [1, 126]
            }, t(C, [2, 26]), t(C, [2, 27]), t(C, [2, 28]), t(C, [2, 29]), {
              19: [1, 127]
            }, t(C, [2, 30]), {
              19: [1, 128]
            }, {
              31: 129,
              66: S
            }, {
              31: 130,
              66: S
            }, {
              5: [2, 50]
            }, {
              5: [2, 36]
            }, {
              5: [2, 37]
            }, {
              17: 131,
              57: T
            }, t(O, [2, 11]), t(C, [2, 12]), t(C, [2, 14]), t(M, a, {
              8: 95,
              37: 132
            }), t(N, a, {
              8: 97,
              39: 133
            }), {
              5: [2, 48]
            }, {
              5: [2, 49]
            }, {
              66: [2, 44]
            }, {
              33: [2, 35]
            }, {
              33: [2, 33]
            }],
            defaultActions: {
              7: [2, 61],
              8: [2, 1],
              9: [2, 2],
              10: [2, 3],
              45: [2, 64],
              58: [2, 60],
              75: [2, 46],
              76: [2, 47],
              83: [2, 63],
              104: [2, 38],
              105: [2, 39],
              106: [2, 40],
              107: [2, 41],
              120: [2, 50],
              121: [2, 36],
              122: [2, 37],
              129: [2, 48],
              130: [2, 49],
              131: [2, 44],
              132: [2, 35],
              133: [2, 33]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              L = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 67;

                case 1:
                  return this.begin("type_directive"), 68;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 14;

                case 3:
                  return this.popState(), this.popState(), 70;

                case 4:
                  return 69;

                case 5:
                  return 5;

                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                  break;

                case 11:
                  return this.begin("ID"), 16;

                case 12:
                  return this.begin("ID"), 20;

                case 13:
                  return e.yytext = e.yytext.trim(), this.begin("ALIAS"), 57;

                case 14:
                  return this.popState(), this.popState(), this.begin("LINE"), 18;

                case 15:
                  return this.popState(), this.popState(), 5;

                case 16:
                  return this.begin("LINE"), 32;

                case 17:
                  return this.begin("LINE"), 34;

                case 18:
                  return this.begin("LINE"), 35;

                case 19:
                  return this.begin("LINE"), 36;

                case 20:
                  return this.begin("LINE"), 41;

                case 21:
                  return this.begin("LINE"), 38;

                case 22:
                  return this.begin("LINE"), 40;

                case 23:
                  return this.popState(), 19;

                case 24:
                  return 33;

                case 25:
                  return 52;

                case 26:
                  return 53;

                case 27:
                  return 46;

                case 28:
                  return 47;

                case 29:
                  return 48;

                case 30:
                  return 49;

                case 31:
                  return 44;

                case 32:
                  return 42;

                case 33:
                  return this.begin("ID"), 23;

                case 34:
                  return this.begin("ID"), 24;

                case 35:
                  return 30;

                case 36:
                  return 7;

                case 37:
                  return 22;

                case 38:
                  return 51;

                case 39:
                  return 5;

                case 40:
                  return e.yytext = e.yytext.trim(), 57;

                case 41:
                  return 60;

                case 42:
                  return 61;

                case 43:
                  return 58;

                case 44:
                  return 59;

                case 45:
                  return 62;

                case 46:
                  return 63;

                case 47:
                  return 64;

                case 48:
                  return 65;

                case 49:
                  return 66;

                case 50:
                  return 55;

                case 51:
                  return 56;

                case 52:
                  return 5;

                case 53:
                  return "INVALID";
              }
            },
            rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:((?!\n)\s)+)/i, /^(?:#[^\n]*)/i, /^(?:%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:participant\b)/i, /^(?:actor\b)/i, /^(?:[^\->:\n,;]+?(?=((?!\n)\s)+as(?!\n)\s|[#\n;]|$))/i, /^(?:as\b)/i, /^(?:(?:))/i, /^(?:loop\b)/i, /^(?:rect\b)/i, /^(?:opt\b)/i, /^(?:alt\b)/i, /^(?:else\b)/i, /^(?:par\b)/i, /^(?:and\b)/i, /^(?:(?:[:]?(?:no)?wrap)?[^#\n;]*)/i, /^(?:end\b)/i, /^(?:left of\b)/i, /^(?:right of\b)/i, /^(?:links\b)/i, /^(?:link\b)/i, /^(?:properties\b)/i, /^(?:details\b)/i, /^(?:over\b)/i, /^(?:note\b)/i, /^(?:activate\b)/i, /^(?:deactivate\b)/i, /^(?:title\b)/i, /^(?:sequenceDiagram\b)/i, /^(?:autonumber\b)/i, /^(?:,)/i, /^(?:;)/i, /^(?:[^\+\->:\n,;]+((?!(-x|--x|-\)|--\)))[\-]*[^\+\->:\n,;]+)*)/i, /^(?:->>)/i, /^(?:-->>)/i, /^(?:->)/i, /^(?:-->)/i, /^(?:-[x])/i, /^(?:--[x])/i, /^(?:-[\)])/i, /^(?:--[\)])/i, /^(?::(?:(?:no)?wrap)?[^#\n;]+)/i, /^(?:\+)/i, /^(?:-)/i, /^(?:$)/i, /^(?:.)/i],
            conditions: {
              open_directive: {
                rules: [1, 8],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3, 8],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4, 8],
                inclusive: !1
              },
              ID: {
                rules: [7, 8, 13],
                inclusive: !1
              },
              ALIAS: {
                rules: [7, 8, 14, 15],
                inclusive: !1
              },
              LINE: {
                rules: [7, 8, 23],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 8, 9, 10, 11, 12, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53],
                inclusive: !0
              }
            }
          };

          function I() {
            this.yy = {};
          }

          return B.lexer = L, I.prototype = B, B.Parser = I, new I();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(1993).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      5537: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t11, e, n, r) {
            for (n = n || {}, r = _t11.length; r--; n[_t11[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 2],
              n = [1, 3],
              r = [1, 5],
              i = [1, 7],
              a = [2, 5],
              o = [1, 15],
              s = [1, 17],
              c = [1, 19],
              u = [1, 20],
              l = [1, 21],
              h = [1, 22],
              f = [1, 30],
              d = [1, 23],
              p = [1, 24],
              y = [1, 25],
              g = [1, 26],
              m = [1, 27],
              v = [1, 32],
              b = [1, 33],
              _ = [1, 34],
              x = [1, 35],
              w = [1, 31],
              k = [1, 38],
              T = [1, 4, 5, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
              E = [1, 4, 5, 12, 13, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
              C = [1, 4, 5, 7, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
              S = [4, 5, 14, 15, 17, 19, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45],
              A = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              SPACE: 4,
              NL: 5,
              directive: 6,
              SD: 7,
              document: 8,
              line: 9,
              statement: 10,
              idStatement: 11,
              DESCR: 12,
              "--\x3e": 13,
              HIDE_EMPTY: 14,
              scale: 15,
              WIDTH: 16,
              COMPOSIT_STATE: 17,
              STRUCT_START: 18,
              STRUCT_STOP: 19,
              STATE_DESCR: 20,
              AS: 21,
              ID: 22,
              FORK: 23,
              JOIN: 24,
              CHOICE: 25,
              CONCURRENT: 26,
              note: 27,
              notePosition: 28,
              NOTE_TEXT: 29,
              direction: 30,
              openDirective: 31,
              typeDirective: 32,
              closeDirective: 33,
              ":": 34,
              argDirective: 35,
              direction_tb: 36,
              direction_bt: 37,
              direction_rl: 38,
              direction_lr: 39,
              eol: 40,
              ";": 41,
              EDGE_STATE: 42,
              left_of: 43,
              right_of: 44,
              open_directive: 45,
              type_directive: 46,
              arg_directive: 47,
              close_directive: 48,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              4: "SPACE",
              5: "NL",
              7: "SD",
              12: "DESCR",
              13: "--\x3e",
              14: "HIDE_EMPTY",
              15: "scale",
              16: "WIDTH",
              17: "COMPOSIT_STATE",
              18: "STRUCT_START",
              19: "STRUCT_STOP",
              20: "STATE_DESCR",
              21: "AS",
              22: "ID",
              23: "FORK",
              24: "JOIN",
              25: "CHOICE",
              26: "CONCURRENT",
              27: "note",
              29: "NOTE_TEXT",
              34: ":",
              36: "direction_tb",
              37: "direction_bt",
              38: "direction_rl",
              39: "direction_lr",
              41: ";",
              42: "EDGE_STATE",
              43: "left_of",
              44: "right_of",
              45: "open_directive",
              46: "type_directive",
              47: "arg_directive",
              48: "close_directive"
            },
            productions_: [0, [3, 2], [3, 2], [3, 2], [3, 2], [8, 0], [8, 2], [9, 2], [9, 1], [9, 1], [10, 1], [10, 2], [10, 3], [10, 4], [10, 1], [10, 2], [10, 1], [10, 4], [10, 3], [10, 6], [10, 1], [10, 1], [10, 1], [10, 1], [10, 4], [10, 4], [10, 1], [10, 1], [6, 3], [6, 5], [30, 1], [30, 1], [30, 1], [30, 1], [40, 1], [40, 1], [11, 1], [11, 1], [28, 1], [28, 1], [31, 1], [32, 1], [35, 1], [33, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 4:
                  return r.setRootDoc(a[s]), a[s];

                case 5:
                  this.$ = [];
                  break;

                case 6:
                  "nl" != a[s] && (a[s - 1].push(a[s]), this.$ = a[s - 1]);
                  break;

                case 7:
                case 8:
                  this.$ = a[s];
                  break;

                case 9:
                  this.$ = "nl";
                  break;

                case 10:
                  this.$ = {
                    stmt: "state",
                    id: a[s],
                    type: "default",
                    description: ""
                  };
                  break;

                case 11:
                  this.$ = {
                    stmt: "state",
                    id: a[s - 1],
                    type: "default",
                    description: r.trimColon(a[s])
                  };
                  break;

                case 12:
                  this.$ = {
                    stmt: "relation",
                    state1: {
                      stmt: "state",
                      id: a[s - 2],
                      type: "default",
                      description: ""
                    },
                    state2: {
                      stmt: "state",
                      id: a[s],
                      type: "default",
                      description: ""
                    }
                  };
                  break;

                case 13:
                  this.$ = {
                    stmt: "relation",
                    state1: {
                      stmt: "state",
                      id: a[s - 3],
                      type: "default",
                      description: ""
                    },
                    state2: {
                      stmt: "state",
                      id: a[s - 1],
                      type: "default",
                      description: ""
                    },
                    description: a[s].substr(1).trim()
                  };
                  break;

                case 17:
                  this.$ = {
                    stmt: "state",
                    id: a[s - 3],
                    type: "default",
                    description: "",
                    doc: a[s - 1]
                  };
                  break;

                case 18:
                  var c = a[s],
                      u = a[s - 2].trim();

                  if (a[s].match(":")) {
                    var l = a[s].split(":");
                    c = l[0], u = [u, l[1]];
                  }

                  this.$ = {
                    stmt: "state",
                    id: c,
                    type: "default",
                    description: u
                  };
                  break;

                case 19:
                  this.$ = {
                    stmt: "state",
                    id: a[s - 3],
                    type: "default",
                    description: a[s - 5],
                    doc: a[s - 1]
                  };
                  break;

                case 20:
                  this.$ = {
                    stmt: "state",
                    id: a[s],
                    type: "fork"
                  };
                  break;

                case 21:
                  this.$ = {
                    stmt: "state",
                    id: a[s],
                    type: "join"
                  };
                  break;

                case 22:
                  this.$ = {
                    stmt: "state",
                    id: a[s],
                    type: "choice"
                  };
                  break;

                case 23:
                  this.$ = {
                    stmt: "state",
                    id: r.getDividerId(),
                    type: "divider"
                  };
                  break;

                case 24:
                  this.$ = {
                    stmt: "state",
                    id: a[s - 1].trim(),
                    note: {
                      position: a[s - 2].trim(),
                      text: a[s].trim()
                    }
                  };
                  break;

                case 30:
                  r.setDirection("TB"), this.$ = {
                    stmt: "dir",
                    value: "TB"
                  };
                  break;

                case 31:
                  r.setDirection("BT"), this.$ = {
                    stmt: "dir",
                    value: "BT"
                  };
                  break;

                case 32:
                  r.setDirection("RL"), this.$ = {
                    stmt: "dir",
                    value: "RL"
                  };
                  break;

                case 33:
                  r.setDirection("LR"), this.$ = {
                    stmt: "dir",
                    value: "LR"
                  };
                  break;

                case 36:
                case 37:
                  this.$ = a[s];
                  break;

                case 40:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 41:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 42:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 43:
                  r.parseDirective("}%%", "close_directive", "state");
              }
            },
            table: [{
              3: 1,
              4: e,
              5: n,
              6: 4,
              7: r,
              31: 6,
              45: i
            }, {
              1: [3]
            }, {
              3: 8,
              4: e,
              5: n,
              6: 4,
              7: r,
              31: 6,
              45: i
            }, {
              3: 9,
              4: e,
              5: n,
              6: 4,
              7: r,
              31: 6,
              45: i
            }, {
              3: 10,
              4: e,
              5: n,
              6: 4,
              7: r,
              31: 6,
              45: i
            }, t([1, 4, 5, 14, 15, 17, 20, 22, 23, 24, 25, 26, 27, 36, 37, 38, 39, 42, 45], a, {
              8: 11
            }), {
              32: 12,
              46: [1, 13]
            }, {
              46: [2, 40]
            }, {
              1: [2, 1]
            }, {
              1: [2, 2]
            }, {
              1: [2, 3]
            }, {
              1: [2, 4],
              4: o,
              5: s,
              6: 28,
              9: 14,
              10: 16,
              11: 18,
              14: c,
              15: u,
              17: l,
              20: h,
              22: f,
              23: d,
              24: p,
              25: y,
              26: g,
              27: m,
              30: 29,
              31: 6,
              36: v,
              37: b,
              38: _,
              39: x,
              42: w,
              45: i
            }, {
              33: 36,
              34: [1, 37],
              48: k
            }, t([34, 48], [2, 41]), t(T, [2, 6]), {
              6: 28,
              10: 39,
              11: 18,
              14: c,
              15: u,
              17: l,
              20: h,
              22: f,
              23: d,
              24: p,
              25: y,
              26: g,
              27: m,
              30: 29,
              31: 6,
              36: v,
              37: b,
              38: _,
              39: x,
              42: w,
              45: i
            }, t(T, [2, 8]), t(T, [2, 9]), t(T, [2, 10], {
              12: [1, 40],
              13: [1, 41]
            }), t(T, [2, 14]), {
              16: [1, 42]
            }, t(T, [2, 16], {
              18: [1, 43]
            }), {
              21: [1, 44]
            }, t(T, [2, 20]), t(T, [2, 21]), t(T, [2, 22]), t(T, [2, 23]), {
              28: 45,
              29: [1, 46],
              43: [1, 47],
              44: [1, 48]
            }, t(T, [2, 26]), t(T, [2, 27]), t(E, [2, 36]), t(E, [2, 37]), t(T, [2, 30]), t(T, [2, 31]), t(T, [2, 32]), t(T, [2, 33]), t(C, [2, 28]), {
              35: 49,
              47: [1, 50]
            }, t(C, [2, 43]), t(T, [2, 7]), t(T, [2, 11]), {
              11: 51,
              22: f,
              42: w
            }, t(T, [2, 15]), t(S, a, {
              8: 52
            }), {
              22: [1, 53]
            }, {
              22: [1, 54]
            }, {
              21: [1, 55]
            }, {
              22: [2, 38]
            }, {
              22: [2, 39]
            }, {
              33: 56,
              48: k
            }, {
              48: [2, 42]
            }, t(T, [2, 12], {
              12: [1, 57]
            }), {
              4: o,
              5: s,
              6: 28,
              9: 14,
              10: 16,
              11: 18,
              14: c,
              15: u,
              17: l,
              19: [1, 58],
              20: h,
              22: f,
              23: d,
              24: p,
              25: y,
              26: g,
              27: m,
              30: 29,
              31: 6,
              36: v,
              37: b,
              38: _,
              39: x,
              42: w,
              45: i
            }, t(T, [2, 18], {
              18: [1, 59]
            }), {
              29: [1, 60]
            }, {
              22: [1, 61]
            }, t(C, [2, 29]), t(T, [2, 13]), t(T, [2, 17]), t(S, a, {
              8: 62
            }), t(T, [2, 24]), t(T, [2, 25]), {
              4: o,
              5: s,
              6: 28,
              9: 14,
              10: 16,
              11: 18,
              14: c,
              15: u,
              17: l,
              19: [1, 63],
              20: h,
              22: f,
              23: d,
              24: p,
              25: y,
              26: g,
              27: m,
              30: 29,
              31: 6,
              36: v,
              37: b,
              38: _,
              39: x,
              42: w,
              45: i
            }, t(T, [2, 19])],
            defaultActions: {
              7: [2, 40],
              8: [2, 1],
              9: [2, 2],
              10: [2, 3],
              47: [2, 38],
              48: [2, 39],
              50: [2, 42]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              M = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return 36;

                case 1:
                  return 37;

                case 2:
                  return 38;

                case 3:
                  return 39;

                case 4:
                  return this.begin("open_directive"), 45;

                case 5:
                  return this.begin("type_directive"), 46;

                case 6:
                  return this.popState(), this.begin("arg_directive"), 34;

                case 7:
                  return this.popState(), this.popState(), 48;

                case 8:
                  return 47;

                case 9:
                case 10:
                  break;

                case 11:
                  return 5;

                case 12:
                case 13:
                case 14:
                case 15:
                  break;

                case 16:
                  return this.pushState("SCALE"), 15;

                case 17:
                  return 16;

                case 18:
                  this.popState();
                  break;

                case 19:
                  this.pushState("STATE");
                  break;

                case 20:
                  return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 23;

                case 21:
                  return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 24;

                case 22:
                  return this.popState(), e.yytext = e.yytext.slice(0, -10).trim(), 25;

                case 23:
                  return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 23;

                case 24:
                  return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 24;

                case 25:
                  return this.popState(), e.yytext = e.yytext.slice(0, -10).trim(), 25;

                case 26:
                  return 36;

                case 27:
                  return 37;

                case 28:
                  return 38;

                case 29:
                  return 39;

                case 30:
                  this.begin("STATE_STRING");
                  break;

                case 31:
                  return this.popState(), this.pushState("STATE_ID"), "AS";

                case 32:
                  return this.popState(), "ID";

                case 33:
                  this.popState();
                  break;

                case 34:
                  return "STATE_DESCR";

                case 35:
                  return 17;

                case 36:
                  this.popState();
                  break;

                case 37:
                  return this.popState(), this.pushState("struct"), 18;

                case 38:
                  return this.popState(), 19;

                case 39:
                  break;

                case 40:
                  return this.begin("NOTE"), 27;

                case 41:
                  return this.popState(), this.pushState("NOTE_ID"), 43;

                case 42:
                  return this.popState(), this.pushState("NOTE_ID"), 44;

                case 43:
                  this.popState(), this.pushState("FLOATING_NOTE");
                  break;

                case 44:
                  return this.popState(), this.pushState("FLOATING_NOTE_ID"), "AS";

                case 45:
                  break;

                case 46:
                  return "NOTE_TEXT";

                case 47:
                  return this.popState(), "ID";

                case 48:
                  return this.popState(), this.pushState("NOTE_TEXT"), 22;

                case 49:
                  return this.popState(), e.yytext = e.yytext.substr(2).trim(), 29;

                case 50:
                  return this.popState(), e.yytext = e.yytext.slice(0, -8).trim(), 29;

                case 51:
                case 52:
                  return 7;

                case 53:
                  return 14;

                case 54:
                  return 42;

                case 55:
                  return 22;

                case 56:
                  return e.yytext = e.yytext.trim(), 12;

                case 57:
                  return 13;

                case 58:
                  return 26;

                case 59:
                  return 5;

                case 60:
                  return "INVALID";
              }
            },
            rules: [/^(?:.*direction\s+TB[^\n]*)/i, /^(?:.*direction\s+BT[^\n]*)/i, /^(?:.*direction\s+RL[^\n]*)/i, /^(?:.*direction\s+LR[^\n]*)/i, /^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n]+)/i, /^(?:[\s]+)/i, /^(?:((?!\n)\s)+)/i, /^(?:#[^\n]*)/i, /^(?:%[^\n]*)/i, /^(?:scale\s+)/i, /^(?:\d+)/i, /^(?:\s+width\b)/i, /^(?:state\s+)/i, /^(?:.*<<fork>>)/i, /^(?:.*<<join>>)/i, /^(?:.*<<choice>>)/i, /^(?:.*\[\[fork\]\])/i, /^(?:.*\[\[join\]\])/i, /^(?:.*\[\[choice\]\])/i, /^(?:.*direction\s+TB[^\n]*)/i, /^(?:.*direction\s+BT[^\n]*)/i, /^(?:.*direction\s+RL[^\n]*)/i, /^(?:.*direction\s+LR[^\n]*)/i, /^(?:["])/i, /^(?:\s*as\s+)/i, /^(?:[^\n\{]*)/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[^\n\s\{]+)/i, /^(?:\n)/i, /^(?:\{)/i, /^(?:\})/i, /^(?:[\n])/i, /^(?:note\s+)/i, /^(?:left of\b)/i, /^(?:right of\b)/i, /^(?:")/i, /^(?:\s*as\s*)/i, /^(?:["])/i, /^(?:[^"]*)/i, /^(?:[^\n]*)/i, /^(?:\s*[^:\n\s\-]+)/i, /^(?:\s*:[^:\n;]+)/i, /^(?:[\s\S]*?end note\b)/i, /^(?:stateDiagram\s+)/i, /^(?:stateDiagram-v2\s+)/i, /^(?:hide empty description\b)/i, /^(?:\[\*\])/i, /^(?:[^:\n\s\-\{]+)/i, /^(?:\s*:[^:\n;]+)/i, /^(?:-->)/i, /^(?:--)/i, /^(?:$)/i, /^(?:.)/i],
            conditions: {
              LINE: {
                rules: [13, 14],
                inclusive: !1
              },
              close_directive: {
                rules: [13, 14],
                inclusive: !1
              },
              arg_directive: {
                rules: [7, 8, 13, 14],
                inclusive: !1
              },
              type_directive: {
                rules: [6, 7, 13, 14],
                inclusive: !1
              },
              open_directive: {
                rules: [5, 13, 14],
                inclusive: !1
              },
              struct: {
                rules: [13, 14, 19, 26, 27, 28, 29, 38, 39, 40, 54, 55, 56, 57, 58],
                inclusive: !1
              },
              FLOATING_NOTE_ID: {
                rules: [47],
                inclusive: !1
              },
              FLOATING_NOTE: {
                rules: [44, 45, 46],
                inclusive: !1
              },
              NOTE_TEXT: {
                rules: [49, 50],
                inclusive: !1
              },
              NOTE_ID: {
                rules: [48],
                inclusive: !1
              },
              NOTE: {
                rules: [41, 42, 43],
                inclusive: !1
              },
              SCALE: {
                rules: [17, 18],
                inclusive: !1
              },
              ALIAS: {
                rules: [],
                inclusive: !1
              },
              STATE_ID: {
                rules: [32],
                inclusive: !1
              },
              STATE_STRING: {
                rules: [33, 34],
                inclusive: !1
              },
              FORK_STATE: {
                rules: [],
                inclusive: !1
              },
              STATE: {
                rules: [13, 14, 20, 21, 22, 23, 24, 25, 30, 31, 35, 36, 37],
                inclusive: !1
              },
              ID: {
                rules: [13, 14],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 1, 2, 3, 4, 9, 10, 11, 12, 14, 15, 16, 19, 37, 40, 51, 52, 53, 54, 55, 56, 57, 59, 60],
                inclusive: !0
              }
            }
          };

          function N() {
            this.yy = {};
          }

          return A.lexer = M, N.prototype = A, A.Parser = N, new N();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(3069).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      6741: function _(t, e, n) {
        t = n.nmd(t);

        var r = function () {
          var t = function t(_t12, e, n, r) {
            for (n = n || {}, r = _t12.length; r--; n[_t12[r]] = e) {
              ;
            }

            return n;
          },
              e = [1, 2],
              n = [1, 5],
              r = [6, 9, 11, 17, 18, 19, 21],
              i = [1, 15],
              a = [1, 16],
              o = [1, 17],
              s = [1, 21],
              c = [4, 6, 9, 11, 17, 18, 19, 21],
              u = {
            trace: function trace() {},
            yy: {},
            symbols_: {
              error: 2,
              start: 3,
              journey: 4,
              document: 5,
              EOF: 6,
              directive: 7,
              line: 8,
              SPACE: 9,
              statement: 10,
              NEWLINE: 11,
              openDirective: 12,
              typeDirective: 13,
              closeDirective: 14,
              ":": 15,
              argDirective: 16,
              title: 17,
              section: 18,
              taskName: 19,
              taskData: 20,
              open_directive: 21,
              type_directive: 22,
              arg_directive: 23,
              close_directive: 24,
              $accept: 0,
              $end: 1
            },
            terminals_: {
              2: "error",
              4: "journey",
              6: "EOF",
              9: "SPACE",
              11: "NEWLINE",
              15: ":",
              17: "title",
              18: "section",
              19: "taskName",
              20: "taskData",
              21: "open_directive",
              22: "type_directive",
              23: "arg_directive",
              24: "close_directive"
            },
            productions_: [0, [3, 3], [3, 2], [5, 0], [5, 2], [8, 2], [8, 1], [8, 1], [8, 1], [7, 4], [7, 6], [10, 1], [10, 1], [10, 2], [10, 1], [12, 1], [13, 1], [16, 1], [14, 1]],
            performAction: function performAction(t, e, n, r, i, a, o) {
              var s = a.length - 1;

              switch (i) {
                case 1:
                  return a[s - 1];

                case 3:
                  this.$ = [];
                  break;

                case 4:
                  a[s - 1].push(a[s]), this.$ = a[s - 1];
                  break;

                case 5:
                case 6:
                  this.$ = a[s];
                  break;

                case 7:
                case 8:
                  this.$ = [];
                  break;

                case 11:
                  r.setTitle(a[s].substr(6)), this.$ = a[s].substr(6);
                  break;

                case 12:
                  r.addSection(a[s].substr(8)), this.$ = a[s].substr(8);
                  break;

                case 13:
                  r.addTask(a[s - 1], a[s]), this.$ = "task";
                  break;

                case 15:
                  r.parseDirective("%%{", "open_directive");
                  break;

                case 16:
                  r.parseDirective(a[s], "type_directive");
                  break;

                case 17:
                  a[s] = a[s].trim().replace(/'/g, '"'), r.parseDirective(a[s], "arg_directive");
                  break;

                case 18:
                  r.parseDirective("}%%", "close_directive", "journey");
              }
            },
            table: [{
              3: 1,
              4: e,
              7: 3,
              12: 4,
              21: n
            }, {
              1: [3]
            }, t(r, [2, 3], {
              5: 6
            }), {
              3: 7,
              4: e,
              7: 3,
              12: 4,
              21: n
            }, {
              13: 8,
              22: [1, 9]
            }, {
              22: [2, 15]
            }, {
              6: [1, 10],
              7: 18,
              8: 11,
              9: [1, 12],
              10: 13,
              11: [1, 14],
              12: 4,
              17: i,
              18: a,
              19: o,
              21: n
            }, {
              1: [2, 2]
            }, {
              14: 19,
              15: [1, 20],
              24: s
            }, t([15, 24], [2, 16]), t(r, [2, 8], {
              1: [2, 1]
            }), t(r, [2, 4]), {
              7: 18,
              10: 22,
              12: 4,
              17: i,
              18: a,
              19: o,
              21: n
            }, t(r, [2, 6]), t(r, [2, 7]), t(r, [2, 11]), t(r, [2, 12]), {
              20: [1, 23]
            }, t(r, [2, 14]), {
              11: [1, 24]
            }, {
              16: 25,
              23: [1, 26]
            }, {
              11: [2, 18]
            }, t(r, [2, 5]), t(r, [2, 13]), t(c, [2, 9]), {
              14: 27,
              24: s
            }, {
              24: [2, 17]
            }, {
              11: [1, 28]
            }, t(c, [2, 10])],
            defaultActions: {
              5: [2, 15],
              7: [2, 2],
              21: [2, 18],
              26: [2, 17]
            },
            parseError: function parseError(t, e) {
              if (!e.recoverable) {
                var n = new Error(t);
                throw n.hash = e, n;
              }

              this.trace(t);
            },
            parse: function parse(t) {
              var e = this,
                  n = [0],
                  r = [],
                  i = [null],
                  a = [],
                  o = this.table,
                  s = "",
                  c = 0,
                  u = 0,
                  l = 0,
                  h = 2,
                  f = 1,
                  d = a.slice.call(arguments, 1),
                  p = Object.create(this.lexer),
                  y = {
                yy: {}
              };

              for (var g in this.yy) {
                Object.prototype.hasOwnProperty.call(this.yy, g) && (y.yy[g] = this.yy[g]);
              }

              p.setInput(t, y.yy), y.yy.lexer = p, y.yy.parser = this, void 0 === p.yylloc && (p.yylloc = {});
              var m = p.yylloc;
              a.push(m);
              var v = p.options && p.options.ranges;

              function b() {
                var t;
                return "number" != typeof (t = r.pop() || p.lex() || f) && (t instanceof Array && (t = (r = t).pop()), t = e.symbols_[t] || t), t;
              }

              "function" == typeof y.yy.parseError ? this.parseError = y.yy.parseError : this.parseError = Object.getPrototypeOf(this).parseError;

              for (var _, x, w, k, T, E, C, S, A, M = {};;) {
                if (w = n[n.length - 1], this.defaultActions[w] ? k = this.defaultActions[w] : (null == _ && (_ = b()), k = o[w] && o[w][_]), void 0 === k || !k.length || !k[0]) {
                  var N = "";

                  for (E in A = [], o[w]) {
                    this.terminals_[E] && E > h && A.push("'" + this.terminals_[E] + "'");
                  }

                  N = p.showPosition ? "Parse error on line " + (c + 1) + ":\n" + p.showPosition() + "\nExpecting " + A.join(", ") + ", got '" + (this.terminals_[_] || _) + "'" : "Parse error on line " + (c + 1) + ": Unexpected " + (_ == f ? "end of input" : "'" + (this.terminals_[_] || _) + "'"), this.parseError(N, {
                    text: p.match,
                    token: this.terminals_[_] || _,
                    line: p.yylineno,
                    loc: m,
                    expected: A
                  });
                }

                if (k[0] instanceof Array && k.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + _);

                switch (k[0]) {
                  case 1:
                    n.push(_), i.push(p.yytext), a.push(p.yylloc), n.push(k[1]), _ = null, x ? (_ = x, x = null) : (u = p.yyleng, s = p.yytext, c = p.yylineno, m = p.yylloc, l > 0 && l--);
                    break;

                  case 2:
                    if (C = this.productions_[k[1]][1], M.$ = i[i.length - C], M._$ = {
                      first_line: a[a.length - (C || 1)].first_line,
                      last_line: a[a.length - 1].last_line,
                      first_column: a[a.length - (C || 1)].first_column,
                      last_column: a[a.length - 1].last_column
                    }, v && (M._$.range = [a[a.length - (C || 1)].range[0], a[a.length - 1].range[1]]), void 0 !== (T = this.performAction.apply(M, [s, u, c, y.yy, k[1], i, a].concat(d)))) return T;
                    C && (n = n.slice(0, -1 * C * 2), i = i.slice(0, -1 * C), a = a.slice(0, -1 * C)), n.push(this.productions_[k[1]][0]), i.push(M.$), a.push(M._$), S = o[n[n.length - 2]][n[n.length - 1]], n.push(S);
                    break;

                  case 3:
                    return !0;
                }
              }

              return !0;
            }
          },
              l = {
            EOF: 1,
            parseError: function parseError(t, e) {
              if (!this.yy.parser) throw new Error(t);
              this.yy.parser.parseError(t, e);
            },
            setInput: function setInput(t, e) {
              return this.yy = e || this.yy || {}, this._input = t, this._more = this._backtrack = this.done = !1, this.yylineno = this.yyleng = 0, this.yytext = this.matched = this.match = "", this.conditionStack = ["INITIAL"], this.yylloc = {
                first_line: 1,
                first_column: 0,
                last_line: 1,
                last_column: 0
              }, this.options.ranges && (this.yylloc.range = [0, 0]), this.offset = 0, this;
            },
            input: function input() {
              var t = this._input[0];
              return this.yytext += t, this.yyleng++, this.offset++, this.match += t, this.matched += t, t.match(/(?:\r\n?|\n).*/g) ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, this._input = this._input.slice(1), t;
            },
            unput: function unput(t) {
              var e = t.length,
                  n = t.split(/(?:\r\n?|\n)/g);
              this._input = t + this._input, this.yytext = this.yytext.substr(0, this.yytext.length - e), this.offset -= e;
              var r = this.match.split(/(?:\r\n?|\n)/g);
              this.match = this.match.substr(0, this.match.length - 1), this.matched = this.matched.substr(0, this.matched.length - 1), n.length - 1 && (this.yylineno -= n.length - 1);
              var i = this.yylloc.range;
              return this.yylloc = {
                first_line: this.yylloc.first_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.first_column,
                last_column: n ? (n.length === r.length ? this.yylloc.first_column : 0) + r[r.length - n.length].length - n[0].length : this.yylloc.first_column - e
              }, this.options.ranges && (this.yylloc.range = [i[0], i[0] + this.yyleng - e]), this.yyleng = this.yytext.length, this;
            },
            more: function more() {
              return this._more = !0, this;
            },
            reject: function reject() {
              return this.options.backtrack_lexer ? (this._backtrack = !0, this) : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            less: function less(t) {
              this.unput(this.match.slice(t));
            },
            pastInput: function pastInput() {
              var t = this.matched.substr(0, this.matched.length - this.match.length);
              return (t.length > 20 ? "..." : "") + t.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
              var t = this.match;
              return t.length < 20 && (t += this._input.substr(0, 20 - t.length)), (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
              var t = this.pastInput(),
                  e = new Array(t.length + 1).join("-");
              return t + this.upcomingInput() + "\n" + e + "^";
            },
            test_match: function test_match(t, e) {
              var n, r, i;
              if (this.options.backtrack_lexer && (i = {
                yylineno: this.yylineno,
                yylloc: {
                  first_line: this.yylloc.first_line,
                  last_line: this.last_line,
                  first_column: this.yylloc.first_column,
                  last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
              }, this.options.ranges && (i.yylloc.range = this.yylloc.range.slice(0))), (r = t[0].match(/(?:\r\n?|\n).*/g)) && (this.yylineno += r.length), this.yylloc = {
                first_line: this.yylloc.last_line,
                last_line: this.yylineno + 1,
                first_column: this.yylloc.last_column,
                last_column: r ? r[r.length - 1].length - r[r.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + t[0].length
              }, this.yytext += t[0], this.match += t[0], this.matches = t, this.yyleng = this.yytext.length, this.options.ranges && (this.yylloc.range = [this.offset, this.offset += this.yyleng]), this._more = !1, this._backtrack = !1, this._input = this._input.slice(t[0].length), this.matched += t[0], n = this.performAction.call(this, this.yy, this, e, this.conditionStack[this.conditionStack.length - 1]), this.done && this._input && (this.done = !1), n) return n;

              if (this._backtrack) {
                for (var a in i) {
                  this[a] = i[a];
                }

                return !1;
              }

              return !1;
            },
            next: function next() {
              if (this.done) return this.EOF;
              var t, e, n, r;
              this._input || (this.done = !0), this._more || (this.yytext = "", this.match = "");

              for (var i = this._currentRules(), a = 0; a < i.length; a++) {
                if ((n = this._input.match(this.rules[i[a]])) && (!e || n[0].length > e[0].length)) {
                  if (e = n, r = a, this.options.backtrack_lexer) {
                    if (!1 !== (t = this.test_match(n, i[a]))) return t;

                    if (this._backtrack) {
                      e = !1;
                      continue;
                    }

                    return !1;
                  }

                  if (!this.options.flex) break;
                }
              }

              return e ? !1 !== (t = this.test_match(e, i[r])) && t : "" === this._input ? this.EOF : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
              });
            },
            lex: function lex() {
              return this.next() || this.lex();
            },
            begin: function begin(t) {
              this.conditionStack.push(t);
            },
            popState: function popState() {
              return this.conditionStack.length - 1 > 0 ? this.conditionStack.pop() : this.conditionStack[0];
            },
            _currentRules: function _currentRules() {
              return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
            },
            topState: function topState(t) {
              return (t = this.conditionStack.length - 1 - Math.abs(t || 0)) >= 0 ? this.conditionStack[t] : "INITIAL";
            },
            pushState: function pushState(t) {
              this.begin(t);
            },
            stateStackSize: function stateStackSize() {
              return this.conditionStack.length;
            },
            options: {
              "case-insensitive": !0
            },
            performAction: function performAction(t, e, n, r) {
              switch (n) {
                case 0:
                  return this.begin("open_directive"), 21;

                case 1:
                  return this.begin("type_directive"), 22;

                case 2:
                  return this.popState(), this.begin("arg_directive"), 15;

                case 3:
                  return this.popState(), this.popState(), 24;

                case 4:
                  return 23;

                case 5:
                case 6:
                  break;

                case 7:
                  return 11;

                case 8:
                case 9:
                  break;

                case 10:
                  return 4;

                case 11:
                  return 17;

                case 12:
                  return 18;

                case 13:
                  return 19;

                case 14:
                  return 20;

                case 15:
                  return 15;

                case 16:
                  return 6;

                case 17:
                  return "INVALID";
              }
            },
            rules: [/^(?:%%\{)/i, /^(?:((?:(?!\}%%)[^:.])*))/i, /^(?::)/i, /^(?:\}%%)/i, /^(?:((?:(?!\}%%).|\n)*))/i, /^(?:%(?!\{)[^\n]*)/i, /^(?:[^\}]%%[^\n]*)/i, /^(?:[\n]+)/i, /^(?:\s+)/i, /^(?:#[^\n]*)/i, /^(?:journey\b)/i, /^(?:title\s[^#\n;]+)/i, /^(?:section\s[^#:\n;]+)/i, /^(?:[^#:\n;]+)/i, /^(?::[^#\n;]+)/i, /^(?::)/i, /^(?:$)/i, /^(?:.)/i],
            conditions: {
              open_directive: {
                rules: [1],
                inclusive: !1
              },
              type_directive: {
                rules: [2, 3],
                inclusive: !1
              },
              arg_directive: {
                rules: [3, 4],
                inclusive: !1
              },
              INITIAL: {
                rules: [0, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
                inclusive: !0
              }
            }
          };

          function h() {
            this.yy = {};
          }

          return u.lexer = l, h.prototype = u, u.Parser = h, new h();
        }();

        e.parser = r, e.Parser = r.Parser, e.parse = function () {
          return r.parse.apply(r, arguments);
        }, e.main = function (t) {
          t[1] || (console.log("Usage: " + t[0] + " FILE"), process.exit(1));
          var r = n(9143).readFileSync(n(6470).normalize(t[1]), "utf8");
          return e.parser.parse(r);
        }, n.c[n.s] === t && e.main(process.argv.slice(1));
      },
      9609: function _(t) {
        var e = /^(%20|\s)*(javascript|data)/im,
            n = /[^\x20-\x7E]/gim,
            r = /^([^:]+):/gm,
            i = [".", "/"];
        t.exports = {
          sanitizeUrl: function sanitizeUrl(t) {
            if (!t) return "about:blank";
            var a,
                o,
                s = t.replace(n, "").trim();
            return function (t) {
              return i.indexOf(t[0]) > -1;
            }(s) ? s : (o = s.match(r)) ? (a = o[0], e.test(a) ? "about:blank" : s) : "about:blank";
          }
        };
      },
      3841: function _(t) {
        t.exports = function (t, e) {
          return t.intersect(e);
        };
      },
      7458: function _(t, e, n) {
        n.d(e, {
          Z: function Z() {
            return nE;
          }
        });

        var r = n(1941),
            i = n.n(r),
            a = {
          debug: 1,
          info: 2,
          warn: 3,
          error: 4,
          fatal: 5
        },
            o = {
          debug: function debug() {},
          info: function info() {},
          warn: function warn() {},
          error: function error() {},
          fatal: function fatal() {}
        },
            s = function s() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "fatal";
          isNaN(t) && (t = t.toLowerCase(), void 0 !== a[t] && (t = a[t])), o.trace = function () {}, o.debug = function () {}, o.info = function () {}, o.warn = function () {}, o.error = function () {}, o.fatal = function () {}, t <= a.fatal && (o.fatal = console.error ? console.error.bind(console, c("FATAL"), "color: orange") : console.log.bind(console, "[35m", c("FATAL"))), t <= a.error && (o.error = console.error ? console.error.bind(console, c("ERROR"), "color: orange") : console.log.bind(console, "[31m", c("ERROR"))), t <= a.warn && (o.warn = console.warn ? console.warn.bind(console, c("WARN"), "color: orange") : console.log.bind(console, "[33m", c("WARN"))), t <= a.info && (o.info = console.info ? console.info.bind(console, c("INFO"), "color: lightblue") : console.log.bind(console, "[34m", c("INFO"))), t <= a.debug && (o.debug = console.debug ? console.debug.bind(console, c("DEBUG"), "color: lightgreen") : console.log.bind(console, "[32m", c("DEBUG")));
        },
            c = function c(t) {
          var e = i()().format("ss.SSS");
          return "%c".concat(e, " : ").concat(t, " : ");
        };

        function u(t, e) {
          var n;

          if (void 0 === e) {
            var _iterator = _createForOfIteratorHelper(t),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _e2 = _step.value;
                null != _e2 && (n < _e2 || void 0 === n && _e2 >= _e2) && (n = _e2);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            var _r2 = -1;

            var _iterator2 = _createForOfIteratorHelper(t),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _i2 = _step2.value;
                null != (_i2 = e(_i2, ++_r2, t)) && (n < _i2 || void 0 === n && _i2 >= _i2) && (n = _i2);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }

          return n;
        }

        function l(t, e) {
          var n;

          if (void 0 === e) {
            var _iterator3 = _createForOfIteratorHelper(t),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _e3 = _step3.value;
                null != _e3 && (n > _e3 || void 0 === n && _e3 >= _e3) && (n = _e3);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else {
            var _r3 = -1;

            var _iterator4 = _createForOfIteratorHelper(t),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _i3 = _step4.value;
                null != (_i3 = e(_i3, ++_r3, t)) && (n > _i3 || void 0 === n && _i3 >= _i3) && (n = _i3);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }

          return n;
        }

        function h(t) {
          return t;
        }

        var f = 1e-6;

        function d(t) {
          return "translate(" + t + ",0)";
        }

        function p(t) {
          return "translate(0," + t + ")";
        }

        function y(t) {
          return function (e) {
            return +t(e);
          };
        }

        function g(t, e) {
          return e = Math.max(0, t.bandwidth() - 2 * e) / 2, t.round() && (e = Math.round(e)), function (n) {
            return +t(n) + e;
          };
        }

        function m() {
          return !this.__axis;
        }

        function v(t, e) {
          var n = [],
              r = null,
              i = null,
              a = 6,
              o = 6,
              s = 3,
              c = "undefined" != typeof window && window.devicePixelRatio > 1 ? 0 : .5,
              u = 1 === t || 4 === t ? -1 : 1,
              l = 4 === t || 2 === t ? "x" : "y",
              v = 1 === t || 3 === t ? d : p;

          function b(d) {
            var p = null == r ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r,
                b = null == i ? e.tickFormat ? e.tickFormat.apply(e, n) : h : i,
                _ = Math.max(a, 0) + s,
                x = e.range(),
                w = +x[0] + c,
                k = +x[x.length - 1] + c,
                T = (e.bandwidth ? g : y)(e.copy(), c),
                E = d.selection ? d.selection() : d,
                C = E.selectAll(".domain").data([null]),
                S = E.selectAll(".tick").data(p, e).order(),
                A = S.exit(),
                M = S.enter().append("g").attr("class", "tick"),
                N = S.select("line"),
                D = S.select("text");

            C = C.merge(C.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), S = S.merge(M), N = N.merge(M.append("line").attr("stroke", "currentColor").attr(l + "2", u * a)), D = D.merge(M.append("text").attr("fill", "currentColor").attr(l, u * _).attr("dy", 1 === t ? "0em" : 3 === t ? "0.71em" : "0.32em")), d !== E && (C = C.transition(d), S = S.transition(d), N = N.transition(d), D = D.transition(d), A = A.transition(d).attr("opacity", f).attr("transform", function (t) {
              return isFinite(t = T(t)) ? v(t + c) : this.getAttribute("transform");
            }), M.attr("opacity", f).attr("transform", function (t) {
              var e = this.parentNode.__axis;
              return v((e && isFinite(e = e(t)) ? e : T(t)) + c);
            })), A.remove(), C.attr("d", 4 === t || 2 === t ? o ? "M" + u * o + "," + w + "H" + c + "V" + k + "H" + u * o : "M" + c + "," + w + "V" + k : o ? "M" + w + "," + u * o + "V" + c + "H" + k + "V" + u * o : "M" + w + "," + c + "H" + k), S.attr("opacity", 1).attr("transform", function (t) {
              return v(T(t) + c);
            }), N.attr(l + "2", u * a), D.attr(l, u * _).text(b), E.filter(m).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", 2 === t ? "start" : 4 === t ? "end" : "middle"), E.each(function () {
              this.__axis = T;
            });
          }

          return b.scale = function (t) {
            return arguments.length ? (e = t, b) : e;
          }, b.ticks = function () {
            return n = Array.from(arguments), b;
          }, b.tickArguments = function (t) {
            return arguments.length ? (n = null == t ? [] : Array.from(t), b) : n.slice();
          }, b.tickValues = function (t) {
            return arguments.length ? (r = null == t ? null : Array.from(t), b) : r && r.slice();
          }, b.tickFormat = function (t) {
            return arguments.length ? (i = t, b) : i;
          }, b.tickSize = function (t) {
            return arguments.length ? (a = o = +t, b) : a;
          }, b.tickSizeInner = function (t) {
            return arguments.length ? (a = +t, b) : a;
          }, b.tickSizeOuter = function (t) {
            return arguments.length ? (o = +t, b) : o;
          }, b.tickPadding = function (t) {
            return arguments.length ? (s = +t, b) : s;
          }, b.offset = function (t) {
            return arguments.length ? (c = +t, b) : c;
          }, b;
        }

        function b() {}

        function _(t) {
          return null == t ? b : function () {
            return this.querySelector(t);
          };
        }

        function x(t) {
          return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
        }

        function w() {
          return [];
        }

        function k(t) {
          return null == t ? w : function () {
            return this.querySelectorAll(t);
          };
        }

        function T(t) {
          return function () {
            return this.matches(t);
          };
        }

        function E(t) {
          return function (e) {
            return e.matches(t);
          };
        }

        var C = Array.prototype.find;

        function S() {
          return this.firstElementChild;
        }

        var A = Array.prototype.filter;

        function M() {
          return Array.from(this.children);
        }

        function N(t) {
          return new Array(t.length);
        }

        function D(t, e) {
          this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
        }

        function O(t) {
          return function () {
            return t;
          };
        }

        function B(t, e, n, r, i, a) {
          for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
            (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new D(t, a[s]);
          }

          for (; s < c; ++s) {
            (o = e[s]) && (i[s] = o);
          }
        }

        function L(t, e, n, r, i, a, o) {
          var s,
              c,
              u,
              l = new Map(),
              h = e.length,
              f = a.length,
              d = new Array(h);

          for (s = 0; s < h; ++s) {
            (c = e[s]) && (d[s] = u = o.call(c, c.__data__, s, e) + "", l.has(u) ? i[s] = c : l.set(u, c));
          }

          for (s = 0; s < f; ++s) {
            u = o.call(t, a[s], s, a) + "", (c = l.get(u)) ? (r[s] = c, c.__data__ = a[s], l.delete(u)) : n[s] = new D(t, a[s]);
          }

          for (s = 0; s < h; ++s) {
            (c = e[s]) && l.get(d[s]) === c && (i[s] = c);
          }
        }

        function I(t) {
          return t.__data__;
        }

        function R(t) {
          return "object" == typeof t && "length" in t ? t : Array.from(t);
        }

        function P(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        D.prototype = {
          constructor: D,
          appendChild: function appendChild(t) {
            return this._parent.insertBefore(t, this._next);
          },
          insertBefore: function insertBefore(t, e) {
            return this._parent.insertBefore(t, e);
          },
          querySelector: function querySelector(t) {
            return this._parent.querySelector(t);
          },
          querySelectorAll: function querySelectorAll(t) {
            return this._parent.querySelectorAll(t);
          }
        };
        var F = "http://www.w3.org/1999/xhtml";
        var j = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: F,
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/"
        };

        function Y(t) {
          var e = t += "",
              n = e.indexOf(":");
          return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), j.hasOwnProperty(e) ? {
            space: j[e],
            local: t
          } : t;
        }

        function U(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function z(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function q(t, e) {
          return function () {
            this.setAttribute(t, e);
          };
        }

        function $(t, e) {
          return function () {
            this.setAttributeNS(t.space, t.local, e);
          };
        }

        function H(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
          };
        }

        function W(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
          };
        }

        function V(t) {
          return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
        }

        function G(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function X(t, e, n) {
          return function () {
            this.style.setProperty(t, e, n);
          };
        }

        function Z(t, e, n) {
          return function () {
            var r = e.apply(this, arguments);
            null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
          };
        }

        function K(t, e) {
          return t.style.getPropertyValue(e) || V(t).getComputedStyle(t, null).getPropertyValue(e);
        }

        function Q(t) {
          return function () {
            delete this[t];
          };
        }

        function J(t, e) {
          return function () {
            this[t] = e;
          };
        }

        function tt(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? delete this[t] : this[t] = n;
          };
        }

        function et(t) {
          return t.trim().split(/^|\s+/);
        }

        function nt(t) {
          return t.classList || new rt(t);
        }

        function rt(t) {
          this._node = t, this._names = et(t.getAttribute("class") || "");
        }

        function it(t, e) {
          for (var n = nt(t), r = -1, i = e.length; ++r < i;) {
            n.add(e[r]);
          }
        }

        function at(t, e) {
          for (var n = nt(t), r = -1, i = e.length; ++r < i;) {
            n.remove(e[r]);
          }
        }

        function ot(t) {
          return function () {
            it(this, t);
          };
        }

        function st(t) {
          return function () {
            at(this, t);
          };
        }

        function ct(t, e) {
          return function () {
            (e.apply(this, arguments) ? it : at)(this, t);
          };
        }

        function ut() {
          this.textContent = "";
        }

        function lt(t) {
          return function () {
            this.textContent = t;
          };
        }

        function ht(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.textContent = null == e ? "" : e;
          };
        }

        function ft() {
          this.innerHTML = "";
        }

        function dt(t) {
          return function () {
            this.innerHTML = t;
          };
        }

        function pt(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.innerHTML = null == e ? "" : e;
          };
        }

        function yt() {
          this.nextSibling && this.parentNode.appendChild(this);
        }

        function gt() {
          this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
        }

        function mt(t) {
          return function () {
            var e = this.ownerDocument,
                n = this.namespaceURI;
            return n === F && e.documentElement.namespaceURI === F ? e.createElement(t) : e.createElementNS(n, t);
          };
        }

        function vt(t) {
          return function () {
            return this.ownerDocument.createElementNS(t.space, t.local);
          };
        }

        function bt(t) {
          var e = Y(t);
          return (e.local ? vt : mt)(e);
        }

        function _t() {
          return null;
        }

        function xt() {
          var t = this.parentNode;
          t && t.removeChild(this);
        }

        function wt() {
          var t = this.cloneNode(!1),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function kt() {
          var t = this.cloneNode(!0),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function Tt(t) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var e = "",
                n = t.indexOf(".");
            return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
              type: t,
              name: e
            };
          });
        }

        function Et(t) {
          return function () {
            var e = this.__on;

            if (e) {
              for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
                n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
              }

              ++i ? e.length = i : delete this.__on;
            }
          };
        }

        function Ct(t, e, n) {
          return function () {
            var r,
                i = this.__on,
                a = function (t) {
              return function (e) {
                t.call(this, e, this.__data__);
              };
            }(e);

            if (i) for (var o = 0, s = i.length; o < s; ++o) {
              if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), void (r.value = e);
            }
            this.addEventListener(t.type, a, n), r = {
              type: t.type,
              name: t.name,
              value: e,
              listener: a,
              options: n
            }, i ? i.push(r) : this.__on = [r];
          };
        }

        function St(t, e, n) {
          var r = V(t),
              i = r.CustomEvent;
          "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
        }

        function At(t, e) {
          return function () {
            return St(this, t, e);
          };
        }

        function Mt(t, e) {
          return function () {
            return St(this, t, e.apply(this, arguments));
          };
        }

        rt.prototype = {
          add: function add(t) {
            this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
          },
          remove: function remove(t) {
            var e = this._names.indexOf(t);

            e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
          },
          contains: function contains(t) {
            return this._names.indexOf(t) >= 0;
          }
        };
        var Nt = [null];

        function Dt(t, e) {
          this._groups = t, this._parents = e;
        }

        function Ot() {
          return new Dt([[document.documentElement]], Nt);
        }

        Dt.prototype = Ot.prototype = _defineProperty({
          constructor: Dt,
          select: function select(t) {
            "function" != typeof t && (t = _(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
                (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
              }
            }

            return new Dt(r, this._parents);
          },
          selectAll: function selectAll(t) {
            t = "function" == typeof t ? function (t) {
              return function () {
                return x(t.apply(this, arguments));
              };
            }(t) : k(t);

            for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
              for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
                (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
              }
            }

            return new Dt(r, i);
          },
          selectChild: function selectChild(t) {
            return this.select(null == t ? S : function (t) {
              return function () {
                return C.call(this.children, t);
              };
            }("function" == typeof t ? t : E(t)));
          },
          selectChildren: function selectChildren(t) {
            return this.selectAll(null == t ? M : function (t) {
              return function () {
                return A.call(this.children, t);
              };
            }("function" == typeof t ? t : E(t)));
          },
          filter: function filter(t) {
            "function" != typeof t && (t = T(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new Dt(r, this._parents);
          },
          data: function data(t, e) {
            if (!arguments.length) return Array.from(this, I);
            var n = e ? L : B,
                r = this._parents,
                i = this._groups;
            "function" != typeof t && (t = O(t));

            for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
              var l = r[u],
                  h = i[u],
                  f = h.length,
                  d = R(t.call(l, l && l.__data__, u, r)),
                  p = d.length,
                  y = s[u] = new Array(p),
                  g = o[u] = new Array(p),
                  m = c[u] = new Array(f);
              n(l, h, y, g, m, d, e);

              for (var v, b, _ = 0, x = 0; _ < p; ++_) {
                if (v = y[_]) {
                  for (_ >= x && (x = _ + 1); !(b = g[x]) && ++x < p;) {
                    ;
                  }

                  v._next = b || null;
                }
              }
            }

            return (o = new Dt(o, r))._enter = s, o._exit = c, o;
          },
          enter: function enter() {
            return new Dt(this._enter || this._groups.map(N), this._parents);
          },
          exit: function exit() {
            return new Dt(this._exit || this._groups.map(N), this._parents);
          },
          join: function join(t, e, n) {
            var r = this.enter(),
                i = this,
                a = this.exit();
            return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
          },
          merge: function merge(t) {
            for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c) {
              for (var u, l = n[c], h = r[c], f = l.length, d = s[c] = new Array(f), p = 0; p < f; ++p) {
                (u = l[p] || h[p]) && (d[p] = u);
              }
            }

            for (; c < i; ++c) {
              s[c] = n[c];
            }

            return new Dt(s, this._parents);
          },
          selection: function selection() {
            return this;
          },
          order: function order() {
            for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
              for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
                (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
              }
            }

            return this;
          },
          sort: function sort(t) {
            function e(e, n) {
              return e && n ? t(e.__data__, n.__data__) : !e - !n;
            }

            t || (t = P);

            for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
              for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
                (o = s[l]) && (u[l] = o);
              }

              u.sort(e);
            }

            return new Dt(i, this._parents).order();
          },
          call: function call() {
            var t = arguments[0];
            return arguments[0] = this, t.apply(null, arguments), this;
          },
          nodes: function nodes() {
            return Array.from(this);
          },
          node: function node() {
            for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
              for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
                var o = r[i];
                if (o) return o;
              }
            }

            return null;
          },
          size: function size() {
            var t = 0;

            var _iterator5 = _createForOfIteratorHelper(this),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _e4 = _step5.value;
                ++t;
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }

            return t;
          },
          empty: function empty() {
            return !this.node();
          },
          each: function each(t) {
            for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
              for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
                (i = a[o]) && t.call(i, i.__data__, o, a);
              }
            }

            return this;
          },
          attr: function attr(t, e) {
            var n = Y(t);

            if (arguments.length < 2) {
              var r = this.node();
              return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
            }

            return this.each((null == e ? n.local ? z : U : "function" == typeof e ? n.local ? W : H : n.local ? $ : q)(n, e));
          },
          style: function style(t, e, n) {
            return arguments.length > 1 ? this.each((null == e ? G : "function" == typeof e ? Z : X)(t, e, null == n ? "" : n)) : K(this.node(), t);
          },
          property: function property(t, e) {
            return arguments.length > 1 ? this.each((null == e ? Q : "function" == typeof e ? tt : J)(t, e)) : this.node()[t];
          },
          classed: function classed(t, e) {
            var n = et(t + "");

            if (arguments.length < 2) {
              for (var r = nt(this.node()), i = -1, a = n.length; ++i < a;) {
                if (!r.contains(n[i])) return !1;
              }

              return !0;
            }

            return this.each(("function" == typeof e ? ct : e ? ot : st)(n, e));
          },
          text: function text(t) {
            return arguments.length ? this.each(null == t ? ut : ("function" == typeof t ? ht : lt)(t)) : this.node().textContent;
          },
          html: function html(t) {
            return arguments.length ? this.each(null == t ? ft : ("function" == typeof t ? pt : dt)(t)) : this.node().innerHTML;
          },
          raise: function raise() {
            return this.each(yt);
          },
          lower: function lower() {
            return this.each(gt);
          },
          append: function append(t) {
            var e = "function" == typeof t ? t : bt(t);
            return this.select(function () {
              return this.appendChild(e.apply(this, arguments));
            });
          },
          insert: function insert(t, e) {
            var n = "function" == typeof t ? t : bt(t),
                r = null == e ? _t : "function" == typeof e ? e : _(e);
            return this.select(function () {
              return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
            });
          },
          remove: function remove() {
            return this.each(xt);
          },
          clone: function clone(t) {
            return this.select(t ? kt : wt);
          },
          datum: function datum(t) {
            return arguments.length ? this.property("__data__", t) : this.node().__data__;
          },
          on: function on(t, e, n) {
            var r,
                i,
                a = Tt(t + ""),
                o = a.length;

            if (!(arguments.length < 2)) {
              for (s = e ? Ct : Et, r = 0; r < o; ++r) {
                this.each(s(a[r], e, n));
              }

              return this;
            }

            var s = this.node().__on;

            if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
              for (r = 0, c = s[u]; r < o; ++r) {
                if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
              }
            }
          },
          dispatch: function dispatch(t, e) {
            return this.each(("function" == typeof e ? Mt : At)(t, e));
          }
        }, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var t, e, n, r, i, a, o;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  t = this._groups, e = 0, n = t.length;

                case 1:
                  if (!(e < n)) {
                    _context.next = 14;
                    break;
                  }

                  i = t[e], a = 0, o = i.length;

                case 3:
                  if (!(a < o)) {
                    _context.next = 11;
                    break;
                  }

                  _context.t0 = r = i[a];

                  if (!_context.t0) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 8;
                  return r;

                case 8:
                  ++a;
                  _context.next = 3;
                  break;

                case 11:
                  ++e;
                  _context.next = 1;
                  break;

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        var Bt = Ot;
        var Lt = {
          value: function value() {}
        };

        function It() {
          for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
            if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            r[t] = [];
          }

          return new Rt(r);
        }

        function Rt(t) {
          this._ = t;
        }

        function Pt(t, e) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var n = "",
                r = t.indexOf(".");
            if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
              type: t,
              name: n
            };
          });
        }

        function Ft(t, e) {
          for (var n, r = 0, i = t.length; r < i; ++r) {
            if ((n = t[r]).name === e) return n.value;
          }
        }

        function jt(t, e, n) {
          for (var r = 0, i = t.length; r < i; ++r) {
            if (t[r].name === e) {
              t[r] = Lt, t = t.slice(0, r).concat(t.slice(r + 1));
              break;
            }
          }

          return null != n && t.push({
            name: e,
            value: n
          }), t;
        }

        Rt.prototype = It.prototype = {
          constructor: Rt,
          on: function on(t, e) {
            var n,
                r = this._,
                i = Pt(t + "", r),
                a = -1,
                o = i.length;

            if (!(arguments.length < 2)) {
              if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

              for (; ++a < o;) {
                if (n = (t = i[a]).type) r[n] = jt(r[n], t.name, e);else if (null == e) for (n in r) {
                  r[n] = jt(r[n], t.name, null);
                }
              }

              return this;
            }

            for (; ++a < o;) {
              if ((n = (t = i[a]).type) && (n = Ft(r[n], t.name))) return n;
            }
          },
          copy: function copy() {
            var t = {},
                e = this._;

            for (var n in e) {
              t[n] = e[n].slice();
            }

            return new Rt(t);
          },
          call: function call(t, e) {
            if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
              i[a] = arguments[a + 2];
            }
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
              r[a].value.apply(e, i);
            }
          },
          apply: function apply(t, e, n) {
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
              r[i].value.apply(e, n);
            }
          }
        };
        var Yt = It;
        var Ut,
            zt,
            qt = 0,
            $t = 0,
            Ht = 0,
            Wt = 0,
            Vt = 0,
            Gt = 0,
            Xt = "object" == typeof performance && performance.now ? performance : Date,
            Zt = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
          setTimeout(t, 17);
        };

        function Kt() {
          return Vt || (Zt(Qt), Vt = Xt.now() + Gt);
        }

        function Qt() {
          Vt = 0;
        }

        function Jt() {
          this._call = this._time = this._next = null;
        }

        function te(t, e, n) {
          var r = new Jt();
          return r.restart(t, e, n), r;
        }

        function ee() {
          Vt = (Wt = Xt.now()) + Gt, qt = $t = 0;

          try {
            !function () {
              Kt(), ++qt;

              for (var t, e = Ut; e;) {
                (t = Vt - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
              }

              --qt;
            }();
          } finally {
            qt = 0, function () {
              for (var t, e, n = Ut, r = 1 / 0; n;) {
                n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : Ut = e);
              }

              zt = t, re(r);
            }(), Vt = 0;
          }
        }

        function ne() {
          var t = Xt.now(),
              e = t - Wt;
          e > 1e3 && (Gt -= e, Wt = t);
        }

        function re(t) {
          qt || ($t && ($t = clearTimeout($t)), t - Vt > 24 ? (t < 1 / 0 && ($t = setTimeout(ee, t - Xt.now() - Gt)), Ht && (Ht = clearInterval(Ht))) : (Ht || (Wt = Xt.now(), Ht = setInterval(ne, 1e3)), qt = 1, Zt(ee)));
        }

        function ie(t, e, n) {
          var r = new Jt();
          return e = null == e ? 0 : +e, r.restart(function (n) {
            r.stop(), t(n + e);
          }, e, n), r;
        }

        Jt.prototype = te.prototype = {
          constructor: Jt,
          restart: function restart(t, e, n) {
            if ("function" != typeof t) throw new TypeError("callback is not a function");
            n = (null == n ? Kt() : +n) + (null == e ? 0 : +e), this._next || zt === this || (zt ? zt._next = this : Ut = this, zt = this), this._call = t, this._time = n, re();
          },
          stop: function stop() {
            this._call && (this._call = null, this._time = 1 / 0, re());
          }
        };
        var ae = Yt("start", "end", "cancel", "interrupt"),
            oe = [];

        function se(t, e, n, r, i, a) {
          var o = t.__transition;

          if (o) {
            if (n in o) return;
          } else t.__transition = {};

          !function (t, e, n) {
            var r,
                i = t.__transition;

            function a(c) {
              var u, l, h, f;
              if (1 !== n.state) return s();

              for (u in i) {
                if ((f = i[u]).name === n.name) {
                  if (3 === f.state) return ie(a);
                  4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
                }
              }

              if (ie(function () {
                3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
              }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
                for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
                  (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
                }

                r.length = l + 1;
              }
            }

            function o(e) {
              for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
                r[a].call(t, i);
              }

              5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
            }

            function s() {
              for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
                return;
              }

              delete t.__transition;
            }

            i[e] = n, n.timer = te(function (t) {
              n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
            }, 0, n.time);
          }(t, n, {
            name: e,
            index: r,
            group: i,
            on: ae,
            tween: oe,
            time: a.time,
            delay: a.delay,
            duration: a.duration,
            ease: a.ease,
            timer: null,
            state: 0
          });
        }

        function ce(t, e) {
          var n = le(t, e);
          if (n.state > 0) throw new Error("too late; already scheduled");
          return n;
        }

        function ue(t, e) {
          var n = le(t, e);
          if (n.state > 3) throw new Error("too late; already running");
          return n;
        }

        function le(t, e) {
          var n = t.__transition;
          if (!n || !(n = n[e])) throw new Error("transition not found");
          return n;
        }

        function he(t, e) {
          return t = +t, e = +e, function (n) {
            return t * (1 - n) + e * n;
          };
        }

        var fe,
            de = 180 / Math.PI,
            pe = {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          skewX: 0,
          scaleX: 1,
          scaleY: 1
        };

        function ye(t, e, n, r, i, a) {
          var o, s, c;
          return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
            translateX: i,
            translateY: a,
            rotate: Math.atan2(e, t) * de,
            skewX: Math.atan(c) * de,
            scaleX: o,
            scaleY: s
          };
        }

        function ge(t, e, n, r) {
          function i(t) {
            return t.length ? t.pop() + " " : "";
          }

          return function (a, o) {
            var s = [],
                c = [];
            return a = t(a), o = t(o), function (t, r, i, a, o, s) {
              if (t !== i || r !== a) {
                var c = o.push("translate(", null, e, null, n);
                s.push({
                  i: c - 4,
                  x: he(t, i)
                }, {
                  i: c - 2,
                  x: he(r, a)
                });
              } else (i || a) && o.push("translate(" + i + e + a + n);
            }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
              t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
                i: n.push(i(n) + "rotate(", null, r) - 2,
                x: he(t, e)
              })) : e && n.push(i(n) + "rotate(" + e + r);
            }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
              t !== e ? a.push({
                i: n.push(i(n) + "skewX(", null, r) - 2,
                x: he(t, e)
              }) : e && n.push(i(n) + "skewX(" + e + r);
            }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
              if (t !== n || e !== r) {
                var s = a.push(i(a) + "scale(", null, ",", null, ")");
                o.push({
                  i: s - 4,
                  x: he(t, n)
                }, {
                  i: s - 2,
                  x: he(e, r)
                });
              } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
            }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
              for (var e, n = -1, r = c.length; ++n < r;) {
                s[(e = c[n]).i] = e.x(t);
              }

              return s.join("");
            };
          };
        }

        var me = ge(function (t) {
          var e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
          return e.isIdentity ? pe : ye(e.a, e.b, e.c, e.d, e.e, e.f);
        }, "px, ", "px)", "deg)"),
            ve = ge(function (t) {
          return null == t ? pe : (fe || (fe = document.createElementNS("http://www.w3.org/2000/svg", "g")), fe.setAttribute("transform", t), (t = fe.transform.baseVal.consolidate()) ? ye((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : pe);
        }, ", ", ")", ")");

        function be(t, e) {
          var n, r;
          return function () {
            var i = ue(this, t),
                a = i.tween;
            if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
              if (r[o].name === e) {
                (r = r.slice()).splice(o, 1);
                break;
              }
            }
            i.tween = r;
          };
        }

        function _e(t, e, n) {
          var r, i;
          if ("function" != typeof n) throw new Error();
          return function () {
            var a = ue(this, t),
                o = a.tween;

            if (o !== r) {
              i = (r = o).slice();

              for (var s = {
                name: e,
                value: n
              }, c = 0, u = i.length; c < u; ++c) {
                if (i[c].name === e) {
                  i[c] = s;
                  break;
                }
              }

              c === u && i.push(s);
            }

            a.tween = i;
          };
        }

        function xe(t, e, n) {
          var r = t._id;
          return t.each(function () {
            var t = ue(this, r);
            (t.value || (t.value = {}))[e] = n.apply(this, arguments);
          }), function (t) {
            return le(t, r).value[e];
          };
        }

        function we(t, e, n) {
          t.prototype = e.prototype = n, n.constructor = t;
        }

        function ke(t, e) {
          var n = Object.create(t.prototype);

          for (var r in e) {
            n[r] = e[r];
          }

          return n;
        }

        function Te() {}

        var Ee = 1 / .7,
            Ce = "\\s*([+-]?\\d+)\\s*",
            Se = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            Ae = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            Me = /^#([0-9a-f]{3,8})$/,
            Ne = new RegExp("^rgb\\(" + [Ce, Ce, Ce] + "\\)$"),
            De = new RegExp("^rgb\\(" + [Ae, Ae, Ae] + "\\)$"),
            Oe = new RegExp("^rgba\\(" + [Ce, Ce, Ce, Se] + "\\)$"),
            Be = new RegExp("^rgba\\(" + [Ae, Ae, Ae, Se] + "\\)$"),
            Le = new RegExp("^hsl\\(" + [Se, Ae, Ae] + "\\)$"),
            Ie = new RegExp("^hsla\\(" + [Se, Ae, Ae, Se] + "\\)$"),
            Re = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };

        function Pe() {
          return this.rgb().formatHex();
        }

        function Fe() {
          return this.rgb().formatRgb();
        }

        function je(t) {
          var e, n;
          return t = (t + "").trim().toLowerCase(), (e = Me.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? Ye(e) : 3 === n ? new $e(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Ue(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Ue(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Ne.exec(t)) ? new $e(e[1], e[2], e[3], 1) : (e = De.exec(t)) ? new $e(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Oe.exec(t)) ? Ue(e[1], e[2], e[3], e[4]) : (e = Be.exec(t)) ? Ue(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Le.exec(t)) ? Ge(e[1], e[2] / 100, e[3] / 100, 1) : (e = Ie.exec(t)) ? Ge(e[1], e[2] / 100, e[3] / 100, e[4]) : Re.hasOwnProperty(t) ? Ye(Re[t]) : "transparent" === t ? new $e(NaN, NaN, NaN, 0) : null;
        }

        function Ye(t) {
          return new $e(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
        }

        function Ue(t, e, n, r) {
          return r <= 0 && (t = e = n = NaN), new $e(t, e, n, r);
        }

        function ze(t) {
          return t instanceof Te || (t = je(t)), t ? new $e((t = t.rgb()).r, t.g, t.b, t.opacity) : new $e();
        }

        function qe(t, e, n, r) {
          return 1 === arguments.length ? ze(t) : new $e(t, e, n, null == r ? 1 : r);
        }

        function $e(t, e, n, r) {
          this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
        }

        function He() {
          return "#" + Ve(this.r) + Ve(this.g) + Ve(this.b);
        }

        function We() {
          var t = this.opacity;
          return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
        }

        function Ve(t) {
          return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
        }

        function Ge(t, e, n, r) {
          return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Ze(t, e, n, r);
        }

        function Xe(t) {
          if (t instanceof Ze) return new Ze(t.h, t.s, t.l, t.opacity);
          if (t instanceof Te || (t = je(t)), !t) return new Ze();
          if (t instanceof Ze) return t;
          var e = (t = t.rgb()).r / 255,
              n = t.g / 255,
              r = t.b / 255,
              i = Math.min(e, n, r),
              a = Math.max(e, n, r),
              o = NaN,
              s = a - i,
              c = (a + i) / 2;
          return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Ze(o, s, c, t.opacity);
        }

        function Ze(t, e, n, r) {
          this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
        }

        function Ke(t, e, n) {
          return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
        }

        function Qe(t, e, n, r, i) {
          var a = t * t,
              o = a * t;
          return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
        }

        we(Te, je, {
          copy: function copy(t) {
            return Object.assign(new this.constructor(), this, t);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: Pe,
          formatHex: Pe,
          formatHsl: function formatHsl() {
            return Xe(this).formatHsl();
          },
          formatRgb: Fe,
          toString: Fe
        }), we($e, qe, ke(Te, {
          brighter: function brighter(t) {
            return t = null == t ? Ee : Math.pow(Ee, t), new $e(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new $e(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: He,
          formatHex: He,
          formatRgb: We,
          toString: We
        })), we(Ze, function (t, e, n, r) {
          return 1 === arguments.length ? Xe(t) : new Ze(t, e, n, null == r ? 1 : r);
        }, ke(Te, {
          brighter: function brighter(t) {
            return t = null == t ? Ee : Math.pow(Ee, t), new Ze(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new Ze(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = this.h % 360 + 360 * (this.h < 0),
                e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                n = this.l,
                r = n + (n < .5 ? n : 1 - n) * e,
                i = 2 * n - r;
            return new $e(Ke(t >= 240 ? t - 240 : t + 120, i, r), Ke(t, i, r), Ke(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var t = this.opacity;
            return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
          }
        }));

        var Je = function Je(t) {
          return function () {
            return t;
          };
        };

        function tn(t, e) {
          var n = e - t;
          return n ? function (t, e) {
            return function (n) {
              return t + n * e;
            };
          }(t, n) : Je(isNaN(t) ? e : t);
        }

        var en = function t(e) {
          var n = function (t) {
            return 1 == (t = +t) ? tn : function (e, n) {
              return n - e ? function (t, e, n) {
                return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
                  return Math.pow(t + r * e, n);
                };
              }(e, n, t) : Je(isNaN(e) ? n : e);
            };
          }(e);

          function r(t, e) {
            var r = n((t = qe(t)).r, (e = qe(e)).r),
                i = n(t.g, e.g),
                a = n(t.b, e.b),
                o = tn(t.opacity, e.opacity);
            return function (e) {
              return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
            };
          }

          return r.gamma = t, r;
        }(1);

        function nn(t) {
          return function (e) {
            var n,
                r,
                i = e.length,
                a = new Array(i),
                o = new Array(i),
                s = new Array(i);

            for (n = 0; n < i; ++n) {
              r = qe(e[n]), a[n] = r.r || 0, o[n] = r.g || 0, s[n] = r.b || 0;
            }

            return a = t(a), o = t(o), s = t(s), r.opacity = 1, function (t) {
              return r.r = a(t), r.g = o(t), r.b = s(t), r + "";
            };
          };
        }

        nn(function (t) {
          var e = t.length - 1;
          return function (n) {
            var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
                i = t[r],
                a = t[r + 1],
                o = r > 0 ? t[r - 1] : 2 * i - a,
                s = r < e - 1 ? t[r + 2] : 2 * a - i;
            return Qe((n - r / e) * e, o, i, a, s);
          };
        }), nn(function (t) {
          var e = t.length;
          return function (n) {
            var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
                i = t[(r + e - 1) % e],
                a = t[r % e],
                o = t[(r + 1) % e],
                s = t[(r + 2) % e];
            return Qe((n - r / e) * e, i, a, o, s);
          };
        });
        var rn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            an = new RegExp(rn.source, "g");

        function on(t, e) {
          var n,
              r,
              i,
              a = rn.lastIndex = an.lastIndex = 0,
              o = -1,
              s = [],
              c = [];

          for (t += "", e += ""; (n = rn.exec(t)) && (r = an.exec(e));) {
            (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
              i: o,
              x: he(n, r)
            })), a = an.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
            return function (e) {
              return t(e) + "";
            };
          }(c[0].x) : function (t) {
            return function () {
              return t;
            };
          }(e) : (e = c.length, function (t) {
            for (var n, r = 0; r < e; ++r) {
              s[(n = c[r]).i] = n.x(t);
            }

            return s.join("");
          });
        }

        function sn(t, e) {
          var n;
          return ("number" == typeof e ? he : e instanceof je ? en : (n = je(e)) ? (e = n, en) : on)(t, e);
        }

        function cn(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function un(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function ln(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttribute(t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function hn(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttributeNS(t.space, t.local);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function fn(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttribute(t);
          };
        }

        function dn(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function pn(t, e) {
          return function (n) {
            this.setAttribute(t, e.call(this, n));
          };
        }

        function yn(t, e) {
          return function (n) {
            this.setAttributeNS(t.space, t.local, e.call(this, n));
          };
        }

        function gn(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && yn(t, i)), n;
          }

          return i._value = e, i;
        }

        function mn(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && pn(t, i)), n;
          }

          return i._value = e, i;
        }

        function vn(t, e) {
          return function () {
            ce(this, t).delay = +e.apply(this, arguments);
          };
        }

        function bn(t, e) {
          return e = +e, function () {
            ce(this, t).delay = e;
          };
        }

        function _n(t, e) {
          return function () {
            ue(this, t).duration = +e.apply(this, arguments);
          };
        }

        function xn(t, e) {
          return e = +e, function () {
            ue(this, t).duration = e;
          };
        }

        function wn(t, e) {
          if ("function" != typeof e) throw new Error();
          return function () {
            ue(this, t).ease = e;
          };
        }

        function kn(t, e, n) {
          var r,
              i,
              a = function (t) {
            return (t + "").trim().split(/^|\s+/).every(function (t) {
              var e = t.indexOf(".");
              return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
            });
          }(e) ? ce : ue;
          return function () {
            var o = a(this, t),
                s = o.on;
            s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
          };
        }

        var Tn = Bt.prototype.constructor;

        function En(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function Cn(t, e, n) {
          return function (r) {
            this.style.setProperty(t, e.call(this, r), n);
          };
        }

        function Sn(t, e, n) {
          var r, i;

          function a() {
            var a = e.apply(this, arguments);
            return a !== i && (r = (i = a) && Cn(t, a, n)), r;
          }

          return a._value = e, a;
        }

        function An(t) {
          return function (e) {
            this.textContent = t.call(this, e);
          };
        }

        function Mn(t) {
          var e, n;

          function r() {
            var r = t.apply(this, arguments);
            return r !== n && (e = (n = r) && An(r)), e;
          }

          return r._value = t, r;
        }

        var Nn = 0;

        function Dn(t, e, n, r) {
          this._groups = t, this._parents = e, this._name = n, this._id = r;
        }

        function On() {
          return ++Nn;
        }

        var Bn = Bt.prototype;

        Dn.prototype = function (t) {
          return Bt().transition(t);
        }.prototype = _defineProperty({
          constructor: Dn,
          select: function select(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = _(t));

            for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
              for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
                (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, se(h[f], e, n, f, h, le(s, n)));
              }
            }

            return new Dn(a, this._parents, e, n);
          },
          selectAll: function selectAll(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = k(t));

            for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
              for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
                if (c = u[h]) {
                  for (var f, d = t.call(c, c.__data__, h, u), p = le(c, n), y = 0, g = d.length; y < g; ++y) {
                    (f = d[y]) && se(f, e, n, y, d, p);
                  }

                  a.push(d), o.push(c);
                }
              }
            }

            return new Dn(a, o, e, n);
          },
          selectChild: Bn.selectChild,
          selectChildren: Bn.selectChildren,
          filter: function filter(t) {
            "function" != typeof t && (t = T(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new Dn(r, this._parents, this._name, this._id);
          },
          merge: function merge(t) {
            if (t._id !== this._id) throw new Error();

            for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
              for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
                (c = u[d] || l[d]) && (f[d] = c);
              }
            }

            for (; s < r; ++s) {
              o[s] = e[s];
            }

            return new Dn(o, this._parents, this._name, this._id);
          },
          selection: function selection() {
            return new Tn(this._groups, this._parents);
          },
          transition: function transition() {
            for (var t = this._name, e = this._id, n = On(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
              for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
                if (o = s[u]) {
                  var l = le(o, e);
                  se(o, t, n, u, s, {
                    time: l.time + l.delay + l.duration,
                    delay: 0,
                    duration: l.duration,
                    ease: l.ease
                  });
                }
              }
            }

            return new Dn(r, this._parents, t, n);
          },
          call: Bn.call,
          nodes: Bn.nodes,
          node: Bn.node,
          size: Bn.size,
          empty: Bn.empty,
          each: Bn.each,
          on: function on(t, e) {
            var n = this._id;
            return arguments.length < 2 ? le(this.node(), n).on.on(t) : this.each(kn(n, t, e));
          },
          attr: function attr(t, e) {
            var n = Y(t),
                r = "transform" === n ? ve : sn;
            return this.attrTween(t, "function" == typeof e ? (n.local ? dn : fn)(n, r, xe(this, "attr." + t, e)) : null == e ? (n.local ? un : cn)(n) : (n.local ? hn : ln)(n, r, e));
          },
          attrTween: function attrTween(t, e) {
            var n = "attr." + t;
            if (arguments.length < 2) return (n = this.tween(n)) && n._value;
            if (null == e) return this.tween(n, null);
            if ("function" != typeof e) throw new Error();
            var r = Y(t);
            return this.tween(n, (r.local ? gn : mn)(r, e));
          },
          style: function style(t, e, n) {
            var r = "transform" == (t += "") ? me : sn;
            return null == e ? this.styleTween(t, function (t, e) {
              var n, r, i;
              return function () {
                var a = K(this, t),
                    o = (this.style.removeProperty(t), K(this, t));
                return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
              };
            }(t, r)).on("end.style." + t, En(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
              var r, i, a;
              return function () {
                var o = K(this, t),
                    s = n(this),
                    c = s + "";
                return null == s && (this.style.removeProperty(t), c = s = K(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
              };
            }(t, r, xe(this, "style." + t, e))).each(function (t, e) {
              var n,
                  r,
                  i,
                  a,
                  o = "style." + e,
                  s = "end." + o;
              return function () {
                var c = ue(this, t),
                    u = c.on,
                    l = null == c.value[o] ? a || (a = En(e)) : void 0;
                u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
              };
            }(this._id, t)) : this.styleTween(t, function (t, e, n) {
              var r,
                  i,
                  a = n + "";
              return function () {
                var o = K(this, t);
                return o === a ? null : o === r ? i : i = e(r = o, n);
              };
            }(t, r, e), n).on("end.style." + t, null);
          },
          styleTween: function styleTween(t, e, n) {
            var r = "style." + (t += "");
            if (arguments.length < 2) return (r = this.tween(r)) && r._value;
            if (null == e) return this.tween(r, null);
            if ("function" != typeof e) throw new Error();
            return this.tween(r, Sn(t, e, null == n ? "" : n));
          },
          text: function text(t) {
            return this.tween("text", "function" == typeof t ? function (t) {
              return function () {
                var e = t(this);
                this.textContent = null == e ? "" : e;
              };
            }(xe(this, "text", t)) : function (t) {
              return function () {
                this.textContent = t;
              };
            }(null == t ? "" : t + ""));
          },
          textTween: function textTween(t) {
            var e = "text";
            if (arguments.length < 1) return (e = this.tween(e)) && e._value;
            if (null == t) return this.tween(e, null);
            if ("function" != typeof t) throw new Error();
            return this.tween(e, Mn(t));
          },
          remove: function remove() {
            return this.on("end.remove", function (t) {
              return function () {
                var e = this.parentNode;

                for (var n in this.__transition) {
                  if (+n !== t) return;
                }

                e && e.removeChild(this);
              };
            }(this._id));
          },
          tween: function tween(t, e) {
            var n = this._id;

            if (t += "", arguments.length < 2) {
              for (var r, i = le(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
                if ((r = i[a]).name === t) return r.value;
              }

              return null;
            }

            return this.each((null == e ? be : _e)(n, t, e));
          },
          delay: function delay(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? vn : bn)(e, t)) : le(this.node(), e).delay;
          },
          duration: function duration(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? _n : xn)(e, t)) : le(this.node(), e).duration;
          },
          ease: function ease(t) {
            var e = this._id;
            return arguments.length ? this.each(wn(e, t)) : le(this.node(), e).ease;
          },
          easeVarying: function easeVarying(t) {
            if ("function" != typeof t) throw new Error();
            return this.each(function (t, e) {
              return function () {
                var n = e.apply(this, arguments);
                if ("function" != typeof n) throw new Error();
                ue(this, t).ease = n;
              };
            }(this._id, t));
          },
          end: function end() {
            var t,
                e,
                n = this,
                r = n._id,
                i = n.size();
            return new Promise(function (a, o) {
              var s = {
                value: o
              },
                  c = {
                value: function value() {
                  0 == --i && a();
                }
              };
              n.each(function () {
                var n = ue(this, r),
                    i = n.on;
                i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
              }), 0 === i && a();
            });
          }
        }, Symbol.iterator, Bn[Symbol.iterator]);

        var Ln = {
          time: null,
          delay: 0,
          duration: 250,
          ease: function ease(t) {
            return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
          }
        };

        function In(t, e) {
          for (var n; !(n = t.__transition) || !(n = n[e]);) {
            if (!(t = t.parentNode)) throw new Error("transition ".concat(e, " not found"));
          }

          return n;
        }

        Bt.prototype.interrupt = function (t) {
          return this.each(function () {
            !function (t, e) {
              var n,
                  r,
                  i,
                  a = t.__transition,
                  o = !0;

              if (a) {
                for (i in e = null == e ? null : e + "", a) {
                  (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
                }

                o && delete t.__transition;
              }
            }(this, t);
          });
        }, Bt.prototype.transition = function (t) {
          var e, n;
          t instanceof Dn ? (e = t._id, t = t._name) : (e = On(), (n = Ln).time = Kt(), t = null == t ? null : t + "");

          for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
            for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
              (o = s[u]) && se(o, t, e, u, s, n || In(o, e));
            }
          }

          return new Dn(r, this._parents, t, e);
        };
        var Rn = Math.abs,
            Pn = Math.max,
            Fn = Math.min;

        function jn(t) {
          return {
            type: t
          };
        }

        function Yn(t, e, n) {
          t.prototype = e.prototype = n, n.constructor = t;
        }

        function Un(t, e) {
          var n = Object.create(t.prototype);

          for (var r in e) {
            n[r] = e[r];
          }

          return n;
        }

        function zn() {}

        ["w", "e"].map(jn), ["n", "s"].map(jn), ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(jn);
        var qn = 1 / .7,
            $n = "\\s*([+-]?\\d+)\\s*",
            Hn = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            Wn = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            Vn = /^#([0-9a-f]{3,8})$/,
            Gn = new RegExp("^rgb\\(" + [$n, $n, $n] + "\\)$"),
            Xn = new RegExp("^rgb\\(" + [Wn, Wn, Wn] + "\\)$"),
            Zn = new RegExp("^rgba\\(" + [$n, $n, $n, Hn] + "\\)$"),
            Kn = new RegExp("^rgba\\(" + [Wn, Wn, Wn, Hn] + "\\)$"),
            Qn = new RegExp("^hsl\\(" + [Hn, Wn, Wn] + "\\)$"),
            Jn = new RegExp("^hsla\\(" + [Hn, Wn, Wn, Hn] + "\\)$"),
            tr = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };

        function er() {
          return this.rgb().formatHex();
        }

        function nr() {
          return this.rgb().formatRgb();
        }

        function rr(t) {
          var e, n;
          return t = (t + "").trim().toLowerCase(), (e = Vn.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? ir(e) : 3 === n ? new cr(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? ar(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? ar(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Gn.exec(t)) ? new cr(e[1], e[2], e[3], 1) : (e = Xn.exec(t)) ? new cr(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Zn.exec(t)) ? ar(e[1], e[2], e[3], e[4]) : (e = Kn.exec(t)) ? ar(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Qn.exec(t)) ? fr(e[1], e[2] / 100, e[3] / 100, 1) : (e = Jn.exec(t)) ? fr(e[1], e[2] / 100, e[3] / 100, e[4]) : tr.hasOwnProperty(t) ? ir(tr[t]) : "transparent" === t ? new cr(NaN, NaN, NaN, 0) : null;
        }

        function ir(t) {
          return new cr(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
        }

        function ar(t, e, n, r) {
          return r <= 0 && (t = e = n = NaN), new cr(t, e, n, r);
        }

        function or(t) {
          return t instanceof zn || (t = rr(t)), t ? new cr((t = t.rgb()).r, t.g, t.b, t.opacity) : new cr();
        }

        function sr(t, e, n, r) {
          return 1 === arguments.length ? or(t) : new cr(t, e, n, null == r ? 1 : r);
        }

        function cr(t, e, n, r) {
          this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
        }

        function ur() {
          return "#" + hr(this.r) + hr(this.g) + hr(this.b);
        }

        function lr() {
          var t = this.opacity;
          return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
        }

        function hr(t) {
          return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
        }

        function fr(t, e, n, r) {
          return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new pr(t, e, n, r);
        }

        function dr(t) {
          if (t instanceof pr) return new pr(t.h, t.s, t.l, t.opacity);
          if (t instanceof zn || (t = rr(t)), !t) return new pr();
          if (t instanceof pr) return t;
          var e = (t = t.rgb()).r / 255,
              n = t.g / 255,
              r = t.b / 255,
              i = Math.min(e, n, r),
              a = Math.max(e, n, r),
              o = NaN,
              s = a - i,
              c = (a + i) / 2;
          return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new pr(o, s, c, t.opacity);
        }

        function pr(t, e, n, r) {
          this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
        }

        function yr(t, e, n) {
          return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
        }

        Yn(zn, rr, {
          copy: function copy(t) {
            return Object.assign(new this.constructor(), this, t);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: er,
          formatHex: er,
          formatHsl: function formatHsl() {
            return dr(this).formatHsl();
          },
          formatRgb: nr,
          toString: nr
        }), Yn(cr, sr, Un(zn, {
          brighter: function brighter(t) {
            return t = null == t ? qn : Math.pow(qn, t), new cr(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new cr(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: ur,
          formatHex: ur,
          formatRgb: lr,
          toString: lr
        })), Yn(pr, function (t, e, n, r) {
          return 1 === arguments.length ? dr(t) : new pr(t, e, n, null == r ? 1 : r);
        }, Un(zn, {
          brighter: function brighter(t) {
            return t = null == t ? qn : Math.pow(qn, t), new pr(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new pr(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = this.h % 360 + 360 * (this.h < 0),
                e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                n = this.l,
                r = n + (n < .5 ? n : 1 - n) * e,
                i = 2 * n - r;
            return new cr(yr(t >= 240 ? t - 240 : t + 120, i, r), yr(t, i, r), yr(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var t = this.opacity;
            return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
          }
        }));
        var gr = Math.PI / 180,
            mr = 180 / Math.PI,
            vr = 6 / 29 * 3 * (6 / 29);

        function br(t) {
          if (t instanceof _r) return new _r(t.l, t.a, t.b, t.opacity);
          if (t instanceof Sr) return Ar(t);
          t instanceof cr || (t = or(t));
          var e,
              n,
              r = Tr(t.r),
              i = Tr(t.g),
              a = Tr(t.b),
              o = xr((.2225045 * r + .7168786 * i + .0606169 * a) / 1);
          return r === i && i === a ? e = n = o : (e = xr((.4360747 * r + .3850649 * i + .1430804 * a) / .96422), n = xr((.0139322 * r + .0971045 * i + .7141733 * a) / .82521)), new _r(116 * o - 16, 500 * (e - o), 200 * (o - n), t.opacity);
        }

        function _r(t, e, n, r) {
          this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
        }

        function xr(t) {
          return t > .008856451679035631 ? Math.pow(t, 1 / 3) : t / vr + 4 / 29;
        }

        function wr(t) {
          return t > 6 / 29 ? t * t * t : vr * (t - 4 / 29);
        }

        function kr(t) {
          return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
        }

        function Tr(t) {
          return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }

        function Er(t) {
          if (t instanceof Sr) return new Sr(t.h, t.c, t.l, t.opacity);
          if (t instanceof _r || (t = br(t)), 0 === t.a && 0 === t.b) return new Sr(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
          var e = Math.atan2(t.b, t.a) * mr;
          return new Sr(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
        }

        function Cr(t, e, n, r) {
          return 1 === arguments.length ? Er(t) : new Sr(t, e, n, null == r ? 1 : r);
        }

        function Sr(t, e, n, r) {
          this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
        }

        function Ar(t) {
          if (isNaN(t.h)) return new _r(t.l, 0, 0, t.opacity);
          var e = t.h * gr;
          return new _r(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
        }

        Yn(_r, function (t, e, n, r) {
          return 1 === arguments.length ? br(t) : new _r(t, e, n, null == r ? 1 : r);
        }, Un(zn, {
          brighter: function brighter(t) {
            return new _r(this.l + 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
          },
          darker: function darker(t) {
            return new _r(this.l - 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
          },
          rgb: function rgb() {
            var t = (this.l + 16) / 116,
                e = isNaN(this.a) ? t : t + this.a / 500,
                n = isNaN(this.b) ? t : t - this.b / 200;
            return new cr(kr(3.1338561 * (e = .96422 * wr(e)) - 1.6168667 * (t = 1 * wr(t)) - .4906146 * (n = .82521 * wr(n))), kr(-.9787684 * e + 1.9161415 * t + .033454 * n), kr(.0719453 * e - .2289914 * t + 1.4052427 * n), this.opacity);
          }
        })), Yn(Sr, Cr, Un(zn, {
          brighter: function brighter(t) {
            return new Sr(this.h, this.c, this.l + 18 * (null == t ? 1 : t), this.opacity);
          },
          darker: function darker(t) {
            return new Sr(this.h, this.c, this.l - 18 * (null == t ? 1 : t), this.opacity);
          },
          rgb: function rgb() {
            return Ar(this).rgb();
          }
        }));

        var Mr = function Mr(t) {
          return function () {
            return t;
          };
        };

        function Nr(t, e) {
          return function (n) {
            return t + n * e;
          };
        }

        function Dr(t, e) {
          var n = e - t;
          return n ? Nr(t, n) : Mr(isNaN(t) ? e : t);
        }

        function Or(t) {
          return function (e, n) {
            var r = t((e = Cr(e)).h, (n = Cr(n)).h),
                i = Dr(e.c, n.c),
                a = Dr(e.l, n.l),
                o = Dr(e.opacity, n.opacity);
            return function (t) {
              return e.h = r(t), e.c = i(t), e.l = a(t), e.opacity = o(t), e + "";
            };
          };
        }

        var Br = Or(function (t, e) {
          var n = e - t;
          return n ? Nr(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Mr(isNaN(t) ? e : t);
        });
        Or(Dr);
        var Lr = Math.sqrt(50),
            Ir = Math.sqrt(10),
            Rr = Math.sqrt(2);

        function Pr(t, e, n) {
          var r = (e - t) / Math.max(0, n),
              i = Math.floor(Math.log(r) / Math.LN10),
              a = r / Math.pow(10, i);
          return i >= 0 ? (a >= Lr ? 10 : a >= Ir ? 5 : a >= Rr ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= Lr ? 10 : a >= Ir ? 5 : a >= Rr ? 2 : 1);
        }

        function Fr(t, e, n) {
          var r = Math.abs(e - t) / Math.max(0, n),
              i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
              a = r / i;
          return a >= Lr ? i *= 10 : a >= Ir ? i *= 5 : a >= Rr && (i *= 2), e < t ? -i : i;
        }

        function jr(t, e) {
          return null == t || null == e ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        function Yr(t) {
          var e = t,
              n = t;

          function r(t, e, r, i) {
            for (null == r && (r = 0), null == i && (i = t.length); r < i;) {
              var _a2 = r + i >>> 1;

              n(t[_a2], e) < 0 ? r = _a2 + 1 : i = _a2;
            }

            return r;
          }

          return 1 === t.length && (e = function e(_e5, n) {
            return t(_e5) - n;
          }, n = function (t) {
            return function (e, n) {
              return jr(t(e), n);
            };
          }(t)), {
            left: r,
            center: function center(t, n, i, a) {
              null == i && (i = 0), null == a && (a = t.length);
              var o = r(t, n, i, a - 1);
              return o > i && e(t[o - 1], n) > -e(t[o], n) ? o - 1 : o;
            },
            right: function right(t, e, r, i) {
              for (null == r && (r = 0), null == i && (i = t.length); r < i;) {
                var _a3 = r + i >>> 1;

                n(t[_a3], e) > 0 ? i = _a3 : r = _a3 + 1;
              }

              return r;
            }
          };
        }

        var Ur = Yr(jr),
            zr = Ur.right,
            qr = (Ur.left, Yr(function (t) {
          return null === t ? NaN : +t;
        }).center, zr);

        function $r(t, e, n) {
          t.prototype = e.prototype = n, n.constructor = t;
        }

        function Hr(t, e) {
          var n = Object.create(t.prototype);

          for (var r in e) {
            n[r] = e[r];
          }

          return n;
        }

        function Wr() {}

        var Vr = 1.4285714285714286,
            Gr = "\\s*([+-]?\\d+)\\s*",
            Xr = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            Zr = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            Kr = /^#([0-9a-f]{3,8})$/,
            Qr = new RegExp("^rgb\\(" + [Gr, Gr, Gr] + "\\)$"),
            Jr = new RegExp("^rgb\\(" + [Zr, Zr, Zr] + "\\)$"),
            ti = new RegExp("^rgba\\(" + [Gr, Gr, Gr, Xr] + "\\)$"),
            ei = new RegExp("^rgba\\(" + [Zr, Zr, Zr, Xr] + "\\)$"),
            ni = new RegExp("^hsl\\(" + [Xr, Zr, Zr] + "\\)$"),
            ri = new RegExp("^hsla\\(" + [Xr, Zr, Zr, Xr] + "\\)$"),
            ii = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };

        function ai() {
          return this.rgb().formatHex();
        }

        function oi() {
          return this.rgb().formatRgb();
        }

        function si(t) {
          var e, n;
          return t = (t + "").trim().toLowerCase(), (e = Kr.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? ci(e) : 3 === n ? new fi(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? ui(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? ui(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Qr.exec(t)) ? new fi(e[1], e[2], e[3], 1) : (e = Jr.exec(t)) ? new fi(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = ti.exec(t)) ? ui(e[1], e[2], e[3], e[4]) : (e = ei.exec(t)) ? ui(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = ni.exec(t)) ? gi(e[1], e[2] / 100, e[3] / 100, 1) : (e = ri.exec(t)) ? gi(e[1], e[2] / 100, e[3] / 100, e[4]) : ii.hasOwnProperty(t) ? ci(ii[t]) : "transparent" === t ? new fi(NaN, NaN, NaN, 0) : null;
        }

        function ci(t) {
          return new fi(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
        }

        function ui(t, e, n, r) {
          return r <= 0 && (t = e = n = NaN), new fi(t, e, n, r);
        }

        function li(t) {
          return t instanceof Wr || (t = si(t)), t ? new fi((t = t.rgb()).r, t.g, t.b, t.opacity) : new fi();
        }

        function hi(t, e, n, r) {
          return 1 === arguments.length ? li(t) : new fi(t, e, n, null == r ? 1 : r);
        }

        function fi(t, e, n, r) {
          this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
        }

        function di() {
          return "#" + yi(this.r) + yi(this.g) + yi(this.b);
        }

        function pi() {
          var t = this.opacity;
          return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
        }

        function yi(t) {
          return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
        }

        function gi(t, e, n, r) {
          return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new vi(t, e, n, r);
        }

        function mi(t) {
          if (t instanceof vi) return new vi(t.h, t.s, t.l, t.opacity);
          if (t instanceof Wr || (t = si(t)), !t) return new vi();
          if (t instanceof vi) return t;
          var e = (t = t.rgb()).r / 255,
              n = t.g / 255,
              r = t.b / 255,
              i = Math.min(e, n, r),
              a = Math.max(e, n, r),
              o = NaN,
              s = a - i,
              c = (a + i) / 2;
          return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new vi(o, s, c, t.opacity);
        }

        function vi(t, e, n, r) {
          this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
        }

        function bi(t, e, n) {
          return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
        }

        function _i(t, e, n, r, i) {
          var a = t * t,
              o = a * t;
          return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
        }

        $r(Wr, si, {
          copy: function copy(t) {
            return Object.assign(new this.constructor(), this, t);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: ai,
          formatHex: ai,
          formatHsl: function formatHsl() {
            return mi(this).formatHsl();
          },
          formatRgb: oi,
          toString: oi
        }), $r(fi, hi, Hr(Wr, {
          brighter: function brighter(t) {
            return t = null == t ? Vr : Math.pow(Vr, t), new fi(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new fi(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: di,
          formatHex: di,
          formatRgb: pi,
          toString: pi
        })), $r(vi, function (t, e, n, r) {
          return 1 === arguments.length ? mi(t) : new vi(t, e, n, null == r ? 1 : r);
        }, Hr(Wr, {
          brighter: function brighter(t) {
            return t = null == t ? Vr : Math.pow(Vr, t), new vi(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new vi(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = this.h % 360 + 360 * (this.h < 0),
                e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                n = this.l,
                r = n + (n < .5 ? n : 1 - n) * e,
                i = 2 * n - r;
            return new fi(bi(t >= 240 ? t - 240 : t + 120, i, r), bi(t, i, r), bi(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var t = this.opacity;
            return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
          }
        }));

        var xi = function xi(t) {
          return function () {
            return t;
          };
        };

        function wi(t, e) {
          var n = e - t;
          return n ? function (t, e) {
            return function (n) {
              return t + n * e;
            };
          }(t, n) : xi(isNaN(t) ? e : t);
        }

        var ki = function t(e) {
          var n = function (t) {
            return 1 == (t = +t) ? wi : function (e, n) {
              return n - e ? function (t, e, n) {
                return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
                  return Math.pow(t + r * e, n);
                };
              }(e, n, t) : xi(isNaN(e) ? n : e);
            };
          }(e);

          function r(t, e) {
            var r = n((t = hi(t)).r, (e = hi(e)).r),
                i = n(t.g, e.g),
                a = n(t.b, e.b),
                o = wi(t.opacity, e.opacity);
            return function (e) {
              return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
            };
          }

          return r.gamma = t, r;
        }(1);

        function Ti(t) {
          return function (e) {
            var n,
                r,
                i = e.length,
                a = new Array(i),
                o = new Array(i),
                s = new Array(i);

            for (n = 0; n < i; ++n) {
              r = hi(e[n]), a[n] = r.r || 0, o[n] = r.g || 0, s[n] = r.b || 0;
            }

            return a = t(a), o = t(o), s = t(s), r.opacity = 1, function (t) {
              return r.r = a(t), r.g = o(t), r.b = s(t), r + "";
            };
          };
        }

        function Ei(t, e) {
          var n,
              r = e ? e.length : 0,
              i = t ? Math.min(r, t.length) : 0,
              a = new Array(i),
              o = new Array(r);

          for (n = 0; n < i; ++n) {
            a[n] = Bi(t[n], e[n]);
          }

          for (; n < r; ++n) {
            o[n] = e[n];
          }

          return function (t) {
            for (n = 0; n < i; ++n) {
              o[n] = a[n](t);
            }

            return o;
          };
        }

        function Ci(t, e) {
          var n = new Date();
          return t = +t, e = +e, function (r) {
            return n.setTime(t * (1 - r) + e * r), n;
          };
        }

        function Si(t, e) {
          return t = +t, e = +e, function (n) {
            return t * (1 - n) + e * n;
          };
        }

        function Ai(t, e) {
          var n,
              r = {},
              i = {};

          for (n in null !== t && "object" == typeof t || (t = {}), null !== e && "object" == typeof e || (e = {}), e) {
            n in t ? r[n] = Bi(t[n], e[n]) : i[n] = e[n];
          }

          return function (t) {
            for (n in r) {
              i[n] = r[n](t);
            }

            return i;
          };
        }

        Ti(function (t) {
          var e = t.length - 1;
          return function (n) {
            var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
                i = t[r],
                a = t[r + 1],
                o = r > 0 ? t[r - 1] : 2 * i - a,
                s = r < e - 1 ? t[r + 2] : 2 * a - i;
            return _i((n - r / e) * e, o, i, a, s);
          };
        }), Ti(function (t) {
          var e = t.length;
          return function (n) {
            var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
                i = t[(r + e - 1) % e],
                a = t[r % e],
                o = t[(r + 1) % e],
                s = t[(r + 2) % e];
            return _i((n - r / e) * e, i, a, o, s);
          };
        });
        var Mi = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            Ni = new RegExp(Mi.source, "g");

        function Di(t, e) {
          var n,
              r,
              i,
              a = Mi.lastIndex = Ni.lastIndex = 0,
              o = -1,
              s = [],
              c = [];

          for (t += "", e += ""; (n = Mi.exec(t)) && (r = Ni.exec(e));) {
            (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
              i: o,
              x: Si(n, r)
            })), a = Ni.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
            return function (e) {
              return t(e) + "";
            };
          }(c[0].x) : function (t) {
            return function () {
              return t;
            };
          }(e) : (e = c.length, function (t) {
            for (var n, r = 0; r < e; ++r) {
              s[(n = c[r]).i] = n.x(t);
            }

            return s.join("");
          });
        }

        function Oi(t, e) {
          e || (e = []);
          var n,
              r = t ? Math.min(e.length, t.length) : 0,
              i = e.slice();
          return function (a) {
            for (n = 0; n < r; ++n) {
              i[n] = t[n] * (1 - a) + e[n] * a;
            }

            return i;
          };
        }

        function Bi(t, e) {
          var n,
              r,
              i = typeof e;
          return null == e || "boolean" === i ? xi(e) : ("number" === i ? Si : "string" === i ? (n = si(e)) ? (e = n, ki) : Di : e instanceof si ? ki : e instanceof Date ? Ci : (r = e, !ArrayBuffer.isView(r) || r instanceof DataView ? Array.isArray(e) ? Ei : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? Ai : Si : Oi))(t, e);
        }

        function Li(t, e) {
          return t = +t, e = +e, function (n) {
            return Math.round(t * (1 - n) + e * n);
          };
        }

        function Ii(t) {
          return +t;
        }

        var Ri = [0, 1];

        function Pi(t) {
          return t;
        }

        function Fi(t, e) {
          return (e -= t = +t) ? function (n) {
            return (n - t) / e;
          } : (n = isNaN(e) ? NaN : .5, function () {
            return n;
          });
          var n;
        }

        function ji(t, e, n) {
          var r = t[0],
              i = t[1],
              a = e[0],
              o = e[1];
          return i < r ? (r = Fi(i, r), a = n(o, a)) : (r = Fi(r, i), a = n(a, o)), function (t) {
            return a(r(t));
          };
        }

        function Yi(t, e, n) {
          var r = Math.min(t.length, e.length) - 1,
              i = new Array(r),
              a = new Array(r),
              o = -1;

          for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r;) {
            i[o] = Fi(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
          }

          return function (e) {
            var n = qr(t, e, 1, r) - 1;
            return a[n](i[n](e));
          };
        }

        function Ui(t, e) {
          return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
        }

        function zi() {
          return function () {
            var t,
                e,
                n,
                r,
                i,
                a,
                o = Ri,
                s = Ri,
                c = Bi,
                u = Pi;

            function l() {
              var t,
                  e,
                  n,
                  c = Math.min(o.length, s.length);
              return u !== Pi && (t = o[0], e = o[c - 1], t > e && (n = t, t = e, e = n), u = function u(n) {
                return Math.max(t, Math.min(e, n));
              }), r = c > 2 ? Yi : ji, i = a = null, h;
            }

            function h(e) {
              return null == e || isNaN(e = +e) ? n : (i || (i = r(o.map(t), s, c)))(t(u(e)));
            }

            return h.invert = function (n) {
              return u(e((a || (a = r(s, o.map(t), Si)))(n)));
            }, h.domain = function (t) {
              return arguments.length ? (o = Array.from(t, Ii), l()) : o.slice();
            }, h.range = function (t) {
              return arguments.length ? (s = Array.from(t), l()) : s.slice();
            }, h.rangeRound = function (t) {
              return s = Array.from(t), c = Li, l();
            }, h.clamp = function (t) {
              return arguments.length ? (u = !!t || Pi, l()) : u !== Pi;
            }, h.interpolate = function (t) {
              return arguments.length ? (c = t, l()) : c;
            }, h.unknown = function (t) {
              return arguments.length ? (n = t, h) : n;
            }, function (n, r) {
              return t = n, e = r, l();
            };
          }()(Pi, Pi);
        }

        function qi(t, e) {
          switch (arguments.length) {
            case 0:
              break;

            case 1:
              this.range(t);
              break;

            default:
              this.range(e).domain(t);
          }

          return this;
        }

        var $i,
            Hi = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

        function Wi(t) {
          if (!(e = Hi.exec(t))) throw new Error("invalid format: " + t);
          var e;
          return new Vi({
            fill: e[1],
            align: e[2],
            sign: e[3],
            symbol: e[4],
            zero: e[5],
            width: e[6],
            comma: e[7],
            precision: e[8] && e[8].slice(1),
            trim: e[9],
            type: e[10]
          });
        }

        function Vi(t) {
          this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
        }

        function Gi(t, e) {
          if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
          var n,
              r = t.slice(0, n);
          return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
        }

        function Xi(t) {
          return (t = Gi(Math.abs(t))) ? t[1] : NaN;
        }

        function Zi(t, e) {
          var n = Gi(t, e);
          if (!n) return t + "";
          var r = n[0],
              i = n[1];
          return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
        }

        Wi.prototype = Vi.prototype, Vi.prototype.toString = function () {
          return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
        };
        var Ki = {
          "%": function _(t, e) {
            return (100 * t).toFixed(e);
          },
          b: function b(t) {
            return Math.round(t).toString(2);
          },
          c: function c(t) {
            return t + "";
          },
          d: function d(t) {
            return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
          },
          e: function e(t, _e6) {
            return t.toExponential(_e6);
          },
          f: function f(t, e) {
            return t.toFixed(e);
          },
          g: function g(t, e) {
            return t.toPrecision(e);
          },
          o: function o(t) {
            return Math.round(t).toString(8);
          },
          p: function p(t, e) {
            return Zi(100 * t, e);
          },
          r: Zi,
          s: function s(t, e) {
            var n = Gi(t, e);
            if (!n) return t + "";
            var r = n[0],
                i = n[1],
                a = i - ($i = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
                o = r.length;
            return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + Gi(t, Math.max(0, e + a - 1))[0];
          },
          X: function X(t) {
            return Math.round(t).toString(16).toUpperCase();
          },
          x: function x(t) {
            return Math.round(t).toString(16);
          }
        };

        function Qi(t) {
          return t;
        }

        var Ji,
            ta,
            ea,
            na = Array.prototype.map,
            ra = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

        function ia(t) {
          var e = t.domain;
          return t.ticks = function (t) {
            var n = e();
            return function (t, e, n) {
              var r,
                  i,
                  a,
                  o,
                  s = -1;
              if (n = +n, (t = +t) == (e = +e) && n > 0) return [t];
              if ((r = e < t) && (i = t, t = e, e = i), 0 === (o = Pr(t, e, n)) || !isFinite(o)) return [];

              if (o > 0) {
                var _n2 = Math.round(t / o),
                    _r4 = Math.round(e / o);

                for (_n2 * o < t && ++_n2, _r4 * o > e && --_r4, a = new Array(i = _r4 - _n2 + 1); ++s < i;) {
                  a[s] = (_n2 + s) * o;
                }
              } else {
                o = -o;

                var _n3 = Math.round(t * o),
                    _r5 = Math.round(e * o);

                for (_n3 / o < t && ++_n3, _r5 / o > e && --_r5, a = new Array(i = _r5 - _n3 + 1); ++s < i;) {
                  a[s] = (_n3 + s) / o;
                }
              }

              return r && a.reverse(), a;
            }(n[0], n[n.length - 1], null == t ? 10 : t);
          }, t.tickFormat = function (t, n) {
            var r = e();
            return function (t, e, n, r) {
              var i,
                  a = Fr(t, e, n);

              switch ((r = Wi(null == r ? ",f" : r)).type) {
                case "s":
                  var o = Math.max(Math.abs(t), Math.abs(e));
                  return null != r.precision || isNaN(i = function (t, e) {
                    return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(Xi(e) / 3))) - Xi(Math.abs(t)));
                  }(a, o)) || (r.precision = i), ea(r, o);

                case "":
                case "e":
                case "g":
                case "p":
                case "r":
                  null != r.precision || isNaN(i = function (t, e) {
                    return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Xi(e) - Xi(t)) + 1;
                  }(a, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
                  break;

                case "f":
                case "%":
                  null != r.precision || isNaN(i = function (t) {
                    return Math.max(0, -Xi(Math.abs(t)));
                  }(a)) || (r.precision = i - 2 * ("%" === r.type));
              }

              return ta(r);
            }(r[0], r[r.length - 1], null == t ? 10 : t, n);
          }, t.nice = function (n) {
            null == n && (n = 10);
            var r,
                i,
                a = e(),
                o = 0,
                s = a.length - 1,
                c = a[o],
                u = a[s],
                l = 10;

            for (u < c && (i = c, c = u, u = i, i = o, o = s, s = i); l-- > 0;) {
              if ((i = Pr(c, u, n)) === r) return a[o] = c, a[s] = u, e(a);
              if (i > 0) c = Math.floor(c / i) * i, u = Math.ceil(u / i) * i;else {
                if (!(i < 0)) break;
                c = Math.ceil(c * i) / i, u = Math.floor(u * i) / i;
              }
              r = i;
            }

            return t;
          }, t;
        }

        Ji = function (t) {
          var e,
              n,
              r = void 0 === t.grouping || void 0 === t.thousands ? Qi : (e = na.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
            for (var i = t.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(t.substring(i -= s, i + s)), !((c += s + 1) > r));) {
              s = e[o = (o + 1) % e.length];
            }

            return a.reverse().join(n);
          }),
              i = void 0 === t.currency ? "" : t.currency[0] + "",
              a = void 0 === t.currency ? "" : t.currency[1] + "",
              o = void 0 === t.decimal ? "." : t.decimal + "",
              s = void 0 === t.numerals ? Qi : function (t) {
            return function (e) {
              return e.replace(/[0-9]/g, function (e) {
                return t[+e];
              });
            };
          }(na.call(t.numerals, String)),
              c = void 0 === t.percent ? "%" : t.percent + "",
              u = void 0 === t.minus ? "−" : t.minus + "",
              l = void 0 === t.nan ? "NaN" : t.nan + "";

          function h(t) {
            var e = (t = Wi(t)).fill,
                n = t.align,
                h = t.sign,
                f = t.symbol,
                d = t.zero,
                p = t.width,
                y = t.comma,
                g = t.precision,
                m = t.trim,
                v = t.type;
            "n" === v ? (y = !0, v = "g") : Ki[v] || (void 0 === g && (g = 12), m = !0, v = "g"), (d || "0" === e && "=" === n) && (d = !0, e = "0", n = "=");

            var b = "$" === f ? i : "#" === f && /[boxX]/.test(v) ? "0" + v.toLowerCase() : "",
                _ = "$" === f ? a : /[%p]/.test(v) ? c : "",
                x = Ki[v],
                w = /[defgprs%]/.test(v);

            function k(t) {
              var i,
                  a,
                  c,
                  f = b,
                  k = _;
              if ("c" === v) k = x(t) + k, t = "";else {
                var T = (t = +t) < 0 || 1 / t < 0;
                if (t = isNaN(t) ? l : x(Math.abs(t), g), m && (t = function (t) {
                  t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
                    switch (t[r]) {
                      case ".":
                        i = e = r;
                        break;

                      case "0":
                        0 === i && (i = r), e = r;
                        break;

                      default:
                        if (!+t[r]) break t;
                        i > 0 && (i = 0);
                    }
                  }

                  return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
                }(t)), T && 0 == +t && "+" !== h && (T = !1), f = (T ? "(" === h ? h : u : "-" === h || "(" === h ? "" : h) + f, k = ("s" === v ? ra[8 + $i / 3] : "") + k + (T && "(" === h ? ")" : ""), w) for (i = -1, a = t.length; ++i < a;) {
                  if (48 > (c = t.charCodeAt(i)) || c > 57) {
                    k = (46 === c ? o + t.slice(i + 1) : t.slice(i)) + k, t = t.slice(0, i);
                    break;
                  }
                }
              }
              y && !d && (t = r(t, 1 / 0));
              var E = f.length + t.length + k.length,
                  C = E < p ? new Array(p - E + 1).join(e) : "";

              switch (y && d && (t = r(C + t, C.length ? p - k.length : 1 / 0), C = ""), n) {
                case "<":
                  t = f + t + k + C;
                  break;

                case "=":
                  t = f + C + t + k;
                  break;

                case "^":
                  t = C.slice(0, E = C.length >> 1) + f + t + k + C.slice(E);
                  break;

                default:
                  t = C + f + t + k;
              }

              return s(t);
            }

            return g = void 0 === g ? 6 : /[gprs]/.test(v) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), k.toString = function () {
              return t + "";
            }, k;
          }

          return {
            format: h,
            formatPrefix: function formatPrefix(t, e) {
              var n = h(((t = Wi(t)).type = "f", t)),
                  r = 3 * Math.max(-8, Math.min(8, Math.floor(Xi(e) / 3))),
                  i = Math.pow(10, -r),
                  a = ra[8 + r / 3];
              return function (t) {
                return n(i * t) + a;
              };
            }
          };
        }({
          thousands: ",",
          grouping: [3],
          currency: ["$", ""]
        }), ta = Ji.format, ea = Ji.formatPrefix;

        var aa = /*#__PURE__*/function (_Map) {
          _inherits(aa, _Map);

          var _super = _createSuper(aa);

          function aa(t) {
            var _this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sa;

            _classCallCheck(this, aa);

            if (_this = _super.call(this), Object.defineProperties(_assertThisInitialized(_this), {
              _intern: {
                value: new Map()
              },
              _key: {
                value: e
              }
            }), null != t) {
              var _iterator6 = _createForOfIteratorHelper(t),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _step6$value = _slicedToArray(_step6.value, 2),
                      _e7 = _step6$value[0],
                      _n4 = _step6$value[1];

                  _this.set(_e7, _n4);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }

            return _possibleConstructorReturn(_this);
          }

          _createClass(aa, [{
            key: "get",
            value: function get(t) {
              return _get(_getPrototypeOf(aa.prototype), "get", this).call(this, oa(this, t));
            }
          }, {
            key: "has",
            value: function has(t) {
              return _get(_getPrototypeOf(aa.prototype), "has", this).call(this, oa(this, t));
            }
          }, {
            key: "set",
            value: function set(t, e) {
              return _get(_getPrototypeOf(aa.prototype), "set", this).call(this, function (_ref, n) {
                var t = _ref._intern,
                    e = _ref._key;
                var r = e(n);
                return t.has(r) ? t.get(r) : (t.set(r, n), n);
              }(this, t), e);
            }
          }, {
            key: "delete",
            value: function _delete(t) {
              return _get(_getPrototypeOf(aa.prototype), "delete", this).call(this, function (_ref2, n) {
                var t = _ref2._intern,
                    e = _ref2._key;
                var r = e(n);
                return t.has(r) && (n = t.get(n), t.delete(r)), n;
              }(this, t));
            }
          }]);

          return aa;
        }( /*#__PURE__*/_wrapNativeSuper(Map));

        function oa(_ref3, n) {
          var t = _ref3._intern,
              e = _ref3._key;
          var r = e(n);
          return t.has(r) ? t.get(r) : n;
        }

        function sa(t) {
          return null !== t && "object" == typeof t ? t.valueOf() : t;
        }

        Set;
        var ca = Symbol("implicit");
        var ua = 1e3,
            la = 6e4,
            ha = 36e5,
            fa = 864e5,
            da = 6048e5,
            pa = 31536e6;
        var ya = new Date(),
            ga = new Date();

        function ma(t, e, n, r) {
          function i(e) {
            return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
          }

          return i.floor = function (e) {
            return t(e = new Date(+e)), e;
          }, i.ceil = function (n) {
            return t(n = new Date(n - 1)), e(n, 1), t(n), n;
          }, i.round = function (t) {
            var e = i(t),
                n = i.ceil(t);
            return t - e < n - t ? e : n;
          }, i.offset = function (t, n) {
            return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
          }, i.range = function (n, r, a) {
            var o,
                s = [];
            if (n = i.ceil(n), a = null == a ? 1 : Math.floor(a), !(n < r && a > 0)) return s;

            do {
              s.push(o = new Date(+n)), e(n, a), t(n);
            } while (o < n && n < r);

            return s;
          }, i.filter = function (n) {
            return ma(function (e) {
              if (e >= e) for (; t(e), !n(e);) {
                e.setTime(e - 1);
              }
            }, function (t, r) {
              if (t >= t) if (r < 0) for (; ++r <= 0;) {
                for (; e(t, -1), !n(t);) {
                  ;
                }
              } else for (; --r >= 0;) {
                for (; e(t, 1), !n(t);) {
                  ;
                }
              }
            });
          }, n && (i.count = function (e, r) {
            return ya.setTime(+e), ga.setTime(+r), t(ya), t(ga), Math.floor(n(ya, ga));
          }, i.every = function (t) {
            return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
              return r(e) % t == 0;
            } : function (e) {
              return i.count(0, e) % t == 0;
            }) : i : null;
          }), i;
        }

        var va = ma(function () {}, function (t, e) {
          t.setTime(+t + e);
        }, function (t, e) {
          return e - t;
        });

        va.every = function (t) {
          return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? ma(function (e) {
            e.setTime(Math.floor(e / t) * t);
          }, function (e, n) {
            e.setTime(+e + n * t);
          }, function (e, n) {
            return (n - e) / t;
          }) : va : null;
        };

        var ba = va;
        va.range;

        var _a = ma(function (t) {
          t.setTime(t - t.getMilliseconds());
        }, function (t, e) {
          t.setTime(+t + e * ua);
        }, function (t, e) {
          return (e - t) / ua;
        }, function (t) {
          return t.getUTCSeconds();
        });

        var xa = _a;
        _a.range;
        var wa = ma(function (t) {
          t.setTime(t - t.getMilliseconds() - t.getSeconds() * ua);
        }, function (t, e) {
          t.setTime(+t + e * la);
        }, function (t, e) {
          return (e - t) / la;
        }, function (t) {
          return t.getMinutes();
        });
        var ka = wa;
        wa.range;
        var Ta = ma(function (t) {
          t.setTime(t - t.getMilliseconds() - t.getSeconds() * ua - t.getMinutes() * la);
        }, function (t, e) {
          t.setTime(+t + e * ha);
        }, function (t, e) {
          return (e - t) / ha;
        }, function (t) {
          return t.getHours();
        });
        var Ea = Ta;
        Ta.range;
        var Ca = ma(function (t) {
          return t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          return t.setDate(t.getDate() + e);
        }, function (t, e) {
          return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * la) / fa;
        }, function (t) {
          return t.getDate() - 1;
        });
        var Sa = Ca;

        function Aa(t) {
          return ma(function (e) {
            e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setDate(t.getDate() + 7 * e);
          }, function (t, e) {
            return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * la) / da;
          });
        }

        Ca.range;
        var Ma = Aa(0),
            Na = Aa(1),
            Da = Aa(2),
            Oa = Aa(3),
            Ba = Aa(4),
            La = Aa(5),
            Ia = Aa(6),
            Ra = (Ma.range, Na.range, Da.range, Oa.range, Ba.range, La.range, Ia.range, ma(function (t) {
          t.setDate(1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setMonth(t.getMonth() + e);
        }, function (t, e) {
          return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
        }, function (t) {
          return t.getMonth();
        }));
        var Pa = Ra;
        Ra.range;
        var Fa = ma(function (t) {
          t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setFullYear(t.getFullYear() + e);
        }, function (t, e) {
          return e.getFullYear() - t.getFullYear();
        }, function (t) {
          return t.getFullYear();
        });

        Fa.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? ma(function (e) {
            e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
          }, function (e, n) {
            e.setFullYear(e.getFullYear() + n * t);
          }) : null;
        };

        var ja = Fa;
        Fa.range;
        var Ya = ma(function (t) {
          t.setUTCSeconds(0, 0);
        }, function (t, e) {
          t.setTime(+t + e * la);
        }, function (t, e) {
          return (e - t) / la;
        }, function (t) {
          return t.getUTCMinutes();
        });
        var Ua = Ya;
        Ya.range;
        var za = ma(function (t) {
          t.setUTCMinutes(0, 0, 0);
        }, function (t, e) {
          t.setTime(+t + e * ha);
        }, function (t, e) {
          return (e - t) / ha;
        }, function (t) {
          return t.getUTCHours();
        });
        var qa = za;
        za.range;
        var $a = ma(function (t) {
          t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCDate(t.getUTCDate() + e);
        }, function (t, e) {
          return (e - t) / fa;
        }, function (t) {
          return t.getUTCDate() - 1;
        });
        var Ha = $a;

        function Wa(t) {
          return ma(function (e) {
            e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setUTCDate(t.getUTCDate() + 7 * e);
          }, function (t, e) {
            return (e - t) / da;
          });
        }

        $a.range;
        var Va = Wa(0),
            Ga = Wa(1),
            Xa = Wa(2),
            Za = Wa(3),
            Ka = Wa(4),
            Qa = Wa(5),
            Ja = Wa(6),
            to = (Va.range, Ga.range, Xa.range, Za.range, Ka.range, Qa.range, Ja.range, ma(function (t) {
          t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCMonth(t.getUTCMonth() + e);
        }, function (t, e) {
          return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
        }, function (t) {
          return t.getUTCMonth();
        }));
        var eo = to;
        to.range;
        var no = ma(function (t) {
          t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCFullYear(t.getUTCFullYear() + e);
        }, function (t, e) {
          return e.getUTCFullYear() - t.getUTCFullYear();
        }, function (t) {
          return t.getUTCFullYear();
        });

        no.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? ma(function (e) {
            e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
          }, function (e, n) {
            e.setUTCFullYear(e.getUTCFullYear() + n * t);
          }) : null;
        };

        var ro = no;

        function io(t, e, n, r, i, a) {
          var o = [[xa, 1, ua], [xa, 5, 5e3], [xa, 15, 15e3], [xa, 30, 3e4], [a, 1, la], [a, 5, 3e5], [a, 15, 9e5], [a, 30, 18e5], [i, 1, ha], [i, 3, 108e5], [i, 6, 216e5], [i, 12, 432e5], [r, 1, fa], [r, 2, 1728e5], [n, 1, da], [e, 1, 2592e6], [e, 3, 7776e6], [t, 1, pa]];

          function s(e, n, r) {
            var i = Math.abs(n - e) / r,
                a = Yr(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 3),
                  t = _ref5[2];

              return t;
            }).right(o, i);
            if (a === o.length) return t.every(Fr(e / pa, n / pa, r));
            if (0 === a) return ba.every(Math.max(Fr(e, n, r), 1));

            var _o2 = _slicedToArray(o[i / o[a - 1][2] < o[a][2] / i ? a - 1 : a], 2),
                s = _o2[0],
                c = _o2[1];

            return s.every(c);
          }

          return [function (t, e, n) {
            var _ref6;

            var r = e < t;
            r && (_ref6 = [e, t], t = _ref6[0], e = _ref6[1], _ref6);
            var i = n && "function" == typeof n.range ? n : s(t, e, n),
                a = i ? i.range(t, +e + 1) : [];
            return r ? a.reverse() : a;
          }, s];
        }

        no.range;

        var _io = io(ro, eo, Va, Ha, qa, Ua),
            _io2 = _slicedToArray(_io, 2),
            ao = _io2[0],
            oo = _io2[1],
            _io3 = io(ja, Pa, Ma, Sa, Ea, ka),
            _io4 = _slicedToArray(_io3, 2),
            so = _io4[0],
            co = _io4[1];

        function uo(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
            return e.setFullYear(t.y), e;
          }

          return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
        }

        function lo(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
            return e.setUTCFullYear(t.y), e;
          }

          return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
        }

        function ho(t, e, n) {
          return {
            y: t,
            m: e,
            d: n,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }

        var fo,
            po,
            yo = {
          "-": "",
          _: " ",
          0: "0"
        },
            go = /^\s*\d+/,
            mo = /^%/,
            vo = /[\\^$*+?|[\]().{}]/g;

        function bo(t, e, n) {
          var r = t < 0 ? "-" : "",
              i = (r ? -t : t) + "",
              a = i.length;
          return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
        }

        function _o(t) {
          return t.replace(vo, "\\$&");
        }

        function xo(t) {
          return new RegExp("^(?:" + t.map(_o).join("|") + ")", "i");
        }

        function wo(t) {
          return new Map(t.map(function (t, e) {
            return [t.toLowerCase(), e];
          }));
        }

        function ko(t, e, n) {
          var r = go.exec(e.slice(n, n + 1));
          return r ? (t.w = +r[0], n + r[0].length) : -1;
        }

        function To(t, e, n) {
          var r = go.exec(e.slice(n, n + 1));
          return r ? (t.u = +r[0], n + r[0].length) : -1;
        }

        function Eo(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.U = +r[0], n + r[0].length) : -1;
        }

        function Co(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.V = +r[0], n + r[0].length) : -1;
        }

        function So(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.W = +r[0], n + r[0].length) : -1;
        }

        function Ao(t, e, n) {
          var r = go.exec(e.slice(n, n + 4));
          return r ? (t.y = +r[0], n + r[0].length) : -1;
        }

        function Mo(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
        }

        function No(t, e, n) {
          var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
          return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
        }

        function Do(t, e, n) {
          var r = go.exec(e.slice(n, n + 1));
          return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
        }

        function Oo(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
        }

        function Bo(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.d = +r[0], n + r[0].length) : -1;
        }

        function Lo(t, e, n) {
          var r = go.exec(e.slice(n, n + 3));
          return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
        }

        function Io(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.H = +r[0], n + r[0].length) : -1;
        }

        function Ro(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.M = +r[0], n + r[0].length) : -1;
        }

        function Po(t, e, n) {
          var r = go.exec(e.slice(n, n + 2));
          return r ? (t.S = +r[0], n + r[0].length) : -1;
        }

        function Fo(t, e, n) {
          var r = go.exec(e.slice(n, n + 3));
          return r ? (t.L = +r[0], n + r[0].length) : -1;
        }

        function jo(t, e, n) {
          var r = go.exec(e.slice(n, n + 6));
          return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
        }

        function Yo(t, e, n) {
          var r = mo.exec(e.slice(n, n + 1));
          return r ? n + r[0].length : -1;
        }

        function Uo(t, e, n) {
          var r = go.exec(e.slice(n));
          return r ? (t.Q = +r[0], n + r[0].length) : -1;
        }

        function zo(t, e, n) {
          var r = go.exec(e.slice(n));
          return r ? (t.s = +r[0], n + r[0].length) : -1;
        }

        function qo(t, e) {
          return bo(t.getDate(), e, 2);
        }

        function $o(t, e) {
          return bo(t.getHours(), e, 2);
        }

        function Ho(t, e) {
          return bo(t.getHours() % 12 || 12, e, 2);
        }

        function Wo(t, e) {
          return bo(1 + Sa.count(ja(t), t), e, 3);
        }

        function Vo(t, e) {
          return bo(t.getMilliseconds(), e, 3);
        }

        function Go(t, e) {
          return Vo(t, e) + "000";
        }

        function Xo(t, e) {
          return bo(t.getMonth() + 1, e, 2);
        }

        function Zo(t, e) {
          return bo(t.getMinutes(), e, 2);
        }

        function Ko(t, e) {
          return bo(t.getSeconds(), e, 2);
        }

        function Qo(t) {
          var e = t.getDay();
          return 0 === e ? 7 : e;
        }

        function Jo(t, e) {
          return bo(Ma.count(ja(t) - 1, t), e, 2);
        }

        function ts(t) {
          var e = t.getDay();
          return e >= 4 || 0 === e ? Ba(t) : Ba.ceil(t);
        }

        function es(t, e) {
          return t = ts(t), bo(Ba.count(ja(t), t) + (4 === ja(t).getDay()), e, 2);
        }

        function ns(t) {
          return t.getDay();
        }

        function rs(t, e) {
          return bo(Na.count(ja(t) - 1, t), e, 2);
        }

        function is(t, e) {
          return bo(t.getFullYear() % 100, e, 2);
        }

        function as(t, e) {
          return bo((t = ts(t)).getFullYear() % 100, e, 2);
        }

        function os(t, e) {
          return bo(t.getFullYear() % 1e4, e, 4);
        }

        function ss(t, e) {
          var n = t.getDay();
          return bo((t = n >= 4 || 0 === n ? Ba(t) : Ba.ceil(t)).getFullYear() % 1e4, e, 4);
        }

        function cs(t) {
          var e = t.getTimezoneOffset();
          return (e > 0 ? "-" : (e *= -1, "+")) + bo(e / 60 | 0, "0", 2) + bo(e % 60, "0", 2);
        }

        function us(t, e) {
          return bo(t.getUTCDate(), e, 2);
        }

        function ls(t, e) {
          return bo(t.getUTCHours(), e, 2);
        }

        function hs(t, e) {
          return bo(t.getUTCHours() % 12 || 12, e, 2);
        }

        function fs(t, e) {
          return bo(1 + Ha.count(ro(t), t), e, 3);
        }

        function ds(t, e) {
          return bo(t.getUTCMilliseconds(), e, 3);
        }

        function ps(t, e) {
          return ds(t, e) + "000";
        }

        function ys(t, e) {
          return bo(t.getUTCMonth() + 1, e, 2);
        }

        function gs(t, e) {
          return bo(t.getUTCMinutes(), e, 2);
        }

        function ms(t, e) {
          return bo(t.getUTCSeconds(), e, 2);
        }

        function vs(t) {
          var e = t.getUTCDay();
          return 0 === e ? 7 : e;
        }

        function bs(t, e) {
          return bo(Va.count(ro(t) - 1, t), e, 2);
        }

        function _s(t) {
          var e = t.getUTCDay();
          return e >= 4 || 0 === e ? Ka(t) : Ka.ceil(t);
        }

        function xs(t, e) {
          return t = _s(t), bo(Ka.count(ro(t), t) + (4 === ro(t).getUTCDay()), e, 2);
        }

        function ws(t) {
          return t.getUTCDay();
        }

        function ks(t, e) {
          return bo(Ga.count(ro(t) - 1, t), e, 2);
        }

        function Ts(t, e) {
          return bo(t.getUTCFullYear() % 100, e, 2);
        }

        function Es(t, e) {
          return bo((t = _s(t)).getUTCFullYear() % 100, e, 2);
        }

        function Cs(t, e) {
          return bo(t.getUTCFullYear() % 1e4, e, 4);
        }

        function Ss(t, e) {
          var n = t.getUTCDay();
          return bo((t = n >= 4 || 0 === n ? Ka(t) : Ka.ceil(t)).getUTCFullYear() % 1e4, e, 4);
        }

        function As() {
          return "+0000";
        }

        function Ms() {
          return "%";
        }

        function Ns(t) {
          return +t;
        }

        function Ds(t) {
          return Math.floor(+t / 1e3);
        }

        function Os(t) {
          return new Date(t);
        }

        function Bs(t) {
          return t instanceof Date ? +t : +new Date(+t);
        }

        function Ls(t, e, n, r, i, a, o, s, c, u) {
          var l = zi(),
              h = l.invert,
              f = l.domain,
              d = u(".%L"),
              p = u(":%S"),
              y = u("%I:%M"),
              g = u("%I %p"),
              m = u("%a %d"),
              v = u("%b %d"),
              b = u("%B"),
              _ = u("%Y");

          function x(t) {
            return (c(t) < t ? d : s(t) < t ? p : o(t) < t ? y : a(t) < t ? g : r(t) < t ? i(t) < t ? m : v : n(t) < t ? b : _)(t);
          }

          return l.invert = function (t) {
            return new Date(h(t));
          }, l.domain = function (t) {
            return arguments.length ? f(Array.from(t, Bs)) : f().map(Os);
          }, l.ticks = function (e) {
            var n = f();
            return t(n[0], n[n.length - 1], null == e ? 10 : e);
          }, l.tickFormat = function (t, e) {
            return null == e ? x : u(e);
          }, l.nice = function (t) {
            var n = f();
            return t && "function" == typeof t.range || (t = e(n[0], n[n.length - 1], null == t ? 10 : t)), t ? f(function (t, e) {
              var n,
                  r = 0,
                  i = (t = t.slice()).length - 1,
                  a = t[r],
                  o = t[i];
              return o < a && (n = r, r = i, i = n, n = a, a = o, o = n), t[r] = e.floor(a), t[i] = e.ceil(o), t;
            }(n, t)) : l;
          }, l.copy = function () {
            return Ui(l, Ls(t, e, n, r, i, a, o, s, c, u));
          }, l;
        }

        function Is() {}

        function Rs(t) {
          return null == t ? Is : function () {
            return this.querySelector(t);
          };
        }

        function Ps(t) {
          return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
        }

        function Fs() {
          return [];
        }

        function js(t) {
          return null == t ? Fs : function () {
            return this.querySelectorAll(t);
          };
        }

        function Ys(t) {
          return function () {
            return this.matches(t);
          };
        }

        function Us(t) {
          return function (e) {
            return e.matches(t);
          };
        }

        fo = function (t) {
          var e = t.dateTime,
              n = t.date,
              r = t.time,
              i = t.periods,
              a = t.days,
              o = t.shortDays,
              s = t.months,
              c = t.shortMonths,
              u = xo(i),
              l = wo(i),
              h = xo(a),
              f = wo(a),
              d = xo(o),
              p = wo(o),
              y = xo(s),
              g = wo(s),
              m = xo(c),
              v = wo(c),
              b = {
            a: function a(t) {
              return o[t.getDay()];
            },
            A: function A(t) {
              return a[t.getDay()];
            },
            b: function b(t) {
              return c[t.getMonth()];
            },
            B: function B(t) {
              return s[t.getMonth()];
            },
            c: null,
            d: qo,
            e: qo,
            f: Go,
            g: as,
            G: ss,
            H: $o,
            I: Ho,
            j: Wo,
            L: Vo,
            m: Xo,
            M: Zo,
            p: function p(t) {
              return i[+(t.getHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getMonth() / 3);
            },
            Q: Ns,
            s: Ds,
            S: Ko,
            u: Qo,
            U: Jo,
            V: es,
            w: ns,
            W: rs,
            x: null,
            X: null,
            y: is,
            Y: os,
            Z: cs,
            "%": Ms
          },
              _ = {
            a: function a(t) {
              return o[t.getUTCDay()];
            },
            A: function A(t) {
              return a[t.getUTCDay()];
            },
            b: function b(t) {
              return c[t.getUTCMonth()];
            },
            B: function B(t) {
              return s[t.getUTCMonth()];
            },
            c: null,
            d: us,
            e: us,
            f: ps,
            g: Es,
            G: Ss,
            H: ls,
            I: hs,
            j: fs,
            L: ds,
            m: ys,
            M: gs,
            p: function p(t) {
              return i[+(t.getUTCHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getUTCMonth() / 3);
            },
            Q: Ns,
            s: Ds,
            S: ms,
            u: vs,
            U: bs,
            V: xs,
            w: ws,
            W: ks,
            x: null,
            X: null,
            y: Ts,
            Y: Cs,
            Z: As,
            "%": Ms
          },
              x = {
            a: function a(t, e, n) {
              var r = d.exec(e.slice(n));
              return r ? (t.w = p.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            A: function A(t, e, n) {
              var r = h.exec(e.slice(n));
              return r ? (t.w = f.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            b: function b(t, e, n) {
              var r = m.exec(e.slice(n));
              return r ? (t.m = v.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            B: function B(t, e, n) {
              var r = y.exec(e.slice(n));
              return r ? (t.m = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            c: function c(t, n, r) {
              return T(t, e, n, r);
            },
            d: Bo,
            e: Bo,
            f: jo,
            g: Mo,
            G: Ao,
            H: Io,
            I: Io,
            j: Lo,
            L: Fo,
            m: Oo,
            M: Ro,
            p: function p(t, e, n) {
              var r = u.exec(e.slice(n));
              return r ? (t.p = l.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            q: Do,
            Q: Uo,
            s: zo,
            S: Po,
            u: To,
            U: Eo,
            V: Co,
            w: ko,
            W: So,
            x: function x(t, e, r) {
              return T(t, n, e, r);
            },
            X: function X(t, e, n) {
              return T(t, r, e, n);
            },
            y: Mo,
            Y: Ao,
            Z: No,
            "%": Yo
          };

          function w(t, e) {
            return function (n) {
              var r,
                  i,
                  a,
                  o = [],
                  s = -1,
                  c = 0,
                  u = t.length;

              for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
                37 === t.charCodeAt(s) && (o.push(t.slice(c, s)), null != (i = yo[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (a = e[r]) && (r = a(n, i)), o.push(r), c = s + 1);
              }

              return o.push(t.slice(c, s)), o.join("");
            };
          }

          function k(t, e) {
            return function (n) {
              var r,
                  i,
                  a = ho(1900, void 0, 1);
              if (T(a, t, n += "", 0) != n.length) return null;
              if ("Q" in a) return new Date(a.Q);
              if ("s" in a) return new Date(1e3 * a.s + ("L" in a ? a.L : 0));

              if (e && !("Z" in a) && (a.Z = 0), "p" in a && (a.H = a.H % 12 + 12 * a.p), void 0 === a.m && (a.m = "q" in a ? a.q : 0), "V" in a) {
                if (a.V < 1 || a.V > 53) return null;
                "w" in a || (a.w = 1), "Z" in a ? (i = (r = lo(ho(a.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? Ga.ceil(r) : Ga(r), r = Ha.offset(r, 7 * (a.V - 1)), a.y = r.getUTCFullYear(), a.m = r.getUTCMonth(), a.d = r.getUTCDate() + (a.w + 6) % 7) : (i = (r = uo(ho(a.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? Na.ceil(r) : Na(r), r = Sa.offset(r, 7 * (a.V - 1)), a.y = r.getFullYear(), a.m = r.getMonth(), a.d = r.getDate() + (a.w + 6) % 7);
              } else ("W" in a || "U" in a) && ("w" in a || (a.w = "u" in a ? a.u % 7 : "W" in a ? 1 : 0), i = "Z" in a ? lo(ho(a.y, 0, 1)).getUTCDay() : uo(ho(a.y, 0, 1)).getDay(), a.m = 0, a.d = "W" in a ? (a.w + 6) % 7 + 7 * a.W - (i + 5) % 7 : a.w + 7 * a.U - (i + 6) % 7);

              return "Z" in a ? (a.H += a.Z / 100 | 0, a.M += a.Z % 100, lo(a)) : uo(a);
            };
          }

          function T(t, e, n, r) {
            for (var i, a, o = 0, s = e.length, c = n.length; o < s;) {
              if (r >= c) return -1;

              if (37 === (i = e.charCodeAt(o++))) {
                if (i = e.charAt(o++), !(a = x[i in yo ? e.charAt(o++) : i]) || (r = a(t, n, r)) < 0) return -1;
              } else if (i != n.charCodeAt(r++)) return -1;
            }

            return r;
          }

          return b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), _.x = w(n, _), _.X = w(r, _), _.c = w(e, _), {
            format: function format(t) {
              var e = w(t += "", b);
              return e.toString = function () {
                return t;
              }, e;
            },
            parse: function parse(t) {
              var e = k(t += "", !1);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcFormat: function utcFormat(t) {
              var e = w(t += "", _);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcParse: function utcParse(t) {
              var e = k(t += "", !0);
              return e.toString = function () {
                return t;
              }, e;
            }
          };
        }({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        }), po = fo.format, fo.parse, fo.utcFormat, fo.utcParse;
        var zs = Array.prototype.find;

        function qs() {
          return this.firstElementChild;
        }

        var $s = Array.prototype.filter;

        function Hs() {
          return Array.from(this.children);
        }

        function Ws(t) {
          return new Array(t.length);
        }

        function Vs(t, e) {
          this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
        }

        function Gs(t) {
          return function () {
            return t;
          };
        }

        function Xs(t, e, n, r, i, a) {
          for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
            (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new Vs(t, a[s]);
          }

          for (; s < c; ++s) {
            (o = e[s]) && (i[s] = o);
          }
        }

        function Zs(t, e, n, r, i, a, o) {
          var s,
              c,
              u,
              l = new Map(),
              h = e.length,
              f = a.length,
              d = new Array(h);

          for (s = 0; s < h; ++s) {
            (c = e[s]) && (d[s] = u = o.call(c, c.__data__, s, e) + "", l.has(u) ? i[s] = c : l.set(u, c));
          }

          for (s = 0; s < f; ++s) {
            u = o.call(t, a[s], s, a) + "", (c = l.get(u)) ? (r[s] = c, c.__data__ = a[s], l.delete(u)) : n[s] = new Vs(t, a[s]);
          }

          for (s = 0; s < h; ++s) {
            (c = e[s]) && l.get(d[s]) === c && (i[s] = c);
          }
        }

        function Ks(t) {
          return t.__data__;
        }

        function Qs(t) {
          return "object" == typeof t && "length" in t ? t : Array.from(t);
        }

        function Js(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        Vs.prototype = {
          constructor: Vs,
          appendChild: function appendChild(t) {
            return this._parent.insertBefore(t, this._next);
          },
          insertBefore: function insertBefore(t, e) {
            return this._parent.insertBefore(t, e);
          },
          querySelector: function querySelector(t) {
            return this._parent.querySelector(t);
          },
          querySelectorAll: function querySelectorAll(t) {
            return this._parent.querySelectorAll(t);
          }
        };
        var tc = "http://www.w3.org/1999/xhtml";
        var ec = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: tc,
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/"
        };

        function nc(t) {
          var e = t += "",
              n = e.indexOf(":");
          return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), ec.hasOwnProperty(e) ? {
            space: ec[e],
            local: t
          } : t;
        }

        function rc(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function ic(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function ac(t, e) {
          return function () {
            this.setAttribute(t, e);
          };
        }

        function oc(t, e) {
          return function () {
            this.setAttributeNS(t.space, t.local, e);
          };
        }

        function sc(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
          };
        }

        function cc(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
          };
        }

        function uc(t) {
          return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
        }

        function lc(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function hc(t, e, n) {
          return function () {
            this.style.setProperty(t, e, n);
          };
        }

        function fc(t, e, n) {
          return function () {
            var r = e.apply(this, arguments);
            null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
          };
        }

        function dc(t, e) {
          return t.style.getPropertyValue(e) || uc(t).getComputedStyle(t, null).getPropertyValue(e);
        }

        function pc(t) {
          return function () {
            delete this[t];
          };
        }

        function yc(t, e) {
          return function () {
            this[t] = e;
          };
        }

        function gc(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? delete this[t] : this[t] = n;
          };
        }

        function mc(t) {
          return t.trim().split(/^|\s+/);
        }

        function vc(t) {
          return t.classList || new bc(t);
        }

        function bc(t) {
          this._node = t, this._names = mc(t.getAttribute("class") || "");
        }

        function _c(t, e) {
          for (var n = vc(t), r = -1, i = e.length; ++r < i;) {
            n.add(e[r]);
          }
        }

        function xc(t, e) {
          for (var n = vc(t), r = -1, i = e.length; ++r < i;) {
            n.remove(e[r]);
          }
        }

        function wc(t) {
          return function () {
            _c(this, t);
          };
        }

        function kc(t) {
          return function () {
            xc(this, t);
          };
        }

        function Tc(t, e) {
          return function () {
            (e.apply(this, arguments) ? _c : xc)(this, t);
          };
        }

        function Ec() {
          this.textContent = "";
        }

        function Cc(t) {
          return function () {
            this.textContent = t;
          };
        }

        function Sc(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.textContent = null == e ? "" : e;
          };
        }

        function Ac() {
          this.innerHTML = "";
        }

        function Mc(t) {
          return function () {
            this.innerHTML = t;
          };
        }

        function Nc(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.innerHTML = null == e ? "" : e;
          };
        }

        function Dc() {
          this.nextSibling && this.parentNode.appendChild(this);
        }

        function Oc() {
          this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
        }

        function Bc(t) {
          return function () {
            var e = this.ownerDocument,
                n = this.namespaceURI;
            return n === tc && e.documentElement.namespaceURI === tc ? e.createElement(t) : e.createElementNS(n, t);
          };
        }

        function Lc(t) {
          return function () {
            return this.ownerDocument.createElementNS(t.space, t.local);
          };
        }

        function Ic(t) {
          var e = nc(t);
          return (e.local ? Lc : Bc)(e);
        }

        function Rc() {
          return null;
        }

        function Pc() {
          var t = this.parentNode;
          t && t.removeChild(this);
        }

        function Fc() {
          var t = this.cloneNode(!1),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function jc() {
          var t = this.cloneNode(!0),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function Yc(t) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var e = "",
                n = t.indexOf(".");
            return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
              type: t,
              name: e
            };
          });
        }

        function Uc(t) {
          return function () {
            var e = this.__on;

            if (e) {
              for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
                n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
              }

              ++i ? e.length = i : delete this.__on;
            }
          };
        }

        function zc(t, e, n) {
          return function () {
            var r,
                i = this.__on,
                a = function (t) {
              return function (e) {
                t.call(this, e, this.__data__);
              };
            }(e);

            if (i) for (var o = 0, s = i.length; o < s; ++o) {
              if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), void (r.value = e);
            }
            this.addEventListener(t.type, a, n), r = {
              type: t.type,
              name: t.name,
              value: e,
              listener: a,
              options: n
            }, i ? i.push(r) : this.__on = [r];
          };
        }

        function qc(t, e, n) {
          var r = uc(t),
              i = r.CustomEvent;
          "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
        }

        function $c(t, e) {
          return function () {
            return qc(this, t, e);
          };
        }

        function Hc(t, e) {
          return function () {
            return qc(this, t, e.apply(this, arguments));
          };
        }

        bc.prototype = {
          add: function add(t) {
            this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
          },
          remove: function remove(t) {
            var e = this._names.indexOf(t);

            e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
          },
          contains: function contains(t) {
            return this._names.indexOf(t) >= 0;
          }
        };
        var Wc = [null];

        function Vc(t, e) {
          this._groups = t, this._parents = e;
        }

        function Gc() {
          return new Vc([[document.documentElement]], Wc);
        }

        Vc.prototype = Gc.prototype = _defineProperty({
          constructor: Vc,
          select: function select(t) {
            "function" != typeof t && (t = Rs(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
                (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
              }
            }

            return new Vc(r, this._parents);
          },
          selectAll: function selectAll(t) {
            t = "function" == typeof t ? function (t) {
              return function () {
                return Ps(t.apply(this, arguments));
              };
            }(t) : js(t);

            for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
              for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
                (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
              }
            }

            return new Vc(r, i);
          },
          selectChild: function selectChild(t) {
            return this.select(null == t ? qs : function (t) {
              return function () {
                return zs.call(this.children, t);
              };
            }("function" == typeof t ? t : Us(t)));
          },
          selectChildren: function selectChildren(t) {
            return this.selectAll(null == t ? Hs : function (t) {
              return function () {
                return $s.call(this.children, t);
              };
            }("function" == typeof t ? t : Us(t)));
          },
          filter: function filter(t) {
            "function" != typeof t && (t = Ys(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new Vc(r, this._parents);
          },
          data: function data(t, e) {
            if (!arguments.length) return Array.from(this, Ks);
            var n = e ? Zs : Xs,
                r = this._parents,
                i = this._groups;
            "function" != typeof t && (t = Gs(t));

            for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
              var l = r[u],
                  h = i[u],
                  f = h.length,
                  d = Qs(t.call(l, l && l.__data__, u, r)),
                  p = d.length,
                  y = s[u] = new Array(p),
                  g = o[u] = new Array(p),
                  m = c[u] = new Array(f);
              n(l, h, y, g, m, d, e);

              for (var v, b, _ = 0, x = 0; _ < p; ++_) {
                if (v = y[_]) {
                  for (_ >= x && (x = _ + 1); !(b = g[x]) && ++x < p;) {
                    ;
                  }

                  v._next = b || null;
                }
              }
            }

            return (o = new Vc(o, r))._enter = s, o._exit = c, o;
          },
          enter: function enter() {
            return new Vc(this._enter || this._groups.map(Ws), this._parents);
          },
          exit: function exit() {
            return new Vc(this._exit || this._groups.map(Ws), this._parents);
          },
          join: function join(t, e, n) {
            var r = this.enter(),
                i = this,
                a = this.exit();
            return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
          },
          merge: function merge(t) {
            for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c) {
              for (var u, l = n[c], h = r[c], f = l.length, d = s[c] = new Array(f), p = 0; p < f; ++p) {
                (u = l[p] || h[p]) && (d[p] = u);
              }
            }

            for (; c < i; ++c) {
              s[c] = n[c];
            }

            return new Vc(s, this._parents);
          },
          selection: function selection() {
            return this;
          },
          order: function order() {
            for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
              for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
                (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
              }
            }

            return this;
          },
          sort: function sort(t) {
            function e(e, n) {
              return e && n ? t(e.__data__, n.__data__) : !e - !n;
            }

            t || (t = Js);

            for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
              for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
                (o = s[l]) && (u[l] = o);
              }

              u.sort(e);
            }

            return new Vc(i, this._parents).order();
          },
          call: function call() {
            var t = arguments[0];
            return arguments[0] = this, t.apply(null, arguments), this;
          },
          nodes: function nodes() {
            return Array.from(this);
          },
          node: function node() {
            for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
              for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
                var o = r[i];
                if (o) return o;
              }
            }

            return null;
          },
          size: function size() {
            var t = 0;

            var _iterator7 = _createForOfIteratorHelper(this),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _e8 = _step7.value;
                ++t;
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }

            return t;
          },
          empty: function empty() {
            return !this.node();
          },
          each: function each(t) {
            for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
              for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
                (i = a[o]) && t.call(i, i.__data__, o, a);
              }
            }

            return this;
          },
          attr: function attr(t, e) {
            var n = nc(t);

            if (arguments.length < 2) {
              var r = this.node();
              return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
            }

            return this.each((null == e ? n.local ? ic : rc : "function" == typeof e ? n.local ? cc : sc : n.local ? oc : ac)(n, e));
          },
          style: function style(t, e, n) {
            return arguments.length > 1 ? this.each((null == e ? lc : "function" == typeof e ? fc : hc)(t, e, null == n ? "" : n)) : dc(this.node(), t);
          },
          property: function property(t, e) {
            return arguments.length > 1 ? this.each((null == e ? pc : "function" == typeof e ? gc : yc)(t, e)) : this.node()[t];
          },
          classed: function classed(t, e) {
            var n = mc(t + "");

            if (arguments.length < 2) {
              for (var r = vc(this.node()), i = -1, a = n.length; ++i < a;) {
                if (!r.contains(n[i])) return !1;
              }

              return !0;
            }

            return this.each(("function" == typeof e ? Tc : e ? wc : kc)(n, e));
          },
          text: function text(t) {
            return arguments.length ? this.each(null == t ? Ec : ("function" == typeof t ? Sc : Cc)(t)) : this.node().textContent;
          },
          html: function html(t) {
            return arguments.length ? this.each(null == t ? Ac : ("function" == typeof t ? Nc : Mc)(t)) : this.node().innerHTML;
          },
          raise: function raise() {
            return this.each(Dc);
          },
          lower: function lower() {
            return this.each(Oc);
          },
          append: function append(t) {
            var e = "function" == typeof t ? t : Ic(t);
            return this.select(function () {
              return this.appendChild(e.apply(this, arguments));
            });
          },
          insert: function insert(t, e) {
            var n = "function" == typeof t ? t : Ic(t),
                r = null == e ? Rc : "function" == typeof e ? e : Rs(e);
            return this.select(function () {
              return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
            });
          },
          remove: function remove() {
            return this.each(Pc);
          },
          clone: function clone(t) {
            return this.select(t ? jc : Fc);
          },
          datum: function datum(t) {
            return arguments.length ? this.property("__data__", t) : this.node().__data__;
          },
          on: function on(t, e, n) {
            var r,
                i,
                a = Yc(t + ""),
                o = a.length;

            if (!(arguments.length < 2)) {
              for (s = e ? zc : Uc, r = 0; r < o; ++r) {
                this.each(s(a[r], e, n));
              }

              return this;
            }

            var s = this.node().__on;

            if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
              for (r = 0, c = s[u]; r < o; ++r) {
                if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
              }
            }
          },
          dispatch: function dispatch(t, e) {
            return this.each(("function" == typeof e ? Hc : $c)(t, e));
          }
        }, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var t, e, n, r, i, a, o;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  t = this._groups, e = 0, n = t.length;

                case 1:
                  if (!(e < n)) {
                    _context2.next = 14;
                    break;
                  }

                  i = t[e], a = 0, o = i.length;

                case 3:
                  if (!(a < o)) {
                    _context2.next = 11;
                    break;
                  }

                  _context2.t0 = r = i[a];

                  if (!_context2.t0) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 8;
                  return r;

                case 8:
                  ++a;
                  _context2.next = 3;
                  break;

                case 11:
                  ++e;
                  _context2.next = 1;
                  break;

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
        var Xc = Gc;

        function Zc(t) {
          return "string" == typeof t ? new Vc([[document.querySelector(t)]], [document.documentElement]) : new Vc([[t]], Wc);
        }

        function Kc(t) {
          return "string" == typeof t ? new Vc([document.querySelectorAll(t)], [document.documentElement]) : new Vc([Ps(t)], Wc);
        }

        var Qc = Math.PI,
            Jc = 2 * Qc,
            tu = 1e-6,
            eu = Jc - tu;

        function nu() {
          this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
        }

        function ru() {
          return new nu();
        }

        nu.prototype = ru.prototype = {
          constructor: nu,
          moveTo: function moveTo(t, e) {
            this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
          },
          closePath: function closePath() {
            null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
          },
          lineTo: function lineTo(t, e) {
            this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
          },
          quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
            this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
          },
          bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
            this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
          },
          arcTo: function arcTo(t, e, n, r, i) {
            t = +t, e = +e, n = +n, r = +r, i = +i;
            var a = this._x1,
                o = this._y1,
                s = n - t,
                c = r - e,
                u = a - t,
                l = o - e,
                h = u * u + l * l;
            if (i < 0) throw new Error("negative radius: " + i);
            if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);else if (h > tu) if (Math.abs(l * s - c * u) > tu && i) {
              var f = n - a,
                  d = r - o,
                  p = s * s + c * c,
                  y = f * f + d * d,
                  g = Math.sqrt(p),
                  m = Math.sqrt(h),
                  v = i * Math.tan((Qc - Math.acos((p + h - y) / (2 * g * m))) / 2),
                  b = v / m,
                  _ = v / g;

              Math.abs(b - 1) > tu && (this._ += "L" + (t + b * u) + "," + (e + b * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * f > u * d) + "," + (this._x1 = t + _ * s) + "," + (this._y1 = e + _ * c);
            } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
          },
          arc: function arc(t, e, n, r, i, a) {
            t = +t, e = +e, a = !!a;
            var o = (n = +n) * Math.cos(r),
                s = n * Math.sin(r),
                c = t + o,
                u = e + s,
                l = 1 ^ a,
                h = a ? r - i : i - r;
            if (n < 0) throw new Error("negative radius: " + n);
            null === this._x1 ? this._ += "M" + c + "," + u : (Math.abs(this._x1 - c) > tu || Math.abs(this._y1 - u) > tu) && (this._ += "L" + c + "," + u), n && (h < 0 && (h = h % Jc + Jc), h > eu ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = c) + "," + (this._y1 = u) : h > tu && (this._ += "A" + n + "," + n + ",0," + +(h >= Qc) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
          },
          rect: function rect(t, e, n, r) {
            this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
          },
          toString: function toString() {
            return this._;
          }
        };
        var iu = ru;

        function au(t) {
          return function () {
            return t;
          };
        }

        var ou = Math.abs,
            su = Math.atan2,
            cu = Math.cos,
            uu = Math.max,
            lu = Math.min,
            hu = Math.sin,
            fu = Math.sqrt,
            du = 1e-12,
            pu = Math.PI,
            yu = pu / 2,
            gu = 2 * pu;

        function mu(t) {
          return t > 1 ? 0 : t < -1 ? pu : Math.acos(t);
        }

        function vu(t) {
          return t >= 1 ? yu : t <= -1 ? -yu : Math.asin(t);
        }

        function bu(t) {
          return t.innerRadius;
        }

        function _u(t) {
          return t.outerRadius;
        }

        function xu(t) {
          return t.startAngle;
        }

        function wu(t) {
          return t.endAngle;
        }

        function ku(t) {
          return t && t.padAngle;
        }

        function Tu(t, e, n, r, i, a, o, s) {
          var c = n - t,
              u = r - e,
              l = o - i,
              h = s - a,
              f = h * c - l * u;
          if (!(f * f < du)) return [t + (f = (l * (e - a) - h * (t - i)) / f) * c, e + f * u];
        }

        function Eu(t, e, n, r, i, a, o) {
          var s = t - n,
              c = e - r,
              u = (o ? a : -a) / fu(s * s + c * c),
              l = u * c,
              h = -u * s,
              f = t + l,
              d = e + h,
              p = n + l,
              y = r + h,
              g = (f + p) / 2,
              m = (d + y) / 2,
              v = p - f,
              b = y - d,
              _ = v * v + b * b,
              x = i - a,
              w = f * y - p * d,
              k = (b < 0 ? -1 : 1) * fu(uu(0, x * x * _ - w * w)),
              T = (w * b - v * k) / _,
              E = (-w * v - b * k) / _,
              C = (w * b + v * k) / _,
              S = (-w * v + b * k) / _,
              A = T - g,
              M = E - m,
              N = C - g,
              D = S - m;

          return A * A + M * M > N * N + D * D && (T = C, E = S), {
            cx: T,
            cy: E,
            x01: -l,
            y01: -h,
            x11: T * (i / x - 1),
            y11: E * (i / x - 1)
          };
        }

        function Cu() {
          var t = bu,
              e = _u,
              n = au(0),
              r = null,
              i = xu,
              a = wu,
              o = ku,
              s = null;

          function c() {
            var c,
                u,
                l = +t.apply(this, arguments),
                h = +e.apply(this, arguments),
                f = i.apply(this, arguments) - yu,
                d = a.apply(this, arguments) - yu,
                p = ou(d - f),
                y = d > f;
            if (s || (s = c = iu()), h < l && (u = h, h = l, l = u), h > du) {
              if (p > gu - du) s.moveTo(h * cu(f), h * hu(f)), s.arc(0, 0, h, f, d, !y), l > du && (s.moveTo(l * cu(d), l * hu(d)), s.arc(0, 0, l, d, f, y));else {
                var g,
                    m,
                    v = f,
                    b = d,
                    _ = f,
                    x = d,
                    w = p,
                    k = p,
                    T = o.apply(this, arguments) / 2,
                    E = T > du && (r ? +r.apply(this, arguments) : fu(l * l + h * h)),
                    C = lu(ou(h - l) / 2, +n.apply(this, arguments)),
                    S = C,
                    A = C;

                if (E > du) {
                  var M = vu(E / l * hu(T)),
                      N = vu(E / h * hu(T));
                  (w -= 2 * M) > du ? (_ += M *= y ? 1 : -1, x -= M) : (w = 0, _ = x = (f + d) / 2), (k -= 2 * N) > du ? (v += N *= y ? 1 : -1, b -= N) : (k = 0, v = b = (f + d) / 2);
                }

                var D = h * cu(v),
                    O = h * hu(v),
                    B = l * cu(x),
                    L = l * hu(x);

                if (C > du) {
                  var I,
                      R = h * cu(b),
                      P = h * hu(b),
                      F = l * cu(_),
                      j = l * hu(_);

                  if (p < pu && (I = Tu(D, O, F, j, R, P, B, L))) {
                    var Y = D - I[0],
                        U = O - I[1],
                        z = R - I[0],
                        q = P - I[1],
                        $ = 1 / hu(mu((Y * z + U * q) / (fu(Y * Y + U * U) * fu(z * z + q * q))) / 2),
                        H = fu(I[0] * I[0] + I[1] * I[1]);
                    S = lu(C, (l - H) / ($ - 1)), A = lu(C, (h - H) / ($ + 1));
                  }
                }

                k > du ? A > du ? (g = Eu(F, j, D, O, h, A, y), m = Eu(R, P, B, L, h, A, y), s.moveTo(g.cx + g.x01, g.cy + g.y01), A < C ? s.arc(g.cx, g.cy, A, su(g.y01, g.x01), su(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, A, su(g.y01, g.x01), su(g.y11, g.x11), !y), s.arc(0, 0, h, su(g.cy + g.y11, g.cx + g.x11), su(m.cy + m.y11, m.cx + m.x11), !y), s.arc(m.cx, m.cy, A, su(m.y11, m.x11), su(m.y01, m.x01), !y))) : (s.moveTo(D, O), s.arc(0, 0, h, v, b, !y)) : s.moveTo(D, O), l > du && w > du ? S > du ? (g = Eu(B, L, R, P, l, -S, y), m = Eu(D, O, F, j, l, -S, y), s.lineTo(g.cx + g.x01, g.cy + g.y01), S < C ? s.arc(g.cx, g.cy, S, su(g.y01, g.x01), su(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, S, su(g.y01, g.x01), su(g.y11, g.x11), !y), s.arc(0, 0, l, su(g.cy + g.y11, g.cx + g.x11), su(m.cy + m.y11, m.cx + m.x11), y), s.arc(m.cx, m.cy, S, su(m.y11, m.x11), su(m.y01, m.x01), !y))) : s.arc(0, 0, l, x, _, y) : s.lineTo(B, L);
              }
            } else s.moveTo(0, 0);
            if (s.closePath(), c) return s = null, c + "" || null;
          }

          return c.centroid = function () {
            var n = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2,
                r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - pu / 2;
            return [cu(r) * n, hu(r) * n];
          }, c.innerRadius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : au(+e), c) : t;
          }, c.outerRadius = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : au(+t), c) : e;
          }, c.cornerRadius = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : au(+t), c) : n;
          }, c.padRadius = function (t) {
            return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : au(+t), c) : r;
          }, c.startAngle = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : au(+t), c) : i;
          }, c.endAngle = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : au(+t), c) : a;
          }, c.padAngle = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : au(+t), c) : o;
          }, c.context = function (t) {
            return arguments.length ? (s = null == t ? null : t, c) : s;
          }, c;
        }

        function Su(t) {
          return "object" == typeof t && "length" in t ? t : Array.from(t);
        }

        function Au(t) {
          this._context = t;
        }

        function Mu(t) {
          return new Au(t);
        }

        function Nu(t) {
          return t[0];
        }

        function Du(t) {
          return t[1];
        }

        function Ou(t, e) {
          var n = au(!0),
              r = null,
              i = Mu,
              a = null;

          function o(o) {
            var s,
                c,
                u,
                l = (o = Su(o)).length,
                h = !1;

            for (null == r && (a = i(u = iu())), s = 0; s <= l; ++s) {
              !(s < l && n(c = o[s], s, o)) === h && ((h = !h) ? a.lineStart() : a.lineEnd()), h && a.point(+t(c, s, o), +e(c, s, o));
            }

            if (u) return a = null, u + "" || null;
          }

          return t = "function" == typeof t ? t : void 0 === t ? Nu : au(t), e = "function" == typeof e ? e : void 0 === e ? Du : au(e), o.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : au(+e), o) : t;
          }, o.y = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : au(+t), o) : e;
          }, o.defined = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : au(!!t), o) : n;
          }, o.curve = function (t) {
            return arguments.length ? (i = t, null != r && (a = i(r)), o) : i;
          }, o.context = function (t) {
            return arguments.length ? (null == t ? r = a = null : a = i(r = t), o) : r;
          }, o;
        }

        function Bu(t, e) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }

        function Lu(t) {
          return t;
        }

        function Iu() {}

        function Ru(t, e, n) {
          t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + n) / 6);
        }

        function Pu(t) {
          this._context = t;
        }

        function Fu(t) {
          return new Pu(t);
        }

        function ju(t) {
          this._context = t;
        }

        function Yu(t) {
          this._context = t;
        }

        function Uu(t) {
          this._context = t;
        }

        function zu(t) {
          return t < 0 ? -1 : 1;
        }

        function qu(t, e, n) {
          var r = t._x1 - t._x0,
              i = e - t._x1,
              a = (t._y1 - t._y0) / (r || i < 0 && -0),
              o = (n - t._y1) / (i || r < 0 && -0),
              s = (a * i + o * r) / (r + i);
          return (zu(a) + zu(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
        }

        function $u(t, e) {
          var n = t._x1 - t._x0;
          return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
        }

        function Hu(t, e, n) {
          var r = t._x0,
              i = t._y0,
              a = t._x1,
              o = t._y1,
              s = (a - r) / 3;

          t._context.bezierCurveTo(r + s, i + s * e, a - s, o - s * n, a, o);
        }

        function Wu(t) {
          this._context = t;
        }

        function Vu(t) {
          this._context = new Gu(t);
        }

        function Gu(t) {
          this._context = t;
        }

        function Xu(t) {
          this._context = t;
        }

        function Zu(t) {
          var e,
              n,
              r = t.length - 1,
              i = new Array(r),
              a = new Array(r),
              o = new Array(r);

          for (i[0] = 0, a[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) {
            i[e] = 1, a[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
          }

          for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) {
            n = i[e] / a[e - 1], a[e] -= n, o[e] -= n * o[e - 1];
          }

          for (i[r - 1] = o[r - 1] / a[r - 1], e = r - 2; e >= 0; --e) {
            i[e] = (o[e] - i[e + 1]) / a[e];
          }

          for (a[r - 1] = (t[r] + i[r - 1]) / 2, e = 0; e < r - 1; ++e) {
            a[e] = 2 * t[e + 1] - i[e + 1];
          }

          return [i, a];
        }

        function Ku(t, e) {
          this._context = t, this._t = e;
        }

        Array.prototype.slice, Au.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;

              default:
                this._context.lineTo(t, e);

            }
          }
        }, Pu.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 3:
                Ru(this, this._x1, this._y1);

              case 2:
                this._context.lineTo(this._x1, this._y1);

            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

              default:
                Ru(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, ju.prototype = {
          areaStart: Iu,
          areaEnd: Iu,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x2, this._y2), this._context.closePath();
                break;

              case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
                break;

              case 3:
                this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
            }
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._x2 = t, this._y2 = e;
                break;

              case 1:
                this._point = 2, this._x3 = t, this._y3 = e;
                break;

              case 2:
                this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
                break;

              default:
                Ru(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, Yu.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3;
                var n = (this._x0 + 4 * this._x1 + t) / 6,
                    r = (this._y0 + 4 * this._y1 + e) / 6;
                this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
                break;

              case 3:
                this._point = 4;

              default:
                Ru(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, Uu.prototype = {
          areaStart: Iu,
          areaEnd: Iu,
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            this._point && this._context.closePath();
          },
          point: function point(t, e) {
            t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
          }
        }, Wu.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x1, this._y1);

                break;

              case 3:
                Hu(this, this._t0, $u(this, this._t0));
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            var n = NaN;

            if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
              switch (this._point) {
                case 0:
                  this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                  break;

                case 1:
                  this._point = 2;
                  break;

                case 2:
                  this._point = 3, Hu(this, $u(this, n = qu(this, t, e)), n);
                  break;

                default:
                  Hu(this, this._t0, n = qu(this, t, e));
              }

              this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
            }
          }
        }, (Vu.prototype = Object.create(Wu.prototype)).point = function (t, e) {
          Wu.prototype.point.call(this, e, t);
        }, Gu.prototype = {
          moveTo: function moveTo(t, e) {
            this._context.moveTo(e, t);
          },
          closePath: function closePath() {
            this._context.closePath();
          },
          lineTo: function lineTo(t, e) {
            this._context.lineTo(e, t);
          },
          bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
            this._context.bezierCurveTo(e, t, r, n, a, i);
          }
        }, Xu.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x = [], this._y = [];
          },
          lineEnd: function lineEnd() {
            var t = this._x,
                e = this._y,
                n = t.length;
            if (n) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === n) this._context.lineTo(t[1], e[1]);else for (var r = Zu(t), i = Zu(e), a = 0, o = 1; o < n; ++a, ++o) {
              this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], t[o], e[o]);
            }
            (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
          },
          point: function point(t, e) {
            this._x.push(+t), this._y.push(+e);
          }
        }, Ku.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x = this._y = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;

              default:
                if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
                  var n = this._x * (1 - this._t) + t * this._t;
                  this._context.lineTo(n, this._y), this._context.lineTo(n, e);
                }
            }

            this._x = t, this._y = e;
          }
        };
        var Qu = new Date(),
            Ju = new Date();

        function tl(t, e, n, r) {
          function i(e) {
            return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
          }

          return i.floor = function (e) {
            return t(e = new Date(+e)), e;
          }, i.ceil = function (n) {
            return t(n = new Date(n - 1)), e(n, 1), t(n), n;
          }, i.round = function (t) {
            var e = i(t),
                n = i.ceil(t);
            return t - e < n - t ? e : n;
          }, i.offset = function (t, n) {
            return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
          }, i.range = function (n, r, a) {
            var o,
                s = [];
            if (n = i.ceil(n), a = null == a ? 1 : Math.floor(a), !(n < r && a > 0)) return s;

            do {
              s.push(o = new Date(+n)), e(n, a), t(n);
            } while (o < n && n < r);

            return s;
          }, i.filter = function (n) {
            return tl(function (e) {
              if (e >= e) for (; t(e), !n(e);) {
                e.setTime(e - 1);
              }
            }, function (t, r) {
              if (t >= t) if (r < 0) for (; ++r <= 0;) {
                for (; e(t, -1), !n(t);) {
                  ;
                }
              } else for (; --r >= 0;) {
                for (; e(t, 1), !n(t);) {
                  ;
                }
              }
            });
          }, n && (i.count = function (e, r) {
            return Qu.setTime(+e), Ju.setTime(+r), t(Qu), t(Ju), Math.floor(n(Qu, Ju));
          }, i.every = function (t) {
            return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
              return r(e) % t == 0;
            } : function (e) {
              return i.count(0, e) % t == 0;
            }) : i : null;
          }), i;
        }

        var el = 6048e5;

        function nl(t) {
          return tl(function (e) {
            e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setUTCDate(t.getUTCDate() + 7 * e);
          }, function (t, e) {
            return (e - t) / el;
          });
        }

        var rl = nl(0),
            il = nl(1),
            al = nl(2),
            ol = nl(3),
            sl = nl(4),
            cl = nl(5),
            ul = nl(6),
            ll = (rl.range, il.range, al.range, ol.range, sl.range, cl.range, ul.range, tl(function (t) {
          t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCDate(t.getUTCDate() + e);
        }, function (t, e) {
          return (e - t) / 864e5;
        }, function (t) {
          return t.getUTCDate() - 1;
        }));
        var hl = ll;

        function fl(t) {
          return tl(function (e) {
            e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setDate(t.getDate() + 7 * e);
          }, function (t, e) {
            return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / el;
          });
        }

        ll.range;

        var dl = fl(0),
            pl = fl(1),
            yl = fl(2),
            gl = fl(3),
            ml = fl(4),
            vl = fl(5),
            bl = fl(6),
            _l = (dl.range, pl.range, yl.range, gl.range, ml.range, vl.range, bl.range, tl(function (t) {
          return t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          return t.setDate(t.getDate() + e);
        }, function (t, e) {
          return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 864e5;
        }, function (t) {
          return t.getDate() - 1;
        }));

        var xl = _l;
        _l.range;
        var wl = tl(function (t) {
          t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setFullYear(t.getFullYear() + e);
        }, function (t, e) {
          return e.getFullYear() - t.getFullYear();
        }, function (t) {
          return t.getFullYear();
        });

        wl.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? tl(function (e) {
            e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
          }, function (e, n) {
            e.setFullYear(e.getFullYear() + n * t);
          }) : null;
        };

        var kl = wl;
        wl.range;
        var Tl = tl(function (t) {
          t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCFullYear(t.getUTCFullYear() + e);
        }, function (t, e) {
          return e.getUTCFullYear() - t.getUTCFullYear();
        }, function (t) {
          return t.getUTCFullYear();
        });

        Tl.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? tl(function (e) {
            e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
          }, function (e, n) {
            e.setUTCFullYear(e.getUTCFullYear() + n * t);
          }) : null;
        };

        var El = Tl;

        function Cl(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
            return e.setFullYear(t.y), e;
          }

          return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
        }

        function Sl(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
            return e.setUTCFullYear(t.y), e;
          }

          return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
        }

        function Al(t, e, n) {
          return {
            y: t,
            m: e,
            d: n,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }

        Tl.range;
        var Ml,
            Nl,
            Dl = {
          "-": "",
          _: " ",
          0: "0"
        },
            Ol = /^\s*\d+/,
            Bl = /^%/,
            Ll = /[\\^$*+?|[\]().{}]/g;

        function Il(t, e, n) {
          var r = t < 0 ? "-" : "",
              i = (r ? -t : t) + "",
              a = i.length;
          return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
        }

        function Rl(t) {
          return t.replace(Ll, "\\$&");
        }

        function Pl(t) {
          return new RegExp("^(?:" + t.map(Rl).join("|") + ")", "i");
        }

        function Fl(t) {
          return new Map(t.map(function (t, e) {
            return [t.toLowerCase(), e];
          }));
        }

        function jl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 1));
          return r ? (t.w = +r[0], n + r[0].length) : -1;
        }

        function Yl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 1));
          return r ? (t.u = +r[0], n + r[0].length) : -1;
        }

        function Ul(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.U = +r[0], n + r[0].length) : -1;
        }

        function zl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.V = +r[0], n + r[0].length) : -1;
        }

        function ql(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.W = +r[0], n + r[0].length) : -1;
        }

        function $l(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 4));
          return r ? (t.y = +r[0], n + r[0].length) : -1;
        }

        function Hl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
        }

        function Wl(t, e, n) {
          var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
          return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
        }

        function Vl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 1));
          return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
        }

        function Gl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
        }

        function Xl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.d = +r[0], n + r[0].length) : -1;
        }

        function Zl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 3));
          return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
        }

        function Kl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.H = +r[0], n + r[0].length) : -1;
        }

        function Ql(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.M = +r[0], n + r[0].length) : -1;
        }

        function Jl(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 2));
          return r ? (t.S = +r[0], n + r[0].length) : -1;
        }

        function th(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 3));
          return r ? (t.L = +r[0], n + r[0].length) : -1;
        }

        function eh(t, e, n) {
          var r = Ol.exec(e.slice(n, n + 6));
          return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
        }

        function nh(t, e, n) {
          var r = Bl.exec(e.slice(n, n + 1));
          return r ? n + r[0].length : -1;
        }

        function rh(t, e, n) {
          var r = Ol.exec(e.slice(n));
          return r ? (t.Q = +r[0], n + r[0].length) : -1;
        }

        function ih(t, e, n) {
          var r = Ol.exec(e.slice(n));
          return r ? (t.s = +r[0], n + r[0].length) : -1;
        }

        function ah(t, e) {
          return Il(t.getDate(), e, 2);
        }

        function oh(t, e) {
          return Il(t.getHours(), e, 2);
        }

        function sh(t, e) {
          return Il(t.getHours() % 12 || 12, e, 2);
        }

        function ch(t, e) {
          return Il(1 + xl.count(kl(t), t), e, 3);
        }

        function uh(t, e) {
          return Il(t.getMilliseconds(), e, 3);
        }

        function lh(t, e) {
          return uh(t, e) + "000";
        }

        function hh(t, e) {
          return Il(t.getMonth() + 1, e, 2);
        }

        function fh(t, e) {
          return Il(t.getMinutes(), e, 2);
        }

        function dh(t, e) {
          return Il(t.getSeconds(), e, 2);
        }

        function ph(t) {
          var e = t.getDay();
          return 0 === e ? 7 : e;
        }

        function yh(t, e) {
          return Il(dl.count(kl(t) - 1, t), e, 2);
        }

        function gh(t) {
          var e = t.getDay();
          return e >= 4 || 0 === e ? ml(t) : ml.ceil(t);
        }

        function mh(t, e) {
          return t = gh(t), Il(ml.count(kl(t), t) + (4 === kl(t).getDay()), e, 2);
        }

        function vh(t) {
          return t.getDay();
        }

        function bh(t, e) {
          return Il(pl.count(kl(t) - 1, t), e, 2);
        }

        function _h(t, e) {
          return Il(t.getFullYear() % 100, e, 2);
        }

        function xh(t, e) {
          return Il((t = gh(t)).getFullYear() % 100, e, 2);
        }

        function wh(t, e) {
          return Il(t.getFullYear() % 1e4, e, 4);
        }

        function kh(t, e) {
          var n = t.getDay();
          return Il((t = n >= 4 || 0 === n ? ml(t) : ml.ceil(t)).getFullYear() % 1e4, e, 4);
        }

        function Th(t) {
          var e = t.getTimezoneOffset();
          return (e > 0 ? "-" : (e *= -1, "+")) + Il(e / 60 | 0, "0", 2) + Il(e % 60, "0", 2);
        }

        function Eh(t, e) {
          return Il(t.getUTCDate(), e, 2);
        }

        function Ch(t, e) {
          return Il(t.getUTCHours(), e, 2);
        }

        function Sh(t, e) {
          return Il(t.getUTCHours() % 12 || 12, e, 2);
        }

        function Ah(t, e) {
          return Il(1 + hl.count(El(t), t), e, 3);
        }

        function Mh(t, e) {
          return Il(t.getUTCMilliseconds(), e, 3);
        }

        function Nh(t, e) {
          return Mh(t, e) + "000";
        }

        function Dh(t, e) {
          return Il(t.getUTCMonth() + 1, e, 2);
        }

        function Oh(t, e) {
          return Il(t.getUTCMinutes(), e, 2);
        }

        function Bh(t, e) {
          return Il(t.getUTCSeconds(), e, 2);
        }

        function Lh(t) {
          var e = t.getUTCDay();
          return 0 === e ? 7 : e;
        }

        function Ih(t, e) {
          return Il(rl.count(El(t) - 1, t), e, 2);
        }

        function Rh(t) {
          var e = t.getUTCDay();
          return e >= 4 || 0 === e ? sl(t) : sl.ceil(t);
        }

        function Ph(t, e) {
          return t = Rh(t), Il(sl.count(El(t), t) + (4 === El(t).getUTCDay()), e, 2);
        }

        function Fh(t) {
          return t.getUTCDay();
        }

        function jh(t, e) {
          return Il(il.count(El(t) - 1, t), e, 2);
        }

        function Yh(t, e) {
          return Il(t.getUTCFullYear() % 100, e, 2);
        }

        function Uh(t, e) {
          return Il((t = Rh(t)).getUTCFullYear() % 100, e, 2);
        }

        function zh(t, e) {
          return Il(t.getUTCFullYear() % 1e4, e, 4);
        }

        function qh(t, e) {
          var n = t.getUTCDay();
          return Il((t = n >= 4 || 0 === n ? sl(t) : sl.ceil(t)).getUTCFullYear() % 1e4, e, 4);
        }

        function $h() {
          return "+0000";
        }

        function Hh() {
          return "%";
        }

        function Wh(t) {
          return +t;
        }

        function Vh(t) {
          return Math.floor(+t / 1e3);
        }

        Ml = function (t) {
          var e = t.dateTime,
              n = t.date,
              r = t.time,
              i = t.periods,
              a = t.days,
              o = t.shortDays,
              s = t.months,
              c = t.shortMonths,
              u = Pl(i),
              l = Fl(i),
              h = Pl(a),
              f = Fl(a),
              d = Pl(o),
              p = Fl(o),
              y = Pl(s),
              g = Fl(s),
              m = Pl(c),
              v = Fl(c),
              b = {
            a: function a(t) {
              return o[t.getDay()];
            },
            A: function A(t) {
              return a[t.getDay()];
            },
            b: function b(t) {
              return c[t.getMonth()];
            },
            B: function B(t) {
              return s[t.getMonth()];
            },
            c: null,
            d: ah,
            e: ah,
            f: lh,
            g: xh,
            G: kh,
            H: oh,
            I: sh,
            j: ch,
            L: uh,
            m: hh,
            M: fh,
            p: function p(t) {
              return i[+(t.getHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getMonth() / 3);
            },
            Q: Wh,
            s: Vh,
            S: dh,
            u: ph,
            U: yh,
            V: mh,
            w: vh,
            W: bh,
            x: null,
            X: null,
            y: _h,
            Y: wh,
            Z: Th,
            "%": Hh
          },
              _ = {
            a: function a(t) {
              return o[t.getUTCDay()];
            },
            A: function A(t) {
              return a[t.getUTCDay()];
            },
            b: function b(t) {
              return c[t.getUTCMonth()];
            },
            B: function B(t) {
              return s[t.getUTCMonth()];
            },
            c: null,
            d: Eh,
            e: Eh,
            f: Nh,
            g: Uh,
            G: qh,
            H: Ch,
            I: Sh,
            j: Ah,
            L: Mh,
            m: Dh,
            M: Oh,
            p: function p(t) {
              return i[+(t.getUTCHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getUTCMonth() / 3);
            },
            Q: Wh,
            s: Vh,
            S: Bh,
            u: Lh,
            U: Ih,
            V: Ph,
            w: Fh,
            W: jh,
            x: null,
            X: null,
            y: Yh,
            Y: zh,
            Z: $h,
            "%": Hh
          },
              x = {
            a: function a(t, e, n) {
              var r = d.exec(e.slice(n));
              return r ? (t.w = p.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            A: function A(t, e, n) {
              var r = h.exec(e.slice(n));
              return r ? (t.w = f.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            b: function b(t, e, n) {
              var r = m.exec(e.slice(n));
              return r ? (t.m = v.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            B: function B(t, e, n) {
              var r = y.exec(e.slice(n));
              return r ? (t.m = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            c: function c(t, n, r) {
              return T(t, e, n, r);
            },
            d: Xl,
            e: Xl,
            f: eh,
            g: Hl,
            G: $l,
            H: Kl,
            I: Kl,
            j: Zl,
            L: th,
            m: Gl,
            M: Ql,
            p: function p(t, e, n) {
              var r = u.exec(e.slice(n));
              return r ? (t.p = l.get(r[0].toLowerCase()), n + r[0].length) : -1;
            },
            q: Vl,
            Q: rh,
            s: ih,
            S: Jl,
            u: Yl,
            U: Ul,
            V: zl,
            w: jl,
            W: ql,
            x: function x(t, e, r) {
              return T(t, n, e, r);
            },
            X: function X(t, e, n) {
              return T(t, r, e, n);
            },
            y: Hl,
            Y: $l,
            Z: Wl,
            "%": nh
          };

          function w(t, e) {
            return function (n) {
              var r,
                  i,
                  a,
                  o = [],
                  s = -1,
                  c = 0,
                  u = t.length;

              for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
                37 === t.charCodeAt(s) && (o.push(t.slice(c, s)), null != (i = Dl[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (a = e[r]) && (r = a(n, i)), o.push(r), c = s + 1);
              }

              return o.push(t.slice(c, s)), o.join("");
            };
          }

          function k(t, e) {
            return function (n) {
              var r,
                  i,
                  a = Al(1900, void 0, 1);
              if (T(a, t, n += "", 0) != n.length) return null;
              if ("Q" in a) return new Date(a.Q);
              if ("s" in a) return new Date(1e3 * a.s + ("L" in a ? a.L : 0));

              if (e && !("Z" in a) && (a.Z = 0), "p" in a && (a.H = a.H % 12 + 12 * a.p), void 0 === a.m && (a.m = "q" in a ? a.q : 0), "V" in a) {
                if (a.V < 1 || a.V > 53) return null;
                "w" in a || (a.w = 1), "Z" in a ? (i = (r = Sl(Al(a.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? il.ceil(r) : il(r), r = hl.offset(r, 7 * (a.V - 1)), a.y = r.getUTCFullYear(), a.m = r.getUTCMonth(), a.d = r.getUTCDate() + (a.w + 6) % 7) : (i = (r = Cl(Al(a.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? pl.ceil(r) : pl(r), r = xl.offset(r, 7 * (a.V - 1)), a.y = r.getFullYear(), a.m = r.getMonth(), a.d = r.getDate() + (a.w + 6) % 7);
              } else ("W" in a || "U" in a) && ("w" in a || (a.w = "u" in a ? a.u % 7 : "W" in a ? 1 : 0), i = "Z" in a ? Sl(Al(a.y, 0, 1)).getUTCDay() : Cl(Al(a.y, 0, 1)).getDay(), a.m = 0, a.d = "W" in a ? (a.w + 6) % 7 + 7 * a.W - (i + 5) % 7 : a.w + 7 * a.U - (i + 6) % 7);

              return "Z" in a ? (a.H += a.Z / 100 | 0, a.M += a.Z % 100, Sl(a)) : Cl(a);
            };
          }

          function T(t, e, n, r) {
            for (var i, a, o = 0, s = e.length, c = n.length; o < s;) {
              if (r >= c) return -1;

              if (37 === (i = e.charCodeAt(o++))) {
                if (i = e.charAt(o++), !(a = x[i in Dl ? e.charAt(o++) : i]) || (r = a(t, n, r)) < 0) return -1;
              } else if (i != n.charCodeAt(r++)) return -1;
            }

            return r;
          }

          return b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), _.x = w(n, _), _.X = w(r, _), _.c = w(e, _), {
            format: function format(t) {
              var e = w(t += "", b);
              return e.toString = function () {
                return t;
              }, e;
            },
            parse: function parse(t) {
              var e = k(t += "", !1);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcFormat: function utcFormat(t) {
              var e = w(t += "", _);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcParse: function utcParse(t) {
              var e = k(t += "", !0);
              return e.toString = function () {
                return t;
              }, e;
            }
          };
        }({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        }), Nl = Ml.format, Ml.parse, Ml.utcFormat, Ml.utcParse;
        var Gh = {
          value: function value() {}
        };

        function Xh() {
          for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
            if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            r[t] = [];
          }

          return new Zh(r);
        }

        function Zh(t) {
          this._ = t;
        }

        function Kh(t, e) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var n = "",
                r = t.indexOf(".");
            if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
              type: t,
              name: n
            };
          });
        }

        function Qh(t, e) {
          for (var n, r = 0, i = t.length; r < i; ++r) {
            if ((n = t[r]).name === e) return n.value;
          }
        }

        function Jh(t, e, n) {
          for (var r = 0, i = t.length; r < i; ++r) {
            if (t[r].name === e) {
              t[r] = Gh, t = t.slice(0, r).concat(t.slice(r + 1));
              break;
            }
          }

          return null != n && t.push({
            name: e,
            value: n
          }), t;
        }

        Zh.prototype = Xh.prototype = {
          constructor: Zh,
          on: function on(t, e) {
            var n,
                r = this._,
                i = Kh(t + "", r),
                a = -1,
                o = i.length;

            if (!(arguments.length < 2)) {
              if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

              for (; ++a < o;) {
                if (n = (t = i[a]).type) r[n] = Jh(r[n], t.name, e);else if (null == e) for (n in r) {
                  r[n] = Jh(r[n], t.name, null);
                }
              }

              return this;
            }

            for (; ++a < o;) {
              if ((n = (t = i[a]).type) && (n = Qh(r[n], t.name))) return n;
            }
          },
          copy: function copy() {
            var t = {},
                e = this._;

            for (var n in e) {
              t[n] = e[n].slice();
            }

            return new Zh(t);
          },
          call: function call(t, e) {
            if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
              i[a] = arguments[a + 2];
            }
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
              r[a].value.apply(e, i);
            }
          },
          apply: function apply(t, e, n) {
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
              r[i].value.apply(e, n);
            }
          }
        };
        var tf = Xh;
        var ef,
            nf,
            rf = 0,
            af = 0,
            of = 0,
            sf = 0,
            cf = 0,
            uf = 0,
            lf = "object" == typeof performance && performance.now ? performance : Date,
            hf = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
          setTimeout(t, 17);
        };

        function ff() {
          return cf || (hf(df), cf = lf.now() + uf);
        }

        function df() {
          cf = 0;
        }

        function pf() {
          this._call = this._time = this._next = null;
        }

        function yf(t, e, n) {
          var r = new pf();
          return r.restart(t, e, n), r;
        }

        function gf() {
          cf = (sf = lf.now()) + uf, rf = af = 0;

          try {
            !function () {
              ff(), ++rf;

              for (var t, e = ef; e;) {
                (t = cf - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
              }

              --rf;
            }();
          } finally {
            rf = 0, function () {
              for (var t, e, n = ef, r = 1 / 0; n;) {
                n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : ef = e);
              }

              nf = t, vf(r);
            }(), cf = 0;
          }
        }

        function mf() {
          var t = lf.now(),
              e = t - sf;
          e > 1e3 && (uf -= e, sf = t);
        }

        function vf(t) {
          rf || (af && (af = clearTimeout(af)), t - cf > 24 ? (t < 1 / 0 && (af = setTimeout(gf, t - lf.now() - uf)), of && (of = clearInterval(of))) : (of || (sf = lf.now(), of = setInterval(mf, 1e3)), rf = 1, hf(gf)));
        }

        function bf(t, e, n) {
          var r = new pf();
          return e = null == e ? 0 : +e, r.restart(function (n) {
            r.stop(), t(n + e);
          }, e, n), r;
        }

        pf.prototype = yf.prototype = {
          constructor: pf,
          restart: function restart(t, e, n) {
            if ("function" != typeof t) throw new TypeError("callback is not a function");
            n = (null == n ? ff() : +n) + (null == e ? 0 : +e), this._next || nf === this || (nf ? nf._next = this : ef = this, nf = this), this._call = t, this._time = n, vf();
          },
          stop: function stop() {
            this._call && (this._call = null, this._time = 1 / 0, vf());
          }
        };

        var _f = tf("start", "end", "cancel", "interrupt"),
            xf = [];

        function wf(t, e, n, r, i, a) {
          var o = t.__transition;

          if (o) {
            if (n in o) return;
          } else t.__transition = {};

          !function (t, e, n) {
            var r,
                i = t.__transition;

            function a(c) {
              var u, l, h, f;
              if (1 !== n.state) return s();

              for (u in i) {
                if ((f = i[u]).name === n.name) {
                  if (3 === f.state) return bf(a);
                  4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
                }
              }

              if (bf(function () {
                3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
              }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
                for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
                  (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
                }

                r.length = l + 1;
              }
            }

            function o(e) {
              for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
                r[a].call(t, i);
              }

              5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
            }

            function s() {
              for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
                return;
              }

              delete t.__transition;
            }

            i[e] = n, n.timer = yf(function (t) {
              n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
            }, 0, n.time);
          }(t, n, {
            name: e,
            index: r,
            group: i,
            on: _f,
            tween: xf,
            time: a.time,
            delay: a.delay,
            duration: a.duration,
            ease: a.ease,
            timer: null,
            state: 0
          });
        }

        function kf(t, e) {
          var n = Ef(t, e);
          if (n.state > 0) throw new Error("too late; already scheduled");
          return n;
        }

        function Tf(t, e) {
          var n = Ef(t, e);
          if (n.state > 3) throw new Error("too late; already running");
          return n;
        }

        function Ef(t, e) {
          var n = t.__transition;
          if (!n || !(n = n[e])) throw new Error("transition not found");
          return n;
        }

        function Cf(t, e) {
          return t = +t, e = +e, function (n) {
            return t * (1 - n) + e * n;
          };
        }

        var Sf,
            Af = 180 / Math.PI,
            Mf = {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          skewX: 0,
          scaleX: 1,
          scaleY: 1
        };

        function Nf(t, e, n, r, i, a) {
          var o, s, c;
          return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
            translateX: i,
            translateY: a,
            rotate: Math.atan2(e, t) * Af,
            skewX: Math.atan(c) * Af,
            scaleX: o,
            scaleY: s
          };
        }

        function Df(t, e, n, r) {
          function i(t) {
            return t.length ? t.pop() + " " : "";
          }

          return function (a, o) {
            var s = [],
                c = [];
            return a = t(a), o = t(o), function (t, r, i, a, o, s) {
              if (t !== i || r !== a) {
                var c = o.push("translate(", null, e, null, n);
                s.push({
                  i: c - 4,
                  x: Cf(t, i)
                }, {
                  i: c - 2,
                  x: Cf(r, a)
                });
              } else (i || a) && o.push("translate(" + i + e + a + n);
            }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
              t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
                i: n.push(i(n) + "rotate(", null, r) - 2,
                x: Cf(t, e)
              })) : e && n.push(i(n) + "rotate(" + e + r);
            }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
              t !== e ? a.push({
                i: n.push(i(n) + "skewX(", null, r) - 2,
                x: Cf(t, e)
              }) : e && n.push(i(n) + "skewX(" + e + r);
            }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
              if (t !== n || e !== r) {
                var s = a.push(i(a) + "scale(", null, ",", null, ")");
                o.push({
                  i: s - 4,
                  x: Cf(t, n)
                }, {
                  i: s - 2,
                  x: Cf(e, r)
                });
              } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
            }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
              for (var e, n = -1, r = c.length; ++n < r;) {
                s[(e = c[n]).i] = e.x(t);
              }

              return s.join("");
            };
          };
        }

        var Of = Df(function (t) {
          var e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
          return e.isIdentity ? Mf : Nf(e.a, e.b, e.c, e.d, e.e, e.f);
        }, "px, ", "px)", "deg)"),
            Bf = Df(function (t) {
          return null == t ? Mf : (Sf || (Sf = document.createElementNS("http://www.w3.org/2000/svg", "g")), Sf.setAttribute("transform", t), (t = Sf.transform.baseVal.consolidate()) ? Nf((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : Mf);
        }, ", ", ")", ")");

        function Lf(t, e) {
          var n, r;
          return function () {
            var i = Tf(this, t),
                a = i.tween;
            if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
              if (r[o].name === e) {
                (r = r.slice()).splice(o, 1);
                break;
              }
            }
            i.tween = r;
          };
        }

        function If(t, e, n) {
          var r, i;
          if ("function" != typeof n) throw new Error();
          return function () {
            var a = Tf(this, t),
                o = a.tween;

            if (o !== r) {
              i = (r = o).slice();

              for (var s = {
                name: e,
                value: n
              }, c = 0, u = i.length; c < u; ++c) {
                if (i[c].name === e) {
                  i[c] = s;
                  break;
                }
              }

              c === u && i.push(s);
            }

            a.tween = i;
          };
        }

        function Rf(t, e, n) {
          var r = t._id;
          return t.each(function () {
            var t = Tf(this, r);
            (t.value || (t.value = {}))[e] = n.apply(this, arguments);
          }), function (t) {
            return Ef(t, r).value[e];
          };
        }

        function Pf(t, e, n, r, i) {
          var a = t * t,
              o = a * t;
          return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
        }

        var Ff = function t(e) {
          var n = function (t) {
            return 1 == (t = +t) ? Dr : function (e, n) {
              return n - e ? function (t, e, n) {
                return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
                  return Math.pow(t + r * e, n);
                };
              }(e, n, t) : Mr(isNaN(e) ? n : e);
            };
          }(e);

          function r(t, e) {
            var r = n((t = sr(t)).r, (e = sr(e)).r),
                i = n(t.g, e.g),
                a = n(t.b, e.b),
                o = Dr(t.opacity, e.opacity);
            return function (e) {
              return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
            };
          }

          return r.gamma = t, r;
        }(1);

        function jf(t) {
          return function (e) {
            var n,
                r,
                i = e.length,
                a = new Array(i),
                o = new Array(i),
                s = new Array(i);

            for (n = 0; n < i; ++n) {
              r = sr(e[n]), a[n] = r.r || 0, o[n] = r.g || 0, s[n] = r.b || 0;
            }

            return a = t(a), o = t(o), s = t(s), r.opacity = 1, function (t) {
              return r.r = a(t), r.g = o(t), r.b = s(t), r + "";
            };
          };
        }

        jf(function (t) {
          var e = t.length - 1;
          return function (n) {
            var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
                i = t[r],
                a = t[r + 1],
                o = r > 0 ? t[r - 1] : 2 * i - a,
                s = r < e - 1 ? t[r + 2] : 2 * a - i;
            return Pf((n - r / e) * e, o, i, a, s);
          };
        }), jf(function (t) {
          var e = t.length;
          return function (n) {
            var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
                i = t[(r + e - 1) % e],
                a = t[r % e],
                o = t[(r + 1) % e],
                s = t[(r + 2) % e];
            return Pf((n - r / e) * e, i, a, o, s);
          };
        });
        var Yf = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            Uf = new RegExp(Yf.source, "g");

        function zf(t, e) {
          var n,
              r,
              i,
              a = Yf.lastIndex = Uf.lastIndex = 0,
              o = -1,
              s = [],
              c = [];

          for (t += "", e += ""; (n = Yf.exec(t)) && (r = Uf.exec(e));) {
            (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
              i: o,
              x: Cf(n, r)
            })), a = Uf.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
            return function (e) {
              return t(e) + "";
            };
          }(c[0].x) : function (t) {
            return function () {
              return t;
            };
          }(e) : (e = c.length, function (t) {
            for (var n, r = 0; r < e; ++r) {
              s[(n = c[r]).i] = n.x(t);
            }

            return s.join("");
          });
        }

        function qf(t, e) {
          var n;
          return ("number" == typeof e ? Cf : e instanceof rr ? Ff : (n = rr(e)) ? (e = n, Ff) : zf)(t, e);
        }

        function $f(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function Hf(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function Wf(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttribute(t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function Vf(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttributeNS(t.space, t.local);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function Gf(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttribute(t);
          };
        }

        function Xf(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function Zf(t, e) {
          return function (n) {
            this.setAttribute(t, e.call(this, n));
          };
        }

        function Kf(t, e) {
          return function (n) {
            this.setAttributeNS(t.space, t.local, e.call(this, n));
          };
        }

        function Qf(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && Kf(t, i)), n;
          }

          return i._value = e, i;
        }

        function Jf(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && Zf(t, i)), n;
          }

          return i._value = e, i;
        }

        function td(t, e) {
          return function () {
            kf(this, t).delay = +e.apply(this, arguments);
          };
        }

        function ed(t, e) {
          return e = +e, function () {
            kf(this, t).delay = e;
          };
        }

        function nd(t, e) {
          return function () {
            Tf(this, t).duration = +e.apply(this, arguments);
          };
        }

        function rd(t, e) {
          return e = +e, function () {
            Tf(this, t).duration = e;
          };
        }

        function id(t, e) {
          if ("function" != typeof e) throw new Error();
          return function () {
            Tf(this, t).ease = e;
          };
        }

        function ad(t, e, n) {
          var r,
              i,
              a = function (t) {
            return (t + "").trim().split(/^|\s+/).every(function (t) {
              var e = t.indexOf(".");
              return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
            });
          }(e) ? kf : Tf;
          return function () {
            var o = a(this, t),
                s = o.on;
            s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
          };
        }

        var od = Xc.prototype.constructor;

        function sd(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function cd(t, e, n) {
          return function (r) {
            this.style.setProperty(t, e.call(this, r), n);
          };
        }

        function ud(t, e, n) {
          var r, i;

          function a() {
            var a = e.apply(this, arguments);
            return a !== i && (r = (i = a) && cd(t, a, n)), r;
          }

          return a._value = e, a;
        }

        function ld(t) {
          return function (e) {
            this.textContent = t.call(this, e);
          };
        }

        function hd(t) {
          var e, n;

          function r() {
            var r = t.apply(this, arguments);
            return r !== n && (e = (n = r) && ld(r)), e;
          }

          return r._value = t, r;
        }

        var fd = 0;

        function dd(t, e, n, r) {
          this._groups = t, this._parents = e, this._name = n, this._id = r;
        }

        function pd() {
          return ++fd;
        }

        var yd = Xc.prototype;

        dd.prototype = function (t) {
          return Xc().transition(t);
        }.prototype = _defineProperty({
          constructor: dd,
          select: function select(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = Rs(t));

            for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
              for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
                (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, wf(h[f], e, n, f, h, Ef(s, n)));
              }
            }

            return new dd(a, this._parents, e, n);
          },
          selectAll: function selectAll(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = js(t));

            for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
              for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
                if (c = u[h]) {
                  for (var f, d = t.call(c, c.__data__, h, u), p = Ef(c, n), y = 0, g = d.length; y < g; ++y) {
                    (f = d[y]) && wf(f, e, n, y, d, p);
                  }

                  a.push(d), o.push(c);
                }
              }
            }

            return new dd(a, o, e, n);
          },
          selectChild: yd.selectChild,
          selectChildren: yd.selectChildren,
          filter: function filter(t) {
            "function" != typeof t && (t = Ys(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new dd(r, this._parents, this._name, this._id);
          },
          merge: function merge(t) {
            if (t._id !== this._id) throw new Error();

            for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
              for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
                (c = u[d] || l[d]) && (f[d] = c);
              }
            }

            for (; s < r; ++s) {
              o[s] = e[s];
            }

            return new dd(o, this._parents, this._name, this._id);
          },
          selection: function selection() {
            return new od(this._groups, this._parents);
          },
          transition: function transition() {
            for (var t = this._name, e = this._id, n = pd(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
              for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
                if (o = s[u]) {
                  var l = Ef(o, e);
                  wf(o, t, n, u, s, {
                    time: l.time + l.delay + l.duration,
                    delay: 0,
                    duration: l.duration,
                    ease: l.ease
                  });
                }
              }
            }

            return new dd(r, this._parents, t, n);
          },
          call: yd.call,
          nodes: yd.nodes,
          node: yd.node,
          size: yd.size,
          empty: yd.empty,
          each: yd.each,
          on: function on(t, e) {
            var n = this._id;
            return arguments.length < 2 ? Ef(this.node(), n).on.on(t) : this.each(ad(n, t, e));
          },
          attr: function attr(t, e) {
            var n = nc(t),
                r = "transform" === n ? Bf : qf;
            return this.attrTween(t, "function" == typeof e ? (n.local ? Xf : Gf)(n, r, Rf(this, "attr." + t, e)) : null == e ? (n.local ? Hf : $f)(n) : (n.local ? Vf : Wf)(n, r, e));
          },
          attrTween: function attrTween(t, e) {
            var n = "attr." + t;
            if (arguments.length < 2) return (n = this.tween(n)) && n._value;
            if (null == e) return this.tween(n, null);
            if ("function" != typeof e) throw new Error();
            var r = nc(t);
            return this.tween(n, (r.local ? Qf : Jf)(r, e));
          },
          style: function style(t, e, n) {
            var r = "transform" == (t += "") ? Of : qf;
            return null == e ? this.styleTween(t, function (t, e) {
              var n, r, i;
              return function () {
                var a = dc(this, t),
                    o = (this.style.removeProperty(t), dc(this, t));
                return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
              };
            }(t, r)).on("end.style." + t, sd(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
              var r, i, a;
              return function () {
                var o = dc(this, t),
                    s = n(this),
                    c = s + "";
                return null == s && (this.style.removeProperty(t), c = s = dc(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
              };
            }(t, r, Rf(this, "style." + t, e))).each(function (t, e) {
              var n,
                  r,
                  i,
                  a,
                  o = "style." + e,
                  s = "end." + o;
              return function () {
                var c = Tf(this, t),
                    u = c.on,
                    l = null == c.value[o] ? a || (a = sd(e)) : void 0;
                u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
              };
            }(this._id, t)) : this.styleTween(t, function (t, e, n) {
              var r,
                  i,
                  a = n + "";
              return function () {
                var o = dc(this, t);
                return o === a ? null : o === r ? i : i = e(r = o, n);
              };
            }(t, r, e), n).on("end.style." + t, null);
          },
          styleTween: function styleTween(t, e, n) {
            var r = "style." + (t += "");
            if (arguments.length < 2) return (r = this.tween(r)) && r._value;
            if (null == e) return this.tween(r, null);
            if ("function" != typeof e) throw new Error();
            return this.tween(r, ud(t, e, null == n ? "" : n));
          },
          text: function text(t) {
            return this.tween("text", "function" == typeof t ? function (t) {
              return function () {
                var e = t(this);
                this.textContent = null == e ? "" : e;
              };
            }(Rf(this, "text", t)) : function (t) {
              return function () {
                this.textContent = t;
              };
            }(null == t ? "" : t + ""));
          },
          textTween: function textTween(t) {
            var e = "text";
            if (arguments.length < 1) return (e = this.tween(e)) && e._value;
            if (null == t) return this.tween(e, null);
            if ("function" != typeof t) throw new Error();
            return this.tween(e, hd(t));
          },
          remove: function remove() {
            return this.on("end.remove", function (t) {
              return function () {
                var e = this.parentNode;

                for (var n in this.__transition) {
                  if (+n !== t) return;
                }

                e && e.removeChild(this);
              };
            }(this._id));
          },
          tween: function tween(t, e) {
            var n = this._id;

            if (t += "", arguments.length < 2) {
              for (var r, i = Ef(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
                if ((r = i[a]).name === t) return r.value;
              }

              return null;
            }

            return this.each((null == e ? Lf : If)(n, t, e));
          },
          delay: function delay(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? td : ed)(e, t)) : Ef(this.node(), e).delay;
          },
          duration: function duration(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? nd : rd)(e, t)) : Ef(this.node(), e).duration;
          },
          ease: function ease(t) {
            var e = this._id;
            return arguments.length ? this.each(id(e, t)) : Ef(this.node(), e).ease;
          },
          easeVarying: function easeVarying(t) {
            if ("function" != typeof t) throw new Error();
            return this.each(function (t, e) {
              return function () {
                var n = e.apply(this, arguments);
                if ("function" != typeof n) throw new Error();
                Tf(this, t).ease = n;
              };
            }(this._id, t));
          },
          end: function end() {
            var t,
                e,
                n = this,
                r = n._id,
                i = n.size();
            return new Promise(function (a, o) {
              var s = {
                value: o
              },
                  c = {
                value: function value() {
                  0 == --i && a();
                }
              };
              n.each(function () {
                var n = Tf(this, r),
                    i = n.on;
                i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
              }), 0 === i && a();
            });
          }
        }, Symbol.iterator, yd[Symbol.iterator]);

        var gd = {
          time: null,
          delay: 0,
          duration: 250,
          ease: function ease(t) {
            return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
          }
        };

        function md(t, e) {
          for (var n; !(n = t.__transition) || !(n = n[e]);) {
            if (!(t = t.parentNode)) throw new Error("transition ".concat(e, " not found"));
          }

          return n;
        }

        function vd() {}

        function bd(t) {
          return null == t ? vd : function () {
            return this.querySelector(t);
          };
        }

        function _d(t) {
          return null == t ? [] : Array.isArray(t) ? t : Array.from(t);
        }

        function xd() {
          return [];
        }

        function wd(t) {
          return null == t ? xd : function () {
            return this.querySelectorAll(t);
          };
        }

        function kd(t) {
          return function () {
            return this.matches(t);
          };
        }

        function Td(t) {
          return function (e) {
            return e.matches(t);
          };
        }

        Xc.prototype.interrupt = function (t) {
          return this.each(function () {
            !function (t, e) {
              var n,
                  r,
                  i,
                  a = t.__transition,
                  o = !0;

              if (a) {
                for (i in e = null == e ? null : e + "", a) {
                  (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
                }

                o && delete t.__transition;
              }
            }(this, t);
          });
        }, Xc.prototype.transition = function (t) {
          var e, n;
          t instanceof dd ? (e = t._id, t = t._name) : (e = pd(), (n = gd).time = ff(), t = null == t ? null : t + "");

          for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
            for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
              (o = s[u]) && wf(o, t, e, u, s, n || md(o, e));
            }
          }

          return new dd(r, this._parents, t, e);
        };
        var Ed = Array.prototype.find;

        function Cd() {
          return this.firstElementChild;
        }

        var Sd = Array.prototype.filter;

        function Ad() {
          return Array.from(this.children);
        }

        function Md(t) {
          return new Array(t.length);
        }

        function Nd(t, e) {
          this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
        }

        function Dd(t) {
          return function () {
            return t;
          };
        }

        function Od(t, e, n, r, i, a) {
          for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
            (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new Nd(t, a[s]);
          }

          for (; s < c; ++s) {
            (o = e[s]) && (i[s] = o);
          }
        }

        function Bd(t, e, n, r, i, a, o) {
          var s,
              c,
              u,
              l = new Map(),
              h = e.length,
              f = a.length,
              d = new Array(h);

          for (s = 0; s < h; ++s) {
            (c = e[s]) && (d[s] = u = o.call(c, c.__data__, s, e) + "", l.has(u) ? i[s] = c : l.set(u, c));
          }

          for (s = 0; s < f; ++s) {
            u = o.call(t, a[s], s, a) + "", (c = l.get(u)) ? (r[s] = c, c.__data__ = a[s], l.delete(u)) : n[s] = new Nd(t, a[s]);
          }

          for (s = 0; s < h; ++s) {
            (c = e[s]) && l.get(d[s]) === c && (i[s] = c);
          }
        }

        function Ld(t) {
          return t.__data__;
        }

        function Id(t) {
          return "object" == typeof t && "length" in t ? t : Array.from(t);
        }

        function Rd(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        Nd.prototype = {
          constructor: Nd,
          appendChild: function appendChild(t) {
            return this._parent.insertBefore(t, this._next);
          },
          insertBefore: function insertBefore(t, e) {
            return this._parent.insertBefore(t, e);
          },
          querySelector: function querySelector(t) {
            return this._parent.querySelector(t);
          },
          querySelectorAll: function querySelectorAll(t) {
            return this._parent.querySelectorAll(t);
          }
        };
        var Pd = "http://www.w3.org/1999/xhtml";
        var Fd = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: Pd,
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/"
        };

        function jd(t) {
          var e = t += "",
              n = e.indexOf(":");
          return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), Fd.hasOwnProperty(e) ? {
            space: Fd[e],
            local: t
          } : t;
        }

        function Yd(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function Ud(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function zd(t, e) {
          return function () {
            this.setAttribute(t, e);
          };
        }

        function qd(t, e) {
          return function () {
            this.setAttributeNS(t.space, t.local, e);
          };
        }

        function $d(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
          };
        }

        function Hd(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
          };
        }

        function Wd(t) {
          return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
        }

        function Vd(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function Gd(t, e, n) {
          return function () {
            this.style.setProperty(t, e, n);
          };
        }

        function Xd(t, e, n) {
          return function () {
            var r = e.apply(this, arguments);
            null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
          };
        }

        function Zd(t, e) {
          return t.style.getPropertyValue(e) || Wd(t).getComputedStyle(t, null).getPropertyValue(e);
        }

        function Kd(t) {
          return function () {
            delete this[t];
          };
        }

        function Qd(t, e) {
          return function () {
            this[t] = e;
          };
        }

        function Jd(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? delete this[t] : this[t] = n;
          };
        }

        function tp(t) {
          return t.trim().split(/^|\s+/);
        }

        function ep(t) {
          return t.classList || new np(t);
        }

        function np(t) {
          this._node = t, this._names = tp(t.getAttribute("class") || "");
        }

        function rp(t, e) {
          for (var n = ep(t), r = -1, i = e.length; ++r < i;) {
            n.add(e[r]);
          }
        }

        function ip(t, e) {
          for (var n = ep(t), r = -1, i = e.length; ++r < i;) {
            n.remove(e[r]);
          }
        }

        function ap(t) {
          return function () {
            rp(this, t);
          };
        }

        function op(t) {
          return function () {
            ip(this, t);
          };
        }

        function sp(t, e) {
          return function () {
            (e.apply(this, arguments) ? rp : ip)(this, t);
          };
        }

        function cp() {
          this.textContent = "";
        }

        function up(t) {
          return function () {
            this.textContent = t;
          };
        }

        function lp(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.textContent = null == e ? "" : e;
          };
        }

        function hp() {
          this.innerHTML = "";
        }

        function fp(t) {
          return function () {
            this.innerHTML = t;
          };
        }

        function dp(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.innerHTML = null == e ? "" : e;
          };
        }

        function pp() {
          this.nextSibling && this.parentNode.appendChild(this);
        }

        function yp() {
          this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
        }

        function gp(t) {
          return function () {
            var e = this.ownerDocument,
                n = this.namespaceURI;
            return n === Pd && e.documentElement.namespaceURI === Pd ? e.createElement(t) : e.createElementNS(n, t);
          };
        }

        function mp(t) {
          return function () {
            return this.ownerDocument.createElementNS(t.space, t.local);
          };
        }

        function vp(t) {
          var e = jd(t);
          return (e.local ? mp : gp)(e);
        }

        function bp() {
          return null;
        }

        function _p() {
          var t = this.parentNode;
          t && t.removeChild(this);
        }

        function xp() {
          var t = this.cloneNode(!1),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function wp() {
          var t = this.cloneNode(!0),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function kp(t) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var e = "",
                n = t.indexOf(".");
            return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
              type: t,
              name: e
            };
          });
        }

        function Tp(t) {
          return function () {
            var e = this.__on;

            if (e) {
              for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
                n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.options);
              }

              ++i ? e.length = i : delete this.__on;
            }
          };
        }

        function Ep(t, e, n) {
          return function () {
            var r,
                i = this.__on,
                a = function (t) {
              return function (e) {
                t.call(this, e, this.__data__);
              };
            }(e);

            if (i) for (var o = 0, s = i.length; o < s; ++o) {
              if ((r = i[o]).type === t.type && r.name === t.name) return this.removeEventListener(r.type, r.listener, r.options), this.addEventListener(r.type, r.listener = a, r.options = n), void (r.value = e);
            }
            this.addEventListener(t.type, a, n), r = {
              type: t.type,
              name: t.name,
              value: e,
              listener: a,
              options: n
            }, i ? i.push(r) : this.__on = [r];
          };
        }

        function Cp(t, e, n) {
          var r = Wd(t),
              i = r.CustomEvent;
          "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
        }

        function Sp(t, e) {
          return function () {
            return Cp(this, t, e);
          };
        }

        function Ap(t, e) {
          return function () {
            return Cp(this, t, e.apply(this, arguments));
          };
        }

        np.prototype = {
          add: function add(t) {
            this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
          },
          remove: function remove(t) {
            var e = this._names.indexOf(t);

            e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
          },
          contains: function contains(t) {
            return this._names.indexOf(t) >= 0;
          }
        };
        var Mp = [null];

        function Np(t, e) {
          this._groups = t, this._parents = e;
        }

        function Dp() {
          return new Np([[document.documentElement]], Mp);
        }

        Np.prototype = Dp.prototype = _defineProperty({
          constructor: Np,
          select: function select(t) {
            "function" != typeof t && (t = bd(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
                (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
              }
            }

            return new Np(r, this._parents);
          },
          selectAll: function selectAll(t) {
            t = "function" == typeof t ? function (t) {
              return function () {
                return _d(t.apply(this, arguments));
              };
            }(t) : wd(t);

            for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
              for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
                (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
              }
            }

            return new Np(r, i);
          },
          selectChild: function selectChild(t) {
            return this.select(null == t ? Cd : function (t) {
              return function () {
                return Ed.call(this.children, t);
              };
            }("function" == typeof t ? t : Td(t)));
          },
          selectChildren: function selectChildren(t) {
            return this.selectAll(null == t ? Ad : function (t) {
              return function () {
                return Sd.call(this.children, t);
              };
            }("function" == typeof t ? t : Td(t)));
          },
          filter: function filter(t) {
            "function" != typeof t && (t = kd(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new Np(r, this._parents);
          },
          data: function data(t, e) {
            if (!arguments.length) return Array.from(this, Ld);
            var n = e ? Bd : Od,
                r = this._parents,
                i = this._groups;
            "function" != typeof t && (t = Dd(t));

            for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
              var l = r[u],
                  h = i[u],
                  f = h.length,
                  d = Id(t.call(l, l && l.__data__, u, r)),
                  p = d.length,
                  y = s[u] = new Array(p),
                  g = o[u] = new Array(p),
                  m = c[u] = new Array(f);
              n(l, h, y, g, m, d, e);

              for (var v, b, _ = 0, x = 0; _ < p; ++_) {
                if (v = y[_]) {
                  for (_ >= x && (x = _ + 1); !(b = g[x]) && ++x < p;) {
                    ;
                  }

                  v._next = b || null;
                }
              }
            }

            return (o = new Np(o, r))._enter = s, o._exit = c, o;
          },
          enter: function enter() {
            return new Np(this._enter || this._groups.map(Md), this._parents);
          },
          exit: function exit() {
            return new Np(this._exit || this._groups.map(Md), this._parents);
          },
          join: function join(t, e, n) {
            var r = this.enter(),
                i = this,
                a = this.exit();
            return "function" == typeof t ? (r = t(r)) && (r = r.selection()) : r = r.append(t + ""), null != e && (i = e(i)) && (i = i.selection()), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
          },
          merge: function merge(t) {
            for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c) {
              for (var u, l = n[c], h = r[c], f = l.length, d = s[c] = new Array(f), p = 0; p < f; ++p) {
                (u = l[p] || h[p]) && (d[p] = u);
              }
            }

            for (; c < i; ++c) {
              s[c] = n[c];
            }

            return new Np(s, this._parents);
          },
          selection: function selection() {
            return this;
          },
          order: function order() {
            for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
              for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
                (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
              }
            }

            return this;
          },
          sort: function sort(t) {
            function e(e, n) {
              return e && n ? t(e.__data__, n.__data__) : !e - !n;
            }

            t || (t = Rd);

            for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
              for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
                (o = s[l]) && (u[l] = o);
              }

              u.sort(e);
            }

            return new Np(i, this._parents).order();
          },
          call: function call() {
            var t = arguments[0];
            return arguments[0] = this, t.apply(null, arguments), this;
          },
          nodes: function nodes() {
            return Array.from(this);
          },
          node: function node() {
            for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
              for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
                var o = r[i];
                if (o) return o;
              }
            }

            return null;
          },
          size: function size() {
            var t = 0;

            var _iterator8 = _createForOfIteratorHelper(this),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e9 = _step8.value;
                ++t;
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }

            return t;
          },
          empty: function empty() {
            return !this.node();
          },
          each: function each(t) {
            for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
              for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
                (i = a[o]) && t.call(i, i.__data__, o, a);
              }
            }

            return this;
          },
          attr: function attr(t, e) {
            var n = jd(t);

            if (arguments.length < 2) {
              var r = this.node();
              return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
            }

            return this.each((null == e ? n.local ? Ud : Yd : "function" == typeof e ? n.local ? Hd : $d : n.local ? qd : zd)(n, e));
          },
          style: function style(t, e, n) {
            return arguments.length > 1 ? this.each((null == e ? Vd : "function" == typeof e ? Xd : Gd)(t, e, null == n ? "" : n)) : Zd(this.node(), t);
          },
          property: function property(t, e) {
            return arguments.length > 1 ? this.each((null == e ? Kd : "function" == typeof e ? Jd : Qd)(t, e)) : this.node()[t];
          },
          classed: function classed(t, e) {
            var n = tp(t + "");

            if (arguments.length < 2) {
              for (var r = ep(this.node()), i = -1, a = n.length; ++i < a;) {
                if (!r.contains(n[i])) return !1;
              }

              return !0;
            }

            return this.each(("function" == typeof e ? sp : e ? ap : op)(n, e));
          },
          text: function text(t) {
            return arguments.length ? this.each(null == t ? cp : ("function" == typeof t ? lp : up)(t)) : this.node().textContent;
          },
          html: function html(t) {
            return arguments.length ? this.each(null == t ? hp : ("function" == typeof t ? dp : fp)(t)) : this.node().innerHTML;
          },
          raise: function raise() {
            return this.each(pp);
          },
          lower: function lower() {
            return this.each(yp);
          },
          append: function append(t) {
            var e = "function" == typeof t ? t : vp(t);
            return this.select(function () {
              return this.appendChild(e.apply(this, arguments));
            });
          },
          insert: function insert(t, e) {
            var n = "function" == typeof t ? t : vp(t),
                r = null == e ? bp : "function" == typeof e ? e : bd(e);
            return this.select(function () {
              return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
            });
          },
          remove: function remove() {
            return this.each(_p);
          },
          clone: function clone(t) {
            return this.select(t ? wp : xp);
          },
          datum: function datum(t) {
            return arguments.length ? this.property("__data__", t) : this.node().__data__;
          },
          on: function on(t, e, n) {
            var r,
                i,
                a = kp(t + ""),
                o = a.length;

            if (!(arguments.length < 2)) {
              for (s = e ? Ep : Tp, r = 0; r < o; ++r) {
                this.each(s(a[r], e, n));
              }

              return this;
            }

            var s = this.node().__on;

            if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
              for (r = 0, c = s[u]; r < o; ++r) {
                if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
              }
            }
          },
          dispatch: function dispatch(t, e) {
            return this.each(("function" == typeof e ? Ap : Sp)(t, e));
          }
        }, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var t, e, n, r, i, a, o;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  t = this._groups, e = 0, n = t.length;

                case 1:
                  if (!(e < n)) {
                    _context3.next = 14;
                    break;
                  }

                  i = t[e], a = 0, o = i.length;

                case 3:
                  if (!(a < o)) {
                    _context3.next = 11;
                    break;
                  }

                  _context3.t0 = r = i[a];

                  if (!_context3.t0) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 8;
                  return r;

                case 8:
                  ++a;
                  _context3.next = 3;
                  break;

                case 11:
                  ++e;
                  _context3.next = 1;
                  break;

                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        var Op = Dp;
        var Bp = {
          value: function value() {}
        };

        function Lp() {
          for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
            if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            r[t] = [];
          }

          return new Ip(r);
        }

        function Ip(t) {
          this._ = t;
        }

        function Rp(t, e) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var n = "",
                r = t.indexOf(".");
            if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
              type: t,
              name: n
            };
          });
        }

        function Pp(t, e) {
          for (var n, r = 0, i = t.length; r < i; ++r) {
            if ((n = t[r]).name === e) return n.value;
          }
        }

        function Fp(t, e, n) {
          for (var r = 0, i = t.length; r < i; ++r) {
            if (t[r].name === e) {
              t[r] = Bp, t = t.slice(0, r).concat(t.slice(r + 1));
              break;
            }
          }

          return null != n && t.push({
            name: e,
            value: n
          }), t;
        }

        Ip.prototype = Lp.prototype = {
          constructor: Ip,
          on: function on(t, e) {
            var n,
                r = this._,
                i = Rp(t + "", r),
                a = -1,
                o = i.length;

            if (!(arguments.length < 2)) {
              if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

              for (; ++a < o;) {
                if (n = (t = i[a]).type) r[n] = Fp(r[n], t.name, e);else if (null == e) for (n in r) {
                  r[n] = Fp(r[n], t.name, null);
                }
              }

              return this;
            }

            for (; ++a < o;) {
              if ((n = (t = i[a]).type) && (n = Pp(r[n], t.name))) return n;
            }
          },
          copy: function copy() {
            var t = {},
                e = this._;

            for (var n in e) {
              t[n] = e[n].slice();
            }

            return new Ip(t);
          },
          call: function call(t, e) {
            if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
              i[a] = arguments[a + 2];
            }
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
              r[a].value.apply(e, i);
            }
          },
          apply: function apply(t, e, n) {
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
              r[i].value.apply(e, n);
            }
          }
        };
        var jp = Lp;
        var Yp,
            Up,
            zp = 0,
            qp = 0,
            $p = 0,
            Hp = 0,
            Wp = 0,
            Vp = 0,
            Gp = "object" == typeof performance && performance.now ? performance : Date,
            Xp = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
          setTimeout(t, 17);
        };

        function Zp() {
          return Wp || (Xp(Kp), Wp = Gp.now() + Vp);
        }

        function Kp() {
          Wp = 0;
        }

        function Qp() {
          this._call = this._time = this._next = null;
        }

        function Jp(t, e, n) {
          var r = new Qp();
          return r.restart(t, e, n), r;
        }

        function ty() {
          Wp = (Hp = Gp.now()) + Vp, zp = qp = 0;

          try {
            !function () {
              Zp(), ++zp;

              for (var t, e = Yp; e;) {
                (t = Wp - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
              }

              --zp;
            }();
          } finally {
            zp = 0, function () {
              for (var t, e, n = Yp, r = 1 / 0; n;) {
                n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : Yp = e);
              }

              Up = t, ny(r);
            }(), Wp = 0;
          }
        }

        function ey() {
          var t = Gp.now(),
              e = t - Hp;
          e > 1e3 && (Vp -= e, Hp = t);
        }

        function ny(t) {
          zp || (qp && (qp = clearTimeout(qp)), t - Wp > 24 ? (t < 1 / 0 && (qp = setTimeout(ty, t - Gp.now() - Vp)), $p && ($p = clearInterval($p))) : ($p || (Hp = Gp.now(), $p = setInterval(ey, 1e3)), zp = 1, Xp(ty)));
        }

        function ry(t, e, n) {
          var r = new Qp();
          return e = null == e ? 0 : +e, r.restart(function (n) {
            r.stop(), t(n + e);
          }, e, n), r;
        }

        Qp.prototype = Jp.prototype = {
          constructor: Qp,
          restart: function restart(t, e, n) {
            if ("function" != typeof t) throw new TypeError("callback is not a function");
            n = (null == n ? Zp() : +n) + (null == e ? 0 : +e), this._next || Up === this || (Up ? Up._next = this : Yp = this, Up = this), this._call = t, this._time = n, ny();
          },
          stop: function stop() {
            this._call && (this._call = null, this._time = 1 / 0, ny());
          }
        };
        var iy = jp("start", "end", "cancel", "interrupt"),
            ay = [];

        function oy(t, e, n, r, i, a) {
          var o = t.__transition;

          if (o) {
            if (n in o) return;
          } else t.__transition = {};

          !function (t, e, n) {
            var r,
                i = t.__transition;

            function a(c) {
              var u, l, h, f;
              if (1 !== n.state) return s();

              for (u in i) {
                if ((f = i[u]).name === n.name) {
                  if (3 === f.state) return ry(a);
                  4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
                }
              }

              if (ry(function () {
                3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
              }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
                for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
                  (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
                }

                r.length = l + 1;
              }
            }

            function o(e) {
              for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
                r[a].call(t, i);
              }

              5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
            }

            function s() {
              for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
                return;
              }

              delete t.__transition;
            }

            i[e] = n, n.timer = Jp(function (t) {
              n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
            }, 0, n.time);
          }(t, n, {
            name: e,
            index: r,
            group: i,
            on: iy,
            tween: ay,
            time: a.time,
            delay: a.delay,
            duration: a.duration,
            ease: a.ease,
            timer: null,
            state: 0
          });
        }

        function sy(t, e) {
          var n = uy(t, e);
          if (n.state > 0) throw new Error("too late; already scheduled");
          return n;
        }

        function cy(t, e) {
          var n = uy(t, e);
          if (n.state > 3) throw new Error("too late; already running");
          return n;
        }

        function uy(t, e) {
          var n = t.__transition;
          if (!n || !(n = n[e])) throw new Error("transition not found");
          return n;
        }

        function ly(t, e) {
          return t = +t, e = +e, function (n) {
            return t * (1 - n) + e * n;
          };
        }

        var hy,
            fy = 180 / Math.PI,
            dy = {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          skewX: 0,
          scaleX: 1,
          scaleY: 1
        };

        function py(t, e, n, r, i, a) {
          var o, s, c;
          return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
            translateX: i,
            translateY: a,
            rotate: Math.atan2(e, t) * fy,
            skewX: Math.atan(c) * fy,
            scaleX: o,
            scaleY: s
          };
        }

        function yy(t, e, n, r) {
          function i(t) {
            return t.length ? t.pop() + " " : "";
          }

          return function (a, o) {
            var s = [],
                c = [];
            return a = t(a), o = t(o), function (t, r, i, a, o, s) {
              if (t !== i || r !== a) {
                var c = o.push("translate(", null, e, null, n);
                s.push({
                  i: c - 4,
                  x: ly(t, i)
                }, {
                  i: c - 2,
                  x: ly(r, a)
                });
              } else (i || a) && o.push("translate(" + i + e + a + n);
            }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
              t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
                i: n.push(i(n) + "rotate(", null, r) - 2,
                x: ly(t, e)
              })) : e && n.push(i(n) + "rotate(" + e + r);
            }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
              t !== e ? a.push({
                i: n.push(i(n) + "skewX(", null, r) - 2,
                x: ly(t, e)
              }) : e && n.push(i(n) + "skewX(" + e + r);
            }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
              if (t !== n || e !== r) {
                var s = a.push(i(a) + "scale(", null, ",", null, ")");
                o.push({
                  i: s - 4,
                  x: ly(t, n)
                }, {
                  i: s - 2,
                  x: ly(e, r)
                });
              } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
            }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
              for (var e, n = -1, r = c.length; ++n < r;) {
                s[(e = c[n]).i] = e.x(t);
              }

              return s.join("");
            };
          };
        }

        var gy = yy(function (t) {
          var e = new ("function" == typeof DOMMatrix ? DOMMatrix : WebKitCSSMatrix)(t + "");
          return e.isIdentity ? dy : py(e.a, e.b, e.c, e.d, e.e, e.f);
        }, "px, ", "px)", "deg)"),
            my = yy(function (t) {
          return null == t ? dy : (hy || (hy = document.createElementNS("http://www.w3.org/2000/svg", "g")), hy.setAttribute("transform", t), (t = hy.transform.baseVal.consolidate()) ? py((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : dy);
        }, ", ", ")", ")");

        function vy(t, e) {
          var n, r;
          return function () {
            var i = cy(this, t),
                a = i.tween;
            if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
              if (r[o].name === e) {
                (r = r.slice()).splice(o, 1);
                break;
              }
            }
            i.tween = r;
          };
        }

        function by(t, e, n) {
          var r, i;
          if ("function" != typeof n) throw new Error();
          return function () {
            var a = cy(this, t),
                o = a.tween;

            if (o !== r) {
              i = (r = o).slice();

              for (var s = {
                name: e,
                value: n
              }, c = 0, u = i.length; c < u; ++c) {
                if (i[c].name === e) {
                  i[c] = s;
                  break;
                }
              }

              c === u && i.push(s);
            }

            a.tween = i;
          };
        }

        function _y(t, e, n) {
          var r = t._id;
          return t.each(function () {
            var t = cy(this, r);
            (t.value || (t.value = {}))[e] = n.apply(this, arguments);
          }), function (t) {
            return uy(t, r).value[e];
          };
        }

        function xy(t, e, n) {
          t.prototype = e.prototype = n, n.constructor = t;
        }

        function wy(t, e) {
          var n = Object.create(t.prototype);

          for (var r in e) {
            n[r] = e[r];
          }

          return n;
        }

        function ky() {}

        var Ty = 1.4285714285714286,
            Ey = "\\s*([+-]?\\d+)\\s*",
            Cy = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            Sy = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            Ay = /^#([0-9a-f]{3,8})$/,
            My = new RegExp("^rgb\\(" + [Ey, Ey, Ey] + "\\)$"),
            Ny = new RegExp("^rgb\\(" + [Sy, Sy, Sy] + "\\)$"),
            Dy = new RegExp("^rgba\\(" + [Ey, Ey, Ey, Cy] + "\\)$"),
            Oy = new RegExp("^rgba\\(" + [Sy, Sy, Sy, Cy] + "\\)$"),
            By = new RegExp("^hsl\\(" + [Cy, Sy, Sy] + "\\)$"),
            Ly = new RegExp("^hsla\\(" + [Cy, Sy, Sy, Cy] + "\\)$"),
            Iy = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };

        function Ry() {
          return this.rgb().formatHex();
        }

        function Py() {
          return this.rgb().formatRgb();
        }

        function Fy(t) {
          var e, n;
          return t = (t + "").trim().toLowerCase(), (e = Ay.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? jy(e) : 3 === n ? new qy(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Yy(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Yy(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = My.exec(t)) ? new qy(e[1], e[2], e[3], 1) : (e = Ny.exec(t)) ? new qy(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Dy.exec(t)) ? Yy(e[1], e[2], e[3], e[4]) : (e = Oy.exec(t)) ? Yy(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = By.exec(t)) ? Vy(e[1], e[2] / 100, e[3] / 100, 1) : (e = Ly.exec(t)) ? Vy(e[1], e[2] / 100, e[3] / 100, e[4]) : Iy.hasOwnProperty(t) ? jy(Iy[t]) : "transparent" === t ? new qy(NaN, NaN, NaN, 0) : null;
        }

        function jy(t) {
          return new qy(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
        }

        function Yy(t, e, n, r) {
          return r <= 0 && (t = e = n = NaN), new qy(t, e, n, r);
        }

        function Uy(t) {
          return t instanceof ky || (t = Fy(t)), t ? new qy((t = t.rgb()).r, t.g, t.b, t.opacity) : new qy();
        }

        function zy(t, e, n, r) {
          return 1 === arguments.length ? Uy(t) : new qy(t, e, n, null == r ? 1 : r);
        }

        function qy(t, e, n, r) {
          this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
        }

        function $y() {
          return "#" + Wy(this.r) + Wy(this.g) + Wy(this.b);
        }

        function Hy() {
          var t = this.opacity;
          return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
        }

        function Wy(t) {
          return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
        }

        function Vy(t, e, n, r) {
          return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Xy(t, e, n, r);
        }

        function Gy(t) {
          if (t instanceof Xy) return new Xy(t.h, t.s, t.l, t.opacity);
          if (t instanceof ky || (t = Fy(t)), !t) return new Xy();
          if (t instanceof Xy) return t;
          var e = (t = t.rgb()).r / 255,
              n = t.g / 255,
              r = t.b / 255,
              i = Math.min(e, n, r),
              a = Math.max(e, n, r),
              o = NaN,
              s = a - i,
              c = (a + i) / 2;
          return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new Xy(o, s, c, t.opacity);
        }

        function Xy(t, e, n, r) {
          this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
        }

        function Zy(t, e, n) {
          return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
        }

        function Ky(t, e, n, r, i) {
          var a = t * t,
              o = a * t;
          return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
        }

        xy(ky, Fy, {
          copy: function copy(t) {
            return Object.assign(new this.constructor(), this, t);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: Ry,
          formatHex: Ry,
          formatHsl: function formatHsl() {
            return Gy(this).formatHsl();
          },
          formatRgb: Py,
          toString: Py
        }), xy(qy, zy, wy(ky, {
          brighter: function brighter(t) {
            return t = null == t ? Ty : Math.pow(Ty, t), new qy(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new qy(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: $y,
          formatHex: $y,
          formatRgb: Hy,
          toString: Hy
        })), xy(Xy, function (t, e, n, r) {
          return 1 === arguments.length ? Gy(t) : new Xy(t, e, n, null == r ? 1 : r);
        }, wy(ky, {
          brighter: function brighter(t) {
            return t = null == t ? Ty : Math.pow(Ty, t), new Xy(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new Xy(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = this.h % 360 + 360 * (this.h < 0),
                e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                n = this.l,
                r = n + (n < .5 ? n : 1 - n) * e,
                i = 2 * n - r;
            return new qy(Zy(t >= 240 ? t - 240 : t + 120, i, r), Zy(t, i, r), Zy(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var t = this.opacity;
            return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
          }
        }));

        var Qy = function Qy(t) {
          return function () {
            return t;
          };
        };

        function Jy(t, e) {
          var n = e - t;
          return n ? function (t, e) {
            return function (n) {
              return t + n * e;
            };
          }(t, n) : Qy(isNaN(t) ? e : t);
        }

        var tg = function t(e) {
          var n = function (t) {
            return 1 == (t = +t) ? Jy : function (e, n) {
              return n - e ? function (t, e, n) {
                return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
                  return Math.pow(t + r * e, n);
                };
              }(e, n, t) : Qy(isNaN(e) ? n : e);
            };
          }(e);

          function r(t, e) {
            var r = n((t = zy(t)).r, (e = zy(e)).r),
                i = n(t.g, e.g),
                a = n(t.b, e.b),
                o = Jy(t.opacity, e.opacity);
            return function (e) {
              return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
            };
          }

          return r.gamma = t, r;
        }(1);

        function eg(t) {
          return function (e) {
            var n,
                r,
                i = e.length,
                a = new Array(i),
                o = new Array(i),
                s = new Array(i);

            for (n = 0; n < i; ++n) {
              r = zy(e[n]), a[n] = r.r || 0, o[n] = r.g || 0, s[n] = r.b || 0;
            }

            return a = t(a), o = t(o), s = t(s), r.opacity = 1, function (t) {
              return r.r = a(t), r.g = o(t), r.b = s(t), r + "";
            };
          };
        }

        eg(function (t) {
          var e = t.length - 1;
          return function (n) {
            var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
                i = t[r],
                a = t[r + 1],
                o = r > 0 ? t[r - 1] : 2 * i - a,
                s = r < e - 1 ? t[r + 2] : 2 * a - i;
            return Ky((n - r / e) * e, o, i, a, s);
          };
        }), eg(function (t) {
          var e = t.length;
          return function (n) {
            var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
                i = t[(r + e - 1) % e],
                a = t[r % e],
                o = t[(r + 1) % e],
                s = t[(r + 2) % e];
            return Ky((n - r / e) * e, i, a, o, s);
          };
        });
        var ng = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            rg = new RegExp(ng.source, "g");

        function ig(t, e) {
          var n,
              r,
              i,
              a = ng.lastIndex = rg.lastIndex = 0,
              o = -1,
              s = [],
              c = [];

          for (t += "", e += ""; (n = ng.exec(t)) && (r = rg.exec(e));) {
            (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
              i: o,
              x: ly(n, r)
            })), a = rg.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
            return function (e) {
              return t(e) + "";
            };
          }(c[0].x) : function (t) {
            return function () {
              return t;
            };
          }(e) : (e = c.length, function (t) {
            for (var n, r = 0; r < e; ++r) {
              s[(n = c[r]).i] = n.x(t);
            }

            return s.join("");
          });
        }

        function ag(t, e) {
          var n;
          return ("number" == typeof e ? ly : e instanceof Fy ? tg : (n = Fy(e)) ? (e = n, tg) : ig)(t, e);
        }

        function og(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function sg(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function cg(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttribute(t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function ug(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttributeNS(t.space, t.local);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function lg(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttribute(t);
          };
        }

        function hg(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function fg(t, e) {
          return function (n) {
            this.setAttribute(t, e.call(this, n));
          };
        }

        function dg(t, e) {
          return function (n) {
            this.setAttributeNS(t.space, t.local, e.call(this, n));
          };
        }

        function pg(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && dg(t, i)), n;
          }

          return i._value = e, i;
        }

        function yg(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && fg(t, i)), n;
          }

          return i._value = e, i;
        }

        function gg(t, e) {
          return function () {
            sy(this, t).delay = +e.apply(this, arguments);
          };
        }

        function mg(t, e) {
          return e = +e, function () {
            sy(this, t).delay = e;
          };
        }

        function vg(t, e) {
          return function () {
            cy(this, t).duration = +e.apply(this, arguments);
          };
        }

        function bg(t, e) {
          return e = +e, function () {
            cy(this, t).duration = e;
          };
        }

        function _g(t, e) {
          if ("function" != typeof e) throw new Error();
          return function () {
            cy(this, t).ease = e;
          };
        }

        function xg(t, e, n) {
          var r,
              i,
              a = function (t) {
            return (t + "").trim().split(/^|\s+/).every(function (t) {
              var e = t.indexOf(".");
              return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
            });
          }(e) ? sy : cy;
          return function () {
            var o = a(this, t),
                s = o.on;
            s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
          };
        }

        var wg = Op.prototype.constructor;

        function kg(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function Tg(t, e, n) {
          return function (r) {
            this.style.setProperty(t, e.call(this, r), n);
          };
        }

        function Eg(t, e, n) {
          var r, i;

          function a() {
            var a = e.apply(this, arguments);
            return a !== i && (r = (i = a) && Tg(t, a, n)), r;
          }

          return a._value = e, a;
        }

        function Cg(t) {
          return function (e) {
            this.textContent = t.call(this, e);
          };
        }

        function Sg(t) {
          var e, n;

          function r() {
            var r = t.apply(this, arguments);
            return r !== n && (e = (n = r) && Cg(r)), e;
          }

          return r._value = t, r;
        }

        var Ag = 0;

        function Mg(t, e, n, r) {
          this._groups = t, this._parents = e, this._name = n, this._id = r;
        }

        function Ng() {
          return ++Ag;
        }

        var Dg = Op.prototype;

        Mg.prototype = function (t) {
          return Op().transition(t);
        }.prototype = _defineProperty({
          constructor: Mg,
          select: function select(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = bd(t));

            for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
              for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
                (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, oy(h[f], e, n, f, h, uy(s, n)));
              }
            }

            return new Mg(a, this._parents, e, n);
          },
          selectAll: function selectAll(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = wd(t));

            for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
              for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
                if (c = u[h]) {
                  for (var f, d = t.call(c, c.__data__, h, u), p = uy(c, n), y = 0, g = d.length; y < g; ++y) {
                    (f = d[y]) && oy(f, e, n, y, d, p);
                  }

                  a.push(d), o.push(c);
                }
              }
            }

            return new Mg(a, o, e, n);
          },
          selectChild: Dg.selectChild,
          selectChildren: Dg.selectChildren,
          filter: function filter(t) {
            "function" != typeof t && (t = kd(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new Mg(r, this._parents, this._name, this._id);
          },
          merge: function merge(t) {
            if (t._id !== this._id) throw new Error();

            for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
              for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
                (c = u[d] || l[d]) && (f[d] = c);
              }
            }

            for (; s < r; ++s) {
              o[s] = e[s];
            }

            return new Mg(o, this._parents, this._name, this._id);
          },
          selection: function selection() {
            return new wg(this._groups, this._parents);
          },
          transition: function transition() {
            for (var t = this._name, e = this._id, n = Ng(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
              for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
                if (o = s[u]) {
                  var l = uy(o, e);
                  oy(o, t, n, u, s, {
                    time: l.time + l.delay + l.duration,
                    delay: 0,
                    duration: l.duration,
                    ease: l.ease
                  });
                }
              }
            }

            return new Mg(r, this._parents, t, n);
          },
          call: Dg.call,
          nodes: Dg.nodes,
          node: Dg.node,
          size: Dg.size,
          empty: Dg.empty,
          each: Dg.each,
          on: function on(t, e) {
            var n = this._id;
            return arguments.length < 2 ? uy(this.node(), n).on.on(t) : this.each(xg(n, t, e));
          },
          attr: function attr(t, e) {
            var n = jd(t),
                r = "transform" === n ? my : ag;
            return this.attrTween(t, "function" == typeof e ? (n.local ? hg : lg)(n, r, _y(this, "attr." + t, e)) : null == e ? (n.local ? sg : og)(n) : (n.local ? ug : cg)(n, r, e));
          },
          attrTween: function attrTween(t, e) {
            var n = "attr." + t;
            if (arguments.length < 2) return (n = this.tween(n)) && n._value;
            if (null == e) return this.tween(n, null);
            if ("function" != typeof e) throw new Error();
            var r = jd(t);
            return this.tween(n, (r.local ? pg : yg)(r, e));
          },
          style: function style(t, e, n) {
            var r = "transform" == (t += "") ? gy : ag;
            return null == e ? this.styleTween(t, function (t, e) {
              var n, r, i;
              return function () {
                var a = Zd(this, t),
                    o = (this.style.removeProperty(t), Zd(this, t));
                return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
              };
            }(t, r)).on("end.style." + t, kg(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
              var r, i, a;
              return function () {
                var o = Zd(this, t),
                    s = n(this),
                    c = s + "";
                return null == s && (this.style.removeProperty(t), c = s = Zd(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
              };
            }(t, r, _y(this, "style." + t, e))).each(function (t, e) {
              var n,
                  r,
                  i,
                  a,
                  o = "style." + e,
                  s = "end." + o;
              return function () {
                var c = cy(this, t),
                    u = c.on,
                    l = null == c.value[o] ? a || (a = kg(e)) : void 0;
                u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
              };
            }(this._id, t)) : this.styleTween(t, function (t, e, n) {
              var r,
                  i,
                  a = n + "";
              return function () {
                var o = Zd(this, t);
                return o === a ? null : o === r ? i : i = e(r = o, n);
              };
            }(t, r, e), n).on("end.style." + t, null);
          },
          styleTween: function styleTween(t, e, n) {
            var r = "style." + (t += "");
            if (arguments.length < 2) return (r = this.tween(r)) && r._value;
            if (null == e) return this.tween(r, null);
            if ("function" != typeof e) throw new Error();
            return this.tween(r, Eg(t, e, null == n ? "" : n));
          },
          text: function text(t) {
            return this.tween("text", "function" == typeof t ? function (t) {
              return function () {
                var e = t(this);
                this.textContent = null == e ? "" : e;
              };
            }(_y(this, "text", t)) : function (t) {
              return function () {
                this.textContent = t;
              };
            }(null == t ? "" : t + ""));
          },
          textTween: function textTween(t) {
            var e = "text";
            if (arguments.length < 1) return (e = this.tween(e)) && e._value;
            if (null == t) return this.tween(e, null);
            if ("function" != typeof t) throw new Error();
            return this.tween(e, Sg(t));
          },
          remove: function remove() {
            return this.on("end.remove", function (t) {
              return function () {
                var e = this.parentNode;

                for (var n in this.__transition) {
                  if (+n !== t) return;
                }

                e && e.removeChild(this);
              };
            }(this._id));
          },
          tween: function tween(t, e) {
            var n = this._id;

            if (t += "", arguments.length < 2) {
              for (var r, i = uy(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
                if ((r = i[a]).name === t) return r.value;
              }

              return null;
            }

            return this.each((null == e ? vy : by)(n, t, e));
          },
          delay: function delay(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? gg : mg)(e, t)) : uy(this.node(), e).delay;
          },
          duration: function duration(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? vg : bg)(e, t)) : uy(this.node(), e).duration;
          },
          ease: function ease(t) {
            var e = this._id;
            return arguments.length ? this.each(_g(e, t)) : uy(this.node(), e).ease;
          },
          easeVarying: function easeVarying(t) {
            if ("function" != typeof t) throw new Error();
            return this.each(function (t, e) {
              return function () {
                var n = e.apply(this, arguments);
                if ("function" != typeof n) throw new Error();
                cy(this, t).ease = n;
              };
            }(this._id, t));
          },
          end: function end() {
            var t,
                e,
                n = this,
                r = n._id,
                i = n.size();
            return new Promise(function (a, o) {
              var s = {
                value: o
              },
                  c = {
                value: function value() {
                  0 == --i && a();
                }
              };
              n.each(function () {
                var n = cy(this, r),
                    i = n.on;
                i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
              }), 0 === i && a();
            });
          }
        }, Symbol.iterator, Dg[Symbol.iterator]);

        var Og = {
          time: null,
          delay: 0,
          duration: 250,
          ease: function ease(t) {
            return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
          }
        };

        function Bg(t, e) {
          for (var n; !(n = t.__transition) || !(n = n[e]);) {
            if (!(t = t.parentNode)) throw new Error("transition ".concat(e, " not found"));
          }

          return n;
        }

        function Lg(t, e, n) {
          this.k = t, this.x = e, this.y = n;
        }

        Op.prototype.interrupt = function (t) {
          return this.each(function () {
            !function (t, e) {
              var n,
                  r,
                  i,
                  a = t.__transition,
                  o = !0;

              if (a) {
                for (i in e = null == e ? null : e + "", a) {
                  (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
                }

                o && delete t.__transition;
              }
            }(this, t);
          });
        }, Op.prototype.transition = function (t) {
          var e, n;
          t instanceof Mg ? (e = t._id, t = t._name) : (e = Ng(), (n = Og).time = Zp(), t = null == t ? null : t + "");

          for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
            for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
              (o = s[u]) && oy(o, t, e, u, s, n || Bg(o, e));
            }
          }

          return new Mg(r, this._parents, t, e);
        }, Lg.prototype = {
          constructor: Lg,
          scale: function scale(t) {
            return 1 === t ? this : new Lg(this.k * t, this.x, this.y);
          },
          translate: function translate(t, e) {
            return 0 === t & 0 === e ? this : new Lg(this.k, this.x + this.k * t, this.y + this.k * e);
          },
          apply: function apply(t) {
            return [t[0] * this.k + this.x, t[1] * this.k + this.y];
          },
          applyX: function applyX(t) {
            return t * this.k + this.x;
          },
          applyY: function applyY(t) {
            return t * this.k + this.y;
          },
          invert: function invert(t) {
            return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
          },
          invertX: function invertX(t) {
            return (t - this.x) / this.k;
          },
          invertY: function invertY(t) {
            return (t - this.y) / this.k;
          },
          rescaleX: function rescaleX(t) {
            return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
          },
          rescaleY: function rescaleY(t) {
            return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
          },
          toString: function toString() {
            return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
          }
        }, new Lg(1, 0, 0), Lg.prototype;
        var Ig = Math.abs,
            Rg = String.fromCharCode;

        function Pg(t) {
          return t.trim();
        }

        function Fg(t, e, n) {
          return t.replace(e, n);
        }

        function jg(t, e) {
          return 0 | t.charCodeAt(e);
        }

        function Yg(t, e, n) {
          return t.slice(e, n);
        }

        function Ug(t) {
          return t.length;
        }

        function zg(t) {
          return t.length;
        }

        function qg(t, e) {
          return e.push(t), t;
        }

        function $g(t, e) {
          for (var n = "", r = zg(t), i = 0; i < r; i++) {
            n += e(t[i], i, t, e) || "";
          }

          return n;
        }

        function Hg(t, e, n, r) {
          switch (t.type) {
            case "@import":
            case "decl":
              return t.return = t.return || t.value;

            case "comm":
              return "";

            case "rule":
              t.value = t.props.join(",");
          }

          return Ug(n = $g(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
        }

        var Wg = 1,
            Vg = 1,
            Gg = 0,
            Xg = 0,
            Zg = 0,
            Kg = "";

        function Qg(t, e, n, r, i, a, o) {
          return {
            value: t,
            root: e,
            parent: n,
            type: r,
            props: i,
            children: a,
            line: Wg,
            column: Vg,
            length: o,
            return: ""
          };
        }

        function Jg() {
          return Zg = Xg < Gg ? jg(Kg, Xg++) : 0, Vg++, 10 === Zg && (Vg = 1, Wg++), Zg;
        }

        function tm() {
          return jg(Kg, Xg);
        }

        function em() {
          return Xg;
        }

        function nm(t, e) {
          return Yg(Kg, t, e);
        }

        function rm(t) {
          switch (t) {
            case 0:
            case 9:
            case 10:
            case 13:
            case 32:
              return 5;

            case 33:
            case 43:
            case 44:
            case 47:
            case 62:
            case 64:
            case 126:
            case 59:
            case 123:
            case 125:
              return 4;

            case 58:
              return 3;

            case 34:
            case 39:
            case 40:
            case 91:
              return 2;

            case 41:
            case 93:
              return 1;
          }

          return 0;
        }

        function im(t) {
          return Pg(nm(Xg - 1, function t(e) {
            for (; Jg();) {
              switch (Zg) {
                case e:
                  return Xg;

                case 34:
                case 39:
                  return t(34 === e || 39 === e ? e : Zg);

                case 40:
                  41 === e && t(e);
                  break;

                case 92:
                  Jg();
              }
            }

            return Xg;
          }(91 === t ? t + 2 : 40 === t ? t + 1 : t)));
        }

        function am(t) {
          for (; (Zg = tm()) && Zg < 33;) {
            Jg();
          }

          return rm(t) > 2 || rm(Zg) > 3 ? "" : " ";
        }

        function om(t, e) {
          for (; --e && Jg() && !(Zg < 48 || Zg > 102 || Zg > 57 && Zg < 65 || Zg > 70 && Zg < 97);) {
            ;
          }

          return nm(t, em() + (e < 6 && 32 == tm() && 32 == Jg()));
        }

        function sm(t, e) {
          for (; Jg() && t + Zg !== 57 && (t + Zg !== 84 || 47 !== tm());) {
            ;
          }

          return "/*" + nm(e, Xg - 1) + "*" + Rg(47 === t ? t : Jg());
        }

        function cm(t) {
          for (; !rm(tm());) {
            Jg();
          }

          return nm(t, Xg);
        }

        function um(t) {
          return function (t) {
            return Kg = "", t;
          }(function t(e, n, r, i, a, o, s, c, u) {
            for (var l = 0, h = 0, f = s, d = 0, p = 0, y = 0, g = 1, m = 1, v = 1, b = 0, _ = "", x = a, w = o, k = i, T = _; m;) {
              switch (y = b, b = Jg()) {
                case 34:
                case 39:
                case 91:
                case 40:
                  T += im(b);
                  break;

                case 9:
                case 10:
                case 13:
                case 32:
                  T += am(y);
                  break;

                case 92:
                  T += om(em() - 1, 7);
                  continue;

                case 47:
                  switch (tm()) {
                    case 42:
                    case 47:
                      qg(hm(sm(Jg(), em()), n, r), u);
                      break;

                    default:
                      T += "/";
                  }

                  break;

                case 123 * g:
                  c[l++] = Ug(T) * v;

                case 125 * g:
                case 59:
                case 0:
                  switch (b) {
                    case 0:
                    case 125:
                      m = 0;

                    case 59 + h:
                      p > 0 && Ug(T) - f && qg(p > 32 ? fm(T + ";", i, r, f - 1) : fm(Fg(T, " ", "") + ";", i, r, f - 2), u);
                      break;

                    case 59:
                      T += ";";

                    default:
                      if (qg(k = lm(T, n, r, l, h, a, c, _, x = [], w = [], f), o), 123 === b) if (0 === h) t(T, n, k, k, x, o, f, c, w);else switch (d) {
                        case 100:
                        case 109:
                        case 115:
                          t(e, k, k, i && qg(lm(e, k, k, 0, 0, a, c, _, a, x = [], f), w), a, w, f, c, i ? x : w);
                          break;

                        default:
                          t(T, k, k, k, [""], w, f, c, w);
                      }
                  }

                  l = h = p = 0, g = v = 1, _ = T = "", f = s;
                  break;

                case 58:
                  f = 1 + Ug(T), p = y;

                default:
                  if (g < 1) if (123 == b) --g;else if (125 == b && 0 == g++ && 125 == (Zg = Xg > 0 ? jg(Kg, --Xg) : 0, Vg--, 10 === Zg && (Vg = 1, Wg--), Zg)) continue;

                  switch (T += Rg(b), b * g) {
                    case 38:
                      v = h > 0 ? 1 : (T += "\f", -1);
                      break;

                    case 44:
                      c[l++] = (Ug(T) - 1) * v, v = 1;
                      break;

                    case 64:
                      45 === tm() && (T += im(Jg())), d = tm(), h = Ug(_ = T += cm(em())), b++;
                      break;

                    case 45:
                      45 === y && 2 == Ug(T) && (g = 0);
                  }

              }
            }

            return o;
          }("", null, null, null, [""], t = function (t) {
            return Wg = Vg = 1, Gg = Ug(Kg = t), Xg = 0, [];
          }(t), 0, [0], t));
        }

        function lm(t, e, n, r, i, a, o, s, c, u, l) {
          for (var h = i - 1, f = 0 === i ? a : [""], d = zg(f), p = 0, y = 0, g = 0; p < r; ++p) {
            for (var m = 0, v = Yg(t, h + 1, h = Ig(y = o[p])), b = t; m < d; ++m) {
              (b = Pg(y > 0 ? f[m] + " " + v : Fg(v, /&\f/g, f[m]))) && (c[g++] = b);
            }
          }

          return Qg(t, e, n, 0 === i ? "rule" : s, c, u, l);
        }

        function hm(t, e, n) {
          return Qg(t, e, n, "comm", Rg(Zg), Yg(t, 2, -2), 0);
        }

        function fm(t, e, n, r) {
          return Qg(t, e, n, "decl", Yg(t, 0, r), Yg(t, r + 1, -1), r);
        }

        var dm = n(9609),
            pm = n(7856),
            ym = n.n(pm),
            gm = function gm(t) {
          for (var e = "", n = 0; n >= 0;) {
            if (!((n = t.indexOf("<script")) >= 0)) {
              e += t, n = -1;
              break;
            }

            e += t.substr(0, n), (n = (t = t.substr(n + 1)).indexOf("<\/script>")) >= 0 && (n += 9, t = t.substr(n));
          }

          return (e = (e = (e = (e = e.replace(/script>/gi, "#")).replace(/script>/gi, "#")).replace(/javascript:/gi, "#")).replace(/onerror=/gi, "onerror:")).replace(/<iframe/gi, "");
        },
            mm = function mm(t, e) {
          return t ? ym().sanitize(function (t, e) {
            var n = t,
                r = !0;

            if (!e.flowchart || !1 !== e.flowchart.htmlLabels && "false" !== e.flowchart.htmlLabels || (r = !1), r) {
              var i = e.securityLevel;
              "antiscript" === i ? n = gm(n) : "loose" !== i && (n = (n = (n = _m(n)).replace(/</g, "&lt;").replace(/>/g, "&gt;")).replace(/=/g, "&equals;"), n = bm(n));
            }

            return n;
          }(t, e)) : t;
        },
            vm = /<br\s*\/?>/gi,
            bm = function bm(t) {
          return t.replace(/#br#/g, "<br/>");
        },
            _m = function _m(t) {
          return t.replace(vm, "#br#");
        },
            xm = function xm(t) {
          return "false" !== t && !1 !== t;
        };

        var wm = {
          getRows: function getRows(t) {
            if (!t) return 1;

            var e = _m(t);

            return (e = e.replace(/\\n/g, "#br#")).split("#br#");
          },
          sanitizeText: mm,
          sanitizeTextOrArray: function sanitizeTextOrArray(t, e) {
            return "string" == typeof t ? mm(t, e) : t.flat().map(function (t) {
              return mm(t, e);
            });
          },
          hasBreaks: function hasBreaks(t) {
            return vm.test(t);
          },
          splitBreaks: function splitBreaks(t) {
            return t.split(vm);
          },
          lineBreakRegex: vm,
          removeScript: gm,
          getUrl: function getUrl(t) {
            var e = "";
            return t && (e = (e = (e = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), e;
          },
          evaluate: xm
        };

        var km = n(8613),
            Tm = function Tm(t, e) {
          return e ? (0, km.adjust)(t, {
            s: -40,
            l: 10
          }) : (0, km.adjust)(t, {
            s: -40,
            l: -10
          });
        };

        function Em(t) {
          return (Em = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var Cm = function () {
          function t() {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.background = "#f4f4f4", this.darkMode = !1, this.primaryColor = "#fff4dd", this.noteBkgColor = "#fff5ad", this.noteTextColor = "#333", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px";
          }

          var e;
          return (e = [{
            key: "updateColors",
            value: function value() {
              this.primaryTextColor = this.primaryTextColor || (this.darkMode ? "#ddd" : "#333"), this.secondaryColor = this.secondaryColor || (0, km.adjust)(this.primaryColor, {
                h: -120
              }), this.tertiaryColor = this.tertiaryColor || (0, km.adjust)(this.primaryColor, {
                h: 180,
                l: 5
              }), this.primaryBorderColor = this.primaryBorderColor || Tm(this.primaryColor, this.darkMode), this.secondaryBorderColor = this.secondaryBorderColor || Tm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = this.tertiaryBorderColor || Tm(this.tertiaryColor, this.darkMode), this.noteBorderColor = this.noteBorderColor || Tm(this.noteBkgColor, this.darkMode), this.noteBkgColor = this.noteBkgColor || "#fff5ad", this.noteTextColor = this.noteTextColor || "#333", this.secondaryTextColor = this.secondaryTextColor || (0, km.invert)(this.secondaryColor), this.tertiaryTextColor = this.tertiaryTextColor || (0, km.invert)(this.tertiaryColor), this.lineColor = this.lineColor || (0, km.invert)(this.background), this.textColor = this.textColor || this.primaryTextColor, this.nodeBkg = this.nodeBkg || this.primaryColor, this.mainBkg = this.mainBkg || this.primaryColor, this.nodeBorder = this.nodeBorder || this.primaryBorderColor, this.clusterBkg = this.clusterBkg || this.tertiaryColor, this.clusterBorder = this.clusterBorder || this.tertiaryBorderColor, this.defaultLinkColor = this.defaultLinkColor || this.lineColor, this.titleColor = this.titleColor || this.tertiaryTextColor, this.edgeLabelBackground = this.edgeLabelBackground || (this.darkMode ? (0, km.darken)(this.secondaryColor, 30) : this.secondaryColor), this.nodeTextColor = this.nodeTextColor || this.primaryTextColor, this.actorBorder = this.actorBorder || this.primaryBorderColor, this.actorBkg = this.actorBkg || this.mainBkg, this.actorTextColor = this.actorTextColor || this.primaryTextColor, this.actorLineColor = this.actorLineColor || "grey", this.labelBoxBkgColor = this.labelBoxBkgColor || this.actorBkg, this.signalColor = this.signalColor || this.textColor, this.signalTextColor = this.signalTextColor || this.textColor, this.labelBoxBorderColor = this.labelBoxBorderColor || this.actorBorder, this.labelTextColor = this.labelTextColor || this.actorTextColor, this.loopTextColor = this.loopTextColor || this.actorTextColor, this.activationBorderColor = this.activationBorderColor || (0, km.darken)(this.secondaryColor, 10), this.activationBkgColor = this.activationBkgColor || this.secondaryColor, this.sequenceNumberColor = this.sequenceNumberColor || (0, km.invert)(this.lineColor), this.sectionBkgColor = this.sectionBkgColor || this.tertiaryColor, this.altSectionBkgColor = this.altSectionBkgColor || "white", this.sectionBkgColor = this.sectionBkgColor || this.secondaryColor, this.sectionBkgColor2 = this.sectionBkgColor2 || this.primaryColor, this.excludeBkgColor = this.excludeBkgColor || "#eeeeee", this.taskBorderColor = this.taskBorderColor || this.primaryBorderColor, this.taskBkgColor = this.taskBkgColor || this.primaryColor, this.activeTaskBorderColor = this.activeTaskBorderColor || this.primaryColor, this.activeTaskBkgColor = this.activeTaskBkgColor || (0, km.lighten)(this.primaryColor, 23), this.gridColor = this.gridColor || "lightgrey", this.doneTaskBkgColor = this.doneTaskBkgColor || "lightgrey", this.doneTaskBorderColor = this.doneTaskBorderColor || "grey", this.critBorderColor = this.critBorderColor || "#ff8888", this.critBkgColor = this.critBkgColor || "red", this.todayLineColor = this.todayLineColor || "red", this.taskTextColor = this.taskTextColor || this.textColor, this.taskTextOutsideColor = this.taskTextOutsideColor || this.textColor, this.taskTextLightColor = this.taskTextLightColor || this.textColor, this.taskTextColor = this.taskTextColor || this.primaryTextColor, this.taskTextDarkColor = this.taskTextDarkColor || this.textColor, this.taskTextClickableColor = this.taskTextClickableColor || "#003163", this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || this.tertiaryColor, this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.nodeBorder, this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.specialStateColor = this.lineColor, this.classText = this.classText || this.textColor, this.fillType0 = this.fillType0 || this.primaryColor, this.fillType1 = this.fillType1 || this.secondaryColor, this.fillType2 = this.fillType2 || (0, km.adjust)(this.primaryColor, {
                h: 64
              }), this.fillType3 = this.fillType3 || (0, km.adjust)(this.secondaryColor, {
                h: 64
              }), this.fillType4 = this.fillType4 || (0, km.adjust)(this.primaryColor, {
                h: -64
              }), this.fillType5 = this.fillType5 || (0, km.adjust)(this.secondaryColor, {
                h: -64
              }), this.fillType6 = this.fillType6 || (0, km.adjust)(this.primaryColor, {
                h: 128
              }), this.fillType7 = this.fillType7 || (0, km.adjust)(this.secondaryColor, {
                h: 128
              }), this.pie1 = this.pie1 || this.primaryColor, this.pie2 = this.pie2 || this.secondaryColor, this.pie3 = this.pie3 || this.tertiaryColor, this.pie4 = this.pie4 || (0, km.adjust)(this.primaryColor, {
                l: -10
              }), this.pie5 = this.pie5 || (0, km.adjust)(this.secondaryColor, {
                l: -10
              }), this.pie6 = this.pie6 || (0, km.adjust)(this.tertiaryColor, {
                l: -10
              }), this.pie7 = this.pie7 || (0, km.adjust)(this.primaryColor, {
                h: 60,
                l: -10
              }), this.pie8 = this.pie8 || (0, km.adjust)(this.primaryColor, {
                h: -60,
                l: -10
              }), this.pie9 = this.pie9 || (0, km.adjust)(this.primaryColor, {
                h: 120,
                l: 0
              }), this.pie10 = this.pie10 || (0, km.adjust)(this.primaryColor, {
                h: 60,
                l: -20
              }), this.pie11 = this.pie11 || (0, km.adjust)(this.primaryColor, {
                h: -60,
                l: -20
              }), this.pie12 = this.pie12 || (0, km.adjust)(this.primaryColor, {
                h: 120,
                l: -10
              }), this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, km.darken)(this.secondaryColor, 30) : this.secondaryColor), this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
            }
          }, {
            key: "calculate",
            value: function value(t) {
              var e = this;

              if ("object" === Em(t)) {
                var n = Object.keys(t);
                n.forEach(function (n) {
                  e[n] = t[n];
                }), this.updateColors(), n.forEach(function (n) {
                  e[n] = t[n];
                });
              } else this.updateColors();
            }
          }]) && function (t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
            }
          }(t.prototype, e), t;
        }();

        function Sm(t) {
          return (Sm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var Am = function () {
          function t() {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.background = "#333", this.primaryColor = "#1f2020", this.secondaryColor = (0, km.lighten)(this.primaryColor, 16), this.tertiaryColor = (0, km.adjust)(this.primaryColor, {
              h: -160
            }), this.primaryBorderColor = Tm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Tm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Tm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, km.invert)(this.primaryColor), this.secondaryTextColor = (0, km.invert)(this.secondaryColor), this.tertiaryTextColor = (0, km.invert)(this.tertiaryColor), this.lineColor = (0, km.invert)(this.background), this.textColor = (0, km.invert)(this.background), this.mainBkg = "#1f2020", this.secondBkg = "calculated", this.mainContrastColor = "lightgrey", this.darkTextColor = (0, km.lighten)((0, km.invert)("#323D47"), 10), this.lineColor = "calculated", this.border1 = "#81B1DB", this.border2 = (0, km.rgba)(255, 255, 255, .25), this.arrowheadColor = "calculated", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.labelBackground = "#181818", this.textColor = "#ccc", this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "#F9FFFE", this.edgeLabelBackground = "calculated", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "calculated", this.actorLineColor = "calculated", this.signalColor = "calculated", this.signalTextColor = "calculated", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "calculated", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "#fff5ad", this.noteTextColor = "calculated", this.activationBorderColor = "calculated", this.activationBkgColor = "calculated", this.sequenceNumberColor = "black", this.sectionBkgColor = (0, km.darken)("#EAE8D9", 30), this.altSectionBkgColor = "calculated", this.sectionBkgColor2 = "#EAE8D9", this.taskBorderColor = (0, km.rgba)(255, 255, 255, 70), this.taskBkgColor = "calculated", this.taskTextColor = "calculated", this.taskTextLightColor = "calculated", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = (0, km.rgba)(255, 255, 255, 50), this.activeTaskBkgColor = "#81B1DB", this.gridColor = "calculated", this.doneTaskBkgColor = "calculated", this.doneTaskBorderColor = "grey", this.critBorderColor = "#E83737", this.critBkgColor = "#E83737", this.taskTextDarkColor = "calculated", this.todayLineColor = "#DB5757", this.labelColor = "calculated", this.errorBkgColor = "#a44141", this.errorTextColor = "#ddd";
          }

          var e;
          return (e = [{
            key: "updateColors",
            value: function value() {
              this.secondBkg = (0, km.lighten)(this.mainBkg, 16), this.lineColor = this.mainContrastColor, this.arrowheadColor = this.mainContrastColor, this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.edgeLabelBackground = (0, km.lighten)(this.labelBackground, 25), this.actorBorder = this.border1, this.actorBkg = this.mainBkg, this.actorTextColor = this.mainContrastColor, this.actorLineColor = this.mainContrastColor, this.signalColor = this.mainContrastColor, this.signalTextColor = this.mainContrastColor, this.labelBoxBkgColor = this.actorBkg, this.labelBoxBorderColor = this.actorBorder, this.labelTextColor = this.mainContrastColor, this.loopTextColor = this.mainContrastColor, this.noteBorderColor = this.secondaryBorderColor, this.noteBkgColor = this.secondBkg, this.noteTextColor = this.secondaryTextColor, this.activationBorderColor = this.border1, this.activationBkgColor = this.secondBkg, this.altSectionBkgColor = this.background, this.taskBkgColor = (0, km.lighten)(this.mainBkg, 23), this.taskTextColor = this.darkTextColor, this.taskTextLightColor = this.mainContrastColor, this.taskTextOutsideColor = this.taskTextLightColor, this.gridColor = this.mainContrastColor, this.doneTaskBkgColor = this.mainContrastColor, this.taskTextDarkColor = this.darkTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#555", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.primaryBorderColor, this.specialStateColor = "#f4f4f4", this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, km.adjust)(this.primaryColor, {
                h: 64
              }), this.fillType3 = (0, km.adjust)(this.secondaryColor, {
                h: 64
              }), this.fillType4 = (0, km.adjust)(this.primaryColor, {
                h: -64
              }), this.fillType5 = (0, km.adjust)(this.secondaryColor, {
                h: -64
              }), this.fillType6 = (0, km.adjust)(this.primaryColor, {
                h: 128
              }), this.fillType7 = (0, km.adjust)(this.secondaryColor, {
                h: 128
              }), this.pie1 = this.pie1 || "#0b0000", this.pie2 = this.pie2 || "#4d1037", this.pie3 = this.pie3 || "#3f5258", this.pie4 = this.pie4 || "#4f2f1b", this.pie5 = this.pie5 || "#6e0a0a", this.pie6 = this.pie6 || "#3b0048", this.pie7 = this.pie7 || "#995a01", this.pie8 = this.pie8 || "#154706", this.pie9 = this.pie9 || "#161722", this.pie10 = this.pie10 || "#00296f", this.pie11 = this.pie11 || "#01629c", this.pie12 = this.pie12 || "#010029", this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.classText = this.primaryTextColor, this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || (this.darkMode ? (0, km.darken)(this.secondaryColor, 30) : this.secondaryColor), this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
            }
          }, {
            key: "calculate",
            value: function value(t) {
              var e = this;

              if ("object" === Sm(t)) {
                var n = Object.keys(t);
                n.forEach(function (n) {
                  e[n] = t[n];
                }), this.updateColors(), n.forEach(function (n) {
                  e[n] = t[n];
                });
              } else this.updateColors();
            }
          }]) && function (t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
            }
          }(t.prototype, e), t;
        }();

        function Mm(t) {
          return (Mm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var Nm = function () {
          function t() {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.background = "#f4f4f4", this.primaryColor = "#ECECFF", this.secondaryColor = (0, km.adjust)(this.primaryColor, {
              h: 120
            }), this.secondaryColor = "#ffffde", this.tertiaryColor = (0, km.adjust)(this.primaryColor, {
              h: -160
            }), this.primaryBorderColor = Tm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Tm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Tm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, km.invert)(this.primaryColor), this.secondaryTextColor = (0, km.invert)(this.secondaryColor), this.tertiaryTextColor = (0, km.invert)(this.tertiaryColor), this.lineColor = (0, km.invert)(this.background), this.textColor = (0, km.invert)(this.background), this.background = "white", this.mainBkg = "#ECECFF", this.secondBkg = "#ffffde", this.lineColor = "#333333", this.border1 = "#9370DB", this.border2 = "#aaaa33", this.arrowheadColor = "#333333", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.labelBackground = "#e8e8e8", this.textColor = "#333", this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "calculated", this.edgeLabelBackground = "calculated", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "black", this.actorLineColor = "grey", this.signalColor = "calculated", this.signalTextColor = "calculated", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "calculated", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "#fff5ad", this.noteTextColor = "calculated", this.activationBorderColor = "#666", this.activationBkgColor = "#f4f4f4", this.sequenceNumberColor = "white", this.sectionBkgColor = "calculated", this.altSectionBkgColor = "calculated", this.sectionBkgColor2 = "calculated", this.excludeBkgColor = "#eeeeee", this.taskBorderColor = "calculated", this.taskBkgColor = "calculated", this.taskTextLightColor = "calculated", this.taskTextColor = this.taskTextLightColor, this.taskTextDarkColor = "calculated", this.taskTextOutsideColor = this.taskTextDarkColor, this.taskTextClickableColor = "calculated", this.activeTaskBorderColor = "calculated", this.activeTaskBkgColor = "calculated", this.gridColor = "calculated", this.doneTaskBkgColor = "calculated", this.doneTaskBorderColor = "calculated", this.critBorderColor = "calculated", this.critBkgColor = "calculated", this.todayLineColor = "calculated", this.sectionBkgColor = (0, km.rgba)(102, 102, 255, .49), this.altSectionBkgColor = "white", this.sectionBkgColor2 = "#fff400", this.taskBorderColor = "#534fbc", this.taskBkgColor = "#8a90dd", this.taskTextLightColor = "white", this.taskTextColor = "calculated", this.taskTextDarkColor = "black", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = "#534fbc", this.activeTaskBkgColor = "#bfc7ff", this.gridColor = "lightgrey", this.doneTaskBkgColor = "lightgrey", this.doneTaskBorderColor = "grey", this.critBorderColor = "#ff8888", this.critBkgColor = "red", this.todayLineColor = "red", this.labelColor = "black", this.errorBkgColor = "#552222", this.errorTextColor = "#552222", this.updateColors();
          }

          var e;
          return (e = [{
            key: "updateColors",
            value: function value() {
              this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.titleColor = this.textColor, this.edgeLabelBackground = this.labelBackground, this.actorBorder = (0, km.lighten)(this.border1, 23), this.actorBkg = this.mainBkg, this.labelBoxBkgColor = this.actorBkg, this.signalColor = this.textColor, this.signalTextColor = this.textColor, this.labelBoxBorderColor = this.actorBorder, this.labelTextColor = this.actorTextColor, this.loopTextColor = this.actorTextColor, this.noteBorderColor = this.border2, this.noteTextColor = this.actorTextColor, this.taskTextColor = this.taskTextLightColor, this.taskTextOutsideColor = this.taskTextDarkColor, this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#f0f0f0", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.nodeBorder, this.specialStateColor = this.lineColor, this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.classText = this.primaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, km.adjust)(this.primaryColor, {
                h: 64
              }), this.fillType3 = (0, km.adjust)(this.secondaryColor, {
                h: 64
              }), this.fillType4 = (0, km.adjust)(this.primaryColor, {
                h: -64
              }), this.fillType5 = (0, km.adjust)(this.secondaryColor, {
                h: -64
              }), this.fillType6 = (0, km.adjust)(this.primaryColor, {
                h: 128
              }), this.fillType7 = (0, km.adjust)(this.secondaryColor, {
                h: 128
              }), this.pie1 = this.pie1 || this.primaryColor, this.pie2 = this.pie2 || this.secondaryColor, this.pie3 = this.pie3 || (0, km.adjust)(this.tertiaryColor, {
                l: -40
              }), this.pie4 = this.pie4 || (0, km.adjust)(this.primaryColor, {
                l: -10
              }), this.pie5 = this.pie5 || (0, km.adjust)(this.secondaryColor, {
                l: -30
              }), this.pie6 = this.pie6 || (0, km.adjust)(this.tertiaryColor, {
                l: -20
              }), this.pie7 = this.pie7 || (0, km.adjust)(this.primaryColor, {
                h: 60,
                l: -20
              }), this.pie8 = this.pie8 || (0, km.adjust)(this.primaryColor, {
                h: -60,
                l: -40
              }), this.pie9 = this.pie9 || (0, km.adjust)(this.primaryColor, {
                h: 120,
                l: -40
              }), this.pie10 = this.pie10 || (0, km.adjust)(this.primaryColor, {
                h: 60,
                l: -40
              }), this.pie11 = this.pie11 || (0, km.adjust)(this.primaryColor, {
                h: -90,
                l: -40
              }), this.pie12 = this.pie12 || (0, km.adjust)(this.primaryColor, {
                h: 120,
                l: -30
              }), this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || this.labelBackground, this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
            }
          }, {
            key: "calculate",
            value: function value(t) {
              var e = this;

              if ("object" === Mm(t)) {
                var n = Object.keys(t);
                n.forEach(function (n) {
                  e[n] = t[n];
                }), this.updateColors(), n.forEach(function (n) {
                  e[n] = t[n];
                });
              } else this.updateColors();
            }
          }]) && function (t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
            }
          }(t.prototype, e), t;
        }();

        function Dm(t) {
          return (Dm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var Om = function () {
          function t() {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.background = "#f4f4f4", this.primaryColor = "#cde498", this.secondaryColor = "#cdffb2", this.background = "white", this.mainBkg = "#cde498", this.secondBkg = "#cdffb2", this.lineColor = "green", this.border1 = "#13540c", this.border2 = "#6eaa49", this.arrowheadColor = "green", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.tertiaryColor = (0, km.lighten)("#cde498", 10), this.primaryBorderColor = Tm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Tm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Tm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, km.invert)(this.primaryColor), this.secondaryTextColor = (0, km.invert)(this.secondaryColor), this.tertiaryTextColor = (0, km.invert)(this.primaryColor), this.lineColor = (0, km.invert)(this.background), this.textColor = (0, km.invert)(this.background), this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "#333", this.edgeLabelBackground = "#e8e8e8", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "black", this.actorLineColor = "grey", this.signalColor = "#333", this.signalTextColor = "#333", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "#326932", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "#fff5ad", this.noteTextColor = "calculated", this.activationBorderColor = "#666", this.activationBkgColor = "#f4f4f4", this.sequenceNumberColor = "white", this.sectionBkgColor = "#6eaa49", this.altSectionBkgColor = "white", this.sectionBkgColor2 = "#6eaa49", this.excludeBkgColor = "#eeeeee", this.taskBorderColor = "calculated", this.taskBkgColor = "#487e3a", this.taskTextLightColor = "white", this.taskTextColor = "calculated", this.taskTextDarkColor = "black", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = "calculated", this.activeTaskBkgColor = "calculated", this.gridColor = "lightgrey", this.doneTaskBkgColor = "lightgrey", this.doneTaskBorderColor = "grey", this.critBorderColor = "#ff8888", this.critBkgColor = "red", this.todayLineColor = "red", this.labelColor = "black", this.errorBkgColor = "#552222", this.errorTextColor = "#552222";
          }

          var e;
          return (e = [{
            key: "updateColors",
            value: function value() {
              this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.actorBorder = (0, km.darken)(this.mainBkg, 20), this.actorBkg = this.mainBkg, this.labelBoxBkgColor = this.actorBkg, this.labelTextColor = this.actorTextColor, this.loopTextColor = this.actorTextColor, this.noteBorderColor = this.border2, this.noteTextColor = this.actorTextColor, this.taskBorderColor = this.border1, this.taskTextColor = this.taskTextLightColor, this.taskTextOutsideColor = this.taskTextDarkColor, this.activeTaskBorderColor = this.taskBorderColor, this.activeTaskBkgColor = this.mainBkg, this.transitionColor = this.transitionColor || this.lineColor, this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#f0f0f0", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.compositeBorder = this.compositeBorder || this.nodeBorder, this.innerEndBackground = this.primaryBorderColor, this.specialStateColor = this.lineColor, this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.transitionColor = this.transitionColor || this.lineColor, this.classText = this.primaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, km.adjust)(this.primaryColor, {
                h: 64
              }), this.fillType3 = (0, km.adjust)(this.secondaryColor, {
                h: 64
              }), this.fillType4 = (0, km.adjust)(this.primaryColor, {
                h: -64
              }), this.fillType5 = (0, km.adjust)(this.secondaryColor, {
                h: -64
              }), this.fillType6 = (0, km.adjust)(this.primaryColor, {
                h: 128
              }), this.fillType7 = (0, km.adjust)(this.secondaryColor, {
                h: 128
              }), this.pie1 = this.pie1 || this.primaryColor, this.pie2 = this.pie2 || this.secondaryColor, this.pie3 = this.pie3 || this.tertiaryColor, this.pie4 = this.pie4 || (0, km.adjust)(this.primaryColor, {
                l: -30
              }), this.pie5 = this.pie5 || (0, km.adjust)(this.secondaryColor, {
                l: -30
              }), this.pie6 = this.pie6 || (0, km.adjust)(this.tertiaryColor, {
                h: 40,
                l: -40
              }), this.pie7 = this.pie7 || (0, km.adjust)(this.primaryColor, {
                h: 60,
                l: -10
              }), this.pie8 = this.pie8 || (0, km.adjust)(this.primaryColor, {
                h: -60,
                l: -10
              }), this.pie9 = this.pie9 || (0, km.adjust)(this.primaryColor, {
                h: 120,
                l: 0
              }), this.pie10 = this.pie10 || (0, km.adjust)(this.primaryColor, {
                h: 60,
                l: -50
              }), this.pie11 = this.pie11 || (0, km.adjust)(this.primaryColor, {
                h: -60,
                l: -50
              }), this.pie12 = this.pie12 || (0, km.adjust)(this.primaryColor, {
                h: 120,
                l: -50
              }), this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground, this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
            }
          }, {
            key: "calculate",
            value: function value(t) {
              var e = this;

              if ("object" === Dm(t)) {
                var n = Object.keys(t);
                n.forEach(function (n) {
                  e[n] = t[n];
                }), this.updateColors(), n.forEach(function (n) {
                  e[n] = t[n];
                });
              } else this.updateColors();
            }
          }]) && function (t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
            }
          }(t.prototype, e), t;
        }();

        function Bm(t) {
          return (Bm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var Lm = function () {
          function t() {
            !function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, t), this.primaryColor = "#eee", this.contrast = "#707070", this.secondaryColor = (0, km.lighten)(this.contrast, 55), this.background = "#ffffff", this.tertiaryColor = (0, km.adjust)(this.primaryColor, {
              h: -160
            }), this.primaryBorderColor = Tm(this.primaryColor, this.darkMode), this.secondaryBorderColor = Tm(this.secondaryColor, this.darkMode), this.tertiaryBorderColor = Tm(this.tertiaryColor, this.darkMode), this.primaryTextColor = (0, km.invert)(this.primaryColor), this.secondaryTextColor = (0, km.invert)(this.secondaryColor), this.tertiaryTextColor = (0, km.invert)(this.tertiaryColor), this.lineColor = (0, km.invert)(this.background), this.textColor = (0, km.invert)(this.background), this.mainBkg = "#eee", this.secondBkg = "calculated", this.lineColor = "#666", this.border1 = "#999", this.border2 = "calculated", this.note = "#ffa", this.text = "#333", this.critical = "#d42", this.done = "#bbb", this.arrowheadColor = "#333333", this.fontFamily = '"trebuchet ms", verdana, arial, sans-serif', this.fontSize = "16px", this.nodeBkg = "calculated", this.nodeBorder = "calculated", this.clusterBkg = "calculated", this.clusterBorder = "calculated", this.defaultLinkColor = "calculated", this.titleColor = "calculated", this.edgeLabelBackground = "white", this.actorBorder = "calculated", this.actorBkg = "calculated", this.actorTextColor = "calculated", this.actorLineColor = "calculated", this.signalColor = "calculated", this.signalTextColor = "calculated", this.labelBoxBkgColor = "calculated", this.labelBoxBorderColor = "calculated", this.labelTextColor = "calculated", this.loopTextColor = "calculated", this.noteBorderColor = "calculated", this.noteBkgColor = "calculated", this.noteTextColor = "calculated", this.activationBorderColor = "#666", this.activationBkgColor = "#f4f4f4", this.sequenceNumberColor = "white", this.sectionBkgColor = "calculated", this.altSectionBkgColor = "white", this.sectionBkgColor2 = "calculated", this.excludeBkgColor = "#eeeeee", this.taskBorderColor = "calculated", this.taskBkgColor = "calculated", this.taskTextLightColor = "white", this.taskTextColor = "calculated", this.taskTextDarkColor = "calculated", this.taskTextOutsideColor = "calculated", this.taskTextClickableColor = "#003163", this.activeTaskBorderColor = "calculated", this.activeTaskBkgColor = "calculated", this.gridColor = "calculated", this.doneTaskBkgColor = "calculated", this.doneTaskBorderColor = "calculated", this.critBkgColor = "calculated", this.critBorderColor = "calculated", this.todayLineColor = "calculated", this.labelColor = "black", this.errorBkgColor = "#552222", this.errorTextColor = "#552222";
          }

          var e;
          return (e = [{
            key: "updateColors",
            value: function value() {
              this.secondBkg = (0, km.lighten)(this.contrast, 55), this.border2 = this.contrast, this.nodeBkg = this.mainBkg, this.nodeBorder = this.border1, this.clusterBkg = this.secondBkg, this.clusterBorder = this.border2, this.defaultLinkColor = this.lineColor, this.titleColor = this.text, this.actorBorder = (0, km.lighten)(this.border1, 23), this.actorBkg = this.mainBkg, this.actorTextColor = this.text, this.actorLineColor = this.lineColor, this.signalColor = this.text, this.signalTextColor = this.text, this.labelBoxBkgColor = this.actorBkg, this.labelBoxBorderColor = this.actorBorder, this.labelTextColor = this.text, this.loopTextColor = this.text, this.noteBorderColor = "#999", this.noteBkgColor = "#666", this.noteTextColor = "#fff", this.sectionBkgColor = (0, km.lighten)(this.contrast, 30), this.sectionBkgColor2 = (0, km.lighten)(this.contrast, 30), this.taskBorderColor = (0, km.darken)(this.contrast, 10), this.taskBkgColor = this.contrast, this.taskTextColor = this.taskTextLightColor, this.taskTextDarkColor = this.text, this.taskTextOutsideColor = this.taskTextDarkColor, this.activeTaskBorderColor = this.taskBorderColor, this.activeTaskBkgColor = this.mainBkg, this.gridColor = (0, km.lighten)(this.border1, 30), this.doneTaskBkgColor = this.done, this.doneTaskBorderColor = this.lineColor, this.critBkgColor = this.critical, this.critBorderColor = (0, km.darken)(this.critBkgColor, 10), this.todayLineColor = this.critBkgColor, this.transitionColor = this.transitionColor || "#000", this.transitionLabelColor = this.transitionLabelColor || this.textColor, this.stateLabelColor = this.stateLabelColor || this.stateBkg || this.primaryTextColor, this.stateBkg = this.stateBkg || this.mainBkg, this.labelBackgroundColor = this.labelBackgroundColor || this.stateBkg, this.compositeBackground = this.compositeBackground || this.background || this.tertiaryColor, this.altBackground = this.altBackground || "#f4f4f4", this.compositeTitleBackground = this.compositeTitleBackground || this.mainBkg, this.stateBorder = this.stateBorder || "#000", this.innerEndBackground = this.primaryBorderColor, this.specialStateColor = "#222", this.errorBkgColor = this.errorBkgColor || this.tertiaryColor, this.errorTextColor = this.errorTextColor || this.tertiaryTextColor, this.classText = this.primaryTextColor, this.fillType0 = this.primaryColor, this.fillType1 = this.secondaryColor, this.fillType2 = (0, km.adjust)(this.primaryColor, {
                h: 64
              }), this.fillType3 = (0, km.adjust)(this.secondaryColor, {
                h: 64
              }), this.fillType4 = (0, km.adjust)(this.primaryColor, {
                h: -64
              }), this.fillType5 = (0, km.adjust)(this.secondaryColor, {
                h: -64
              }), this.fillType6 = (0, km.adjust)(this.primaryColor, {
                h: 128
              }), this.fillType7 = (0, km.adjust)(this.secondaryColor, {
                h: 128
              }), this.pie1 = this.pie1 || "#F4F4F4", this.pie2 = this.pie2 || "#555", this.pie3 = this.pie3 || "#BBB", this.pie4 = this.pie4 || "#777", this.pie5 = this.pie5 || "#999", this.pie6 = this.pie6 || "#DDD", this.pie7 = this.pie7 || "#FFF", this.pie8 = this.pie8 || "#DDD", this.pie9 = this.pie9 || "#BBB", this.pie10 = this.pie10 || "#999", this.pie11 = this.pie11 || "#777", this.pie12 = this.pie12 || "#555", this.pieTitleTextSize = this.pieTitleTextSize || "25px", this.pieTitleTextColor = this.pieTitleTextColor || this.taskTextDarkColor, this.pieSectionTextSize = this.pieSectionTextSize || "17px", this.pieSectionTextColor = this.pieSectionTextColor || this.textColor, this.pieLegendTextSize = this.pieLegendTextSize || "17px", this.pieLegendTextColor = this.pieLegendTextColor || this.taskTextDarkColor, this.pieStrokeColor = this.pieStrokeColor || "black", this.pieStrokeWidth = this.pieStrokeWidth || "2px", this.pieOpacity = this.pieOpacity || "0.7", this.requirementBackground = this.requirementBackground || this.primaryColor, this.requirementBorderColor = this.requirementBorderColor || this.primaryBorderColor, this.requirementBorderSize = this.requirementBorderSize || this.primaryBorderColor, this.requirementTextColor = this.requirementTextColor || this.primaryTextColor, this.relationColor = this.relationColor || this.lineColor, this.relationLabelBackground = this.relationLabelBackground || this.edgeLabelBackground, this.relationLabelColor = this.relationLabelColor || this.actorTextColor;
            }
          }, {
            key: "calculate",
            value: function value(t) {
              var e = this;

              if ("object" === Bm(t)) {
                var n = Object.keys(t);
                n.forEach(function (n) {
                  e[n] = t[n];
                }), this.updateColors(), n.forEach(function (n) {
                  e[n] = t[n];
                });
              } else this.updateColors();
            }
          }]) && function (t, e) {
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
            }
          }(t.prototype, e), t;
        }();

        var Im = {
          base: {
            getThemeVariables: function getThemeVariables(t) {
              var e = new Cm();
              return e.calculate(t), e;
            }
          },
          dark: {
            getThemeVariables: function getThemeVariables(t) {
              var e = new Am();
              return e.calculate(t), e;
            }
          },
          default: {
            getThemeVariables: function getThemeVariables(t) {
              var e = new Nm();
              return e.calculate(t), e;
            }
          },
          forest: {
            getThemeVariables: function getThemeVariables(t) {
              var e = new Om();
              return e.calculate(t), e;
            }
          },
          neutral: {
            getThemeVariables: function getThemeVariables(t) {
              var e = new Lm();
              return e.calculate(t), e;
            }
          }
        };

        function Rm(t) {
          return function (t) {
            if (Array.isArray(t)) return Pm(t);
          }(t) || function (t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
          }(t) || function (t, e) {
            if (t) {
              if ("string" == typeof t) return Pm(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pm(t, e) : void 0;
            }
          }(t) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function Pm(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        function Fm(t) {
          return (Fm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var jm = {
          theme: "default",
          themeVariables: Im.default.getThemeVariables(),
          themeCSS: void 0,
          maxTextSize: 5e4,
          fontFamily: '"trebuchet ms", verdana, arial, sans-serif;',
          logLevel: 5,
          securityLevel: "strict",
          startOnLoad: !0,
          arrowMarkerAbsolute: !1,
          secure: ["secure", "securityLevel", "startOnLoad", "maxTextSize"],
          deterministicIds: !1,
          deterministicIDSeed: void 0,
          flowchart: {
            diagramPadding: 8,
            htmlLabels: !0,
            nodeSpacing: 50,
            rankSpacing: 50,
            curve: "basis",
            padding: 15,
            useMaxWidth: !0,
            defaultRenderer: "dagre-d3"
          },
          sequence: {
            activationWidth: 10,
            diagramMarginX: 50,
            diagramMarginY: 10,
            actorMargin: 50,
            width: 150,
            height: 65,
            boxMargin: 10,
            boxTextMargin: 5,
            noteMargin: 10,
            messageMargin: 35,
            messageAlign: "center",
            mirrorActors: !0,
            forceMenus: !1,
            bottomMarginAdj: 1,
            useMaxWidth: !0,
            rightAngles: !1,
            showSequenceNumbers: !1,
            actorFontSize: 14,
            actorFontFamily: '"Open-Sans", "sans-serif"',
            actorFontWeight: 400,
            noteFontSize: 14,
            noteFontFamily: '"trebuchet ms", verdana, arial, sans-serif',
            noteFontWeight: 400,
            noteAlign: "center",
            messageFontSize: 16,
            messageFontFamily: '"trebuchet ms", verdana, arial, sans-serif',
            messageFontWeight: 400,
            wrap: !1,
            wrapPadding: 10,
            labelBoxWidth: 50,
            labelBoxHeight: 20,
            messageFont: function messageFont() {
              return {
                fontFamily: this.messageFontFamily,
                fontSize: this.messageFontSize,
                fontWeight: this.messageFontWeight
              };
            },
            noteFont: function noteFont() {
              return {
                fontFamily: this.noteFontFamily,
                fontSize: this.noteFontSize,
                fontWeight: this.noteFontWeight
              };
            },
            actorFont: function actorFont() {
              return {
                fontFamily: this.actorFontFamily,
                fontSize: this.actorFontSize,
                fontWeight: this.actorFontWeight
              };
            }
          },
          gantt: {
            titleTopMargin: 25,
            barHeight: 20,
            barGap: 4,
            topPadding: 50,
            rightPadding: 75,
            leftPadding: 75,
            gridLineStartPadding: 35,
            fontSize: 11,
            sectionFontSize: 11,
            numberSectionStyles: 4,
            axisFormat: "%Y-%m-%d",
            useMaxWidth: !0,
            topAxis: !1,
            useWidth: void 0
          },
          journey: {
            diagramMarginX: 50,
            diagramMarginY: 10,
            leftMargin: 150,
            width: 150,
            height: 50,
            boxMargin: 10,
            boxTextMargin: 5,
            noteMargin: 10,
            messageMargin: 35,
            messageAlign: "center",
            bottomMarginAdj: 1,
            useMaxWidth: !0,
            rightAngles: !1,
            taskFontSize: 14,
            taskFontFamily: '"Open-Sans", "sans-serif"',
            taskMargin: 50,
            activationWidth: 10,
            textPlacement: "fo",
            actorColours: ["#8FBC8F", "#7CFC00", "#00FFFF", "#20B2AA", "#B0E0E6", "#FFFFE0"],
            sectionFills: ["#191970", "#8B008B", "#4B0082", "#2F4F4F", "#800000", "#8B4513", "#00008B"],
            sectionColours: ["#fff"]
          },
          class: {
            arrowMarkerAbsolute: !1,
            useMaxWidth: !0,
            defaultRenderer: "dagre-wrapper"
          },
          git: {
            arrowMarkerAbsolute: !1,
            useWidth: void 0,
            useMaxWidth: !0
          },
          state: {
            dividerMargin: 10,
            sizeUnit: 5,
            padding: 8,
            textHeight: 10,
            titleShift: -15,
            noteMargin: 10,
            forkWidth: 70,
            forkHeight: 7,
            miniPadding: 2,
            fontSizeFactor: 5.02,
            fontSize: 24,
            labelHeight: 16,
            edgeLengthFactor: "20",
            compositTitleSize: 35,
            radius: 5,
            useMaxWidth: !0,
            defaultRenderer: "dagre-wrapper"
          },
          er: {
            diagramPadding: 20,
            layoutDirection: "TB",
            minEntityWidth: 100,
            minEntityHeight: 75,
            entityPadding: 15,
            stroke: "gray",
            fill: "honeydew",
            fontSize: 12,
            useMaxWidth: !0
          },
          pie: {
            useWidth: void 0,
            useMaxWidth: !0
          },
          requirement: {
            useWidth: void 0,
            useMaxWidth: !0,
            rect_fill: "#f9f9f9",
            text_color: "#333",
            rect_border_size: "0.5px",
            rect_border_color: "#bbb",
            rect_min_width: 200,
            rect_min_height: 200,
            fontSize: 14,
            rect_padding: 10,
            line_height: 20
          }
        };
        jm.class.arrowMarkerAbsolute = jm.arrowMarkerAbsolute, jm.git.arrowMarkerAbsolute = jm.arrowMarkerAbsolute;

        var Ym = function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return Object.keys(e).reduce(function (r, i) {
            return Array.isArray(e[i]) ? r : "object" === Fm(e[i]) && null !== e[i] ? [].concat(Rm(r), [n + i], Rm(t(e[i], ""))) : [].concat(Rm(r), [n + i]);
          }, []);
        }(jm, "");

        var Um = jm;

        function zm(t, e) {
          var _n5 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

          if (!_n5) {
            if (Array.isArray(t) || (_n5 = Hm(t)) || e && t && "number" == typeof t.length) {
              _n5 && (t = _n5);

              var r = 0,
                  i = function i() {};

              return {
                s: i,
                n: function n() {
                  return r >= t.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: t[r++]
                  };
                },
                e: function e(t) {
                  throw t;
                },
                f: i
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          var a,
              o = !0,
              s = !1;
          return {
            s: function s() {
              _n5 = _n5.call(t);
            },
            n: function n() {
              var t = _n5.next();

              return o = t.done, t;
            },
            e: function e(t) {
              s = !0, a = t;
            },
            f: function f() {
              try {
                o || null == _n5.return || _n5.return();
              } finally {
                if (s) throw a;
              }
            }
          };
        }

        function qm(t) {
          return (qm = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        function $m(t) {
          return function (t) {
            if (Array.isArray(t)) return Wm(t);
          }(t) || function (t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
          }(t) || Hm(t) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function Hm(t, e) {
          if (t) {
            if ("string" == typeof t) return Wm(t, e);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Wm(t, e) : void 0;
          }
        }

        function Wm(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        var Vm,
            Gm = {
          curveBasis: Fu,
          curveBasisClosed: function curveBasisClosed(t) {
            return new ju(t);
          },
          curveBasisOpen: function curveBasisOpen(t) {
            return new Yu(t);
          },
          curveLinear: Mu,
          curveLinearClosed: function curveLinearClosed(t) {
            return new Uu(t);
          },
          curveMonotoneX: function curveMonotoneX(t) {
            return new Wu(t);
          },
          curveMonotoneY: function curveMonotoneY(t) {
            return new Vu(t);
          },
          curveNatural: function curveNatural(t) {
            return new Xu(t);
          },
          curveStep: function curveStep(t) {
            return new Ku(t, .5);
          },
          curveStepAfter: function curveStepAfter(t) {
            return new Ku(t, 1);
          },
          curveStepBefore: function curveStepBefore(t) {
            return new Ku(t, 0);
          }
        },
            Xm = /[%]{2}[{]\s*(?:(?:(\w+)\s*:|(\w+))\s*(?:(?:(\w+))|((?:(?![}][%]{2}).|\r?\n)*))?\s*)(?:[}][%]{2})?/gi,
            Zm = /\s*(?:(?:(\w+)(?=:):|(\w+))\s*(?:(?:(\w+))|((?:(?![}][%]{2}).|\r?\n)*))?\s*)(?:[}][%]{2})?/gi,
            Km = /\s*%%.*\n/gm,
            Qm = function Qm(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

          try {
            var n = new RegExp("[%]{2}(?![{]".concat(Zm.source, ")(?=[}][%]{2}).*\n"), "ig");
            t = t.trim().replace(n, "").replace(/'/gm, '"'), o.debug("Detecting diagram directive".concat(null !== e ? " type:" + e : "", " based on the text:").concat(t));

            for (var r, i = []; null !== (r = Xm.exec(t));) {
              if (r.index === Xm.lastIndex && Xm.lastIndex++, r && !e || e && r[1] && r[1].match(e) || e && r[2] && r[2].match(e)) {
                var a = r[1] ? r[1] : r[2],
                    s = r[3] ? r[3].trim() : r[4] ? JSON.parse(r[4].trim()) : null;
                i.push({
                  type: a,
                  args: s
                });
              }
            }

            return 0 === i.length && i.push({
              type: t,
              args: null
            }), 1 === i.length ? i[0] : i;
          } catch (n) {
            return o.error("ERROR: ".concat(n.message, " - Unable to parse directive\n      ").concat(null !== e ? " type:" + e : "", " based on the text:").concat(t)), {
              type: null,
              args: null
            };
          }
        },
            Jm = function Jm(t, e) {
          return (t = t.replace(Xm, "").replace(Km, "\n")).match(/^\s*sequenceDiagram/) ? "sequence" : t.match(/^\s*gantt/) ? "gantt" : t.match(/^\s*classDiagram-v2/) ? "classDiagram" : t.match(/^\s*classDiagram/) ? e && e.class && "dagre-wrapper" === e.class.defaultRenderer ? "classDiagram" : "class" : t.match(/^\s*stateDiagram-v2/) ? "stateDiagram" : t.match(/^\s*stateDiagram/) ? e && e.class && "dagre-wrapper" === e.state.defaultRenderer ? "stateDiagram" : "state" : t.match(/^\s*gitGraph/) ? "git" : t.match(/^\s*flowchart/) ? "flowchart-v2" : t.match(/^\s*info/) ? "info" : t.match(/^\s*pie/) ? "pie" : t.match(/^\s*erDiagram/) ? "er" : t.match(/^\s*journey/) ? "journey" : t.match(/^\s*requirement/) || t.match(/^\s*requirementDiagram/) ? "requirement" : e && e.flowchart && "dagre-wrapper" === e.flowchart.defaultRenderer ? "flowchart-v2" : "flowchart";
        },
            tv = function tv(t, e) {
          var n = {};
          return function () {
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
              i[a] = arguments[a];
            }

            var o = e ? e.apply(void 0, i) : i[0];
            if (o in n) return n[o];
            var s = t.apply(void 0, i);
            return n[o] = s, s;
          };
        },
            ev = function ev(t, e) {
          if (!t) return e;
          var n = "curve".concat(t.charAt(0).toUpperCase() + t.slice(1));
          return Gm[n] || e;
        },
            nv = function nv(t, e) {
          return t && e ? Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)) : 0;
        },
            rv = function rv(t) {
          for (var e = "", n = "", r = 0; r < t.length; r++) {
            void 0 !== t[r] && (t[r].startsWith("color:") || t[r].startsWith("text-align:") ? n = n + t[r] + ";" : e = e + t[r] + ";");
          }

          return {
            style: e,
            labelStyle: n
          };
        },
            iv = 0,
            av = function av() {
          return iv++, "id-" + Math.random().toString(36).substr(2, 12) + "-" + iv;
        },
            ov = function ov(t) {
          return function (t) {
            for (var e = "", n = "0123456789abcdef", r = n.length, i = 0; i < t; i++) {
              e += n.charAt(Math.floor(Math.random() * r));
            }

            return e;
          }(t.length);
        },
            sv = function t(e, n, r) {
          var i = Object.assign({
            depth: 2,
            clobber: !1
          }, r),
              a = i.depth,
              o = i.clobber;
          return Array.isArray(n) && !Array.isArray(e) ? (n.forEach(function (n) {
            return t(e, n, r);
          }), e) : Array.isArray(n) && Array.isArray(e) ? (n.forEach(function (t) {
            -1 === e.indexOf(t) && e.push(t);
          }), e) : void 0 === e || a <= 0 ? null != e && "object" === qm(e) && "object" === qm(n) ? Object.assign(e, n) : n : (void 0 !== n && "object" === qm(e) && "object" === qm(n) && Object.keys(n).forEach(function (r) {
            "object" !== qm(n[r]) || void 0 !== e[r] && "object" !== qm(e[r]) ? (o || "object" !== qm(e[r]) && "object" !== qm(n[r])) && (e[r] = n[r]) : (void 0 === e[r] && (e[r] = Array.isArray(n[r]) ? [] : {}), e[r] = t(e[r], n[r], {
              depth: a - 1,
              clobber: o
            }));
          }), e);
        },
            cv = function cv(t, e) {
          var n = e.text.replace(wm.lineBreakRegex, " "),
              r = t.append("text");
          r.attr("x", e.x), r.attr("y", e.y), r.style("text-anchor", e.anchor), r.style("font-family", e.fontFamily), r.style("font-size", e.fontSize), r.style("font-weight", e.fontWeight), r.attr("fill", e.fill), void 0 !== e.class && r.attr("class", e.class);
          var i = r.append("tspan");
          return i.attr("x", e.x + 2 * e.textMargin), i.attr("fill", e.fill), i.text(n), r;
        },
            uv = tv(function (t, e, n) {
          if (!t) return t;
          if (n = Object.assign({
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "Arial",
            joinWith: "<br/>"
          }, n), wm.lineBreakRegex.test(t)) return t;
          var r = t.split(" "),
              i = [],
              a = "";
          return r.forEach(function (t, o) {
            var s = hv("".concat(t, " "), n),
                c = hv(a, n);

            if (s > e) {
              var u = lv(t, e, "-", n),
                  l = u.hyphenatedStrings,
                  h = u.remainingWord;
              i.push.apply(i, [a].concat($m(l))), a = h;
            } else c + s >= e ? (i.push(a), a = t) : a = [a, t].filter(Boolean).join(" ");

            o + 1 === r.length && i.push(a);
          }), i.filter(function (t) {
            return "" !== t;
          }).join(n.joinWith);
        }, function (t, e, n) {
          return "".concat(t, "-").concat(e, "-").concat(n.fontSize, "-").concat(n.fontWeight, "-").concat(n.fontFamily, "-").concat(n.joinWith);
        }),
            lv = tv(function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "-",
              r = arguments.length > 3 ? arguments[3] : void 0;
          r = Object.assign({
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "Arial",
            margin: 0
          }, r);
          var i = t.split(""),
              a = [],
              o = "";
          return i.forEach(function (t, s) {
            var c = "".concat(o).concat(t);

            if (hv(c, r) >= e) {
              var u = s + 1,
                  l = i.length === u,
                  h = "".concat(c).concat(n);
              a.push(l ? c : h), o = "";
            } else o = c;
          }), {
            hyphenatedStrings: a,
            remainingWord: o
          };
        }, function (t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "-",
              r = arguments.length > 3 ? arguments[3] : void 0;
          return "".concat(t, "-").concat(e, "-").concat(n, "-").concat(r.fontSize, "-").concat(r.fontWeight, "-").concat(r.fontFamily);
        }),
            hv = function hv(t, e) {
          return e = Object.assign({
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "Arial"
          }, e), fv(t, e).width;
        },
            fv = tv(function (t, e) {
          var n = e = Object.assign({
            fontSize: 12,
            fontWeight: 400,
            fontFamily: "Arial"
          }, e),
              r = n.fontSize,
              i = n.fontFamily,
              a = n.fontWeight;
          if (!t) return {
            width: 0,
            height: 0
          };
          var o = ["sans-serif", i],
              s = t.split(wm.lineBreakRegex),
              c = [],
              u = Zc("body");
          if (!u.remove) return {
            width: 0,
            height: 0,
            lineHeight: 0
          };

          for (var l = u.append("svg"), h = 0, f = o; h < f.length; h++) {
            var d,
                p = f[h],
                y = 0,
                g = {
              width: 0,
              height: 0,
              lineHeight: 0
            },
                m = zm(s);

            try {
              for (m.s(); !(d = m.n()).done;) {
                var v = d.value,
                    b = {
                  x: 0,
                  y: 0,
                  fill: void 0,
                  anchor: "start",
                  style: "#666",
                  width: 100,
                  height: 100,
                  textMargin: 0,
                  rx: 0,
                  ry: 0,
                  valign: void 0
                };
                b.text = v;

                var _ = cv(l, b).style("font-size", r).style("font-weight", a).style("font-family", p),
                    x = (_._groups || _)[0][0].getBBox();

                g.width = Math.round(Math.max(g.width, x.width)), y = Math.round(x.height), g.height += y, g.lineHeight = Math.round(Math.max(g.lineHeight, y));
              }
            } catch (t) {
              m.e(t);
            } finally {
              m.f();
            }

            c.push(g);
          }

          return l.remove(), c[isNaN(c[1].height) || isNaN(c[1].width) || isNaN(c[1].lineHeight) || c[0].height > c[1].height && c[0].width > c[1].width && c[0].lineHeight > c[1].lineHeight ? 0 : 1];
        }, function (t, e) {
          return "".concat(t, "-").concat(e.fontSize, "-").concat(e.fontWeight, "-").concat(e.fontFamily);
        }),
            dv = function dv(t, e, n) {
          var r = new Map();
          return r.set("height", t), n ? (r.set("width", "100%"), r.set("style", "max-width: ".concat(e, "px;"))) : r.set("width", e), r;
        },
            pv = function pv(t, e, n, r) {
          !function (t, e) {
            var n,
                r = zm(e);

            try {
              for (r.s(); !(n = r.n()).done;) {
                var i = n.value;
                t.attr(i[0], i[1]);
              }
            } catch (t) {
              r.e(t);
            } finally {
              r.f();
            }
          }(t, dv(e, n, r));
        },
            yv = function t(e) {
          o.debug("directiveSanitizer called with", e), "object" === qm(e) && (e.length ? e.forEach(function (e) {
            return t(e);
          }) : Object.keys(e).forEach(function (n) {
            o.debug("Checking key", n), 0 === n.indexOf("__") && (o.debug("sanitize deleting __ option", n), delete e[n]), n.indexOf("proto") >= 0 && (o.debug("sanitize deleting proto option", n), delete e[n]), n.indexOf("constr") >= 0 && (o.debug("sanitize deleting constr option", n), delete e[n]), Ym.indexOf(n) < 0 ? (o.debug("sanitize deleting option", n), delete e[n]) : "object" === qm(e[n]) && (o.debug("sanitize deleting object", n), t(e[n]));
          }));
        };

        var gv = {
          assignWithDepth: sv,
          wrapLabel: uv,
          calculateTextHeight: function calculateTextHeight(t, e) {
            return e = Object.assign({
              fontSize: 12,
              fontWeight: 400,
              fontFamily: "Arial",
              margin: 15
            }, e), fv(t, e).height;
          },
          calculateTextWidth: hv,
          calculateTextDimensions: fv,
          calculateSvgSizeAttrs: dv,
          configureSvgSize: pv,
          detectInit: function detectInit(t, e) {
            var n = Qm(t, /(?:init\b)|(?:initialize\b)/),
                r = {};

            if (Array.isArray(n)) {
              var i = n.map(function (t) {
                return t.args;
              });
              yv(i), r = sv(r, $m(i));
            } else r = n.args;

            if (r) {
              var a = Jm(t, e);
              ["config"].forEach(function (t) {
                void 0 !== r[t] && ("flowchart-v2" === a && (a = "flowchart"), r[a] = r[t], delete r[t]);
              });
            }

            return r;
          },
          detectDirective: Qm,
          detectType: Jm,
          isSubstringInArray: function isSubstringInArray(t, e) {
            for (var n = 0; n < e.length; n++) {
              if (e[n].match(t)) return n;
            }

            return -1;
          },
          interpolateToCurve: ev,
          calcLabelPosition: function calcLabelPosition(t) {
            return function (t) {
              var e,
                  n = 0;
              t.forEach(function (t) {
                n += nv(t, e), e = t;
              });
              var r = n / 2,
                  i = void 0;
              return e = void 0, t.forEach(function (t) {
                if (e && !i) {
                  var n = nv(t, e);
                  if (n < r) r -= n;else {
                    var a = r / n;
                    a <= 0 && (i = e), a >= 1 && (i = {
                      x: t.x,
                      y: t.y
                    }), a > 0 && a < 1 && (i = {
                      x: (1 - a) * e.x + a * t.x,
                      y: (1 - a) * e.y + a * t.y
                    });
                  }
                }

                e = t;
              }), i;
            }(t);
          },
          calcCardinalityPosition: function calcCardinalityPosition(t, e, n) {
            var r;
            o.info("our points", e), e[0] !== n && (e = e.reverse()), e.forEach(function (t) {
              nv(t, r), r = t;
            });
            var i,
                a = 25;
            r = void 0, e.forEach(function (t) {
              if (r && !i) {
                var e = nv(t, r);
                if (e < a) a -= e;else {
                  var n = a / e;
                  n <= 0 && (i = r), n >= 1 && (i = {
                    x: t.x,
                    y: t.y
                  }), n > 0 && n < 1 && (i = {
                    x: (1 - n) * r.x + n * t.x,
                    y: (1 - n) * r.y + n * t.y
                  });
                }
              }

              r = t;
            });
            var s = t ? 10 : 5,
                c = Math.atan2(e[0].y - i.y, e[0].x - i.x),
                u = {
              x: 0,
              y: 0
            };
            return u.x = Math.sin(c) * s + (e[0].x + i.x) / 2, u.y = -Math.cos(c) * s + (e[0].y + i.y) / 2, u;
          },
          calcTerminalLabelPosition: function calcTerminalLabelPosition(t, e, n) {
            var r,
                i = JSON.parse(JSON.stringify(n));
            o.info("our points", i), "start_left" !== e && "start_right" !== e && (i = i.reverse()), i.forEach(function (t) {
              nv(t, r), r = t;
            });
            var a,
                s = 25 + t;
            r = void 0, i.forEach(function (t) {
              if (r && !a) {
                var e = nv(t, r);
                if (e < s) s -= e;else {
                  var n = s / e;
                  n <= 0 && (a = r), n >= 1 && (a = {
                    x: t.x,
                    y: t.y
                  }), n > 0 && n < 1 && (a = {
                    x: (1 - n) * r.x + n * t.x,
                    y: (1 - n) * r.y + n * t.y
                  });
                }
              }

              r = t;
            });
            var c = 10 + .5 * t,
                u = Math.atan2(i[0].y - a.y, i[0].x - a.x),
                l = {
              x: 0,
              y: 0
            };
            return l.x = Math.sin(u) * c + (i[0].x + a.x) / 2, l.y = -Math.cos(u) * c + (i[0].y + a.y) / 2, "start_left" === e && (l.x = Math.sin(u + Math.PI) * c + (i[0].x + a.x) / 2, l.y = -Math.cos(u + Math.PI) * c + (i[0].y + a.y) / 2), "end_right" === e && (l.x = Math.sin(u - Math.PI) * c + (i[0].x + a.x) / 2 - 5, l.y = -Math.cos(u - Math.PI) * c + (i[0].y + a.y) / 2 - 5), "end_left" === e && (l.x = Math.sin(u) * c + (i[0].x + a.x) / 2 - 5, l.y = -Math.cos(u) * c + (i[0].y + a.y) / 2 - 5), l;
          },
          formatUrl: function formatUrl(t, e) {
            var n = t.trim();
            if (n) return "loose" !== e.securityLevel ? (0, dm.sanitizeUrl)(n) : n;
          },
          getStylesFromArray: rv,
          generateId: av,
          random: ov,
          memoize: tv,
          runFunc: function runFunc(t) {
            for (var e, n = t.split("."), r = n.length - 1, i = n[r], a = window, o = 0; o < r; o++) {
              if (!(a = a[n[o]])) return;
            }

            for (var s = arguments.length, c = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++) {
              c[u - 1] = arguments[u];
            }

            (e = a)[i].apply(e, c);
          },
          entityDecode: function entityDecode(t) {
            return Vm = Vm || document.createElement("div"), t = escape(t).replace(/%26/g, "&").replace(/%23/g, "#").replace(/%3B/g, ";"), Vm.innerHTML = t, unescape(Vm.textContent);
          },
          initIdGeneratior: function () {
            function t(e, n) {
              !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
              }(this, t), this.deterministic = e, this.seed = n, this.count = n ? n.length : 0;
            }

            var e;
            return (e = [{
              key: "next",
              value: function value() {
                return this.deterministic ? this.count++ : Date.now();
              }
            }]) && function (t, e) {
              for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
              }
            }(t.prototype, e), t;
          }(),
          directiveSanitizer: yv
        };

        function mv(t) {
          return (mv = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var vv,
            bv = Object.freeze(Um),
            _v = sv({}, bv),
            xv = [],
            wv = sv({}, bv),
            kv = function kv(t, e) {
          for (var n = sv({}, t), r = {}, i = 0; i < e.length; i++) {
            var a = e[i];
            Cv(a), r = sv(r, a);
          }

          if (n = sv(n, r), r.theme) {
            var o = sv({}, vv),
                s = sv(o.themeVariables || {}, r.themeVariables);
            n.themeVariables = Im[n.theme].getThemeVariables(s);
          }

          return wv = n, n;
        },
            Tv = function Tv() {
          return sv({}, _v);
        },
            Ev = function Ev() {
          return sv({}, wv);
        },
            Cv = function t(e) {
          Object.keys(_v.secure).forEach(function (t) {
            void 0 !== e[_v.secure[t]] && (o.debug("Denied attempt to modify a secure key ".concat(_v.secure[t]), e[_v.secure[t]]), delete e[_v.secure[t]]);
          }), Object.keys(e).forEach(function (t) {
            0 === t.indexOf("__") && delete e[t];
          }), Object.keys(e).forEach(function (n) {
            "string" == typeof e[n] && (e[n].indexOf("<") > -1 || e[n].indexOf(">") > -1 || e[n].indexOf("url(data:") > -1) && delete e[n], "object" === mv(e[n]) && t(e[n]);
          });
        },
            Sv = function Sv(t) {
          t.fontFamily && (t.themeVariables && t.themeVariables.fontFamily || (t.themeVariables = {
            fontFamily: t.fontFamily
          })), xv.push(t), kv(_v, xv);
        },
            Av = function Av() {
          kv(_v, xv = []);
        };

        function Mv(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        var Nv = "classid-",
            Dv = [],
            Ov = {},
            Bv = 0,
            Lv = [],
            Iv = function Iv(t) {
          var e = "",
              n = t;

          if (t.indexOf("~") > 0) {
            var r = t.split("~");
            n = r[0], e = wm.sanitizeText(r[1], Ev());
          }

          return {
            className: n,
            type: e
          };
        },
            Rv = function Rv(t) {
          var e = Iv(t);
          void 0 === Ov[e.className] && (Ov[e.className] = {
            id: e.className,
            type: e.type,
            cssClasses: [],
            methods: [],
            members: [],
            annotations: [],
            domId: Nv + e.className + "-" + Bv
          }, Bv++);
        },
            Pv = function Pv(t) {
          for (var e = Object.keys(Ov), n = 0; n < e.length; n++) {
            if (Ov[e[n]].id === t) return Ov[e[n]].domId;
          }
        },
            Fv = function Fv(t, e) {
          var n = Iv(t).className,
              r = Ov[n];

          if ("string" == typeof e) {
            var i = e.trim();
            i.startsWith("<<") && i.endsWith(">>") ? r.annotations.push(i.substring(2, i.length - 2)) : i.indexOf(")") > 0 ? r.methods.push(i) : i && r.members.push(i);
          }
        },
            jv = function jv(t, e) {
          t.split(",").forEach(function (t) {
            var n = t;
            t[0].match(/\d/) && (n = Nv + n), void 0 !== Ov[n] && Ov[n].cssClasses.push(e);
          });
        },
            Yv = {
          AGGREGATION: 0,
          EXTENSION: 1,
          COMPOSITION: 2,
          DEPENDENCY: 3
        },
            Uv = function Uv(t) {
          var e = Zc(".mermaidTooltip");
          null === (e._groups || e)[0][0] && (e = Zc("body").append("div").attr("class", "mermaidTooltip").style("opacity", 0)), Zc(t).select("svg").selectAll("g.node").on("mouseover", function () {
            var t = Zc(this);

            if (null !== t.attr("title")) {
              var n = this.getBoundingClientRect();
              e.transition().duration(200).style("opacity", ".9"), e.html(t.attr("title")).style("left", window.scrollX + n.left + (n.right - n.left) / 2 + "px").style("top", window.scrollY + n.top - 14 + document.body.scrollTop + "px"), t.classed("hover", !0);
            }
          }).on("mouseout", function () {
            e.transition().duration(500).style("opacity", 0), Zc(this).classed("hover", !1);
          });
        };

        Lv.push(Uv);
        var zv = "TB";
        var qv = {
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().class;
          },
          addClass: Rv,
          bindFunctions: function bindFunctions(t) {
            Lv.forEach(function (e) {
              e(t);
            });
          },
          clear: function clear() {
            Dv = [], Ov = {}, (Lv = []).push(Uv);
          },
          getClass: function getClass(t) {
            return Ov[t];
          },
          getClasses: function getClasses() {
            return Ov;
          },
          addAnnotation: function addAnnotation(t, e) {
            var n = Iv(t).className;
            Ov[n].annotations.push(e);
          },
          getRelations: function getRelations() {
            return Dv;
          },
          addRelation: function addRelation(t) {
            o.debug("Adding relation: " + JSON.stringify(t)), Rv(t.id1), Rv(t.id2), t.id1 = Iv(t.id1).className, t.id2 = Iv(t.id2).className, Dv.push(t);
          },
          getDirection: function getDirection() {
            return zv;
          },
          setDirection: function setDirection(t) {
            zv = t;
          },
          addMember: Fv,
          addMembers: function addMembers(t, e) {
            Array.isArray(e) && (e.reverse(), e.forEach(function (e) {
              return Fv(t, e);
            }));
          },
          cleanupLabel: function cleanupLabel(t) {
            return ":" === t.substring(0, 1) ? t.substr(1).trim() : t.trim();
          },
          lineType: {
            LINE: 0,
            DOTTED_LINE: 1
          },
          relationType: Yv,
          setClickEvent: function setClickEvent(t, e, n) {
            t.split(",").forEach(function (t) {
              (function (t, e, n) {
                var r = Ev(),
                    i = t,
                    a = Pv(i);

                if ("loose" === r.securityLevel && void 0 !== e && void 0 !== Ov[i]) {
                  var o = [];

                  if ("string" == typeof n) {
                    o = n.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

                    for (var s = 0; s < o.length; s++) {
                      var c = o[s].trim();
                      '"' === c.charAt(0) && '"' === c.charAt(c.length - 1) && (c = c.substr(1, c.length - 2)), o[s] = c;
                    }
                  }

                  0 === o.length && o.push(a), Lv.push(function () {
                    var t = document.querySelector('[id="'.concat(a, '"]'));
                    null !== t && t.addEventListener("click", function () {
                      var t;
                      gv.runFunc.apply(gv, [e].concat(function (t) {
                        if (Array.isArray(t)) return Mv(t);
                      }(t = o) || function (t) {
                        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                      }(t) || function (t, e) {
                        if (t) {
                          if ("string" == typeof t) return Mv(t, e);
                          var n = Object.prototype.toString.call(t).slice(8, -1);
                          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Mv(t, e) : void 0;
                        }
                      }(t) || function () {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                      }()));
                    }, !1);
                  });
                }
              })(t, e, n), Ov[t].haveCallback = !0;
            }), jv(t, "clickable");
          },
          setCssClass: jv,
          setLink: function setLink(t, e, n) {
            var r = Ev();
            t.split(",").forEach(function (t) {
              var i = t;
              t[0].match(/\d/) && (i = Nv + i), void 0 !== Ov[i] && (Ov[i].link = gv.formatUrl(e, r), Ov[i].linkTarget = "string" == typeof n ? n : "_blank");
            }), jv(t, "clickable");
          },
          setTooltip: function setTooltip(t, e) {
            var n = Ev();
            t.split(",").forEach(function (t) {
              void 0 !== e && (Ov[t].tooltip = wm.sanitizeText(e, n));
            });
          },
          lookUpDomId: Pv
        };

        var $v = n(681),
            Hv = n.n($v),
            Wv = n(8282),
            Vv = n.n(Wv),
            Gv = n(5051),
            Xv = n.n(Gv),
            Zv = 0,
            Kv = function Kv(t) {
          var e = t.match(/^(\+|-|~|#)?(\w+)(~\w+~|\[\])?\s+(\w+) *(\*|\$)?$/),
              n = t.match(/^([+|\-|~|#])?(\w+) *\( *(.*)\) *(\*|\$)? *(\w*[~|[\]]*\s*\w*~?)$/);
          return e && !n ? Qv(e) : n ? Jv(n) : tb(t);
        },
            Qv = function Qv(t) {
          var e = "",
              n = "";

          try {
            var r = t[1] ? t[1].trim() : "",
                i = t[2] ? t[2].trim() : "",
                a = t[3] ? nb(t[3].trim()) : "",
                o = t[4] ? t[4].trim() : "",
                s = t[5] ? t[5].trim() : "";
            n = r + i + a + " " + o, e = rb(s);
          } catch (e) {
            n = t;
          }

          return {
            displayText: n,
            cssStyle: e
          };
        },
            Jv = function Jv(t) {
          var e = "",
              n = "";

          try {
            var r = t[1] ? t[1].trim() : "",
                i = t[2] ? t[2].trim() : "",
                a = t[3] ? nb(t[3].trim()) : "",
                o = t[4] ? t[4].trim() : "";
            n = r + i + "(" + a + ")" + (t[5] ? " : " + nb(t[5]).trim() : ""), e = rb(o);
          } catch (e) {
            n = t;
          }

          return {
            displayText: n,
            cssStyle: e
          };
        },
            tb = function tb(t) {
          var e = "",
              n = "",
              r = "",
              i = t.indexOf("("),
              a = t.indexOf(")");

          if (i > 1 && a > i && a <= t.length) {
            var o = "",
                s = "",
                c = t.substring(0, 1);
            c.match(/\w/) ? s = t.substring(0, i).trim() : (c.match(/\+|-|~|#/) && (o = c), s = t.substring(1, i).trim());
            var u = t.substring(i + 1, a),
                l = t.substring(a + 1, 1);
            n = rb(l), e = o + s + "(" + nb(u.trim()) + ")", a < "".length && "" !== (r = t.substring(a + 2).trim()) && (r = " : " + nb(r));
          } else e = nb(t);

          return {
            displayText: e,
            cssStyle: n
          };
        },
            eb = function eb(t, e, n, r) {
          var i = Kv(e),
              a = t.append("tspan").attr("x", r.padding).text(i.displayText);
          "" !== i.cssStyle && a.attr("style", i.cssStyle), n || a.attr("dy", r.textHeight);
        },
            nb = function t(e) {
          var n = e;
          return -1 != e.indexOf("~") ? t(n = (n = n.replace("~", "<")).replace("~", ">")) : n;
        },
            rb = function rb(t) {
          switch (t) {
            case "*":
              return "font-style:italic;";

            case "$":
              return "text-decoration:underline;";

            default:
              return "";
          }
        };

        var ib = function ib(t, e, n) {
          o.info("Rendering class " + e);
          var r,
              i = e.id,
              a = {
            id: i,
            label: e.id,
            width: 0,
            height: 0
          },
              s = t.append("g").attr("id", Pv(i)).attr("class", "classGroup");
          r = e.link ? s.append("svg:a").attr("xlink:href", e.link).attr("target", e.linkTarget).append("text").attr("y", n.textHeight + n.padding).attr("x", 0) : s.append("text").attr("y", n.textHeight + n.padding).attr("x", 0);
          var c = !0;
          e.annotations.forEach(function (t) {
            var e = r.append("tspan").text("«" + t + "»");
            c || e.attr("dy", n.textHeight), c = !1;
          });
          var u = e.id;
          void 0 !== e.type && "" !== e.type && (u += "<" + e.type + ">");
          var l = r.append("tspan").text(u).attr("class", "title");
          c || l.attr("dy", n.textHeight);
          var h = r.node().getBBox().height,
              f = s.append("line").attr("x1", 0).attr("y1", n.padding + h + n.dividerMargin / 2).attr("y2", n.padding + h + n.dividerMargin / 2),
              d = s.append("text").attr("x", n.padding).attr("y", h + n.dividerMargin + n.textHeight).attr("fill", "white").attr("class", "classText");
          c = !0, e.members.forEach(function (t) {
            eb(d, t, c, n), c = !1;
          });
          var p = d.node().getBBox(),
              y = s.append("line").attr("x1", 0).attr("y1", n.padding + h + n.dividerMargin + p.height).attr("y2", n.padding + h + n.dividerMargin + p.height),
              g = s.append("text").attr("x", n.padding).attr("y", h + 2 * n.dividerMargin + p.height + n.textHeight).attr("fill", "white").attr("class", "classText");
          c = !0, e.methods.forEach(function (t) {
            eb(g, t, c, n), c = !1;
          });
          var m = s.node().getBBox(),
              v = " ";
          e.cssClasses.length > 0 && (v += e.cssClasses.join(" "));
          var b = s.insert("rect", ":first-child").attr("x", 0).attr("y", 0).attr("width", m.width + 2 * n.padding).attr("height", m.height + n.padding + .5 * n.dividerMargin).attr("class", v).node().getBBox().width;
          return r.node().childNodes.forEach(function (t) {
            t.setAttribute("x", (b - t.getBBox().width) / 2);
          }), e.tooltip && r.insert("title").text(e.tooltip), f.attr("x2", b), y.attr("x2", b), a.width = b, a.height = m.height + n.padding + .5 * n.dividerMargin, a;
        };

        Gv.parser.yy = qv;

        var ab = {},
            ob = {
          dividerMargin: 10,
          padding: 5,
          textHeight: 10
        },
            sb = function sb(t) {
          var e = Object.entries(ab).find(function (e) {
            return e[1].label === t;
          });
          if (e) return e[0];
        };

        var cb = function cb(t) {
          Object.keys(t).forEach(function (e) {
            ob[e] = t[e];
          });
        };

        var ub = {
          extension: function extension(t, e, n) {
            o.trace("Making markers for ", n), t.append("defs").append("marker").attr("id", e + "-extensionStart").attr("class", "marker extension " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 1,7 L18,13 V 1 Z"), t.append("defs").append("marker").attr("id", e + "-extensionEnd").attr("class", "marker extension " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 1,1 V 13 L18,7 Z");
          },
          composition: function composition(t, e) {
            t.append("defs").append("marker").attr("id", e + "-compositionStart").attr("class", "marker composition " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), t.append("defs").append("marker").attr("id", e + "-compositionEnd").attr("class", "marker composition " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z");
          },
          aggregation: function aggregation(t, e) {
            t.append("defs").append("marker").attr("id", e + "-aggregationStart").attr("class", "marker aggregation " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), t.append("defs").append("marker").attr("id", e + "-aggregationEnd").attr("class", "marker aggregation " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z");
          },
          dependency: function dependency(t, e) {
            t.append("defs").append("marker").attr("id", e + "-dependencyStart").attr("class", "marker dependency " + e).attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 5,7 L9,13 L1,7 L9,1 Z"), t.append("defs").append("marker").attr("id", e + "-dependencyEnd").attr("class", "marker dependency " + e).attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L14,7 L9,1 Z");
          },
          point: function point(t, e) {
            t.append("marker").attr("id", e + "-pointEnd").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 12).attr("markerHeight", 12).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0"), t.append("marker").attr("id", e + "-pointStart").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", 0).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 12).attr("markerHeight", 12).attr("orient", "auto").append("path").attr("d", "M 0 5 L 10 10 L 10 0 z").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0");
          },
          circle: function circle(t, e) {
            t.append("marker").attr("id", e + "-circleEnd").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", 11).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("circle").attr("cx", "5").attr("cy", "5").attr("r", "5").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0"), t.append("marker").attr("id", e + "-circleStart").attr("class", "marker " + e).attr("viewBox", "0 0 10 10").attr("refX", -1).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("circle").attr("cx", "5").attr("cy", "5").attr("r", "5").attr("class", "arrowMarkerPath").style("stroke-width", 1).style("stroke-dasharray", "1,0");
          },
          cross: function cross(t, e) {
            t.append("marker").attr("id", e + "-crossEnd").attr("class", "marker cross " + e).attr("viewBox", "0 0 11 11").attr("refX", 12).attr("refY", 5.2).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("path").attr("d", "M 1,1 l 9,9 M 10,1 l -9,9").attr("class", "arrowMarkerPath").style("stroke-width", 2).style("stroke-dasharray", "1,0"), t.append("marker").attr("id", e + "-crossStart").attr("class", "marker cross " + e).attr("viewBox", "0 0 11 11").attr("refX", -1).attr("refY", 5.2).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 11).attr("markerHeight", 11).attr("orient", "auto").append("path").attr("d", "M 1,1 l 9,9 M 10,1 l -9,9").attr("class", "arrowMarkerPath").style("stroke-width", 2).style("stroke-dasharray", "1,0");
          },
          barb: function barb(t, e) {
            t.append("defs").append("marker").attr("id", e + "-barbEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 14).attr("markerUnits", "strokeWidth").attr("orient", "auto").append("path").attr("d", "M 19,7 L9,13 L14,7 L9,1 Z");
          }
        };

        function lb(t) {
          return (lb = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var hb = function hb(t, e, n, r) {
          var i,
              a,
              s,
              c,
              u,
              l,
              h = t || "";
          if ("object" === lb(h) && (h = h[0]), xm(Ev().flowchart.htmlLabels)) return h = h.replace(/\\n|\n/g, "<br />"), o.info("vertexText" + h), i = {
            isNode: r,
            label: h.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
              return "<i class='".concat(t.replace(":", " "), "'></i>");
            }),
            labelStyle: e.replace("fill:", "color:")
          }, c = (s = Zc(document.createElementNS("http://www.w3.org/2000/svg", "foreignObject"))).append("xhtml:div"), u = i.label, l = i.isNode ? "nodeLabel" : "edgeLabel", c.html('<span class="' + l + '" ' + (i.labelStyle ? 'style="' + i.labelStyle + '"' : "") + ">" + u + "</span>"), (a = i.labelStyle) && c.attr("style", a), c.style("display", "inline-block"), c.style("white-space", "nowrap"), c.attr("xmlns", "http://www.w3.org/1999/xhtml"), s.node();
          var f = document.createElementNS("http://www.w3.org/2000/svg", "text");
          f.setAttribute("style", e.replace("color:", "fill:"));
          var d = [];
          d = "string" == typeof h ? h.split(/\\n|\n|<br\s*\/?>/gi) : Array.isArray(h) ? h : [];

          for (var p = 0; p < d.length; p++) {
            var y = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
            y.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), y.setAttribute("dy", "1em"), y.setAttribute("x", "0"), n ? y.setAttribute("class", "title-row") : y.setAttribute("class", "row"), y.textContent = d[p].trim(), f.appendChild(y);
          }

          return f;
        };

        var fb = function fb(t, e, n, r) {
          var i;
          i = n || "node default";
          var a = t.insert("g").attr("class", i).attr("id", e.domId || e.id),
              o = a.insert("g").attr("class", "label").attr("style", e.labelStyle),
              s = o.node().appendChild(hb(mm(XT(e.labelText), Ev()), e.labelStyle, !1, r)),
              c = s.getBBox();

          if (xm(Ev().flowchart.htmlLabels)) {
            var u = s.children[0],
                l = Zc(s);
            c = u.getBoundingClientRect(), l.attr("width", c.width), l.attr("height", c.height);
          }

          var h = e.padding / 2;
          return o.attr("transform", "translate(" + -c.width / 2 + ", " + -c.height / 2 + ")"), {
            shapeSvg: a,
            bbox: c,
            halfPadding: h,
            label: o
          };
        },
            db = function db(t, e) {
          var n = e.node().getBBox();
          t.width = n.width, t.height = n.height;
        };

        function pb(t, e, n, r) {
          return t.insert("polygon", ":first-child").attr("points", r.map(function (t) {
            return t.x + "," + t.y;
          }).join(" ")).attr("class", "label-container").attr("transform", "translate(" + -e / 2 + "," + n / 2 + ")");
        }

        var yb = {},
            gb = {},
            mb = {},
            vb = function vb(t, e) {
          return o.trace("In isDecendant", e, " ", t, " = ", gb[e].indexOf(t) >= 0), gb[e].indexOf(t) >= 0;
        },
            bb = function t(e, n, r, i) {
          o.warn("Copying children of ", e, "root", i, "data", n.node(e), i);
          var a = n.children(e) || [];
          e !== i && a.push(e), o.warn("Copying (nodes) clusterId", e, "nodes", a), a.forEach(function (a) {
            if (n.children(a).length > 0) t(a, n, r, i);else {
              var s = n.node(a);
              o.info("cp ", a, " to ", i, " with parent ", e), r.setNode(a, s), i !== n.parent(a) && (o.warn("Setting parent", a, n.parent(a)), r.setParent(a, n.parent(a))), e !== i && a !== e ? (o.debug("Setting parent", a, e), r.setParent(a, e)) : (o.info("In copy ", e, "root", i, "data", n.node(e), i), o.debug("Not Setting parent for node=", a, "cluster!==rootId", e !== i, "node!==clusterId", a !== e));
              var c = n.edges(a);
              o.debug("Copying Edges", c), c.forEach(function (t) {
                o.info("Edge", t);
                var a = n.edge(t.v, t.w, t.name);
                o.info("Edge data", a, i);

                try {
                  !function (t, e) {
                    return o.info("Decendants of ", e, " is ", gb[e]), o.info("Edge is ", t), t.v !== e && t.w !== e && (gb[e] ? (o.info("Here "), gb[e].indexOf(t.v) >= 0 || !!vb(t.v, e) || !!vb(t.w, e) || gb[e].indexOf(t.w) >= 0) : (o.debug("Tilt, ", e, ",not in decendants"), !1));
                  }(t, i) ? o.info("Skipping copy of edge ", t.v, "--\x3e", t.w, " rootId: ", i, " clusterId:", e) : (o.info("Copying as ", t.v, t.w, a, t.name), r.setEdge(t.v, t.w, a, t.name), o.info("newGraph edges ", r.edges(), r.edge(r.edges()[0])));
                } catch (t) {
                  o.error(t);
                }
              });
            }
            o.debug("Removing node", a), n.removeNode(a);
          });
        },
            _b = function t(e, n) {
          o.trace("Searching", e);
          var r = n.children(e);
          if (o.trace("Searching children of id ", e, r), r.length < 1) return o.trace("This is a valid node", e), e;

          for (var i = 0; i < r.length; i++) {
            var a = t(r[i], n);
            if (a) return o.trace("Found replacement for", e, " => ", a), a;
          }
        },
            xb = function xb(t) {
          return yb[t] && yb[t].externalConnections && yb[t] ? yb[t].id : t;
        },
            wb = function wb(t, e) {
          !t || e > 10 ? o.debug("Opting out, no graph ") : (o.debug("Opting in, graph "), t.nodes().forEach(function (e) {
            t.children(e).length > 0 && (o.warn("Cluster identified", e, " Replacement id in edges: ", _b(e, t)), gb[e] = function t(e, n) {
              for (var r = n.children(e), i = [].concat(r), a = 0; a < r.length; a++) {
                mb[r[a]] = e, i = i.concat(t(r[a], n));
              }

              return i;
            }(e, t), yb[e] = {
              id: _b(e, t),
              clusterData: t.node(e)
            });
          }), t.nodes().forEach(function (e) {
            var n = t.children(e),
                r = t.edges();
            n.length > 0 ? (o.debug("Cluster identified", e, gb), r.forEach(function (t) {
              t.v !== e && t.w !== e && vb(t.v, e) ^ vb(t.w, e) && (o.warn("Edge: ", t, " leaves cluster ", e), o.warn("Decendants of XXX ", e, ": ", gb[e]), yb[e].externalConnections = !0);
            })) : o.debug("Not a cluster ", e, gb);
          }), t.edges().forEach(function (e) {
            var n = t.edge(e);
            o.warn("Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(e)), o.warn("Edge " + e.v + " -> " + e.w + ": " + JSON.stringify(t.edge(e)));
            var r = e.v,
                i = e.w;
            o.warn("Fix XXX", yb, "ids:", e.v, e.w, "Translateing: ", yb[e.v], " --- ", yb[e.w]), (yb[e.v] || yb[e.w]) && (o.warn("Fixing and trixing - removing XXX", e.v, e.w, e.name), r = xb(e.v), i = xb(e.w), t.removeEdge(e.v, e.w, e.name), r !== e.v && (n.fromCluster = e.v), i !== e.w && (n.toCluster = e.w), o.warn("Fix Replacing with XXX", r, i, e.name), t.setEdge(r, i, n, e.name));
          }), o.warn("Adjusted Graph", Vv().json.write(t)), kb(t, 0), o.trace(yb));
        },
            kb = function t(e, n) {
          if (o.warn("extractor - ", n, Vv().json.write(e), e.children("D")), n > 10) o.error("Bailing out");else {
            for (var r = e.nodes(), i = !1, a = 0; a < r.length; a++) {
              var s = r[a],
                  c = e.children(s);
              i = i || c.length > 0;
            }

            if (i) {
              o.debug("Nodes = ", r, n);

              for (var u = 0; u < r.length; u++) {
                var l = r[u];
                if (o.debug("Extracting node", l, yb, yb[l] && !yb[l].externalConnections, !e.parent(l), e.node(l), e.children("D"), " Depth ", n), yb[l]) {
                  if (!yb[l].externalConnections && e.children(l) && e.children(l).length > 0) {
                    o.warn("Cluster without external connections, without a parent and with children", l, n);
                    var h = "TB" === e.graph().rankdir ? "LR" : "TB";
                    yb[l] && yb[l].clusterData && yb[l].clusterData.dir && (h = yb[l].clusterData.dir, o.warn("Fixing dir", yb[l].clusterData.dir, h));
                    var f = new (Vv().Graph)({
                      multigraph: !0,
                      compound: !0
                    }).setGraph({
                      rankdir: h,
                      nodesep: 50,
                      ranksep: 50,
                      marginx: 8,
                      marginy: 8
                    }).setDefaultEdgeLabel(function () {
                      return {};
                    });
                    o.warn("Old graph before copy", Vv().json.write(e)), bb(l, e, f, l), e.setNode(l, {
                      clusterNode: !0,
                      id: l,
                      clusterData: yb[l].clusterData,
                      labelText: yb[l].labelText,
                      graph: f
                    }), o.warn("New graph after copy node: (", l, ")", Vv().json.write(f)), o.debug("Old graph after copy", Vv().json.write(e));
                  } else o.warn("Cluster ** ", l, " **not meeting the criteria !externalConnections:", !yb[l].externalConnections, " no parent: ", !e.parent(l), " children ", e.children(l) && e.children(l).length > 0, e.children("D"), n), o.debug(yb);
                } else o.debug("Not a cluster", l, n);
              }

              r = e.nodes(), o.warn("New list of nodes", r);

              for (var d = 0; d < r.length; d++) {
                var p = r[d],
                    y = e.node(p);
                o.warn(" Now next level", p, y), y.clusterNode && t(y.graph, n + 1);
              }
            } else o.debug("Done, no node has children", e.nodes());
          }
        },
            Tb = function Tb(t) {
          return function t(e, n) {
            if (0 === n.length) return [];
            var r = Object.assign(n);
            return n.forEach(function (n) {
              var i = e.children(n),
                  a = t(e, i);
              r = r.concat(a);
            }), r;
          }(t, t.children());
        },
            Eb = n(3841);

        function Cb(t, e) {
          return t * e > 0;
        }

        var Sb = function Sb(t, e, n, r) {
          var i, a, o, s, c, u, l, h, f, d, p, y, g;
          if (i = e.y - t.y, o = t.x - e.x, c = e.x * t.y - t.x * e.y, f = i * n.x + o * n.y + c, d = i * r.x + o * r.y + c, !(0 !== f && 0 !== d && Cb(f, d) || (a = r.y - n.y, s = n.x - r.x, u = r.x * n.y - n.x * r.y, l = a * t.x + s * t.y + u, h = a * e.x + s * e.y + u, 0 !== l && 0 !== h && Cb(l, h) || 0 == (p = i * s - a * o)))) return y = Math.abs(p / 2), {
            x: (g = o * u - s * c) < 0 ? (g - y) / p : (g + y) / p,
            y: (g = a * c - i * u) < 0 ? (g - y) / p : (g + y) / p
          };
        },
            Ab = function Ab(t, e) {
          var n,
              r,
              i = t.x,
              a = t.y,
              o = e.x - i,
              s = e.y - a,
              c = t.width / 2,
              u = t.height / 2;
          return Math.abs(s) * c > Math.abs(o) * u ? (s < 0 && (u = -u), n = 0 === s ? 0 : u * o / s, r = u) : (o < 0 && (c = -c), n = c, r = 0 === o ? 0 : c * s / o), {
            x: i + n,
            y: a + r
          };
        },
            Mb = (n.n(Eb)(), function (t, e, n) {
          return function (t, e, n, r) {
            var i = t.x,
                a = t.y,
                o = i - r.x,
                s = a - r.y,
                c = Math.sqrt(e * e * s * s + n * n * o * o),
                u = Math.abs(e * n * o / c);
            r.x < i && (u = -u);
            var l = Math.abs(e * n * s / c);
            return r.y < a && (l = -l), {
              x: i + u,
              y: a + l
            };
          }(t, e, e, n);
        }),
            Nb = function Nb(t, e, n) {
          var r = t.x,
              i = t.y,
              a = [],
              o = Number.POSITIVE_INFINITY,
              s = Number.POSITIVE_INFINITY;
          "function" == typeof e.forEach ? e.forEach(function (t) {
            o = Math.min(o, t.x), s = Math.min(s, t.y);
          }) : (o = Math.min(o, e.x), s = Math.min(s, e.y));

          for (var c = r - t.width / 2 - o, u = i - t.height / 2 - s, l = 0; l < e.length; l++) {
            var h = e[l],
                f = e[l < e.length - 1 ? l + 1 : 0],
                d = Sb(t, n, {
              x: c + h.x,
              y: u + h.y
            }, {
              x: c + f.x,
              y: u + f.y
            });
            d && a.push(d);
          }

          return a.length ? (a.length > 1 && a.sort(function (t, e) {
            var r = t.x - n.x,
                i = t.y - n.y,
                a = Math.sqrt(r * r + i * i),
                o = e.x - n.x,
                s = e.y - n.y,
                c = Math.sqrt(o * o + s * s);
            return a < c ? -1 : a === c ? 0 : 1;
          }), a[0]) : t;
        },
            Db = Ab;

        function Ob(t) {
          return (Ob = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var Bb = function Bb(t, e, n) {
          var r = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id),
              i = 70,
              a = 10;
          "LR" === n && (i = 10, a = 70);
          var o = r.append("rect").attr("x", -1 * i / 2).attr("y", -1 * a / 2).attr("width", i).attr("height", a).attr("class", "fork-join");
          return db(e, o), e.height = e.height + e.padding / 2, e.width = e.width + e.padding / 2, e.intersect = function (t) {
            return Db(e, t);
          }, r;
        },
            Lb = {
          question: function question(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding + (i.height + e.padding),
                s = [{
              x: a / 2,
              y: 0
            }, {
              x: a,
              y: -a / 2
            }, {
              x: a / 2,
              y: -a
            }, {
              x: 0,
              y: -a / 2
            }];
            o.info("Question main (Circle)");
            var c = pb(r, a, a, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return o.warn("Intersect called"), Nb(e, s, t);
            }, r;
          },
          rect: function rect(t, e) {
            var n = fb(t, e, "node " + e.classes, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = n.halfPadding;
            o.trace("Classes = ", e.classes);
            var s = r.insert("rect", ":first-child");
            return s.attr("class", "basic label-container").attr("style", e.style).attr("rx", e.rx).attr("ry", e.ry).attr("x", -i.width / 2 - a).attr("y", -i.height / 2 - a).attr("width", i.width + e.padding).attr("height", i.height + e.padding), db(e, s), e.intersect = function (t) {
              return Db(e, t);
            }, r;
          },
          rectWithTitle: function rectWithTitle(t, e) {
            var n;
            n = e.classes ? "node " + e.classes : "node default";
            var r,
                i = t.insert("g").attr("class", n).attr("id", e.domId || e.id),
                a = i.insert("rect", ":first-child"),
                s = i.insert("line"),
                c = i.insert("g").attr("class", "label"),
                u = e.labelText.flat ? e.labelText.flat() : e.labelText;
            r = "object" === Ob(u) ? u[0] : u, o.info("Label text abc79", r, u, "object" === Ob(u));
            var l = c.node().appendChild(hb(r, e.labelStyle, !0, !0)),
                h = {
              width: 0,
              height: 0
            };

            if (xm(Ev().flowchart.htmlLabels)) {
              var f = l.children[0],
                  d = Zc(l);
              h = f.getBoundingClientRect(), d.attr("width", h.width), d.attr("height", h.height);
            }

            o.info("Text 2", u);
            var p = u.slice(1, u.length),
                y = l.getBBox(),
                g = c.node().appendChild(hb(p.join ? p.join("<br/>") : p, e.labelStyle, !0, !0));

            if (xm(Ev().flowchart.htmlLabels)) {
              var m = g.children[0],
                  v = Zc(g);
              h = m.getBoundingClientRect(), v.attr("width", h.width), v.attr("height", h.height);
            }

            var b = e.padding / 2;
            return Zc(g).attr("transform", "translate( " + (h.width > y.width ? 0 : (y.width - h.width) / 2) + ", " + (y.height + b + 5) + ")"), Zc(l).attr("transform", "translate( " + (h.width < y.width ? 0 : -(y.width - h.width) / 2) + ", 0)"), h = c.node().getBBox(), c.attr("transform", "translate(" + -h.width / 2 + ", " + (-h.height / 2 - b + 3) + ")"), a.attr("class", "outer title-state").attr("x", -h.width / 2 - b).attr("y", -h.height / 2 - b).attr("width", h.width + e.padding).attr("height", h.height + e.padding), s.attr("class", "divider").attr("x1", -h.width / 2 - b).attr("x2", h.width / 2 + b).attr("y1", -h.height / 2 - b + y.height + b).attr("y2", -h.height / 2 - b + y.height + b), db(e, a), e.intersect = function (t) {
              return Db(e, t);
            }, i;
          },
          choice: function choice(t, e) {
            var n = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id);
            return n.insert("polygon", ":first-child").attr("points", [{
              x: 0,
              y: 14
            }, {
              x: 14,
              y: 0
            }, {
              x: 0,
              y: -14
            }, {
              x: -14,
              y: 0
            }].map(function (t) {
              return t.x + "," + t.y;
            }).join(" ")).attr("class", "state-start").attr("r", 7).attr("width", 28).attr("height", 28), e.width = 28, e.height = 28, e.intersect = function (t) {
              return Mb(e, 14, t);
            }, n;
          },
          circle: function circle(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = n.halfPadding,
                s = r.insert("circle", ":first-child");
            return s.attr("style", e.style).attr("rx", e.rx).attr("ry", e.ry).attr("r", i.width / 2 + a).attr("width", i.width + e.padding).attr("height", i.height + e.padding), o.info("Circle main"), db(e, s), e.intersect = function (t) {
              return o.info("Circle intersect", e, i.width / 2 + a, t), Mb(e, i.width / 2 + a, t);
            }, r;
          },
          stadium: function stadium(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.height + e.padding,
                o = i.width + a / 4 + e.padding,
                s = r.insert("rect", ":first-child").attr("style", e.style).attr("rx", a / 2).attr("ry", a / 2).attr("x", -o / 2).attr("y", -a / 2).attr("width", o).attr("height", a);
            return db(e, s), e.intersect = function (t) {
              return Db(e, t);
            }, r;
          },
          hexagon: function hexagon(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.height + e.padding,
                o = a / 4,
                s = i.width + 2 * o + e.padding,
                c = [{
              x: o,
              y: 0
            }, {
              x: s - o,
              y: 0
            }, {
              x: s,
              y: -a / 2
            }, {
              x: s - o,
              y: -a
            }, {
              x: o,
              y: -a
            }, {
              x: 0,
              y: -a / 2
            }],
                u = pb(r, s, a, c);
            return u.attr("style", e.style), db(e, u), e.intersect = function (t) {
              return Nb(e, c, t);
            }, r;
          },
          rect_left_inv_arrow: function rect_left_inv_arrow(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: -o / 2,
              y: 0
            }, {
              x: a,
              y: 0
            }, {
              x: a,
              y: -o
            }, {
              x: -o / 2,
              y: -o
            }, {
              x: 0,
              y: -o / 2
            }];
            return pb(r, a, o, s).attr("style", e.style), e.width = a + o, e.height = o, e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          lean_right: function lean_right(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: -2 * o / 6,
              y: 0
            }, {
              x: a - o / 6,
              y: 0
            }, {
              x: a + 2 * o / 6,
              y: -o
            }, {
              x: o / 6,
              y: -o
            }],
                c = pb(r, a, o, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          lean_left: function lean_left(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: 2 * o / 6,
              y: 0
            }, {
              x: a + o / 6,
              y: 0
            }, {
              x: a - 2 * o / 6,
              y: -o
            }, {
              x: -o / 6,
              y: -o
            }],
                c = pb(r, a, o, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          trapezoid: function trapezoid(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: -2 * o / 6,
              y: 0
            }, {
              x: a + 2 * o / 6,
              y: 0
            }, {
              x: a - o / 6,
              y: -o
            }, {
              x: o / 6,
              y: -o
            }],
                c = pb(r, a, o, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          inv_trapezoid: function inv_trapezoid(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: o / 6,
              y: 0
            }, {
              x: a - o / 6,
              y: 0
            }, {
              x: a + 2 * o / 6,
              y: -o
            }, {
              x: -2 * o / 6,
              y: -o
            }],
                c = pb(r, a, o, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          rect_right_inv_arrow: function rect_right_inv_arrow(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: 0,
              y: 0
            }, {
              x: a + o / 2,
              y: 0
            }, {
              x: a,
              y: -o / 2
            }, {
              x: a + o / 2,
              y: -o
            }, {
              x: 0,
              y: -o
            }],
                c = pb(r, a, o, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          cylinder: function cylinder(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = a / 2,
                s = o / (2.5 + a / 50),
                c = i.height + s + e.padding,
                u = "M 0," + s + " a " + o + "," + s + " 0,0,0 " + a + " 0 a " + o + "," + s + " 0,0,0 " + -a + " 0 l 0," + c + " a " + o + "," + s + " 0,0,0 " + a + " 0 l 0," + -c,
                l = r.attr("label-offset-y", s).insert("path", ":first-child").attr("style", e.style).attr("d", u).attr("transform", "translate(" + -a / 2 + "," + -(c / 2 + s) + ")");
            return db(e, l), e.intersect = function (t) {
              var n = Db(e, t),
                  r = n.x - e.x;

              if (0 != o && (Math.abs(r) < e.width / 2 || Math.abs(r) == e.width / 2 && Math.abs(n.y - e.y) > e.height / 2 - s)) {
                var i = s * s * (1 - r * r / (o * o));
                0 != i && (i = Math.sqrt(i)), i = s - i, t.y - e.y > 0 && (i = -i), n.y += i;
              }

              return n;
            }, r;
          },
          start: function start(t, e) {
            var n = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id),
                r = n.insert("circle", ":first-child");
            return r.attr("class", "state-start").attr("r", 7).attr("width", 14).attr("height", 14), db(e, r), e.intersect = function (t) {
              return Mb(e, 7, t);
            }, n;
          },
          end: function end(t, e) {
            var n = t.insert("g").attr("class", "node default").attr("id", e.domId || e.id),
                r = n.insert("circle", ":first-child"),
                i = n.insert("circle", ":first-child");
            return i.attr("class", "state-start").attr("r", 7).attr("width", 14).attr("height", 14), r.attr("class", "state-end").attr("r", 5).attr("width", 10).attr("height", 10), db(e, i), e.intersect = function (t) {
              return Mb(e, 7, t);
            }, n;
          },
          note: function note(t, e) {
            var n = fb(t, e, "node " + e.classes, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = n.halfPadding;
            o.info("Classes = ", e.classes);
            var s = r.insert("rect", ":first-child");
            return s.attr("rx", e.rx).attr("ry", e.ry).attr("x", -i.width / 2 - a).attr("y", -i.height / 2 - a).attr("width", i.width + e.padding).attr("height", i.height + e.padding), db(e, s), e.intersect = function (t) {
              return Db(e, t);
            }, r;
          },
          subroutine: function subroutine(t, e) {
            var n = fb(t, e, void 0, !0),
                r = n.shapeSvg,
                i = n.bbox,
                a = i.width + e.padding,
                o = i.height + e.padding,
                s = [{
              x: 0,
              y: 0
            }, {
              x: a,
              y: 0
            }, {
              x: a,
              y: -o
            }, {
              x: 0,
              y: -o
            }, {
              x: 0,
              y: 0
            }, {
              x: -8,
              y: 0
            }, {
              x: a + 8,
              y: 0
            }, {
              x: a + 8,
              y: -o
            }, {
              x: -8,
              y: -o
            }, {
              x: -8,
              y: 0
            }],
                c = pb(r, a, o, s);
            return c.attr("style", e.style), db(e, c), e.intersect = function (t) {
              return Nb(e, s, t);
            }, r;
          },
          fork: Bb,
          join: Bb,
          class_box: function class_box(t, e) {
            var n,
                r = e.padding / 2;
            n = e.classes ? "node " + e.classes : "node default";
            var i = t.insert("g").attr("class", n).attr("id", e.domId || e.id),
                a = i.insert("rect", ":first-child"),
                o = i.insert("line"),
                s = i.insert("line"),
                c = 0,
                u = 4,
                l = i.insert("g").attr("class", "label"),
                h = 0,
                f = e.classData.annotations && e.classData.annotations[0],
                d = e.classData.annotations[0] ? "«" + e.classData.annotations[0] + "»" : "",
                p = l.node().appendChild(hb(d, e.labelStyle, !0, !0)),
                y = p.getBBox();

            if (xm(Ev().flowchart.htmlLabels)) {
              var g = p.children[0],
                  m = Zc(p);
              y = g.getBoundingClientRect(), m.attr("width", y.width), m.attr("height", y.height);
            }

            e.classData.annotations[0] && (u += y.height + 4, c += y.width);
            var v = e.classData.id;
            void 0 !== e.classData.type && "" !== e.classData.type && (Ev().flowchart.htmlLabels ? v += "&lt;" + e.classData.type + "&gt;" : v += "<" + e.classData.type + ">");
            var b = l.node().appendChild(hb(v, e.labelStyle, !0, !0));
            Zc(b).attr("class", "classTitle");

            var _ = b.getBBox();

            if (xm(Ev().flowchart.htmlLabels)) {
              var x = b.children[0],
                  w = Zc(b);
              _ = x.getBoundingClientRect(), w.attr("width", _.width), w.attr("height", _.height);
            }

            u += _.height + 4, _.width > c && (c = _.width);
            var k = [];
            e.classData.members.forEach(function (t) {
              var n = Kv(t),
                  r = n.displayText;
              Ev().flowchart.htmlLabels && (r = r.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
              var i = l.node().appendChild(hb(r, n.cssStyle ? n.cssStyle : e.labelStyle, !0, !0)),
                  a = i.getBBox();

              if (xm(Ev().flowchart.htmlLabels)) {
                var o = i.children[0],
                    s = Zc(i);
                a = o.getBoundingClientRect(), s.attr("width", a.width), s.attr("height", a.height);
              }

              a.width > c && (c = a.width), u += a.height + 4, k.push(i);
            }), u += 8;
            var T = [];

            if (e.classData.methods.forEach(function (t) {
              var n = Kv(t),
                  r = n.displayText;
              Ev().flowchart.htmlLabels && (r = r.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
              var i = l.node().appendChild(hb(r, n.cssStyle ? n.cssStyle : e.labelStyle, !0, !0)),
                  a = i.getBBox();

              if (xm(Ev().flowchart.htmlLabels)) {
                var o = i.children[0],
                    s = Zc(i);
                a = o.getBoundingClientRect(), s.attr("width", a.width), s.attr("height", a.height);
              }

              a.width > c && (c = a.width), u += a.height + 4, T.push(i);
            }), u += 8, f) {
              var E = (c - y.width) / 2;
              Zc(p).attr("transform", "translate( " + (-1 * c / 2 + E) + ", " + -1 * u / 2 + ")"), h = y.height + 4;
            }

            var C = (c - _.width) / 2;
            return Zc(b).attr("transform", "translate( " + (-1 * c / 2 + C) + ", " + (-1 * u / 2 + h) + ")"), h += _.height + 4, o.attr("class", "divider").attr("x1", -c / 2 - r).attr("x2", c / 2 + r).attr("y1", -u / 2 - r + 8 + h).attr("y2", -u / 2 - r + 8 + h), h += 8, k.forEach(function (t) {
              Zc(t).attr("transform", "translate( " + -c / 2 + ", " + (-1 * u / 2 + h + 4) + ")"), h += _.height + 4;
            }), h += 8, s.attr("class", "divider").attr("x1", -c / 2 - r).attr("x2", c / 2 + r).attr("y1", -u / 2 - r + 8 + h).attr("y2", -u / 2 - r + 8 + h), h += 8, T.forEach(function (t) {
              Zc(t).attr("transform", "translate( " + -c / 2 + ", " + (-1 * u / 2 + h) + ")"), h += _.height + 4;
            }), a.attr("class", "outer title-state").attr("x", -c / 2 - r).attr("y", -u / 2 - r).attr("width", c + e.padding).attr("height", u + e.padding), db(e, a), e.intersect = function (t) {
              return Db(e, t);
            }, i;
          }
        },
            Ib = {},
            Rb = function Rb(t) {
          var e = Ib[t.id];
          o.trace("Transforming node", t.diff, t, "translate(" + (t.x - t.width / 2 - 5) + ", " + t.width / 2 + ")");
          var n = t.diff || 0;
          return t.clusterNode ? e.attr("transform", "translate(" + (t.x + n - t.width / 2) + ", " + (t.y - t.height / 2 - 8) + ")") : e.attr("transform", "translate(" + t.x + ", " + t.y + ")"), n;
        },
            Pb = {
          rect: function rect(t, e) {
            o.trace("Creating subgraph rect for ", e.id, e);
            var n = t.insert("g").attr("class", "cluster" + (e.class ? " " + e.class : "")).attr("id", e.id),
                r = n.insert("rect", ":first-child"),
                i = n.insert("g").attr("class", "cluster-label"),
                a = i.node().appendChild(hb(e.labelText, e.labelStyle, void 0, !0)),
                s = a.getBBox();

            if (xm(Ev().flowchart.htmlLabels)) {
              var c = a.children[0],
                  u = Zc(a);
              s = c.getBoundingClientRect(), u.attr("width", s.width), u.attr("height", s.height);
            }

            var l = 0 * e.padding,
                h = l / 2,
                f = e.width <= s.width + l ? s.width + l : e.width;
            e.width <= s.width + l ? e.diff = (s.width - e.width) / 2 : e.diff = -e.padding / 2, o.trace("Data ", e, JSON.stringify(e)), r.attr("style", e.style).attr("rx", e.rx).attr("ry", e.ry).attr("x", e.x - f / 2).attr("y", e.y - e.height / 2 - h).attr("width", f).attr("height", e.height + l), i.attr("transform", "translate(" + (e.x - s.width / 2) + ", " + (e.y - e.height / 2 + e.padding / 3) + ")");
            var d = r.node().getBBox();
            return e.width = d.width, e.height = d.height, e.intersect = function (t) {
              return Ab(e, t);
            }, n;
          },
          roundedWithTitle: function roundedWithTitle(t, e) {
            var n = t.insert("g").attr("class", e.classes).attr("id", e.id),
                r = n.insert("rect", ":first-child"),
                i = n.insert("g").attr("class", "cluster-label"),
                a = n.append("rect"),
                o = i.node().appendChild(hb(e.labelText, e.labelStyle, void 0, !0)),
                s = o.getBBox();

            if (xm(Ev().flowchart.htmlLabels)) {
              var c = o.children[0],
                  u = Zc(o);
              s = c.getBoundingClientRect(), u.attr("width", s.width), u.attr("height", s.height);
            }

            s = o.getBBox();
            var l = 0 * e.padding,
                h = l / 2,
                f = e.width <= s.width + e.padding ? s.width + e.padding : e.width;
            e.width <= s.width + e.padding ? e.diff = (s.width + 0 * e.padding - e.width) / 2 : e.diff = -e.padding / 2, r.attr("class", "outer").attr("x", e.x - f / 2 - h).attr("y", e.y - e.height / 2 - h).attr("width", f + l).attr("height", e.height + l), a.attr("class", "inner").attr("x", e.x - f / 2 - h).attr("y", e.y - e.height / 2 - h + s.height - 1).attr("width", f + l).attr("height", e.height + l - s.height - 3), i.attr("transform", "translate(" + (e.x - s.width / 2) + ", " + (e.y - e.height / 2 - e.padding / 3 + (xm(Ev().flowchart.htmlLabels) ? 5 : 3)) + ")");
            var d = r.node().getBBox();
            return e.height = d.height, e.intersect = function (t) {
              return Ab(e, t);
            }, n;
          },
          noteGroup: function noteGroup(t, e) {
            var n = t.insert("g").attr("class", "note-cluster").attr("id", e.id),
                r = n.insert("rect", ":first-child"),
                i = 0 * e.padding,
                a = i / 2;
            r.attr("rx", e.rx).attr("ry", e.ry).attr("x", e.x - e.width / 2 - a).attr("y", e.y - e.height / 2 - a).attr("width", e.width + i).attr("height", e.height + i).attr("fill", "none");
            var o = r.node().getBBox();
            return e.width = o.width, e.height = o.height, e.intersect = function (t) {
              return Ab(e, t);
            }, n;
          },
          divider: function divider(t, e) {
            var n = t.insert("g").attr("class", e.classes).attr("id", e.id),
                r = n.insert("rect", ":first-child"),
                i = 0 * e.padding,
                a = i / 2;
            r.attr("class", "divider").attr("x", e.x - e.width / 2 - a).attr("y", e.y - e.height / 2).attr("width", e.width + i).attr("height", e.height + i);
            var o = r.node().getBBox();
            return e.width = o.width, e.height = o.height, e.diff = -e.padding / 2, e.intersect = function (t) {
              return Ab(e, t);
            }, n;
          }
        },
            Fb = {},
            jb = {},
            Yb = {};

        function Ub(t, e) {
          Ev().flowchart.htmlLabels && t && (t.style.width = 9 * e.length + "px", t.style.height = "12px");
        }

        var zb = function zb(t, e) {
          o.warn("abc88 cutPathAtIntersect", t, e);
          var n = [],
              r = t[0],
              i = !1;
          return t.forEach(function (t) {
            if (o.info("abc88 checking point", t, e), function (t, e) {
              var n = t.x,
                  r = t.y,
                  i = Math.abs(e.x - n),
                  a = Math.abs(e.y - r),
                  o = t.width / 2,
                  s = t.height / 2;
              return i >= o || a >= s;
            }(e, t) || i) o.warn("abc88 outside", t, r), r = t, i || n.push(t);else {
              var a = function (t, e, n) {
                o.warn("intersection calc abc89:\n  outsidePoint: ".concat(JSON.stringify(e), "\n  insidePoint : ").concat(JSON.stringify(n), "\n  node        : x:").concat(t.x, " y:").concat(t.y, " w:").concat(t.width, " h:").concat(t.height));
                var r = t.x,
                    i = t.y,
                    a = Math.abs(r - n.x),
                    s = t.width / 2,
                    c = n.x < e.x ? s - a : s + a,
                    u = t.height / 2,
                    l = Math.abs(e.y - n.y),
                    h = Math.abs(e.x - n.x);

                if (Math.abs(i - e.y) * s > Math.abs(r - e.x) * u) {
                  var f = n.y < e.y ? e.y - u - i : i - u - e.y;
                  c = h * f / l;
                  var d = {
                    x: n.x < e.x ? n.x + c : n.x - h + c,
                    y: n.y < e.y ? n.y + l - f : n.y - l + f
                  };
                  return 0 === c && (d.x = e.x, d.y = e.y), 0 === h && (d.x = e.x), 0 === l && (d.y = e.y), o.warn("abc89 topp/bott calc, Q ".concat(l, ", q ").concat(f, ", R ").concat(h, ", r ").concat(c), d), d;
                }

                var p = l * (c = n.x < e.x ? e.x - s - r : r - s - e.x) / h,
                    y = n.x < e.x ? n.x + h - c : n.x - h + c,
                    g = n.y < e.y ? n.y + p : n.y - p;
                return o.warn("sides calc abc89, Q ".concat(l, ", q ").concat(p, ", R ").concat(h, ", r ").concat(c), {
                  _x: y,
                  _y: g
                }), 0 === c && (y = e.x, g = e.y), 0 === h && (y = e.x), 0 === l && (g = e.y), {
                  x: y,
                  y: g
                };
              }(e, r, t);

              o.warn("abc88 inside", t, r, a), o.warn("abc88 intersection", a);
              var s = !1;
              n.forEach(function (t) {
                s = s || t.x === a.x && t.y === a.y;
              }), n.find(function (t) {
                return t.x === a.x && t.y === a.y;
              }) ? o.warn("abc88 no intersect", a, n) : n.push(a), i = !0;
            }
          }), o.warn("abc88 returning points", n), n;
        },
            qb = function t(e, n, r, i) {
          o.info("Graph in recursive render: XXX", Vv().json.write(n), i);
          var a = n.graph().rankdir;
          o.trace("Dir in recursive render - dir:", a);
          var s = e.insert("g").attr("class", "root");
          n.nodes() ? o.info("Recursive render XXX", n.nodes()) : o.info("No nodes found for", n), n.edges().length > 0 && o.trace("Recursive edges", n.edge(n.edges()[0]));
          var c = s.insert("g").attr("class", "clusters"),
              u = s.insert("g").attr("class", "edgePaths"),
              l = s.insert("g").attr("class", "edgeLabels"),
              h = s.insert("g").attr("class", "nodes");
          n.nodes().forEach(function (e) {
            var s = n.node(e);

            if (void 0 !== i) {
              var c = JSON.parse(JSON.stringify(i.clusterData));
              o.info("Setting data for cluster XXX (", e, ") ", c, i), n.setNode(i.id, c), n.parent(e) || (o.trace("Setting parent", e, i.id), n.setParent(e, i.id, c));
            }

            if (o.info("(Insert) Node XXX" + e + ": " + JSON.stringify(n.node(e))), s && s.clusterNode) {
              o.info("Cluster identified", e, s.width, n.node(e));
              var u = t(h, s.graph, r, n.node(e)),
                  l = u.elem;
              db(s, l), s.diff = u.diff || 0, o.info("Node bounds (abc123)", e, s, s.width, s.x, s.y), function (t, e) {
                Ib[e.id] = t;
              }(l, s), o.warn("Recursive render complete ", l, s);
            } else n.children(e).length > 0 ? (o.info("Cluster - the non recursive path XXX", e, s.id, s, n), o.info(_b(s.id, n)), yb[s.id] = {
              id: _b(s.id, n),
              node: s
            }) : (o.info("Node - the non recursive path", e, s.id, s), function (t, e, n) {
              var r, i;
              e.link ? (r = t.insert("svg:a").attr("xlink:href", e.link).attr("target", e.linkTarget || "_blank"), i = Lb[e.shape](r, e, n)) : r = i = Lb[e.shape](t, e, n), e.tooltip && i.attr("title", e.tooltip), e.class && i.attr("class", "node default " + e.class), Ib[e.id] = r, e.haveCallback && Ib[e.id].attr("class", Ib[e.id].attr("class") + " clickable");
            }(h, n.node(e), a));
          }), n.edges().forEach(function (t) {
            var e = n.edge(t.v, t.w, t.name);
            o.info("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(t)), o.info("Edge " + t.v + " -> " + t.w + ": ", t, " ", JSON.stringify(n.edge(t))), o.info("Fix", yb, "ids:", t.v, t.w, "Translateing: ", yb[t.v], yb[t.w]), function (t, e) {
              var n = hb(e.label, e.labelStyle),
                  r = t.insert("g").attr("class", "edgeLabel"),
                  i = r.insert("g").attr("class", "label");
              i.node().appendChild(n);
              var a,
                  o = n.getBBox();

              if (xm(Ev().flowchart.htmlLabels)) {
                var s = n.children[0],
                    c = Zc(n);
                o = s.getBoundingClientRect(), c.attr("width", o.width), c.attr("height", o.height);
              }

              if (i.attr("transform", "translate(" + -o.width / 2 + ", " + -o.height / 2 + ")"), jb[e.id] = r, e.width = o.width, e.height = o.height, e.startLabelLeft) {
                var u = hb(e.startLabelLeft, e.labelStyle),
                    l = t.insert("g").attr("class", "edgeTerminals"),
                    h = l.insert("g").attr("class", "inner");
                a = h.node().appendChild(u);
                var f = u.getBBox();
                h.attr("transform", "translate(" + -f.width / 2 + ", " + -f.height / 2 + ")"), Yb[e.id] || (Yb[e.id] = {}), Yb[e.id].startLeft = l, Ub(a, e.startLabelLeft);
              }

              if (e.startLabelRight) {
                var d = hb(e.startLabelRight, e.labelStyle),
                    p = t.insert("g").attr("class", "edgeTerminals"),
                    y = p.insert("g").attr("class", "inner");
                a = p.node().appendChild(d), y.node().appendChild(d);
                var g = d.getBBox();
                y.attr("transform", "translate(" + -g.width / 2 + ", " + -g.height / 2 + ")"), Yb[e.id] || (Yb[e.id] = {}), Yb[e.id].startRight = p, Ub(a, e.startLabelRight);
              }

              if (e.endLabelLeft) {
                var m = hb(e.endLabelLeft, e.labelStyle),
                    v = t.insert("g").attr("class", "edgeTerminals"),
                    b = v.insert("g").attr("class", "inner");
                a = b.node().appendChild(m);

                var _ = m.getBBox();

                b.attr("transform", "translate(" + -_.width / 2 + ", " + -_.height / 2 + ")"), v.node().appendChild(m), Yb[e.id] || (Yb[e.id] = {}), Yb[e.id].endLeft = v, Ub(a, e.endLabelLeft);
              }

              if (e.endLabelRight) {
                var x = hb(e.endLabelRight, e.labelStyle),
                    w = t.insert("g").attr("class", "edgeTerminals"),
                    k = w.insert("g").attr("class", "inner");
                a = k.node().appendChild(x);
                var T = x.getBBox();
                k.attr("transform", "translate(" + -T.width / 2 + ", " + -T.height / 2 + ")"), w.node().appendChild(x), Yb[e.id] || (Yb[e.id] = {}), Yb[e.id].endRight = w, Ub(a, e.endLabelRight);
              }
            }(l, e);
          }), n.edges().forEach(function (t) {
            o.info("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(t));
          }), o.info("#############################################"), o.info("###                Layout                 ###"), o.info("#############################################"), o.info(n), Hv().layout(n), o.info("Graph after layout:", Vv().json.write(n));
          var f = 0;
          return Tb(n).forEach(function (t) {
            var e = n.node(t);
            o.info("Position " + t + ": " + JSON.stringify(n.node(t))), o.info("Position " + t + ": (" + e.x, "," + e.y, ") width: ", e.width, " height: ", e.height), e && e.clusterNode ? Rb(e) : n.children(t).length > 0 ? (function (t, e) {
              o.trace("Inserting cluster");
              var n = e.shape || "rect";
              Fb[e.id] = Pb[n](t, e);
            }(c, e), yb[e.id].node = e) : Rb(e);
          }), n.edges().forEach(function (t) {
            var e = n.edge(t);
            o.info("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(e), e), function (t, e) {
              o.info("Moving label abc78 ", t.id, t.label, jb[t.id]);
              var n = e.updatedPath ? e.updatedPath : e.originalPath;

              if (t.label) {
                var r = jb[t.id],
                    i = t.x,
                    a = t.y;

                if (n) {
                  var s = gv.calcLabelPosition(n);
                  o.info("Moving label from (", i, ",", a, ") to (", s.x, ",", s.y, ") abc78");
                }

                r.attr("transform", "translate(" + i + ", " + a + ")");
              }

              if (t.startLabelLeft) {
                var c = Yb[t.id].startLeft,
                    u = t.x,
                    l = t.y;

                if (n) {
                  var h = gv.calcTerminalLabelPosition(t.arrowTypeStart ? 10 : 0, "start_left", n);
                  u = h.x, l = h.y;
                }

                c.attr("transform", "translate(" + u + ", " + l + ")");
              }

              if (t.startLabelRight) {
                var f = Yb[t.id].startRight,
                    d = t.x,
                    p = t.y;

                if (n) {
                  var y = gv.calcTerminalLabelPosition(t.arrowTypeStart ? 10 : 0, "start_right", n);
                  d = y.x, p = y.y;
                }

                f.attr("transform", "translate(" + d + ", " + p + ")");
              }

              if (t.endLabelLeft) {
                var g = Yb[t.id].endLeft,
                    m = t.x,
                    v = t.y;

                if (n) {
                  var b = gv.calcTerminalLabelPosition(t.arrowTypeEnd ? 10 : 0, "end_left", n);
                  m = b.x, v = b.y;
                }

                g.attr("transform", "translate(" + m + ", " + v + ")");
              }

              if (t.endLabelRight) {
                var _ = Yb[t.id].endRight,
                    x = t.x,
                    w = t.y;

                if (n) {
                  var k = gv.calcTerminalLabelPosition(t.arrowTypeEnd ? 10 : 0, "end_right", n);
                  x = k.x, w = k.y;
                }

                _.attr("transform", "translate(" + x + ", " + w + ")");
              }
            }(e, function (t, e, n, r, i, a) {
              var s = n.points,
                  c = !1,
                  u = a.node(e.v),
                  l = a.node(e.w);
              o.info("abc88 InsertEdge: ", n), l.intersect && u.intersect && ((s = s.slice(1, n.points.length - 1)).unshift(u.intersect(s[0])), o.info("Last point", s[s.length - 1], l, l.intersect(s[s.length - 1])), s.push(l.intersect(s[s.length - 1]))), n.toCluster && (o.info("to cluster abc88", r[n.toCluster]), s = zb(n.points, r[n.toCluster].node), c = !0), n.fromCluster && (o.info("from cluster abc88", r[n.fromCluster]), s = zb(s.reverse(), r[n.fromCluster].node).reverse(), c = !0);
              var h,
                  f = s.filter(function (t) {
                return !Number.isNaN(t.y);
              });
              h = ("graph" === i || "flowchart" === i) && n.curve || Fu;
              var d,
                  p = Ou().x(function (t) {
                return t.x;
              }).y(function (t) {
                return t.y;
              }).curve(h);

              switch (n.thickness) {
                case "normal":
                  d = "edge-thickness-normal";
                  break;

                case "thick":
                  d = "edge-thickness-thick";
                  break;

                default:
                  d = "";
              }

              switch (n.pattern) {
                case "solid":
                  d += " edge-pattern-solid";
                  break;

                case "dotted":
                  d += " edge-pattern-dotted";
                  break;

                case "dashed":
                  d += " edge-pattern-dashed";
              }

              var y = t.append("path").attr("d", p(f)).attr("id", n.id).attr("class", " " + d + (n.classes ? " " + n.classes : "")).attr("style", n.style),
                  g = "";

              switch (Ev().state.arrowMarkerAbsolute && (g = (g = (g = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), o.info("arrowTypeStart", n.arrowTypeStart), o.info("arrowTypeEnd", n.arrowTypeEnd), n.arrowTypeStart) {
                case "arrow_cross":
                  y.attr("marker-start", "url(" + g + "#" + i + "-crossStart)");
                  break;

                case "arrow_point":
                  y.attr("marker-start", "url(" + g + "#" + i + "-pointStart)");
                  break;

                case "arrow_barb":
                  y.attr("marker-start", "url(" + g + "#" + i + "-barbStart)");
                  break;

                case "arrow_circle":
                  y.attr("marker-start", "url(" + g + "#" + i + "-circleStart)");
                  break;

                case "aggregation":
                  y.attr("marker-start", "url(" + g + "#" + i + "-aggregationStart)");
                  break;

                case "extension":
                  y.attr("marker-start", "url(" + g + "#" + i + "-extensionStart)");
                  break;

                case "composition":
                  y.attr("marker-start", "url(" + g + "#" + i + "-compositionStart)");
                  break;

                case "dependency":
                  y.attr("marker-start", "url(" + g + "#" + i + "-dependencyStart)");
              }

              switch (n.arrowTypeEnd) {
                case "arrow_cross":
                  y.attr("marker-end", "url(" + g + "#" + i + "-crossEnd)");
                  break;

                case "arrow_point":
                  y.attr("marker-end", "url(" + g + "#" + i + "-pointEnd)");
                  break;

                case "arrow_barb":
                  y.attr("marker-end", "url(" + g + "#" + i + "-barbEnd)");
                  break;

                case "arrow_circle":
                  y.attr("marker-end", "url(" + g + "#" + i + "-circleEnd)");
                  break;

                case "aggregation":
                  y.attr("marker-end", "url(" + g + "#" + i + "-aggregationEnd)");
                  break;

                case "extension":
                  y.attr("marker-end", "url(" + g + "#" + i + "-extensionEnd)");
                  break;

                case "composition":
                  y.attr("marker-end", "url(" + g + "#" + i + "-compositionEnd)");
                  break;

                case "dependency":
                  y.attr("marker-end", "url(" + g + "#" + i + "-dependencyEnd)");
              }

              var m = {};
              return c && (m.updatedPath = s), m.originalPath = n.points, m;
            }(u, t, e, yb, r, n));
          }), n.nodes().forEach(function (t) {
            var e = n.node(t);
            o.info(t, e.type, e.diff), "group" === e.type && (f = e.diff);
          }), {
            elem: s,
            diff: f
          };
        },
            $b = function $b(t, e, n, r, i) {
          (function (t, e, n, r) {
            e.forEach(function (e) {
              ub[e](t, n, r);
            });
          })(t, n, r, i), Ib = {}, jb = {}, Yb = {}, Fb = {}, gb = {}, mb = {}, yb = {}, o.warn("Graph at first:", Vv().json.write(e)), wb(e), o.warn("Graph after:", Vv().json.write(e)), qb(t, e, r);
        };

        Gv.parser.yy = qv;
        var Hb = {
          dividerMargin: 10,
          padding: 5,
          textHeight: 10
        };

        function Wb(t) {
          var e;

          switch (t) {
            case 0:
              e = "aggregation";
              break;

            case 1:
              e = "extension";
              break;

            case 2:
              e = "composition";
              break;

            case 3:
              e = "dependency";
              break;

            default:
              e = "none";
          }

          return e;
        }

        var Vb = {},
            Gb = [],
            Xb = "",
            Zb = function Zb(t) {
          return void 0 === Vb[t] && (Vb[t] = {
            attributes: []
          }, o.info("Added new entity :", t)), Vb[t];
        };

        var Kb = {
          Cardinality: {
            ZERO_OR_ONE: "ZERO_OR_ONE",
            ZERO_OR_MORE: "ZERO_OR_MORE",
            ONE_OR_MORE: "ONE_OR_MORE",
            ONLY_ONE: "ONLY_ONE"
          },
          Identification: {
            NON_IDENTIFYING: "NON_IDENTIFYING",
            IDENTIFYING: "IDENTIFYING"
          },
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().er;
          },
          addEntity: Zb,
          addAttributes: function addAttributes(t, e) {
            var n,
                r = Zb(t);

            for (n = e.length - 1; n >= 0; n--) {
              r.attributes.push(e[n]), o.debug("Added attribute ", e[n].attributeName);
            }
          },
          getEntities: function getEntities() {
            return Vb;
          },
          addRelationship: function addRelationship(t, e, n, r) {
            var i = {
              entityA: t,
              roleA: e,
              entityB: n,
              relSpec: r
            };
            Gb.push(i), o.debug("Added new relationship :", i);
          },
          getRelationships: function getRelationships() {
            return Gb;
          },
          clear: function clear() {
            Vb = {}, Gb = [], Xb = "";
          },
          setTitle: function setTitle(t) {
            Xb = t;
          },
          getTitle: function getTitle() {
            return Xb;
          }
        };
        var Qb = n(4701),
            Jb = n.n(Qb),
            t_ = {
          ONLY_ONE_START: "ONLY_ONE_START",
          ONLY_ONE_END: "ONLY_ONE_END",
          ZERO_OR_ONE_START: "ZERO_OR_ONE_START",
          ZERO_OR_ONE_END: "ZERO_OR_ONE_END",
          ONE_OR_MORE_START: "ONE_OR_MORE_START",
          ONE_OR_MORE_END: "ONE_OR_MORE_END",
          ZERO_OR_MORE_START: "ZERO_OR_MORE_START",
          ZERO_OR_MORE_END: "ZERO_OR_MORE_END"
        };
        var e_ = t_;

        var n_ = {},
            r_ = function r_(t) {
          return (t.entityA + t.roleA + t.entityB).replace(/\s/g, "");
        },
            i_ = 0;

        var a_ = function a_(t) {
          for (var e = Object.keys(t), n = 0; n < e.length; n++) {
            n_[e[n]] = t[e[n]];
          }
        };

        function o_(t) {
          return (o_ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        function s_(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        var c_,
            u_,
            l_ = 0,
            h_ = Ev(),
            f_ = {},
            d_ = [],
            p_ = [],
            y_ = [],
            g_ = {},
            m_ = {},
            v_ = 0,
            b_ = !0,
            __ = [],
            x_ = function x_(t) {
          for (var e = Object.keys(f_), n = 0; n < e.length; n++) {
            if (f_[e[n]].id === t) return f_[e[n]].domId;
          }

          return t;
        },
            w_ = function w_(t, e, n, r) {
          var i = {
            start: t,
            end: e,
            type: void 0,
            text: ""
          };
          void 0 !== (r = n.text) && (i.text = wm.sanitizeText(r.trim(), h_), '"' === i.text[0] && '"' === i.text[i.text.length - 1] && (i.text = i.text.substring(1, i.text.length - 1))), void 0 !== n && (i.type = n.type, i.stroke = n.stroke, i.length = n.length), d_.push(i);
        },
            k_ = function k_(t, e) {
          t.split(",").forEach(function (t) {
            var n = t;
            void 0 !== f_[n] && f_[n].classes.push(e), void 0 !== g_[n] && g_[n].classes.push(e);
          });
        },
            T_ = function T_(t) {
          var e = Zc(".mermaidTooltip");
          null === (e._groups || e)[0][0] && (e = Zc("body").append("div").attr("class", "mermaidTooltip").style("opacity", 0)), Zc(t).select("svg").selectAll("g.node").on("mouseover", function () {
            var t = Zc(this);

            if (null !== t.attr("title")) {
              var n = this.getBoundingClientRect();
              e.transition().duration(200).style("opacity", ".9"), e.html(t.attr("title")).style("left", window.scrollX + n.left + (n.right - n.left) / 2 + "px").style("top", window.scrollY + n.top - 14 + document.body.scrollTop + "px"), t.classed("hover", !0);
            }
          }).on("mouseout", function () {
            e.transition().duration(500).style("opacity", 0), Zc(this).classed("hover", !1);
          });
        };

        __.push(T_);

        var E_ = function E_(t) {
          for (var e = 0; e < y_.length; e++) {
            if (y_[e].id === t) return e;
          }

          return -1;
        },
            C_ = -1,
            S_ = [],
            A_ = function A_(t, e) {
          var n = !1;
          return t.forEach(function (t) {
            t.nodes.indexOf(e) >= 0 && (n = !0);
          }), n;
        },
            M_ = function M_(t, e) {
          var n = [];
          return t.nodes.forEach(function (r, i) {
            A_(e, r) || n.push(t.nodes[i]);
          }), {
            nodes: n
          };
        };

        var N_ = {
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          defaultConfig: function defaultConfig() {
            return bv.flowchart;
          },
          addVertex: function addVertex(t, e, n, r, i, a) {
            var o,
                s = t;
            void 0 !== s && 0 !== s.trim().length && (void 0 === f_[s] && (f_[s] = {
              id: s,
              domId: "flowchart-" + s + "-" + l_,
              styles: [],
              classes: []
            }), l_++, void 0 !== e ? (h_ = Ev(), '"' === (o = wm.sanitizeText(e.trim(), h_))[0] && '"' === o[o.length - 1] && (o = o.substring(1, o.length - 1)), f_[s].text = o) : void 0 === f_[s].text && (f_[s].text = t), void 0 !== n && (f_[s].type = n), null != r && r.forEach(function (t) {
              f_[s].styles.push(t);
            }), null != i && i.forEach(function (t) {
              f_[s].classes.push(t);
            }), void 0 !== a && (f_[s].dir = a));
          },
          lookUpDomId: x_,
          addLink: function addLink(t, e, n, r) {
            var i, a;

            for (i = 0; i < t.length; i++) {
              for (a = 0; a < e.length; a++) {
                w_(t[i], e[a], n, r);
              }
            }
          },
          updateLinkInterpolate: function updateLinkInterpolate(t, e) {
            t.forEach(function (t) {
              "default" === t ? d_.defaultInterpolate = e : d_[t].interpolate = e;
            });
          },
          updateLink: function updateLink(t, e) {
            t.forEach(function (t) {
              "default" === t ? d_.defaultStyle = e : (-1 === gv.isSubstringInArray("fill", e) && e.push("fill:none"), d_[t].style = e);
            });
          },
          addClass: function addClass(t, e) {
            void 0 === p_[t] && (p_[t] = {
              id: t,
              styles: [],
              textStyles: []
            }), null != e && e.forEach(function (e) {
              if (e.match("color")) {
                var n = e.replace("fill", "bgFill").replace("color", "fill");
                p_[t].textStyles.push(n);
              }

              p_[t].styles.push(e);
            });
          },
          setDirection: function setDirection(t) {
            (c_ = t).match(/.*</) && (c_ = "RL"), c_.match(/.*\^/) && (c_ = "BT"), c_.match(/.*>/) && (c_ = "LR"), c_.match(/.*v/) && (c_ = "TB");
          },
          setClass: k_,
          setTooltip: function setTooltip(t, e) {
            t.split(",").forEach(function (t) {
              void 0 !== e && (m_["gen-1" === u_ ? x_(t) : t] = wm.sanitizeText(e, h_));
            });
          },
          getTooltip: function getTooltip(t) {
            return m_[t];
          },
          setClickEvent: function setClickEvent(t, e, n) {
            t.split(",").forEach(function (t) {
              !function (t, e, n) {
                var r = x_(t);

                if ("loose" === Ev().securityLevel && void 0 !== e) {
                  var i = [];

                  if ("string" == typeof n) {
                    i = n.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

                    for (var a = 0; a < i.length; a++) {
                      var o = i[a].trim();
                      '"' === o.charAt(0) && '"' === o.charAt(o.length - 1) && (o = o.substr(1, o.length - 2)), i[a] = o;
                    }
                  }

                  0 === i.length && i.push(t), void 0 !== f_[t] && (f_[t].haveCallback = !0, __.push(function () {
                    var t = document.querySelector('[id="'.concat(r, '"]'));
                    null !== t && t.addEventListener("click", function () {
                      var t;
                      gv.runFunc.apply(gv, [e].concat(function (t) {
                        if (Array.isArray(t)) return s_(t);
                      }(t = i) || function (t) {
                        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                      }(t) || function (t, e) {
                        if (t) {
                          if ("string" == typeof t) return s_(t, e);
                          var n = Object.prototype.toString.call(t).slice(8, -1);
                          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s_(t, e) : void 0;
                        }
                      }(t) || function () {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                      }()));
                    }, !1);
                  }));
                }
              }(t, e, n);
            }), k_(t, "clickable");
          },
          setLink: function setLink(t, e, n) {
            t.split(",").forEach(function (t) {
              void 0 !== f_[t] && (f_[t].link = gv.formatUrl(e, h_), f_[t].linkTarget = n);
            }), k_(t, "clickable");
          },
          bindFunctions: function bindFunctions(t) {
            __.forEach(function (e) {
              e(t);
            });
          },
          getDirection: function getDirection() {
            return c_.trim();
          },
          getVertices: function getVertices() {
            return f_;
          },
          getEdges: function getEdges() {
            return d_;
          },
          getClasses: function getClasses() {
            return p_;
          },
          clear: function clear(t) {
            f_ = {}, p_ = {}, d_ = [], (__ = []).push(T_), y_ = [], g_ = {}, v_ = 0, m_ = [], b_ = !0, u_ = t || "gen-1";
          },
          setGen: function setGen(t) {
            u_ = t || "gen-1";
          },
          defaultStyle: function defaultStyle() {
            return "fill:#ffa;stroke: #f66; stroke-width: 3px; stroke-dasharray: 5, 5;fill:#ffa;stroke: #666;";
          },
          addSubGraph: function addSubGraph(t, e, n) {
            var r = t.trim(),
                i = n;
            t === n && n.match(/\s/) && (r = void 0);

            var a = [],
                s = function (t) {
              var e,
                  n = {
                boolean: {},
                number: {},
                string: {}
              },
                  r = [];
              return {
                nodeList: t.filter(function (t) {
                  var i = o_(t);
                  return t.stmt && "dir" === t.stmt ? (e = t.value, !1) : "" !== t.trim() && (i in n ? !n[i].hasOwnProperty(t) && (n[i][t] = !0) : !(r.indexOf(t) >= 0) && r.push(t));
                }),
                dir: e
              };
            }(a.concat.apply(a, e)),
                c = s.nodeList,
                u = s.dir;

            if (a = c, "gen-1" === u_) {
              o.warn("LOOKING UP");

              for (var l = 0; l < a.length; l++) {
                a[l] = x_(a[l]);
              }
            }

            r = r || "subGraph" + v_, i = i || "", i = wm.sanitizeText(i, h_), v_ += 1;
            var h = {
              id: r,
              nodes: a,
              title: i.trim(),
              classes: [],
              dir: u
            };
            return o.info("Adding", h.id, h.nodes, h.dir), h.nodes = M_(h, y_).nodes, y_.push(h), g_[r] = h, r;
          },
          getDepthFirstPos: function getDepthFirstPos(t) {
            return S_[t];
          },
          indexNodes: function indexNodes() {
            C_ = -1, y_.length > 0 && function t(e, n) {
              var r = y_[n].nodes;

              if (!((C_ += 1) > 2e3)) {
                if (S_[C_] = n, y_[n].id === e) return {
                  result: !0,
                  count: 0
                };

                for (var i = 0, a = 1; i < r.length;) {
                  var o = E_(r[i]);

                  if (o >= 0) {
                    var s = t(e, o);
                    if (s.result) return {
                      result: !0,
                      count: a + s.count
                    };
                    a += s.count;
                  }

                  i += 1;
                }

                return {
                  result: !1,
                  count: a
                };
              }
            }("none", y_.length - 1);
          },
          getSubGraphs: function getSubGraphs() {
            return y_;
          },
          destructLink: function destructLink(t, e) {
            var n,
                r = function (t) {
              var e = t.trim(),
                  n = e.slice(0, -1),
                  r = "arrow_open";

              switch (e.slice(-1)) {
                case "x":
                  r = "arrow_cross", "x" === e[0] && (r = "double_" + r, n = n.slice(1));
                  break;

                case ">":
                  r = "arrow_point", "<" === e[0] && (r = "double_" + r, n = n.slice(1));
                  break;

                case "o":
                  r = "arrow_circle", "o" === e[0] && (r = "double_" + r, n = n.slice(1));
              }

              var i = "normal",
                  a = n.length - 1;
              "=" === n[0] && (i = "thick");

              var o = function (t, e) {
                for (var n = e.length, r = 0, i = 0; i < n; ++i) {
                  "." === e[i] && ++r;
                }

                return r;
              }(0, n);

              return o && (i = "dotted", a = o), {
                type: r,
                stroke: i,
                length: a
              };
            }(t);

            if (e) {
              if ((n = function (t) {
                var e = t.trim(),
                    n = "arrow_open";

                switch (e[0]) {
                  case "<":
                    n = "arrow_point", e = e.slice(1);
                    break;

                  case "x":
                    n = "arrow_cross", e = e.slice(1);
                    break;

                  case "o":
                    n = "arrow_circle", e = e.slice(1);
                }

                var r = "normal";
                return -1 !== e.indexOf("=") && (r = "thick"), -1 !== e.indexOf(".") && (r = "dotted"), {
                  type: n,
                  stroke: r
                };
              }(e)).stroke !== r.stroke) return {
                type: "INVALID",
                stroke: "INVALID"
              };
              if ("arrow_open" === n.type) n.type = r.type;else {
                if (n.type !== r.type) return {
                  type: "INVALID",
                  stroke: "INVALID"
                };
                n.type = "double_" + n.type;
              }
              return "double_arrow" === n.type && (n.type = "double_arrow_point"), n.length = r.length, n;
            }

            return r;
          },
          lex: {
            firstGraph: function firstGraph() {
              return !!b_ && (b_ = !1, !0);
            }
          },
          exists: A_,
          makeUniq: M_
        };
        var D_ = n(7805),
            O_ = n.n(D_),
            B_ = n(4949),
            L_ = n.n(B_),
            I_ = n(8284),
            R_ = n.n(I_);

        function P_(t, e, n) {
          var r = .9 * (e.width + e.height),
              i = [{
            x: r / 2,
            y: 0
          }, {
            x: r,
            y: -r / 2
          }, {
            x: r / 2,
            y: -r
          }, {
            x: 0,
            y: -r / 2
          }],
              a = G_(t, r, r, i);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, i, t);
          }, a;
        }

        function F_(t, e, n) {
          var r = e.height,
              i = r / 4,
              a = e.width + 2 * i,
              o = [{
            x: i,
            y: 0
          }, {
            x: a - i,
            y: 0
          }, {
            x: a,
            y: -r / 2
          }, {
            x: a - i,
            y: -r
          }, {
            x: i,
            y: -r
          }, {
            x: 0,
            y: -r / 2
          }],
              s = G_(t, a, r, o);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, o, t);
          }, s;
        }

        function j_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: -i / 2,
            y: 0
          }, {
            x: r,
            y: 0
          }, {
            x: r,
            y: -i
          }, {
            x: -i / 2,
            y: -i
          }, {
            x: 0,
            y: -i / 2
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function Y_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: -2 * i / 6,
            y: 0
          }, {
            x: r - i / 6,
            y: 0
          }, {
            x: r + 2 * i / 6,
            y: -i
          }, {
            x: i / 6,
            y: -i
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function U_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: 2 * i / 6,
            y: 0
          }, {
            x: r + i / 6,
            y: 0
          }, {
            x: r - 2 * i / 6,
            y: -i
          }, {
            x: -i / 6,
            y: -i
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function z_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: -2 * i / 6,
            y: 0
          }, {
            x: r + 2 * i / 6,
            y: 0
          }, {
            x: r - i / 6,
            y: -i
          }, {
            x: i / 6,
            y: -i
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function q_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: i / 6,
            y: 0
          }, {
            x: r - i / 6,
            y: 0
          }, {
            x: r + 2 * i / 6,
            y: -i
          }, {
            x: -2 * i / 6,
            y: -i
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function $_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: 0,
            y: 0
          }, {
            x: r + i / 2,
            y: 0
          }, {
            x: r,
            y: -i / 2
          }, {
            x: r + i / 2,
            y: -i
          }, {
            x: 0,
            y: -i
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function H_(t, e, n) {
          var r = e.height,
              i = e.width + r / 4,
              a = t.insert("rect", ":first-child").attr("rx", r / 2).attr("ry", r / 2).attr("x", -i / 2).attr("y", -r / 2).attr("width", i).attr("height", r);
          return n.intersect = function (t) {
            return L_().intersect.rect(n, t);
          }, a;
        }

        function W_(t, e, n) {
          var r = e.width,
              i = e.height,
              a = [{
            x: 0,
            y: 0
          }, {
            x: r,
            y: 0
          }, {
            x: r,
            y: -i
          }, {
            x: 0,
            y: -i
          }, {
            x: 0,
            y: 0
          }, {
            x: -8,
            y: 0
          }, {
            x: r + 8,
            y: 0
          }, {
            x: r + 8,
            y: -i
          }, {
            x: -8,
            y: -i
          }, {
            x: -8,
            y: 0
          }],
              o = G_(t, r, i, a);
          return n.intersect = function (t) {
            return L_().intersect.polygon(n, a, t);
          }, o;
        }

        function V_(t, e, n) {
          var r = e.width,
              i = r / 2,
              a = i / (2.5 + r / 50),
              o = e.height + a,
              s = "M 0," + a + " a " + i + "," + a + " 0,0,0 " + r + " 0 a " + i + "," + a + " 0,0,0 " + -r + " 0 l 0," + o + " a " + i + "," + a + " 0,0,0 " + r + " 0 l 0," + -o,
              c = t.attr("label-offset-y", a).insert("path", ":first-child").attr("d", s).attr("transform", "translate(" + -r / 2 + "," + -(o / 2 + a) + ")");
          return n.intersect = function (t) {
            var e = L_().intersect.rect(n, t),
                r = e.x - n.x;

            if (0 != i && (Math.abs(r) < n.width / 2 || Math.abs(r) == n.width / 2 && Math.abs(e.y - n.y) > n.height / 2 - a)) {
              var o = a * a * (1 - r * r / (i * i));
              0 != o && (o = Math.sqrt(o)), o = a - o, t.y - n.y > 0 && (o = -o), e.y += o;
            }

            return e;
          }, c;
        }

        function G_(t, e, n, r) {
          return t.insert("polygon", ":first-child").attr("points", r.map(function (t) {
            return t.x + "," + t.y;
          }).join(" ")).attr("transform", "translate(" + -e / 2 + "," + n / 2 + ")");
        }

        var X_ = {};

        var Z_ = function Z_(t) {
          for (var e = Object.keys(t), n = 0; n < e.length; n++) {
            X_[e[n]] = t[e[n]];
          }
        },
            K_ = function K_(t, e) {
          o.info("Drawing flowchart"), N_.clear(), N_.setGen("gen-1");
          var n = O_().parser;
          n.yy = N_, n.parse(t);
          var r = N_.getDirection();
          void 0 === r && (r = "TD");

          for (var i, a = Ev().flowchart, s = a.nodeSpacing || 50, c = a.rankSpacing || 50, u = new (Vv().Graph)({
            multigraph: !0,
            compound: !0
          }).setGraph({
            rankdir: r,
            nodesep: s,
            ranksep: c,
            marginx: 8,
            marginy: 8
          }).setDefaultEdgeLabel(function () {
            return {};
          }), l = N_.getSubGraphs(), h = l.length - 1; h >= 0; h--) {
            i = l[h], N_.addVertex(i.id, i.title, "group", void 0, i.classes);
          }

          var f = N_.getVertices();
          o.warn("Get vertices", f);
          var d = N_.getEdges(),
              p = 0;

          for (p = l.length - 1; p >= 0; p--) {
            i = l[p], Kc("cluster").append("text");

            for (var y = 0; y < i.nodes.length; y++) {
              o.warn("Setting subgraph", i.nodes[y], N_.lookUpDomId(i.nodes[y]), N_.lookUpDomId(i.id)), u.setParent(N_.lookUpDomId(i.nodes[y]), N_.lookUpDomId(i.id));
            }
          }

          (function (t, e, n) {
            var r = Zc('[id="'.concat(n, '"]'));
            Object.keys(t).forEach(function (n) {
              var i = t[n],
                  a = "default";
              i.classes.length > 0 && (a = i.classes.join(" "));
              var s,
                  c = rv(i.styles),
                  u = void 0 !== i.text ? i.text : i.id;

              if (xm(Ev().flowchart.htmlLabels)) {
                var l = {
                  label: u.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
                    return "<i class='".concat(t.replace(":", " "), "'></i>");
                  })
                };
                (s = R_()(r, l).node()).parentNode.removeChild(s);
              } else {
                var h = document.createElementNS("http://www.w3.org/2000/svg", "text");
                h.setAttribute("style", c.labelStyle.replace("color:", "fill:"));

                for (var f = u.split(wm.lineBreakRegex), d = 0; d < f.length; d++) {
                  var p = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                  p.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), p.setAttribute("dy", "1em"), p.setAttribute("x", "1"), p.textContent = f[d], h.appendChild(p);
                }

                s = h;
              }

              var y = 0,
                  g = "";

              switch (i.type) {
                case "round":
                  y = 5, g = "rect";
                  break;

                case "square":
                  g = "rect";
                  break;

                case "diamond":
                  g = "question";
                  break;

                case "hexagon":
                  g = "hexagon";
                  break;

                case "odd":
                  g = "rect_left_inv_arrow";
                  break;

                case "lean_right":
                  g = "lean_right";
                  break;

                case "lean_left":
                  g = "lean_left";
                  break;

                case "trapezoid":
                  g = "trapezoid";
                  break;

                case "inv_trapezoid":
                  g = "inv_trapezoid";
                  break;

                case "odd_right":
                  g = "rect_left_inv_arrow";
                  break;

                case "circle":
                  g = "circle";
                  break;

                case "ellipse":
                  g = "ellipse";
                  break;

                case "stadium":
                  g = "stadium";
                  break;

                case "subroutine":
                  g = "subroutine";
                  break;

                case "cylinder":
                  g = "cylinder";
                  break;

                default:
                  g = "rect";
              }

              o.warn("Adding node", i.id, i.domId), e.setNode(N_.lookUpDomId(i.id), {
                labelType: "svg",
                labelStyle: c.labelStyle,
                shape: g,
                label: s,
                rx: y,
                ry: y,
                class: a,
                style: c.style,
                id: N_.lookUpDomId(i.id)
              });
            });
          })(f, u, e), function (t, e) {
            var n,
                r,
                i = 0;

            if (void 0 !== t.defaultStyle) {
              var a = rv(t.defaultStyle);
              n = a.style, r = a.labelStyle;
            }

            t.forEach(function (a) {
              i++;
              var o = "L-" + a.start + "-" + a.end,
                  s = "LS-" + a.start,
                  c = "LE-" + a.end,
                  u = {};
              "arrow_open" === a.type ? u.arrowhead = "none" : u.arrowhead = "normal";
              var l = "",
                  h = "";

              if (void 0 !== a.style) {
                var f = rv(a.style);
                l = f.style, h = f.labelStyle;
              } else switch (a.stroke) {
                case "normal":
                  l = "fill:none", void 0 !== n && (l = n), void 0 !== r && (h = r);
                  break;

                case "dotted":
                  l = "fill:none;stroke-width:2px;stroke-dasharray:3;";
                  break;

                case "thick":
                  l = " stroke-width: 3.5px;fill:none";
              }

              u.style = l, u.labelStyle = h, void 0 !== a.interpolate ? u.curve = ev(a.interpolate, Mu) : void 0 !== t.defaultInterpolate ? u.curve = ev(t.defaultInterpolate, Mu) : u.curve = ev(X_.curve, Mu), void 0 === a.text ? void 0 !== a.style && (u.arrowheadStyle = "fill: #333") : (u.arrowheadStyle = "fill: #333", u.labelpos = "c", xm(Ev().flowchart.htmlLabels) ? (u.labelType = "html", u.label = '<span id="L-'.concat(o, '" class="edgeLabel L-').concat(s, "' L-").concat(c, '">').concat(a.text.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
                return "<i class='".concat(t.replace(":", " "), "'></i>");
              }), "</span>")) : (u.labelType = "text", u.label = a.text.replace(wm.lineBreakRegex, "\n"), void 0 === a.style && (u.style = u.style || "stroke: #333; stroke-width: 1.5px;fill:none"), u.labelStyle = u.labelStyle.replace("color:", "fill:"))), u.id = o, u.class = s + " " + c, u.minlen = a.length || 1, e.setEdge(N_.lookUpDomId(a.start), N_.lookUpDomId(a.end), u, i);
            });
          }(d, u);
          var g = new (0, L_().render)();
          (function (t) {
            t.shapes().question = P_, t.shapes().hexagon = F_, t.shapes().stadium = H_, t.shapes().subroutine = W_, t.shapes().cylinder = V_, t.shapes().rect_left_inv_arrow = j_, t.shapes().lean_right = Y_, t.shapes().lean_left = U_, t.shapes().trapezoid = z_, t.shapes().inv_trapezoid = q_, t.shapes().rect_right_inv_arrow = $_;
          })(g), g.arrows().none = function (t, e, n, r) {
            var i = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 0 0 L 0 0 z");
            L_().util.applyStyle(i, n[r + "Style"]);
          }, g.arrows().normal = function (t, e) {
            t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").attr("class", "arrowheadPath").style("stroke-width", 1).style("stroke-dasharray", "1,0");
          };
          var m = Zc('[id="'.concat(e, '"]'));
          m.attr("xmlns:xlink", "http://www.w3.org/1999/xlink"), o.warn(u);
          var v = Zc("#" + e + " g");
          g(v, u), v.selectAll("g.node").attr("title", function () {
            return N_.getTooltip(this.id);
          });

          var b = a.diagramPadding,
              _ = m.node().getBBox(),
              x = _.width + 2 * b,
              w = _.height + 2 * b;

          pv(m, w, x, a.useMaxWidth);
          var k = "".concat(_.x - b, " ").concat(_.y - b, " ").concat(x, " ").concat(w);

          for (o.debug("viewBox ".concat(k)), m.attr("viewBox", k), N_.indexNodes("subGraph" + p), p = 0; p < l.length; p++) {
            if ("undefined" !== (i = l[p]).title) {
              var T = document.querySelectorAll("#" + e + ' [id="' + N_.lookUpDomId(i.id) + '"] rect'),
                  E = document.querySelectorAll("#" + e + ' [id="' + N_.lookUpDomId(i.id) + '"]'),
                  C = T[0].x.baseVal.value,
                  S = T[0].y.baseVal.value,
                  A = T[0].width.baseVal.value,
                  M = Zc(E[0]).select(".label");
              M.attr("transform", "translate(".concat(C + A / 2, ", ").concat(S + 14, ")")), M.attr("id", e + "Text");

              for (var N = 0; N < i.classes.length; N++) {
                E[0].classList.add(i.classes[N]);
              }
            }
          }

          xm(a.htmlLabels);

          for (var D = document.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), O = 0; O < D.length; O++) {
            var B = D[O],
                L = B.getBBox(),
                I = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            I.setAttribute("rx", 0), I.setAttribute("ry", 0), I.setAttribute("width", L.width), I.setAttribute("height", L.height), B.insertBefore(I, B.firstChild);
          }

          Object.keys(f).forEach(function (t) {
            var n = f[t];

            if (n.link) {
              var r = Zc("#" + e + ' [id="' + N_.lookUpDomId(t) + '"]');

              if (r) {
                var i = document.createElementNS("http://www.w3.org/2000/svg", "a");
                i.setAttributeNS("http://www.w3.org/2000/svg", "class", n.classes.join(" ")), i.setAttributeNS("http://www.w3.org/2000/svg", "href", n.link), i.setAttributeNS("http://www.w3.org/2000/svg", "rel", "noopener"), n.linkTarget && i.setAttributeNS("http://www.w3.org/2000/svg", "target", n.linkTarget);
                var a = r.insert(function () {
                  return i;
                }, ":first-child"),
                    o = r.select(".label-container");
                o && a.append(function () {
                  return o.node();
                });
                var s = r.select(".label");
                s && a.append(function () {
                  return s.node();
                });
              }
            }
          });
        };

        var Q_ = {};

        var J_ = function J_(t) {
          for (var e = Object.keys(t), n = 0; n < e.length; n++) {
            Q_[e[n]] = t[e[n]];
          }
        };

        function tx(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        var ex,
            nx,
            rx = "",
            ix = "",
            ax = "",
            ox = [],
            sx = [],
            cx = "",
            ux = [],
            lx = [],
            hx = "",
            fx = ["active", "done", "crit", "milestone"],
            dx = [],
            px = !1,
            yx = !1,
            gx = 0,
            mx = function mx(t, e, n, r) {
          return !(r.indexOf(t.format(e.trim())) >= 0) && (t.isoWeekday() >= 6 && n.indexOf("weekends") >= 0 || n.indexOf(t.format("dddd").toLowerCase()) >= 0 || n.indexOf(t.format(e.trim())) >= 0);
        },
            vx = function vx(t, e, n, r) {
          if (n.length && !t.manualEndTime) {
            var a = i()(t.startTime, e, !0);
            a.add(1, "d");
            var o = i()(t.endTime, e, !0),
                s = bx(a, o, e, n, r);
            t.endTime = o.toDate(), t.renderEndTime = s;
          }
        },
            bx = function bx(t, e, n, r, i) {
          for (var a = !1, o = null; t <= e;) {
            a || (o = e.toDate()), (a = mx(t, n, r, i)) && e.add(1, "d"), t.add(1, "d");
          }

          return o;
        },
            _x = function _x(t, e, n) {
          n = n.trim();
          var r = /^after\s+([\d\w- ]+)/.exec(n.trim());

          if (null !== r) {
            var a = null;
            if (r[1].split(" ").forEach(function (t) {
              var e = Sx(t);
              void 0 !== e && (a ? e.endTime > a.endTime && (a = e) : a = e);
            }), a) return a.endTime;
            var s = new Date();
            return s.setHours(0, 0, 0, 0), s;
          }

          var c = i()(n, e.trim(), !0);
          return c.isValid() ? c.toDate() : (o.debug("Invalid date:" + n), o.debug("With date format:" + e.trim()), new Date());
        },
            xx = function xx(t, e) {
          if (null !== t) switch (t[2]) {
            case "s":
              e.add(t[1], "seconds");
              break;

            case "m":
              e.add(t[1], "minutes");
              break;

            case "h":
              e.add(t[1], "hours");
              break;

            case "d":
              e.add(t[1], "days");
              break;

            case "w":
              e.add(t[1], "weeks");
          }
          return e.toDate();
        },
            wx = function wx(t, e, n, r) {
          r = r || !1, n = n.trim();
          var a = i()(n, e.trim(), !0);
          return a.isValid() ? (r && a.add(1, "d"), a.toDate()) : xx(/^([\d]+)([wdhms])/.exec(n.trim()), i()(t));
        },
            kx = 0,
            Tx = function Tx(t) {
          return void 0 === t ? "task" + (kx += 1) : t;
        },
            Ex = [],
            Cx = {},
            Sx = function Sx(t) {
          var e = Cx[t];
          return Ex[e];
        },
            Ax = function Ax() {
          for (var t = function t(_t13) {
            var e = Ex[_t13],
                n = "";

            switch (Ex[_t13].raw.startTime.type) {
              case "prevTaskEnd":
                var r = Sx(e.prevTaskId);
                e.startTime = r.endTime;
                break;

              case "getStartDate":
                (n = _x(0, rx, Ex[_t13].raw.startTime.startData)) && (Ex[_t13].startTime = n);
            }

            return Ex[_t13].startTime && (Ex[_t13].endTime = wx(Ex[_t13].startTime, rx, Ex[_t13].raw.endTime.data, px), Ex[_t13].endTime && (Ex[_t13].processed = !0, Ex[_t13].manualEndTime = i()(Ex[_t13].raw.endTime.data, "YYYY-MM-DD", !0).isValid(), vx(Ex[_t13], rx, sx, ox))), Ex[_t13].processed;
          }, e = !0, n = 0; n < Ex.length; n++) {
            t(n), e = e && Ex[n].processed;
          }

          return e;
        },
            Mx = function Mx(t, e) {
          t.split(",").forEach(function (t) {
            var n = Sx(t);
            void 0 !== n && n.classes.push(e);
          });
        },
            Nx = function Nx(t, e) {
          dx.push(function () {
            var n = document.querySelector('[id="'.concat(t, '"]'));
            null !== n && n.addEventListener("click", function () {
              e();
            });
          }), dx.push(function () {
            var n = document.querySelector('[id="'.concat(t, '-text"]'));
            null !== n && n.addEventListener("click", function () {
              e();
            });
          });
        };

        var Dx = {
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().gantt;
          },
          clear: function clear() {
            ux = [], lx = [], hx = "", dx = [], cx = "", kx = 0, ex = void 0, nx = void 0, Ex = [], rx = "", ix = "", ax = "", ox = [], sx = [], px = !1, yx = !1, gx = 0;
          },
          setDateFormat: function setDateFormat(t) {
            rx = t;
          },
          getDateFormat: function getDateFormat() {
            return rx;
          },
          enableInclusiveEndDates: function enableInclusiveEndDates() {
            px = !0;
          },
          endDatesAreInclusive: function endDatesAreInclusive() {
            return px;
          },
          enableTopAxis: function enableTopAxis() {
            yx = !0;
          },
          topAxisEnabled: function topAxisEnabled() {
            return yx;
          },
          setAxisFormat: function setAxisFormat(t) {
            ix = t;
          },
          getAxisFormat: function getAxisFormat() {
            return ix;
          },
          setTodayMarker: function setTodayMarker(t) {
            ax = t;
          },
          getTodayMarker: function getTodayMarker() {
            return ax;
          },
          setTitle: function setTitle(t) {
            cx = t;
          },
          getTitle: function getTitle() {
            return cx;
          },
          addSection: function addSection(t) {
            hx = t, ux.push(t);
          },
          getSections: function getSections() {
            return ux;
          },
          getTasks: function getTasks() {
            for (var t = Ax(), e = 0; !t && e < 10;) {
              t = Ax(), e++;
            }

            return lx = Ex;
          },
          addTask: function addTask(t, e) {
            var n = {
              section: hx,
              type: hx,
              processed: !1,
              manualEndTime: !1,
              renderEndTime: null,
              raw: {
                data: e
              },
              task: t,
              classes: []
            },
                r = function (t, e) {
              var n = (":" === e.substr(0, 1) ? e.substr(1, e.length) : e).split(","),
                  r = {};
              Ox(n, r, fx);

              for (var i = 0; i < n.length; i++) {
                n[i] = n[i].trim();
              }

              switch (n.length) {
                case 1:
                  r.id = Tx(), r.startTime = {
                    type: "prevTaskEnd",
                    id: t
                  }, r.endTime = {
                    data: n[0]
                  };
                  break;

                case 2:
                  r.id = Tx(), r.startTime = {
                    type: "getStartDate",
                    startData: n[0]
                  }, r.endTime = {
                    data: n[1]
                  };
                  break;

                case 3:
                  r.id = Tx(n[0]), r.startTime = {
                    type: "getStartDate",
                    startData: n[1]
                  }, r.endTime = {
                    data: n[2]
                  };
              }

              return r;
            }(nx, e);

            n.raw.startTime = r.startTime, n.raw.endTime = r.endTime, n.id = r.id, n.prevTaskId = nx, n.active = r.active, n.done = r.done, n.crit = r.crit, n.milestone = r.milestone, n.order = gx, gx++;
            var i = Ex.push(n);
            nx = n.id, Cx[n.id] = i - 1;
          },
          findTaskById: Sx,
          addTaskOrg: function addTaskOrg(t, e) {
            var n = {
              section: hx,
              type: hx,
              description: t,
              task: t,
              classes: []
            },
                r = function (t, e) {
              var n = (":" === e.substr(0, 1) ? e.substr(1, e.length) : e).split(","),
                  r = {};
              Ox(n, r, fx);

              for (var a = 0; a < n.length; a++) {
                n[a] = n[a].trim();
              }

              var o = "";

              switch (n.length) {
                case 1:
                  r.id = Tx(), r.startTime = t.endTime, o = n[0];
                  break;

                case 2:
                  r.id = Tx(), r.startTime = _x(0, rx, n[0]), o = n[1];
                  break;

                case 3:
                  r.id = Tx(n[0]), r.startTime = _x(0, rx, n[1]), o = n[2];
              }

              return o && (r.endTime = wx(r.startTime, rx, o, px), r.manualEndTime = i()(o, "YYYY-MM-DD", !0).isValid(), vx(r, rx, sx, ox)), r;
            }(ex, e);

            n.startTime = r.startTime, n.endTime = r.endTime, n.id = r.id, n.active = r.active, n.done = r.done, n.crit = r.crit, n.milestone = r.milestone, ex = n, lx.push(n);
          },
          setIncludes: function setIncludes(t) {
            ox = t.toLowerCase().split(/[\s,]+/);
          },
          getIncludes: function getIncludes() {
            return ox;
          },
          setExcludes: function setExcludes(t) {
            sx = t.toLowerCase().split(/[\s,]+/);
          },
          getExcludes: function getExcludes() {
            return sx;
          },
          setClickEvent: function setClickEvent(t, e, n) {
            t.split(",").forEach(function (t) {
              !function (t, e, n) {
                if ("loose" === Ev().securityLevel && void 0 !== e) {
                  var r = [];

                  if ("string" == typeof n) {
                    r = n.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);

                    for (var i = 0; i < r.length; i++) {
                      var a = r[i].trim();
                      '"' === a.charAt(0) && '"' === a.charAt(a.length - 1) && (a = a.substr(1, a.length - 2)), r[i] = a;
                    }
                  }

                  0 === r.length && r.push(t), void 0 !== Sx(t) && Nx(t, function () {
                    var t;
                    gv.runFunc.apply(gv, [e].concat(function (t) {
                      if (Array.isArray(t)) return tx(t);
                    }(t = r) || function (t) {
                      if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                    }(t) || function (t, e) {
                      if (t) {
                        if ("string" == typeof t) return tx(t, e);
                        var n = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? tx(t, e) : void 0;
                      }
                    }(t) || function () {
                      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()));
                  });
                }
              }(t, e, n);
            }), Mx(t, "clickable");
          },
          setLink: function setLink(t, e) {
            var n = e;
            "loose" !== Ev().securityLevel && (n = (0, dm.sanitizeUrl)(e)), t.split(",").forEach(function (t) {
              void 0 !== Sx(t) && Nx(t, function () {
                window.open(n, "_self");
              });
            }), Mx(t, "clickable");
          },
          bindFunctions: function bindFunctions(t) {
            dx.forEach(function (e) {
              e(t);
            });
          },
          durationToDate: xx,
          isInvalidDate: mx
        };

        function Ox(t, e, n) {
          for (var r = !0; r;) {
            r = !1, n.forEach(function (n) {
              var i = new RegExp("^\\s*" + n + "\\s*$");
              t[0].match(i) && (e[n] = !0, t.shift(1), r = !0);
            });
          }
        }

        var Bx,
            Lx = n(2055),
            Ix = n.n(Lx);
        Lx.parser.yy = Dx;

        var Rx = function Rx(t, e) {
          var n = Ev().gantt;
          Lx.parser.yy.clear(), Lx.parser.parse(t);
          var r = document.getElementById(e);
          void 0 === (Bx = r.parentElement.offsetWidth) && (Bx = 1200), void 0 !== n.useWidth && (Bx = n.useWidth);
          var a = Lx.parser.yy.getTasks(),
              o = a.length * (n.barHeight + n.barGap) + 2 * n.topPadding;
          r.setAttribute("viewBox", "0 0 " + Bx + " " + o);

          for (var s = Zc('[id="'.concat(e, '"]')), c = function () {
            return qi.apply(Ls(so, co, ja, Pa, Ma, Sa, Ea, ka, xa, po).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
          }().domain([l(a, function (t) {
            return t.startTime;
          }), u(a, function (t) {
            return t.endTime;
          })]).rangeRound([0, Bx - n.leftPadding - n.rightPadding]), h = [], f = 0; f < a.length; f++) {
            h.push(a[f].type);
          }

          var d = h;
          h = function (t) {
            for (var e = {}, n = [], r = 0, i = t.length; r < i; ++r) {
              Object.prototype.hasOwnProperty.call(e, t[r]) || (e[t[r]] = !0, n.push(t[r]));
            }

            return n;
          }(h), a.sort(function (t, e) {
            var n = t.startTime,
                r = e.startTime,
                i = 0;
            return n > r ? i = 1 : n < r && (i = -1), i;
          }), function (t, e, r) {
            var a = n.barHeight,
                o = a + n.barGap,
                u = n.topPadding,
                l = n.leftPadding;
            (function t() {
              var e = zi();
              return e.copy = function () {
                return Ui(e, t());
              }, qi.apply(e, arguments), ia(e);
            })().domain([0, h.length]).range(["#00B9FA", "#F95002"]).interpolate(Br), function (t, e, r, a, o, u, l, h) {
              var f = u.reduce(function (t, e) {
                var n = e.startTime;
                return t ? Math.min(t, n) : n;
              }, 0),
                  d = u.reduce(function (t, e) {
                var n = e.endTime;
                return t ? Math.max(t, n) : n;
              }, 0),
                  p = Lx.parser.yy.getDateFormat();

              if (f && d) {
                for (var y = [], g = null, m = i()(f); m.valueOf() <= d;) {
                  Lx.parser.yy.isInvalidDate(m, p, l, h) ? g ? g.end = m.clone() : g = {
                    start: m.clone(),
                    end: m.clone()
                  } : g && (y.push(g), g = null), m.add(1, "d");
                }

                s.append("g").selectAll("rect").data(y).enter().append("rect").attr("id", function (t) {
                  return "exclude-" + t.start.format("YYYY-MM-DD");
                }).attr("x", function (t) {
                  return c(t.start) + r;
                }).attr("y", n.gridLineStartPadding).attr("width", function (t) {
                  var e = t.end.clone().add(1, "day");
                  return c(e) - c(t.start);
                }).attr("height", o - e - n.gridLineStartPadding).attr("transform-origin", function (e, n) {
                  return (c(e.start) + r + .5 * (c(e.end) - c(e.start))).toString() + "px " + (n * t + .5 * o).toString() + "px";
                }).attr("class", "exclude-range");
              }
            }(o, u, l, 0, r, t, Lx.parser.yy.getExcludes(), Lx.parser.yy.getIncludes()), function (t, e, r, i) {
              var a,
                  o = (a = c, v(3, a)).tickSize(-i + e + n.gridLineStartPadding).tickFormat(Nl(Lx.parser.yy.getAxisFormat() || n.axisFormat || "%Y-%m-%d"));

              if (s.append("g").attr("class", "grid").attr("transform", "translate(" + t + ", " + (i - 50) + ")").call(o).selectAll("text").style("text-anchor", "middle").attr("fill", "#000").attr("stroke", "none").attr("font-size", 10).attr("dy", "1em"), Dx.topAxisEnabled() || n.topAxis) {
                var u = function (t) {
                  return v(1, t);
                }(c).tickSize(-i + e + n.gridLineStartPadding).tickFormat(Nl(Lx.parser.yy.getAxisFormat() || n.axisFormat || "%Y-%m-%d"));

                s.append("g").attr("class", "grid").attr("transform", "translate(" + t + ", " + e + ")").call(u).selectAll("text").style("text-anchor", "middle").attr("fill", "#000").attr("stroke", "none").attr("font-size", 10);
              }
            }(l, u, 0, r), function (t, e, r, i, a, o, u) {
              s.append("g").selectAll("rect").data(t).enter().append("rect").attr("x", 0).attr("y", function (t, n) {
                return t.order * e + r - 2;
              }).attr("width", function () {
                return u - n.rightPadding / 2;
              }).attr("height", e).attr("class", function (t) {
                for (var e = 0; e < h.length; e++) {
                  if (t.type === h[e]) return "section section" + e % n.numberSectionStyles;
                }

                return "section section0";
              });
              var l = s.append("g").selectAll("rect").data(t).enter();
              l.append("rect").attr("id", function (t) {
                return t.id;
              }).attr("rx", 3).attr("ry", 3).attr("x", function (t) {
                return t.milestone ? c(t.startTime) + i + .5 * (c(t.endTime) - c(t.startTime)) - .5 * a : c(t.startTime) + i;
              }).attr("y", function (t, n) {
                return t.order * e + r;
              }).attr("width", function (t) {
                return t.milestone ? a : c(t.renderEndTime || t.endTime) - c(t.startTime);
              }).attr("height", a).attr("transform-origin", function (t, n) {
                return n = t.order, (c(t.startTime) + i + .5 * (c(t.endTime) - c(t.startTime))).toString() + "px " + (n * e + r + .5 * a).toString() + "px";
              }).attr("class", function (t) {
                var e = "";
                t.classes.length > 0 && (e = t.classes.join(" "));

                for (var r = 0, i = 0; i < h.length; i++) {
                  t.type === h[i] && (r = i % n.numberSectionStyles);
                }

                var a = "";
                return t.active ? t.crit ? a += " activeCrit" : a = " active" : t.done ? a = t.crit ? " doneCrit" : " done" : t.crit && (a += " crit"), 0 === a.length && (a = " task"), t.milestone && (a = " milestone " + a), "task" + (a += r) + " " + e;
              }), l.append("text").attr("id", function (t) {
                return t.id + "-text";
              }).text(function (t) {
                return t.task;
              }).attr("font-size", n.fontSize).attr("x", function (t) {
                var e = c(t.startTime),
                    r = c(t.renderEndTime || t.endTime);
                t.milestone && (e += .5 * (c(t.endTime) - c(t.startTime)) - .5 * a), t.milestone && (r = e + a);
                var o = this.getBBox().width;
                return o > r - e ? r + o + 1.5 * n.leftPadding > u ? e + i - 5 : r + i + 5 : (r - e) / 2 + e + i;
              }).attr("y", function (t, i) {
                return t.order * e + n.barHeight / 2 + (n.fontSize / 2 - 2) + r;
              }).attr("text-height", a).attr("class", function (t) {
                var e = c(t.startTime),
                    r = c(t.endTime);
                t.milestone && (r = e + a);
                var i = this.getBBox().width,
                    o = "";
                t.classes.length > 0 && (o = t.classes.join(" "));

                for (var s = 0, l = 0; l < h.length; l++) {
                  t.type === h[l] && (s = l % n.numberSectionStyles);
                }

                var f = "";
                return t.active && (f = t.crit ? "activeCritText" + s : "activeText" + s), t.done ? f = t.crit ? f + " doneCritText" + s : f + " doneText" + s : t.crit && (f = f + " critText" + s), t.milestone && (f += " milestoneText"), i > r - e ? r + i + 1.5 * n.leftPadding > u ? o + " taskTextOutsideLeft taskTextOutside" + s + " " + f : o + " taskTextOutsideRight taskTextOutside" + s + " " + f + " width-" + i : o + " taskText taskText" + s + " " + f + " width-" + i;
              });
            }(t, o, u, l, a, 0, e), function (t, e) {
              for (var r = [], i = 0, a = 0; a < h.length; a++) {
                r[a] = [h[a], (o = h[a], c = d, function (t) {
                  for (var e = t.length, n = {}; e;) {
                    n[t[--e]] = (n[t[e]] || 0) + 1;
                  }

                  return n;
                }(c)[o] || 0)];
              }

              var o, c;
              s.append("g").selectAll("text").data(r).enter().append(function (t) {
                var e = t[0].split(wm.lineBreakRegex),
                    n = -(e.length - 1) / 2,
                    r = document.createElementNS("http://www.w3.org/2000/svg", "text");
                r.setAttribute("dy", n + "em");

                for (var i = 0; i < e.length; i++) {
                  var a = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                  a.setAttribute("alignment-baseline", "central"), a.setAttribute("x", "10"), i > 0 && a.setAttribute("dy", "1em"), a.textContent = e[i], r.appendChild(a);
                }

                return r;
              }).attr("x", 10).attr("y", function (n, a) {
                if (!(a > 0)) return n[1] * t / 2 + e;

                for (var o = 0; o < a; o++) {
                  return i += r[a - 1][1], n[1] * t / 2 + i * t + e;
                }
              }).attr("font-size", n.sectionFontSize).attr("font-size", n.sectionFontSize).attr("class", function (t) {
                for (var e = 0; e < h.length; e++) {
                  if (t[0] === h[e]) return "sectionTitle sectionTitle" + e % n.numberSectionStyles;
                }

                return "sectionTitle";
              });
            }(o, u), function (t, e, r, i) {
              var a = Dx.getTodayMarker();

              if ("off" !== a) {
                var o = s.append("g").attr("class", "today"),
                    u = new Date(),
                    l = o.append("line");
                l.attr("x1", c(u) + t).attr("x2", c(u) + t).attr("y1", n.titleTopMargin).attr("y2", i - n.titleTopMargin).attr("class", "today"), "" !== a && l.attr("style", a.replace(/,/g, ";"));
              }
            }(l, 0, 0, r);
          }(a, Bx, o), pv(s, o, Bx, n.useMaxWidth), s.append("text").text(Lx.parser.yy.getTitle()).attr("x", Bx / 2).attr("y", n.titleTopMargin).attr("class", "titleText");
        };

        var Px = {},
            Fx = null,
            jx = {
          master: Fx
        },
            Yx = "master",
            Ux = "LR",
            zx = 0;

        function qx() {
          return ov({
            length: 7
          });
        }

        function $x(t, e) {
          for (o.debug("Entering isfastforwardable:", t.id, e.id); t.seq <= e.seq && t !== e && null != e.parent;) {
            if (Array.isArray(e.parent)) return o.debug("In merge commit:", e.parent), $x(t, Px[e.parent[0]]) || $x(t, Px[e.parent[1]]);
            e = Px[e.parent];
          }

          return o.debug(t.id, e.id), t.id === e.id;
        }

        var Hx = {};

        function Wx(t, e, n) {
          var r = t.indexOf(e);
          -1 === r ? t.push(n) : t.splice(r, 1, n);
        }

        var Vx = function Vx() {
          var t = Object.keys(Px).map(function (t) {
            return Px[t];
          });
          return t.forEach(function (t) {
            o.debug(t.id);
          }), t.sort(function (t, e) {
            return e.seq - t.seq;
          }), t;
        };

        var Gx = {
          setDirection: function setDirection(t) {
            Ux = t;
          },
          setOptions: function setOptions(t) {
            o.debug("options str", t), t = (t = t && t.trim()) || "{}";

            try {
              Hx = JSON.parse(t);
            } catch (t) {
              o.error("error while parsing gitGraph options", t.message);
            }
          },
          getOptions: function getOptions() {
            return Hx;
          },
          commit: function commit(t) {
            var e = {
              id: qx(),
              message: t,
              seq: zx++,
              parent: null == Fx ? null : Fx.id
            };
            Fx = e, Px[e.id] = e, jx[Yx] = e.id, o.debug("in pushCommit " + e.id);
          },
          branch: function branch(t) {
            jx[t] = null != Fx ? Fx.id : null, o.debug("in createBranch");
          },
          merge: function merge(t) {
            var e = Px[jx[Yx]],
                n = Px[jx[t]];
            if (function (t, e) {
              return t.seq > e.seq && $x(e, t);
            }(e, n)) o.debug("Already merged");else {
              if ($x(e, n)) jx[Yx] = jx[t], Fx = Px[jx[Yx]];else {
                var r = {
                  id: qx(),
                  message: "merged branch " + t + " into " + Yx,
                  seq: zx++,
                  parent: [null == Fx ? null : Fx.id, jx[t]]
                };
                Fx = r, Px[r.id] = r, jx[Yx] = r.id;
              }
              o.debug(jx), o.debug("in mergeBranch");
            }
          },
          checkout: function checkout(t) {
            o.debug("in checkout");
            var e = jx[Yx = t];
            Fx = Px[e];
          },
          reset: function reset(t) {
            o.debug("in reset", t);
            var e = t.split(":")[0],
                n = parseInt(t.split(":")[1]),
                r = "HEAD" === e ? Fx : Px[jx[e]];

            for (o.debug(r, n); n > 0;) {
              if (n--, !(r = Px[r.parent])) {
                var i = "Critical error - unique parent commit not found during reset";
                throw o.error(i), i;
              }
            }

            Fx = r, jx[Yx] = r.id;
          },
          prettyPrint: function prettyPrint() {
            o.debug(Px), function t(e) {
              var n = e.reduce(function (t, e) {
                return t.seq > e.seq ? t : e;
              }, e[0]),
                  r = "";
              e.forEach(function (t) {
                r += t === n ? "\t*" : "\t|";
              });
              var i,
                  a,
                  s,
                  c = [r, n.id, n.seq];

              for (var u in jx) {
                jx[u] === n.id && c.push(u);
              }

              if (o.debug(c.join(" ")), Array.isArray(n.parent)) {
                var l = Px[n.parent[0]];
                Wx(e, n, l), e.push(Px[n.parent[1]]);
              } else {
                if (null == n.parent) return;
                var h = Px[n.parent];
                Wx(e, n, h);
              }

              i = e, a = function a(t) {
                return t.id;
              }, s = Object.create(null), t(e = i.reduce(function (t, e) {
                var n = a(e);
                return s[n] || (s[n] = !0, t.push(e)), t;
              }, []));
            }([Vx()[0]]);
          },
          clear: function clear() {
            Px = {}, jx = {
              master: Fx = null
            }, Yx = "master", zx = 0;
          },
          getBranchesAsObjArray: function getBranchesAsObjArray() {
            var t = [];

            for (var e in jx) {
              t.push({
                name: e,
                commit: Px[jx[e]]
              });
            }

            return t;
          },
          getBranches: function getBranches() {
            return jx;
          },
          getCommits: function getCommits() {
            return Px;
          },
          getCommitsArray: Vx,
          getCurrentBranch: function getCurrentBranch() {
            return Yx;
          },
          getDirection: function getDirection() {
            return Ux;
          },
          getHead: function getHead() {
            return Fx;
          }
        };
        var Xx,
            Zx = n(8454),
            Kx = n.n(Zx),
            Qx = {},
            Jx = {
          nodeSpacing: 150,
          nodeFillColor: "yellow",
          nodeStrokeWidth: 2,
          nodeStrokeColor: "grey",
          lineStrokeWidth: 4,
          branchOffset: 50,
          lineColor: "grey",
          leftMargin: 50,
          branchColors: ["#442f74", "#983351", "#609732", "#AA9A39"],
          nodeRadius: 10,
          nodeLabel: {
            width: 75,
            height: 100,
            x: -25,
            y: 0
          }
        },
            tw = {};

        function ew(t, e, n, r) {
          var i = ev(r, Fu),
              a = Jx.branchColors[n % Jx.branchColors.length],
              o = Ou().x(function (t) {
            return Math.round(t.x);
          }).y(function (t) {
            return Math.round(t.y);
          }).curve(i);
          t.append("svg:path").attr("d", o(e)).style("stroke", a).style("stroke-width", Jx.lineStrokeWidth).style("fill", "none");
        }

        function nw(t, e) {
          e = e || t.node().getBBox();
          var n = t.node().getCTM();
          return {
            left: n.e + e.x * n.a,
            top: n.f + e.y * n.d,
            width: e.width,
            height: e.height
          };
        }

        function rw(t, e, n, r, i) {
          o.debug("svgDrawLineForCommits: ", e, n);
          var a = nw(t.select("#node-" + e + " circle")),
              s = nw(t.select("#node-" + n + " circle"));

          switch (r) {
            case "LR":
              if (a.left - s.left > Jx.nodeSpacing) {
                var c = {
                  x: a.left - Jx.nodeSpacing,
                  y: s.top + s.height / 2
                };
                ew(t, [c, {
                  x: s.left + s.width,
                  y: s.top + s.height / 2
                }], i, "linear"), ew(t, [{
                  x: a.left,
                  y: a.top + a.height / 2
                }, {
                  x: a.left - Jx.nodeSpacing / 2,
                  y: a.top + a.height / 2
                }, {
                  x: a.left - Jx.nodeSpacing / 2,
                  y: c.y
                }, c], i);
              } else ew(t, [{
                x: a.left,
                y: a.top + a.height / 2
              }, {
                x: a.left - Jx.nodeSpacing / 2,
                y: a.top + a.height / 2
              }, {
                x: a.left - Jx.nodeSpacing / 2,
                y: s.top + s.height / 2
              }, {
                x: s.left + s.width,
                y: s.top + s.height / 2
              }], i);

              break;

            case "BT":
              if (s.top - a.top > Jx.nodeSpacing) {
                var u = {
                  x: s.left + s.width / 2,
                  y: a.top + a.height + Jx.nodeSpacing
                };
                ew(t, [u, {
                  x: s.left + s.width / 2,
                  y: s.top
                }], i, "linear"), ew(t, [{
                  x: a.left + a.width / 2,
                  y: a.top + a.height
                }, {
                  x: a.left + a.width / 2,
                  y: a.top + a.height + Jx.nodeSpacing / 2
                }, {
                  x: s.left + s.width / 2,
                  y: u.y - Jx.nodeSpacing / 2
                }, u], i);
              } else ew(t, [{
                x: a.left + a.width / 2,
                y: a.top + a.height
              }, {
                x: a.left + a.width / 2,
                y: a.top + Jx.nodeSpacing / 2
              }, {
                x: s.left + s.width / 2,
                y: s.top - Jx.nodeSpacing / 2
              }, {
                x: s.left + s.width / 2,
                y: s.top
              }], i);

          }
        }

        function iw(t, e) {
          return t.select(e).node().cloneNode(!0);
        }

        function aw(t, e, n, r) {
          var i,
              a = Object.keys(Qx).length;
          if ("string" == typeof e) do {
            if (i = Qx[e], o.debug("in renderCommitHistory", i.id, i.seq), t.select("#node-" + e).size() > 0) return;
            t.append(function () {
              return iw(t, "#def-commit");
            }).attr("class", "commit").attr("id", function () {
              return "node-" + i.id;
            }).attr("transform", function () {
              switch (r) {
                case "LR":
                  return "translate(" + (i.seq * Jx.nodeSpacing + Jx.leftMargin) + ", " + Xx * Jx.branchOffset + ")";

                case "BT":
                  return "translate(" + (Xx * Jx.branchOffset + Jx.leftMargin) + ", " + (a - i.seq) * Jx.nodeSpacing + ")";
              }
            }).attr("fill", Jx.nodeFillColor).attr("stroke", Jx.nodeStrokeColor).attr("stroke-width", Jx.nodeStrokeWidth);
            var s = void 0;

            for (var c in n) {
              if (n[c].commit === i) {
                s = n[c];
                break;
              }
            }

            s && (o.debug("found branch ", s.name), t.select("#node-" + i.id + " p").append("xhtml:span").attr("class", "branch-label").text(s.name + ", ")), t.select("#node-" + i.id + " p").append("xhtml:span").attr("class", "commit-id").text(i.id), "" !== i.message && "BT" === r && t.select("#node-" + i.id + " p").append("xhtml:span").attr("class", "commit-msg").text(", " + i.message), e = i.parent;
          } while (e && Qx[e]);
          Array.isArray(e) && (o.debug("found merge commmit", e), aw(t, e[0], n, r), Xx++, aw(t, e[1], n, r), Xx--);
        }

        function ow(t, e, n, r) {
          for (r = r || 0; e.seq > 0 && !e.lineDrawn;) {
            "string" == typeof e.parent ? (rw(t, e.id, e.parent, n, r), e.lineDrawn = !0, e = Qx[e.parent]) : Array.isArray(e.parent) && (rw(t, e.id, e.parent[0], n, r), rw(t, e.id, e.parent[1], n, r + 1), ow(t, Qx[e.parent[1]], n, r + 1), e.lineDrawn = !0, e = Qx[e.parent[0]]);
          }
        }

        var sw = function sw(t) {
          tw = t;
        };

        var cw = "",
            uw = !1;
        var lw = {
          setMessage: function setMessage(t) {
            o.debug("Setting message to: " + t), cw = t;
          },
          getMessage: function getMessage() {
            return cw;
          },
          setInfo: function setInfo(t) {
            uw = t;
          },
          getInfo: function getInfo() {
            return uw;
          }
        };
        var hw = n(4645),
            fw = n.n(hw),
            dw = {};

        var pw = function pw(t) {
          Object.keys(t).forEach(function (e) {
            dw[e] = t[e];
          });
        };

        var yw = n(5963),
            gw = n.n(yw),
            mw = {},
            vw = "",
            bw = !1;
        var _w = {
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().pie;
          },
          addSection: function addSection(t, e) {
            void 0 === mw[t] && (mw[t] = e, o.debug("Added new section :", t));
          },
          getSections: function getSections() {
            return mw;
          },
          cleanupValue: function cleanupValue(t) {
            return ":" === t.substring(0, 1) ? (t = t.substring(1).trim(), Number(t.trim())) : Number(t.trim());
          },
          clear: function clear() {
            mw = {}, vw = "", bw = !1;
          },
          setTitle: function setTitle(t) {
            vw = t;
          },
          getTitle: function getTitle() {
            return vw;
          },
          setShowData: function setShowData(t) {
            bw = t;
          },
          getShowData: function getShowData() {
            return bw;
          }
        };
        var xw,
            ww = Ev();

        var kw = function kw(t, e) {
          try {
            ww = Ev();
            var n = gw().parser;
            n.yy = _w, o.debug("Rendering info diagram\n" + t), n.yy.clear(), n.parse(t), o.debug("Parsed info diagram");
            var r = document.getElementById(e);
            void 0 === (xw = r.parentElement.offsetWidth) && (xw = 1200), void 0 !== ww.useWidth && (xw = ww.useWidth), void 0 !== ww.pie.useWidth && (xw = ww.pie.useWidth);
            var i = Zc("#" + e);
            pv(i, 450, xw, ww.pie.useMaxWidth), r.setAttribute("viewBox", "0 0 " + xw + " 450");

            var a = Math.min(xw, 450) / 2 - 40,
                s = i.append("g").attr("transform", "translate(" + xw / 2 + ",225)"),
                c = _w.getSections(),
                u = 0;

            Object.keys(c).forEach(function (t) {
              u += c[t];
            });

            var l = ww.themeVariables,
                h = [l.pie1, l.pie2, l.pie3, l.pie4, l.pie5, l.pie6, l.pie7, l.pie8, l.pie9, l.pie10, l.pie11, l.pie12],
                f = function t() {
              var e = new aa(),
                  n = [],
                  r = [],
                  i = ca;

              function a(t) {
                var a = e.get(t);

                if (void 0 === a) {
                  if (i !== ca) return i;
                  e.set(t, a = n.push(t) - 1);
                }

                return r[a % r.length];
              }

              return a.domain = function (t) {
                if (!arguments.length) return n.slice();
                n = [], e = new aa();

                var _iterator9 = _createForOfIteratorHelper(t),
                    _step9;

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _r6 = _step9.value;
                    e.has(_r6) || e.set(_r6, n.push(_r6) - 1);
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                return a;
              }, a.range = function (t) {
                return arguments.length ? (r = Array.from(t), a) : r.slice();
              }, a.unknown = function (t) {
                return arguments.length ? (i = t, a) : i;
              }, a.copy = function () {
                return t(n, r).unknown(i);
              }, qi.apply(a, arguments), a;
            }().range(h),
                d = function () {
              var t = Lu,
                  e = Bu,
                  n = null,
                  r = au(0),
                  i = au(gu),
                  a = au(0);

              function o(o) {
                var s,
                    c,
                    u,
                    l,
                    h,
                    f = (o = Su(o)).length,
                    d = 0,
                    p = new Array(f),
                    y = new Array(f),
                    g = +r.apply(this, arguments),
                    m = Math.min(gu, Math.max(-gu, i.apply(this, arguments) - g)),
                    v = Math.min(Math.abs(m) / f, a.apply(this, arguments)),
                    b = v * (m < 0 ? -1 : 1);

                for (s = 0; s < f; ++s) {
                  (h = y[p[s] = s] = +t(o[s], s, o)) > 0 && (d += h);
                }

                for (null != e ? p.sort(function (t, n) {
                  return e(y[t], y[n]);
                }) : null != n && p.sort(function (t, e) {
                  return n(o[t], o[e]);
                }), s = 0, u = d ? (m - f * b) / d : 0; s < f; ++s, g = l) {
                  c = p[s], l = g + ((h = y[c]) > 0 ? h * u : 0) + b, y[c] = {
                    data: o[c],
                    index: s,
                    value: h,
                    startAngle: g,
                    endAngle: l,
                    padAngle: v
                  };
                }

                return y;
              }

              return o.value = function (e) {
                return arguments.length ? (t = "function" == typeof e ? e : au(+e), o) : t;
              }, o.sortValues = function (t) {
                return arguments.length ? (e = t, n = null, o) : e;
              }, o.sort = function (t) {
                return arguments.length ? (n = t, e = null, o) : n;
              }, o.startAngle = function (t) {
                return arguments.length ? (r = "function" == typeof t ? t : au(+t), o) : r;
              }, o.endAngle = function (t) {
                return arguments.length ? (i = "function" == typeof t ? t : au(+t), o) : i;
              }, o.padAngle = function (t) {
                return arguments.length ? (a = "function" == typeof t ? t : au(+t), o) : a;
              }, o;
            }().value(function (t) {
              return t[1];
            })(Object.entries(c)),
                p = Cu().innerRadius(0).outerRadius(a);

            s.selectAll("mySlices").data(d).enter().append("path").attr("d", p).attr("fill", function (t) {
              return f(t.data[0]);
            }).attr("class", "pieCircle"), s.selectAll("mySlices").data(d).enter().append("text").text(function (t) {
              return (t.data[1] / u * 100).toFixed(0) + "%";
            }).attr("transform", function (t) {
              return "translate(" + p.centroid(t) + ")";
            }).style("text-anchor", "middle").attr("class", "slice"), s.append("text").text(n.yy.getTitle()).attr("x", 0).attr("y", -200).attr("class", "pieTitleText");
            var y = s.selectAll(".legend").data(f.domain()).enter().append("g").attr("class", "legend").attr("transform", function (t, e) {
              return "translate(216," + (22 * e - 22 * f.domain().length / 2) + ")";
            });
            y.append("rect").attr("width", 18).attr("height", 18).style("fill", f).style("stroke", f), y.data(d).append("text").attr("x", 22).attr("y", 14).text(function (t) {
              return n.yy.getShowData() || ww.showData || ww.pie.showData ? t.data[0] + " [" + t.data[1] + "]" : t.data[0];
            });
          } catch (t) {
            o.error("Error while rendering info diagram"), o.error(t);
          }
        };

        var Tw = n(6463),
            Ew = n.n(Tw),
            Cw = [],
            Sw = {},
            Aw = {},
            Mw = {},
            Nw = {};
        var Dw = {
          RequirementType: {
            REQUIREMENT: "Requirement",
            FUNCTIONAL_REQUIREMENT: "Functional Requirement",
            INTERFACE_REQUIREMENT: "Interface Requirement",
            PERFORMANCE_REQUIREMENT: "Performance Requirement",
            PHYSICAL_REQUIREMENT: "Physical Requirement",
            DESIGN_CONSTRAINT: "Design Constraint"
          },
          RiskLevel: {
            LOW_RISK: "Low",
            MED_RISK: "Medium",
            HIGH_RISK: "High"
          },
          VerifyType: {
            VERIFY_ANALYSIS: "Analysis",
            VERIFY_DEMONSTRATION: "Demonstration",
            VERIFY_INSPECTION: "Inspection",
            VERIFY_TEST: "Test"
          },
          Relationships: {
            CONTAINS: "contains",
            COPIES: "copies",
            DERIVES: "derives",
            SATISFIES: "satisfies",
            VERIFIES: "verifies",
            REFINES: "refines",
            TRACES: "traces"
          },
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().req;
          },
          addRequirement: function addRequirement(t, e) {
            return void 0 === Aw[t] && (Aw[t] = {
              name: t,
              type: e,
              id: Sw.id,
              text: Sw.text,
              risk: Sw.risk,
              verifyMethod: Sw.verifyMethod
            }), Sw = {}, Aw[t];
          },
          getRequirements: function getRequirements() {
            return Aw;
          },
          setNewReqId: function setNewReqId(t) {
            void 0 !== Sw && (Sw.id = t);
          },
          setNewReqText: function setNewReqText(t) {
            void 0 !== Sw && (Sw.text = t);
          },
          setNewReqRisk: function setNewReqRisk(t) {
            void 0 !== Sw && (Sw.risk = t);
          },
          setNewReqVerifyMethod: function setNewReqVerifyMethod(t) {
            void 0 !== Sw && (Sw.verifyMethod = t);
          },
          addElement: function addElement(t) {
            return void 0 === Nw[t] && (Nw[t] = {
              name: t,
              type: Mw.type,
              docRef: Mw.docRef
            }, o.info("Added new requirement: ", t)), Mw = {}, Nw[t];
          },
          getElements: function getElements() {
            return Nw;
          },
          setNewElementType: function setNewElementType(t) {
            void 0 !== Mw && (Mw.type = t);
          },
          setNewElementDocRef: function setNewElementDocRef(t) {
            void 0 !== Mw && (Mw.docRef = t);
          },
          addRelationship: function addRelationship(t, e, n) {
            Cw.push({
              type: t,
              src: e,
              dst: n
            });
          },
          getRelationships: function getRelationships() {
            return Cw;
          },
          clear: function clear() {
            Cw = [], Sw = {}, Aw = {}, Mw = {}, Nw = {};
          }
        };
        var Ow = {
          CONTAINS: "contains",
          ARROW: "arrow"
        };
        var Bw = Ow;

        var Lw = {},
            Iw = 0,
            Rw = function Rw(t, e) {
          return t.insert("rect", "#" + e).attr("class", "req reqBox").attr("x", 0).attr("y", 0).attr("width", Lw.rect_min_width + "px").attr("height", Lw.rect_min_height + "px");
        },
            Pw = function Pw(t, e, n) {
          var r = Lw.rect_min_width / 2,
              i = t.append("text").attr("class", "req reqLabel reqTitle").attr("id", e).attr("x", r).attr("y", Lw.rect_padding).attr("dominant-baseline", "hanging"),
              a = 0;
          n.forEach(function (t) {
            0 == a ? i.append("tspan").attr("text-anchor", "middle").attr("x", Lw.rect_min_width / 2).attr("dy", 0).text(t) : i.append("tspan").attr("text-anchor", "middle").attr("x", Lw.rect_min_width / 2).attr("dy", .75 * Lw.line_height).text(t), a++;
          });
          var o = 1.5 * Lw.rect_padding + a * Lw.line_height * .75;
          return t.append("line").attr("class", "req-title-line").attr("x1", "0").attr("x2", Lw.rect_min_width).attr("y1", o).attr("y2", o), {
            titleNode: i,
            y: o
          };
        },
            Fw = function Fw(t, e, n, r) {
          var i = t.append("text").attr("class", "req reqLabel").attr("id", e).attr("x", Lw.rect_padding).attr("y", r).attr("dominant-baseline", "hanging"),
              a = 0,
              o = [];
          return n.forEach(function (t) {
            for (var e = t.length; e > 30 && a < 3;) {
              var n = t.substring(0, 30);
              e = (t = t.substring(30, t.length)).length, o[o.length] = n, a++;
            }

            if (3 == a) {
              var r = o[o.length - 1];
              o[o.length - 1] = r.substring(0, r.length - 4) + "...";
            } else o[o.length] = t;

            a = 0;
          }), o.forEach(function (t) {
            i.append("tspan").attr("x", Lw.rect_padding).attr("dy", Lw.line_height).text(t);
          }), i;
        },
            jw = function jw(t) {
          return t.replace(/\s/g, "").replace(/\./g, "_");
        };

        var Yw = function Yw(t) {
          if (void 0 !== t) for (var e = Object.keys(t), n = 0; n < e.length; n++) {
            Lw[e[n]] = t[e[n]];
          }
        };

        var Uw = n(9923),
            zw = n.n(Uw),
            qw = void 0,
            $w = {},
            Hw = [],
            Ww = [],
            Vw = "",
            Gw = !1,
            Xw = !1,
            Zw = !1,
            Kw = function Kw(t, e, n, r) {
          var i = $w[t];
          i && e === i.name && null == n || (null != n && null != n.text || (n = {
            text: e,
            wrap: null,
            type: r
          }), null != r && null != n.text || (n = {
            text: e,
            wrap: null,
            type: r
          }), $w[t] = {
            name: e,
            description: n.text,
            wrap: void 0 === n.wrap && ek() || !!n.wrap,
            prevActor: qw,
            links: {},
            properties: {},
            actorCnt: null,
            rectData: null,
            type: r || "participant"
          }, qw && $w[qw] && ($w[qw].nextActor = t), qw = t);
        },
            Qw = function Qw(t) {
          var e,
              n = 0;

          for (e = 0; e < Hw.length; e++) {
            Hw[e].type === nk.ACTIVE_START && Hw[e].from.actor === t && n++, Hw[e].type === nk.ACTIVE_END && Hw[e].from.actor === t && n--;
          }

          return n;
        },
            Jw = function Jw(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            text: void 0,
            wrap: void 0
          },
              r = arguments.length > 3 ? arguments[3] : void 0;

          if (r === nk.ACTIVE_END) {
            var i = Qw(t.actor);

            if (i < 1) {
              var a = new Error("Trying to inactivate an inactive participant (" + t.actor + ")");
              throw a.hash = {
                text: "->>-",
                token: "->>-",
                line: "1",
                loc: {
                  first_line: 1,
                  last_line: 1,
                  first_column: 1,
                  last_column: 1
                },
                expected: ["'ACTIVE_PARTICIPANT'"]
              }, a;
            }
          }

          return Hw.push({
            from: t,
            to: e,
            message: n.text,
            wrap: void 0 === n.wrap && ek() || !!n.wrap,
            type: r
          }), !0;
        },
            tk = function tk(t) {
          return $w[t];
        },
            ek = function ek() {
          return Zw;
        },
            nk = {
          SOLID: 0,
          DOTTED: 1,
          NOTE: 2,
          SOLID_CROSS: 3,
          DOTTED_CROSS: 4,
          SOLID_OPEN: 5,
          DOTTED_OPEN: 6,
          LOOP_START: 10,
          LOOP_END: 11,
          ALT_START: 12,
          ALT_ELSE: 13,
          ALT_END: 14,
          OPT_START: 15,
          OPT_END: 16,
          ACTIVE_START: 17,
          ACTIVE_END: 18,
          PAR_START: 19,
          PAR_AND: 20,
          PAR_END: 21,
          RECT_START: 22,
          RECT_END: 23,
          SOLID_POINT: 24,
          DOTTED_POINT: 25
        },
            rk = function rk(t, e, n) {
          var r = {
            actor: t,
            placement: e,
            message: n.text,
            wrap: void 0 === n.wrap && ek() || !!n.wrap
          },
              i = [].concat(t, t);
          Ww.push(r), Hw.push({
            from: i[0],
            to: i[1],
            message: n.text,
            wrap: void 0 === n.wrap && ek() || !!n.wrap,
            type: nk.NOTE,
            placement: e
          });
        },
            ik = function ik(t, e) {
          var n = tk(t);

          try {
            var r = mm(e.text, Ev());
            r = (r = r.replace(/&amp;/g, "&")).replace(/&equals;/g, "="), ak(n, JSON.parse(r));
          } catch (t) {
            o.error("error while parsing actor link text", t);
          }
        };

        function ak(t, e) {
          if (null == t.links) t.links = e;else for (var n in e) {
            t.links[n] = e[n];
          }
        }

        var ok = function ok(t, e) {
          var n = tk(t);

          try {
            var r = mm(e.text, Ev());
            sk(n, JSON.parse(r));
          } catch (t) {
            o.error("error while parsing actor properties text", t);
          }
        };

        function sk(t, e) {
          if (null == t.properties) t.properties = e;else for (var n in e) {
            t.properties[n] = e[n];
          }
        }

        var ck = function ck(t, e) {
          var n = tk(t),
              r = document.getElementById(e.text);

          try {
            var i = r.innerHTML,
                a = JSON.parse(i);
            a.properties && sk(n, a.properties), a.links && ak(n, a.links);
          } catch (t) {
            o.error("error while parsing actor details text", t);
          }
        },
            uk = function uk(t) {
          Vw = t.text, Gw = void 0 === t.wrap && ek() || !!t.wrap;
        };

        var lk = {
          addActor: Kw,
          addMessage: function addMessage(t, e, n, r) {
            Hw.push({
              from: t,
              to: e,
              message: n.text,
              wrap: void 0 === n.wrap && ek() || !!n.wrap,
              answer: r
            });
          },
          addSignal: Jw,
          addLinks: ik,
          addDetails: ck,
          addProperties: ok,
          autoWrap: ek,
          setWrap: function setWrap(t) {
            Zw = t;
          },
          enableSequenceNumbers: function enableSequenceNumbers() {
            Xw = !0;
          },
          showSequenceNumbers: function showSequenceNumbers() {
            return Xw;
          },
          getMessages: function getMessages() {
            return Hw;
          },
          getActors: function getActors() {
            return $w;
          },
          getActor: tk,
          getActorKeys: function getActorKeys() {
            return Object.keys($w);
          },
          getActorProperty: function getActorProperty(t, e) {
            if (void 0 !== t && void 0 !== t.properties) return t.properties[e];
          },
          getTitle: function getTitle() {
            return Vw;
          },
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().sequence;
          },
          getTitleWrapped: function getTitleWrapped() {
            return Gw;
          },
          clear: function clear() {
            $w = {}, Hw = [];
          },
          parseMessage: function parseMessage(t) {
            var e = t.trim(),
                n = {
              text: e.replace(/^[:]?(?:no)?wrap:/, "").trim(),
              wrap: null !== e.match(/^[:]?wrap:/) || null === e.match(/^[:]?nowrap:/) && void 0
            };
            return o.debug("parseMessage:", n), n;
          },
          LINETYPE: nk,
          ARROWTYPE: {
            FILLED: 0,
            OPEN: 1
          },
          PLACEMENT: {
            LEFTOF: 0,
            RIGHTOF: 1,
            OVER: 2
          },
          addNote: rk,
          setTitle: uk,
          apply: function t(e) {
            if (e instanceof Array) e.forEach(function (e) {
              t(e);
            });else switch (e.type) {
              case "addParticipant":
                Kw(e.actor, e.actor, e.description, "participant");
                break;

              case "addActor":
                Kw(e.actor, e.actor, e.description, "actor");
                break;

              case "activeStart":
              case "activeEnd":
                Jw(e.actor, void 0, void 0, e.signalType);
                break;

              case "addNote":
                rk(e.actor, e.placement, e.text);
                break;

              case "addLinks":
                ik(e.actor, e.text);
                break;

              case "addALink":
                !function (t, e) {
                  var n = tk(t);

                  try {
                    var r = {},
                        i = mm(e.text, Ev()),
                        a = i.indexOf("@"),
                        s = (i = (i = i.replace(/&amp;/g, "&")).replace(/&equals;/g, "=")).slice(0, a - 1).trim(),
                        c = i.slice(a + 1).trim();
                    r[s] = c, ak(n, r);
                  } catch (t) {
                    o.error("error while parsing actor link text", t);
                  }
                }(e.actor, e.text);
                break;

              case "addProperties":
                ok(e.actor, e.text);
                break;

              case "addDetails":
                ck(e.actor, e.text);
                break;

              case "addMessage":
                Jw(e.from, e.to, e.msg, e.signalType);
                break;

              case "loopStart":
                Jw(void 0, void 0, e.loopText, e.signalType);
                break;

              case "loopEnd":
                Jw(void 0, void 0, void 0, e.signalType);
                break;

              case "rectStart":
                Jw(void 0, void 0, e.color, e.signalType);
                break;

              case "rectEnd":
                Jw(void 0, void 0, void 0, e.signalType);
                break;

              case "optStart":
                Jw(void 0, void 0, e.optText, e.signalType);
                break;

              case "optEnd":
                Jw(void 0, void 0, void 0, e.signalType);
                break;

              case "altStart":
              case "else":
                Jw(void 0, void 0, e.altText, e.signalType);
                break;

              case "altEnd":
                Jw(void 0, void 0, void 0, e.signalType);
                break;

              case "setTitle":
                uk(e.text);
                break;

              case "parStart":
              case "and":
                Jw(void 0, void 0, e.parText, e.signalType);
                break;

              case "parEnd":
                Jw(void 0, void 0, void 0, e.signalType);
            }
          }
        };

        var hk = [],
            fk = function fk(t, e) {
          var n = t.append("rect");
          return n.attr("x", e.x), n.attr("y", e.y), n.attr("fill", e.fill), n.attr("stroke", e.stroke), n.attr("width", e.width), n.attr("height", e.height), n.attr("rx", e.rx), n.attr("ry", e.ry), void 0 !== e.class && n.attr("class", e.class), n;
        },
            dk = function dk(t) {
          return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/javascript:/g, "");
        },
            pk = function pk(t, e) {
          var n;
          n = function n() {
            var n = document.querySelectorAll(t);
            n[0].addEventListener("mouseover", function () {
              yk("actor" + e + "_popup");
            }), n[0].addEventListener("mouseout", function () {
              gk("actor" + e + "_popup");
            });
          }, hk.push(n);
        },
            yk = function yk(t) {
          var e = document.getElementById(t);
          null != e && (e.style.display = "block");
        },
            gk = function gk(t) {
          var e = document.getElementById(t);
          null != e && (e.style.display = "none");
        },
            mk = function mk(t, e) {
          var n = 0,
              r = 0,
              i = e.text.split(wm.lineBreakRegex),
              a = [],
              o = 0,
              s = function s() {
            return e.y;
          };

          if (void 0 !== e.valign && void 0 !== e.textMargin && e.textMargin > 0) switch (e.valign) {
            case "top":
            case "start":
              s = function s() {
                return Math.round(e.y + e.textMargin);
              };

              break;

            case "middle":
            case "center":
              s = function s() {
                return Math.round(e.y + (n + r + e.textMargin) / 2);
              };

              break;

            case "bottom":
            case "end":
              s = function s() {
                return Math.round(e.y + (n + r + 2 * e.textMargin) - e.textMargin);
              };

          }
          if (void 0 !== e.anchor && void 0 !== e.textMargin && void 0 !== e.width) switch (e.anchor) {
            case "left":
            case "start":
              e.x = Math.round(e.x + e.textMargin), e.anchor = "start", e.dominantBaseline = "text-after-edge", e.alignmentBaseline = "middle";
              break;

            case "middle":
            case "center":
              e.x = Math.round(e.x + e.width / 2), e.anchor = "middle", e.dominantBaseline = "middle", e.alignmentBaseline = "middle";
              break;

            case "right":
            case "end":
              e.x = Math.round(e.x + e.width - e.textMargin), e.anchor = "end", e.dominantBaseline = "text-before-edge", e.alignmentBaseline = "middle";
          }

          for (var c = 0; c < i.length; c++) {
            var u = i[c];
            void 0 !== e.textMargin && 0 === e.textMargin && void 0 !== e.fontSize && (o = c * e.fontSize);
            var l = t.append("text");

            if (l.attr("x", e.x), l.attr("y", s()), void 0 !== e.anchor && l.attr("text-anchor", e.anchor).attr("dominant-baseline", e.dominantBaseline).attr("alignment-baseline", e.alignmentBaseline), void 0 !== e.fontFamily && l.style("font-family", e.fontFamily), void 0 !== e.fontSize && l.style("font-size", e.fontSize), void 0 !== e.fontWeight && l.style("font-weight", e.fontWeight), void 0 !== e.fill && l.attr("fill", e.fill), void 0 !== e.class && l.attr("class", e.class), void 0 !== e.dy ? l.attr("dy", e.dy) : 0 !== o && l.attr("dy", o), e.tspan) {
              var h = l.append("tspan");
              h.attr("x", e.x), void 0 !== e.fill && h.attr("fill", e.fill), h.text(u);
            } else l.text(u);

            void 0 !== e.valign && void 0 !== e.textMargin && e.textMargin > 0 && (r += (l._groups || l)[0][0].getBBox().height, n = r), a.push(l);
          }

          return a;
        },
            vk = -1,
            bk = function () {
          function t(t, e, n, i, a, o, s) {
            r(e.append("text").attr("x", n + a / 2).attr("y", i + o / 2 + 5).style("text-anchor", "middle").text(t), s);
          }

          function e(t, e, n, i, a, o, s, c) {
            for (var u = c.actorFontSize, l = c.actorFontFamily, h = c.actorFontWeight, f = t.split(wm.lineBreakRegex), d = 0; d < f.length; d++) {
              var p = d * u - u * (f.length - 1) / 2,
                  y = e.append("text").attr("x", n + a / 2).attr("y", i).style("text-anchor", "middle").style("font-size", u).style("font-weight", h).style("font-family", l);
              y.append("tspan").attr("x", n + a / 2).attr("dy", p).text(f[d]), y.attr("y", i + o / 2).attr("dominant-baseline", "central").attr("alignment-baseline", "central"), r(y, s);
            }
          }

          function n(t, n, i, a, o, s, c, u) {
            var l = n.append("switch"),
                h = l.append("foreignObject").attr("x", i).attr("y", a).attr("width", o).attr("height", s).append("xhtml:div").style("display", "table").style("height", "100%").style("width", "100%");
            h.append("div").style("display", "table-cell").style("text-align", "center").style("vertical-align", "middle").text(t), e(t, l, i, a, o, s, c, u), r(h, c);
          }

          function r(t, e) {
            for (var n in e) {
              e.hasOwnProperty(n) && t.attr(n, e[n]);
            }
          }

          return function (r) {
            return "fo" === r.textPlacement ? n : "old" === r.textPlacement ? t : e;
          };
        }(),
            _k = function () {
          function t(t, e, n, i, a, o, s) {
            r(e.append("text").attr("x", n).attr("y", i).style("text-anchor", "start").text(t), s);
          }

          function e(t, e, n, i, a, o, s, c) {
            for (var u = c.actorFontSize, l = c.actorFontFamily, h = c.actorFontWeight, f = t.split(wm.lineBreakRegex), d = 0; d < f.length; d++) {
              var p = d * u - u * (f.length - 1) / 2,
                  y = e.append("text").attr("x", n).attr("y", i).style("text-anchor", "start").style("font-size", u).style("font-weight", h).style("font-family", l);
              y.append("tspan").attr("x", n).attr("dy", p).text(f[d]), y.attr("y", i + o / 2).attr("dominant-baseline", "central").attr("alignment-baseline", "central"), r(y, s);
            }
          }

          function n(t, n, i, a, o, s, c, u) {
            var l = n.append("switch"),
                h = l.append("foreignObject").attr("x", i).attr("y", a).attr("width", o).attr("height", s).append("xhtml:div").style("display", "table").style("height", "100%").style("width", "100%");
            h.append("div").style("display", "table-cell").style("text-align", "center").style("vertical-align", "middle").text(t), e(t, l, i, a, 0, s, c, u), r(h, c);
          }

          function r(t, e) {
            for (var n in e) {
              e.hasOwnProperty(n) && t.attr(n, e[n]);
            }
          }

          return function (r) {
            return "fo" === r.textPlacement ? n : "old" === r.textPlacement ? t : e;
          };
        }();

        var xk = fk,
            wk = function wk(t, e, n) {
          switch (e.type) {
            case "actor":
              return function (t, e, n) {
                var r = e.x + e.width / 2;
                0 === e.y && (vk++, t.append("line").attr("id", "actor" + vk).attr("x1", r).attr("y1", 80).attr("x2", r).attr("y2", 2e3).attr("class", "actor-line").attr("stroke-width", "0.5px").attr("stroke", "#999"));
                var i = t.append("g");
                i.attr("class", "actor-man");
                var a = {
                  x: 0,
                  y: 0,
                  fill: "#EDF2AE",
                  stroke: "#666",
                  width: 100,
                  anchor: "start",
                  height: 100,
                  rx: 0,
                  ry: 0
                };
                a.x = e.x, a.y = e.y, a.fill = "#eaeaea", a.width = e.width, a.height = e.height, a.class = "actor", a.rx = 3, a.ry = 3, i.append("line").attr("id", "actor-man-torso" + vk).attr("x1", r).attr("y1", e.y + 25).attr("x2", r).attr("y2", e.y + 45), i.append("line").attr("id", "actor-man-arms" + vk).attr("x1", r - 18).attr("y1", e.y + 33).attr("x2", r + 18).attr("y2", e.y + 33), i.append("line").attr("x1", r - 18).attr("y1", e.y + 60).attr("x2", r).attr("y2", e.y + 45), i.append("line").attr("x1", r).attr("y1", e.y + 45).attr("x2", r + 16).attr("y2", e.y + 60);
                var o = i.append("circle");
                o.attr("cx", e.x + e.width / 2), o.attr("cy", e.y + 10), o.attr("r", 15), o.attr("width", e.width), o.attr("height", e.height);
                var s = i.node().getBBox();
                return e.height = s.height, bk(n)(e.description, i, a.x, a.y + 35, a.width, a.height, {
                  class: "actor"
                }, n), e.height;
              }(t, e, n);

            case "participant":
              return function (t, e, n) {
                var r = e.x + e.width / 2,
                    i = t.append("g"),
                    a = i;
                0 === e.y && (vk++, a.append("line").attr("id", "actor" + vk).attr("x1", r).attr("y1", 5).attr("x2", r).attr("y2", 2e3).attr("class", "actor-line").attr("stroke-width", "0.5px").attr("stroke", "#999"), a = i.append("g"), e.actorCnt = vk, null != e.links && (a.attr("id", "root-" + vk), pk("#root-" + vk, vk)));
                var o = {
                  x: 0,
                  y: 0,
                  fill: "#EDF2AE",
                  stroke: "#666",
                  width: 100,
                  anchor: "start",
                  height: 100,
                  rx: 0,
                  ry: 0
                },
                    s = "actor";
                null != e.properties && e.properties.class ? s = e.properties.class : o.fill = "#eaeaea", o.x = e.x, o.y = e.y, o.width = e.width, o.height = e.height, o.class = s, o.rx = 3, o.ry = 3;
                var c = fk(a, o);

                if (e.rectData = o, null != e.properties && e.properties.icon) {
                  var u = e.properties.icon.trim();
                  "@" === u.charAt(0) ? function (t, e, n, r) {
                    var i = t.append("use");
                    i.attr("x", e), i.attr("y", n);
                    var a = dk(r);
                    i.attr("xlink:href", "#" + a);
                  }(a, o.x + o.width - 20, o.y + 10, u.substr(1)) : function (t, e, n, r) {
                    var i = t.append("image");
                    i.attr("x", e), i.attr("y", n);
                    var a = dk(r);
                    i.attr("xlink:href", a);
                  }(a, o.x + o.width - 20, o.y + 10, u);
                }

                bk(n)(e.description, a, o.x, o.y, o.width, o.height, {
                  class: "actor"
                }, n);
                var l = e.height;

                if (c.node) {
                  var h = c.node().getBBox();
                  e.height = h.height, l = h.height;
                }

                return l;
              }(t, e, n);
          }
        },
            kk = function kk(t, e, n, r, i) {
          if (void 0 === e.links || null === e.links || 0 === Object.keys(e.links).length) return {
            height: 0,
            width: 0
          };
          var a = e.links,
              o = e.actorCnt,
              s = e.rectData,
              c = "none";
          i && (c = "block !important");
          var u = t.append("g");
          u.attr("id", "actor" + o + "_popup"), u.attr("class", "actorPopupMenu"), u.attr("display", c), pk("#actor" + o + "_popup", o);
          var l = "";
          void 0 !== s.class && (l = " " + s.class);
          var h = s.width > n ? s.width : n,
              f = u.append("rect");

          if (f.attr("class", "actorPopupMenuPanel" + l), f.attr("x", s.x), f.attr("y", s.height), f.attr("fill", s.fill), f.attr("stroke", s.stroke), f.attr("width", h), f.attr("height", s.height), f.attr("rx", s.rx), f.attr("ry", s.ry), null != a) {
            var d = 20;

            for (var p in a) {
              var y = u.append("a"),
                  g = dk(a[p]);
              y.attr("xlink:href", g), y.attr("target", "_blank"), _k(r)(p, y, s.x + 10, s.height + d, h, 20, {
                class: "actor"
              }, r), d += 30;
            }
          }

          return f.attr("height", d), {
            height: s.height + d,
            width: h
          };
        },
            Tk = function Tk(t) {
          return t.append("g");
        },
            Ek = function Ek(t, e, n, r) {
          var i = r.boxMargin,
              a = r.boxTextMargin,
              o = r.labelBoxHeight,
              s = r.labelBoxWidth,
              c = r.messageFontFamily,
              u = r.messageFontSize,
              l = r.messageFontWeight,
              h = t.append("g"),
              f = function f(t, e, n, r) {
            return h.append("line").attr("x1", t).attr("y1", e).attr("x2", n).attr("y2", r).attr("class", "loopLine");
          };

          f(e.startx, e.starty, e.stopx, e.starty), f(e.stopx, e.starty, e.stopx, e.stopy), f(e.startx, e.stopy, e.stopx, e.stopy), f(e.startx, e.starty, e.startx, e.stopy), void 0 !== e.sections && e.sections.forEach(function (t) {
            f(e.startx, t.y, e.stopx, t.y).style("stroke-dasharray", "3, 3");
          });
          var d = {
            x: 0,
            y: 0,
            fill: void 0,
            anchor: void 0,
            style: "#666",
            width: void 0,
            height: void 0,
            textMargin: 0,
            rx: 0,
            ry: 0,
            tspan: !0,
            valign: void 0
          };
          d.text = n, d.x = e.startx, d.y = e.starty, d.fontFamily = c, d.fontSize = u, d.fontWeight = l, d.anchor = "middle", d.valign = "middle", d.tspan = !1, d.width = s || 50, d.height = o || 20, d.textMargin = a, d.class = "labelText", function (t, e) {
            var n = t.append("polygon");
            n.attr("points", function (t, e, n, r, i) {
              return t + "," + e + " " + (t + n) + "," + e + " " + (t + n) + "," + (e + r - 7) + " " + (t + n - 8.4) + "," + (e + r) + " " + t + "," + (e + r);
            }(e.x, e.y, e.width, e.height)), n.attr("class", "labelBox"), e.y = e.y + e.height / 2, mk(t, e);
          }(h, d), (d = {
            x: 0,
            y: 0,
            fill: void 0,
            anchor: void 0,
            style: "#666",
            width: void 0,
            height: void 0,
            textMargin: 0,
            rx: 0,
            ry: 0,
            tspan: !0,
            valign: void 0
          }).text = e.title, d.x = e.startx + s / 2 + (e.stopx - e.startx) / 2, d.y = e.starty + i + a, d.anchor = "middle", d.valign = "middle", d.textMargin = a, d.class = "loopText", d.fontFamily = c, d.fontSize = u, d.fontWeight = l, d.wrap = !0;
          var p = mk(h, d);
          return void 0 !== e.sectionTitles && e.sectionTitles.forEach(function (t, n) {
            if (t.message) {
              d.text = t.message, d.x = e.startx + (e.stopx - e.startx) / 2, d.y = e.sections[n].y + i + a, d.class = "loopText", d.anchor = "middle", d.valign = "middle", d.tspan = !1, d.fontFamily = c, d.fontSize = u, d.fontWeight = l, d.wrap = e.wrap, p = mk(h, d);
              var r = Math.round(p.map(function (t) {
                return (t._groups || t)[0][0].getBBox().height;
              }).reduce(function (t, e) {
                return t + e;
              }));
              e.sections[n].height += r - (i + a);
            }
          }), e.height = Math.round(e.stopy - e.starty), h;
        },
            Ck = function Ck() {
          return {
            x: 0,
            y: 0,
            fill: void 0,
            anchor: void 0,
            style: "#666",
            width: void 0,
            height: void 0,
            textMargin: 0,
            rx: 0,
            ry: 0,
            tspan: !0,
            valign: void 0
          };
        },
            Sk = function Sk() {
          return {
            x: 0,
            y: 0,
            fill: "#EDF2AE",
            stroke: "#666",
            width: 100,
            anchor: "start",
            height: 100,
            rx: 0,
            ry: 0
          };
        };

        Uw.parser.yy = lk;

        var Ak = {},
            Mk = {
          data: {
            startx: void 0,
            stopx: void 0,
            starty: void 0,
            stopy: void 0
          },
          verticalPos: 0,
          sequenceItems: [],
          activations: [],
          models: {
            getHeight: function getHeight() {
              return Math.max.apply(null, 0 === this.actors.length ? [0] : this.actors.map(function (t) {
                return t.height || 0;
              })) + (0 === this.loops.length ? 0 : this.loops.map(function (t) {
                return t.height || 0;
              }).reduce(function (t, e) {
                return t + e;
              })) + (0 === this.messages.length ? 0 : this.messages.map(function (t) {
                return t.height || 0;
              }).reduce(function (t, e) {
                return t + e;
              })) + (0 === this.notes.length ? 0 : this.notes.map(function (t) {
                return t.height || 0;
              }).reduce(function (t, e) {
                return t + e;
              }));
            },
            clear: function clear() {
              this.actors = [], this.loops = [], this.messages = [], this.notes = [];
            },
            addActor: function addActor(t) {
              this.actors.push(t);
            },
            addLoop: function addLoop(t) {
              this.loops.push(t);
            },
            addMessage: function addMessage(t) {
              this.messages.push(t);
            },
            addNote: function addNote(t) {
              this.notes.push(t);
            },
            lastActor: function lastActor() {
              return this.actors[this.actors.length - 1];
            },
            lastLoop: function lastLoop() {
              return this.loops[this.loops.length - 1];
            },
            lastMessage: function lastMessage() {
              return this.messages[this.messages.length - 1];
            },
            lastNote: function lastNote() {
              return this.notes[this.notes.length - 1];
            },
            actors: [],
            loops: [],
            messages: [],
            notes: []
          },
          init: function init() {
            this.sequenceItems = [], this.activations = [], this.models.clear(), this.data = {
              startx: void 0,
              stopx: void 0,
              starty: void 0,
              stopy: void 0
            }, this.verticalPos = 0, Ik(Uw.parser.yy.getConfig());
          },
          updateVal: function updateVal(t, e, n, r) {
            void 0 === t[e] ? t[e] = n : t[e] = r(n, t[e]);
          },
          updateBounds: function updateBounds(t, e, n, r) {
            var i = this,
                a = 0;

            function o(o) {
              return function (s) {
                a++;
                var c = i.sequenceItems.length - a + 1;
                i.updateVal(s, "starty", e - c * Ak.boxMargin, Math.min), i.updateVal(s, "stopy", r + c * Ak.boxMargin, Math.max), i.updateVal(Mk.data, "startx", t - c * Ak.boxMargin, Math.min), i.updateVal(Mk.data, "stopx", n + c * Ak.boxMargin, Math.max), "activation" !== o && (i.updateVal(s, "startx", t - c * Ak.boxMargin, Math.min), i.updateVal(s, "stopx", n + c * Ak.boxMargin, Math.max), i.updateVal(Mk.data, "starty", e - c * Ak.boxMargin, Math.min), i.updateVal(Mk.data, "stopy", r + c * Ak.boxMargin, Math.max));
              };
            }

            this.sequenceItems.forEach(o()), this.activations.forEach(o("activation"));
          },
          insert: function insert(t, e, n, r) {
            var i = Math.min(t, n),
                a = Math.max(t, n),
                o = Math.min(e, r),
                s = Math.max(e, r);
            this.updateVal(Mk.data, "startx", i, Math.min), this.updateVal(Mk.data, "starty", o, Math.min), this.updateVal(Mk.data, "stopx", a, Math.max), this.updateVal(Mk.data, "stopy", s, Math.max), this.updateBounds(i, o, a, s);
          },
          newActivation: function newActivation(t, e, n) {
            var r = n[t.from.actor],
                i = Rk(t.from.actor).length || 0,
                a = r.x + r.width / 2 + (i - 1) * Ak.activationWidth / 2;
            this.activations.push({
              startx: a,
              starty: this.verticalPos + 2,
              stopx: a + Ak.activationWidth,
              stopy: void 0,
              actor: t.from.actor,
              anchored: Tk(e)
            });
          },
          endActivation: function endActivation(t) {
            var e = this.activations.map(function (t) {
              return t.actor;
            }).lastIndexOf(t.from.actor);
            return this.activations.splice(e, 1)[0];
          },
          createLoop: function createLoop() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              message: void 0,
              wrap: !1,
              width: void 0
            },
                e = arguments.length > 1 ? arguments[1] : void 0;
            return {
              startx: void 0,
              starty: this.verticalPos,
              stopx: void 0,
              stopy: void 0,
              title: t.message,
              wrap: t.wrap,
              width: t.width,
              height: 0,
              fill: e
            };
          },
          newLoop: function newLoop() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              message: void 0,
              wrap: !1,
              width: void 0
            },
                e = arguments.length > 1 ? arguments[1] : void 0;
            this.sequenceItems.push(this.createLoop(t, e));
          },
          endLoop: function endLoop() {
            return this.sequenceItems.pop();
          },
          addSectionToLoop: function addSectionToLoop(t) {
            var e = this.sequenceItems.pop();
            e.sections = e.sections || [], e.sectionTitles = e.sectionTitles || [], e.sections.push({
              y: Mk.getVerticalPos(),
              height: 0
            }), e.sectionTitles.push(t), this.sequenceItems.push(e);
          },
          bumpVerticalPos: function bumpVerticalPos(t) {
            this.verticalPos = this.verticalPos + t, this.data.stopy = this.verticalPos;
          },
          getVerticalPos: function getVerticalPos() {
            return this.verticalPos;
          },
          getBounds: function getBounds() {
            return {
              bounds: this.data,
              models: this.models
            };
          }
        },
            Nk = function Nk(t) {
          return {
            fontFamily: t.messageFontFamily,
            fontSize: t.messageFontSize,
            fontWeight: t.messageFontWeight
          };
        },
            Dk = function Dk(t) {
          return {
            fontFamily: t.noteFontFamily,
            fontSize: t.noteFontSize,
            fontWeight: t.noteFontWeight
          };
        },
            Ok = function Ok(t) {
          return {
            fontFamily: t.actorFontFamily,
            fontSize: t.actorFontSize,
            fontWeight: t.actorFontWeight
          };
        },
            Bk = function Bk(t, e, n, r) {
          for (var i = 0, a = 0, o = 0, s = 0; s < n.length; s++) {
            var c = e[n[s]];
            c.width = c.width || Ak.width, c.height = Math.max(c.height || Ak.height, Ak.height), c.margin = c.margin || Ak.actorMargin, c.x = i + a, c.y = r;
            var u = wk(t, c, Ak);
            o = Math.max(o, u), Mk.insert(c.x, r, c.x + c.width, c.height), i += c.width, a += c.margin, Mk.models.addActor(c);
          }

          Mk.bumpVerticalPos(o);
        },
            Lk = function Lk(t, e, n) {
          for (var r = 0, i = 0, a = 0; a < n.length; a++) {
            var o = e[n[a]],
                s = jk(o),
                c = kk(t, o, s, Ak, Ak.forceMenus);
            c.height > r && (r = c.height), c.width + o.x > i && (i = c.width + o.x);
          }

          return {
            maxHeight: r,
            maxWidth: i
          };
        },
            Ik = function Ik(t) {
          sv(Ak, t), t.fontFamily && (Ak.actorFontFamily = Ak.noteFontFamily = Ak.messageFontFamily = t.fontFamily), t.fontSize && (Ak.actorFontSize = Ak.noteFontSize = Ak.messageFontSize = t.fontSize), t.fontWeight && (Ak.actorFontWeight = Ak.noteFontWeight = Ak.messageFontWeight = t.fontWeight);
        },
            Rk = function Rk(t) {
          return Mk.activations.filter(function (e) {
            return e.actor === t;
          });
        },
            Pk = function Pk(t, e) {
          var n = e[t],
              r = Rk(t);
          return [r.reduce(function (t, e) {
            return Math.min(t, e.startx);
          }, n.x + n.width / 2), r.reduce(function (t, e) {
            return Math.max(t, e.stopx);
          }, n.x + n.width / 2)];
        };

        function Fk(t, e, n, r, i) {
          Mk.bumpVerticalPos(n);
          var a = r;

          if (e.id && e.message && t[e.id]) {
            var s = t[e.id].width,
                c = Nk(Ak);
            e.message = gv.wrapLabel("[".concat(e.message, "]"), s - 2 * Ak.wrapPadding, c), e.width = s, e.wrap = !0;
            var u = gv.calculateTextDimensions(e.message, c),
                l = Math.max(u.height, Ak.labelBoxHeight);
            a = r + l, o.debug("".concat(l, " - ").concat(e.message));
          }

          i(e), Mk.bumpVerticalPos(a);
        }

        var jk = function jk(t) {
          var e = 0,
              n = Ok(Ak);

          for (var r in t.links) {
            var i = gv.calculateTextDimensions(r, n).width + 2 * Ak.wrapPadding + 2 * Ak.boxMargin;
            e < i && (e = i);
          }

          return e;
        };

        var Yk = {
          bounds: Mk,
          drawActors: Bk,
          drawActorsPopup: Lk,
          setConf: Ik,
          draw: function draw(t, e) {
            Ak = Ev().sequence, Uw.parser.yy.clear(), Uw.parser.yy.setWrap(Ak.wrap), Uw.parser.parse(t + "\n"), Mk.init(), o.debug("C:".concat(JSON.stringify(Ak, null, 2)));

            var n = Zc('[id="'.concat(e, '"]')),
                r = Uw.parser.yy.getActors(),
                i = Uw.parser.yy.getActorKeys(),
                a = Uw.parser.yy.getMessages(),
                s = Uw.parser.yy.getTitle(),
                c = function (t, e) {
              var n = {};
              return e.forEach(function (e) {
                if (t[e.to] && t[e.from]) {
                  var r = t[e.to];
                  if (e.placement === Uw.parser.yy.PLACEMENT.LEFTOF && !r.prevActor) return;
                  if (e.placement === Uw.parser.yy.PLACEMENT.RIGHTOF && !r.nextActor) return;
                  var i = void 0 !== e.placement,
                      a = !i,
                      o = i ? Dk(Ak) : Nk(Ak),
                      s = e.wrap ? gv.wrapLabel(e.message, Ak.width - 2 * Ak.wrapPadding, o) : e.message,
                      c = gv.calculateTextDimensions(s, o).width + 2 * Ak.wrapPadding;
                  a && e.from === r.nextActor ? n[e.to] = Math.max(n[e.to] || 0, c) : a && e.from === r.prevActor ? n[e.from] = Math.max(n[e.from] || 0, c) : a && e.from === e.to ? (n[e.from] = Math.max(n[e.from] || 0, c / 2), n[e.to] = Math.max(n[e.to] || 0, c / 2)) : e.placement === Uw.parser.yy.PLACEMENT.RIGHTOF ? n[e.from] = Math.max(n[e.from] || 0, c) : e.placement === Uw.parser.yy.PLACEMENT.LEFTOF ? n[r.prevActor] = Math.max(n[r.prevActor] || 0, c) : e.placement === Uw.parser.yy.PLACEMENT.OVER && (r.prevActor && (n[r.prevActor] = Math.max(n[r.prevActor] || 0, c / 2)), r.nextActor && (n[e.from] = Math.max(n[e.from] || 0, c / 2)));
                }
              }), o.debug("maxMessageWidthPerActor:", n), n;
            }(r, a);

            Ak.height = function (t, e) {
              var n = 0;

              for (var r in Object.keys(t).forEach(function (e) {
                var r = t[e];
                r.wrap && (r.description = gv.wrapLabel(r.description, Ak.width - 2 * Ak.wrapPadding, Ok(Ak)));
                var i = gv.calculateTextDimensions(r.description, Ok(Ak));
                r.width = r.wrap ? Ak.width : Math.max(Ak.width, i.width + 2 * Ak.wrapPadding), r.height = r.wrap ? Math.max(i.height, Ak.height) : Ak.height, n = Math.max(n, r.height);
              }), e) {
                var i = t[r];

                if (i) {
                  var a = t[i.nextActor];

                  if (a) {
                    var o = e[r] + Ak.actorMargin - i.width / 2 - a.width / 2;
                    i.margin = Math.max(o, Ak.actorMargin);
                  }
                }
              }

              return Math.max(n, Ak.height);
            }(r, c), function (t) {
              t.append("defs").append("symbol").attr("id", "computer").attr("width", "24").attr("height", "24").append("path").attr("transform", "scale(.5)").attr("d", "M2 2v13h20v-13h-20zm18 11h-16v-9h16v9zm-10.228 6l.466-1h3.524l.467 1h-4.457zm14.228 3h-24l2-6h2.104l-1.33 4h18.45l-1.297-4h2.073l2 6zm-5-10h-14v-7h14v7z");
            }(n), function (t) {
              t.append("defs").append("symbol").attr("id", "database").attr("fill-rule", "evenodd").attr("clip-rule", "evenodd").append("path").attr("transform", "scale(.5)").attr("d", "M12.258.001l.256.004.255.005.253.008.251.01.249.012.247.015.246.016.242.019.241.02.239.023.236.024.233.027.231.028.229.031.225.032.223.034.22.036.217.038.214.04.211.041.208.043.205.045.201.046.198.048.194.05.191.051.187.053.183.054.18.056.175.057.172.059.168.06.163.061.16.063.155.064.15.066.074.033.073.033.071.034.07.034.069.035.068.035.067.035.066.035.064.036.064.036.062.036.06.036.06.037.058.037.058.037.055.038.055.038.053.038.052.038.051.039.05.039.048.039.047.039.045.04.044.04.043.04.041.04.04.041.039.041.037.041.036.041.034.041.033.042.032.042.03.042.029.042.027.042.026.043.024.043.023.043.021.043.02.043.018.044.017.043.015.044.013.044.012.044.011.045.009.044.007.045.006.045.004.045.002.045.001.045v17l-.001.045-.002.045-.004.045-.006.045-.007.045-.009.044-.011.045-.012.044-.013.044-.015.044-.017.043-.018.044-.02.043-.021.043-.023.043-.024.043-.026.043-.027.042-.029.042-.03.042-.032.042-.033.042-.034.041-.036.041-.037.041-.039.041-.04.041-.041.04-.043.04-.044.04-.045.04-.047.039-.048.039-.05.039-.051.039-.052.038-.053.038-.055.038-.055.038-.058.037-.058.037-.06.037-.06.036-.062.036-.064.036-.064.036-.066.035-.067.035-.068.035-.069.035-.07.034-.071.034-.073.033-.074.033-.15.066-.155.064-.16.063-.163.061-.168.06-.172.059-.175.057-.18.056-.183.054-.187.053-.191.051-.194.05-.198.048-.201.046-.205.045-.208.043-.211.041-.214.04-.217.038-.22.036-.223.034-.225.032-.229.031-.231.028-.233.027-.236.024-.239.023-.241.02-.242.019-.246.016-.247.015-.249.012-.251.01-.253.008-.255.005-.256.004-.258.001-.258-.001-.256-.004-.255-.005-.253-.008-.251-.01-.249-.012-.247-.015-.245-.016-.243-.019-.241-.02-.238-.023-.236-.024-.234-.027-.231-.028-.228-.031-.226-.032-.223-.034-.22-.036-.217-.038-.214-.04-.211-.041-.208-.043-.204-.045-.201-.046-.198-.048-.195-.05-.19-.051-.187-.053-.184-.054-.179-.056-.176-.057-.172-.059-.167-.06-.164-.061-.159-.063-.155-.064-.151-.066-.074-.033-.072-.033-.072-.034-.07-.034-.069-.035-.068-.035-.067-.035-.066-.035-.064-.036-.063-.036-.062-.036-.061-.036-.06-.037-.058-.037-.057-.037-.056-.038-.055-.038-.053-.038-.052-.038-.051-.039-.049-.039-.049-.039-.046-.039-.046-.04-.044-.04-.043-.04-.041-.04-.04-.041-.039-.041-.037-.041-.036-.041-.034-.041-.033-.042-.032-.042-.03-.042-.029-.042-.027-.042-.026-.043-.024-.043-.023-.043-.021-.043-.02-.043-.018-.044-.017-.043-.015-.044-.013-.044-.012-.044-.011-.045-.009-.044-.007-.045-.006-.045-.004-.045-.002-.045-.001-.045v-17l.001-.045.002-.045.004-.045.006-.045.007-.045.009-.044.011-.045.012-.044.013-.044.015-.044.017-.043.018-.044.02-.043.021-.043.023-.043.024-.043.026-.043.027-.042.029-.042.03-.042.032-.042.033-.042.034-.041.036-.041.037-.041.039-.041.04-.041.041-.04.043-.04.044-.04.046-.04.046-.039.049-.039.049-.039.051-.039.052-.038.053-.038.055-.038.056-.038.057-.037.058-.037.06-.037.061-.036.062-.036.063-.036.064-.036.066-.035.067-.035.068-.035.069-.035.07-.034.072-.034.072-.033.074-.033.151-.066.155-.064.159-.063.164-.061.167-.06.172-.059.176-.057.179-.056.184-.054.187-.053.19-.051.195-.05.198-.048.201-.046.204-.045.208-.043.211-.041.214-.04.217-.038.22-.036.223-.034.226-.032.228-.031.231-.028.234-.027.236-.024.238-.023.241-.02.243-.019.245-.016.247-.015.249-.012.251-.01.253-.008.255-.005.256-.004.258-.001.258.001zm-9.258 20.499v.01l.001.021.003.021.004.022.005.021.006.022.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.023.018.024.019.024.021.024.022.025.023.024.024.025.052.049.056.05.061.051.066.051.07.051.075.051.079.052.084.052.088.052.092.052.097.052.102.051.105.052.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.048.144.049.147.047.152.047.155.047.16.045.163.045.167.043.171.043.176.041.178.041.183.039.187.039.19.037.194.035.197.035.202.033.204.031.209.03.212.029.216.027.219.025.222.024.226.021.23.02.233.018.236.016.24.015.243.012.246.01.249.008.253.005.256.004.259.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.021.224-.024.22-.026.216-.027.212-.028.21-.031.205-.031.202-.034.198-.034.194-.036.191-.037.187-.039.183-.04.179-.04.175-.042.172-.043.168-.044.163-.045.16-.046.155-.046.152-.047.148-.048.143-.049.139-.049.136-.05.131-.05.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.053.083-.051.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.05.023-.024.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.023.01-.022.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.127l-.077.055-.08.053-.083.054-.085.053-.087.052-.09.052-.093.051-.095.05-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.045-.118.044-.12.043-.122.042-.124.042-.126.041-.128.04-.13.04-.132.038-.134.038-.135.037-.138.037-.139.035-.142.035-.143.034-.144.033-.147.032-.148.031-.15.03-.151.03-.153.029-.154.027-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.01-.179.008-.179.008-.181.006-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.006-.179-.008-.179-.008-.178-.01-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.027-.153-.029-.151-.03-.15-.03-.148-.031-.146-.032-.145-.033-.143-.034-.141-.035-.14-.035-.137-.037-.136-.037-.134-.038-.132-.038-.13-.04-.128-.04-.126-.041-.124-.042-.122-.042-.12-.044-.117-.043-.116-.045-.113-.045-.112-.046-.109-.047-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.05-.093-.052-.09-.051-.087-.052-.085-.053-.083-.054-.08-.054-.077-.054v4.127zm0-5.654v.011l.001.021.003.021.004.021.005.022.006.022.007.022.009.022.01.022.011.023.012.023.013.023.015.024.016.023.017.024.018.024.019.024.021.024.022.024.023.025.024.024.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.052.11.051.114.051.119.052.123.05.127.051.131.05.135.049.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.044.171.042.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.022.23.02.233.018.236.016.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.012.241-.015.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.048.139-.05.136-.049.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.051.051-.049.023-.025.023-.024.021-.025.02-.024.019-.024.018-.024.017-.024.015-.023.014-.023.013-.024.012-.022.01-.023.01-.023.008-.022.006-.022.006-.022.004-.021.004-.022.001-.021.001-.021v-4.139l-.077.054-.08.054-.083.054-.085.052-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.044-.118.044-.12.044-.122.042-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.035-.143.033-.144.033-.147.033-.148.031-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.009-.179.009-.179.007-.181.007-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.007-.179-.007-.179-.009-.178-.009-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.031-.146-.033-.145-.033-.143-.033-.141-.035-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.04-.126-.041-.124-.042-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.051-.093-.051-.09-.051-.087-.053-.085-.052-.083-.054-.08-.054-.077-.054v4.139zm0-5.666v.011l.001.02.003.022.004.021.005.022.006.021.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.024.018.023.019.024.021.025.022.024.023.024.024.025.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.051.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.043.171.043.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.021.23.02.233.018.236.017.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.013.241-.014.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.049.139-.049.136-.049.131-.051.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.049.023-.025.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.022.01-.023.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.153l-.077.054-.08.054-.083.053-.085.053-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.048-.105.048-.106.048-.109.046-.111.046-.114.046-.115.044-.118.044-.12.043-.122.043-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.034-.143.034-.144.033-.147.032-.148.032-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.024-.161.024-.162.023-.163.023-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.01-.178.01-.179.009-.179.007-.181.006-.182.006-.182.004-.184.003-.184.001-.185.001-.185-.001-.184-.001-.184-.003-.182-.004-.182-.006-.181-.006-.179-.007-.179-.009-.178-.01-.176-.01-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.023-.162-.023-.161-.024-.159-.024-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.032-.146-.032-.145-.033-.143-.034-.141-.034-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.041-.126-.041-.124-.041-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.048-.105-.048-.102-.048-.1-.05-.097-.049-.095-.051-.093-.051-.09-.052-.087-.052-.085-.053-.083-.053-.08-.054-.077-.054v4.153zm8.74-8.179l-.257.004-.254.005-.25.008-.247.011-.244.012-.241.014-.237.016-.233.018-.231.021-.226.022-.224.023-.22.026-.216.027-.212.028-.21.031-.205.032-.202.033-.198.034-.194.036-.191.038-.187.038-.183.04-.179.041-.175.042-.172.043-.168.043-.163.045-.16.046-.155.046-.152.048-.148.048-.143.048-.139.049-.136.05-.131.05-.126.051-.123.051-.118.051-.114.052-.11.052-.106.052-.101.052-.096.052-.092.052-.088.052-.083.052-.079.052-.074.051-.07.052-.065.051-.06.05-.056.05-.051.05-.023.025-.023.024-.021.024-.02.025-.019.024-.018.024-.017.023-.015.024-.014.023-.013.023-.012.023-.01.023-.01.022-.008.022-.006.023-.006.021-.004.022-.004.021-.001.021-.001.021.001.021.001.021.004.021.004.022.006.021.006.023.008.022.01.022.01.023.012.023.013.023.014.023.015.024.017.023.018.024.019.024.02.025.021.024.023.024.023.025.051.05.056.05.06.05.065.051.07.052.074.051.079.052.083.052.088.052.092.052.096.052.101.052.106.052.11.052.114.052.118.051.123.051.126.051.131.05.136.05.139.049.143.048.148.048.152.048.155.046.16.046.163.045.168.043.172.043.175.042.179.041.183.04.187.038.191.038.194.036.198.034.202.033.205.032.21.031.212.028.216.027.22.026.224.023.226.022.231.021.233.018.237.016.241.014.244.012.247.011.25.008.254.005.257.004.26.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.022.224-.023.22-.026.216-.027.212-.028.21-.031.205-.032.202-.033.198-.034.194-.036.191-.038.187-.038.183-.04.179-.041.175-.042.172-.043.168-.043.163-.045.16-.046.155-.046.152-.048.148-.048.143-.048.139-.049.136-.05.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.05.051-.05.023-.025.023-.024.021-.024.02-.025.019-.024.018-.024.017-.023.015-.024.014-.023.013-.023.012-.023.01-.023.01-.022.008-.022.006-.023.006-.021.004-.022.004-.021.001-.021.001-.021-.001-.021-.001-.021-.004-.021-.004-.022-.006-.021-.006-.023-.008-.022-.01-.022-.01-.023-.012-.023-.013-.023-.014-.023-.015-.024-.017-.023-.018-.024-.019-.024-.02-.025-.021-.024-.023-.024-.023-.025-.051-.05-.056-.05-.06-.05-.065-.051-.07-.052-.074-.051-.079-.052-.083-.052-.088-.052-.092-.052-.096-.052-.101-.052-.106-.052-.11-.052-.114-.052-.118-.051-.123-.051-.126-.051-.131-.05-.136-.05-.139-.049-.143-.048-.148-.048-.152-.048-.155-.046-.16-.046-.163-.045-.168-.043-.172-.043-.175-.042-.179-.041-.183-.04-.187-.038-.191-.038-.194-.036-.198-.034-.202-.033-.205-.032-.21-.031-.212-.028-.216-.027-.22-.026-.224-.023-.226-.022-.231-.021-.233-.018-.237-.016-.241-.014-.244-.012-.247-.011-.25-.008-.254-.005-.257-.004-.26-.001-.26.001z");
            }(n), function (t) {
              t.append("defs").append("symbol").attr("id", "clock").attr("width", "24").attr("height", "24").append("path").attr("transform", "scale(.5)").attr("d", "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.848 12.459c.202.038.202.333.001.372-1.907.361-6.045 1.111-6.547 1.111-.719 0-1.301-.582-1.301-1.301 0-.512.77-5.447 1.125-7.445.034-.192.312-.181.343.014l.985 6.238 5.394 1.011z");
            }(n), Bk(n, r, i, 0);

            var u = function (t, e) {
              var n,
                  r,
                  i,
                  a = {},
                  s = [];
              return t.forEach(function (t) {
                switch (t.id = gv.random({
                  length: 10
                }), t.type) {
                  case Uw.parser.yy.LINETYPE.LOOP_START:
                  case Uw.parser.yy.LINETYPE.ALT_START:
                  case Uw.parser.yy.LINETYPE.OPT_START:
                  case Uw.parser.yy.LINETYPE.PAR_START:
                    s.push({
                      id: t.id,
                      msg: t.message,
                      from: Number.MAX_SAFE_INTEGER,
                      to: Number.MIN_SAFE_INTEGER,
                      width: 0
                    });
                    break;

                  case Uw.parser.yy.LINETYPE.ALT_ELSE:
                  case Uw.parser.yy.LINETYPE.PAR_AND:
                    t.message && (n = s.pop(), a[n.id] = n, a[t.id] = n, s.push(n));
                    break;

                  case Uw.parser.yy.LINETYPE.LOOP_END:
                  case Uw.parser.yy.LINETYPE.ALT_END:
                  case Uw.parser.yy.LINETYPE.OPT_END:
                  case Uw.parser.yy.LINETYPE.PAR_END:
                    n = s.pop(), a[n.id] = n;
                    break;

                  case Uw.parser.yy.LINETYPE.ACTIVE_START:
                    var c = e[t.from ? t.from.actor : t.to.actor],
                        u = Rk(t.from ? t.from.actor : t.to.actor).length,
                        l = c.x + c.width / 2 + (u - 1) * Ak.activationWidth / 2,
                        h = {
                      startx: l,
                      stopx: l + Ak.activationWidth,
                      actor: t.from.actor,
                      enabled: !0
                    };
                    Mk.activations.push(h);
                    break;

                  case Uw.parser.yy.LINETYPE.ACTIVE_END:
                    var f = Mk.activations.map(function (t) {
                      return t.actor;
                    }).lastIndexOf(t.from.actor);
                    delete Mk.activations.splice(f, 1)[0];
                }

                void 0 !== t.placement ? (r = function (t, e) {
                  var n = e[t.from].x,
                      r = e[t.to].x,
                      i = t.wrap && t.message,
                      a = gv.calculateTextDimensions(i ? gv.wrapLabel(t.message, Ak.width, Dk(Ak)) : t.message, Dk(Ak)),
                      s = {
                    width: i ? Ak.width : Math.max(Ak.width, a.width + 2 * Ak.noteMargin),
                    height: 0,
                    startx: e[t.from].x,
                    stopx: 0,
                    starty: 0,
                    stopy: 0,
                    message: t.message
                  };
                  return t.placement === Uw.parser.yy.PLACEMENT.RIGHTOF ? (s.width = i ? Math.max(Ak.width, a.width) : Math.max(e[t.from].width / 2 + e[t.to].width / 2, a.width + 2 * Ak.noteMargin), s.startx = n + (e[t.from].width + Ak.actorMargin) / 2) : t.placement === Uw.parser.yy.PLACEMENT.LEFTOF ? (s.width = i ? Math.max(Ak.width, a.width + 2 * Ak.noteMargin) : Math.max(e[t.from].width / 2 + e[t.to].width / 2, a.width + 2 * Ak.noteMargin), s.startx = n - s.width + (e[t.from].width - Ak.actorMargin) / 2) : t.to === t.from ? (a = gv.calculateTextDimensions(i ? gv.wrapLabel(t.message, Math.max(Ak.width, e[t.from].width), Dk(Ak)) : t.message, Dk(Ak)), s.width = i ? Math.max(Ak.width, e[t.from].width) : Math.max(e[t.from].width, Ak.width, a.width + 2 * Ak.noteMargin), s.startx = n + (e[t.from].width - s.width) / 2) : (s.width = Math.abs(n + e[t.from].width / 2 - (r + e[t.to].width / 2)) + Ak.actorMargin, s.startx = n < r ? n + e[t.from].width / 2 - Ak.actorMargin / 2 : r + e[t.to].width / 2 - Ak.actorMargin / 2), i && (s.message = gv.wrapLabel(t.message, s.width - 2 * Ak.wrapPadding, Dk(Ak))), o.debug("NM:[".concat(s.startx, ",").concat(s.stopx, ",").concat(s.starty, ",").concat(s.stopy, ":").concat(s.width, ",").concat(s.height, "=").concat(t.message, "]")), s;
                }(t, e), t.noteModel = r, s.forEach(function (t) {
                  (n = t).from = Math.min(n.from, r.startx), n.to = Math.max(n.to, r.startx + r.width), n.width = Math.max(n.width, Math.abs(n.from - n.to)) - Ak.labelBoxWidth;
                })) : (i = function (t, e) {
                  var n = !1;
                  if ([Uw.parser.yy.LINETYPE.SOLID_OPEN, Uw.parser.yy.LINETYPE.DOTTED_OPEN, Uw.parser.yy.LINETYPE.SOLID, Uw.parser.yy.LINETYPE.DOTTED, Uw.parser.yy.LINETYPE.SOLID_CROSS, Uw.parser.yy.LINETYPE.DOTTED_CROSS, Uw.parser.yy.LINETYPE.SOLID_POINT, Uw.parser.yy.LINETYPE.DOTTED_POINT].includes(t.type) && (n = !0), !n) return {};
                  var r = Pk(t.from, e),
                      i = Pk(t.to, e),
                      a = r[0] <= i[0] ? 1 : 0,
                      o = r[0] < i[0] ? 0 : 1,
                      s = r.concat(i),
                      c = Math.abs(i[o] - r[a]);
                  t.wrap && t.message && (t.message = gv.wrapLabel(t.message, Math.max(c + 2 * Ak.wrapPadding, Ak.width), Nk(Ak)));
                  var u = gv.calculateTextDimensions(t.message, Nk(Ak));
                  return {
                    width: Math.max(t.wrap ? 0 : u.width + 2 * Ak.wrapPadding, c + 2 * Ak.wrapPadding, Ak.width),
                    height: 0,
                    startx: r[a],
                    stopx: i[o],
                    starty: 0,
                    stopy: 0,
                    message: t.message,
                    type: t.type,
                    wrap: t.wrap,
                    fromBounds: Math.min.apply(null, s),
                    toBounds: Math.max.apply(null, s)
                  };
                }(t, e), t.msgModel = i, i.startx && i.stopx && s.length > 0 && s.forEach(function (r) {
                  if (n = r, i.startx === i.stopx) {
                    var a = e[t.from],
                        o = e[t.to];
                    n.from = Math.min(a.x - i.width / 2, a.x - a.width / 2, n.from), n.to = Math.max(o.x + i.width / 2, o.x + a.width / 2, n.to), n.width = Math.max(n.width, Math.abs(n.to - n.from)) - Ak.labelBoxWidth;
                  } else n.from = Math.min(i.startx, n.from), n.to = Math.max(i.stopx, n.to), n.width = Math.max(n.width, i.width) - Ak.labelBoxWidth;
                }));
              }), Mk.activations = [], o.debug("Loop type widths:", a), a;
            }(a, r);

            (function (t) {
              t.append("defs").append("marker").attr("id", "arrowhead").attr("refX", 9).attr("refY", 5).attr("markerUnits", "userSpaceOnUse").attr("markerWidth", 12).attr("markerHeight", 12).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z");
            })(n), function (t) {
              var e = t.append("defs").append("marker").attr("id", "crosshead").attr("markerWidth", 15).attr("markerHeight", 8).attr("orient", "auto").attr("refX", 16).attr("refY", 4);
              e.append("path").attr("fill", "black").attr("stroke", "#000000").style("stroke-dasharray", "0, 0").attr("stroke-width", "1px").attr("d", "M 9,2 V 6 L16,4 Z"), e.append("path").attr("fill", "none").attr("stroke", "#000000").style("stroke-dasharray", "0, 0").attr("stroke-width", "1px").attr("d", "M 0,1 L 6,7 M 6,1 L 0,7");
            }(n), function (t) {
              t.append("defs").append("marker").attr("id", "filled-head").attr("refX", 18).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L14,7 L9,1 Z");
            }(n), function (t) {
              t.append("defs").append("marker").attr("id", "sequencenumber").attr("refX", 15).attr("refY", 15).attr("markerWidth", 60).attr("markerHeight", 40).attr("orient", "auto").append("circle").attr("cx", 15).attr("cy", 15).attr("r", 6);
            }(n);
            var l = 1;
            a.forEach(function (t) {
              var e, i, a;

              switch (t.type) {
                case Uw.parser.yy.LINETYPE.NOTE:
                  i = t.noteModel, function (t, e) {
                    Mk.bumpVerticalPos(Ak.boxMargin), e.height = Ak.boxMargin, e.starty = Mk.getVerticalPos();
                    var n = Sk();
                    n.x = e.startx, n.y = e.starty, n.width = e.width || Ak.width, n.class = "note";
                    var r = t.append("g"),
                        i = xk(r, n),
                        a = Ck();
                    a.x = e.startx, a.y = e.starty, a.width = n.width, a.dy = "1em", a.text = e.message, a.class = "noteText", a.fontFamily = Ak.noteFontFamily, a.fontSize = Ak.noteFontSize, a.fontWeight = Ak.noteFontWeight, a.anchor = Ak.noteAlign, a.textMargin = Ak.noteMargin, a.valign = Ak.noteAlign;
                    var o = mk(r, a),
                        s = Math.round(o.map(function (t) {
                      return (t._groups || t)[0][0].getBBox().height;
                    }).reduce(function (t, e) {
                      return t + e;
                    }));
                    i.attr("height", s + 2 * Ak.noteMargin), e.height += s + 2 * Ak.noteMargin, Mk.bumpVerticalPos(s + 2 * Ak.noteMargin), e.stopy = e.starty + s + 2 * Ak.noteMargin, e.stopx = e.startx + n.width, Mk.insert(e.startx, e.starty, e.stopx, e.stopy), Mk.models.addNote(e);
                  }(n, i);
                  break;

                case Uw.parser.yy.LINETYPE.ACTIVE_START:
                  Mk.newActivation(t, n, r);
                  break;

                case Uw.parser.yy.LINETYPE.ACTIVE_END:
                  !function (t, e) {
                    var n = Mk.endActivation(t);
                    n.starty + 18 > e && (n.starty = e - 6, e += 12), function (t, e, n, r, i) {
                      var a = {
                        x: 0,
                        y: 0,
                        fill: "#EDF2AE",
                        stroke: "#666",
                        width: 100,
                        anchor: "start",
                        height: 100,
                        rx: 0,
                        ry: 0
                      },
                          o = e.anchored;
                      a.x = e.startx, a.y = e.starty, a.class = "activation" + i % 3, a.width = e.stopx - e.startx, a.height = n - e.starty, fk(o, a);
                    }(0, n, e, 0, Rk(t.from.actor).length), Mk.insert(n.startx, e - 10, n.stopx, e);
                  }(t, Mk.getVerticalPos());
                  break;

                case Uw.parser.yy.LINETYPE.LOOP_START:
                  Fk(u, t, Ak.boxMargin, Ak.boxMargin + Ak.boxTextMargin, function (t) {
                    return Mk.newLoop(t);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.LOOP_END:
                  e = Mk.endLoop(), Ek(n, e, "loop", Ak), Mk.bumpVerticalPos(e.stopy - Mk.getVerticalPos()), Mk.models.addLoop(e);
                  break;

                case Uw.parser.yy.LINETYPE.RECT_START:
                  Fk(u, t, Ak.boxMargin, Ak.boxMargin, function (t) {
                    return Mk.newLoop(void 0, t.message);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.RECT_END:
                  e = Mk.endLoop(), function (t, e) {
                    fk(t, {
                      x: e.startx,
                      y: e.starty,
                      width: e.stopx - e.startx,
                      height: e.stopy - e.starty,
                      fill: e.fill,
                      class: "rect"
                    }).lower();
                  }(n, e), Mk.models.addLoop(e), Mk.bumpVerticalPos(e.stopy - Mk.getVerticalPos());
                  break;

                case Uw.parser.yy.LINETYPE.OPT_START:
                  Fk(u, t, Ak.boxMargin, Ak.boxMargin + Ak.boxTextMargin, function (t) {
                    return Mk.newLoop(t);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.OPT_END:
                  e = Mk.endLoop(), Ek(n, e, "opt", Ak), Mk.bumpVerticalPos(e.stopy - Mk.getVerticalPos()), Mk.models.addLoop(e);
                  break;

                case Uw.parser.yy.LINETYPE.ALT_START:
                  Fk(u, t, Ak.boxMargin, Ak.boxMargin + Ak.boxTextMargin, function (t) {
                    return Mk.newLoop(t);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.ALT_ELSE:
                  Fk(u, t, Ak.boxMargin + Ak.boxTextMargin, Ak.boxMargin, function (t) {
                    return Mk.addSectionToLoop(t);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.ALT_END:
                  e = Mk.endLoop(), Ek(n, e, "alt", Ak), Mk.bumpVerticalPos(e.stopy - Mk.getVerticalPos()), Mk.models.addLoop(e);
                  break;

                case Uw.parser.yy.LINETYPE.PAR_START:
                  Fk(u, t, Ak.boxMargin, Ak.boxMargin + Ak.boxTextMargin, function (t) {
                    return Mk.newLoop(t);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.PAR_AND:
                  Fk(u, t, Ak.boxMargin + Ak.boxTextMargin, Ak.boxMargin, function (t) {
                    return Mk.addSectionToLoop(t);
                  });
                  break;

                case Uw.parser.yy.LINETYPE.PAR_END:
                  e = Mk.endLoop(), Ek(n, e, "par", Ak), Mk.bumpVerticalPos(e.stopy - Mk.getVerticalPos()), Mk.models.addLoop(e);
                  break;

                default:
                  try {
                    (a = t.msgModel).starty = Mk.getVerticalPos(), a.sequenceIndex = l, function (t, e) {
                      Mk.bumpVerticalPos(10);
                      var n = e.startx,
                          r = e.stopx,
                          i = e.starty,
                          a = e.message,
                          o = e.type,
                          s = e.sequenceIndex,
                          c = wm.splitBreaks(a).length,
                          u = gv.calculateTextDimensions(a, Nk(Ak)),
                          l = u.height / c;
                      e.height += l, Mk.bumpVerticalPos(l);
                      var h = Ck();
                      h.x = n, h.y = i + 10, h.width = r - n, h.class = "messageText", h.dy = "1em", h.text = a, h.fontFamily = Ak.messageFontFamily, h.fontSize = Ak.messageFontSize, h.fontWeight = Ak.messageFontWeight, h.anchor = Ak.messageAlign, h.valign = Ak.messageAlign, h.textMargin = Ak.wrapPadding, h.tspan = !1, mk(t, h);
                      var f,
                          d,
                          p = u.height - 10,
                          y = u.width;

                      if (n === r) {
                        d = Mk.getVerticalPos() + p, Ak.rightAngles ? f = t.append("path").attr("d", "M  ".concat(n, ",").concat(d, " H ").concat(n + Math.max(Ak.width / 2, y / 2), " V ").concat(d + 25, " H ").concat(n)) : (p += Ak.boxMargin, d = Mk.getVerticalPos() + p, f = t.append("path").attr("d", "M " + n + "," + d + " C " + (n + 60) + "," + (d - 10) + " " + (n + 60) + "," + (d + 30) + " " + n + "," + (d + 20))), p += 30;
                        var g = Math.max(y / 2, Ak.width / 2);
                        Mk.insert(n - g, Mk.getVerticalPos() - 10 + p, r + g, Mk.getVerticalPos() + 30 + p);
                      } else p += Ak.boxMargin, d = Mk.getVerticalPos() + p, (f = t.append("line")).attr("x1", n), f.attr("y1", d), f.attr("x2", r), f.attr("y2", d), Mk.insert(n, d - 10, r, d);

                      o === Uw.parser.yy.LINETYPE.DOTTED || o === Uw.parser.yy.LINETYPE.DOTTED_CROSS || o === Uw.parser.yy.LINETYPE.DOTTED_POINT || o === Uw.parser.yy.LINETYPE.DOTTED_OPEN ? (f.style("stroke-dasharray", "3, 3"), f.attr("class", "messageLine1")) : f.attr("class", "messageLine0");
                      var m = "";
                      Ak.arrowMarkerAbsolute && (m = (m = (m = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), f.attr("stroke-width", 2), f.attr("stroke", "none"), f.style("fill", "none"), o !== Uw.parser.yy.LINETYPE.SOLID && o !== Uw.parser.yy.LINETYPE.DOTTED || f.attr("marker-end", "url(" + m + "#arrowhead)"), o !== Uw.parser.yy.LINETYPE.SOLID_POINT && o !== Uw.parser.yy.LINETYPE.DOTTED_POINT || f.attr("marker-end", "url(" + m + "#filled-head)"), o !== Uw.parser.yy.LINETYPE.SOLID_CROSS && o !== Uw.parser.yy.LINETYPE.DOTTED_CROSS || f.attr("marker-end", "url(" + m + "#crosshead)"), (lk.showSequenceNumbers() || Ak.showSequenceNumbers) && (f.attr("marker-start", "url(" + m + "#sequencenumber)"), t.append("text").attr("x", n).attr("y", d + 4).attr("font-family", "sans-serif").attr("font-size", "12px").attr("text-anchor", "middle").attr("textLength", "16px").attr("class", "sequenceNumber").text(s)), Mk.bumpVerticalPos(p), e.height += p, e.stopy = e.starty + e.height, Mk.insert(e.fromBounds, e.starty, e.toBounds, e.stopy);
                    }(n, a), Mk.models.addMessage(a);
                  } catch (t) {
                    o.error("error while drawing message", t);
                  }

              }

              [Uw.parser.yy.LINETYPE.SOLID_OPEN, Uw.parser.yy.LINETYPE.DOTTED_OPEN, Uw.parser.yy.LINETYPE.SOLID, Uw.parser.yy.LINETYPE.DOTTED, Uw.parser.yy.LINETYPE.SOLID_CROSS, Uw.parser.yy.LINETYPE.DOTTED_CROSS, Uw.parser.yy.LINETYPE.SOLID_POINT, Uw.parser.yy.LINETYPE.DOTTED_POINT].includes(t.type) && l++;
            }), Ak.mirrorActors && (Mk.bumpVerticalPos(2 * Ak.boxMargin), Bk(n, r, i, Mk.getVerticalPos()), Mk.bumpVerticalPos(Ak.boxMargin), function (t, e) {
              t.selectAll && t.selectAll(".actor-line").attr("class", "200").attr("y2", e - 55);
            }(n, Mk.getVerticalPos()));
            var h = Lk(n, r, i),
                f = Mk.getBounds().bounds;
            o.debug("For line height fix Querying: #" + e + " .actor-line"), Kc("#" + e + " .actor-line").attr("y2", f.stopy);
            var d = f.stopy - f.starty;
            d < h.maxHeight && (d = h.maxHeight);
            var p = d + 2 * Ak.diagramMarginY;
            Ak.mirrorActors && (p = p - Ak.boxMargin + Ak.bottomMarginAdj);
            var y = f.stopx - f.startx;
            y < h.maxWidth && (y = h.maxWidth);
            var g = y + 2 * Ak.diagramMarginX;
            s && n.append("text").text(s).attr("x", (f.stopx - f.startx) / 2 - 2 * Ak.diagramMarginX).attr("y", -25), pv(n, p, g, Ak.useMaxWidth);
            var m = s ? 40 : 0;
            n.attr("viewBox", f.startx - Ak.diagramMarginX + " -" + (Ak.diagramMarginY + m) + " " + g + " " + (p + m)), o.debug("models:", Mk.models);
          }
        };
        var Uk = n(5537),
            zk = n.n(Uk);

        function qk(t) {
          return (qk = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var $k = function $k(t) {
          return JSON.parse(JSON.stringify(t));
        },
            Hk = [],
            Wk = {
          root: {
            relations: [],
            states: {},
            documents: {}
          }
        },
            Vk = Wk.root,
            Gk = 0,
            Xk = function Xk(t, e, n, r, i) {
          void 0 === Vk.states[t] ? Vk.states[t] = {
            id: t,
            descriptions: [],
            type: e,
            doc: n,
            note: i
          } : (Vk.states[t].doc || (Vk.states[t].doc = n), Vk.states[t].type || (Vk.states[t].type = e)), r && (o.info("Adding state ", t, r), "string" == typeof r && Qk(t, r.trim()), "object" === qk(r) && r.forEach(function (e) {
            return Qk(t, e.trim());
          })), i && (Vk.states[t].note = i, Vk.states[t].note.text = wm.sanitizeText(Vk.states[t].note.text, Ev()));
        },
            Zk = function Zk() {
          Vk = (Wk = {
            root: {
              relations: [],
              states: {},
              documents: {}
            }
          }).root, Vk = Wk.root, Gk = 0, tT = [];
        },
            Kk = function Kk(t, e, n) {
          var r = t,
              i = e,
              a = "default",
              o = "default";
          "[*]" === t && (r = "start" + ++Gk, a = "start"), "[*]" === e && (i = "end" + Gk, o = "end"), Xk(r, a), Xk(i, o), Vk.relations.push({
            id1: r,
            id2: i,
            title: wm.sanitizeText(n, Ev())
          });
        },
            Qk = function Qk(t, e) {
          var n = Vk.states[t],
              r = e;
          ":" === r[0] && (r = r.substr(1).trim()), n.descriptions.push(wm.sanitizeText(r, Ev()));
        },
            Jk = 0,
            tT = [],
            eT = "TB";

        var nT = {
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().state;
          },
          addState: Xk,
          clear: Zk,
          getState: function getState(t) {
            return Vk.states[t];
          },
          getStates: function getStates() {
            return Vk.states;
          },
          getRelations: function getRelations() {
            return Vk.relations;
          },
          getClasses: function getClasses() {
            return tT;
          },
          getDirection: function getDirection() {
            return eT;
          },
          addRelation: Kk,
          getDividerId: function getDividerId() {
            return "divider-id-" + ++Jk;
          },
          setDirection: function setDirection(t) {
            eT = t;
          },
          cleanupLabel: function cleanupLabel(t) {
            return ":" === t.substring(0, 1) ? t.substr(2).trim() : t.trim();
          },
          lineType: {
            LINE: 0,
            DOTTED_LINE: 1
          },
          relationType: {
            AGGREGATION: 0,
            EXTENSION: 1,
            COMPOSITION: 2,
            DEPENDENCY: 3
          },
          logDocuments: function logDocuments() {
            o.info("Documents = ", Wk);
          },
          getRootDoc: function getRootDoc() {
            return Hk;
          },
          setRootDoc: function setRootDoc(t) {
            o.info("Setting root doc", t), Hk = t;
          },
          getRootDocV2: function getRootDocV2() {
            return function t(e, n, r) {
              if ("relation" === n.stmt) t(e, n.state1, !0), t(e, n.state2, !1);else if ("state" === n.stmt && "[*]" === n.id && (n.id = r ? e.id + "_start" : e.id + "_end", n.start = r), n.doc) {
                var i = [],
                    a = 0,
                    o = [];

                for (a = 0; a < n.doc.length; a++) {
                  if ("divider" === n.doc[a].type) {
                    var s = $k(n.doc[a]);
                    s.doc = $k(o), i.push(s), o = [];
                  } else o.push(n.doc[a]);
                }

                if (i.length > 0 && o.length > 0) {
                  var c = {
                    stmt: "state",
                    id: av(),
                    type: "divider",
                    doc: $k(o)
                  };
                  i.push($k(c)), n.doc = i;
                }

                n.doc.forEach(function (e) {
                  return t(n, e, !0);
                });
              }
            }({
              id: "root"
            }, {
              id: "root",
              doc: Hk
            }, !0), {
              id: "root",
              doc: Hk
            };
          },
          extract: function extract(t) {
            var e;
            e = t.doc ? t.doc : t, o.info(e), Zk(), o.info("Extract", e), e.forEach(function (t) {
              "state" === t.stmt && Xk(t.id, t.type, t.doc, t.description, t.note), "relation" === t.stmt && Kk(t.state1.id, t.state2.id, t.description);
            });
          },
          trimColon: function trimColon(t) {
            return t && ":" === t[0] ? t.substr(1).trim() : t.trim();
          }
        };
        var rT = {};

        function iT(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        var aT,
            oT = function oT(t, e, n) {
          var r,
              i = Ev().state.padding,
              a = 2 * Ev().state.padding,
              o = t.node().getBBox(),
              s = o.width,
              c = o.x,
              u = t.append("text").attr("x", 0).attr("y", Ev().state.titleShift).attr("font-size", Ev().state.fontSize).attr("class", "state-title").text(e.id),
              l = u.node().getBBox().width + a,
              h = Math.max(l, s);
          h === s && (h += a);
          var f = t.node().getBBox();
          e.doc, r = c - i, l > s && (r = (s - h) / 2 + i), Math.abs(c - f.x) < i && l > s && (r = c - (l - s) / 2);
          var d = 1 - Ev().state.textHeight;
          return t.insert("rect", ":first-child").attr("x", r).attr("y", d).attr("class", n ? "alt-composit" : "composit").attr("width", h).attr("height", f.height + Ev().state.textHeight + Ev().state.titleShift + 1).attr("rx", "0"), u.attr("x", r + i), l <= s && u.attr("x", c + (h - a) / 2 - l / 2 + i), t.insert("rect", ":first-child").attr("x", r).attr("y", Ev().state.titleShift - Ev().state.textHeight - Ev().state.padding).attr("width", h).attr("height", 3 * Ev().state.textHeight).attr("rx", Ev().state.radius), t.insert("rect", ":first-child").attr("x", r).attr("y", Ev().state.titleShift - Ev().state.textHeight - Ev().state.padding).attr("width", h).attr("height", f.height + 3 + 2 * Ev().state.textHeight).attr("rx", Ev().state.radius), t;
        },
            sT = function sT(t, e) {
          var n = e.id,
              r = {
            id: n,
            label: e.id,
            width: 0,
            height: 0
          },
              i = t.append("g").attr("id", n).attr("class", "stateGroup");
          "start" === e.type && function (t) {
            t.append("circle").attr("class", "start-state").attr("r", Ev().state.sizeUnit).attr("cx", Ev().state.padding + Ev().state.sizeUnit).attr("cy", Ev().state.padding + Ev().state.sizeUnit);
          }(i), "end" === e.type && function (t) {
            t.append("circle").attr("class", "end-state-outer").attr("r", Ev().state.sizeUnit + Ev().state.miniPadding).attr("cx", Ev().state.padding + Ev().state.sizeUnit + Ev().state.miniPadding).attr("cy", Ev().state.padding + Ev().state.sizeUnit + Ev().state.miniPadding), t.append("circle").attr("class", "end-state-inner").attr("r", Ev().state.sizeUnit).attr("cx", Ev().state.padding + Ev().state.sizeUnit + 2).attr("cy", Ev().state.padding + Ev().state.sizeUnit + 2);
          }(i), "fork" !== e.type && "join" !== e.type || function (t, e) {
            var n = Ev().state.forkWidth,
                r = Ev().state.forkHeight;

            if (e.parentId) {
              var i = n;
              n = r, r = i;
            }

            t.append("rect").style("stroke", "black").style("fill", "black").attr("width", n).attr("height", r).attr("x", Ev().state.padding).attr("y", Ev().state.padding);
          }(i, e), "note" === e.type && function (t, e) {
            e.attr("class", "state-note");

            var n = e.append("rect").attr("x", 0).attr("y", Ev().state.padding),
                r = function (t, e, n, r) {
              var i = 0,
                  a = r.append("text");
              a.style("text-anchor", "start"), a.attr("class", "noteText");

              var o,
                  s = t.replace(/\r\n/g, "<br/>"),
                  c = (s = s.replace(/\n/g, "<br/>")).split(wm.lineBreakRegex),
                  u = 1.25 * Ev().state.noteMargin,
                  l = function (t, e) {
                var _n6 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

                if (!_n6) {
                  if (Array.isArray(t) || (_n6 = function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return iT(t, e);
                      var n = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? iT(t, e) : void 0;
                    }
                  }(t))) {
                    _n6 && (t = _n6);

                    var r = 0,
                        i = function i() {};

                    return {
                      s: i,
                      n: function n() {
                        return r >= t.length ? {
                          done: !0
                        } : {
                          done: !1,
                          value: t[r++]
                        };
                      },
                      e: function e(t) {
                        throw t;
                      },
                      f: i
                    };
                  }

                  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }

                var a,
                    o = !0,
                    s = !1;
                return {
                  s: function s() {
                    _n6 = _n6.call(t);
                  },
                  n: function n() {
                    var t = _n6.next();

                    return o = t.done, t;
                  },
                  e: function e(t) {
                    s = !0, a = t;
                  },
                  f: function f() {
                    try {
                      o || null == _n6.return || _n6.return();
                    } finally {
                      if (s) throw a;
                    }
                  }
                };
              }(c);

              try {
                for (l.s(); !(o = l.n()).done;) {
                  var h = o.value.trim();

                  if (h.length > 0) {
                    var f = a.append("tspan");
                    f.text(h), 0 === u && (u += f.node().getBBox().height), i += u, f.attr("x", 0 + Ev().state.noteMargin), f.attr("y", 0 + i + 1.25 * Ev().state.noteMargin);
                  }
                }
              } catch (t) {
                l.e(t);
              } finally {
                l.f();
              }

              return {
                textWidth: a.node().getBBox().width,
                textHeight: i
              };
            }(t, 0, 0, e.append("g")),
                i = r.textWidth,
                a = r.textHeight;

            n.attr("height", a + 2 * Ev().state.noteMargin), n.attr("width", i + 2 * Ev().state.noteMargin);
          }(e.note.text, i), "divider" === e.type && function (t) {
            t.append("line").style("stroke", "grey").style("stroke-dasharray", "3").attr("x1", Ev().state.textHeight).attr("class", "divider").attr("x2", 2 * Ev().state.textHeight).attr("y1", 0).attr("y2", 0);
          }(i), "default" === e.type && 0 === e.descriptions.length && function (t, e) {
            var n = t.append("text").attr("x", 2 * Ev().state.padding).attr("y", Ev().state.textHeight + 2 * Ev().state.padding).attr("font-size", Ev().state.fontSize).attr("class", "state-title").text(e.id).node().getBBox();
            t.insert("rect", ":first-child").attr("x", Ev().state.padding).attr("y", Ev().state.padding).attr("width", n.width + 2 * Ev().state.padding).attr("height", n.height + 2 * Ev().state.padding).attr("rx", Ev().state.radius);
          }(i, e), "default" === e.type && e.descriptions.length > 0 && function (t, e) {
            var n = t.append("text").attr("x", 2 * Ev().state.padding).attr("y", Ev().state.textHeight + 1.3 * Ev().state.padding).attr("font-size", Ev().state.fontSize).attr("class", "state-title").text(e.descriptions[0]).node().getBBox(),
                r = n.height,
                i = t.append("text").attr("x", Ev().state.padding).attr("y", r + .4 * Ev().state.padding + Ev().state.dividerMargin + Ev().state.textHeight).attr("class", "state-description"),
                a = !0,
                o = !0;
            e.descriptions.forEach(function (t) {
              a || (function (t, e, n) {
                var r = t.append("tspan").attr("x", 2 * Ev().state.padding).text(e);
                n || r.attr("dy", Ev().state.textHeight);
              }(i, t, o), o = !1), a = !1;
            });
            var s = t.append("line").attr("x1", Ev().state.padding).attr("y1", Ev().state.padding + r + Ev().state.dividerMargin / 2).attr("y2", Ev().state.padding + r + Ev().state.dividerMargin / 2).attr("class", "descr-divider"),
                c = i.node().getBBox(),
                u = Math.max(c.width, n.width);
            s.attr("x2", u + 3 * Ev().state.padding), t.insert("rect", ":first-child").attr("x", Ev().state.padding).attr("y", Ev().state.padding).attr("width", u + 2 * Ev().state.padding).attr("height", c.height + r + 2 * Ev().state.padding).attr("rx", Ev().state.radius);
          }(i, e);
          var a,
              o = i.node().getBBox();
          return r.width = o.width + 2 * Ev().state.padding, r.height = o.height + 2 * Ev().state.padding, a = r, rT[n] = a, r;
        },
            cT = 0;

        Uk.parser.yy = nT;
        var uT = {};

        var lT = function lT(t, e) {
          aT = Ev().state, Uk.parser.yy.clear(), Uk.parser.parse(t), o.debug("Rendering diagram " + t);
          var n = Zc("[id='".concat(e, "']"));
          n.append("defs").append("marker").attr("id", "dependencyEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 19,7 L9,13 L14,7 L9,1 Z"), new (Vv().Graph)({
            multigraph: !0,
            compound: !0,
            rankdir: "RL"
          }).setDefaultEdgeLabel(function () {
            return {};
          }), function t(e, n, r, i) {
            var a,
                s = new (Vv().Graph)({
              compound: !0,
              multigraph: !0
            }),
                c = !0;

            for (a = 0; a < e.length; a++) {
              if ("relation" === e[a].stmt) {
                c = !1;
                break;
              }
            }

            r ? s.setGraph({
              rankdir: "LR",
              multigraph: !0,
              compound: !0,
              ranker: "tight-tree",
              ranksep: c ? 1 : aT.edgeLengthFactor,
              nodeSep: c ? 1 : 50,
              isMultiGraph: !0
            }) : s.setGraph({
              rankdir: "TB",
              multigraph: !0,
              compound: !0,
              ranksep: c ? 1 : aT.edgeLengthFactor,
              nodeSep: c ? 1 : 50,
              ranker: "tight-tree",
              isMultiGraph: !0
            }), s.setDefaultEdgeLabel(function () {
              return {};
            }), nT.extract(e);

            for (var u = nT.getStates(), l = nT.getRelations(), h = Object.keys(u), f = 0; f < h.length; f++) {
              var d = u[h[f]];
              r && (d.parentId = r);
              var p = void 0;

              if (d.doc) {
                var y = n.append("g").attr("id", d.id).attr("class", "stateGroup");
                p = t(d.doc, y, d.id, !i);
                var g = (y = oT(y, d, i)).node().getBBox();
                p.width = g.width, p.height = g.height + aT.padding / 2, uT[d.id] = {
                  y: aT.compositTitleSize
                };
              } else p = sT(n, d);

              if (d.note) {
                var m = {
                  descriptions: [],
                  id: d.id + "-note",
                  note: d.note,
                  type: "note"
                },
                    v = sT(n, m);
                "left of" === d.note.position ? (s.setNode(p.id + "-note", v), s.setNode(p.id, p)) : (s.setNode(p.id, p), s.setNode(p.id + "-note", v)), s.setParent(p.id, p.id + "-group"), s.setParent(p.id + "-note", p.id + "-group");
              } else s.setNode(p.id, p);
            }

            o.debug("Count=", s.nodeCount(), s);
            var b = 0;
            l.forEach(function (t) {
              var e;
              b++, o.debug("Setting edge", t), s.setEdge(t.id1, t.id2, {
                relation: t,
                width: (e = t.title, e ? e.length * aT.fontSizeFactor : 1),
                height: aT.labelHeight * wm.getRows(t.title).length,
                labelpos: "c"
              }, "id" + b);
            }), Hv().layout(s), o.debug("Graph after layout", s.nodes());

            var _ = n.node();

            s.nodes().forEach(function (t) {
              void 0 !== t && void 0 !== s.node(t) ? (o.warn("Node " + t + ": " + JSON.stringify(s.node(t))), Zc("#" + _.id + " #" + t).attr("transform", "translate(" + (s.node(t).x - s.node(t).width / 2) + "," + (s.node(t).y + (uT[t] ? uT[t].y : 0) - s.node(t).height / 2) + " )"), Zc("#" + _.id + " #" + t).attr("data-x-shift", s.node(t).x - s.node(t).width / 2), document.querySelectorAll("#" + _.id + " #" + t + " .divider").forEach(function (t) {
                var e = t.parentElement,
                    n = 0,
                    r = 0;
                e && (e.parentElement && (n = e.parentElement.getBBox().width), r = parseInt(e.getAttribute("data-x-shift"), 10), Number.isNaN(r) && (r = 0)), t.setAttribute("x1", 0 - r + 8), t.setAttribute("x2", n - r - 8);
              })) : o.debug("No Node " + t + ": " + JSON.stringify(s.node(t)));
            });

            var x = _.getBBox();

            s.edges().forEach(function (t) {
              void 0 !== t && void 0 !== s.edge(t) && (o.debug("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(s.edge(t))), function (t, e, n) {
                e.points = e.points.filter(function (t) {
                  return !Number.isNaN(t.y);
                });
                var r = e.points,
                    i = Ou().x(function (t) {
                  return t.x;
                }).y(function (t) {
                  return t.y;
                }).curve(Fu),
                    a = t.append("path").attr("d", i(r)).attr("id", "edge" + cT).attr("class", "transition"),
                    s = "";

                if (Ev().state.arrowMarkerAbsolute && (s = (s = (s = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), a.attr("marker-end", "url(" + s + "#" + function (t) {
                  switch (t) {
                    case nT.relationType.AGGREGATION:
                      return "aggregation";

                    case nT.relationType.EXTENSION:
                      return "extension";

                    case nT.relationType.COMPOSITION:
                      return "composition";

                    case nT.relationType.DEPENDENCY:
                      return "dependency";
                  }
                }(nT.relationType.DEPENDENCY) + "End)"), void 0 !== n.title) {
                  for (var c = t.append("g").attr("class", "stateLabel"), u = gv.calcLabelPosition(e.points), l = u.x, h = u.y, f = wm.getRows(n.title), d = 0, p = [], y = 0, g = 0, m = 0; m <= f.length; m++) {
                    var v = c.append("text").attr("text-anchor", "middle").text(f[m]).attr("x", l).attr("y", h + d),
                        b = v.node().getBBox();

                    if (y = Math.max(y, b.width), g = Math.min(g, b.x), o.info(b.x, l, h + d), 0 === d) {
                      var _ = v.node().getBBox();

                      d = _.height, o.info("Title height", d, h);
                    }

                    p.push(v);
                  }

                  var x = d * f.length;

                  if (f.length > 1) {
                    var w = (f.length - 1) * d * .5;
                    p.forEach(function (t, e) {
                      return t.attr("y", h + e * d - w);
                    }), x = d * f.length;
                  }

                  var k = c.node().getBBox();
                  c.insert("rect", ":first-child").attr("class", "box").attr("x", l - y / 2 - Ev().state.padding / 2).attr("y", h - x / 2 - Ev().state.padding / 2 - 3.5).attr("width", y + Ev().state.padding).attr("height", x + Ev().state.padding), o.info(k);
                }

                cT++;
              }(n, s.edge(t), s.edge(t).relation));
            }), x = _.getBBox();
            var w = {
              id: r || "root",
              label: r || "root",
              width: 0,
              height: 0
            };
            return w.width = x.width + 2 * aT.padding, w.height = x.height + 2 * aT.padding, o.debug("Doc rendered", w, s), w;
          }(nT.getRootDoc(), n, void 0, !1);
          var r = aT.padding,
              i = n.node().getBBox(),
              a = i.width + 2 * r,
              s = i.height + 2 * r;
          pv(n, s, 1.75 * a, aT.useMaxWidth), n.attr("viewBox", "".concat(i.x - aT.padding, "  ").concat(i.y - aT.padding, " ") + a + " " + s);
        };

        var hT = {},
            fT = {},
            dT = function dT(t, e, n, r) {
          if ("root" !== n.id) {
            var i = "rect";
            !0 === n.start && (i = "start"), !1 === n.start && (i = "end"), "default" !== n.type && (i = n.type), fT[n.id] || (fT[n.id] = {
              id: n.id,
              shape: i,
              description: wm.sanitizeText(n.id, Ev()),
              classes: "statediagram-state"
            }), n.description && (Array.isArray(fT[n.id].description) ? (fT[n.id].shape = "rectWithTitle", fT[n.id].description.push(n.description)) : fT[n.id].description.length > 0 ? (fT[n.id].shape = "rectWithTitle", fT[n.id].description === n.id ? fT[n.id].description = [n.description] : fT[n.id].description = [fT[n.id].description, n.description]) : (fT[n.id].shape = "rect", fT[n.id].description = n.description), fT[n.id].description = wm.sanitizeTextOrArray(fT[n.id].description, Ev())), !fT[n.id].type && n.doc && (o.info("Setting cluster for ", n.id, gT(n)), fT[n.id].type = "group", fT[n.id].dir = gT(n), fT[n.id].shape = "divider" === n.type ? "divider" : "roundedWithTitle", fT[n.id].classes = fT[n.id].classes + " " + (r ? "statediagram-cluster statediagram-cluster-alt" : "statediagram-cluster"));
            var a = {
              labelStyle: "",
              shape: fT[n.id].shape,
              labelText: fT[n.id].description,
              classes: fT[n.id].classes,
              style: "",
              id: n.id,
              dir: fT[n.id].dir,
              domId: "state-" + n.id + "-" + pT,
              type: fT[n.id].type,
              padding: 15
            };

            if (n.note) {
              var s = {
                labelStyle: "",
                shape: "note",
                labelText: n.note.text,
                classes: "statediagram-note",
                style: "",
                id: n.id + "----note-" + pT,
                domId: "state-" + n.id + "----note-" + pT,
                type: fT[n.id].type,
                padding: 15
              },
                  c = {
                labelStyle: "",
                shape: "noteGroup",
                labelText: n.note.text,
                classes: fT[n.id].classes,
                style: "",
                id: n.id + "----parent",
                domId: "state-" + n.id + "----parent-" + pT,
                type: "group",
                padding: 0
              };
              pT++, t.setNode(n.id + "----parent", c), t.setNode(s.id, s), t.setNode(n.id, a), t.setParent(n.id, n.id + "----parent"), t.setParent(s.id, n.id + "----parent");
              var u = n.id,
                  l = s.id;
              "left of" === n.note.position && (u = s.id, l = n.id), t.setEdge(u, l, {
                arrowhead: "none",
                arrowType: "",
                style: "fill:none",
                labelStyle: "",
                classes: "transition note-edge",
                arrowheadStyle: "fill: #333",
                labelpos: "c",
                labelType: "text",
                thickness: "normal"
              });
            } else t.setNode(n.id, a);
          }

          e && "root" !== e.id && (o.trace("Setting node ", n.id, " to be child of its parent ", e.id), t.setParent(n.id, e.id)), n.doc && (o.trace("Adding nodes children "), yT(t, n, n.doc, !r));
        },
            pT = 0,
            yT = function yT(t, e, n, r) {
          o.trace("items", n), n.forEach(function (n) {
            if ("state" === n.stmt || "default" === n.stmt) dT(t, e, n, r);else if ("relation" === n.stmt) {
              dT(t, e, n.state1, r), dT(t, e, n.state2, r);
              var i = {
                id: "edge" + pT,
                arrowhead: "normal",
                arrowTypeEnd: "arrow_barb",
                style: "fill:none",
                labelStyle: "",
                label: wm.sanitizeText(n.description, Ev()),
                arrowheadStyle: "fill: #333",
                labelpos: "c",
                labelType: "text",
                thickness: "normal",
                classes: "transition"
              },
                  a = n.state1.id,
                  o = n.state2.id;
              t.setEdge(a, o, i, pT), pT++;
            }
          });
        },
            gT = function gT(t, e) {
          var n = e || "TB";
          if (t.doc) for (var r = 0; r < t.doc.length; r++) {
            var i = t.doc[r];
            "dir" === i.stmt && (n = i.value);
          }
          return n;
        };

        var mT = function mT(t) {
          for (var e = Object.keys(t), n = 0; n < e.length; n++) {
            hT[e[n]] = t[e[n]];
          }
        };

        function vT(t) {
          return function (t) {
            if (Array.isArray(t)) return bT(t);
          }(t) || function (t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
          }(t) || function (t, e) {
            if (t) {
              if ("string" == typeof t) return bT(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bT(t, e) : void 0;
            }
          }(t) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function bT(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, r = new Array(e); n < e; n++) {
            r[n] = t[n];
          }

          return r;
        }

        var _T = "",
            xT = "",
            wT = [],
            kT = [],
            TT = [],
            ET = function ET() {
          for (var t = !0, e = 0; e < TT.length; e++) {
            TT[e].processed, t = t && TT[e].processed;
          }

          return t;
        };

        var CT = {
          parseDirective: function parseDirective(t, e, n) {
            JT.parseDirective(this, t, e, n);
          },
          getConfig: function getConfig() {
            return Ev().journey;
          },
          clear: function clear() {
            wT.length = 0, kT.length = 0, xT = "", _T = "", TT.length = 0;
          },
          setTitle: function setTitle(t) {
            _T = t;
          },
          getTitle: function getTitle() {
            return _T;
          },
          addSection: function addSection(t) {
            xT = t, wT.push(t);
          },
          getSections: function getSections() {
            return wT;
          },
          getTasks: function getTasks() {
            for (var t = ET(), e = 0; !t && e < 100;) {
              t = ET(), e++;
            }

            return kT.push.apply(kT, TT), kT;
          },
          addTask: function addTask(t, e) {
            var n = e.substr(1).split(":"),
                r = 0,
                i = [];
            1 === n.length ? (r = Number(n[0]), i = []) : (r = Number(n[0]), i = n[1].split(","));
            var a = i.map(function (t) {
              return t.trim();
            }),
                o = {
              section: xT,
              type: xT,
              people: a,
              task: t,
              score: r
            };
            TT.push(o);
          },
          addTaskOrg: function addTaskOrg(t) {
            var e = {
              section: xT,
              type: xT,
              description: t,
              task: t,
              classes: []
            };
            kT.push(e);
          },
          getActors: function getActors() {
            return t = [], kT.forEach(function (e) {
              e.people && t.push.apply(t, vT(e.people));
            }), vT(new Set(t)).sort();
            var t;
          }
        };

        var ST = n(6741),
            AT = n.n(ST),
            MT = function MT(t, e) {
          var n = t.append("rect");
          return n.attr("x", e.x), n.attr("y", e.y), n.attr("fill", e.fill), n.attr("stroke", e.stroke), n.attr("width", e.width), n.attr("height", e.height), n.attr("rx", e.rx), n.attr("ry", e.ry), void 0 !== e.class && n.attr("class", e.class), n;
        },
            NT = function NT(t, e) {
          var n = t.append("circle");
          return n.attr("cx", e.cx), n.attr("cy", e.cy), n.attr("class", "actor-" + e.pos), n.attr("fill", e.fill), n.attr("stroke", e.stroke), n.attr("r", e.r), void 0 !== n.class && n.attr("class", n.class), void 0 !== e.title && n.append("title").text(e.title), n;
        },
            DT = -1,
            OT = function () {
          function t(t, e, n, i, a, o, s, c) {
            r(e.append("text").attr("x", n + a / 2).attr("y", i + o / 2 + 5).style("font-color", c).style("text-anchor", "middle").text(t), s);
          }

          function e(t, e, n, i, a, o, s, c, u) {
            for (var l = c.taskFontSize, h = c.taskFontFamily, f = t.split(/<br\s*\/?>/gi), d = 0; d < f.length; d++) {
              var p = d * l - l * (f.length - 1) / 2,
                  y = e.append("text").attr("x", n + a / 2).attr("y", i).attr("fill", u).style("text-anchor", "middle").style("font-size", l).style("font-family", h);
              y.append("tspan").attr("x", n + a / 2).attr("dy", p).text(f[d]), y.attr("y", i + o / 2).attr("dominant-baseline", "central").attr("alignment-baseline", "central"), r(y, s);
            }
          }

          function n(t, n, i, a, o, s, c, u) {
            var l = n.append("switch"),
                h = l.append("foreignObject").attr("x", i).attr("y", a).attr("width", o).attr("height", s).attr("position", "fixed").append("xhtml:div").style("display", "table").style("height", "100%").style("width", "100%");
            h.append("div").attr("class", "label").style("display", "table-cell").style("text-align", "center").style("vertical-align", "middle").text(t), e(t, l, i, a, o, s, c, u), r(h, c);
          }

          function r(t, e) {
            for (var n in e) {
              n in e && t.attr(n, e[n]);
            }
          }

          return function (r) {
            return "fo" === r.textPlacement ? n : "old" === r.textPlacement ? t : e;
          };
        }();

        var BT = NT,
            LT = function LT(t, e, n) {
          var r = t.append("g"),
              i = {
            x: 0,
            y: 0,
            width: 100,
            anchor: "start",
            height: 100,
            rx: 0,
            ry: 0
          };
          i.x = e.x, i.y = e.y, i.fill = e.fill, i.width = n.width, i.height = n.height, i.class = "journey-section section-type-" + e.num, i.rx = 3, i.ry = 3, MT(r, i), OT(n)(e.text, r, i.x, i.y, i.width, i.height, {
            class: "journey-section section-type-" + e.num
          }, n, e.colour);
        },
            IT = function IT(t, e, n) {
          var r,
              i,
              a,
              o = e.x + n.width / 2,
              s = t.append("g");
          DT++, s.append("line").attr("id", "task" + DT).attr("x1", o).attr("y1", e.y).attr("x2", o).attr("y2", 450).attr("class", "task-line").attr("stroke-width", "1px").attr("stroke-dasharray", "4 2").attr("stroke", "#666"), r = s, i = {
            cx: o,
            cy: 300 + 30 * (5 - e.score),
            score: e.score
          }, r.append("circle").attr("cx", i.cx).attr("cy", i.cy).attr("class", "face").attr("r", 15).attr("stroke-width", 2).attr("overflow", "visible"), (a = r.append("g")).append("circle").attr("cx", i.cx - 5).attr("cy", i.cy - 5).attr("r", 1.5).attr("stroke-width", 2).attr("fill", "#666").attr("stroke", "#666"), a.append("circle").attr("cx", i.cx + 5).attr("cy", i.cy - 5).attr("r", 1.5).attr("stroke-width", 2).attr("fill", "#666").attr("stroke", "#666"), i.score > 3 ? function (t) {
            var e = Cu().startAngle(Math.PI / 2).endAngle(Math.PI / 2 * 3).innerRadius(7.5).outerRadius(15 / 2.2);
            t.append("path").attr("class", "mouth").attr("d", e).attr("transform", "translate(" + i.cx + "," + (i.cy + 2) + ")");
          }(a) : i.score < 3 ? function (t) {
            var e = Cu().startAngle(3 * Math.PI / 2).endAngle(Math.PI / 2 * 5).innerRadius(7.5).outerRadius(15 / 2.2);
            t.append("path").attr("class", "mouth").attr("d", e).attr("transform", "translate(" + i.cx + "," + (i.cy + 7) + ")");
          }(a) : function (t) {
            t.append("line").attr("class", "mouth").attr("stroke", 2).attr("x1", i.cx - 5).attr("y1", i.cy + 7).attr("x2", i.cx + 5).attr("y2", i.cy + 7).attr("class", "mouth").attr("stroke-width", "1px").attr("stroke", "#666");
          }(a);
          var c = {
            x: 0,
            y: 0,
            width: 100,
            anchor: "start",
            height: 100,
            rx: 0,
            ry: 0
          };
          c.x = e.x, c.y = e.y, c.fill = e.fill, c.width = n.width, c.height = n.height, c.class = "task task-type-" + e.num, c.rx = 3, c.ry = 3, MT(s, c);
          var u = e.x + 14;
          e.people.forEach(function (t) {
            var n = e.actors[t].color,
                r = {
              cx: u,
              cy: e.y,
              r: 7,
              fill: n,
              stroke: "#000",
              title: t,
              pos: e.actors[t].position
            };
            NT(s, r), u += 10;
          }), OT(n)(e.task, s, c.x, c.y, c.width, c.height, {
            class: "task"
          }, n, e.colour);
        };

        ST.parser.yy = CT;
        var RT = {},
            PT = Ev().journey,
            FT = Ev().journey.leftMargin,
            jT = {
          data: {
            startx: void 0,
            stopx: void 0,
            starty: void 0,
            stopy: void 0
          },
          verticalPos: 0,
          sequenceItems: [],
          init: function init() {
            this.sequenceItems = [], this.data = {
              startx: void 0,
              stopx: void 0,
              starty: void 0,
              stopy: void 0
            }, this.verticalPos = 0;
          },
          updateVal: function updateVal(t, e, n, r) {
            void 0 === t[e] ? t[e] = n : t[e] = r(n, t[e]);
          },
          updateBounds: function updateBounds(t, e, n, r) {
            var i = Ev().journey,
                a = this,
                o = 0;
            this.sequenceItems.forEach(function (s) {
              o++;
              var c = a.sequenceItems.length - o + 1;
              a.updateVal(s, "starty", e - c * i.boxMargin, Math.min), a.updateVal(s, "stopy", r + c * i.boxMargin, Math.max), a.updateVal(jT.data, "startx", t - c * i.boxMargin, Math.min), a.updateVal(jT.data, "stopx", n + c * i.boxMargin, Math.max), a.updateVal(s, "startx", t - c * i.boxMargin, Math.min), a.updateVal(s, "stopx", n + c * i.boxMargin, Math.max), a.updateVal(jT.data, "starty", e - c * i.boxMargin, Math.min), a.updateVal(jT.data, "stopy", r + c * i.boxMargin, Math.max);
            });
          },
          insert: function insert(t, e, n, r) {
            var i = Math.min(t, n),
                a = Math.max(t, n),
                o = Math.min(e, r),
                s = Math.max(e, r);
            this.updateVal(jT.data, "startx", i, Math.min), this.updateVal(jT.data, "starty", o, Math.min), this.updateVal(jT.data, "stopx", a, Math.max), this.updateVal(jT.data, "stopy", s, Math.max), this.updateBounds(i, o, a, s);
          },
          bumpVerticalPos: function bumpVerticalPos(t) {
            this.verticalPos = this.verticalPos + t, this.data.stopy = this.verticalPos;
          },
          getVerticalPos: function getVerticalPos() {
            return this.verticalPos;
          },
          getBounds: function getBounds() {
            return this.data;
          }
        },
            YT = PT.sectionFills,
            UT = PT.sectionColours;

        var zT = function zT(t) {
          Object.keys(t).forEach(function (e) {
            PT[e] = t[e];
          });
        };

        var qT = {};

        var $T = function $T(t) {
          return "g.classGroup text {\n  fill: ".concat(t.nodeBorder, ";\n  fill: ").concat(t.classText, ";\n  stroke: none;\n  font-family: ").concat(t.fontFamily, ";\n  font-size: 10px;\n\n  .title {\n    font-weight: bolder;\n  }\n\n}\n\n.nodeLabel, .edgeLabel {\n  color: ").concat(t.classText, ";\n}\n.edgeLabel .label rect {\n  fill: ").concat(t.mainBkg, ";\n}\n.label text {\n  fill: ").concat(t.classText, ";\n}\n.edgeLabel .label span {\n  background: ").concat(t.mainBkg, ";\n}\n\n.classTitle {\n  font-weight: bolder;\n}\n.node rect,\n  .node circle,\n  .node ellipse,\n  .node polygon,\n  .node path {\n    fill: ").concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n    stroke-width: 1px;\n  }\n\n\n.divider {\n  stroke: ").concat(t.nodeBorder, ";\n  stroke: 1;\n}\n\ng.clickable {\n  cursor: pointer;\n}\n\ng.classGroup rect {\n  fill: ").concat(t.mainBkg, ";\n  stroke: ").concat(t.nodeBorder, ";\n}\n\ng.classGroup line {\n  stroke: ").concat(t.nodeBorder, ";\n  stroke-width: 1;\n}\n\n.classLabel .box {\n  stroke: none;\n  stroke-width: 0;\n  fill: ").concat(t.mainBkg, ";\n  opacity: 0.5;\n}\n\n.classLabel .label {\n  fill: ").concat(t.nodeBorder, ";\n  font-size: 10px;\n}\n\n.relation {\n  stroke: ").concat(t.lineColor, ";\n  stroke-width: 1;\n  fill: none;\n}\n\n.dashed-line{\n  stroke-dasharray: 3;\n}\n\n#compositionStart, .composition {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#compositionEnd, .composition {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#dependencyStart, .dependency {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#dependencyStart, .dependency {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#extensionStart, .extension {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#extensionEnd, .extension {\n  fill: ").concat(t.lineColor, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#aggregationStart, .aggregation {\n  fill: ").concat(t.mainBkg, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n#aggregationEnd, .aggregation {\n  fill: ").concat(t.mainBkg, " !important;\n  stroke: ").concat(t.lineColor, " !important;\n  stroke-width: 1;\n}\n\n.edgeTerminals {\n  font-size: 11px;\n}\n\n");
        },
            HT = function HT(t) {
          return ".label {\n    font-family: ".concat(t.fontFamily, ";\n    color: ").concat(t.nodeTextColor || t.textColor, ";\n  }\n  .cluster-label text {\n    fill: ").concat(t.titleColor, ";\n  }\n  .cluster-label span {\n    color: ").concat(t.titleColor, ";\n  }\n\n  .label text,span {\n    fill: ").concat(t.nodeTextColor || t.textColor, ";\n    color: ").concat(t.nodeTextColor || t.textColor, ";\n  }\n\n  .node rect,\n  .node circle,\n  .node ellipse,\n  .node polygon,\n  .node path {\n    fill: ").concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n    stroke-width: 1px;\n  }\n\n  .node .label {\n    text-align: center;\n  }\n  .node.clickable {\n    cursor: pointer;\n  }\n\n  .arrowheadPath {\n    fill: ").concat(t.arrowheadColor, ";\n  }\n\n  .edgePath .path {\n    stroke: ").concat(t.lineColor, ";\n    stroke-width: 2.0px;\n  }\n\n  .flowchart-link {\n    stroke: ").concat(t.lineColor, ";\n    fill: none;\n  }\n\n  .edgeLabel {\n    background-color: ").concat(t.edgeLabelBackground, ";\n    rect {\n      opacity: 0.5;\n      background-color: ").concat(t.edgeLabelBackground, ";\n      fill: ").concat(t.edgeLabelBackground, ";\n    }\n    text-align: center;\n  }\n\n  .cluster rect {\n    fill: ").concat(t.clusterBkg, ";\n    stroke: ").concat(t.clusterBorder, ";\n    stroke-width: 1px;\n  }\n\n  .cluster text {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .cluster span {\n    color: ").concat(t.titleColor, ";\n  }\n  /* .cluster div {\n    color: ").concat(t.titleColor, ";\n  } */\n\n  div.mermaidTooltip {\n    position: absolute;\n    text-align: center;\n    max-width: 200px;\n    padding: 2px;\n    font-family: ").concat(t.fontFamily, ";\n    font-size: 12px;\n    background: ").concat(t.tertiaryColor, ";\n    border: 1px solid ").concat(t.border2, ";\n    border-radius: 2px;\n    pointer-events: none;\n    z-index: 100;\n  }\n");
        },
            WT = function WT(t) {
          return "\ndefs #statediagram-barbEnd {\n    fill: ".concat(t.transitionColor, ";\n    stroke: ").concat(t.transitionColor, ";\n  }\ng.stateGroup text {\n  fill: ").concat(t.nodeBorder, ";\n  stroke: none;\n  font-size: 10px;\n}\ng.stateGroup text {\n  fill: ").concat(t.textColor, ";\n  stroke: none;\n  font-size: 10px;\n\n}\ng.stateGroup .state-title {\n  font-weight: bolder;\n  fill: ").concat(t.stateLabelColor, ";\n}\n\ng.stateGroup rect {\n  fill: ").concat(t.mainBkg, ";\n  stroke: ").concat(t.nodeBorder, ";\n}\n\ng.stateGroup line {\n  stroke: ").concat(t.lineColor, ";\n  stroke-width: 1;\n}\n\n.transition {\n  stroke: ").concat(t.transitionColor, ";\n  stroke-width: 1;\n  fill: none;\n}\n\n.stateGroup .composit {\n  fill: ").concat(t.background, ";\n  border-bottom: 1px\n}\n\n.stateGroup .alt-composit {\n  fill: #e0e0e0;\n  border-bottom: 1px\n}\n\n.state-note {\n  stroke: ").concat(t.noteBorderColor, ";\n  fill: ").concat(t.noteBkgColor, ";\n\n  text {\n    fill: ").concat(t.noteTextColor, ";\n    stroke: none;\n    font-size: 10px;\n  }\n}\n\n.stateLabel .box {\n  stroke: none;\n  stroke-width: 0;\n  fill: ").concat(t.mainBkg, ";\n  opacity: 0.5;\n}\n\n.edgeLabel .label rect {\n  fill: ").concat(t.labelBackgroundColor, ";\n  opacity: 0.5;\n}\n.edgeLabel .label text {\n  fill: ").concat(t.transitionLabelColor || t.tertiaryTextColor, ";\n}\n.label div .edgeLabel {\n  color: ").concat(t.transitionLabelColor || t.tertiaryTextColor, ";\n}\n\n.stateLabel text {\n  fill: ").concat(t.stateLabelColor, ";\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.node circle.state-start {\n  fill: ").concat(t.specialStateColor, ";\n  stroke: ").concat(t.specialStateColor, ";\n}\n\n.node .fork-join {\n  fill: ").concat(t.specialStateColor, ";\n  stroke: ").concat(t.specialStateColor, ";\n}\n\n.node circle.state-end {\n  fill: ").concat(t.innerEndBackground, ";\n  stroke: ").concat(t.background, ";\n  stroke-width: 1.5\n}\n.end-state-inner {\n  fill: ").concat(t.compositeBackground || t.background, ";\n  // stroke: ").concat(t.background, ";\n  stroke-width: 1.5\n}\n\n.node rect {\n  fill: ").concat(t.stateBkg || t.mainBkg, ";\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";\n  stroke-width: 1px;\n}\n.node polygon {\n  fill: ").concat(t.mainBkg, ";\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";;\n  stroke-width: 1px;\n}\n#statediagram-barbEnd {\n  fill: ").concat(t.lineColor, ";\n}\n\n.statediagram-cluster rect {\n  fill: ").concat(t.compositeTitleBackground, ";\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";\n  stroke-width: 1px;\n}\n\n.cluster-label, .nodeLabel {\n  color: ").concat(t.stateLabelColor, ";\n}\n\n.statediagram-cluster rect.outer {\n  rx: 5px;\n  ry: 5px;\n}\n.statediagram-state .divider {\n  stroke: ").concat(t.stateBorder || t.nodeBorder, ";\n}\n\n.statediagram-state .title-state {\n  rx: 5px;\n  ry: 5px;\n}\n.statediagram-cluster.statediagram-cluster .inner {\n  fill: ").concat(t.compositeBackground || t.background, ";\n}\n.statediagram-cluster.statediagram-cluster-alt .inner {\n  fill: ").concat(t.altBackground ? t.altBackground : "#efefef", ";\n}\n\n.statediagram-cluster .inner {\n  rx:0;\n  ry:0;\n}\n\n.statediagram-state rect.basic {\n  rx: 5px;\n  ry: 5px;\n}\n.statediagram-state rect.divider {\n  stroke-dasharray: 10,10;\n  fill: ").concat(t.altBackground ? t.altBackground : "#efefef", ";\n}\n\n.note-edge {\n  stroke-dasharray: 5;\n}\n\n.statediagram-note rect {\n  fill: ").concat(t.noteBkgColor, ";\n  stroke: ").concat(t.noteBorderColor, ";\n  stroke-width: 1px;\n  rx: 0;\n  ry: 0;\n}\n.statediagram-note rect {\n  fill: ").concat(t.noteBkgColor, ";\n  stroke: ").concat(t.noteBorderColor, ";\n  stroke-width: 1px;\n  rx: 0;\n  ry: 0;\n}\n\n.statediagram-note text {\n  fill: ").concat(t.noteTextColor, ";\n}\n\n.statediagram-note .nodeLabel {\n  color: ").concat(t.noteTextColor, ";\n}\n.statediagram .edgeLabel {\n  color: red; // ").concat(t.noteTextColor, ";\n}\n\n#dependencyStart, #dependencyEnd {\n  fill: ").concat(t.lineColor, ";\n  stroke: ").concat(t.lineColor, ";\n  stroke-width: 1;\n}\n");
        };

        var VT = {
          flowchart: HT,
          "flowchart-v2": HT,
          sequence: function sequence(t) {
            return ".actor {\n    stroke: ".concat(t.actorBorder, ";\n    fill: ").concat(t.actorBkg, ";\n  }\n\n  text.actor > tspan {\n    fill: ").concat(t.actorTextColor, ";\n    stroke: none;\n  }\n\n  .actor-line {\n    stroke: ").concat(t.actorLineColor, ";\n  }\n\n  .messageLine0 {\n    stroke-width: 1.5;\n    stroke-dasharray: none;\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  .messageLine1 {\n    stroke-width: 1.5;\n    stroke-dasharray: 2, 2;\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  #arrowhead path {\n    fill: ").concat(t.signalColor, ";\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  .sequenceNumber {\n    fill: ").concat(t.sequenceNumberColor, ";\n  }\n\n  #sequencenumber {\n    fill: ").concat(t.signalColor, ";\n  }\n\n  #crosshead path {\n    fill: ").concat(t.signalColor, ";\n    stroke: ").concat(t.signalColor, ";\n  }\n\n  .messageText {\n    fill: ").concat(t.signalTextColor, ";\n    stroke: ").concat(t.signalTextColor, ";\n  }\n\n  .labelBox {\n    stroke: ").concat(t.labelBoxBorderColor, ";\n    fill: ").concat(t.labelBoxBkgColor, ";\n  }\n\n  .labelText, .labelText > tspan {\n    fill: ").concat(t.labelTextColor, ";\n    stroke: none;\n  }\n\n  .loopText, .loopText > tspan {\n    fill: ").concat(t.loopTextColor, ";\n    stroke: none;\n  }\n\n  .loopLine {\n    stroke-width: 2px;\n    stroke-dasharray: 2, 2;\n    stroke: ").concat(t.labelBoxBorderColor, ";\n    fill: ").concat(t.labelBoxBorderColor, ";\n  }\n\n  .note {\n    //stroke: #decc93;\n    stroke: ").concat(t.noteBorderColor, ";\n    fill: ").concat(t.noteBkgColor, ";\n  }\n\n  .noteText, .noteText > tspan {\n    fill: ").concat(t.noteTextColor, ";\n    stroke: none;\n  }\n\n  .activation0 {\n    fill: ").concat(t.activationBkgColor, ";\n    stroke: ").concat(t.activationBorderColor, ";\n  }\n\n  .activation1 {\n    fill: ").concat(t.activationBkgColor, ";\n    stroke: ").concat(t.activationBorderColor, ";\n  }\n\n  .activation2 {\n    fill: ").concat(t.activationBkgColor, ";\n    stroke: ").concat(t.activationBorderColor, ";\n  }\n\n  .actorPopupMenu {\n    position: absolute;\n  }\n\n  .actorPopupMenuPanel {\n    position: absolute;\n    fill: ").concat(t.actorBkg, ";\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));\n}\n  .actor-man line {\n    stroke: ").concat(t.actorBorder, ";\n    fill: ").concat(t.actorBkg, ";\n  }\n  .actor-man circle, line {\n    stroke: ").concat(t.actorBorder, ";\n    fill: ").concat(t.actorBkg, ";\n    stroke-width: 2px;\n  }\n");
          },
          gantt: function gantt(t) {
            return '\n  .mermaid-main-font {\n    font-family: "trebuchet ms", verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n  .exclude-range {\n    fill: '.concat(t.excludeBkgColor, ";\n  }\n\n  .section {\n    stroke: none;\n    opacity: 0.2;\n  }\n\n  .section0 {\n    fill: ").concat(t.sectionBkgColor, ";\n  }\n\n  .section2 {\n    fill: ").concat(t.sectionBkgColor2, ";\n  }\n\n  .section1,\n  .section3 {\n    fill: ").concat(t.altSectionBkgColor, ";\n    opacity: 0.2;\n  }\n\n  .sectionTitle0 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle1 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle2 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle3 {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  .sectionTitle {\n    text-anchor: start;\n    // font-size: ").concat(t.ganttFontSize, ";\n    // text-height: 14px;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n\n  }\n\n\n  /* Grid and axis */\n\n  .grid .tick {\n    stroke: ").concat(t.gridColor, ";\n    opacity: 0.8;\n    shape-rendering: crispEdges;\n    text {\n      font-family: ").concat(t.fontFamily, ";\n      fill: ").concat(t.textColor, ";\n    }\n  }\n\n  .grid path {\n    stroke-width: 0;\n  }\n\n\n  /* Today line */\n\n  .today {\n    fill: none;\n    stroke: ").concat(t.todayLineColor, ";\n    stroke-width: 2px;\n  }\n\n\n  /* Task styling */\n\n  /* Default task */\n\n  .task {\n    stroke-width: 2;\n  }\n\n  .taskText {\n    text-anchor: middle;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n\n  // .taskText:not([font-size]) {\n  //   font-size: ").concat(t.ganttFontSize, ";\n  // }\n\n  .taskTextOutsideRight {\n    fill: ").concat(t.taskTextDarkColor, ";\n    text-anchor: start;\n    // font-size: ").concat(t.ganttFontSize, ";\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n\n  }\n\n  .taskTextOutsideLeft {\n    fill: ").concat(t.taskTextDarkColor, ";\n    text-anchor: end;\n    // font-size: ").concat(t.ganttFontSize, ";\n  }\n\n  /* Special case clickable */\n  .task.clickable {\n    cursor: pointer;\n  }\n  .taskText.clickable {\n    cursor: pointer;\n    fill: ").concat(t.taskTextClickableColor, " !important;\n    font-weight: bold;\n  }\n\n  .taskTextOutsideLeft.clickable {\n    cursor: pointer;\n    fill: ").concat(t.taskTextClickableColor, " !important;\n    font-weight: bold;\n  }\n\n  .taskTextOutsideRight.clickable {\n    cursor: pointer;\n    fill: ").concat(t.taskTextClickableColor, " !important;\n    font-weight: bold;\n  }\n\n  /* Specific task settings for the sections*/\n\n  .taskText0,\n  .taskText1,\n  .taskText2,\n  .taskText3 {\n    fill: ").concat(t.taskTextColor, ";\n  }\n\n  .task0,\n  .task1,\n  .task2,\n  .task3 {\n    fill: ").concat(t.taskBkgColor, ";\n    stroke: ").concat(t.taskBorderColor, ";\n  }\n\n  .taskTextOutside0,\n  .taskTextOutside2\n  {\n    fill: ").concat(t.taskTextOutsideColor, ";\n  }\n\n  .taskTextOutside1,\n  .taskTextOutside3 {\n    fill: ").concat(t.taskTextOutsideColor, ";\n  }\n\n\n  /* Active task */\n\n  .active0,\n  .active1,\n  .active2,\n  .active3 {\n    fill: ").concat(t.activeTaskBkgColor, ";\n    stroke: ").concat(t.activeTaskBorderColor, ";\n  }\n\n  .activeText0,\n  .activeText1,\n  .activeText2,\n  .activeText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n\n  /* Completed task */\n\n  .done0,\n  .done1,\n  .done2,\n  .done3 {\n    stroke: ").concat(t.doneTaskBorderColor, ";\n    fill: ").concat(t.doneTaskBkgColor, ";\n    stroke-width: 2;\n  }\n\n  .doneText0,\n  .doneText1,\n  .doneText2,\n  .doneText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n\n  /* Tasks on the critical line */\n\n  .crit0,\n  .crit1,\n  .crit2,\n  .crit3 {\n    stroke: ").concat(t.critBorderColor, ";\n    fill: ").concat(t.critBkgColor, ";\n    stroke-width: 2;\n  }\n\n  .activeCrit0,\n  .activeCrit1,\n  .activeCrit2,\n  .activeCrit3 {\n    stroke: ").concat(t.critBorderColor, ";\n    fill: ").concat(t.activeTaskBkgColor, ";\n    stroke-width: 2;\n  }\n\n  .doneCrit0,\n  .doneCrit1,\n  .doneCrit2,\n  .doneCrit3 {\n    stroke: ").concat(t.critBorderColor, ";\n    fill: ").concat(t.doneTaskBkgColor, ";\n    stroke-width: 2;\n    cursor: pointer;\n    shape-rendering: crispEdges;\n  }\n\n  .milestone {\n    transform: rotate(45deg) scale(0.8,0.8);\n  }\n\n  .milestoneText {\n    font-style: italic;\n  }\n  .doneCritText0,\n  .doneCritText1,\n  .doneCritText2,\n  .doneCritText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n  .activeCritText0,\n  .activeCritText1,\n  .activeCritText2,\n  .activeCritText3 {\n    fill: ").concat(t.taskTextDarkColor, " !important;\n  }\n\n  .titleText {\n    text-anchor: middle;\n    font-size: 18px;\n    fill: ").concat(t.textColor, "    ;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n");
          },
          classDiagram: $T,
          "classDiagram-v2": $T,
          class: $T,
          stateDiagram: WT,
          state: WT,
          git: function git() {
            return "\n  .commit-id,\n  .commit-msg,\n  .branch-label {\n    fill: lightgrey;\n    color: lightgrey;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n  }\n";
          },
          info: function info() {
            return "";
          },
          pie: function pie(t) {
            return "\n  .pieCircle{\n    stroke: ".concat(t.pieStrokeColor, ";\n    stroke-width : ").concat(t.pieStrokeWidth, ";\n    opacity : ").concat(t.pieOpacity, ";\n  }\n  .pieTitleText {\n    text-anchor: middle;\n    font-size: ").concat(t.pieTitleTextSize, ";\n    fill: ").concat(t.pieTitleTextColor, ";\n    font-family: ").concat(t.fontFamily, ";\n  }\n  .slice {\n    font-family: ").concat(t.fontFamily, ";\n    fill: ").concat(t.pieSectionTextColor, ";\n    font-size:").concat(t.pieSectionTextSize, ";\n    // fill: white;\n  }\n  .legend text {\n    fill: ").concat(t.pieLegendTextColor, ";\n    font-family: ").concat(t.fontFamily, ";\n    font-size: ").concat(t.pieLegendTextSize, ";\n  }\n");
          },
          er: function er(t) {
            return "\n  .entityBox {\n    fill: ".concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n  }\n\n  .attributeBoxOdd {\n    fill: #ffffff;\n    stroke: ").concat(t.nodeBorder, ";\n  }\n\n  .attributeBoxEven {\n    fill: #f2f2f2;\n    stroke: ").concat(t.nodeBorder, ";\n  }\n\n  .relationshipLabelBox {\n    fill: ").concat(t.tertiaryColor, ";\n    opacity: 0.7;\n    background-color: ").concat(t.tertiaryColor, ";\n      rect {\n        opacity: 0.5;\n      }\n  }\n\n    .relationshipLine {\n      stroke: ").concat(t.lineColor, ";\n    }\n");
          },
          journey: function journey(t) {
            return ".label {\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n    color: ".concat(t.textColor, ";\n  }\n  .mouth {\n    stroke: #666;\n  }\n\n  line {\n    stroke: ").concat(t.textColor, "\n  }\n\n  .legend {\n    fill: ").concat(t.textColor, ";\n  }\n\n  .label text {\n    fill: #333;\n  }\n  .label {\n    color: ").concat(t.textColor, "\n  }\n\n  .face {\n    ").concat(t.faceColor ? "fill: ".concat(t.faceColor) : "fill: #FFF8DC", ";\n    stroke: #999;\n  }\n\n  .node rect,\n  .node circle,\n  .node ellipse,\n  .node polygon,\n  .node path {\n    fill: ").concat(t.mainBkg, ";\n    stroke: ").concat(t.nodeBorder, ";\n    stroke-width: 1px;\n  }\n\n  .node .label {\n    text-align: center;\n  }\n  .node.clickable {\n    cursor: pointer;\n  }\n\n  .arrowheadPath {\n    fill: ").concat(t.arrowheadColor, ";\n  }\n\n  .edgePath .path {\n    stroke: ").concat(t.lineColor, ";\n    stroke-width: 1.5px;\n  }\n\n  .flowchart-link {\n    stroke: ").concat(t.lineColor, ";\n    fill: none;\n  }\n\n  .edgeLabel {\n    background-color: ").concat(t.edgeLabelBackground, ";\n    rect {\n      opacity: 0.5;\n    }\n    text-align: center;\n  }\n\n  .cluster rect {\n  }\n\n  .cluster text {\n    fill: ").concat(t.titleColor, ";\n  }\n\n  div.mermaidTooltip {\n    position: absolute;\n    text-align: center;\n    max-width: 200px;\n    padding: 2px;\n    font-family: 'trebuchet ms', verdana, arial, sans-serif;\n    font-family: var(--mermaid-font-family);\n    font-size: 12px;\n    background: ").concat(t.tertiaryColor, ";\n    border: 1px solid ").concat(t.border2, ";\n    border-radius: 2px;\n    pointer-events: none;\n    z-index: 100;\n  }\n\n  .task-type-0, .section-type-0  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType0) : "", ";\n  }\n  .task-type-1, .section-type-1  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType1) : "", ";\n  }\n  .task-type-2, .section-type-2  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType2) : "", ";\n  }\n  .task-type-3, .section-type-3  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType3) : "", ";\n  }\n  .task-type-4, .section-type-4  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType4) : "", ";\n  }\n  .task-type-5, .section-type-5  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType5) : "", ";\n  }\n  .task-type-6, .section-type-6  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType6) : "", ";\n  }\n  .task-type-7, .section-type-7  {\n    ").concat(t.fillType0 ? "fill: ".concat(t.fillType7) : "", ";\n  }\n\n  .actor-0 {\n    ").concat(t.actor0 ? "fill: ".concat(t.actor0) : "", ";\n  }\n  .actor-1 {\n    ").concat(t.actor1 ? "fill: ".concat(t.actor1) : "", ";\n  }\n  .actor-2 {\n    ").concat(t.actor2 ? "fill: ".concat(t.actor2) : "", ";\n  }\n  .actor-3 {\n    ").concat(t.actor3 ? "fill: ".concat(t.actor3) : "", ";\n  }\n  .actor-4 {\n    ").concat(t.actor4 ? "fill: ".concat(t.actor4) : "", ";\n  }\n  .actor-5 {\n    ").concat(t.actor5 ? "fill: ".concat(t.actor5) : "", ";\n  }\n\n  }\n");
          },
          requirement: function requirement(t) {
            return "\n\n  marker {\n    fill: ".concat(t.relationColor, ";\n    stroke: ").concat(t.relationColor, ";\n  }\n\n  marker.cross {\n    stroke: ").concat(t.lineColor, ";\n  }\n\n  svg {\n    font-family: ").concat(t.fontFamily, ";\n    font-size: ").concat(t.fontSize, ";\n  }\n\n  .reqBox {\n    fill: ").concat(t.requirementBackground, ";\n    fill-opacity: 100%;\n    stroke: ").concat(t.requirementBorderColor, ";\n    stroke-width: ").concat(t.requirementBorderSize, ";\n  }\n  \n  .reqTitle, .reqLabel{\n    fill:  ").concat(t.requirementTextColor, ";\n  }\n  .reqLabelBox {\n    fill: ").concat(t.relationLabelBackground, ";\n    fill-opacity: 100%;\n  }\n\n  .req-title-line {\n    stroke: ").concat(t.requirementBorderColor, ";\n    stroke-width: ").concat(t.requirementBorderSize, ";\n  }\n  .relationshipLine {\n    stroke: ").concat(t.relationColor, ";\n    stroke-width: 1;\n  }\n  .relationshipLabel {\n    fill: ").concat(t.relationLabelColor, ";\n  }\n\n");
          }
        };

        function GT(t) {
          return (GT = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          })(t);
        }

        var XT = function XT(t) {
          return t.replace(/ﬂ°°/g, function () {
            return "&#";
          }).replace(/ﬂ°/g, function () {
            return "&";
          }).replace(/¶ß/g, function () {
            return ";";
          });
        },
            ZT = {};

        function KT(t) {
          var e;
          sw(t.git), Z_(t.flowchart), J_(t.flowchart), void 0 !== t.sequenceDiagram && Yk.setConf(sv(t.sequence, t.sequenceDiagram)), Yk.setConf(t.sequence), t.gantt, cb(t.class), t.state, mT(t.state), pw(t.class), a_(t.er), zT(t.journey), Yw(t.requirement), e = t.class, Object.keys(e).forEach(function (t) {
            qT[t] = e[t];
          });
        }

        var QT = Object.freeze({
          render: function render(t, e, n, r) {
            Av();
            var i = e,
                a = gv.detectInit(i);
            a && Sv(a);
            var s = Ev();
            if (e.length > s.maxTextSize && (i = "graph TB;a[Maximum text size in diagram exceeded];style a fill:#faa"), void 0 !== r) r.innerHTML = "", Zc(r).append("div").attr("id", "d" + t).attr("style", "font-family: " + s.fontFamily).append("svg").attr("id", t).attr("width", "100%").attr("xmlns", "http://www.w3.org/2000/svg").append("g");else {
              var c = document.getElementById(t);
              c && c.remove();
              var u = document.querySelector("#d" + t);
              u && u.remove(), Zc("body").append("div").attr("id", "d" + t).append("svg").attr("id", t).attr("width", "100%").attr("xmlns", "http://www.w3.org/2000/svg").append("g");
            }
            window.txt = i, i = i.replace(/style.*:\S*#.*;/g, function (t) {
              return t.substring(0, t.length - 1);
            }).replace(/classDef.*:\S*#.*;/g, function (t) {
              return t.substring(0, t.length - 1);
            }).replace(/#\w+;/g, function (t) {
              var e = t.substring(1, t.length - 1);
              return /^\+?\d+$/.test(e) ? "ﬂ°°" + e + "¶ß" : "ﬂ°" + e + "¶ß";
            });
            var l = Zc("#d" + t).node(),
                h = gv.detectType(i, s),
                f = l.firstChild,
                d = f.firstChild,
                p = "";

            if (void 0 !== s.themeCSS && (p += "\n".concat(s.themeCSS)), void 0 !== s.fontFamily && (p += "\n:root { --mermaid-font-family: ".concat(s.fontFamily, "}")), void 0 !== s.altFontFamily && (p += "\n:root { --mermaid-alt-font-family: ".concat(s.altFontFamily, "}")), "flowchart" === h || "flowchart-v2" === h || "graph" === h) {
              var y = function (t) {
                o.info("Extracting classes"), N_.clear();

                try {
                  var e = O_().parser;
                  return e.yy = N_, e.parse(t), N_.getClasses();
                } catch (t) {
                  return;
                }
              }(i),
                  g = s.htmlLabels || s.flowchart.htmlLabels;

              for (var m in y) {
                g ? (p += "\n.".concat(m, " > * { ").concat(y[m].styles.join(" !important; "), " !important; }"), p += "\n.".concat(m, " span { ").concat(y[m].styles.join(" !important; "), " !important; }")) : (p += "\n.".concat(m, " path { ").concat(y[m].styles.join(" !important; "), " !important; }"), p += "\n.".concat(m, " rect { ").concat(y[m].styles.join(" !important; "), " !important; }"), p += "\n.".concat(m, " polygon { ").concat(y[m].styles.join(" !important; "), " !important; }"), p += "\n.".concat(m, " ellipse { ").concat(y[m].styles.join(" !important; "), " !important; }"), p += "\n.".concat(m, " circle { ").concat(y[m].styles.join(" !important; "), " !important; }"), y[m].textStyles && (p += "\n.".concat(m, " tspan { ").concat(y[m].textStyles.join(" !important; "), " !important; }")));
              }
            }

            var v = function (t, e) {
              return $g(um("".concat(t, "{").concat(e, "}")), Hg);
            }("#".concat(t), function (t, e, n) {
              return " {\n    font-family: ".concat(n.fontFamily, ";\n    font-size: ").concat(n.fontSize, ";\n    fill: ").concat(n.textColor, "\n  }\n\n  /* Classes common for multiple diagrams */\n\n  .error-icon {\n    fill: ").concat(n.errorBkgColor, ";\n  }\n  .error-text {\n    fill: ").concat(n.errorTextColor, ";\n    stroke: ").concat(n.errorTextColor, ";\n  }\n\n  .edge-thickness-normal {\n    stroke-width: 2px;\n  }\n  .edge-thickness-thick {\n    stroke-width: 3.5px\n  }\n  .edge-pattern-solid {\n    stroke-dasharray: 0;\n  }\n\n  .edge-pattern-dashed{\n    stroke-dasharray: 3;\n  }\n  .edge-pattern-dotted {\n    stroke-dasharray: 2;\n  }\n\n  .marker {\n    fill: ").concat(n.lineColor, ";\n    stroke: ").concat(n.lineColor, ";\n  }\n  .marker.cross {\n    stroke: ").concat(n.lineColor, ";\n  }\n\n  svg {\n    font-family: ").concat(n.fontFamily, ";\n    font-size: ").concat(n.fontSize, ";\n  }\n\n  ").concat(VT[t](n), "\n\n  ").concat(e, "\n");
            }(h, p, s.themeVariables)),
                b = document.createElement("style");

            b.innerHTML = "#".concat(t, " ") + v, f.insertBefore(b, d);

            try {
              switch (h) {
                case "git":
                  s.flowchart.arrowMarkerAbsolute = s.arrowMarkerAbsolute, sw(s.git), function (t, e, n) {
                    try {
                      var r = Kx().parser;
                      r.yy = Gx, r.yy.clear(), o.debug("in gitgraph renderer", t + "\n", "id:", e, !1), r.parse(t + "\n"), Jx = Object.assign(Jx, tw, Gx.getOptions()), o.debug("effective options", Jx);
                      var i = Gx.getDirection();
                      Qx = Gx.getCommits();
                      var a = Gx.getBranchesAsObjArray();
                      "BT" === i && (Jx.nodeLabel.x = a.length * Jx.branchOffset, Jx.nodeLabel.width = "100%", Jx.nodeLabel.y = -2 * Jx.nodeRadius);
                      var s = Zc('[id="'.concat(e, '"]'));

                      for (var c in function (t) {
                        t.append("defs").append("g").attr("id", "def-commit").append("circle").attr("r", Jx.nodeRadius).attr("cx", 0).attr("cy", 0), t.select("#def-commit").append("foreignObject").attr("width", Jx.nodeLabel.width).attr("height", Jx.nodeLabel.height).attr("x", Jx.nodeLabel.x).attr("y", Jx.nodeLabel.y).attr("class", "node-label").attr("requiredFeatures", "http://www.w3.org/TR/SVG11/feature#Extensibility").append("p").html("");
                      }(s), Xx = 1, a) {
                        var u = a[c];
                        aw(s, u.commit.id, a, i), ow(s, u.commit, i), Xx++;
                      }

                      s.attr("height", function () {
                        return "BT" === i ? Object.keys(Qx).length * Jx.nodeSpacing : (a.length + 1) * Jx.branchOffset;
                      });
                    } catch (t) {
                      o.error("Error while rendering gitgraph"), o.error(t.message);
                    }
                  }(i, t);
                  break;

                case "flowchart":
                  s.flowchart.arrowMarkerAbsolute = s.arrowMarkerAbsolute, Z_(s.flowchart), K_(i, t);
                  break;

                case "flowchart-v2":
                  s.flowchart.arrowMarkerAbsolute = s.arrowMarkerAbsolute, J_(s.flowchart), function (t, e) {
                    o.info("Drawing flowchart"), N_.clear(), N_.setGen("gen-2");
                    var n = O_().parser;
                    n.yy = N_, n.parse(t);
                    var r = N_.getDirection();
                    void 0 === r && (r = "TD");
                    var i,
                        a = Ev().flowchart,
                        s = a.nodeSpacing || 50,
                        c = a.rankSpacing || 50,
                        u = new (Vv().Graph)({
                      multigraph: !0,
                      compound: !0
                    }).setGraph({
                      rankdir: r,
                      nodesep: s,
                      ranksep: c,
                      marginx: 8,
                      marginy: 8
                    }).setDefaultEdgeLabel(function () {
                      return {};
                    }),
                        l = N_.getSubGraphs();
                    o.info("Subgraphs - ", l);

                    for (var h = l.length - 1; h >= 0; h--) {
                      i = l[h], o.info("Subgraph - ", i), N_.addVertex(i.id, i.title, "group", void 0, i.classes, i.dir);
                    }

                    var f = N_.getVertices(),
                        d = N_.getEdges();
                    o.info(d);
                    var p = 0;

                    for (p = l.length - 1; p >= 0; p--) {
                      i = l[p], Kc("cluster").append("text");

                      for (var y = 0; y < i.nodes.length; y++) {
                        o.info("Setting up subgraphs", i.nodes[y], i.id), u.setParent(i.nodes[y], i.id);
                      }
                    }

                    (function (t, e, n) {
                      var r = Zc('[id="'.concat(n, '"]'));
                      Object.keys(t).forEach(function (n) {
                        var i = t[n],
                            a = "default";
                        i.classes.length > 0 && (a = i.classes.join(" "));
                        var s,
                            c = rv(i.styles),
                            u = void 0 !== i.text ? i.text : i.id;

                        if (xm(Ev().flowchart.htmlLabels)) {
                          var l = {
                            label: u.replace(/fa[lrsb]?:fa-[\w-]+/g, function (t) {
                              return "<i class='".concat(t.replace(":", " "), "'></i>");
                            })
                          };
                          (s = R_()(r, l).node()).parentNode.removeChild(s);
                        } else {
                          var h = document.createElementNS("http://www.w3.org/2000/svg", "text");
                          h.setAttribute("style", c.labelStyle.replace("color:", "fill:"));

                          for (var f = u.split(wm.lineBreakRegex), d = 0; d < f.length; d++) {
                            var p = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                            p.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), p.setAttribute("dy", "1em"), p.setAttribute("x", "1"), p.textContent = f[d], h.appendChild(p);
                          }

                          s = h;
                        }

                        var y = 0,
                            g = "";

                        switch (i.type) {
                          case "round":
                            y = 5, g = "rect";
                            break;

                          case "square":
                            g = "rect";
                            break;

                          case "diamond":
                            g = "question";
                            break;

                          case "hexagon":
                            g = "hexagon";
                            break;

                          case "odd":
                            g = "rect_left_inv_arrow";
                            break;

                          case "lean_right":
                            g = "lean_right";
                            break;

                          case "lean_left":
                            g = "lean_left";
                            break;

                          case "trapezoid":
                            g = "trapezoid";
                            break;

                          case "inv_trapezoid":
                            g = "inv_trapezoid";
                            break;

                          case "odd_right":
                            g = "rect_left_inv_arrow";
                            break;

                          case "circle":
                            g = "circle";
                            break;

                          case "ellipse":
                            g = "ellipse";
                            break;

                          case "stadium":
                            g = "stadium";
                            break;

                          case "subroutine":
                            g = "subroutine";
                            break;

                          case "cylinder":
                            g = "cylinder";
                            break;

                          default:
                            g = "rect";
                        }

                        e.setNode(i.id, {
                          labelStyle: c.labelStyle,
                          shape: g,
                          labelText: u,
                          rx: y,
                          ry: y,
                          class: a,
                          style: c.style,
                          id: i.id,
                          link: i.link,
                          linkTarget: i.linkTarget,
                          tooltip: N_.getTooltip(i.id) || "",
                          domId: N_.lookUpDomId(i.id),
                          haveCallback: i.haveCallback,
                          width: "group" === i.type ? 500 : void 0,
                          dir: i.dir,
                          type: i.type,
                          padding: Ev().flowchart.padding
                        }), o.info("setNode", {
                          labelStyle: c.labelStyle,
                          shape: g,
                          labelText: u,
                          rx: y,
                          ry: y,
                          class: a,
                          style: c.style,
                          id: i.id,
                          domId: N_.lookUpDomId(i.id),
                          width: "group" === i.type ? 500 : void 0,
                          type: i.type,
                          dir: i.dir,
                          padding: Ev().flowchart.padding
                        });
                      });
                    })(f, u, e), function (t, e) {
                      o.info("abc78 edges = ", t);
                      var n,
                          r,
                          i = 0,
                          a = {};

                      if (void 0 !== t.defaultStyle) {
                        var s = rv(t.defaultStyle);
                        n = s.style, r = s.labelStyle;
                      }

                      t.forEach(function (s) {
                        i++;
                        var c = "L-" + s.start + "-" + s.end;
                        void 0 === a[c] ? (a[c] = 0, o.info("abc78 new entry", c, a[c])) : (a[c]++, o.info("abc78 new entry", c, a[c]));
                        var u = c + "-" + a[c];
                        o.info("abc78 new link id to be used is", c, u, a[c]);
                        var l = "LS-" + s.start,
                            h = "LE-" + s.end,
                            f = {
                          style: "",
                          labelStyle: ""
                        };

                        switch (f.minlen = s.length || 1, "arrow_open" === s.type ? f.arrowhead = "none" : f.arrowhead = "normal", f.arrowTypeStart = "arrow_open", f.arrowTypeEnd = "arrow_open", s.type) {
                          case "double_arrow_cross":
                            f.arrowTypeStart = "arrow_cross";

                          case "arrow_cross":
                            f.arrowTypeEnd = "arrow_cross";
                            break;

                          case "double_arrow_point":
                            f.arrowTypeStart = "arrow_point";

                          case "arrow_point":
                            f.arrowTypeEnd = "arrow_point";
                            break;

                          case "double_arrow_circle":
                            f.arrowTypeStart = "arrow_circle";

                          case "arrow_circle":
                            f.arrowTypeEnd = "arrow_circle";
                        }

                        var d = "",
                            p = "";

                        switch (s.stroke) {
                          case "normal":
                            d = "fill:none;", void 0 !== n && (d = n), void 0 !== r && (p = r), f.thickness = "normal", f.pattern = "solid";
                            break;

                          case "dotted":
                            f.thickness = "normal", f.pattern = "dotted", f.style = "fill:none;stroke-width:2px;stroke-dasharray:3;";
                            break;

                          case "thick":
                            f.thickness = "thick", f.pattern = "solid", f.style = "stroke-width: 3.5px;fill:none;";
                        }

                        if (void 0 !== s.style) {
                          var y = rv(s.style);
                          d = y.style, p = y.labelStyle;
                        }

                        f.style = f.style += d, f.labelStyle = f.labelStyle += p, void 0 !== s.interpolate ? f.curve = ev(s.interpolate, Mu) : void 0 !== t.defaultInterpolate ? f.curve = ev(t.defaultInterpolate, Mu) : f.curve = ev(Q_.curve, Mu), void 0 === s.text ? void 0 !== s.style && (f.arrowheadStyle = "fill: #333") : (f.arrowheadStyle = "fill: #333", f.labelpos = "c"), f.labelType = "text", f.label = s.text.replace(wm.lineBreakRegex, "\n"), void 0 === s.style && (f.style = f.style || "stroke: #333; stroke-width: 1.5px;fill:none;"), f.labelStyle = f.labelStyle.replace("color:", "fill:"), f.id = u, f.classes = "flowchart-link " + l + " " + h, e.setEdge(s.start, s.end, f, i);
                      });
                    }(d, u);
                    var g = Zc('[id="'.concat(e, '"]'));
                    g.attr("xmlns:xlink", "http://www.w3.org/1999/xlink");
                    var m = Zc("#" + e + " g");
                    $b(m, u, ["point", "circle", "cross"], "flowchart", e);

                    var v = a.diagramPadding,
                        b = g.node().getBBox(),
                        _ = b.width + 2 * v,
                        x = b.height + 2 * v;

                    if (o.debug("new ViewBox 0 0 ".concat(_, " ").concat(x), "translate(".concat(v - u._label.marginx, ", ").concat(v - u._label.marginy, ")")), pv(g, x, _, a.useMaxWidth), g.attr("viewBox", "0 0 ".concat(_, " ").concat(x)), g.select("g").attr("transform", "translate(".concat(v - u._label.marginx, ", ").concat(v - b.y, ")")), N_.indexNodes("subGraph" + p), !a.htmlLabels) for (var w = document.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), k = 0; k < w.length; k++) {
                      var T = w[k],
                          E = T.getBBox(),
                          C = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                      C.setAttribute("rx", 0), C.setAttribute("ry", 0), C.setAttribute("width", E.width), C.setAttribute("height", E.height), T.insertBefore(C, T.firstChild);
                    }
                    Object.keys(f).forEach(function (t) {
                      var n = f[t];

                      if (n.link) {
                        var r = Zc("#" + e + ' [id="' + t + '"]');

                        if (r) {
                          var i = document.createElementNS("http://www.w3.org/2000/svg", "a");
                          i.setAttributeNS("http://www.w3.org/2000/svg", "class", n.classes.join(" ")), i.setAttributeNS("http://www.w3.org/2000/svg", "href", n.link), i.setAttributeNS("http://www.w3.org/2000/svg", "rel", "noopener"), n.linkTarget && i.setAttributeNS("http://www.w3.org/2000/svg", "target", n.linkTarget);
                          var a = r.insert(function () {
                            return i;
                          }, ":first-child"),
                              o = r.select(".label-container");
                          o && a.append(function () {
                            return o.node();
                          });
                          var s = r.select(".label");
                          s && a.append(function () {
                            return s.node();
                          });
                        }
                      }
                    });
                  }(i, t);
                  break;

                case "sequence":
                  s.sequence.arrowMarkerAbsolute = s.arrowMarkerAbsolute, s.sequenceDiagram ? (Yk.setConf(Object.assign(s.sequence, s.sequenceDiagram)), console.error("`mermaid config.sequenceDiagram` has been renamed to `config.sequence`. Please update your mermaid config.")) : Yk.setConf(s.sequence), Yk.draw(i, t);
                  break;

                case "gantt":
                  s.gantt.arrowMarkerAbsolute = s.arrowMarkerAbsolute, s.gantt, Rx(i, t);
                  break;

                case "class":
                  s.class.arrowMarkerAbsolute = s.arrowMarkerAbsolute, cb(s.class), function (t, e) {
                    ab = {}, Gv.parser.yy.clear(), Gv.parser.parse(t), o.info("Rendering diagram " + t);
                    var n,
                        r = Zc("[id='".concat(e, "']"));
                    r.attr("xmlns:xlink", "http://www.w3.org/1999/xlink"), (n = r).append("defs").append("marker").attr("id", "extensionStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 1,7 L18,13 V 1 Z"), n.append("defs").append("marker").attr("id", "extensionEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 1,1 V 13 L18,7 Z"), n.append("defs").append("marker").attr("id", "compositionStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), n.append("defs").append("marker").attr("id", "compositionEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), n.append("defs").append("marker").attr("id", "aggregationStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), n.append("defs").append("marker").attr("id", "aggregationEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L1,7 L9,1 Z"), n.append("defs").append("marker").attr("id", "dependencyStart").attr("class", "extension").attr("refX", 0).attr("refY", 7).attr("markerWidth", 190).attr("markerHeight", 240).attr("orient", "auto").append("path").attr("d", "M 5,7 L9,13 L1,7 L9,1 Z"), n.append("defs").append("marker").attr("id", "dependencyEnd").attr("refX", 19).attr("refY", 7).attr("markerWidth", 20).attr("markerHeight", 28).attr("orient", "auto").append("path").attr("d", "M 18,7 L9,13 L14,7 L9,1 Z");
                    var i = new (Vv().Graph)({
                      multigraph: !0
                    });
                    i.setGraph({
                      isMultiGraph: !0
                    }), i.setDefaultEdgeLabel(function () {
                      return {};
                    });

                    for (var a = qv.getClasses(), s = Object.keys(a), c = 0; c < s.length; c++) {
                      var u = a[s[c]],
                          l = ib(r, u, ob);
                      ab[l.id] = l, i.setNode(l.id, l), o.info("Org height: " + l.height);
                    }

                    qv.getRelations().forEach(function (t) {
                      o.info("tjoho" + sb(t.id1) + sb(t.id2) + JSON.stringify(t)), i.setEdge(sb(t.id1), sb(t.id2), {
                        relation: t
                      }, t.title || "DEFAULT");
                    }), Hv().layout(i), i.nodes().forEach(function (t) {
                      void 0 !== t && void 0 !== i.node(t) && (o.debug("Node " + t + ": " + JSON.stringify(i.node(t))), Zc("#" + Pv(t)).attr("transform", "translate(" + (i.node(t).x - i.node(t).width / 2) + "," + (i.node(t).y - i.node(t).height / 2) + " )"));
                    }), i.edges().forEach(function (t) {
                      void 0 !== t && void 0 !== i.edge(t) && (o.debug("Edge " + t.v + " -> " + t.w + ": " + JSON.stringify(i.edge(t))), function (t, e, n, r) {
                        var i = function i(t) {
                          switch (t) {
                            case Yv.AGGREGATION:
                              return "aggregation";

                            case Yv.EXTENSION:
                              return "extension";

                            case Yv.COMPOSITION:
                              return "composition";

                            case Yv.DEPENDENCY:
                              return "dependency";
                          }
                        };

                        e.points = e.points.filter(function (t) {
                          return !Number.isNaN(t.y);
                        });
                        var a,
                            s,
                            c = e.points,
                            u = Ou().x(function (t) {
                          return t.x;
                        }).y(function (t) {
                          return t.y;
                        }).curve(Fu),
                            l = t.append("path").attr("d", u(c)).attr("id", "edge" + Zv).attr("class", "relation"),
                            h = "";
                        r.arrowMarkerAbsolute && (h = (h = (h = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), 1 == n.relation.lineType && l.attr("class", "relation dashed-line"), "none" !== n.relation.type1 && l.attr("marker-start", "url(" + h + "#" + i(n.relation.type1) + "Start)"), "none" !== n.relation.type2 && l.attr("marker-end", "url(" + h + "#" + i(n.relation.type2) + "End)");
                        var f,
                            d,
                            p,
                            y,
                            g = e.points.length,
                            m = gv.calcLabelPosition(e.points);

                        if (a = m.x, s = m.y, g % 2 != 0 && g > 1) {
                          var v = gv.calcCardinalityPosition("none" !== n.relation.type1, e.points, e.points[0]),
                              b = gv.calcCardinalityPosition("none" !== n.relation.type2, e.points, e.points[g - 1]);
                          o.debug("cardinality_1_point " + JSON.stringify(v)), o.debug("cardinality_2_point " + JSON.stringify(b)), f = v.x, d = v.y, p = b.x, y = b.y;
                        }

                        if (void 0 !== n.title) {
                          var _ = t.append("g").attr("class", "classLabel"),
                              x = _.append("text").attr("class", "label").attr("x", a).attr("y", s).attr("fill", "red").attr("text-anchor", "middle").text(n.title);

                          window.label = x;
                          var w = x.node().getBBox();

                          _.insert("rect", ":first-child").attr("class", "box").attr("x", w.x - r.padding / 2).attr("y", w.y - r.padding / 2).attr("width", w.width + r.padding).attr("height", w.height + r.padding);
                        }

                        o.info("Rendering relation " + JSON.stringify(n)), void 0 !== n.relationTitle1 && "none" !== n.relationTitle1 && t.append("g").attr("class", "cardinality").append("text").attr("class", "type1").attr("x", f).attr("y", d).attr("fill", "black").attr("font-size", "6").text(n.relationTitle1), void 0 !== n.relationTitle2 && "none" !== n.relationTitle2 && t.append("g").attr("class", "cardinality").append("text").attr("class", "type2").attr("x", p).attr("y", y).attr("fill", "black").attr("font-size", "6").text(n.relationTitle2), Zv++;
                      }(r, i.edge(t), i.edge(t).relation, ob));
                    });
                    var h = r.node().getBBox(),
                        f = h.width + 40,
                        d = h.height + 40;
                    pv(r, d, f, ob.useMaxWidth);
                    var p = "".concat(h.x - 20, " ").concat(h.y - 20, " ").concat(f, " ").concat(d);
                    o.debug("viewBox ".concat(p)), r.attr("viewBox", p);
                  }(i, t);
                  break;

                case "classDiagram":
                  s.class.arrowMarkerAbsolute = s.arrowMarkerAbsolute, function (t) {
                    Object.keys(t).forEach(function (e) {
                      Hb[e] = t[e];
                    });
                  }(s.class), function (t, e) {
                    o.info("Drawing class"), qv.clear(), Gv.parser.parse(t);
                    var n = Ev().flowchart;
                    o.info("config:", n);
                    var r = n.nodeSpacing || 50,
                        i = n.rankSpacing || 50,
                        a = new (Vv().Graph)({
                      multigraph: !0,
                      compound: !0
                    }).setGraph({
                      rankdir: qv.getDirection(),
                      nodesep: r,
                      ranksep: i,
                      marginx: 8,
                      marginy: 8
                    }).setDefaultEdgeLabel(function () {
                      return {};
                    }),
                        s = qv.getClasses(),
                        c = qv.getRelations();
                    o.info(c), function (t, e) {
                      var n = Object.keys(t);
                      o.info("keys:", n), o.info(t), n.forEach(function (n) {
                        var r = t[n],
                            i = "";
                        r.cssClasses.length > 0 && (i = i + " " + r.cssClasses.join(" "));
                        var a,
                            s = {
                          labelStyle: ""
                        },
                            c = void 0 !== r.text ? r.text : r.id;
                        r.type, a = "class_box", e.setNode(r.id, {
                          labelStyle: s.labelStyle,
                          shape: a,
                          labelText: c,
                          classData: r,
                          rx: 0,
                          ry: 0,
                          class: i,
                          style: s.style,
                          id: r.id,
                          domId: r.domId,
                          haveCallback: r.haveCallback,
                          link: r.link,
                          width: "group" === r.type ? 500 : void 0,
                          type: r.type,
                          padding: Ev().flowchart.padding
                        }), o.info("setNode", {
                          labelStyle: s.labelStyle,
                          shape: a,
                          labelText: c,
                          rx: 0,
                          ry: 0,
                          class: i,
                          style: s.style,
                          id: r.id,
                          width: "group" === r.type ? 500 : void 0,
                          type: r.type,
                          padding: Ev().flowchart.padding
                        });
                      });
                    }(s, a), function (t, e) {
                      var n = 0;
                      t.forEach(function (r) {
                        n++;
                        var i = {
                          classes: "relation"
                        };
                        i.pattern = 1 == r.relation.lineType ? "dashed" : "solid", i.id = "id" + n, "arrow_open" === r.type ? i.arrowhead = "none" : i.arrowhead = "normal", o.info(i, r), i.startLabelRight = "none" === r.relationTitle1 ? "" : r.relationTitle1, i.endLabelLeft = "none" === r.relationTitle2 ? "" : r.relationTitle2, i.arrowTypeStart = Wb(r.relation.type1), i.arrowTypeEnd = Wb(r.relation.type2);
                        var a = "",
                            s = "";

                        if (void 0 !== r.style) {
                          var c = rv(r.style);
                          a = c.style, s = c.labelStyle;
                        } else a = "fill:none";

                        i.style = a, i.labelStyle = s, void 0 !== r.interpolate ? i.curve = ev(r.interpolate, Mu) : void 0 !== t.defaultInterpolate ? i.curve = ev(t.defaultInterpolate, Mu) : i.curve = ev(Hb.curve, Mu), r.text = r.title, void 0 === r.text ? void 0 !== r.style && (i.arrowheadStyle = "fill: #333") : (i.arrowheadStyle = "fill: #333", i.labelpos = "c", Ev().flowchart.htmlLabels ? (i.labelType = "html", i.label = '<span class="edgeLabel">' + r.text + "</span>") : (i.labelType = "text", i.label = r.text.replace(wm.lineBreakRegex, "\n"), void 0 === r.style && (i.style = i.style || "stroke: #333; stroke-width: 1.5px;fill:none"), i.labelStyle = i.labelStyle.replace("color:", "fill:"))), e.setEdge(r.id1, r.id2, i, n);
                      });
                    }(c, a);
                    var u = Zc('[id="'.concat(e, '"]'));
                    u.attr("xmlns:xlink", "http://www.w3.org/1999/xlink");
                    var l = Zc("#" + e + " g");
                    $b(l, a, ["aggregation", "extension", "composition", "dependency"], "classDiagram", e);
                    var h = u.node().getBBox(),
                        f = h.width + 16,
                        d = h.height + 16;
                    if (o.debug("new ViewBox 0 0 ".concat(f, " ").concat(d), "translate(".concat(8 - a._label.marginx, ", ").concat(8 - a._label.marginy, ")")), pv(u, d, f, n.useMaxWidth), u.attr("viewBox", "0 0 ".concat(f, " ").concat(d)), u.select("g").attr("transform", "translate(".concat(8 - a._label.marginx, ", ").concat(8 - h.y, ")")), !n.htmlLabels) for (var p = document.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), y = 0; y < p.length; y++) {
                      var g = p[y],
                          m = g.getBBox(),
                          v = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                      v.setAttribute("rx", 0), v.setAttribute("ry", 0), v.setAttribute("width", m.width), v.setAttribute("height", m.height), g.insertBefore(v, g.firstChild);
                    }
                  }(i, t);
                  break;

                case "state":
                  s.class.arrowMarkerAbsolute = s.arrowMarkerAbsolute, s.state, lT(i, t);
                  break;

                case "stateDiagram":
                  s.class.arrowMarkerAbsolute = s.arrowMarkerAbsolute, mT(s.state), function (t, e) {
                    o.info("Drawing state diagram (v2)", e), nT.clear(), fT = {};
                    var n = zk().parser;
                    n.yy = nT, n.parse(t);
                    var r = nT.getDirection();
                    void 0 === r && (r = "LR");
                    var i = Ev().state,
                        a = i.nodeSpacing || 50,
                        s = i.rankSpacing || 50;
                    o.info(nT.getRootDocV2()), nT.extract(nT.getRootDocV2()), o.info(nT.getRootDocV2());
                    var c = new (Vv().Graph)({
                      multigraph: !0,
                      compound: !0
                    }).setGraph({
                      rankdir: gT(nT.getRootDocV2()),
                      nodesep: a,
                      ranksep: s,
                      marginx: 8,
                      marginy: 8
                    }).setDefaultEdgeLabel(function () {
                      return {};
                    });
                    dT(c, void 0, nT.getRootDocV2(), !0);
                    var u = Zc('[id="'.concat(e, '"]')),
                        l = Zc("#" + e + " g");
                    $b(l, c, ["barb"], "statediagram", e);
                    var h = u.node().getBBox(),
                        f = h.width + 16,
                        d = h.height + 16;
                    u.attr("class", "statediagram");
                    var p = u.node().getBBox();
                    pv(u, d, 1.75 * f, i.useMaxWidth);
                    var y = "".concat(p.x - 8, " ").concat(p.y - 8, " ").concat(f, " ").concat(d);
                    o.debug("viewBox ".concat(y)), u.attr("viewBox", y);

                    for (var g = document.querySelectorAll('[id="' + e + '"] .edgeLabel .label'), m = 0; m < g.length; m++) {
                      var v = g[m],
                          b = v.getBBox(),
                          _ = document.createElementNS("http://www.w3.org/2000/svg", "rect");

                      _.setAttribute("rx", 0), _.setAttribute("ry", 0), _.setAttribute("width", b.width), _.setAttribute("height", b.height), v.insertBefore(_, v.firstChild);
                    }
                  }(i, t);
                  break;

                case "info":
                  s.class.arrowMarkerAbsolute = s.arrowMarkerAbsolute, pw(s.class), function (t, e, n) {
                    try {
                      var r = fw().parser;
                      r.yy = lw, o.debug("Renering info diagram\n" + t), r.parse(t), o.debug("Parsed info diagram");
                      var i = Zc("#" + e);
                      i.append("g").append("text").attr("x", 100).attr("y", 40).attr("class", "version").attr("font-size", "32px").style("text-anchor", "middle").text("v 8.13.4"), i.attr("height", 100), i.attr("width", 400);
                    } catch (t) {
                      o.error("Error while rendering info diagram"), o.error(t.message);
                    }
                  }(i, t);
                  break;

                case "pie":
                  kw(i, t);
                  break;

                case "er":
                  a_(s.er), function (t, e) {
                    o.info("Drawing ER diagram"), Kb.clear();
                    var n = Jb().parser;
                    n.yy = Kb;

                    try {
                      n.parse(t);
                    } catch (t) {
                      o.debug("Parsing failed");
                    }

                    var r,
                        i = Zc("[id='".concat(e, "']"));
                    (function (t, e) {
                      var n;
                      t.append("defs").append("marker").attr("id", t_.ONLY_ONE_START).attr("refX", 0).attr("refY", 9).attr("markerWidth", 18).attr("markerHeight", 18).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M9,0 L9,18 M15,0 L15,18"), t.append("defs").append("marker").attr("id", t_.ONLY_ONE_END).attr("refX", 18).attr("refY", 9).attr("markerWidth", 18).attr("markerHeight", 18).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M3,0 L3,18 M9,0 L9,18"), (n = t.append("defs").append("marker").attr("id", t_.ZERO_OR_ONE_START).attr("refX", 0).attr("refY", 9).attr("markerWidth", 30).attr("markerHeight", 18).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 21).attr("cy", 9).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M9,0 L9,18"), (n = t.append("defs").append("marker").attr("id", t_.ZERO_OR_ONE_END).attr("refX", 30).attr("refY", 9).attr("markerWidth", 30).attr("markerHeight", 18).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 9).attr("cy", 9).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M21,0 L21,18"), t.append("defs").append("marker").attr("id", t_.ONE_OR_MORE_START).attr("refX", 18).attr("refY", 18).attr("markerWidth", 45).attr("markerHeight", 36).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M0,18 Q 18,0 36,18 Q 18,36 0,18 M42,9 L42,27"), t.append("defs").append("marker").attr("id", t_.ONE_OR_MORE_END).attr("refX", 27).attr("refY", 18).attr("markerWidth", 45).attr("markerHeight", 36).attr("orient", "auto").append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M3,9 L3,27 M9,18 Q27,0 45,18 Q27,36 9,18"), (n = t.append("defs").append("marker").attr("id", t_.ZERO_OR_MORE_START).attr("refX", 18).attr("refY", 18).attr("markerWidth", 57).attr("markerHeight", 36).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 48).attr("cy", 18).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M0,18 Q18,0 36,18 Q18,36 0,18"), (n = t.append("defs").append("marker").attr("id", t_.ZERO_OR_MORE_END).attr("refX", 39).attr("refY", 18).attr("markerWidth", 57).attr("markerHeight", 36).attr("orient", "auto")).append("circle").attr("stroke", e.stroke).attr("fill", "white").attr("cx", 9).attr("cy", 18).attr("r", 6), n.append("path").attr("stroke", e.stroke).attr("fill", "none").attr("d", "M21,18 Q39,0 57,18 Q39,36 21,18");
                    })(i, n_), r = new (Vv().Graph)({
                      multigraph: !0,
                      directed: !0,
                      compound: !1
                    }).setGraph({
                      rankdir: n_.layoutDirection,
                      marginx: 20,
                      marginy: 20,
                      nodesep: 100,
                      edgesep: 100,
                      ranksep: 100
                    }).setDefaultEdgeLabel(function () {
                      return {};
                    });

                    var a = function (t, e, n) {
                      var r;
                      return Object.keys(e).forEach(function (i) {
                        var a = t.append("g").attr("id", i);
                        r = void 0 === r ? i : r;

                        var o = "entity-" + i,
                            s = a.append("text").attr("class", "er entityLabel").attr("id", o).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "middle").attr("style", "font-family: " + Ev().fontFamily + "; font-size: " + n_.fontSize + "px").text(i),
                            c = function (t, e, n) {
                          var r = n_.entityPadding / 3,
                              i = n_.entityPadding / 3,
                              a = .85 * n_.fontSize,
                              o = e.node().getBBox(),
                              s = [],
                              c = !1,
                              u = !1,
                              l = 0,
                              h = 0,
                              f = 0,
                              d = 0,
                              p = 0,
                              y = o.height + 2 * r,
                              g = 1;
                          n.forEach(function (n) {
                            var i = "".concat(e.node().id, "-attr-").concat(g),
                                o = 0,
                                m = 0,
                                v = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-type")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Ev().fontFamily + "; font-size: " + a + "px").text(n.attributeType),
                                b = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-name")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Ev().fontFamily + "; font-size: " + a + "px").text(n.attributeName),
                                _ = {};
                            _.tn = v, _.nn = b;
                            var x = v.node().getBBox(),
                                w = b.node().getBBox();

                            if (h = Math.max(h, x.width), f = Math.max(f, w.width), o += x.width, o += w.width, m = Math.max(x.height, w.height), c || void 0 !== n.attributeKeyType) {
                              var k = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-name")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Ev().fontFamily + "; font-size: " + a + "px").text(n.attributeKeyType || "");
                              _.kn = k;
                              var T = k.node().getBBox();
                              o += T.width, d = Math.max(d, o), m = Math.max(m, T.height), c = !0;
                            }

                            if (u || void 0 !== n.attributeComment) {
                              var E = t.append("text").attr("class", "er entityLabel").attr("id", "".concat(i, "-name")).attr("x", 0).attr("y", 0).attr("dominant-baseline", "middle").attr("text-anchor", "left").attr("style", "font-family: " + Ev().fontFamily + "; font-size: " + a + "px").text(n.attributeComment || "");
                              _.cn = E;
                              var C = E.node().getBBox();
                              o += C.width, p = Math.max(o, w.width), m = Math.max(m, C.height), u = !0;
                            }

                            _.height = m, s.push(_), l = Math.max(l, o), y += m + 2 * r, g += 1;
                          });
                          var m = {
                            width: Math.max(n_.minEntityWidth, Math.max(o.width + 2 * n_.entityPadding, l + 4 * i)),
                            height: n.length > 0 ? y : Math.max(n_.minEntityHeight, o.height + 2 * n_.entityPadding)
                          },
                              v = Math.max(0, m.width - l - 4 * i);

                          if (n.length > 0) {
                            e.attr("transform", "translate(" + m.width / 2 + "," + (r + o.height / 2) + ")");
                            var b = o.height + 2 * r,
                                _ = "attributeBoxOdd";
                            s.forEach(function (e) {
                              var n = b + r + e.height / 2;
                              e.tn.attr("transform", "translate(" + i + "," + n + ")");
                              var a = t.insert("rect", "#" + e.tn.node().id).attr("class", "er ".concat(_)).attr("fill", n_.fill).attr("fill-opacity", "100%").attr("stroke", n_.stroke).attr("x", 0).attr("y", b).attr("width", 2 * h + v / 2).attr("height", e.tn.node().getBBox().height + 2 * r);
                              e.nn.attr("transform", "translate(" + (parseFloat(a.attr("width")) + i) + "," + n + ")"), t.insert("rect", "#" + e.nn.node().id).attr("class", "er ".concat(_)).attr("fill", n_.fill).attr("fill-opacity", "100%").attr("stroke", n_.stroke).attr("x", "".concat(a.attr("x") + a.attr("width"))).attr("y", b).attr("width", f + 2 * i + v / 2).attr("height", e.nn.node().getBBox().height + 2 * r), c && (e.kn.attr("transform", "translate(" + (parseFloat(a.attr("width")) + i) + "," + n + ")"), t.insert("rect", "#" + e.kn.node().id).attr("class", "er ".concat(_)).attr("fill", n_.fill).attr("fill-opacity", "100%").attr("stroke", n_.stroke).attr("x", "".concat(a.attr("x") + a.attr("width"))).attr("y", b).attr("width", d + 2 * i + v / 2).attr("height", e.kn.node().getBBox().height + 2 * r)), u && (e.cn.attr("transform", "translate(" + (parseFloat(a.attr("width")) + i) + "," + n + ")"), t.insert("rect", "#" + e.cn.node().id).attr("class", "er ".concat(_)).attr("fill", n_.fill).attr("fill-opacity", "100%").attr("stroke", n_.stroke).attr("x", "".concat(a.attr("x") + a.attr("width"))).attr("y", b).attr("width", p + 2 * i + v / 2).attr("height", e.cn.node().getBBox().height + 2 * r)), b += e.height + 2 * r, _ = "attributeBoxOdd" == _ ? "attributeBoxEven" : "attributeBoxOdd";
                            });
                          } else m.height = Math.max(n_.minEntityHeight, y), e.attr("transform", "translate(" + m.width / 2 + "," + m.height / 2 + ")");

                          return m;
                        }(a, s, e[i].attributes),
                            u = c.width,
                            l = c.height,
                            h = a.insert("rect", "#" + o).attr("class", "er entityBox").attr("fill", n_.fill).attr("fill-opacity", "100%").attr("stroke", n_.stroke).attr("x", 0).attr("y", 0).attr("width", u).attr("height", l).node().getBBox();

                        n.setNode(i, {
                          width: h.width,
                          height: h.height,
                          shape: "rect",
                          id: i
                        });
                      }), r;
                    }(i, Kb.getEntities(), r),
                        s = function (t, e) {
                      return t.forEach(function (t) {
                        e.setEdge(t.entityA, t.entityB, {
                          relationship: t
                        }, r_(t));
                      }), t;
                    }(Kb.getRelationships(), r);

                    Hv().layout(r), function (t, e) {
                      e.nodes().forEach(function (n) {
                        void 0 !== n && void 0 !== e.node(n) && t.select("#" + n).attr("transform", "translate(" + (e.node(n).x - e.node(n).width / 2) + "," + (e.node(n).y - e.node(n).height / 2) + " )");
                      });
                    }(i, r), s.forEach(function (t) {
                      !function (t, e, n, r) {
                        i_++;
                        var i = n.edge(e.entityA, e.entityB, r_(e)),
                            a = Ou().x(function (t) {
                          return t.x;
                        }).y(function (t) {
                          return t.y;
                        }).curve(Fu),
                            o = t.insert("path", "#" + r).attr("class", "er relationshipLine").attr("d", a(i.points)).attr("stroke", n_.stroke).attr("fill", "none");
                        e.relSpec.relType === Kb.Identification.NON_IDENTIFYING && o.attr("stroke-dasharray", "8,8");
                        var s = "";

                        switch (n_.arrowMarkerAbsolute && (s = (s = (s = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search).replace(/\(/g, "\\(")).replace(/\)/g, "\\)")), e.relSpec.cardA) {
                          case Kb.Cardinality.ZERO_OR_ONE:
                            o.attr("marker-end", "url(" + s + "#" + e_.ZERO_OR_ONE_END + ")");
                            break;

                          case Kb.Cardinality.ZERO_OR_MORE:
                            o.attr("marker-end", "url(" + s + "#" + e_.ZERO_OR_MORE_END + ")");
                            break;

                          case Kb.Cardinality.ONE_OR_MORE:
                            o.attr("marker-end", "url(" + s + "#" + e_.ONE_OR_MORE_END + ")");
                            break;

                          case Kb.Cardinality.ONLY_ONE:
                            o.attr("marker-end", "url(" + s + "#" + e_.ONLY_ONE_END + ")");
                        }

                        switch (e.relSpec.cardB) {
                          case Kb.Cardinality.ZERO_OR_ONE:
                            o.attr("marker-start", "url(" + s + "#" + e_.ZERO_OR_ONE_START + ")");
                            break;

                          case Kb.Cardinality.ZERO_OR_MORE:
                            o.attr("marker-start", "url(" + s + "#" + e_.ZERO_OR_MORE_START + ")");
                            break;

                          case Kb.Cardinality.ONE_OR_MORE:
                            o.attr("marker-start", "url(" + s + "#" + e_.ONE_OR_MORE_START + ")");
                            break;

                          case Kb.Cardinality.ONLY_ONE:
                            o.attr("marker-start", "url(" + s + "#" + e_.ONLY_ONE_START + ")");
                        }

                        var c = o.node().getTotalLength(),
                            u = o.node().getPointAtLength(.5 * c),
                            l = "rel" + i_,
                            h = t.append("text").attr("class", "er relationshipLabel").attr("id", l).attr("x", u.x).attr("y", u.y).attr("text-anchor", "middle").attr("dominant-baseline", "middle").attr("style", "font-family: " + Ev().fontFamily + "; font-size: " + n_.fontSize + "px").text(e.roleA).node().getBBox();
                        t.insert("rect", "#" + l).attr("class", "er relationshipLabelBox").attr("x", u.x - h.width / 2).attr("y", u.y - h.height / 2).attr("width", h.width).attr("height", h.height).attr("fill", "white").attr("fill-opacity", "85%");
                      }(i, t, r, a);
                    });
                    var c = n_.diagramPadding,
                        u = i.node().getBBox(),
                        l = u.width + 2 * c,
                        h = u.height + 2 * c;
                    pv(i, h, l, n_.useMaxWidth), i.attr("viewBox", "".concat(u.x - c, " ").concat(u.y - c, " ").concat(l, " ").concat(h));
                  }(i, t);
                  break;

                case "journey":
                  zT(s.journey), function (t, e) {
                    var n = Ev().journey;
                    ST.parser.yy.clear(), ST.parser.parse(t + "\n"), jT.init();
                    var r = Zc("#" + e);
                    r.attr("xmlns:xlink", "http://www.w3.org/1999/xlink"), r.append("defs").append("marker").attr("id", "arrowhead").attr("refX", 5).attr("refY", 2).attr("markerWidth", 6).attr("markerHeight", 4).attr("orient", "auto").append("path").attr("d", "M 0,0 V 4 L6,2 Z");
                    var i = ST.parser.yy.getTasks(),
                        a = ST.parser.yy.getTitle(),
                        o = ST.parser.yy.getActors();

                    for (var s in RT) {
                      delete RT[s];
                    }

                    var c = 0;
                    o.forEach(function (t) {
                      RT[t] = {
                        color: n.actorColours[c % n.actorColours.length],
                        position: c
                      }, c++;
                    }), function (t) {
                      var e = Ev().journey,
                          n = 60;
                      Object.keys(RT).forEach(function (r) {
                        var i = RT[r].color,
                            a = {
                          cx: 20,
                          cy: n,
                          r: 7,
                          fill: i,
                          stroke: "#000",
                          pos: RT[r].position
                        };
                        BT(t, a);
                        var o = {
                          x: 40,
                          y: n + 7,
                          fill: "#666",
                          text: r,
                          textMargin: 5 | e.boxTextMargin
                        };
                        (function (t, e) {
                          var n = e.text.replace(/<br\s*\/?>/gi, " "),
                              r = t.append("text");
                          r.attr("x", e.x), r.attr("y", e.y), r.attr("class", "legend"), r.style("text-anchor", e.anchor), void 0 !== e.class && r.attr("class", e.class);
                          var i = r.append("tspan");
                          i.attr("x", e.x + 2 * e.textMargin), i.text(n);
                        })(t, o), n += 20;
                      });
                    }(r), jT.insert(0, 0, FT, 50 * Object.keys(RT).length), function (t, e, n) {
                      for (var r = Ev().journey, i = "", a = 0 + (2 * r.height + r.diagramMarginY), o = 0, s = "#CCC", c = "black", u = 0, l = 0; l < e.length; l++) {
                        var h = e[l];

                        if (i !== h.section) {
                          s = YT[o % YT.length], u = o % YT.length, c = UT[o % UT.length];
                          var f = {
                            x: l * r.taskMargin + l * r.width + FT,
                            y: 50,
                            text: h.section,
                            fill: s,
                            num: u,
                            colour: c
                          };
                          LT(t, f, r), i = h.section, o++;
                        }

                        var d = h.people.reduce(function (t, e) {
                          return RT[e] && (t[e] = RT[e]), t;
                        }, {});
                        h.x = l * r.taskMargin + l * r.width + FT, h.y = a, h.width = r.diagramMarginX, h.height = r.diagramMarginY, h.colour = c, h.fill = s, h.num = u, h.actors = d, IT(t, h, r), jT.insert(h.x, h.y, h.x + h.width + r.taskMargin, 450);
                      }
                    }(r, i);
                    var u = jT.getBounds();
                    a && r.append("text").text(a).attr("x", FT).attr("font-size", "4ex").attr("font-weight", "bold").attr("y", 25);
                    var l = u.stopy - u.starty + 2 * n.diagramMarginY,
                        h = FT + u.stopx + 2 * n.diagramMarginX;
                    pv(r, l, h, n.useMaxWidth), r.append("line").attr("x1", FT).attr("y1", 4 * n.height).attr("x2", h - FT - 4).attr("y2", 4 * n.height).attr("stroke-width", 4).attr("stroke", "black").attr("marker-end", "url(#arrowhead)");
                    var f = a ? 70 : 0;
                    r.attr("viewBox", "".concat(u.startx, " -25 ").concat(h, " ").concat(l + f)), r.attr("preserveAspectRatio", "xMinYMin meet"), r.attr("height", l + f + 25);
                  }(i, t);
                  break;

                case "requirement":
                  Yw(s.requirement), function (t, e) {
                    Tw.parser.yy = Dw, Tw.parser.yy.clear(), Tw.parser.parse(t);
                    var n = Zc("[id='".concat(e, "']"));
                    !function (t, e) {
                      var n = t.append("defs").append("marker").attr("id", Ow.CONTAINS + "_line_ending").attr("refX", 0).attr("refY", e.line_height / 2).attr("markerWidth", e.line_height).attr("markerHeight", e.line_height).attr("orient", "auto").append("g");
                      n.append("circle").attr("cx", e.line_height / 2).attr("cy", e.line_height / 2).attr("r", e.line_height / 2).attr("fill", "none"), n.append("line").attr("x1", 0).attr("x2", e.line_height).attr("y1", e.line_height / 2).attr("y2", e.line_height / 2).attr("stroke-width", 1), n.append("line").attr("y1", 0).attr("y2", e.line_height).attr("x1", e.line_height / 2).attr("x2", e.line_height / 2).attr("stroke-width", 1), t.append("defs").append("marker").attr("id", Ow.ARROW + "_line_ending").attr("refX", e.line_height).attr("refY", .5 * e.line_height).attr("markerWidth", e.line_height).attr("markerHeight", e.line_height).attr("orient", "auto").append("path").attr("d", "M0,0\n      L".concat(e.line_height, ",").concat(e.line_height / 2, "\n      M").concat(e.line_height, ",").concat(e.line_height / 2, "\n      L0,").concat(e.line_height)).attr("stroke-width", 1);
                    }(n, Lw);
                    var r = new (Vv().Graph)({
                      multigraph: !1,
                      compound: !1,
                      directed: !0
                    }).setGraph({
                      rankdir: Lw.layoutDirection,
                      marginx: 20,
                      marginy: 20,
                      nodesep: 100,
                      edgesep: 100,
                      ranksep: 100
                    }).setDefaultEdgeLabel(function () {
                      return {};
                    }),
                        i = Dw.getRequirements(),
                        a = Dw.getElements(),
                        s = Dw.getRelationships();
                    !function (t, e, n) {
                      Object.keys(t).forEach(function (r) {
                        var i = t[r];
                        r = jw(r), o.info("Added new requirement: ", r);
                        var a = n.append("g").attr("id", r),
                            s = Rw(a, "req-" + r),
                            c = [],
                            u = Pw(a, r + "_title", ["<<".concat(i.type, ">>"), "".concat(i.name)]);
                        c.push(u.titleNode);
                        var l = Fw(a, r + "_body", ["Id: ".concat(i.id), "Text: ".concat(i.text), "Risk: ".concat(i.risk), "Verification: ".concat(i.verifyMethod)], u.y);
                        c.push(l);
                        var h = s.node().getBBox();
                        e.setNode(r, {
                          width: h.width,
                          height: h.height,
                          shape: "rect",
                          id: r
                        });
                      });
                    }(i, r, n), function (t, e, n) {
                      Object.keys(t).forEach(function (r) {
                        var i = t[r],
                            a = jw(r),
                            o = n.append("g").attr("id", a),
                            s = "element-" + a,
                            c = Rw(o, s),
                            u = [],
                            l = Pw(o, s + "_title", ["<<Element>>", "".concat(r)]);
                        u.push(l.titleNode);
                        var h = Fw(o, s + "_body", ["Type: ".concat(i.type || "Not Specified"), "Doc Ref: ".concat(i.docRef || "None")], l.y);
                        u.push(h);
                        var f = c.node().getBBox();
                        e.setNode(a, {
                          width: f.width,
                          height: f.height,
                          shape: "rect",
                          id: a
                        });
                      });
                    }(a, r, n), function (t, e) {
                      t.forEach(function (t) {
                        var n = jw(t.src),
                            r = jw(t.dst);
                        e.setEdge(n, r, {
                          relationship: t
                        });
                      });
                    }(s, r), Hv().layout(r), function (t, e) {
                      e.nodes().forEach(function (n) {
                        void 0 !== n && void 0 !== e.node(n) && (t.select("#" + n), t.select("#" + n).attr("transform", "translate(" + (e.node(n).x - e.node(n).width / 2) + "," + (e.node(n).y - e.node(n).height / 2) + " )"));
                      });
                    }(n, r), s.forEach(function (t) {
                      !function (t, e, n, r) {
                        var i = n.edge(jw(e.src), jw(e.dst)),
                            a = Ou().x(function (t) {
                          return t.x;
                        }).y(function (t) {
                          return t.y;
                        }),
                            o = t.insert("path", "#" + r).attr("class", "er relationshipLine").attr("d", a(i.points)).attr("fill", "none");
                        e.type == Dw.Relationships.CONTAINS ? o.attr("marker-start", "url(" + wm.getUrl(Lw.arrowMarkerAbsolute) + "#" + e.type + "_line_ending)") : (o.attr("stroke-dasharray", "10,7"), o.attr("marker-end", "url(" + wm.getUrl(Lw.arrowMarkerAbsolute) + "#" + Bw.ARROW + "_line_ending)")), function (t, e, n, r) {
                          var i = e.node().getTotalLength(),
                              a = e.node().getPointAtLength(.5 * i),
                              o = "rel" + Iw;
                          Iw++;
                          var s = t.append("text").attr("class", "req relationshipLabel").attr("id", o).attr("x", a.x).attr("y", a.y).attr("text-anchor", "middle").attr("dominant-baseline", "middle").text(r).node().getBBox();
                          t.insert("rect", "#" + o).attr("class", "req reqLabelBox").attr("x", a.x - s.width / 2).attr("y", a.y - s.height / 2).attr("width", s.width).attr("height", s.height).attr("fill", "white").attr("fill-opacity", "85%");
                        }(t, o, 0, "<<".concat(e.type, ">>"));
                      }(n, t, r, e);
                    });
                    var c = Lw.rect_padding,
                        u = n.node().getBBox(),
                        l = u.width + 2 * c,
                        h = u.height + 2 * c;
                    pv(n, h, l, Lw.useMaxWidth), n.attr("viewBox", "".concat(u.x - c, " ").concat(u.y - c, " ").concat(l, " ").concat(h));
                  }(i, t);
              }
            } catch (e) {
              throw function (t, e) {
                try {
                  o.debug("Renering svg for syntax error\n");
                  var n = Zc("#" + t),
                      r = n.append("g");
                  r.append("path").attr("class", "error-icon").attr("d", "m411.313,123.313c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32-9.375,9.375-20.688-20.688c-12.484-12.5-32.766-12.5-45.25,0l-16,16c-1.261,1.261-2.304,2.648-3.31,4.051-21.739-8.561-45.324-13.426-70.065-13.426-105.867,0-192,86.133-192,192s86.133,192 192,192 192-86.133 192-192c0-24.741-4.864-48.327-13.426-70.065 1.402-1.007 2.79-2.049 4.051-3.31l16-16c12.5-12.492 12.5-32.758 0-45.25l-20.688-20.688 9.375-9.375 32.001-31.999zm-219.313,100.687c-52.938,0-96,43.063-96,96 0,8.836-7.164,16-16,16s-16-7.164-16-16c0-70.578 57.422-128 128-128 8.836,0 16,7.164 16,16s-7.164,16-16,16z"), r.append("path").attr("class", "error-icon").attr("d", "m459.02,148.98c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l16,16c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16.001-16z"), r.append("path").attr("class", "error-icon").attr("d", "m340.395,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688 6.25-6.25 6.25-16.375 0-22.625l-16-16c-6.25-6.25-16.375-6.25-22.625,0s-6.25,16.375 0,22.625l15.999,16z"), r.append("path").attr("class", "error-icon").attr("d", "m400,64c8.844,0 16-7.164 16-16v-32c0-8.836-7.156-16-16-16-8.844,0-16,7.164-16,16v32c0,8.836 7.156,16 16,16z"), r.append("path").attr("class", "error-icon").attr("d", "m496,96.586h-32c-8.844,0-16,7.164-16,16 0,8.836 7.156,16 16,16h32c8.844,0 16-7.164 16-16 0-8.836-7.156-16-16-16z"), r.append("path").attr("class", "error-icon").attr("d", "m436.98,75.605c3.125,3.125 7.219,4.688 11.313,4.688 4.094,0 8.188-1.563 11.313-4.688l32-32c6.25-6.25 6.25-16.375 0-22.625s-16.375-6.25-22.625,0l-32,32c-6.251,6.25-6.251,16.375-0.001,22.625z"), r.append("text").attr("class", "error-text").attr("x", 1240).attr("y", 250).attr("font-size", "150px").style("text-anchor", "middle").text("Syntax error in graph"), r.append("text").attr("class", "error-text").attr("x", 1050).attr("y", 400).attr("font-size", "100px").style("text-anchor", "middle").text("mermaid version 8.13.4"), n.attr("height", 100), n.attr("width", 400), n.attr("viewBox", "768 0 512 512");
                } catch (t) {
                  o.error("Error while rendering info diagram"), o.error(t.message);
                }
              }(t), e;
            }

            Zc('[id="'.concat(t, '"]')).selectAll("foreignobject > *").attr("xmlns", "http://www.w3.org/1999/xhtml");
            var _ = Zc("#d" + t).node().innerHTML;
            if (o.debug("cnf.arrowMarkerAbsolute", s.arrowMarkerAbsolute), s.arrowMarkerAbsolute && "false" !== s.arrowMarkerAbsolute || (_ = _.replace(/marker-end="url\(.*?#/g, 'marker-end="url(#', "g")), _ = (_ = XT(_)).replace(/<br>/g, "<br/>"), void 0 !== n) switch (h) {
              case "flowchart":
              case "flowchart-v2":
                n(_, N_.bindFunctions);
                break;

              case "gantt":
                n(_, Dx.bindFunctions);
                break;

              case "class":
              case "classDiagram":
                n(_, qv.bindFunctions);
                break;

              default:
                n(_);
            } else o.debug("CB = undefined!");
            hk.forEach(function (t) {
              t();
            }), hk = [];
            var x = Zc("#d" + t).node();
            return null !== x && "function" == typeof x.remove && Zc("#d" + t).node().remove(), _;
          },
          parse: function parse(t) {
            var e = Ev(),
                n = gv.detectInit(t, e);
            n && o.debug("reinit ", n);
            var r,
                i = gv.detectType(t, e);

            switch (o.debug("Type " + i), i) {
              case "git":
                (r = Kx()).parser.yy = Gx;
                break;

              case "flowchart":
              case "flowchart-v2":
                N_.clear(), (r = O_()).parser.yy = N_;
                break;

              case "sequence":
                (r = zw()).parser.yy = lk;
                break;

              case "gantt":
                (r = Ix()).parser.yy = Dx;
                break;

              case "class":
              case "classDiagram":
                (r = Xv()).parser.yy = qv;
                break;

              case "state":
              case "stateDiagram":
                (r = zk()).parser.yy = nT;
                break;

              case "info":
                o.debug("info info info"), (r = fw()).parser.yy = lw;
                break;

              case "pie":
                o.debug("pie"), (r = gw()).parser.yy = _w;
                break;

              case "er":
                o.debug("er"), (r = Jb()).parser.yy = Kb;
                break;

              case "journey":
                o.debug("Journey"), (r = AT()).parser.yy = CT;
                break;

              case "requirement":
              case "requirementDiagram":
                o.debug("RequirementDiagram"), (r = Ew()).parser.yy = Dw;
            }

            return r.parser.yy.graphType = i, r.parser.yy.parseError = function (t, e) {
              throw {
                str: t,
                hash: e
              };
            }, r.parse(t), r;
          },
          parseDirective: function parseDirective(t, e, n, r) {
            try {
              if (void 0 !== e) switch (e = e.trim(), n) {
                case "open_directive":
                  ZT = {};
                  break;

                case "type_directive":
                  ZT.type = e.toLowerCase();
                  break;

                case "arg_directive":
                  ZT.args = JSON.parse(e);
                  break;

                case "close_directive":
                  (function (t, e, n) {
                    switch (o.debug("Directive type=".concat(e.type, " with args:"), e.args), e.type) {
                      case "init":
                      case "initialize":
                        ["config"].forEach(function (t) {
                          void 0 !== e.args[t] && ("flowchart-v2" === n && (n = "flowchart"), e.args[n] = e.args[t], delete e.args[t]);
                        }), o.debug("sanitize in handleDirective", e.args), yv(e.args), o.debug("sanitize in handleDirective (done)", e.args), e.args, Sv(e.args);
                        break;

                      case "wrap":
                      case "nowrap":
                        t && t.setWrap && t.setWrap("wrap" === e.type);
                        break;

                      default:
                        o.warn("Unhandled directive: source: '%%{".concat(e.type, ": ").concat(JSON.stringify(e.args ? e.args : {}), "}%%"), e);
                    }
                  })(t, ZT, r), ZT = null;
              }
            } catch (t) {
              o.error("Error while rendering sequenceDiagram directive: ".concat(e, " jison context: ").concat(n)), o.error(t.message);
            }
          },
          initialize: function initialize(t) {
            t && t.fontFamily && (t.themeVariables && t.themeVariables.fontFamily || (t.themeVariables = {
              fontFamily: t.fontFamily
            })), function (t) {
              vv = sv({}, t);
            }(t), t && t.theme && Im[t.theme] ? t.themeVariables = Im[t.theme].getThemeVariables(t.themeVariables) : t && (t.themeVariables = Im.default.getThemeVariables(t.themeVariables));
            var e = "object" === GT(t) ? function (t) {
              return _v = sv({}, bv), _v = sv(_v, t), t.theme && (_v.themeVariables = Im[t.theme].getThemeVariables(t.themeVariables)), wv = kv(_v, xv), _v;
            }(t) : Tv();
            KT(e), s(e.logLevel);
          },
          reinitialize: function reinitialize() {},
          getConfig: Ev,
          setConfig: function setConfig(t) {
            return sv(wv, t), Ev();
          },
          getSiteConfig: Tv,
          updateSiteConfig: function updateSiteConfig(t) {
            return _v = sv(_v, t), kv(_v, xv), _v;
          },
          reset: function reset() {
            Av();
          },
          globalReset: function globalReset() {
            Av(), KT(Ev());
          },
          defaultConfig: bv
        });
        s(Ev().logLevel), Av(Ev());
        var JT = QT;

        var tE = function tE() {
          eE.startOnLoad ? JT.getConfig().startOnLoad && eE.init() : void 0 === eE.startOnLoad && (o.debug("In start, no config"), JT.getConfig().startOnLoad && eE.init());
        };

        "undefined" != typeof document && window.addEventListener("load", function () {
          tE();
        }, !1);
        var eE = {
          startOnLoad: !0,
          htmlLabels: !0,
          mermaidAPI: JT,
          parse: JT.parse,
          render: JT.render,
          init: function init() {
            var t,
                e,
                n = this,
                r = JT.getConfig();
            arguments.length >= 2 ? (void 0 !== arguments[0] && (eE.sequenceConfig = arguments[0]), t = arguments[1]) : t = arguments[0], "function" == typeof arguments[arguments.length - 1] ? (e = arguments[arguments.length - 1], o.debug("Callback function found")) : void 0 !== r.mermaid && ("function" == typeof r.mermaid.callback ? (e = r.mermaid.callback, o.debug("Callback function found")) : o.debug("No Callback function found")), t = void 0 === t ? document.querySelectorAll(".mermaid") : "string" == typeof t ? document.querySelectorAll(t) : t instanceof window.Node ? [t] : t, o.debug("Start On Load before: " + eE.startOnLoad), void 0 !== eE.startOnLoad && (o.debug("Start On Load inner: " + eE.startOnLoad), JT.updateSiteConfig({
              startOnLoad: eE.startOnLoad
            })), void 0 !== eE.ganttConfig && JT.updateSiteConfig({
              gantt: eE.ganttConfig
            });

            for (var i, a = new gv.initIdGeneratior(r.deterministicIds, r.deterministicIDSeed), s = function s(r) {
              var s = t[r];
              if (s.getAttribute("data-processed")) return "continue";
              s.setAttribute("data-processed", !0);
              var c = "mermaid-".concat(a.next());
              i = s.innerHTML, i = gv.entityDecode(i).trim().replace(/<br\s*\/?>/gi, "<br/>");
              var u = gv.detectInit(i);
              u && o.debug("Detected early reinit: ", u);

              try {
                JT.render(c, i, function (t, n) {
                  s.innerHTML = t, void 0 !== e && e(c), n && n(s);
                }, s);
              } catch (t) {
                o.warn("Syntax Error rendering"), o.warn(t), n.parseError && n.parseError(t);
              }
            }, c = 0; c < t.length; c++) {
              s(c);
            }
          },
          initialize: function initialize(t) {
            void 0 !== t.mermaid && (void 0 !== t.mermaid.startOnLoad && (eE.startOnLoad = t.mermaid.startOnLoad), void 0 !== t.mermaid.htmlLabels && (eE.htmlLabels = "false" !== t.mermaid.htmlLabels && !1 !== t.mermaid.htmlLabels)), JT.initialize(t);
          },
          contentLoaded: tE
        };
        var nE = eE;
      },
      4949: function _(t, e, n) {
        t.exports = {
          graphlib: n(6614),
          dagre: n(1463),
          intersect: n(8114),
          render: n(5787),
          util: n(8355),
          version: n(5689)
        };
      },
      9144: function _(t, e, n) {
        var r = n(8355);

        function i(t, e, n, i) {
          var a = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 z").style("stroke-width", 1).style("stroke-dasharray", "1,0");
          r.applyStyle(a, n[i + "Style"]), n[i + "Class"] && a.attr("class", n[i + "Class"]);
        }

        t.exports = {
          default: i,
          normal: i,
          vee: function vee(t, e, n, i) {
            var a = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 0 L 10 5 L 0 10 L 4 5 z").style("stroke-width", 1).style("stroke-dasharray", "1,0");
            r.applyStyle(a, n[i + "Style"]), n[i + "Class"] && a.attr("class", n[i + "Class"]);
          },
          undirected: function undirected(t, e, n, i) {
            var a = t.append("marker").attr("id", e).attr("viewBox", "0 0 10 10").attr("refX", 9).attr("refY", 5).attr("markerUnits", "strokeWidth").attr("markerWidth", 8).attr("markerHeight", 6).attr("orient", "auto").append("path").attr("d", "M 0 5 L 10 5").style("stroke-width", 1).style("stroke-dasharray", "1,0");
            r.applyStyle(a, n[i + "Style"]), n[i + "Class"] && a.attr("class", n[i + "Class"]);
          }
        };
      },
      5632: function _(t, e, n) {
        var r = n(8355),
            i = n(4322),
            a = n(1322);

        t.exports = function (t, e) {
          var n,
              o = e.nodes().filter(function (t) {
            return r.isSubgraph(e, t);
          }),
              s = t.selectAll("g.cluster").data(o, function (t) {
            return t;
          });
          return s.selectAll("*").remove(), s.enter().append("g").attr("class", "cluster").attr("id", function (t) {
            return e.node(t).id;
          }).style("opacity", 0), s = t.selectAll("g.cluster"), r.applyTransition(s, e).style("opacity", 1), s.each(function (t) {
            var n = e.node(t),
                r = i.select(this);
            i.select(this).append("rect");
            var o = r.append("g").attr("class", "label");
            a(o, n, n.clusterLabelPos);
          }), s.selectAll("rect").each(function (t) {
            var n = e.node(t),
                a = i.select(this);
            r.applyStyle(a, n.style);
          }), n = s.exit ? s.exit() : s.selectAll(null), r.applyTransition(n, e).style("opacity", 0).remove(), s;
        };
      },
      6315: function _(t, e, n) {
        var r = n(1034),
            i = n(1322),
            a = n(8355),
            o = n(4322);

        t.exports = function (t, e) {
          var n,
              s = t.selectAll("g.edgeLabel").data(e.edges(), function (t) {
            return a.edgeToId(t);
          }).classed("update", !0);
          return s.exit().remove(), s.enter().append("g").classed("edgeLabel", !0).style("opacity", 0), (s = t.selectAll("g.edgeLabel")).each(function (t) {
            var n = o.select(this);
            n.select(".label").remove();
            var a = e.edge(t),
                s = i(n, e.edge(t), 0, 0).classed("label", !0),
                c = s.node().getBBox();
            a.labelId && s.attr("id", a.labelId), r.has(a, "width") || (a.width = c.width), r.has(a, "height") || (a.height = c.height);
          }), n = s.exit ? s.exit() : s.selectAll(null), a.applyTransition(n, e).style("opacity", 0).remove(), s;
        };
      },
      940: function _(t, e, n) {
        var r = n(1034),
            i = n(7584),
            a = n(8355),
            o = n(4322);

        function s(t, e) {
          var n = (o.line || o.svg.line)().x(function (t) {
            return t.x;
          }).y(function (t) {
            return t.y;
          });
          return (n.curve || n.interpolate)(t.curve), n(e);
        }

        t.exports = function (t, e, n) {
          var c = t.selectAll("g.edgePath").data(e.edges(), function (t) {
            return a.edgeToId(t);
          }).classed("update", !0),
              u = function (t, e) {
            var n = t.enter().append("g").attr("class", "edgePath").style("opacity", 0);
            return n.append("path").attr("class", "path").attr("d", function (t) {
              var n = e.edge(t),
                  i = e.node(t.v).elem;
              return s(n, r.range(n.points.length).map(function () {
                return e = (t = i).getBBox(), {
                  x: (n = t.ownerSVGElement.getScreenCTM().inverse().multiply(t.getScreenCTM()).translate(e.width / 2, e.height / 2)).e,
                  y: n.f
                };
                var t, e, n;
              }));
            }), n.append("defs"), n;
          }(c, e);

          !function (t, e) {
            var n = t.exit();
            a.applyTransition(n, e).style("opacity", 0).remove();
          }(c, e);
          var l = void 0 !== c.merge ? c.merge(u) : c;
          return a.applyTransition(l, e).style("opacity", 1), l.each(function (t) {
            var n = o.select(this),
                r = e.edge(t);
            r.elem = this, r.id && n.attr("id", r.id), a.applyClass(n, r.class, (n.classed("update") ? "update " : "") + "edgePath");
          }), l.selectAll("path.path").each(function (t) {
            var n = e.edge(t);
            n.arrowheadId = r.uniqueId("arrowhead");
            var c = o.select(this).attr("marker-end", function () {
              return "url(" + (t = location.href, e = n.arrowheadId, t.split("#")[0] + "#" + e + ")");
              var t, e;
            }).style("fill", "none");
            a.applyTransition(c, e).attr("d", function (t) {
              return function (t, e) {
                var n = t.edge(e),
                    r = t.node(e.v),
                    a = t.node(e.w),
                    o = n.points.slice(1, n.points.length - 1);
                return o.unshift(i(r, o[0])), o.push(i(a, o[o.length - 1])), s(n, o);
              }(e, t);
            }), a.applyStyle(c, n.style);
          }), l.selectAll("defs *").remove(), l.selectAll("defs").each(function (t) {
            var r = e.edge(t);
            (0, n[r.arrowhead])(o.select(this), r.arrowheadId, r, "arrowhead");
          }), l;
        };
      },
      607: function _(t, e, n) {
        var r = n(1034),
            i = n(1322),
            a = n(8355),
            o = n(4322);

        t.exports = function (t, e, n) {
          var s,
              c = e.nodes().filter(function (t) {
            return !a.isSubgraph(e, t);
          }),
              u = t.selectAll("g.node").data(c, function (t) {
            return t;
          }).classed("update", !0);
          return u.exit().remove(), u.enter().append("g").attr("class", "node").style("opacity", 0), (u = t.selectAll("g.node")).each(function (t) {
            var s = e.node(t),
                c = o.select(this);
            a.applyClass(c, s.class, (c.classed("update") ? "update " : "") + "node"), c.select("g.label").remove();
            var u = c.append("g").attr("class", "label"),
                l = i(u, s),
                h = n[s.shape],
                f = r.pick(l.node().getBBox(), "width", "height");
            s.elem = this, s.id && c.attr("id", s.id), s.labelId && u.attr("id", s.labelId), r.has(s, "width") && (f.width = s.width), r.has(s, "height") && (f.height = s.height), f.width += s.paddingLeft + s.paddingRight, f.height += s.paddingTop + s.paddingBottom, u.attr("transform", "translate(" + (s.paddingLeft - s.paddingRight) / 2 + "," + (s.paddingTop - s.paddingBottom) / 2 + ")");
            var d = o.select(this);
            d.select(".label-container").remove();
            var p = h(d, f, s).classed("label-container", !0);
            a.applyStyle(p, s.style);
            var y = p.node().getBBox();
            s.width = y.width, s.height = y.height;
          }), s = u.exit ? u.exit() : u.selectAll(null), a.applyTransition(s, e).style("opacity", 0).remove(), u;
        };
      },
      4322: function _(t, e, n) {
        var r;
        if (!r) try {
          r = n(7188);
        } catch (t) {}
        r || (r = window.d3), t.exports = r;
      },
      1463: function _(t, e, n) {
        var r;

        try {
          r = n(681);
        } catch (t) {}

        r || (r = window.dagre), t.exports = r;
      },
      6614: function _(t, e, n) {
        var r;

        try {
          r = n(8282);
        } catch (t) {}

        r || (r = window.graphlib), t.exports = r;
      },
      8114: function _(t, e, n) {
        t.exports = {
          node: n(7584),
          circle: n(6587),
          ellipse: n(3260),
          polygon: n(5337),
          rect: n(8049)
        };
      },
      6587: function _(t, e, n) {
        var r = n(3260);

        t.exports = function (t, e, n) {
          return r(t, e, e, n);
        };
      },
      3260: function _(t) {
        t.exports = function (t, e, n, r) {
          var i = t.x,
              a = t.y,
              o = i - r.x,
              s = a - r.y,
              c = Math.sqrt(e * e * s * s + n * n * o * o),
              u = Math.abs(e * n * o / c);
          r.x < i && (u = -u);
          var l = Math.abs(e * n * s / c);
          return r.y < a && (l = -l), {
            x: i + u,
            y: a + l
          };
        };
      },
      6808: function _(t) {
        function e(t, e) {
          return t * e > 0;
        }

        t.exports = function (t, n, r, i) {
          var a, o, s, c, u, l, h, f, d, p, y, g, m;
          if (a = n.y - t.y, s = t.x - n.x, u = n.x * t.y - t.x * n.y, d = a * r.x + s * r.y + u, p = a * i.x + s * i.y + u, !(0 !== d && 0 !== p && e(d, p) || (o = i.y - r.y, c = r.x - i.x, l = i.x * r.y - r.x * i.y, h = o * t.x + c * t.y + l, f = o * n.x + c * n.y + l, 0 !== h && 0 !== f && e(h, f) || 0 == (y = a * c - o * s)))) return g = Math.abs(y / 2), {
            x: (m = s * l - c * u) < 0 ? (m - g) / y : (m + g) / y,
            y: (m = o * u - a * l) < 0 ? (m - g) / y : (m + g) / y
          };
        };
      },
      7584: function _(t) {
        t.exports = function (t, e) {
          return t.intersect(e);
        };
      },
      5337: function _(t, e, n) {
        var r = n(6808);

        t.exports = function (t, e, n) {
          var i = t.x,
              a = t.y,
              o = [],
              s = Number.POSITIVE_INFINITY,
              c = Number.POSITIVE_INFINITY;
          e.forEach(function (t) {
            s = Math.min(s, t.x), c = Math.min(c, t.y);
          });

          for (var u = i - t.width / 2 - s, l = a - t.height / 2 - c, h = 0; h < e.length; h++) {
            var f = e[h],
                d = e[h < e.length - 1 ? h + 1 : 0],
                p = r(t, n, {
              x: u + f.x,
              y: l + f.y
            }, {
              x: u + d.x,
              y: l + d.y
            });
            p && o.push(p);
          }

          return o.length ? (o.length > 1 && o.sort(function (t, e) {
            var r = t.x - n.x,
                i = t.y - n.y,
                a = Math.sqrt(r * r + i * i),
                o = e.x - n.x,
                s = e.y - n.y,
                c = Math.sqrt(o * o + s * s);
            return a < c ? -1 : a === c ? 0 : 1;
          }), o[0]) : (console.log("NO INTERSECTION FOUND, RETURN NODE CENTER", t), t);
        };
      },
      8049: function _(t) {
        t.exports = function (t, e) {
          var n,
              r,
              i = t.x,
              a = t.y,
              o = e.x - i,
              s = e.y - a,
              c = t.width / 2,
              u = t.height / 2;
          return Math.abs(s) * c > Math.abs(o) * u ? (s < 0 && (u = -u), n = 0 === s ? 0 : u * o / s, r = u) : (o < 0 && (c = -c), n = c, r = 0 === o ? 0 : c * s / o), {
            x: i + n,
            y: a + r
          };
        };
      },
      8284: function _(t, e, n) {
        var r = n(8355);

        t.exports = function (t, e) {
          var n = t.append("foreignObject").attr("width", "100000"),
              i = n.append("xhtml:div");
          i.attr("xmlns", "http://www.w3.org/1999/xhtml");
          var a = e.label;

          switch (typeof a) {
            case "function":
              i.insert(a);
              break;

            case "object":
              i.insert(function () {
                return a;
              });
              break;

            default:
              i.html(a);
          }

          r.applyStyle(i, e.labelStyle), i.style("display", "inline-block"), i.style("white-space", "nowrap");
          var o = i.node().getBoundingClientRect();
          return n.attr("width", o.width).attr("height", o.height), n;
        };
      },
      1322: function _(t, e, n) {
        var r = n(7318),
            i = n(8284),
            a = n(8287);

        t.exports = function (t, e, n) {
          var o = e.label,
              s = t.append("g");
          "svg" === e.labelType ? a(s, e) : "string" != typeof o || "html" === e.labelType ? i(s, e) : r(s, e);
          var c,
              u = s.node().getBBox();

          switch (n) {
            case "top":
              c = -e.height / 2;
              break;

            case "bottom":
              c = e.height / 2 - u.height;
              break;

            default:
              c = -u.height / 2;
          }

          return s.attr("transform", "translate(" + -u.width / 2 + "," + c + ")"), s;
        };
      },
      8287: function _(t, e, n) {
        var r = n(8355);

        t.exports = function (t, e) {
          var n = t;
          return n.node().appendChild(e.label), r.applyStyle(n, e.labelStyle), n;
        };
      },
      7318: function _(t, e, n) {
        var r = n(8355);

        t.exports = function (t, e) {
          for (var n = t.append("text"), i = function (t) {
            for (var e, n = "", r = !1, i = 0; i < t.length; ++i) {
              e = t[i], r ? (n += "n" === e ? "\n" : e, r = !1) : "\\" === e ? r = !0 : n += e;
            }

            return n;
          }(e.label).split("\n"), a = 0; a < i.length; a++) {
            n.append("tspan").attr("xml:space", "preserve").attr("dy", "1em").attr("x", "1").text(i[a]);
          }

          return r.applyStyle(n, e.labelStyle), n;
        };
      },
      1034: function _(t, e, n) {
        var r;

        try {
          r = {
            defaults: n(1747),
            each: n(6073),
            isFunction: n(3560),
            isPlainObject: n(8630),
            pick: n(9722),
            has: n(8721),
            range: n(6026),
            uniqueId: n(3955)
          };
        } catch (t) {}

        r || (r = window._), t.exports = r;
      },
      6381: function _(t, e, n) {
        var r = n(8355),
            i = n(4322);

        t.exports = function (t, e) {
          var n = t.filter(function () {
            return !i.select(this).classed("update");
          });

          function a(t) {
            var n = e.node(t);
            return "translate(" + n.x + "," + n.y + ")";
          }

          n.attr("transform", a), r.applyTransition(t, e).style("opacity", 1).attr("transform", a), r.applyTransition(n.selectAll("rect"), e).attr("width", function (t) {
            return e.node(t).width;
          }).attr("height", function (t) {
            return e.node(t).height;
          }).attr("x", function (t) {
            return -e.node(t).width / 2;
          }).attr("y", function (t) {
            return -e.node(t).height / 2;
          });
        };
      },
      4577: function _(t, e, n) {
        var r = n(8355),
            i = n(4322),
            a = n(1034);

        t.exports = function (t, e) {
          function n(t) {
            var n = e.edge(t);
            return a.has(n, "x") ? "translate(" + n.x + "," + n.y + ")" : "";
          }

          t.filter(function () {
            return !i.select(this).classed("update");
          }).attr("transform", n), r.applyTransition(t, e).style("opacity", 1).attr("transform", n);
        };
      },
      4849: function _(t, e, n) {
        var r = n(8355),
            i = n(4322);

        t.exports = function (t, e) {
          function n(t) {
            var n = e.node(t);
            return "translate(" + n.x + "," + n.y + ")";
          }

          t.filter(function () {
            return !i.select(this).classed("update");
          }).attr("transform", n), r.applyTransition(t, e).style("opacity", 1).attr("transform", n);
        };
      },
      5787: function _(t, e, n) {
        var r = n(1034),
            i = n(4322),
            a = n(1463).layout;

        t.exports = function () {
          var t = n(607),
              e = n(5632),
              i = n(6315),
              u = n(940),
              l = n(4849),
              h = n(4577),
              f = n(6381),
              d = n(4418),
              p = n(9144),
              y = function y(n, _y2) {
            !function (t) {
              t.nodes().forEach(function (e) {
                var n = t.node(e);
                r.has(n, "label") || t.children(e).length || (n.label = e), r.has(n, "paddingX") && r.defaults(n, {
                  paddingLeft: n.paddingX,
                  paddingRight: n.paddingX
                }), r.has(n, "paddingY") && r.defaults(n, {
                  paddingTop: n.paddingY,
                  paddingBottom: n.paddingY
                }), r.has(n, "padding") && r.defaults(n, {
                  paddingLeft: n.padding,
                  paddingRight: n.padding,
                  paddingTop: n.padding,
                  paddingBottom: n.padding
                }), r.defaults(n, o), r.each(["paddingLeft", "paddingRight", "paddingTop", "paddingBottom"], function (t) {
                  n[t] = Number(n[t]);
                }), r.has(n, "width") && (n._prevWidth = n.width), r.has(n, "height") && (n._prevHeight = n.height);
              }), t.edges().forEach(function (e) {
                var n = t.edge(e);
                r.has(n, "label") || (n.label = ""), r.defaults(n, s);
              });
            }(_y2);

            var g = c(n, "output"),
                m = c(g, "clusters"),
                v = c(g, "edgePaths"),
                b = i(c(g, "edgeLabels"), _y2),
                _ = t(c(g, "nodes"), _y2, d);

            a(_y2), l(_, _y2), h(b, _y2), u(v, _y2, p);
            var x = e(m, _y2);
            f(x, _y2), function (t) {
              r.each(t.nodes(), function (e) {
                var n = t.node(e);
                r.has(n, "_prevWidth") ? n.width = n._prevWidth : delete n.width, r.has(n, "_prevHeight") ? n.height = n._prevHeight : delete n.height, delete n._prevWidth, delete n._prevHeight;
              });
            }(_y2);
          };

          return y.createNodes = function (e) {
            return arguments.length ? (t = e, y) : t;
          }, y.createClusters = function (t) {
            return arguments.length ? (e = t, y) : e;
          }, y.createEdgeLabels = function (t) {
            return arguments.length ? (i = t, y) : i;
          }, y.createEdgePaths = function (t) {
            return arguments.length ? (u = t, y) : u;
          }, y.shapes = function (t) {
            return arguments.length ? (d = t, y) : d;
          }, y.arrows = function (t) {
            return arguments.length ? (p = t, y) : p;
          }, y;
        };

        var o = {
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 10,
          paddingBottom: 10,
          rx: 0,
          ry: 0,
          shape: "rect"
        },
            s = {
          arrowhead: "normal",
          curve: i.curveLinear
        };

        function c(t, e) {
          var n = t.select("g." + e);
          return n.empty() && (n = t.append("g").attr("class", e)), n;
        }
      },
      4418: function _(t, e, n) {
        var r = n(8049),
            i = n(3260),
            a = n(6587),
            o = n(5337);
        t.exports = {
          rect: function rect(t, e, n) {
            var i = t.insert("rect", ":first-child").attr("rx", n.rx).attr("ry", n.ry).attr("x", -e.width / 2).attr("y", -e.height / 2).attr("width", e.width).attr("height", e.height);
            return n.intersect = function (t) {
              return r(n, t);
            }, i;
          },
          ellipse: function ellipse(t, e, n) {
            var r = e.width / 2,
                a = e.height / 2,
                o = t.insert("ellipse", ":first-child").attr("x", -e.width / 2).attr("y", -e.height / 2).attr("rx", r).attr("ry", a);
            return n.intersect = function (t) {
              return i(n, r, a, t);
            }, o;
          },
          circle: function circle(t, e, n) {
            var r = Math.max(e.width, e.height) / 2,
                i = t.insert("circle", ":first-child").attr("x", -e.width / 2).attr("y", -e.height / 2).attr("r", r);
            return n.intersect = function (t) {
              return a(n, r, t);
            }, i;
          },
          diamond: function diamond(t, e, n) {
            var r = e.width * Math.SQRT2 / 2,
                i = e.height * Math.SQRT2 / 2,
                a = [{
              x: 0,
              y: -i
            }, {
              x: -r,
              y: 0
            }, {
              x: 0,
              y: i
            }, {
              x: r,
              y: 0
            }],
                s = t.insert("polygon", ":first-child").attr("points", a.map(function (t) {
              return t.x + "," + t.y;
            }).join(" "));
            return n.intersect = function (t) {
              return o(n, a, t);
            }, s;
          }
        };
      },
      8355: function _(t, e, n) {
        var r = n(1034);
        t.exports = {
          isSubgraph: function isSubgraph(t, e) {
            return !!t.children(e).length;
          },
          edgeToId: function edgeToId(t) {
            return a(t.v) + ":" + a(t.w) + ":" + a(t.name);
          },
          applyStyle: function applyStyle(t, e) {
            e && t.attr("style", e);
          },
          applyClass: function applyClass(t, e, n) {
            e && t.attr("class", e).attr("class", n + " " + t.attr("class"));
          },
          applyTransition: function applyTransition(t, e) {
            var n = e.graph();

            if (r.isPlainObject(n)) {
              var i = n.transition;
              if (r.isFunction(i)) return i(t);
            }

            return t;
          }
        };
        var i = /:/g;

        function a(t) {
          return t ? String(t).replace(i, "\\:") : "";
        }
      },
      5689: function _(t) {
        t.exports = "0.6.4";
      },
      7188: function _(t, e, n) {
        n.r(e), n.d(e, {
          FormatSpecifier: function FormatSpecifier() {
            return rc;
          },
          active: function active() {
            return Qr;
          },
          arc: function arc() {
            return rx;
          },
          area: function area() {
            return ux;
          },
          areaRadial: function areaRadial() {
            return vx;
          },
          ascending: function ascending() {
            return i;
          },
          autoType: function autoType() {
            return Do;
          },
          axisBottom: function axisBottom() {
            return it;
          },
          axisLeft: function axisLeft() {
            return at;
          },
          axisRight: function axisRight() {
            return rt;
          },
          axisTop: function axisTop() {
            return nt;
          },
          bisect: function bisect() {
            return u;
          },
          bisectLeft: function bisectLeft() {
            return c;
          },
          bisectRight: function bisectRight() {
            return s;
          },
          bisector: function bisector() {
            return a;
          },
          blob: function blob() {
            return hs;
          },
          brush: function brush() {
            return Si;
          },
          brushSelection: function brushSelection() {
            return Ti;
          },
          brushX: function brushX() {
            return Ei;
          },
          brushY: function brushY() {
            return Ci;
          },
          buffer: function buffer() {
            return ds;
          },
          chord: function chord() {
            return Ri;
          },
          clientPoint: function clientPoint() {
            return Nn;
          },
          cluster: function cluster() {
            return _d;
          },
          color: function color() {
            return We;
          },
          contourDensity: function contourDensity() {
            return to;
          },
          contours: function contours() {
            return Ga;
          },
          create: function create() {
            return N_;
          },
          creator: function creator() {
            return ie;
          },
          cross: function cross() {
            return f;
          },
          csv: function csv() {
            return vs;
          },
          csvFormat: function csvFormat() {
            return vo;
          },
          csvFormatBody: function csvFormatBody() {
            return bo;
          },
          csvFormatRow: function csvFormatRow() {
            return xo;
          },
          csvFormatRows: function csvFormatRows() {
            return _o;
          },
          csvFormatValue: function csvFormatValue() {
            return wo;
          },
          csvParse: function csvParse() {
            return go;
          },
          csvParseRows: function csvParseRows() {
            return mo;
          },
          cubehelix: function cubehelix() {
            return Fa;
          },
          curveBasis: function curveBasis() {
            return Qx;
          },
          curveBasisClosed: function curveBasisClosed() {
            return tw;
          },
          curveBasisOpen: function curveBasisOpen() {
            return nw;
          },
          curveBundle: function curveBundle() {
            return iw;
          },
          curveCardinal: function curveCardinal() {
            return sw;
          },
          curveCardinalClosed: function curveCardinalClosed() {
            return uw;
          },
          curveCardinalOpen: function curveCardinalOpen() {
            return hw;
          },
          curveCatmullRom: function curveCatmullRom() {
            return pw;
          },
          curveCatmullRomClosed: function curveCatmullRomClosed() {
            return gw;
          },
          curveCatmullRomOpen: function curveCatmullRomOpen() {
            return vw;
          },
          curveLinear: function curveLinear() {
            return ax;
          },
          curveLinearClosed: function curveLinearClosed() {
            return _w;
          },
          curveMonotoneX: function curveMonotoneX() {
            return Aw;
          },
          curveMonotoneY: function curveMonotoneY() {
            return Mw;
          },
          curveNatural: function curveNatural() {
            return Ow;
          },
          curveStep: function curveStep() {
            return Lw;
          },
          curveStepAfter: function curveStepAfter() {
            return Rw;
          },
          curveStepBefore: function curveStepBefore() {
            return Iw;
          },
          customEvent: function customEvent() {
            return ge;
          },
          descending: function descending() {
            return d;
          },
          deviation: function deviation() {
            return g;
          },
          dispatch: function dispatch() {
            return ft;
          },
          drag: function drag() {
            return so;
          },
          dragDisable: function dragDisable() {
            return Se;
          },
          dragEnable: function dragEnable() {
            return Ae;
          },
          dsv: function dsv() {
            return ms;
          },
          dsvFormat: function dsvFormat() {
            return po;
          },
          easeBack: function easeBack() {
            return as;
          },
          easeBackIn: function easeBackIn() {
            return rs;
          },
          easeBackInOut: function easeBackInOut() {
            return as;
          },
          easeBackOut: function easeBackOut() {
            return is;
          },
          easeBounce: function easeBounce() {
            return ts;
          },
          easeBounceIn: function easeBounceIn() {
            return Jo;
          },
          easeBounceInOut: function easeBounceInOut() {
            return es;
          },
          easeBounceOut: function easeBounceOut() {
            return ts;
          },
          easeCircle: function easeCircle() {
            return Ko;
          },
          easeCircleIn: function easeCircleIn() {
            return Xo;
          },
          easeCircleInOut: function easeCircleInOut() {
            return Ko;
          },
          easeCircleOut: function easeCircleOut() {
            return Zo;
          },
          easeCubic: function easeCubic() {
            return Gr;
          },
          easeCubicIn: function easeCubicIn() {
            return Wr;
          },
          easeCubicInOut: function easeCubicInOut() {
            return Gr;
          },
          easeCubicOut: function easeCubicOut() {
            return Vr;
          },
          easeElastic: function easeElastic() {
            return cs;
          },
          easeElasticIn: function easeElasticIn() {
            return ss;
          },
          easeElasticInOut: function easeElasticInOut() {
            return us;
          },
          easeElasticOut: function easeElasticOut() {
            return cs;
          },
          easeExp: function easeExp() {
            return Go;
          },
          easeExpIn: function easeExpIn() {
            return Wo;
          },
          easeExpInOut: function easeExpInOut() {
            return Go;
          },
          easeExpOut: function easeExpOut() {
            return Vo;
          },
          easeLinear: function easeLinear() {
            return Bo;
          },
          easePoly: function easePoly() {
            return jo;
          },
          easePolyIn: function easePolyIn() {
            return Po;
          },
          easePolyInOut: function easePolyInOut() {
            return jo;
          },
          easePolyOut: function easePolyOut() {
            return Fo;
          },
          easeQuad: function easeQuad() {
            return Ro;
          },
          easeQuadIn: function easeQuadIn() {
            return Lo;
          },
          easeQuadInOut: function easeQuadInOut() {
            return Ro;
          },
          easeQuadOut: function easeQuadOut() {
            return Io;
          },
          easeSin: function easeSin() {
            return $o;
          },
          easeSinIn: function easeSinIn() {
            return zo;
          },
          easeSinInOut: function easeSinInOut() {
            return $o;
          },
          easeSinOut: function easeSinOut() {
            return qo;
          },
          entries: function entries() {
            return da;
          },
          event: function event() {
            return le;
          },
          extent: function extent() {
            return m;
          },
          forceCenter: function forceCenter() {
            return Ss;
          },
          forceCollide: function forceCollide() {
            return Ys;
          },
          forceLink: function forceLink() {
            return qs;
          },
          forceManyBody: function forceManyBody() {
            return Gs;
          },
          forceRadial: function forceRadial() {
            return Xs;
          },
          forceSimulation: function forceSimulation() {
            return Vs;
          },
          forceX: function forceX() {
            return Zs;
          },
          forceY: function forceY() {
            return Ks;
          },
          format: function format() {
            return cc;
          },
          formatDefaultLocale: function formatDefaultLocale() {
            return dc;
          },
          formatLocale: function formatLocale() {
            return fc;
          },
          formatPrefix: function formatPrefix() {
            return uc;
          },
          formatSpecifier: function formatSpecifier() {
            return nc;
          },
          geoAlbers: function geoAlbers() {
            return If;
          },
          geoAlbersUsa: function geoAlbersUsa() {
            return Rf;
          },
          geoArea: function geoArea() {
            return uu;
          },
          geoAzimuthalEqualArea: function geoAzimuthalEqualArea() {
            return Yf;
          },
          geoAzimuthalEqualAreaRaw: function geoAzimuthalEqualAreaRaw() {
            return jf;
          },
          geoAzimuthalEquidistant: function geoAzimuthalEquidistant() {
            return zf;
          },
          geoAzimuthalEquidistantRaw: function geoAzimuthalEquidistantRaw() {
            return Uf;
          },
          geoBounds: function geoBounds() {
            return el;
          },
          geoCentroid: function geoCentroid() {
            return dl;
          },
          geoCircle: function geoCircle() {
            return Tl;
          },
          geoClipAntimeridian: function geoClipAntimeridian() {
            return Rl;
          },
          geoClipCircle: function geoClipCircle() {
            return Pl;
          },
          geoClipExtent: function geoClipExtent() {
            return Ul;
          },
          geoClipRectangle: function geoClipRectangle() {
            return Yl;
          },
          geoConicConformal: function geoConicConformal() {
            return Gf;
          },
          geoConicConformalRaw: function geoConicConformalRaw() {
            return Vf;
          },
          geoConicEqualArea: function geoConicEqualArea() {
            return Lf;
          },
          geoConicEqualAreaRaw: function geoConicEqualAreaRaw() {
            return Bf;
          },
          geoConicEquidistant: function geoConicEquidistant() {
            return Qf;
          },
          geoConicEquidistantRaw: function geoConicEquidistantRaw() {
            return Kf;
          },
          geoContains: function geoContains() {
            return ch;
          },
          geoDistance: function geoDistance() {
            return Jl;
          },
          geoEqualEarth: function geoEqualEarth() {
            return ad;
          },
          geoEqualEarthRaw: function geoEqualEarthRaw() {
            return id;
          },
          geoEquirectangular: function geoEquirectangular() {
            return Zf;
          },
          geoEquirectangularRaw: function geoEquirectangularRaw() {
            return Xf;
          },
          geoGnomonic: function geoGnomonic() {
            return sd;
          },
          geoGnomonicRaw: function geoGnomonicRaw() {
            return od;
          },
          geoGraticule: function geoGraticule() {
            return hh;
          },
          geoGraticule10: function geoGraticule10() {
            return fh;
          },
          geoIdentity: function geoIdentity() {
            return cd;
          },
          geoInterpolate: function geoInterpolate() {
            return dh;
          },
          geoLength: function geoLength() {
            return Zl;
          },
          geoMercator: function geoMercator() {
            return $f;
          },
          geoMercatorRaw: function geoMercatorRaw() {
            return qf;
          },
          geoNaturalEarth1: function geoNaturalEarth1() {
            return ld;
          },
          geoNaturalEarth1Raw: function geoNaturalEarth1Raw() {
            return ud;
          },
          geoOrthographic: function geoOrthographic() {
            return fd;
          },
          geoOrthographicRaw: function geoOrthographicRaw() {
            return hd;
          },
          geoPath: function geoPath() {
            return gf;
          },
          geoProjection: function geoProjection() {
            return Nf;
          },
          geoProjectionMutator: function geoProjectionMutator() {
            return Df;
          },
          geoRotation: function geoRotation() {
            return xl;
          },
          geoStereographic: function geoStereographic() {
            return pd;
          },
          geoStereographicRaw: function geoStereographicRaw() {
            return dd;
          },
          geoStream: function geoStream() {
            return Zc;
          },
          geoTransform: function geoTransform() {
            return mf;
          },
          geoTransverseMercator: function geoTransverseMercator() {
            return gd;
          },
          geoTransverseMercatorRaw: function geoTransverseMercatorRaw() {
            return yd;
          },
          gray: function gray() {
            return va;
          },
          hcl: function hcl() {
            return Sa;
          },
          hierarchy: function hierarchy() {
            return wd;
          },
          histogram: function histogram() {
            return D;
          },
          hsl: function hsl() {
            return rn;
          },
          html: function html() {
            return Es;
          },
          image: function image() {
            return _s;
          },
          interpolate: function interpolate() {
            return An;
          },
          interpolateArray: function interpolateArray() {
            return _n;
          },
          interpolateBasis: function interpolateBasis() {
            return cn;
          },
          interpolateBasisClosed: function interpolateBasisClosed() {
            return un;
          },
          interpolateBlues: function interpolateBlues() {
            return r_;
          },
          interpolateBrBG: function interpolateBrBG() {
            return yb;
          },
          interpolateBuGn: function interpolateBuGn() {
            return Bb;
          },
          interpolateBuPu: function interpolateBuPu() {
            return Ib;
          },
          interpolateCividis: function interpolateCividis() {
            return p_;
          },
          interpolateCool: function interpolateCool() {
            return m_;
          },
          interpolateCubehelix: function interpolateCubehelix() {
            return Lp;
          },
          interpolateCubehelixDefault: function interpolateCubehelixDefault() {
            return y_;
          },
          interpolateCubehelixLong: function interpolateCubehelixLong() {
            return Ip;
          },
          interpolateDate: function interpolateDate() {
            return wn;
          },
          interpolateDiscrete: function interpolateDiscrete() {
            return _p;
          },
          interpolateGnBu: function interpolateGnBu() {
            return Pb;
          },
          interpolateGreens: function interpolateGreens() {
            return a_;
          },
          interpolateGreys: function interpolateGreys() {
            return s_;
          },
          interpolateHcl: function interpolateHcl() {
            return Dp;
          },
          interpolateHclLong: function interpolateHclLong() {
            return Op;
          },
          interpolateHsl: function interpolateHsl() {
            return Sp;
          },
          interpolateHslLong: function interpolateHslLong() {
            return Ap;
          },
          interpolateHue: function interpolateHue() {
            return xp;
          },
          interpolateInferno: function interpolateInferno() {
            return A_;
          },
          interpolateLab: function interpolateLab() {
            return Mp;
          },
          interpolateMagma: function interpolateMagma() {
            return S_;
          },
          interpolateNumber: function interpolateNumber() {
            return kn;
          },
          interpolateNumberArray: function interpolateNumberArray() {
            return vn;
          },
          interpolateObject: function interpolateObject() {
            return Tn;
          },
          interpolateOrRd: function interpolateOrRd() {
            return jb;
          },
          interpolateOranges: function interpolateOranges() {
            return d_;
          },
          interpolatePRGn: function interpolatePRGn() {
            return mb;
          },
          interpolatePiYG: function interpolatePiYG() {
            return bb;
          },
          interpolatePlasma: function interpolatePlasma() {
            return M_;
          },
          interpolatePuBu: function interpolatePuBu() {
            return qb;
          },
          interpolatePuBuGn: function interpolatePuBuGn() {
            return Ub;
          },
          interpolatePuOr: function interpolatePuOr() {
            return xb;
          },
          interpolatePuRd: function interpolatePuRd() {
            return Hb;
          },
          interpolatePurples: function interpolatePurples() {
            return u_;
          },
          interpolateRainbow: function interpolateRainbow() {
            return b_;
          },
          interpolateRdBu: function interpolateRdBu() {
            return kb;
          },
          interpolateRdGy: function interpolateRdGy() {
            return Eb;
          },
          interpolateRdPu: function interpolateRdPu() {
            return Vb;
          },
          interpolateRdYlBu: function interpolateRdYlBu() {
            return Sb;
          },
          interpolateRdYlGn: function interpolateRdYlGn() {
            return Mb;
          },
          interpolateReds: function interpolateReds() {
            return h_;
          },
          interpolateRgb: function interpolateRgb() {
            return pn;
          },
          interpolateRgbBasis: function interpolateRgbBasis() {
            return gn;
          },
          interpolateRgbBasisClosed: function interpolateRgbBasisClosed() {
            return mn;
          },
          interpolateRound: function interpolateRound() {
            return wp;
          },
          interpolateSinebow: function interpolateSinebow() {
            return k_;
          },
          interpolateSpectral: function interpolateSpectral() {
            return Db;
          },
          interpolateString: function interpolateString() {
            return Sn;
          },
          interpolateTransformCss: function interpolateTransformCss() {
            return dr;
          },
          interpolateTransformSvg: function interpolateTransformSvg() {
            return pr;
          },
          interpolateTurbo: function interpolateTurbo() {
            return T_;
          },
          interpolateViridis: function interpolateViridis() {
            return C_;
          },
          interpolateWarm: function interpolateWarm() {
            return g_;
          },
          interpolateYlGn: function interpolateYlGn() {
            return Kb;
          },
          interpolateYlGnBu: function interpolateYlGnBu() {
            return Xb;
          },
          interpolateYlOrBr: function interpolateYlOrBr() {
            return Jb;
          },
          interpolateYlOrRd: function interpolateYlOrRd() {
            return e_;
          },
          interpolateZoom: function interpolateZoom() {
            return Ep;
          },
          interrupt: function interrupt() {
            return ir;
          },
          interval: function interval() {
            return ek;
          },
          isoFormat: function isoFormat() {
            return Jw;
          },
          isoParse: function isoParse() {
            return tk;
          },
          json: function json() {
            return ws;
          },
          keys: function keys() {
            return ha;
          },
          lab: function lab() {
            return ba;
          },
          lch: function lch() {
            return Ca;
          },
          line: function line() {
            return cx;
          },
          lineRadial: function lineRadial() {
            return mx;
          },
          linkHorizontal: function linkHorizontal() {
            return Sx;
          },
          linkRadial: function linkRadial() {
            return Mx;
          },
          linkVertical: function linkVertical() {
            return Ax;
          },
          local: function local() {
            return O_;
          },
          map: function map() {
            return ea;
          },
          matcher: function matcher() {
            return mt;
          },
          max: function max() {
            return I;
          },
          mean: function mean() {
            return R;
          },
          median: function median() {
            return P;
          },
          merge: function merge() {
            return F;
          },
          min: function min() {
            return j;
          },
          mouse: function mouse() {
            return On;
          },
          namespace: function namespace() {
            return Et;
          },
          namespaces: function namespaces() {
            return Tt;
          },
          nest: function nest() {
            return na;
          },
          now: function now() {
            return qn;
          },
          pack: function pack() {
            return Vd;
          },
          packEnclose: function packEnclose() {
            return Ad;
          },
          packSiblings: function packSiblings() {
            return Ud;
          },
          pairs: function pairs() {
            return l;
          },
          partition: function partition() {
            return Jd;
          },
          path: function path() {
            return Hi;
          },
          permute: function permute() {
            return Y;
          },
          pie: function pie() {
            return fx;
          },
          piecewise: function piecewise() {
            return Rp;
          },
          pointRadial: function pointRadial() {
            return bx;
          },
          polygonArea: function polygonArea() {
            return Fp;
          },
          polygonCentroid: function polygonCentroid() {
            return jp;
          },
          polygonContains: function polygonContains() {
            return $p;
          },
          polygonHull: function polygonHull() {
            return qp;
          },
          polygonLength: function polygonLength() {
            return Hp;
          },
          precisionFixed: function precisionFixed() {
            return pc;
          },
          precisionPrefix: function precisionPrefix() {
            return yc;
          },
          precisionRound: function precisionRound() {
            return gc;
          },
          quadtree: function quadtree() {
            return Ls;
          },
          quantile: function quantile() {
            return O;
          },
          quantize: function quantize() {
            return Pp;
          },
          radialArea: function radialArea() {
            return vx;
          },
          radialLine: function radialLine() {
            return mx;
          },
          randomBates: function randomBates() {
            return Kp;
          },
          randomExponential: function randomExponential() {
            return Qp;
          },
          randomIrwinHall: function randomIrwinHall() {
            return Zp;
          },
          randomLogNormal: function randomLogNormal() {
            return Xp;
          },
          randomNormal: function randomNormal() {
            return Gp;
          },
          randomUniform: function randomUniform() {
            return Vp;
          },
          range: function range() {
            return k;
          },
          rgb: function rgb() {
            return Ze;
          },
          ribbon: function ribbon() {
            return Ki;
          },
          scaleBand: function scaleBand() {
            return oy;
          },
          scaleDiverging: function scaleDiverging() {
            return Kv;
          },
          scaleDivergingLog: function scaleDivergingLog() {
            return Qv;
          },
          scaleDivergingPow: function scaleDivergingPow() {
            return tb;
          },
          scaleDivergingSqrt: function scaleDivergingSqrt() {
            return eb;
          },
          scaleDivergingSymlog: function scaleDivergingSymlog() {
            return Jv;
          },
          scaleIdentity: function scaleIdentity() {
            return wy;
          },
          scaleImplicit: function scaleImplicit() {
            return iy;
          },
          scaleLinear: function scaleLinear() {
            return xy;
          },
          scaleLog: function scaleLog() {
            return Dy;
          },
          scaleOrdinal: function scaleOrdinal() {
            return ay;
          },
          scalePoint: function scalePoint() {
            return cy;
          },
          scalePow: function scalePow() {
            return Yy;
          },
          scaleQuantile: function scaleQuantile() {
            return zy;
          },
          scaleQuantize: function scaleQuantize() {
            return qy;
          },
          scaleSequential: function scaleSequential() {
            return $v;
          },
          scaleSequentialLog: function scaleSequentialLog() {
            return Hv;
          },
          scaleSequentialPow: function scaleSequentialPow() {
            return Vv;
          },
          scaleSequentialQuantile: function scaleSequentialQuantile() {
            return Xv;
          },
          scaleSequentialSqrt: function scaleSequentialSqrt() {
            return Gv;
          },
          scaleSequentialSymlog: function scaleSequentialSymlog() {
            return Wv;
          },
          scaleSqrt: function scaleSqrt() {
            return Uy;
          },
          scaleSymlog: function scaleSymlog() {
            return Iy;
          },
          scaleThreshold: function scaleThreshold() {
            return $y;
          },
          scaleTime: function scaleTime() {
            return Dv;
          },
          scaleUtc: function scaleUtc() {
            return Uv;
          },
          scan: function scan() {
            return U;
          },
          schemeAccent: function schemeAccent() {
            return ib;
          },
          schemeBlues: function schemeBlues() {
            return n_;
          },
          schemeBrBG: function schemeBrBG() {
            return pb;
          },
          schemeBuGn: function schemeBuGn() {
            return Ob;
          },
          schemeBuPu: function schemeBuPu() {
            return Lb;
          },
          schemeCategory10: function schemeCategory10() {
            return rb;
          },
          schemeDark2: function schemeDark2() {
            return ab;
          },
          schemeGnBu: function schemeGnBu() {
            return Rb;
          },
          schemeGreens: function schemeGreens() {
            return i_;
          },
          schemeGreys: function schemeGreys() {
            return o_;
          },
          schemeOrRd: function schemeOrRd() {
            return Fb;
          },
          schemeOranges: function schemeOranges() {
            return f_;
          },
          schemePRGn: function schemePRGn() {
            return gb;
          },
          schemePaired: function schemePaired() {
            return ob;
          },
          schemePastel1: function schemePastel1() {
            return sb;
          },
          schemePastel2: function schemePastel2() {
            return cb;
          },
          schemePiYG: function schemePiYG() {
            return vb;
          },
          schemePuBu: function schemePuBu() {
            return zb;
          },
          schemePuBuGn: function schemePuBuGn() {
            return Yb;
          },
          schemePuOr: function schemePuOr() {
            return _b;
          },
          schemePuRd: function schemePuRd() {
            return $b;
          },
          schemePurples: function schemePurples() {
            return c_;
          },
          schemeRdBu: function schemeRdBu() {
            return wb;
          },
          schemeRdGy: function schemeRdGy() {
            return Tb;
          },
          schemeRdPu: function schemeRdPu() {
            return Wb;
          },
          schemeRdYlBu: function schemeRdYlBu() {
            return Cb;
          },
          schemeRdYlGn: function schemeRdYlGn() {
            return Ab;
          },
          schemeReds: function schemeReds() {
            return l_;
          },
          schemeSet1: function schemeSet1() {
            return ub;
          },
          schemeSet2: function schemeSet2() {
            return lb;
          },
          schemeSet3: function schemeSet3() {
            return hb;
          },
          schemeSpectral: function schemeSpectral() {
            return Nb;
          },
          schemeTableau10: function schemeTableau10() {
            return fb;
          },
          schemeYlGn: function schemeYlGn() {
            return Zb;
          },
          schemeYlGnBu: function schemeYlGnBu() {
            return Gb;
          },
          schemeYlOrBr: function schemeYlOrBr() {
            return Qb;
          },
          schemeYlOrRd: function schemeYlOrRd() {
            return t_;
          },
          select: function select() {
            return Te;
          },
          selectAll: function selectAll() {
            return L_;
          },
          selection: function selection() {
            return ke;
          },
          selector: function selector() {
            return pt;
          },
          selectorAll: function selectorAll() {
            return gt;
          },
          set: function set() {
            return la;
          },
          shuffle: function shuffle() {
            return z;
          },
          stack: function stack() {
            return Yw;
          },
          stackOffsetDiverging: function stackOffsetDiverging() {
            return zw;
          },
          stackOffsetExpand: function stackOffsetExpand() {
            return Uw;
          },
          stackOffsetNone: function stackOffsetNone() {
            return Pw;
          },
          stackOffsetSilhouette: function stackOffsetSilhouette() {
            return qw;
          },
          stackOffsetWiggle: function stackOffsetWiggle() {
            return $w;
          },
          stackOrderAppearance: function stackOrderAppearance() {
            return Hw;
          },
          stackOrderAscending: function stackOrderAscending() {
            return Vw;
          },
          stackOrderDescending: function stackOrderDescending() {
            return Xw;
          },
          stackOrderInsideOut: function stackOrderInsideOut() {
            return Zw;
          },
          stackOrderNone: function stackOrderNone() {
            return Fw;
          },
          stackOrderReverse: function stackOrderReverse() {
            return Kw;
          },
          stratify: function stratify() {
            return ip;
          },
          style: function style() {
            return Rt;
          },
          sum: function sum() {
            return q;
          },
          svg: function svg() {
            return Cs;
          },
          symbol: function symbol() {
            return Gx;
          },
          symbolCircle: function symbolCircle() {
            return Nx;
          },
          symbolCross: function symbolCross() {
            return Dx;
          },
          symbolDiamond: function symbolDiamond() {
            return Lx;
          },
          symbolSquare: function symbolSquare() {
            return jx;
          },
          symbolStar: function symbolStar() {
            return Fx;
          },
          symbolTriangle: function symbolTriangle() {
            return Ux;
          },
          symbolWye: function symbolWye() {
            return Wx;
          },
          symbols: function symbols() {
            return Vx;
          },
          text: function text() {
            return ys;
          },
          thresholdFreedmanDiaconis: function thresholdFreedmanDiaconis() {
            return B;
          },
          thresholdScott: function thresholdScott() {
            return L;
          },
          thresholdSturges: function thresholdSturges() {
            return N;
          },
          tickFormat: function tickFormat() {
            return by;
          },
          tickIncrement: function tickIncrement() {
            return A;
          },
          tickStep: function tickStep() {
            return M;
          },
          ticks: function ticks() {
            return S;
          },
          timeDay: function timeDay() {
            return bg;
          },
          timeDays: function timeDays() {
            return _g;
          },
          timeFormat: function timeFormat() {
            return am;
          },
          timeFormatDefaultLocale: function timeFormatDefaultLocale() {
            return Cv;
          },
          timeFormatLocale: function timeFormatLocale() {
            return rm;
          },
          timeFriday: function timeFriday() {
            return ug;
          },
          timeFridays: function timeFridays() {
            return gg;
          },
          timeHour: function timeHour() {
            return wg;
          },
          timeHours: function timeHours() {
            return kg;
          },
          timeInterval: function timeInterval() {
            return Vy;
          },
          timeMillisecond: function timeMillisecond() {
            return Dg;
          },
          timeMilliseconds: function timeMilliseconds() {
            return Og;
          },
          timeMinute: function timeMinute() {
            return Eg;
          },
          timeMinutes: function timeMinutes() {
            return Cg;
          },
          timeMonday: function timeMonday() {
            return ag;
          },
          timeMondays: function timeMondays() {
            return fg;
          },
          timeMonth: function timeMonth() {
            return Qy;
          },
          timeMonths: function timeMonths() {
            return Jy;
          },
          timeParse: function timeParse() {
            return om;
          },
          timeSaturday: function timeSaturday() {
            return lg;
          },
          timeSaturdays: function timeSaturdays() {
            return mg;
          },
          timeSecond: function timeSecond() {
            return Ag;
          },
          timeSeconds: function timeSeconds() {
            return Mg;
          },
          timeSunday: function timeSunday() {
            return ig;
          },
          timeSundays: function timeSundays() {
            return hg;
          },
          timeThursday: function timeThursday() {
            return cg;
          },
          timeThursdays: function timeThursdays() {
            return yg;
          },
          timeTuesday: function timeTuesday() {
            return og;
          },
          timeTuesdays: function timeTuesdays() {
            return dg;
          },
          timeWednesday: function timeWednesday() {
            return sg;
          },
          timeWednesdays: function timeWednesdays() {
            return pg;
          },
          timeWeek: function timeWeek() {
            return ig;
          },
          timeWeeks: function timeWeeks() {
            return hg;
          },
          timeYear: function timeYear() {
            return Xy;
          },
          timeYears: function timeYears() {
            return Zy;
          },
          timeout: function timeout() {
            return Kn;
          },
          timer: function timer() {
            return Wn;
          },
          timerFlush: function timerFlush() {
            return Vn;
          },
          touch: function touch() {
            return Dn;
          },
          touches: function touches() {
            return I_;
          },
          transition: function transition() {
            return qr;
          },
          transpose: function transpose() {
            return $;
          },
          tree: function tree() {
            return hp;
          },
          treemap: function treemap() {
            return gp;
          },
          treemapBinary: function treemapBinary() {
            return mp;
          },
          treemapDice: function treemapDice() {
            return Qd;
          },
          treemapResquarify: function treemapResquarify() {
            return bp;
          },
          treemapSlice: function treemapSlice() {
            return fp;
          },
          treemapSliceDice: function treemapSliceDice() {
            return vp;
          },
          treemapSquarify: function treemapSquarify() {
            return yp;
          },
          tsv: function tsv() {
            return bs;
          },
          tsvFormat: function tsvFormat() {
            return Co;
          },
          tsvFormatBody: function tsvFormatBody() {
            return So;
          },
          tsvFormatRow: function tsvFormatRow() {
            return Mo;
          },
          tsvFormatRows: function tsvFormatRows() {
            return Ao;
          },
          tsvFormatValue: function tsvFormatValue() {
            return No;
          },
          tsvParse: function tsvParse() {
            return To;
          },
          tsvParseRows: function tsvParseRows() {
            return Eo;
          },
          utcDay: function utcDay() {
            return Xg;
          },
          utcDays: function utcDays() {
            return Zg;
          },
          utcFormat: function utcFormat() {
            return sm;
          },
          utcFriday: function utcFriday() {
            return jg;
          },
          utcFridays: function utcFridays() {
            return Wg;
          },
          utcHour: function utcHour() {
            return Rv;
          },
          utcHours: function utcHours() {
            return Pv;
          },
          utcMillisecond: function utcMillisecond() {
            return Dg;
          },
          utcMilliseconds: function utcMilliseconds() {
            return Og;
          },
          utcMinute: function utcMinute() {
            return jv;
          },
          utcMinutes: function utcMinutes() {
            return Yv;
          },
          utcMonday: function utcMonday() {
            return Ig;
          },
          utcMondays: function utcMondays() {
            return zg;
          },
          utcMonth: function utcMonth() {
            return Bv;
          },
          utcMonths: function utcMonths() {
            return Lv;
          },
          utcParse: function utcParse() {
            return cm;
          },
          utcSaturday: function utcSaturday() {
            return Yg;
          },
          utcSaturdays: function utcSaturdays() {
            return Vg;
          },
          utcSecond: function utcSecond() {
            return Ag;
          },
          utcSeconds: function utcSeconds() {
            return Mg;
          },
          utcSunday: function utcSunday() {
            return Lg;
          },
          utcSundays: function utcSundays() {
            return Ug;
          },
          utcThursday: function utcThursday() {
            return Fg;
          },
          utcThursdays: function utcThursdays() {
            return Hg;
          },
          utcTuesday: function utcTuesday() {
            return Rg;
          },
          utcTuesdays: function utcTuesdays() {
            return qg;
          },
          utcWednesday: function utcWednesday() {
            return Pg;
          },
          utcWednesdays: function utcWednesdays() {
            return $g;
          },
          utcWeek: function utcWeek() {
            return Lg;
          },
          utcWeeks: function utcWeeks() {
            return Ug;
          },
          utcYear: function utcYear() {
            return Qg;
          },
          utcYears: function utcYears() {
            return Jg;
          },
          values: function values() {
            return fa;
          },
          variance: function variance() {
            return y;
          },
          version: function version() {
            return r;
          },
          voronoi: function voronoi() {
            return Uk;
          },
          window: function window() {
            return Ot;
          },
          xml: function xml() {
            return Ts;
          },
          zip: function zip() {
            return W;
          },
          zoom: function zoom() {
            return eT;
          },
          zoomIdentity: function zoomIdentity() {
            return Hk;
          },
          zoomTransform: function zoomTransform() {
            return Wk;
          }
        });
        var r = "5.16.0";

        function i(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        function a(t) {
          var e;
          return 1 === t.length && (e = t, t = function t(_t14, n) {
            return i(e(_t14), n);
          }), {
            left: function left(e, n, r, i) {
              for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
                var a = r + i >>> 1;
                t(e[a], n) < 0 ? r = a + 1 : i = a;
              }

              return r;
            },
            right: function right(e, n, r, i) {
              for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
                var a = r + i >>> 1;
                t(e[a], n) > 0 ? i = a : r = a + 1;
              }

              return r;
            }
          };
        }

        var o = a(i),
            s = o.right,
            c = o.left;
        var u = s;

        function l(t, e) {
          null == e && (e = h);

          for (var n = 0, r = t.length - 1, i = t[0], a = new Array(r < 0 ? 0 : r); n < r;) {
            a[n] = e(i, i = t[++n]);
          }

          return a;
        }

        function h(t, e) {
          return [t, e];
        }

        function f(t, e, n) {
          var r,
              i,
              a,
              o,
              s = t.length,
              c = e.length,
              u = new Array(s * c);

          for (null == n && (n = h), r = a = 0; r < s; ++r) {
            for (o = t[r], i = 0; i < c; ++i, ++a) {
              u[a] = n(o, e[i]);
            }
          }

          return u;
        }

        function d(t, e) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }

        function p(t) {
          return null === t ? NaN : +t;
        }

        function y(t, e) {
          var n,
              r,
              i = t.length,
              a = 0,
              o = -1,
              s = 0,
              c = 0;
          if (null == e) for (; ++o < i;) {
            isNaN(n = p(t[o])) || (c += (r = n - s) * (n - (s += r / ++a)));
          } else for (; ++o < i;) {
            isNaN(n = p(e(t[o], o, t))) || (c += (r = n - s) * (n - (s += r / ++a)));
          }
          if (a > 1) return c / (a - 1);
        }

        function g(t, e) {
          var n = y(t, e);
          return n ? Math.sqrt(n) : n;
        }

        function m(t, e) {
          var n,
              r,
              i,
              a = t.length,
              o = -1;

          if (null == e) {
            for (; ++o < a;) {
              if (null != (n = t[o]) && n >= n) for (r = i = n; ++o < a;) {
                null != (n = t[o]) && (r > n && (r = n), i < n && (i = n));
              }
            }
          } else for (; ++o < a;) {
            if (null != (n = e(t[o], o, t)) && n >= n) for (r = i = n; ++o < a;) {
              null != (n = e(t[o], o, t)) && (r > n && (r = n), i < n && (i = n));
            }
          }

          return [r, i];
        }

        var v = Array.prototype,
            b = v.slice,
            _ = v.map;

        function x(t) {
          return function () {
            return t;
          };
        }

        function w(t) {
          return t;
        }

        function k(t, e, n) {
          t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;

          for (var r = -1, i = 0 | Math.max(0, Math.ceil((e - t) / n)), a = new Array(i); ++r < i;) {
            a[r] = t + r * n;
          }

          return a;
        }

        var T = Math.sqrt(50),
            E = Math.sqrt(10),
            C = Math.sqrt(2);

        function S(t, e, n) {
          var r,
              i,
              a,
              o,
              s = -1;
          if (n = +n, (t = +t) == (e = +e) && n > 0) return [t];
          if ((r = e < t) && (i = t, t = e, e = i), 0 === (o = A(t, e, n)) || !isFinite(o)) return [];
          if (o > 0) for (t = Math.ceil(t / o), e = Math.floor(e / o), a = new Array(i = Math.ceil(e - t + 1)); ++s < i;) {
            a[s] = (t + s) * o;
          } else for (t = Math.floor(t * o), e = Math.ceil(e * o), a = new Array(i = Math.ceil(t - e + 1)); ++s < i;) {
            a[s] = (t - s) / o;
          }
          return r && a.reverse(), a;
        }

        function A(t, e, n) {
          var r = (e - t) / Math.max(0, n),
              i = Math.floor(Math.log(r) / Math.LN10),
              a = r / Math.pow(10, i);
          return i >= 0 ? (a >= T ? 10 : a >= E ? 5 : a >= C ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= T ? 10 : a >= E ? 5 : a >= C ? 2 : 1);
        }

        function M(t, e, n) {
          var r = Math.abs(e - t) / Math.max(0, n),
              i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
              a = r / i;
          return a >= T ? i *= 10 : a >= E ? i *= 5 : a >= C && (i *= 2), e < t ? -i : i;
        }

        function N(t) {
          return Math.ceil(Math.log(t.length) / Math.LN2) + 1;
        }

        function D() {
          var t = w,
              e = m,
              n = N;

          function r(r) {
            var i,
                a,
                o = r.length,
                s = new Array(o);

            for (i = 0; i < o; ++i) {
              s[i] = t(r[i], i, r);
            }

            var c = e(s),
                l = c[0],
                h = c[1],
                f = n(s, l, h);
            Array.isArray(f) || (f = M(l, h, f), f = k(Math.ceil(l / f) * f, h, f));

            for (var d = f.length; f[0] <= l;) {
              f.shift(), --d;
            }

            for (; f[d - 1] > h;) {
              f.pop(), --d;
            }

            var p,
                y = new Array(d + 1);

            for (i = 0; i <= d; ++i) {
              (p = y[i] = []).x0 = i > 0 ? f[i - 1] : l, p.x1 = i < d ? f[i] : h;
            }

            for (i = 0; i < o; ++i) {
              l <= (a = s[i]) && a <= h && y[u(f, a, 0, d)].push(r[i]);
            }

            return y;
          }

          return r.value = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : x(e), r) : t;
          }, r.domain = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : x([t[0], t[1]]), r) : e;
          }, r.thresholds = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : Array.isArray(t) ? x(b.call(t)) : x(t), r) : n;
          }, r;
        }

        function O(t, e, n) {
          if (null == n && (n = p), r = t.length) {
            if ((e = +e) <= 0 || r < 2) return +n(t[0], 0, t);
            if (e >= 1) return +n(t[r - 1], r - 1, t);
            var r,
                i = (r - 1) * e,
                a = Math.floor(i),
                o = +n(t[a], a, t);
            return o + (+n(t[a + 1], a + 1, t) - o) * (i - a);
          }
        }

        function B(t, e, n) {
          return t = _.call(t, p).sort(i), Math.ceil((n - e) / (2 * (O(t, .75) - O(t, .25)) * Math.pow(t.length, -1 / 3)));
        }

        function L(t, e, n) {
          return Math.ceil((n - e) / (3.5 * g(t) * Math.pow(t.length, -1 / 3)));
        }

        function I(t, e) {
          var n,
              r,
              i = t.length,
              a = -1;

          if (null == e) {
            for (; ++a < i;) {
              if (null != (n = t[a]) && n >= n) for (r = n; ++a < i;) {
                null != (n = t[a]) && n > r && (r = n);
              }
            }
          } else for (; ++a < i;) {
            if (null != (n = e(t[a], a, t)) && n >= n) for (r = n; ++a < i;) {
              null != (n = e(t[a], a, t)) && n > r && (r = n);
            }
          }

          return r;
        }

        function R(t, e) {
          var n,
              r = t.length,
              i = r,
              a = -1,
              o = 0;
          if (null == e) for (; ++a < r;) {
            isNaN(n = p(t[a])) ? --i : o += n;
          } else for (; ++a < r;) {
            isNaN(n = p(e(t[a], a, t))) ? --i : o += n;
          }
          if (i) return o / i;
        }

        function P(t, e) {
          var n,
              r = t.length,
              a = -1,
              o = [];
          if (null == e) for (; ++a < r;) {
            isNaN(n = p(t[a])) || o.push(n);
          } else for (; ++a < r;) {
            isNaN(n = p(e(t[a], a, t))) || o.push(n);
          }
          return O(o.sort(i), .5);
        }

        function F(t) {
          for (var e, n, r, i = t.length, a = -1, o = 0; ++a < i;) {
            o += t[a].length;
          }

          for (n = new Array(o); --i >= 0;) {
            for (e = (r = t[i]).length; --e >= 0;) {
              n[--o] = r[e];
            }
          }

          return n;
        }

        function j(t, e) {
          var n,
              r,
              i = t.length,
              a = -1;

          if (null == e) {
            for (; ++a < i;) {
              if (null != (n = t[a]) && n >= n) for (r = n; ++a < i;) {
                null != (n = t[a]) && r > n && (r = n);
              }
            }
          } else for (; ++a < i;) {
            if (null != (n = e(t[a], a, t)) && n >= n) for (r = n; ++a < i;) {
              null != (n = e(t[a], a, t)) && r > n && (r = n);
            }
          }

          return r;
        }

        function Y(t, e) {
          for (var n = e.length, r = new Array(n); n--;) {
            r[n] = t[e[n]];
          }

          return r;
        }

        function U(t, e) {
          if (n = t.length) {
            var n,
                r,
                a = 0,
                o = 0,
                s = t[o];

            for (null == e && (e = i); ++a < n;) {
              (e(r = t[a], s) < 0 || 0 !== e(s, s)) && (s = r, o = a);
            }

            return 0 === e(s, s) ? o : void 0;
          }
        }

        function z(t, e, n) {
          for (var r, i, a = (null == n ? t.length : n) - (e = null == e ? 0 : +e); a;) {
            i = Math.random() * a-- | 0, r = t[a + e], t[a + e] = t[i + e], t[i + e] = r;
          }

          return t;
        }

        function q(t, e) {
          var n,
              r = t.length,
              i = -1,
              a = 0;
          if (null == e) for (; ++i < r;) {
            (n = +t[i]) && (a += n);
          } else for (; ++i < r;) {
            (n = +e(t[i], i, t)) && (a += n);
          }
          return a;
        }

        function $(t) {
          if (!(i = t.length)) return [];

          for (var e = -1, n = j(t, H), r = new Array(n); ++e < n;) {
            for (var i, a = -1, o = r[e] = new Array(i); ++a < i;) {
              o[a] = t[a][e];
            }
          }

          return r;
        }

        function H(t) {
          return t.length;
        }

        function W() {
          return $(arguments);
        }

        var V = Array.prototype.slice;

        function G(t) {
          return t;
        }

        var X = 1e-6;

        function Z(t) {
          return "translate(" + (t + .5) + ",0)";
        }

        function K(t) {
          return "translate(0," + (t + .5) + ")";
        }

        function Q(t) {
          return function (e) {
            return +t(e);
          };
        }

        function J(t) {
          var e = Math.max(0, t.bandwidth() - 1) / 2;
          return t.round() && (e = Math.round(e)), function (n) {
            return +t(n) + e;
          };
        }

        function tt() {
          return !this.__axis;
        }

        function et(t, e) {
          var n = [],
              r = null,
              i = null,
              a = 6,
              o = 6,
              s = 3,
              c = 1 === t || 4 === t ? -1 : 1,
              u = 4 === t || 2 === t ? "x" : "y",
              l = 1 === t || 3 === t ? Z : K;

          function h(h) {
            var f = null == r ? e.ticks ? e.ticks.apply(e, n) : e.domain() : r,
                d = null == i ? e.tickFormat ? e.tickFormat.apply(e, n) : G : i,
                p = Math.max(a, 0) + s,
                y = e.range(),
                g = +y[0] + .5,
                m = +y[y.length - 1] + .5,
                v = (e.bandwidth ? J : Q)(e.copy()),
                b = h.selection ? h.selection() : h,
                _ = b.selectAll(".domain").data([null]),
                x = b.selectAll(".tick").data(f, e).order(),
                w = x.exit(),
                k = x.enter().append("g").attr("class", "tick"),
                T = x.select("line"),
                E = x.select("text");

            _ = _.merge(_.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), x = x.merge(k), T = T.merge(k.append("line").attr("stroke", "currentColor").attr(u + "2", c * a)), E = E.merge(k.append("text").attr("fill", "currentColor").attr(u, c * p).attr("dy", 1 === t ? "0em" : 3 === t ? "0.71em" : "0.32em")), h !== b && (_ = _.transition(h), x = x.transition(h), T = T.transition(h), E = E.transition(h), w = w.transition(h).attr("opacity", X).attr("transform", function (t) {
              return isFinite(t = v(t)) ? l(t) : this.getAttribute("transform");
            }), k.attr("opacity", X).attr("transform", function (t) {
              var e = this.parentNode.__axis;
              return l(e && isFinite(e = e(t)) ? e : v(t));
            })), w.remove(), _.attr("d", 4 === t || 2 == t ? o ? "M" + c * o + "," + g + "H0.5V" + m + "H" + c * o : "M0.5," + g + "V" + m : o ? "M" + g + "," + c * o + "V0.5H" + m + "V" + c * o : "M" + g + ",0.5H" + m), x.attr("opacity", 1).attr("transform", function (t) {
              return l(v(t));
            }), T.attr(u + "2", c * a), E.attr(u, c * p).text(d), b.filter(tt).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", 2 === t ? "start" : 4 === t ? "end" : "middle"), b.each(function () {
              this.__axis = v;
            });
          }

          return h.scale = function (t) {
            return arguments.length ? (e = t, h) : e;
          }, h.ticks = function () {
            return n = V.call(arguments), h;
          }, h.tickArguments = function (t) {
            return arguments.length ? (n = null == t ? [] : V.call(t), h) : n.slice();
          }, h.tickValues = function (t) {
            return arguments.length ? (r = null == t ? null : V.call(t), h) : r && r.slice();
          }, h.tickFormat = function (t) {
            return arguments.length ? (i = t, h) : i;
          }, h.tickSize = function (t) {
            return arguments.length ? (a = o = +t, h) : a;
          }, h.tickSizeInner = function (t) {
            return arguments.length ? (a = +t, h) : a;
          }, h.tickSizeOuter = function (t) {
            return arguments.length ? (o = +t, h) : o;
          }, h.tickPadding = function (t) {
            return arguments.length ? (s = +t, h) : s;
          }, h;
        }

        function nt(t) {
          return et(1, t);
        }

        function rt(t) {
          return et(2, t);
        }

        function it(t) {
          return et(3, t);
        }

        function at(t) {
          return et(4, t);
        }

        var ot = {
          value: function value() {}
        };

        function st() {
          for (var t, e = 0, n = arguments.length, r = {}; e < n; ++e) {
            if (!(t = arguments[e] + "") || t in r || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            r[t] = [];
          }

          return new ct(r);
        }

        function ct(t) {
          this._ = t;
        }

        function ut(t, e) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var n = "",
                r = t.indexOf(".");
            if (r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), t && !e.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
              type: t,
              name: n
            };
          });
        }

        function lt(t, e) {
          for (var n, r = 0, i = t.length; r < i; ++r) {
            if ((n = t[r]).name === e) return n.value;
          }
        }

        function ht(t, e, n) {
          for (var r = 0, i = t.length; r < i; ++r) {
            if (t[r].name === e) {
              t[r] = ot, t = t.slice(0, r).concat(t.slice(r + 1));
              break;
            }
          }

          return null != n && t.push({
            name: e,
            value: n
          }), t;
        }

        ct.prototype = st.prototype = {
          constructor: ct,
          on: function on(t, e) {
            var n,
                r = this._,
                i = ut(t + "", r),
                a = -1,
                o = i.length;

            if (!(arguments.length < 2)) {
              if (null != e && "function" != typeof e) throw new Error("invalid callback: " + e);

              for (; ++a < o;) {
                if (n = (t = i[a]).type) r[n] = ht(r[n], t.name, e);else if (null == e) for (n in r) {
                  r[n] = ht(r[n], t.name, null);
                }
              }

              return this;
            }

            for (; ++a < o;) {
              if ((n = (t = i[a]).type) && (n = lt(r[n], t.name))) return n;
            }
          },
          copy: function copy() {
            var t = {},
                e = this._;

            for (var n in e) {
              t[n] = e[n].slice();
            }

            return new ct(t);
          },
          call: function call(t, e) {
            if ((n = arguments.length - 2) > 0) for (var n, r, i = new Array(n), a = 0; a < n; ++a) {
              i[a] = arguments[a + 2];
            }
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (a = 0, n = (r = this._[t]).length; a < n; ++a) {
              r[a].value.apply(e, i);
            }
          },
          apply: function apply(t, e, n) {
            if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);

            for (var r = this._[t], i = 0, a = r.length; i < a; ++i) {
              r[i].value.apply(e, n);
            }
          }
        };
        var ft = st;

        function dt() {}

        function pt(t) {
          return null == t ? dt : function () {
            return this.querySelector(t);
          };
        }

        function yt() {
          return [];
        }

        function gt(t) {
          return null == t ? yt : function () {
            return this.querySelectorAll(t);
          };
        }

        function mt(t) {
          return function () {
            return this.matches(t);
          };
        }

        function vt(t) {
          return new Array(t.length);
        }

        function bt(t, e) {
          this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
        }

        function _t(t, e, n, r, i, a) {
          for (var o, s = 0, c = e.length, u = a.length; s < u; ++s) {
            (o = e[s]) ? (o.__data__ = a[s], r[s] = o) : n[s] = new bt(t, a[s]);
          }

          for (; s < c; ++s) {
            (o = e[s]) && (i[s] = o);
          }
        }

        function xt(t, e, n, r, i, a, o) {
          var s,
              c,
              u,
              l = {},
              h = e.length,
              f = a.length,
              d = new Array(h);

          for (s = 0; s < h; ++s) {
            (c = e[s]) && (d[s] = u = "$" + o.call(c, c.__data__, s, e), u in l ? i[s] = c : l[u] = c);
          }

          for (s = 0; s < f; ++s) {
            (c = l[u = "$" + o.call(t, a[s], s, a)]) ? (r[s] = c, c.__data__ = a[s], l[u] = null) : n[s] = new bt(t, a[s]);
          }

          for (s = 0; s < h; ++s) {
            (c = e[s]) && l[d[s]] === c && (i[s] = c);
          }
        }

        function wt(t, e) {
          return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
        }

        bt.prototype = {
          constructor: bt,
          appendChild: function appendChild(t) {
            return this._parent.insertBefore(t, this._next);
          },
          insertBefore: function insertBefore(t, e) {
            return this._parent.insertBefore(t, e);
          },
          querySelector: function querySelector(t) {
            return this._parent.querySelector(t);
          },
          querySelectorAll: function querySelectorAll(t) {
            return this._parent.querySelectorAll(t);
          }
        };
        var kt = "http://www.w3.org/1999/xhtml";
        var Tt = {
          svg: "http://www.w3.org/2000/svg",
          xhtml: kt,
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace",
          xmlns: "http://www.w3.org/2000/xmlns/"
        };

        function Et(t) {
          var e = t += "",
              n = e.indexOf(":");
          return n >= 0 && "xmlns" !== (e = t.slice(0, n)) && (t = t.slice(n + 1)), Tt.hasOwnProperty(e) ? {
            space: Tt[e],
            local: t
          } : t;
        }

        function Ct(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function St(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function At(t, e) {
          return function () {
            this.setAttribute(t, e);
          };
        }

        function Mt(t, e) {
          return function () {
            this.setAttributeNS(t.space, t.local, e);
          };
        }

        function Nt(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttribute(t) : this.setAttribute(t, n);
          };
        }

        function Dt(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
          };
        }

        function Ot(t) {
          return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
        }

        function Bt(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function Lt(t, e, n) {
          return function () {
            this.style.setProperty(t, e, n);
          };
        }

        function It(t, e, n) {
          return function () {
            var r = e.apply(this, arguments);
            null == r ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
          };
        }

        function Rt(t, e) {
          return t.style.getPropertyValue(e) || Ot(t).getComputedStyle(t, null).getPropertyValue(e);
        }

        function Pt(t) {
          return function () {
            delete this[t];
          };
        }

        function Ft(t, e) {
          return function () {
            this[t] = e;
          };
        }

        function jt(t, e) {
          return function () {
            var n = e.apply(this, arguments);
            null == n ? delete this[t] : this[t] = n;
          };
        }

        function Yt(t) {
          return t.trim().split(/^|\s+/);
        }

        function Ut(t) {
          return t.classList || new zt(t);
        }

        function zt(t) {
          this._node = t, this._names = Yt(t.getAttribute("class") || "");
        }

        function qt(t, e) {
          for (var n = Ut(t), r = -1, i = e.length; ++r < i;) {
            n.add(e[r]);
          }
        }

        function $t(t, e) {
          for (var n = Ut(t), r = -1, i = e.length; ++r < i;) {
            n.remove(e[r]);
          }
        }

        function Ht(t) {
          return function () {
            qt(this, t);
          };
        }

        function Wt(t) {
          return function () {
            $t(this, t);
          };
        }

        function Vt(t, e) {
          return function () {
            (e.apply(this, arguments) ? qt : $t)(this, t);
          };
        }

        function Gt() {
          this.textContent = "";
        }

        function Xt(t) {
          return function () {
            this.textContent = t;
          };
        }

        function Zt(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.textContent = null == e ? "" : e;
          };
        }

        function Kt() {
          this.innerHTML = "";
        }

        function Qt(t) {
          return function () {
            this.innerHTML = t;
          };
        }

        function Jt(t) {
          return function () {
            var e = t.apply(this, arguments);
            this.innerHTML = null == e ? "" : e;
          };
        }

        function te() {
          this.nextSibling && this.parentNode.appendChild(this);
        }

        function ee() {
          this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
        }

        function ne(t) {
          return function () {
            var e = this.ownerDocument,
                n = this.namespaceURI;
            return n === kt && e.documentElement.namespaceURI === kt ? e.createElement(t) : e.createElementNS(n, t);
          };
        }

        function re(t) {
          return function () {
            return this.ownerDocument.createElementNS(t.space, t.local);
          };
        }

        function ie(t) {
          var e = Et(t);
          return (e.local ? re : ne)(e);
        }

        function ae() {
          return null;
        }

        function oe() {
          var t = this.parentNode;
          t && t.removeChild(this);
        }

        function se() {
          var t = this.cloneNode(!1),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        function ce() {
          var t = this.cloneNode(!0),
              e = this.parentNode;
          return e ? e.insertBefore(t, this.nextSibling) : t;
        }

        zt.prototype = {
          add: function add(t) {
            this._names.indexOf(t) < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
          },
          remove: function remove(t) {
            var e = this._names.indexOf(t);

            e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
          },
          contains: function contains(t) {
            return this._names.indexOf(t) >= 0;
          }
        };
        var ue = {},
            le = null;

        function he(t, e, n) {
          return t = fe(t, e, n), function (e) {
            var n = e.relatedTarget;
            n && (n === this || 8 & n.compareDocumentPosition(this)) || t.call(this, e);
          };
        }

        function fe(t, e, n) {
          return function (r) {
            var i = le;
            le = r;

            try {
              t.call(this, this.__data__, e, n);
            } finally {
              le = i;
            }
          };
        }

        function de(t) {
          return t.trim().split(/^|\s+/).map(function (t) {
            var e = "",
                n = t.indexOf(".");
            return n >= 0 && (e = t.slice(n + 1), t = t.slice(0, n)), {
              type: t,
              name: e
            };
          });
        }

        function pe(t) {
          return function () {
            var e = this.__on;

            if (e) {
              for (var n, r = 0, i = -1, a = e.length; r < a; ++r) {
                n = e[r], t.type && n.type !== t.type || n.name !== t.name ? e[++i] = n : this.removeEventListener(n.type, n.listener, n.capture);
              }

              ++i ? e.length = i : delete this.__on;
            }
          };
        }

        function ye(t, e, n) {
          var r = ue.hasOwnProperty(t.type) ? he : fe;
          return function (i, a, o) {
            var s,
                c = this.__on,
                u = r(e, a, o);
            if (c) for (var l = 0, h = c.length; l < h; ++l) {
              if ((s = c[l]).type === t.type && s.name === t.name) return this.removeEventListener(s.type, s.listener, s.capture), this.addEventListener(s.type, s.listener = u, s.capture = n), void (s.value = e);
            }
            this.addEventListener(t.type, u, n), s = {
              type: t.type,
              name: t.name,
              value: e,
              listener: u,
              capture: n
            }, c ? c.push(s) : this.__on = [s];
          };
        }

        function ge(t, e, n, r) {
          var i = le;
          t.sourceEvent = le, le = t;

          try {
            return e.apply(n, r);
          } finally {
            le = i;
          }
        }

        function me(t, e, n) {
          var r = Ot(t),
              i = r.CustomEvent;
          "function" == typeof i ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
        }

        function ve(t, e) {
          return function () {
            return me(this, t, e);
          };
        }

        function be(t, e) {
          return function () {
            return me(this, t, e.apply(this, arguments));
          };
        }

        "undefined" != typeof document && ("onmouseenter" in document.documentElement || (ue = {
          mouseenter: "mouseover",
          mouseleave: "mouseout"
        }));
        var _e = [null];

        function xe(t, e) {
          this._groups = t, this._parents = e;
        }

        function we() {
          return new xe([[document.documentElement]], _e);
        }

        xe.prototype = we.prototype = {
          constructor: xe,
          select: function select(t) {
            "function" != typeof t && (t = pt(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o, s = e[i], c = s.length, u = r[i] = new Array(c), l = 0; l < c; ++l) {
                (a = s[l]) && (o = t.call(a, a.__data__, l, s)) && ("__data__" in a && (o.__data__ = a.__data__), u[l] = o);
              }
            }

            return new xe(r, this._parents);
          },
          selectAll: function selectAll(t) {
            "function" != typeof t && (t = gt(t));

            for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a) {
              for (var o, s = e[a], c = s.length, u = 0; u < c; ++u) {
                (o = s[u]) && (r.push(t.call(o, o.__data__, u, s)), i.push(o));
              }
            }

            return new xe(r, i);
          },
          filter: function filter(t) {
            "function" != typeof t && (t = mt(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new xe(r, this._parents);
          },
          data: function data(t, e) {
            if (!t) return p = new Array(this.size()), l = -1, this.each(function (t) {
              p[++l] = t;
            }), p;
            var n,
                r = e ? xt : _t,
                i = this._parents,
                a = this._groups;
            "function" != typeof t && (n = t, t = function t() {
              return n;
            });

            for (var o = a.length, s = new Array(o), c = new Array(o), u = new Array(o), l = 0; l < o; ++l) {
              var h = i[l],
                  f = a[l],
                  d = f.length,
                  p = t.call(h, h && h.__data__, l, i),
                  y = p.length,
                  g = c[l] = new Array(y),
                  m = s[l] = new Array(y);
              r(h, f, g, m, u[l] = new Array(d), p, e);

              for (var v, b, _ = 0, x = 0; _ < y; ++_) {
                if (v = g[_]) {
                  for (_ >= x && (x = _ + 1); !(b = m[x]) && ++x < y;) {
                    ;
                  }

                  v._next = b || null;
                }
              }
            }

            return (s = new xe(s, i))._enter = c, s._exit = u, s;
          },
          enter: function enter() {
            return new xe(this._enter || this._groups.map(vt), this._parents);
          },
          exit: function exit() {
            return new xe(this._exit || this._groups.map(vt), this._parents);
          },
          join: function join(t, e, n) {
            var r = this.enter(),
                i = this,
                a = this.exit();
            return r = "function" == typeof t ? t(r) : r.append(t + ""), null != e && (i = e(i)), null == n ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
          },
          merge: function merge(t) {
            for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
              for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
                (c = u[d] || l[d]) && (f[d] = c);
              }
            }

            for (; s < r; ++s) {
              o[s] = e[s];
            }

            return new xe(o, this._parents);
          },
          order: function order() {
            for (var t = this._groups, e = -1, n = t.length; ++e < n;) {
              for (var r, i = t[e], a = i.length - 1, o = i[a]; --a >= 0;) {
                (r = i[a]) && (o && 4 ^ r.compareDocumentPosition(o) && o.parentNode.insertBefore(r, o), o = r);
              }
            }

            return this;
          },
          sort: function sort(t) {
            function e(e, n) {
              return e && n ? t(e.__data__, n.__data__) : !e - !n;
            }

            t || (t = wt);

            for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
              for (var o, s = n[a], c = s.length, u = i[a] = new Array(c), l = 0; l < c; ++l) {
                (o = s[l]) && (u[l] = o);
              }

              u.sort(e);
            }

            return new xe(i, this._parents).order();
          },
          call: function call() {
            var t = arguments[0];
            return arguments[0] = this, t.apply(null, arguments), this;
          },
          nodes: function nodes() {
            var t = new Array(this.size()),
                e = -1;
            return this.each(function () {
              t[++e] = this;
            }), t;
          },
          node: function node() {
            for (var t = this._groups, e = 0, n = t.length; e < n; ++e) {
              for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
                var o = r[i];
                if (o) return o;
              }
            }

            return null;
          },
          size: function size() {
            var t = 0;
            return this.each(function () {
              ++t;
            }), t;
          },
          empty: function empty() {
            return !this.node();
          },
          each: function each(t) {
            for (var e = this._groups, n = 0, r = e.length; n < r; ++n) {
              for (var i, a = e[n], o = 0, s = a.length; o < s; ++o) {
                (i = a[o]) && t.call(i, i.__data__, o, a);
              }
            }

            return this;
          },
          attr: function attr(t, e) {
            var n = Et(t);

            if (arguments.length < 2) {
              var r = this.node();
              return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
            }

            return this.each((null == e ? n.local ? St : Ct : "function" == typeof e ? n.local ? Dt : Nt : n.local ? Mt : At)(n, e));
          },
          style: function style(t, e, n) {
            return arguments.length > 1 ? this.each((null == e ? Bt : "function" == typeof e ? It : Lt)(t, e, null == n ? "" : n)) : Rt(this.node(), t);
          },
          property: function property(t, e) {
            return arguments.length > 1 ? this.each((null == e ? Pt : "function" == typeof e ? jt : Ft)(t, e)) : this.node()[t];
          },
          classed: function classed(t, e) {
            var n = Yt(t + "");

            if (arguments.length < 2) {
              for (var r = Ut(this.node()), i = -1, a = n.length; ++i < a;) {
                if (!r.contains(n[i])) return !1;
              }

              return !0;
            }

            return this.each(("function" == typeof e ? Vt : e ? Ht : Wt)(n, e));
          },
          text: function text(t) {
            return arguments.length ? this.each(null == t ? Gt : ("function" == typeof t ? Zt : Xt)(t)) : this.node().textContent;
          },
          html: function html(t) {
            return arguments.length ? this.each(null == t ? Kt : ("function" == typeof t ? Jt : Qt)(t)) : this.node().innerHTML;
          },
          raise: function raise() {
            return this.each(te);
          },
          lower: function lower() {
            return this.each(ee);
          },
          append: function append(t) {
            var e = "function" == typeof t ? t : ie(t);
            return this.select(function () {
              return this.appendChild(e.apply(this, arguments));
            });
          },
          insert: function insert(t, e) {
            var n = "function" == typeof t ? t : ie(t),
                r = null == e ? ae : "function" == typeof e ? e : pt(e);
            return this.select(function () {
              return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
            });
          },
          remove: function remove() {
            return this.each(oe);
          },
          clone: function clone(t) {
            return this.select(t ? ce : se);
          },
          datum: function datum(t) {
            return arguments.length ? this.property("__data__", t) : this.node().__data__;
          },
          on: function on(t, e, n) {
            var r,
                i,
                a = de(t + ""),
                o = a.length;

            if (!(arguments.length < 2)) {
              for (s = e ? ye : pe, null == n && (n = !1), r = 0; r < o; ++r) {
                this.each(s(a[r], e, n));
              }

              return this;
            }

            var s = this.node().__on;

            if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
              for (r = 0, c = s[u]; r < o; ++r) {
                if ((i = a[r]).type === c.type && i.name === c.name) return c.value;
              }
            }
          },
          dispatch: function dispatch(t, e) {
            return this.each(("function" == typeof e ? be : ve)(t, e));
          }
        };
        var ke = we;

        function Te(t) {
          return "string" == typeof t ? new xe([[document.querySelector(t)]], [document.documentElement]) : new xe([[t]], _e);
        }

        function Ee() {
          le.stopImmediatePropagation();
        }

        function Ce() {
          le.preventDefault(), le.stopImmediatePropagation();
        }

        function Se(t) {
          var e = t.document.documentElement,
              n = Te(t).on("dragstart.drag", Ce, !0);
          "onselectstart" in e ? n.on("selectstart.drag", Ce, !0) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
        }

        function Ae(t, e) {
          var n = t.document.documentElement,
              r = Te(t).on("dragstart.drag", null);
          e && (r.on("click.drag", Ce, !0), setTimeout(function () {
            r.on("click.drag", null);
          }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
        }

        function Me(t, e, n) {
          t.prototype = e.prototype = n, n.constructor = t;
        }

        function Ne(t, e) {
          var n = Object.create(t.prototype);

          for (var r in e) {
            n[r] = e[r];
          }

          return n;
        }

        function De() {}

        var Oe = 1 / .7,
            Be = "\\s*([+-]?\\d+)\\s*",
            Le = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
            Ie = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
            Re = /^#([0-9a-f]{3,8})$/,
            Pe = new RegExp("^rgb\\(" + [Be, Be, Be] + "\\)$"),
            Fe = new RegExp("^rgb\\(" + [Ie, Ie, Ie] + "\\)$"),
            je = new RegExp("^rgba\\(" + [Be, Be, Be, Le] + "\\)$"),
            Ye = new RegExp("^rgba\\(" + [Ie, Ie, Ie, Le] + "\\)$"),
            Ue = new RegExp("^hsl\\(" + [Le, Ie, Ie] + "\\)$"),
            ze = new RegExp("^hsla\\(" + [Le, Ie, Ie, Le] + "\\)$"),
            qe = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };

        function $e() {
          return this.rgb().formatHex();
        }

        function He() {
          return this.rgb().formatRgb();
        }

        function We(t) {
          var e, n;
          return t = (t + "").trim().toLowerCase(), (e = Re.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? Ve(e) : 3 === n ? new Ke(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? Ge(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? Ge(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Pe.exec(t)) ? new Ke(e[1], e[2], e[3], 1) : (e = Fe.exec(t)) ? new Ke(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = je.exec(t)) ? Ge(e[1], e[2], e[3], e[4]) : (e = Ye.exec(t)) ? Ge(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Ue.exec(t)) ? en(e[1], e[2] / 100, e[3] / 100, 1) : (e = ze.exec(t)) ? en(e[1], e[2] / 100, e[3] / 100, e[4]) : qe.hasOwnProperty(t) ? Ve(qe[t]) : "transparent" === t ? new Ke(NaN, NaN, NaN, 0) : null;
        }

        function Ve(t) {
          return new Ke(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
        }

        function Ge(t, e, n, r) {
          return r <= 0 && (t = e = n = NaN), new Ke(t, e, n, r);
        }

        function Xe(t) {
          return t instanceof De || (t = We(t)), t ? new Ke((t = t.rgb()).r, t.g, t.b, t.opacity) : new Ke();
        }

        function Ze(t, e, n, r) {
          return 1 === arguments.length ? Xe(t) : new Ke(t, e, n, null == r ? 1 : r);
        }

        function Ke(t, e, n, r) {
          this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
        }

        function Qe() {
          return "#" + tn(this.r) + tn(this.g) + tn(this.b);
        }

        function Je() {
          var t = this.opacity;
          return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
        }

        function tn(t) {
          return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
        }

        function en(t, e, n, r) {
          return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new an(t, e, n, r);
        }

        function nn(t) {
          if (t instanceof an) return new an(t.h, t.s, t.l, t.opacity);
          if (t instanceof De || (t = We(t)), !t) return new an();
          if (t instanceof an) return t;
          var e = (t = t.rgb()).r / 255,
              n = t.g / 255,
              r = t.b / 255,
              i = Math.min(e, n, r),
              a = Math.max(e, n, r),
              o = NaN,
              s = a - i,
              c = (a + i) / 2;
          return s ? (o = e === a ? (n - r) / s + 6 * (n < r) : n === a ? (r - e) / s + 2 : (e - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new an(o, s, c, t.opacity);
        }

        function rn(t, e, n, r) {
          return 1 === arguments.length ? nn(t) : new an(t, e, n, null == r ? 1 : r);
        }

        function an(t, e, n, r) {
          this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
        }

        function on(t, e, n) {
          return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
        }

        function sn(t, e, n, r, i) {
          var a = t * t,
              o = a * t;
          return ((1 - 3 * t + 3 * a - o) * e + (4 - 6 * a + 3 * o) * n + (1 + 3 * t + 3 * a - 3 * o) * r + o * i) / 6;
        }

        function cn(t) {
          var e = t.length - 1;
          return function (n) {
            var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e),
                i = t[r],
                a = t[r + 1],
                o = r > 0 ? t[r - 1] : 2 * i - a,
                s = r < e - 1 ? t[r + 2] : 2 * a - i;
            return sn((n - r / e) * e, o, i, a, s);
          };
        }

        function un(t) {
          var e = t.length;
          return function (n) {
            var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e),
                i = t[(r + e - 1) % e],
                a = t[r % e],
                o = t[(r + 1) % e],
                s = t[(r + 2) % e];
            return sn((n - r / e) * e, i, a, o, s);
          };
        }

        function ln(t) {
          return function () {
            return t;
          };
        }

        function hn(t, e) {
          return function (n) {
            return t + n * e;
          };
        }

        function fn(t, e) {
          var n = e - t;
          return n ? hn(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : ln(isNaN(t) ? e : t);
        }

        function dn(t, e) {
          var n = e - t;
          return n ? hn(t, n) : ln(isNaN(t) ? e : t);
        }

        Me(De, We, {
          copy: function copy(t) {
            return Object.assign(new this.constructor(), this, t);
          },
          displayable: function displayable() {
            return this.rgb().displayable();
          },
          hex: $e,
          formatHex: $e,
          formatHsl: function formatHsl() {
            return nn(this).formatHsl();
          },
          formatRgb: He,
          toString: He
        }), Me(Ke, Ze, Ne(De, {
          brighter: function brighter(t) {
            return t = null == t ? Oe : Math.pow(Oe, t), new Ke(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new Ke(this.r * t, this.g * t, this.b * t, this.opacity);
          },
          rgb: function rgb() {
            return this;
          },
          displayable: function displayable() {
            return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
          },
          hex: Qe,
          formatHex: Qe,
          formatRgb: Je,
          toString: Je
        })), Me(an, rn, Ne(De, {
          brighter: function brighter(t) {
            return t = null == t ? Oe : Math.pow(Oe, t), new an(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new an(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = this.h % 360 + 360 * (this.h < 0),
                e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
                n = this.l,
                r = n + (n < .5 ? n : 1 - n) * e,
                i = 2 * n - r;
            return new Ke(on(t >= 240 ? t - 240 : t + 120, i, r), on(t, i, r), on(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
          },
          displayable: function displayable() {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
          },
          formatHsl: function formatHsl() {
            var t = this.opacity;
            return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
          }
        }));

        var pn = function t(e) {
          var n = function (t) {
            return 1 == (t = +t) ? dn : function (e, n) {
              return n - e ? function (t, e, n) {
                return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
                  return Math.pow(t + r * e, n);
                };
              }(e, n, t) : ln(isNaN(e) ? n : e);
            };
          }(e);

          function r(t, e) {
            var r = n((t = Ze(t)).r, (e = Ze(e)).r),
                i = n(t.g, e.g),
                a = n(t.b, e.b),
                o = dn(t.opacity, e.opacity);
            return function (e) {
              return t.r = r(e), t.g = i(e), t.b = a(e), t.opacity = o(e), t + "";
            };
          }

          return r.gamma = t, r;
        }(1);

        function yn(t) {
          return function (e) {
            var n,
                r,
                i = e.length,
                a = new Array(i),
                o = new Array(i),
                s = new Array(i);

            for (n = 0; n < i; ++n) {
              r = Ze(e[n]), a[n] = r.r || 0, o[n] = r.g || 0, s[n] = r.b || 0;
            }

            return a = t(a), o = t(o), s = t(s), r.opacity = 1, function (t) {
              return r.r = a(t), r.g = o(t), r.b = s(t), r + "";
            };
          };
        }

        var gn = yn(cn),
            mn = yn(un);

        function vn(t, e) {
          e || (e = []);
          var n,
              r = t ? Math.min(e.length, t.length) : 0,
              i = e.slice();
          return function (a) {
            for (n = 0; n < r; ++n) {
              i[n] = t[n] * (1 - a) + e[n] * a;
            }

            return i;
          };
        }

        function bn(t) {
          return ArrayBuffer.isView(t) && !(t instanceof DataView);
        }

        function _n(t, e) {
          return (bn(e) ? vn : xn)(t, e);
        }

        function xn(t, e) {
          var n,
              r = e ? e.length : 0,
              i = t ? Math.min(r, t.length) : 0,
              a = new Array(i),
              o = new Array(r);

          for (n = 0; n < i; ++n) {
            a[n] = An(t[n], e[n]);
          }

          for (; n < r; ++n) {
            o[n] = e[n];
          }

          return function (t) {
            for (n = 0; n < i; ++n) {
              o[n] = a[n](t);
            }

            return o;
          };
        }

        function wn(t, e) {
          var n = new Date();
          return t = +t, e = +e, function (r) {
            return n.setTime(t * (1 - r) + e * r), n;
          };
        }

        function kn(t, e) {
          return t = +t, e = +e, function (n) {
            return t * (1 - n) + e * n;
          };
        }

        function Tn(t, e) {
          var n,
              r = {},
              i = {};

          for (n in null !== t && "object" == typeof t || (t = {}), null !== e && "object" == typeof e || (e = {}), e) {
            n in t ? r[n] = An(t[n], e[n]) : i[n] = e[n];
          }

          return function (t) {
            for (n in r) {
              i[n] = r[n](t);
            }

            return i;
          };
        }

        var En = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            Cn = new RegExp(En.source, "g");

        function Sn(t, e) {
          var n,
              r,
              i,
              a = En.lastIndex = Cn.lastIndex = 0,
              o = -1,
              s = [],
              c = [];

          for (t += "", e += ""; (n = En.exec(t)) && (r = Cn.exec(e));) {
            (i = r.index) > a && (i = e.slice(a, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (r = r[0]) ? s[o] ? s[o] += r : s[++o] = r : (s[++o] = null, c.push({
              i: o,
              x: kn(n, r)
            })), a = Cn.lastIndex;
          }

          return a < e.length && (i = e.slice(a), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? c[0] ? function (t) {
            return function (e) {
              return t(e) + "";
            };
          }(c[0].x) : function (t) {
            return function () {
              return t;
            };
          }(e) : (e = c.length, function (t) {
            for (var n, r = 0; r < e; ++r) {
              s[(n = c[r]).i] = n.x(t);
            }

            return s.join("");
          });
        }

        function An(t, e) {
          var n,
              r = typeof e;
          return null == e || "boolean" === r ? ln(e) : ("number" === r ? kn : "string" === r ? (n = We(e)) ? (e = n, pn) : Sn : e instanceof We ? pn : e instanceof Date ? wn : bn(e) ? vn : Array.isArray(e) ? xn : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? Tn : kn)(t, e);
        }

        function Mn() {
          for (var t, e = le; t = e.sourceEvent;) {
            e = t;
          }

          return e;
        }

        function Nn(t, e) {
          var n = t.ownerSVGElement || t;

          if (n.createSVGPoint) {
            var r = n.createSVGPoint();
            return r.x = e.clientX, r.y = e.clientY, [(r = r.matrixTransform(t.getScreenCTM().inverse())).x, r.y];
          }

          var i = t.getBoundingClientRect();
          return [e.clientX - i.left - t.clientLeft, e.clientY - i.top - t.clientTop];
        }

        function Dn(t, e, n) {
          arguments.length < 3 && (n = e, e = Mn().changedTouches);

          for (var r, i = 0, a = e ? e.length : 0; i < a; ++i) {
            if ((r = e[i]).identifier === n) return Nn(t, r);
          }

          return null;
        }

        function On(t) {
          var e = Mn();
          return e.changedTouches && (e = e.changedTouches[0]), Nn(t, e);
        }

        var Bn,
            Ln,
            In = 0,
            Rn = 0,
            Pn = 0,
            Fn = 0,
            jn = 0,
            Yn = 0,
            Un = "object" == typeof performance && performance.now ? performance : Date,
            zn = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (t) {
          setTimeout(t, 17);
        };

        function qn() {
          return jn || (zn($n), jn = Un.now() + Yn);
        }

        function $n() {
          jn = 0;
        }

        function Hn() {
          this._call = this._time = this._next = null;
        }

        function Wn(t, e, n) {
          var r = new Hn();
          return r.restart(t, e, n), r;
        }

        function Vn() {
          qn(), ++In;

          for (var t, e = Bn; e;) {
            (t = jn - e._time) >= 0 && e._call.call(null, t), e = e._next;
          }

          --In;
        }

        function Gn() {
          jn = (Fn = Un.now()) + Yn, In = Rn = 0;

          try {
            Vn();
          } finally {
            In = 0, function () {
              for (var t, e, n = Bn, r = 1 / 0; n;) {
                n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : Bn = e);
              }

              Ln = t, Zn(r);
            }(), jn = 0;
          }
        }

        function Xn() {
          var t = Un.now(),
              e = t - Fn;
          e > 1e3 && (Yn -= e, Fn = t);
        }

        function Zn(t) {
          In || (Rn && (Rn = clearTimeout(Rn)), t - jn > 24 ? (t < 1 / 0 && (Rn = setTimeout(Gn, t - Un.now() - Yn)), Pn && (Pn = clearInterval(Pn))) : (Pn || (Fn = Un.now(), Pn = setInterval(Xn, 1e3)), In = 1, zn(Gn)));
        }

        function Kn(t, e, n) {
          var r = new Hn();
          return e = null == e ? 0 : +e, r.restart(function (n) {
            r.stop(), t(n + e);
          }, e, n), r;
        }

        Hn.prototype = Wn.prototype = {
          constructor: Hn,
          restart: function restart(t, e, n) {
            if ("function" != typeof t) throw new TypeError("callback is not a function");
            n = (null == n ? qn() : +n) + (null == e ? 0 : +e), this._next || Ln === this || (Ln ? Ln._next = this : Bn = this, Ln = this), this._call = t, this._time = n, Zn();
          },
          stop: function stop() {
            this._call && (this._call = null, this._time = 1 / 0, Zn());
          }
        };
        var Qn = ft("start", "end", "cancel", "interrupt"),
            Jn = [];

        function tr(t, e, n, r, i, a) {
          var o = t.__transition;

          if (o) {
            if (n in o) return;
          } else t.__transition = {};

          !function (t, e, n) {
            var r,
                i = t.__transition;

            function a(c) {
              var u, l, h, f;
              if (1 !== n.state) return s();

              for (u in i) {
                if ((f = i[u]).name === n.name) {
                  if (3 === f.state) return Kn(a);
                  4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", t, t.__data__, f.index, f.group), delete i[u]) : +u < e && (f.state = 6, f.timer.stop(), f.on.call("cancel", t, t.__data__, f.index, f.group), delete i[u]);
                }
              }

              if (Kn(function () {
                3 === n.state && (n.state = 4, n.timer.restart(o, n.delay, n.time), o(c));
              }), n.state = 2, n.on.call("start", t, t.__data__, n.index, n.group), 2 === n.state) {
                for (n.state = 3, r = new Array(h = n.tween.length), u = 0, l = -1; u < h; ++u) {
                  (f = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (r[++l] = f);
                }

                r.length = l + 1;
              }
            }

            function o(e) {
              for (var i = e < n.duration ? n.ease.call(null, e / n.duration) : (n.timer.restart(s), n.state = 5, 1), a = -1, o = r.length; ++a < o;) {
                r[a].call(t, i);
              }

              5 === n.state && (n.on.call("end", t, t.__data__, n.index, n.group), s());
            }

            function s() {
              for (var r in n.state = 6, n.timer.stop(), delete i[e], i) {
                return;
              }

              delete t.__transition;
            }

            i[e] = n, n.timer = Wn(function (t) {
              n.state = 1, n.timer.restart(a, n.delay, n.time), n.delay <= t && a(t - n.delay);
            }, 0, n.time);
          }(t, n, {
            name: e,
            index: r,
            group: i,
            on: Qn,
            tween: Jn,
            time: a.time,
            delay: a.delay,
            duration: a.duration,
            ease: a.ease,
            timer: null,
            state: 0
          });
        }

        function er(t, e) {
          var n = rr(t, e);
          if (n.state > 0) throw new Error("too late; already scheduled");
          return n;
        }

        function nr(t, e) {
          var n = rr(t, e);
          if (n.state > 3) throw new Error("too late; already running");
          return n;
        }

        function rr(t, e) {
          var n = t.__transition;
          if (!n || !(n = n[e])) throw new Error("transition not found");
          return n;
        }

        function ir(t, e) {
          var n,
              r,
              i,
              a = t.__transition,
              o = !0;

          if (a) {
            for (i in e = null == e ? null : e + "", a) {
              (n = a[i]).name === e ? (r = n.state > 2 && n.state < 5, n.state = 6, n.timer.stop(), n.on.call(r ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete a[i]) : o = !1;
            }

            o && delete t.__transition;
          }
        }

        var ar,
            or,
            sr,
            cr,
            ur = 180 / Math.PI,
            lr = {
          translateX: 0,
          translateY: 0,
          rotate: 0,
          skewX: 0,
          scaleX: 1,
          scaleY: 1
        };

        function hr(t, e, n, r, i, a) {
          var o, s, c;
          return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
            translateX: i,
            translateY: a,
            rotate: Math.atan2(e, t) * ur,
            skewX: Math.atan(c) * ur,
            scaleX: o,
            scaleY: s
          };
        }

        function fr(t, e, n, r) {
          function i(t) {
            return t.length ? t.pop() + " " : "";
          }

          return function (a, o) {
            var s = [],
                c = [];
            return a = t(a), o = t(o), function (t, r, i, a, o, s) {
              if (t !== i || r !== a) {
                var c = o.push("translate(", null, e, null, n);
                s.push({
                  i: c - 4,
                  x: kn(t, i)
                }, {
                  i: c - 2,
                  x: kn(r, a)
                });
              } else (i || a) && o.push("translate(" + i + e + a + n);
            }(a.translateX, a.translateY, o.translateX, o.translateY, s, c), function (t, e, n, a) {
              t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), a.push({
                i: n.push(i(n) + "rotate(", null, r) - 2,
                x: kn(t, e)
              })) : e && n.push(i(n) + "rotate(" + e + r);
            }(a.rotate, o.rotate, s, c), function (t, e, n, a) {
              t !== e ? a.push({
                i: n.push(i(n) + "skewX(", null, r) - 2,
                x: kn(t, e)
              }) : e && n.push(i(n) + "skewX(" + e + r);
            }(a.skewX, o.skewX, s, c), function (t, e, n, r, a, o) {
              if (t !== n || e !== r) {
                var s = a.push(i(a) + "scale(", null, ",", null, ")");
                o.push({
                  i: s - 4,
                  x: kn(t, n)
                }, {
                  i: s - 2,
                  x: kn(e, r)
                });
              } else 1 === n && 1 === r || a.push(i(a) + "scale(" + n + "," + r + ")");
            }(a.scaleX, a.scaleY, o.scaleX, o.scaleY, s, c), a = o = null, function (t) {
              for (var e, n = -1, r = c.length; ++n < r;) {
                s[(e = c[n]).i] = e.x(t);
              }

              return s.join("");
            };
          };
        }

        var dr = fr(function (t) {
          return "none" === t ? lr : (ar || (ar = document.createElement("DIV"), or = document.documentElement, sr = document.defaultView), ar.style.transform = t, t = sr.getComputedStyle(or.appendChild(ar), null).getPropertyValue("transform"), or.removeChild(ar), hr(+(t = t.slice(7, -1).split(","))[0], +t[1], +t[2], +t[3], +t[4], +t[5]));
        }, "px, ", "px)", "deg)"),
            pr = fr(function (t) {
          return null == t ? lr : (cr || (cr = document.createElementNS("http://www.w3.org/2000/svg", "g")), cr.setAttribute("transform", t), (t = cr.transform.baseVal.consolidate()) ? hr((t = t.matrix).a, t.b, t.c, t.d, t.e, t.f) : lr);
        }, ", ", ")", ")");

        function yr(t, e) {
          var n, r;
          return function () {
            var i = nr(this, t),
                a = i.tween;
            if (a !== n) for (var o = 0, s = (r = n = a).length; o < s; ++o) {
              if (r[o].name === e) {
                (r = r.slice()).splice(o, 1);
                break;
              }
            }
            i.tween = r;
          };
        }

        function gr(t, e, n) {
          var r, i;
          if ("function" != typeof n) throw new Error();
          return function () {
            var a = nr(this, t),
                o = a.tween;

            if (o !== r) {
              i = (r = o).slice();

              for (var s = {
                name: e,
                value: n
              }, c = 0, u = i.length; c < u; ++c) {
                if (i[c].name === e) {
                  i[c] = s;
                  break;
                }
              }

              c === u && i.push(s);
            }

            a.tween = i;
          };
        }

        function mr(t, e, n) {
          var r = t._id;
          return t.each(function () {
            var t = nr(this, r);
            (t.value || (t.value = {}))[e] = n.apply(this, arguments);
          }), function (t) {
            return rr(t, r).value[e];
          };
        }

        function vr(t, e) {
          var n;
          return ("number" == typeof e ? kn : e instanceof We ? pn : (n = We(e)) ? (e = n, pn) : Sn)(t, e);
        }

        function br(t) {
          return function () {
            this.removeAttribute(t);
          };
        }

        function _r(t) {
          return function () {
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function xr(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttribute(t);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function wr(t, e, n) {
          var r,
              i,
              a = n + "";
          return function () {
            var o = this.getAttributeNS(t.space, t.local);
            return o === a ? null : o === r ? i : i = e(r = o, n);
          };
        }

        function kr(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttribute(t)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttribute(t);
          };
        }

        function Tr(t, e, n) {
          var r, i, a;
          return function () {
            var o,
                s,
                c = n(this);
            if (null != c) return (o = this.getAttributeNS(t.space, t.local)) === (s = c + "") ? null : o === r && s === i ? a : (i = s, a = e(r = o, c));
            this.removeAttributeNS(t.space, t.local);
          };
        }

        function Er(t, e) {
          return function (n) {
            this.setAttribute(t, e.call(this, n));
          };
        }

        function Cr(t, e) {
          return function (n) {
            this.setAttributeNS(t.space, t.local, e.call(this, n));
          };
        }

        function Sr(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && Cr(t, i)), n;
          }

          return i._value = e, i;
        }

        function Ar(t, e) {
          var n, r;

          function i() {
            var i = e.apply(this, arguments);
            return i !== r && (n = (r = i) && Er(t, i)), n;
          }

          return i._value = e, i;
        }

        function Mr(t, e) {
          return function () {
            er(this, t).delay = +e.apply(this, arguments);
          };
        }

        function Nr(t, e) {
          return e = +e, function () {
            er(this, t).delay = e;
          };
        }

        function Dr(t, e) {
          return function () {
            nr(this, t).duration = +e.apply(this, arguments);
          };
        }

        function Or(t, e) {
          return e = +e, function () {
            nr(this, t).duration = e;
          };
        }

        function Br(t, e) {
          if ("function" != typeof e) throw new Error();
          return function () {
            nr(this, t).ease = e;
          };
        }

        function Lr(t, e, n) {
          var r,
              i,
              a = function (t) {
            return (t + "").trim().split(/^|\s+/).every(function (t) {
              var e = t.indexOf(".");
              return e >= 0 && (t = t.slice(0, e)), !t || "start" === t;
            });
          }(e) ? er : nr;
          return function () {
            var o = a(this, t),
                s = o.on;
            s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
          };
        }

        var Ir = ke.prototype.constructor;

        function Rr(t) {
          return function () {
            this.style.removeProperty(t);
          };
        }

        function Pr(t, e, n) {
          return function (r) {
            this.style.setProperty(t, e.call(this, r), n);
          };
        }

        function Fr(t, e, n) {
          var r, i;

          function a() {
            var a = e.apply(this, arguments);
            return a !== i && (r = (i = a) && Pr(t, a, n)), r;
          }

          return a._value = e, a;
        }

        function jr(t) {
          return function (e) {
            this.textContent = t.call(this, e);
          };
        }

        function Yr(t) {
          var e, n;

          function r() {
            var r = t.apply(this, arguments);
            return r !== n && (e = (n = r) && jr(r)), e;
          }

          return r._value = t, r;
        }

        var Ur = 0;

        function zr(t, e, n, r) {
          this._groups = t, this._parents = e, this._name = n, this._id = r;
        }

        function qr(t) {
          return ke().transition(t);
        }

        function $r() {
          return ++Ur;
        }

        var Hr = ke.prototype;

        function Wr(t) {
          return t * t * t;
        }

        function Vr(t) {
          return --t * t * t + 1;
        }

        function Gr(t) {
          return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
        }

        zr.prototype = qr.prototype = {
          constructor: zr,
          select: function select(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = pt(t));

            for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o) {
              for (var s, c, u = r[o], l = u.length, h = a[o] = new Array(l), f = 0; f < l; ++f) {
                (s = u[f]) && (c = t.call(s, s.__data__, f, u)) && ("__data__" in s && (c.__data__ = s.__data__), h[f] = c, tr(h[f], e, n, f, h, rr(s, n)));
              }
            }

            return new zr(a, this._parents, e, n);
          },
          selectAll: function selectAll(t) {
            var e = this._name,
                n = this._id;
            "function" != typeof t && (t = gt(t));

            for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s) {
              for (var c, u = r[s], l = u.length, h = 0; h < l; ++h) {
                if (c = u[h]) {
                  for (var f, d = t.call(c, c.__data__, h, u), p = rr(c, n), y = 0, g = d.length; y < g; ++y) {
                    (f = d[y]) && tr(f, e, n, y, d, p);
                  }

                  a.push(d), o.push(c);
                }
              }
            }

            return new zr(a, o, e, n);
          },
          filter: function filter(t) {
            "function" != typeof t && (t = mt(t));

            for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i) {
              for (var a, o = e[i], s = o.length, c = r[i] = [], u = 0; u < s; ++u) {
                (a = o[u]) && t.call(a, a.__data__, u, o) && c.push(a);
              }
            }

            return new zr(r, this._parents, this._name, this._id);
          },
          merge: function merge(t) {
            if (t._id !== this._id) throw new Error();

            for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s) {
              for (var c, u = e[s], l = n[s], h = u.length, f = o[s] = new Array(h), d = 0; d < h; ++d) {
                (c = u[d] || l[d]) && (f[d] = c);
              }
            }

            for (; s < r; ++s) {
              o[s] = e[s];
            }

            return new zr(o, this._parents, this._name, this._id);
          },
          selection: function selection() {
            return new Ir(this._groups, this._parents);
          },
          transition: function transition() {
            for (var t = this._name, e = this._id, n = $r(), r = this._groups, i = r.length, a = 0; a < i; ++a) {
              for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
                if (o = s[u]) {
                  var l = rr(o, e);
                  tr(o, t, n, u, s, {
                    time: l.time + l.delay + l.duration,
                    delay: 0,
                    duration: l.duration,
                    ease: l.ease
                  });
                }
              }
            }

            return new zr(r, this._parents, t, n);
          },
          call: Hr.call,
          nodes: Hr.nodes,
          node: Hr.node,
          size: Hr.size,
          empty: Hr.empty,
          each: Hr.each,
          on: function on(t, e) {
            var n = this._id;
            return arguments.length < 2 ? rr(this.node(), n).on.on(t) : this.each(Lr(n, t, e));
          },
          attr: function attr(t, e) {
            var n = Et(t),
                r = "transform" === n ? pr : vr;
            return this.attrTween(t, "function" == typeof e ? (n.local ? Tr : kr)(n, r, mr(this, "attr." + t, e)) : null == e ? (n.local ? _r : br)(n) : (n.local ? wr : xr)(n, r, e));
          },
          attrTween: function attrTween(t, e) {
            var n = "attr." + t;
            if (arguments.length < 2) return (n = this.tween(n)) && n._value;
            if (null == e) return this.tween(n, null);
            if ("function" != typeof e) throw new Error();
            var r = Et(t);
            return this.tween(n, (r.local ? Sr : Ar)(r, e));
          },
          style: function style(t, e, n) {
            var r = "transform" == (t += "") ? dr : vr;
            return null == e ? this.styleTween(t, function (t, e) {
              var n, r, i;
              return function () {
                var a = Rt(this, t),
                    o = (this.style.removeProperty(t), Rt(this, t));
                return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
              };
            }(t, r)).on("end.style." + t, Rr(t)) : "function" == typeof e ? this.styleTween(t, function (t, e, n) {
              var r, i, a;
              return function () {
                var o = Rt(this, t),
                    s = n(this),
                    c = s + "";
                return null == s && (this.style.removeProperty(t), c = s = Rt(this, t)), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
              };
            }(t, r, mr(this, "style." + t, e))).each(function (t, e) {
              var n,
                  r,
                  i,
                  a,
                  o = "style." + e,
                  s = "end." + o;
              return function () {
                var c = nr(this, t),
                    u = c.on,
                    l = null == c.value[o] ? a || (a = Rr(e)) : void 0;
                u === n && i === l || (r = (n = u).copy()).on(s, i = l), c.on = r;
              };
            }(this._id, t)) : this.styleTween(t, function (t, e, n) {
              var r,
                  i,
                  a = n + "";
              return function () {
                var o = Rt(this, t);
                return o === a ? null : o === r ? i : i = e(r = o, n);
              };
            }(t, r, e), n).on("end.style." + t, null);
          },
          styleTween: function styleTween(t, e, n) {
            var r = "style." + (t += "");
            if (arguments.length < 2) return (r = this.tween(r)) && r._value;
            if (null == e) return this.tween(r, null);
            if ("function" != typeof e) throw new Error();
            return this.tween(r, Fr(t, e, null == n ? "" : n));
          },
          text: function text(t) {
            return this.tween("text", "function" == typeof t ? function (t) {
              return function () {
                var e = t(this);
                this.textContent = null == e ? "" : e;
              };
            }(mr(this, "text", t)) : function (t) {
              return function () {
                this.textContent = t;
              };
            }(null == t ? "" : t + ""));
          },
          textTween: function textTween(t) {
            var e = "text";
            if (arguments.length < 1) return (e = this.tween(e)) && e._value;
            if (null == t) return this.tween(e, null);
            if ("function" != typeof t) throw new Error();
            return this.tween(e, Yr(t));
          },
          remove: function remove() {
            return this.on("end.remove", function (t) {
              return function () {
                var e = this.parentNode;

                for (var n in this.__transition) {
                  if (+n !== t) return;
                }

                e && e.removeChild(this);
              };
            }(this._id));
          },
          tween: function tween(t, e) {
            var n = this._id;

            if (t += "", arguments.length < 2) {
              for (var r, i = rr(this.node(), n).tween, a = 0, o = i.length; a < o; ++a) {
                if ((r = i[a]).name === t) return r.value;
              }

              return null;
            }

            return this.each((null == e ? yr : gr)(n, t, e));
          },
          delay: function delay(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? Mr : Nr)(e, t)) : rr(this.node(), e).delay;
          },
          duration: function duration(t) {
            var e = this._id;
            return arguments.length ? this.each(("function" == typeof t ? Dr : Or)(e, t)) : rr(this.node(), e).duration;
          },
          ease: function ease(t) {
            var e = this._id;
            return arguments.length ? this.each(Br(e, t)) : rr(this.node(), e).ease;
          },
          end: function end() {
            var t,
                e,
                n = this,
                r = n._id,
                i = n.size();
            return new Promise(function (a, o) {
              var s = {
                value: o
              },
                  c = {
                value: function value() {
                  0 == --i && a();
                }
              };
              n.each(function () {
                var n = nr(this, r),
                    i = n.on;
                i !== t && ((e = (t = i).copy())._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), n.on = e;
              });
            });
          }
        };
        var Xr = {
          time: null,
          delay: 0,
          duration: 250,
          ease: Gr
        };

        function Zr(t, e) {
          for (var n; !(n = t.__transition) || !(n = n[e]);) {
            if (!(t = t.parentNode)) return Xr.time = qn(), Xr;
          }

          return n;
        }

        ke.prototype.interrupt = function (t) {
          return this.each(function () {
            ir(this, t);
          });
        }, ke.prototype.transition = function (t) {
          var e, n;
          t instanceof zr ? (e = t._id, t = t._name) : (e = $r(), (n = Xr).time = qn(), t = null == t ? null : t + "");

          for (var r = this._groups, i = r.length, a = 0; a < i; ++a) {
            for (var o, s = r[a], c = s.length, u = 0; u < c; ++u) {
              (o = s[u]) && tr(o, t, e, u, s, n || Zr(o, e));
            }
          }

          return new zr(r, this._parents, t, e);
        };
        var Kr = [null];

        function Qr(t, e) {
          var n,
              r,
              i = t.__transition;
          if (i) for (r in e = null == e ? null : e + "", i) {
            if ((n = i[r]).state > 1 && n.name === e) return new zr([[t]], Kr, e, +r);
          }
          return null;
        }

        function Jr(t) {
          return function () {
            return t;
          };
        }

        function ti(t, e, n) {
          this.target = t, this.type = e, this.selection = n;
        }

        function ei() {
          le.stopImmediatePropagation();
        }

        function ni() {
          le.preventDefault(), le.stopImmediatePropagation();
        }

        var ri = {
          name: "drag"
        },
            ii = {
          name: "space"
        },
            ai = {
          name: "handle"
        },
            oi = {
          name: "center"
        };

        function si(t) {
          return [+t[0], +t[1]];
        }

        function ci(t) {
          return [si(t[0]), si(t[1])];
        }

        function ui(t) {
          return function (e) {
            return Dn(e, le.touches, t);
          };
        }

        var li = {
          name: "x",
          handles: ["w", "e"].map(vi),
          input: function input(t, e) {
            return null == t ? null : [[+t[0], e[0][1]], [+t[1], e[1][1]]];
          },
          output: function output(t) {
            return t && [t[0][0], t[1][0]];
          }
        },
            hi = {
          name: "y",
          handles: ["n", "s"].map(vi),
          input: function input(t, e) {
            return null == t ? null : [[e[0][0], +t[0]], [e[1][0], +t[1]]];
          },
          output: function output(t) {
            return t && [t[0][1], t[1][1]];
          }
        },
            fi = {
          name: "xy",
          handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(vi),
          input: function input(t) {
            return null == t ? null : ci(t);
          },
          output: function output(t) {
            return t;
          }
        },
            di = {
          overlay: "crosshair",
          selection: "move",
          n: "ns-resize",
          e: "ew-resize",
          s: "ns-resize",
          w: "ew-resize",
          nw: "nwse-resize",
          ne: "nesw-resize",
          se: "nwse-resize",
          sw: "nesw-resize"
        },
            pi = {
          e: "w",
          w: "e",
          nw: "ne",
          ne: "nw",
          se: "sw",
          sw: "se"
        },
            yi = {
          n: "s",
          s: "n",
          nw: "sw",
          ne: "se",
          se: "ne",
          sw: "nw"
        },
            gi = {
          overlay: 1,
          selection: 1,
          n: null,
          e: 1,
          s: null,
          w: -1,
          nw: -1,
          ne: 1,
          se: 1,
          sw: -1
        },
            mi = {
          overlay: 1,
          selection: 1,
          n: -1,
          e: null,
          s: 1,
          w: null,
          nw: -1,
          ne: -1,
          se: 1,
          sw: 1
        };

        function vi(t) {
          return {
            type: t
          };
        }

        function bi() {
          return !le.ctrlKey && !le.button;
        }

        function _i() {
          var t = this.ownerSVGElement || this;
          return t.hasAttribute("viewBox") ? [[(t = t.viewBox.baseVal).x, t.y], [t.x + t.width, t.y + t.height]] : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]];
        }

        function xi() {
          return navigator.maxTouchPoints || "ontouchstart" in this;
        }

        function wi(t) {
          for (; !t.__brush;) {
            if (!(t = t.parentNode)) return;
          }

          return t.__brush;
        }

        function ki(t) {
          return t[0][0] === t[1][0] || t[0][1] === t[1][1];
        }

        function Ti(t) {
          var e = t.__brush;
          return e ? e.dim.output(e.selection) : null;
        }

        function Ei() {
          return Ai(li);
        }

        function Ci() {
          return Ai(hi);
        }

        function Si() {
          return Ai(fi);
        }

        function Ai(t) {
          var e,
              n = _i,
              r = bi,
              i = xi,
              a = !0,
              o = ft("start", "brush", "end"),
              s = 6;

          function c(e) {
            var n = e.property("__brush", y).selectAll(".overlay").data([vi("overlay")]);
            n.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", di.overlay).merge(n).each(function () {
              var t = wi(this).extent;
              Te(this).attr("x", t[0][0]).attr("y", t[0][1]).attr("width", t[1][0] - t[0][0]).attr("height", t[1][1] - t[0][1]);
            }), e.selectAll(".selection").data([vi("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", di.selection).attr("fill", "#777").attr("fill-opacity", .3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
            var r = e.selectAll(".handle").data(t.handles, function (t) {
              return t.type;
            });
            r.exit().remove(), r.enter().append("rect").attr("class", function (t) {
              return "handle handle--" + t.type;
            }).attr("cursor", function (t) {
              return di[t.type];
            }), e.each(u).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", f).filter(i).on("touchstart.brush", f).on("touchmove.brush", d).on("touchend.brush touchcancel.brush", p).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
          }

          function u() {
            var t = Te(this),
                e = wi(this).selection;
            e ? (t.selectAll(".selection").style("display", null).attr("x", e[0][0]).attr("y", e[0][1]).attr("width", e[1][0] - e[0][0]).attr("height", e[1][1] - e[0][1]), t.selectAll(".handle").style("display", null).attr("x", function (t) {
              return "e" === t.type[t.type.length - 1] ? e[1][0] - s / 2 : e[0][0] - s / 2;
            }).attr("y", function (t) {
              return "s" === t.type[0] ? e[1][1] - s / 2 : e[0][1] - s / 2;
            }).attr("width", function (t) {
              return "n" === t.type || "s" === t.type ? e[1][0] - e[0][0] + s : s;
            }).attr("height", function (t) {
              return "e" === t.type || "w" === t.type ? e[1][1] - e[0][1] + s : s;
            })) : t.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
          }

          function l(t, e, n) {
            var r = t.__brush.emitter;
            return !r || n && r.clean ? new h(t, e, n) : r;
          }

          function h(t, e, n) {
            this.that = t, this.args = e, this.state = t.__brush, this.active = 0, this.clean = n;
          }

          function f() {
            if ((!e || le.touches) && r.apply(this, arguments)) {
              var n,
                  i,
                  o,
                  s,
                  c,
                  h,
                  f,
                  d,
                  p,
                  y,
                  g,
                  m = this,
                  v = le.target.__data__.type,
                  b = "selection" === (a && le.metaKey ? v = "overlay" : v) ? ri : a && le.altKey ? oi : ai,
                  _ = t === hi ? null : gi[v],
                  x = t === li ? null : mi[v],
                  w = wi(m),
                  k = w.extent,
                  T = w.selection,
                  E = k[0][0],
                  C = k[0][1],
                  S = k[1][0],
                  A = k[1][1],
                  M = 0,
                  N = 0,
                  D = _ && x && a && le.shiftKey,
                  O = le.touches ? ui(le.changedTouches[0].identifier) : On,
                  B = O(m),
                  L = B,
                  I = l(m, arguments, !0).beforestart();

              "overlay" === v ? (T && (p = !0), w.selection = T = [[n = t === hi ? E : B[0], o = t === li ? C : B[1]], [c = t === hi ? S : n, f = t === li ? A : o]]) : (n = T[0][0], o = T[0][1], c = T[1][0], f = T[1][1]), i = n, s = o, h = c, d = f;
              var R = Te(m).attr("pointer-events", "none"),
                  P = R.selectAll(".overlay").attr("cursor", di[v]);
              if (le.touches) I.moved = j, I.ended = U;else {
                var F = Te(le.view).on("mousemove.brush", j, !0).on("mouseup.brush", U, !0);
                a && F.on("keydown.brush", z, !0).on("keyup.brush", q, !0), Se(le.view);
              }
              ei(), ir(m), u.call(m), I.start();
            }

            function j() {
              var t = O(m);
              !D || y || g || (Math.abs(t[0] - L[0]) > Math.abs(t[1] - L[1]) ? g = !0 : y = !0), L = t, p = !0, ni(), Y();
            }

            function Y() {
              var t;

              switch (M = L[0] - B[0], N = L[1] - B[1], b) {
                case ii:
                case ri:
                  _ && (M = Math.max(E - n, Math.min(S - c, M)), i = n + M, h = c + M), x && (N = Math.max(C - o, Math.min(A - f, N)), s = o + N, d = f + N);
                  break;

                case ai:
                  _ < 0 ? (M = Math.max(E - n, Math.min(S - n, M)), i = n + M, h = c) : _ > 0 && (M = Math.max(E - c, Math.min(S - c, M)), i = n, h = c + M), x < 0 ? (N = Math.max(C - o, Math.min(A - o, N)), s = o + N, d = f) : x > 0 && (N = Math.max(C - f, Math.min(A - f, N)), s = o, d = f + N);
                  break;

                case oi:
                  _ && (i = Math.max(E, Math.min(S, n - M * _)), h = Math.max(E, Math.min(S, c + M * _))), x && (s = Math.max(C, Math.min(A, o - N * x)), d = Math.max(C, Math.min(A, f + N * x)));
              }

              h < i && (_ *= -1, t = n, n = c, c = t, t = i, i = h, h = t, v in pi && P.attr("cursor", di[v = pi[v]])), d < s && (x *= -1, t = o, o = f, f = t, t = s, s = d, d = t, v in yi && P.attr("cursor", di[v = yi[v]])), w.selection && (T = w.selection), y && (i = T[0][0], h = T[1][0]), g && (s = T[0][1], d = T[1][1]), T[0][0] === i && T[0][1] === s && T[1][0] === h && T[1][1] === d || (w.selection = [[i, s], [h, d]], u.call(m), I.brush());
            }

            function U() {
              if (ei(), le.touches) {
                if (le.touches.length) return;
                e && clearTimeout(e), e = setTimeout(function () {
                  e = null;
                }, 500);
              } else Ae(le.view, p), F.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);

              R.attr("pointer-events", "all"), P.attr("cursor", di.overlay), w.selection && (T = w.selection), ki(T) && (w.selection = null, u.call(m)), I.end();
            }

            function z() {
              switch (le.keyCode) {
                case 16:
                  D = _ && x;
                  break;

                case 18:
                  b === ai && (_ && (c = h - M * _, n = i + M * _), x && (f = d - N * x, o = s + N * x), b = oi, Y());
                  break;

                case 32:
                  b !== ai && b !== oi || (_ < 0 ? c = h - M : _ > 0 && (n = i - M), x < 0 ? f = d - N : x > 0 && (o = s - N), b = ii, P.attr("cursor", di.selection), Y());
                  break;

                default:
                  return;
              }

              ni();
            }

            function q() {
              switch (le.keyCode) {
                case 16:
                  D && (y = g = D = !1, Y());
                  break;

                case 18:
                  b === oi && (_ < 0 ? c = h : _ > 0 && (n = i), x < 0 ? f = d : x > 0 && (o = s), b = ai, Y());
                  break;

                case 32:
                  b === ii && (le.altKey ? (_ && (c = h - M * _, n = i + M * _), x && (f = d - N * x, o = s + N * x), b = oi) : (_ < 0 ? c = h : _ > 0 && (n = i), x < 0 ? f = d : x > 0 && (o = s), b = ai), P.attr("cursor", di[v]), Y());
                  break;

                default:
                  return;
              }

              ni();
            }
          }

          function d() {
            l(this, arguments).moved();
          }

          function p() {
            l(this, arguments).ended();
          }

          function y() {
            var e = this.__brush || {
              selection: null
            };
            return e.extent = ci(n.apply(this, arguments)), e.dim = t, e;
          }

          return c.move = function (e, n) {
            e.selection ? e.on("start.brush", function () {
              l(this, arguments).beforestart().start();
            }).on("interrupt.brush end.brush", function () {
              l(this, arguments).end();
            }).tween("brush", function () {
              var e = this,
                  r = e.__brush,
                  i = l(e, arguments),
                  a = r.selection,
                  o = t.input("function" == typeof n ? n.apply(this, arguments) : n, r.extent),
                  s = An(a, o);

              function c(t) {
                r.selection = 1 === t && null === o ? null : s(t), u.call(e), i.brush();
              }

              return null !== a && null !== o ? c : c(1);
            }) : e.each(function () {
              var e = this,
                  r = arguments,
                  i = e.__brush,
                  a = t.input("function" == typeof n ? n.apply(e, r) : n, i.extent),
                  o = l(e, r).beforestart();
              ir(e), i.selection = null === a ? null : a, u.call(e), o.start().brush().end();
            });
          }, c.clear = function (t) {
            c.move(t, null);
          }, h.prototype = {
            beforestart: function beforestart() {
              return 1 == ++this.active && (this.state.emitter = this, this.starting = !0), this;
            },
            start: function start() {
              return this.starting ? (this.starting = !1, this.emit("start")) : this.emit("brush"), this;
            },
            brush: function brush() {
              return this.emit("brush"), this;
            },
            end: function end() {
              return 0 == --this.active && (delete this.state.emitter, this.emit("end")), this;
            },
            emit: function emit(e) {
              ge(new ti(c, e, t.output(this.state.selection)), o.apply, o, [e, this.that, this.args]);
            }
          }, c.extent = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : Jr(ci(t)), c) : n;
          }, c.filter = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : Jr(!!t), c) : r;
          }, c.touchable = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : Jr(!!t), c) : i;
          }, c.handleSize = function (t) {
            return arguments.length ? (s = +t, c) : s;
          }, c.keyModifiers = function (t) {
            return arguments.length ? (a = !!t, c) : a;
          }, c.on = function () {
            var t = o.on.apply(o, arguments);
            return t === o ? c : t;
          }, c;
        }

        var Mi = Math.cos,
            Ni = Math.sin,
            Di = Math.PI,
            Oi = Di / 2,
            Bi = 2 * Di,
            Li = Math.max;

        function Ii(t) {
          return function (e, n) {
            return t(e.source.value + e.target.value, n.source.value + n.target.value);
          };
        }

        function Ri() {
          var t = 0,
              e = null,
              n = null,
              r = null;

          function i(i) {
            var a,
                o,
                s,
                c,
                u,
                l,
                h = i.length,
                f = [],
                d = k(h),
                p = [],
                y = [],
                g = y.groups = new Array(h),
                m = new Array(h * h);

            for (a = 0, u = -1; ++u < h;) {
              for (o = 0, l = -1; ++l < h;) {
                o += i[u][l];
              }

              f.push(o), p.push(k(h)), a += o;
            }

            for (e && d.sort(function (t, n) {
              return e(f[t], f[n]);
            }), n && p.forEach(function (t, e) {
              t.sort(function (t, r) {
                return n(i[e][t], i[e][r]);
              });
            }), c = (a = Li(0, Bi - t * h) / a) ? t : Bi / h, o = 0, u = -1; ++u < h;) {
              for (s = o, l = -1; ++l < h;) {
                var v = d[u],
                    b = p[v][l],
                    _ = i[v][b],
                    x = o,
                    w = o += _ * a;
                m[b * h + v] = {
                  index: v,
                  subindex: b,
                  startAngle: x,
                  endAngle: w,
                  value: _
                };
              }

              g[v] = {
                index: v,
                startAngle: s,
                endAngle: o,
                value: f[v]
              }, o += c;
            }

            for (u = -1; ++u < h;) {
              for (l = u - 1; ++l < h;) {
                var T = m[l * h + u],
                    E = m[u * h + l];
                (T.value || E.value) && y.push(T.value < E.value ? {
                  source: E,
                  target: T
                } : {
                  source: T,
                  target: E
                });
              }
            }

            return r ? y.sort(r) : y;
          }

          return i.padAngle = function (e) {
            return arguments.length ? (t = Li(0, e), i) : t;
          }, i.sortGroups = function (t) {
            return arguments.length ? (e = t, i) : e;
          }, i.sortSubgroups = function (t) {
            return arguments.length ? (n = t, i) : n;
          }, i.sortChords = function (t) {
            return arguments.length ? (null == t ? r = null : (r = Ii(t))._ = t, i) : r && r._;
          }, i;
        }

        var Pi = Array.prototype.slice;

        function Fi(t) {
          return function () {
            return t;
          };
        }

        var ji = Math.PI,
            Yi = 2 * ji,
            Ui = 1e-6,
            zi = Yi - Ui;

        function qi() {
          this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
        }

        function $i() {
          return new qi();
        }

        qi.prototype = $i.prototype = {
          constructor: qi,
          moveTo: function moveTo(t, e) {
            this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
          },
          closePath: function closePath() {
            null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
          },
          lineTo: function lineTo(t, e) {
            this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
          },
          quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
            this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
          },
          bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
            this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
          },
          arcTo: function arcTo(t, e, n, r, i) {
            t = +t, e = +e, n = +n, r = +r, i = +i;
            var a = this._x1,
                o = this._y1,
                s = n - t,
                c = r - e,
                u = a - t,
                l = o - e,
                h = u * u + l * l;
            if (i < 0) throw new Error("negative radius: " + i);
            if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);else if (h > Ui) if (Math.abs(l * s - c * u) > Ui && i) {
              var f = n - a,
                  d = r - o,
                  p = s * s + c * c,
                  y = f * f + d * d,
                  g = Math.sqrt(p),
                  m = Math.sqrt(h),
                  v = i * Math.tan((ji - Math.acos((p + h - y) / (2 * g * m))) / 2),
                  b = v / m,
                  _ = v / g;

              Math.abs(b - 1) > Ui && (this._ += "L" + (t + b * u) + "," + (e + b * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * f > u * d) + "," + (this._x1 = t + _ * s) + "," + (this._y1 = e + _ * c);
            } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
          },
          arc: function arc(t, e, n, r, i, a) {
            t = +t, e = +e, a = !!a;
            var o = (n = +n) * Math.cos(r),
                s = n * Math.sin(r),
                c = t + o,
                u = e + s,
                l = 1 ^ a,
                h = a ? r - i : i - r;
            if (n < 0) throw new Error("negative radius: " + n);
            null === this._x1 ? this._ += "M" + c + "," + u : (Math.abs(this._x1 - c) > Ui || Math.abs(this._y1 - u) > Ui) && (this._ += "L" + c + "," + u), n && (h < 0 && (h = h % Yi + Yi), h > zi ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = c) + "," + (this._y1 = u) : h > Ui && (this._ += "A" + n + "," + n + ",0," + +(h >= ji) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
          },
          rect: function rect(t, e, n, r) {
            this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
          },
          toString: function toString() {
            return this._;
          }
        };
        var Hi = $i;

        function Wi(t) {
          return t.source;
        }

        function Vi(t) {
          return t.target;
        }

        function Gi(t) {
          return t.radius;
        }

        function Xi(t) {
          return t.startAngle;
        }

        function Zi(t) {
          return t.endAngle;
        }

        function Ki() {
          var t = Wi,
              e = Vi,
              n = Gi,
              r = Xi,
              i = Zi,
              a = null;

          function o() {
            var o,
                s = Pi.call(arguments),
                c = t.apply(this, s),
                u = e.apply(this, s),
                l = +n.apply(this, (s[0] = c, s)),
                h = r.apply(this, s) - Oi,
                f = i.apply(this, s) - Oi,
                d = l * Mi(h),
                p = l * Ni(h),
                y = +n.apply(this, (s[0] = u, s)),
                g = r.apply(this, s) - Oi,
                m = i.apply(this, s) - Oi;
            if (a || (a = o = Hi()), a.moveTo(d, p), a.arc(0, 0, l, h, f), h === g && f === m || (a.quadraticCurveTo(0, 0, y * Mi(g), y * Ni(g)), a.arc(0, 0, y, g, m)), a.quadraticCurveTo(0, 0, d, p), a.closePath(), o) return a = null, o + "" || null;
          }

          return o.radius = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : Fi(+t), o) : n;
          }, o.startAngle = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : Fi(+t), o) : r;
          }, o.endAngle = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : Fi(+t), o) : i;
          }, o.source = function (e) {
            return arguments.length ? (t = e, o) : t;
          }, o.target = function (t) {
            return arguments.length ? (e = t, o) : e;
          }, o.context = function (t) {
            return arguments.length ? (a = null == t ? null : t, o) : a;
          }, o;
        }

        var Qi = "$";

        function Ji() {}

        function ta(t, e) {
          var n = new Ji();
          if (t instanceof Ji) t.each(function (t, e) {
            n.set(e, t);
          });else if (Array.isArray(t)) {
            var r,
                i = -1,
                a = t.length;
            if (null == e) for (; ++i < a;) {
              n.set(i, t[i]);
            } else for (; ++i < a;) {
              n.set(e(r = t[i], i, t), r);
            }
          } else if (t) for (var o in t) {
            n.set(o, t[o]);
          }
          return n;
        }

        Ji.prototype = ta.prototype = {
          constructor: Ji,
          has: function has(t) {
            return Qi + t in this;
          },
          get: function get(t) {
            return this[Qi + t];
          },
          set: function set(t, e) {
            return this[Qi + t] = e, this;
          },
          remove: function remove(t) {
            var e = Qi + t;
            return e in this && delete this[e];
          },
          clear: function clear() {
            for (var t in this) {
              t[0] === Qi && delete this[t];
            }
          },
          keys: function keys() {
            var t = [];

            for (var e in this) {
              e[0] === Qi && t.push(e.slice(1));
            }

            return t;
          },
          values: function values() {
            var t = [];

            for (var e in this) {
              e[0] === Qi && t.push(this[e]);
            }

            return t;
          },
          entries: function entries() {
            var t = [];

            for (var e in this) {
              e[0] === Qi && t.push({
                key: e.slice(1),
                value: this[e]
              });
            }

            return t;
          },
          size: function size() {
            var t = 0;

            for (var e in this) {
              e[0] === Qi && ++t;
            }

            return t;
          },
          empty: function empty() {
            for (var t in this) {
              if (t[0] === Qi) return !1;
            }

            return !0;
          },
          each: function each(t) {
            for (var e in this) {
              e[0] === Qi && t(this[e], e.slice(1), this);
            }
          }
        };
        var ea = ta;

        function na() {
          var t,
              e,
              n,
              r = [],
              i = [];

          function a(n, i, o, s) {
            if (i >= r.length) return null != t && n.sort(t), null != e ? e(n) : n;

            for (var c, u, l, h = -1, f = n.length, d = r[i++], p = ea(), y = o(); ++h < f;) {
              (l = p.get(c = d(u = n[h]) + "")) ? l.push(u) : p.set(c, [u]);
            }

            return p.each(function (t, e) {
              s(y, e, a(t, i, o, s));
            }), y;
          }

          return n = {
            object: function object(t) {
              return a(t, 0, ra, ia);
            },
            map: function map(t) {
              return a(t, 0, aa, oa);
            },
            entries: function entries(t) {
              return function t(n, a) {
                if (++a > r.length) return n;
                var o,
                    s = i[a - 1];
                return null != e && a >= r.length ? o = n.entries() : (o = [], n.each(function (e, n) {
                  o.push({
                    key: n,
                    values: t(e, a)
                  });
                })), null != s ? o.sort(function (t, e) {
                  return s(t.key, e.key);
                }) : o;
              }(a(t, 0, aa, oa), 0);
            },
            key: function key(t) {
              return r.push(t), n;
            },
            sortKeys: function sortKeys(t) {
              return i[r.length - 1] = t, n;
            },
            sortValues: function sortValues(e) {
              return t = e, n;
            },
            rollup: function rollup(t) {
              return e = t, n;
            }
          };
        }

        function ra() {
          return {};
        }

        function ia(t, e, n) {
          t[e] = n;
        }

        function aa() {
          return ea();
        }

        function oa(t, e, n) {
          t.set(e, n);
        }

        function sa() {}

        var ca = ea.prototype;

        function ua(t, e) {
          var n = new sa();
          if (t instanceof sa) t.each(function (t) {
            n.add(t);
          });else if (t) {
            var r = -1,
                i = t.length;
            if (null == e) for (; ++r < i;) {
              n.add(t[r]);
            } else for (; ++r < i;) {
              n.add(e(t[r], r, t));
            }
          }
          return n;
        }

        sa.prototype = ua.prototype = {
          constructor: sa,
          has: ca.has,
          add: function add(t) {
            return this[Qi + (t += "")] = t, this;
          },
          remove: ca.remove,
          clear: ca.clear,
          values: ca.keys,
          size: ca.size,
          empty: ca.empty,
          each: ca.each
        };
        var la = ua;

        function ha(t) {
          var e = [];

          for (var n in t) {
            e.push(n);
          }

          return e;
        }

        function fa(t) {
          var e = [];

          for (var n in t) {
            e.push(t[n]);
          }

          return e;
        }

        function da(t) {
          var e = [];

          for (var n in t) {
            e.push({
              key: n,
              value: t[n]
            });
          }

          return e;
        }

        var pa = Math.PI / 180,
            ya = 180 / Math.PI,
            ga = 6 / 29 * 3 * (6 / 29);

        function ma(t) {
          if (t instanceof _a) return new _a(t.l, t.a, t.b, t.opacity);
          if (t instanceof Aa) return Ma(t);
          t instanceof Ke || (t = Xe(t));
          var e,
              n,
              r = Ta(t.r),
              i = Ta(t.g),
              a = Ta(t.b),
              o = xa((.2225045 * r + .7168786 * i + .0606169 * a) / 1);
          return r === i && i === a ? e = n = o : (e = xa((.4360747 * r + .3850649 * i + .1430804 * a) / .96422), n = xa((.0139322 * r + .0971045 * i + .7141733 * a) / .82521)), new _a(116 * o - 16, 500 * (e - o), 200 * (o - n), t.opacity);
        }

        function va(t, e) {
          return new _a(t, 0, 0, null == e ? 1 : e);
        }

        function ba(t, e, n, r) {
          return 1 === arguments.length ? ma(t) : new _a(t, e, n, null == r ? 1 : r);
        }

        function _a(t, e, n, r) {
          this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
        }

        function xa(t) {
          return t > .008856451679035631 ? Math.pow(t, 1 / 3) : t / ga + 4 / 29;
        }

        function wa(t) {
          return t > 6 / 29 ? t * t * t : ga * (t - 4 / 29);
        }

        function ka(t) {
          return 255 * (t <= .0031308 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055);
        }

        function Ta(t) {
          return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }

        function Ea(t) {
          if (t instanceof Aa) return new Aa(t.h, t.c, t.l, t.opacity);
          if (t instanceof _a || (t = ma(t)), 0 === t.a && 0 === t.b) return new Aa(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
          var e = Math.atan2(t.b, t.a) * ya;
          return new Aa(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
        }

        function Ca(t, e, n, r) {
          return 1 === arguments.length ? Ea(t) : new Aa(n, e, t, null == r ? 1 : r);
        }

        function Sa(t, e, n, r) {
          return 1 === arguments.length ? Ea(t) : new Aa(t, e, n, null == r ? 1 : r);
        }

        function Aa(t, e, n, r) {
          this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
        }

        function Ma(t) {
          if (isNaN(t.h)) return new _a(t.l, 0, 0, t.opacity);
          var e = t.h * pa;
          return new _a(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
        }

        Me(_a, ba, Ne(De, {
          brighter: function brighter(t) {
            return new _a(this.l + 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
          },
          darker: function darker(t) {
            return new _a(this.l - 18 * (null == t ? 1 : t), this.a, this.b, this.opacity);
          },
          rgb: function rgb() {
            var t = (this.l + 16) / 116,
                e = isNaN(this.a) ? t : t + this.a / 500,
                n = isNaN(this.b) ? t : t - this.b / 200;
            return new Ke(ka(3.1338561 * (e = .96422 * wa(e)) - 1.6168667 * (t = 1 * wa(t)) - .4906146 * (n = .82521 * wa(n))), ka(-.9787684 * e + 1.9161415 * t + .033454 * n), ka(.0719453 * e - .2289914 * t + 1.4052427 * n), this.opacity);
          }
        })), Me(Aa, Sa, Ne(De, {
          brighter: function brighter(t) {
            return new Aa(this.h, this.c, this.l + 18 * (null == t ? 1 : t), this.opacity);
          },
          darker: function darker(t) {
            return new Aa(this.h, this.c, this.l - 18 * (null == t ? 1 : t), this.opacity);
          },
          rgb: function rgb() {
            return Ma(this).rgb();
          }
        }));
        var Na = 1.78277,
            Da = -.29227,
            Oa = -.90649,
            Ba = 1.97294,
            La = Ba * Oa,
            Ia = Ba * Na,
            Ra = Na * Da - -.14861 * Oa;

        function Pa(t) {
          if (t instanceof ja) return new ja(t.h, t.s, t.l, t.opacity);
          t instanceof Ke || (t = Xe(t));
          var e = t.r / 255,
              n = t.g / 255,
              r = t.b / 255,
              i = (Ra * r + La * e - Ia * n) / (Ra + La - Ia),
              a = r - i,
              o = (Ba * (n - i) - Da * a) / Oa,
              s = Math.sqrt(o * o + a * a) / (Ba * i * (1 - i)),
              c = s ? Math.atan2(o, a) * ya - 120 : NaN;
          return new ja(c < 0 ? c + 360 : c, s, i, t.opacity);
        }

        function Fa(t, e, n, r) {
          return 1 === arguments.length ? Pa(t) : new ja(t, e, n, null == r ? 1 : r);
        }

        function ja(t, e, n, r) {
          this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
        }

        Me(ja, Fa, Ne(De, {
          brighter: function brighter(t) {
            return t = null == t ? Oe : Math.pow(Oe, t), new ja(this.h, this.s, this.l * t, this.opacity);
          },
          darker: function darker(t) {
            return t = null == t ? .7 : Math.pow(.7, t), new ja(this.h, this.s, this.l * t, this.opacity);
          },
          rgb: function rgb() {
            var t = isNaN(this.h) ? 0 : (this.h + 120) * pa,
                e = +this.l,
                n = isNaN(this.s) ? 0 : this.s * e * (1 - e),
                r = Math.cos(t),
                i = Math.sin(t);
            return new Ke(255 * (e + n * (-.14861 * r + Na * i)), 255 * (e + n * (Da * r + Oa * i)), 255 * (e + n * (Ba * r)), this.opacity);
          }
        }));
        var Ya = Array.prototype.slice;

        function Ua(t, e) {
          return t - e;
        }

        function za(t) {
          return function () {
            return t;
          };
        }

        function qa(t, e) {
          for (var n, r = -1, i = e.length; ++r < i;) {
            if (n = $a(t, e[r])) return n;
          }

          return 0;
        }

        function $a(t, e) {
          for (var n = e[0], r = e[1], i = -1, a = 0, o = t.length, s = o - 1; a < o; s = a++) {
            var c = t[a],
                u = c[0],
                l = c[1],
                h = t[s],
                f = h[0],
                d = h[1];
            if (Ha(c, h, e)) return 0;
            l > r != d > r && n < (f - u) * (r - l) / (d - l) + u && (i = -i);
          }

          return i;
        }

        function Ha(t, e, n) {
          var r, i, a, o;
          return function (t, e, n) {
            return (e[0] - t[0]) * (n[1] - t[1]) == (n[0] - t[0]) * (e[1] - t[1]);
          }(t, e, n) && (i = t[r = +(t[0] === e[0])], a = n[r], o = e[r], i <= a && a <= o || o <= a && a <= i);
        }

        function Wa() {}

        var Va = [[], [[[1, 1.5], [.5, 1]]], [[[1.5, 1], [1, 1.5]]], [[[1.5, 1], [.5, 1]]], [[[1, .5], [1.5, 1]]], [[[1, 1.5], [.5, 1]], [[1, .5], [1.5, 1]]], [[[1, .5], [1, 1.5]]], [[[1, .5], [.5, 1]]], [[[.5, 1], [1, .5]]], [[[1, 1.5], [1, .5]]], [[[.5, 1], [1, .5]], [[1.5, 1], [1, 1.5]]], [[[1.5, 1], [1, .5]]], [[[.5, 1], [1.5, 1]]], [[[1, 1.5], [1.5, 1]]], [[[.5, 1], [1, 1.5]]], []];

        function Ga() {
          var t = 1,
              e = 1,
              n = N,
              r = s;

          function i(t) {
            var e = n(t);
            if (Array.isArray(e)) e = e.slice().sort(Ua);else {
              var r = m(t),
                  i = r[0],
                  o = r[1];
              e = M(i, o, e), e = k(Math.floor(i / e) * e, Math.floor(o / e) * e, e);
            }
            return e.map(function (e) {
              return a(t, e);
            });
          }

          function a(n, i) {
            var a = [],
                s = [];
            return function (n, r, i) {
              var a,
                  s,
                  c,
                  u,
                  l,
                  h,
                  f = new Array(),
                  d = new Array();

              for (a = s = -1, u = n[0] >= r, Va[u << 1].forEach(p); ++a < t - 1;) {
                c = u, u = n[a + 1] >= r, Va[c | u << 1].forEach(p);
              }

              for (Va[u << 0].forEach(p); ++s < e - 1;) {
                for (a = -1, u = n[s * t + t] >= r, l = n[s * t] >= r, Va[u << 1 | l << 2].forEach(p); ++a < t - 1;) {
                  c = u, u = n[s * t + t + a + 1] >= r, h = l, l = n[s * t + a + 1] >= r, Va[c | u << 1 | l << 2 | h << 3].forEach(p);
                }

                Va[u | l << 3].forEach(p);
              }

              for (a = -1, l = n[s * t] >= r, Va[l << 2].forEach(p); ++a < t - 1;) {
                h = l, l = n[s * t + a + 1] >= r, Va[l << 2 | h << 3].forEach(p);
              }

              function p(t) {
                var e,
                    n,
                    r = [t[0][0] + a, t[0][1] + s],
                    c = [t[1][0] + a, t[1][1] + s],
                    u = o(r),
                    l = o(c);
                (e = d[u]) ? (n = f[l]) ? (delete d[e.end], delete f[n.start], e === n ? (e.ring.push(c), i(e.ring)) : f[e.start] = d[n.end] = {
                  start: e.start,
                  end: n.end,
                  ring: e.ring.concat(n.ring)
                }) : (delete d[e.end], e.ring.push(c), d[e.end = l] = e) : (e = f[l]) ? (n = d[u]) ? (delete f[e.start], delete d[n.end], e === n ? (e.ring.push(c), i(e.ring)) : f[n.start] = d[e.end] = {
                  start: n.start,
                  end: e.end,
                  ring: n.ring.concat(e.ring)
                }) : (delete f[e.start], e.ring.unshift(r), f[e.start = u] = e) : f[u] = d[l] = {
                  start: u,
                  end: l,
                  ring: [r, c]
                };
              }

              Va[l << 3].forEach(p);
            }(n, i, function (t) {
              r(t, n, i), function (t) {
                for (var e = 0, n = t.length, r = t[n - 1][1] * t[0][0] - t[n - 1][0] * t[0][1]; ++e < n;) {
                  r += t[e - 1][1] * t[e][0] - t[e - 1][0] * t[e][1];
                }

                return r;
              }(t) > 0 ? a.push([t]) : s.push(t);
            }), s.forEach(function (t) {
              for (var e, n = 0, r = a.length; n < r; ++n) {
                if (-1 !== qa((e = a[n])[0], t)) return void e.push(t);
              }
            }), {
              type: "MultiPolygon",
              value: i,
              coordinates: a
            };
          }

          function o(e) {
            return 2 * e[0] + e[1] * (t + 1) * 4;
          }

          function s(n, r, i) {
            n.forEach(function (n) {
              var a,
                  o = n[0],
                  s = n[1],
                  c = 0 | o,
                  u = 0 | s,
                  l = r[u * t + c];
              o > 0 && o < t && c === o && (a = r[u * t + c - 1], n[0] = o + (i - a) / (l - a) - .5), s > 0 && s < e && u === s && (a = r[(u - 1) * t + c], n[1] = s + (i - a) / (l - a) - .5);
            });
          }

          return i.contour = a, i.size = function (n) {
            if (!arguments.length) return [t, e];
            var r = Math.ceil(n[0]),
                a = Math.ceil(n[1]);
            if (!(r > 0 && a > 0)) throw new Error("invalid size");
            return t = r, e = a, i;
          }, i.thresholds = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : Array.isArray(t) ? za(Ya.call(t)) : za(t), i) : n;
          }, i.smooth = function (t) {
            return arguments.length ? (r = t ? s : Wa, i) : r === s;
          }, i;
        }

        function Xa(t, e, n) {
          for (var r = t.width, i = t.height, a = 1 + (n << 1), o = 0; o < i; ++o) {
            for (var s = 0, c = 0; s < r + n; ++s) {
              s < r && (c += t.data[s + o * r]), s >= n && (s >= a && (c -= t.data[s - a + o * r]), e.data[s - n + o * r] = c / Math.min(s + 1, r - 1 + a - s, a));
            }
          }
        }

        function Za(t, e, n) {
          for (var r = t.width, i = t.height, a = 1 + (n << 1), o = 0; o < r; ++o) {
            for (var s = 0, c = 0; s < i + n; ++s) {
              s < i && (c += t.data[o + s * r]), s >= n && (s >= a && (c -= t.data[o + (s - a) * r]), e.data[o + (s - n) * r] = c / Math.min(s + 1, i - 1 + a - s, a));
            }
          }
        }

        function Ka(t) {
          return t[0];
        }

        function Qa(t) {
          return t[1];
        }

        function Ja() {
          return 1;
        }

        function to() {
          var t = Ka,
              e = Qa,
              n = Ja,
              r = 960,
              i = 500,
              a = 20,
              o = 2,
              s = 3 * a,
              c = r + 2 * s >> o,
              u = i + 2 * s >> o,
              l = za(20);

          function h(r) {
            var i = new Float32Array(c * u),
                h = new Float32Array(c * u);
            r.forEach(function (r, a, l) {
              var h = +t(r, a, l) + s >> o,
                  f = +e(r, a, l) + s >> o,
                  d = +n(r, a, l);
              h >= 0 && h < c && f >= 0 && f < u && (i[h + f * c] += d);
            }), Xa({
              width: c,
              height: u,
              data: i
            }, {
              width: c,
              height: u,
              data: h
            }, a >> o), Za({
              width: c,
              height: u,
              data: h
            }, {
              width: c,
              height: u,
              data: i
            }, a >> o), Xa({
              width: c,
              height: u,
              data: i
            }, {
              width: c,
              height: u,
              data: h
            }, a >> o), Za({
              width: c,
              height: u,
              data: h
            }, {
              width: c,
              height: u,
              data: i
            }, a >> o), Xa({
              width: c,
              height: u,
              data: i
            }, {
              width: c,
              height: u,
              data: h
            }, a >> o), Za({
              width: c,
              height: u,
              data: h
            }, {
              width: c,
              height: u,
              data: i
            }, a >> o);
            var d = l(i);

            if (!Array.isArray(d)) {
              var p = I(i);
              d = M(0, p, d), (d = k(0, Math.floor(p / d) * d, d)).shift();
            }

            return Ga().thresholds(d).size([c, u])(i).map(f);
          }

          function f(t) {
            return t.value *= Math.pow(2, -2 * o), t.coordinates.forEach(d), t;
          }

          function d(t) {
            t.forEach(p);
          }

          function p(t) {
            t.forEach(y);
          }

          function y(t) {
            t[0] = t[0] * Math.pow(2, o) - s, t[1] = t[1] * Math.pow(2, o) - s;
          }

          function g() {
            return c = r + 2 * (s = 3 * a) >> o, u = i + 2 * s >> o, h;
          }

          return h.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : za(+e), h) : t;
          }, h.y = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : za(+t), h) : e;
          }, h.weight = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : za(+t), h) : n;
          }, h.size = function (t) {
            if (!arguments.length) return [r, i];
            var e = Math.ceil(t[0]),
                n = Math.ceil(t[1]);
            if (!(e >= 0 || e >= 0)) throw new Error("invalid size");
            return r = e, i = n, g();
          }, h.cellSize = function (t) {
            if (!arguments.length) return 1 << o;
            if (!((t = +t) >= 1)) throw new Error("invalid cell size");
            return o = Math.floor(Math.log(t) / Math.LN2), g();
          }, h.thresholds = function (t) {
            return arguments.length ? (l = "function" == typeof t ? t : Array.isArray(t) ? za(Ya.call(t)) : za(t), h) : l;
          }, h.bandwidth = function (t) {
            if (!arguments.length) return Math.sqrt(a * (a + 1));
            if (!((t = +t) >= 0)) throw new Error("invalid bandwidth");
            return a = Math.round((Math.sqrt(4 * t * t + 1) - 1) / 2), g();
          }, h;
        }

        function eo(t) {
          return function () {
            return t;
          };
        }

        function no(t, e, n, r, i, a, o, s, c, u) {
          this.target = t, this.type = e, this.subject = n, this.identifier = r, this.active = i, this.x = a, this.y = o, this.dx = s, this.dy = c, this._ = u;
        }

        function ro() {
          return !le.ctrlKey && !le.button;
        }

        function io() {
          return this.parentNode;
        }

        function ao(t) {
          return null == t ? {
            x: le.x,
            y: le.y
          } : t;
        }

        function oo() {
          return navigator.maxTouchPoints || "ontouchstart" in this;
        }

        function so() {
          var t,
              e,
              n,
              r,
              i = ro,
              a = io,
              o = ao,
              s = oo,
              c = {},
              u = ft("start", "drag", "end"),
              l = 0,
              h = 0;

          function f(t) {
            t.on("mousedown.drag", d).filter(s).on("touchstart.drag", g).on("touchmove.drag", m).on("touchend.drag touchcancel.drag", v).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
          }

          function d() {
            if (!r && i.apply(this, arguments)) {
              var o = b("mouse", a.apply(this, arguments), On, this, arguments);
              o && (Te(le.view).on("mousemove.drag", p, !0).on("mouseup.drag", y, !0), Se(le.view), Ee(), n = !1, t = le.clientX, e = le.clientY, o("start"));
            }
          }

          function p() {
            if (Ce(), !n) {
              var r = le.clientX - t,
                  i = le.clientY - e;
              n = r * r + i * i > h;
            }

            c.mouse("drag");
          }

          function y() {
            Te(le.view).on("mousemove.drag mouseup.drag", null), Ae(le.view, n), Ce(), c.mouse("end");
          }

          function g() {
            if (i.apply(this, arguments)) {
              var t,
                  e,
                  n = le.changedTouches,
                  r = a.apply(this, arguments),
                  o = n.length;

              for (t = 0; t < o; ++t) {
                (e = b(n[t].identifier, r, Dn, this, arguments)) && (Ee(), e("start"));
              }
            }
          }

          function m() {
            var t,
                e,
                n = le.changedTouches,
                r = n.length;

            for (t = 0; t < r; ++t) {
              (e = c[n[t].identifier]) && (Ce(), e("drag"));
            }
          }

          function v() {
            var t,
                e,
                n = le.changedTouches,
                i = n.length;

            for (r && clearTimeout(r), r = setTimeout(function () {
              r = null;
            }, 500), t = 0; t < i; ++t) {
              (e = c[n[t].identifier]) && (Ee(), e("end"));
            }
          }

          function b(t, e, n, r, i) {
            var a,
                s,
                h,
                d = n(e, t),
                p = u.copy();
            if (ge(new no(f, "beforestart", a, t, l, d[0], d[1], 0, 0, p), function () {
              return null != (le.subject = a = o.apply(r, i)) && (s = a.x - d[0] || 0, h = a.y - d[1] || 0, !0);
            })) return function o(u) {
              var y,
                  g = d;

              switch (u) {
                case "start":
                  c[t] = o, y = l++;
                  break;

                case "end":
                  delete c[t], --l;

                case "drag":
                  d = n(e, t), y = l;
              }

              ge(new no(f, u, a, t, y, d[0] + s, d[1] + h, d[0] - g[0], d[1] - g[1], p), p.apply, p, [u, r, i]);
            };
          }

          return f.filter = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : eo(!!t), f) : i;
          }, f.container = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : eo(t), f) : a;
          }, f.subject = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : eo(t), f) : o;
          }, f.touchable = function (t) {
            return arguments.length ? (s = "function" == typeof t ? t : eo(!!t), f) : s;
          }, f.on = function () {
            var t = u.on.apply(u, arguments);
            return t === u ? f : t;
          }, f.clickDistance = function (t) {
            return arguments.length ? (h = (t = +t) * t, f) : Math.sqrt(h);
          }, f;
        }

        no.prototype.on = function () {
          var t = this._.on.apply(this._, arguments);

          return t === this._ ? this : t;
        };

        var co = {},
            uo = {};

        function lo(t) {
          return new Function("d", "return {" + t.map(function (t, e) {
            return JSON.stringify(t) + ": d[" + e + '] || ""';
          }).join(",") + "}");
        }

        function ho(t) {
          var e = Object.create(null),
              n = [];
          return t.forEach(function (t) {
            for (var r in t) {
              r in e || n.push(e[r] = r);
            }
          }), n;
        }

        function fo(t, e) {
          var n = t + "",
              r = n.length;
          return r < e ? new Array(e - r + 1).join(0) + n : n;
        }

        function po(t) {
          var e = new RegExp('["' + t + "\n\r]"),
              n = t.charCodeAt(0);

          function r(t, e) {
            var r,
                i = [],
                a = t.length,
                o = 0,
                s = 0,
                c = a <= 0,
                u = !1;

            function l() {
              if (c) return uo;
              if (u) return u = !1, co;
              var e,
                  r,
                  i = o;

              if (34 === t.charCodeAt(i)) {
                for (; o++ < a && 34 !== t.charCodeAt(o) || 34 === t.charCodeAt(++o);) {
                  ;
                }

                return (e = o) >= a ? c = !0 : 10 === (r = t.charCodeAt(o++)) ? u = !0 : 13 === r && (u = !0, 10 === t.charCodeAt(o) && ++o), t.slice(i + 1, e - 1).replace(/""/g, '"');
              }

              for (; o < a;) {
                if (10 === (r = t.charCodeAt(e = o++))) u = !0;else if (13 === r) u = !0, 10 === t.charCodeAt(o) && ++o;else if (r !== n) continue;
                return t.slice(i, e);
              }

              return c = !0, t.slice(i, a);
            }

            for (10 === t.charCodeAt(a - 1) && --a, 13 === t.charCodeAt(a - 1) && --a; (r = l()) !== uo;) {
              for (var h = []; r !== co && r !== uo;) {
                h.push(r), r = l();
              }

              e && null == (h = e(h, s++)) || i.push(h);
            }

            return i;
          }

          function i(e, n) {
            return e.map(function (e) {
              return n.map(function (t) {
                return o(e[t]);
              }).join(t);
            });
          }

          function a(e) {
            return e.map(o).join(t);
          }

          function o(t) {
            return null == t ? "" : t instanceof Date ? function (t) {
              var e = t.getUTCHours(),
                  n = t.getUTCMinutes(),
                  r = t.getUTCSeconds(),
                  i = t.getUTCMilliseconds();
              return isNaN(t) ? "Invalid Date" : function (t) {
                return t < 0 ? "-" + fo(-t, 6) : t > 9999 ? "+" + fo(t, 6) : fo(t, 4);
              }(t.getUTCFullYear()) + "-" + fo(t.getUTCMonth() + 1, 2) + "-" + fo(t.getUTCDate(), 2) + (i ? "T" + fo(e, 2) + ":" + fo(n, 2) + ":" + fo(r, 2) + "." + fo(i, 3) + "Z" : r ? "T" + fo(e, 2) + ":" + fo(n, 2) + ":" + fo(r, 2) + "Z" : n || e ? "T" + fo(e, 2) + ":" + fo(n, 2) + "Z" : "");
            }(t) : e.test(t += "") ? '"' + t.replace(/"/g, '""') + '"' : t;
          }

          return {
            parse: function parse(t, e) {
              var n,
                  i,
                  a = r(t, function (t, r) {
                if (n) return n(t, r - 1);
                i = t, n = e ? function (t, e) {
                  var n = lo(t);
                  return function (r, i) {
                    return e(n(r), i, t);
                  };
                }(t, e) : lo(t);
              });
              return a.columns = i || [], a;
            },
            parseRows: r,
            format: function format(e, n) {
              return null == n && (n = ho(e)), [n.map(o).join(t)].concat(i(e, n)).join("\n");
            },
            formatBody: function formatBody(t, e) {
              return null == e && (e = ho(t)), i(t, e).join("\n");
            },
            formatRows: function formatRows(t) {
              return t.map(a).join("\n");
            },
            formatRow: a,
            formatValue: o
          };
        }

        var yo = po(","),
            go = yo.parse,
            mo = yo.parseRows,
            vo = yo.format,
            bo = yo.formatBody,
            _o = yo.formatRows,
            xo = yo.formatRow,
            wo = yo.formatValue,
            ko = po("\t"),
            To = ko.parse,
            Eo = ko.parseRows,
            Co = ko.format,
            So = ko.formatBody,
            Ao = ko.formatRows,
            Mo = ko.formatRow,
            No = ko.formatValue;

        function Do(t) {
          for (var e in t) {
            var n,
                r,
                i = t[e].trim();
            if (i) {
              if ("true" === i) i = !0;else if ("false" === i) i = !1;else if ("NaN" === i) i = NaN;else if (isNaN(n = +i)) {
                if (!(r = i.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/))) continue;
                Oo && r[4] && !r[7] && (i = i.replace(/-/g, "/").replace(/T/, " ")), i = new Date(i);
              } else i = n;
            } else i = null;
            t[e] = i;
          }

          return t;
        }

        var Oo = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

        function Bo(t) {
          return +t;
        }

        function Lo(t) {
          return t * t;
        }

        function Io(t) {
          return t * (2 - t);
        }

        function Ro(t) {
          return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
        }

        var Po = function t(e) {
          function n(t) {
            return Math.pow(t, e);
          }

          return e = +e, n.exponent = t, n;
        }(3),
            Fo = function t(e) {
          function n(t) {
            return 1 - Math.pow(1 - t, e);
          }

          return e = +e, n.exponent = t, n;
        }(3),
            jo = function t(e) {
          function n(t) {
            return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
          }

          return e = +e, n.exponent = t, n;
        }(3),
            Yo = Math.PI,
            Uo = Yo / 2;

        function zo(t) {
          return 1 == +t ? 1 : 1 - Math.cos(t * Uo);
        }

        function qo(t) {
          return Math.sin(t * Uo);
        }

        function $o(t) {
          return (1 - Math.cos(Yo * t)) / 2;
        }

        function Ho(t) {
          return 1.0009775171065494 * (Math.pow(2, -10 * t) - .0009765625);
        }

        function Wo(t) {
          return Ho(1 - +t);
        }

        function Vo(t) {
          return 1 - Ho(t);
        }

        function Go(t) {
          return ((t *= 2) <= 1 ? Ho(1 - t) : 2 - Ho(t - 1)) / 2;
        }

        function Xo(t) {
          return 1 - Math.sqrt(1 - t * t);
        }

        function Zo(t) {
          return Math.sqrt(1 - --t * t);
        }

        function Ko(t) {
          return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
        }

        var Qo = 7.5625;

        function Jo(t) {
          return 1 - ts(1 - t);
        }

        function ts(t) {
          return (t = +t) < .36363636363636365 ? Qo * t * t : t < .7272727272727273 ? Qo * (t -= .5454545454545454) * t + .75 : t < .9090909090909091 ? Qo * (t -= .8181818181818182) * t + .9375 : Qo * (t -= .9545454545454546) * t + .984375;
        }

        function es(t) {
          return ((t *= 2) <= 1 ? 1 - ts(1 - t) : ts(t - 1) + 1) / 2;
        }

        var ns = 1.70158,
            rs = function t(e) {
          function n(t) {
            return (t = +t) * t * (e * (t - 1) + t);
          }

          return e = +e, n.overshoot = t, n;
        }(ns),
            is = function t(e) {
          function n(t) {
            return --t * t * ((t + 1) * e + t) + 1;
          }

          return e = +e, n.overshoot = t, n;
        }(ns),
            as = function t(e) {
          function n(t) {
            return ((t *= 2) < 1 ? t * t * ((e + 1) * t - e) : (t -= 2) * t * ((e + 1) * t + e) + 2) / 2;
          }

          return e = +e, n.overshoot = t, n;
        }(ns),
            os = 2 * Math.PI,
            ss = function t(e, n) {
          var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= os);

          function i(t) {
            return e * Ho(- --t) * Math.sin((r - t) / n);
          }

          return i.amplitude = function (e) {
            return t(e, n * os);
          }, i.period = function (n) {
            return t(e, n);
          }, i;
        }(1, .3),
            cs = function t(e, n) {
          var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= os);

          function i(t) {
            return 1 - e * Ho(t = +t) * Math.sin((t + r) / n);
          }

          return i.amplitude = function (e) {
            return t(e, n * os);
          }, i.period = function (n) {
            return t(e, n);
          }, i;
        }(1, .3),
            us = function t(e, n) {
          var r = Math.asin(1 / (e = Math.max(1, e))) * (n /= os);

          function i(t) {
            return ((t = 2 * t - 1) < 0 ? e * Ho(-t) * Math.sin((r - t) / n) : 2 - e * Ho(t) * Math.sin((r + t) / n)) / 2;
          }

          return i.amplitude = function (e) {
            return t(e, n * os);
          }, i.period = function (n) {
            return t(e, n);
          }, i;
        }(1, .3);

        function ls(t) {
          if (!t.ok) throw new Error(t.status + " " + t.statusText);
          return t.blob();
        }

        function hs(t, e) {
          return fetch(t, e).then(ls);
        }

        function fs(t) {
          if (!t.ok) throw new Error(t.status + " " + t.statusText);
          return t.arrayBuffer();
        }

        function ds(t, e) {
          return fetch(t, e).then(fs);
        }

        function ps(t) {
          if (!t.ok) throw new Error(t.status + " " + t.statusText);
          return t.text();
        }

        function ys(t, e) {
          return fetch(t, e).then(ps);
        }

        function gs(t) {
          return function (e, n, r) {
            return 2 === arguments.length && "function" == typeof n && (r = n, n = void 0), ys(e, n).then(function (e) {
              return t(e, r);
            });
          };
        }

        function ms(t, e, n, r) {
          3 === arguments.length && "function" == typeof n && (r = n, n = void 0);
          var i = po(t);
          return ys(e, n).then(function (t) {
            return i.parse(t, r);
          });
        }

        var vs = gs(go),
            bs = gs(To);

        function _s(t, e) {
          return new Promise(function (n, r) {
            var i = new Image();

            for (var a in e) {
              i[a] = e[a];
            }

            i.onerror = r, i.onload = function () {
              n(i);
            }, i.src = t;
          });
        }

        function xs(t) {
          if (!t.ok) throw new Error(t.status + " " + t.statusText);
          if (204 !== t.status && 205 !== t.status) return t.json();
        }

        function ws(t, e) {
          return fetch(t, e).then(xs);
        }

        function ks(t) {
          return function (e, n) {
            return ys(e, n).then(function (e) {
              return new DOMParser().parseFromString(e, t);
            });
          };
        }

        var Ts = ks("application/xml");
        var Es = ks("text/html"),
            Cs = ks("image/svg+xml");

        function Ss(t, e) {
          var n;

          function r() {
            var r,
                i,
                a = n.length,
                o = 0,
                s = 0;

            for (r = 0; r < a; ++r) {
              o += (i = n[r]).x, s += i.y;
            }

            for (o = o / a - t, s = s / a - e, r = 0; r < a; ++r) {
              (i = n[r]).x -= o, i.y -= s;
            }
          }

          return null == t && (t = 0), null == e && (e = 0), r.initialize = function (t) {
            n = t;
          }, r.x = function (e) {
            return arguments.length ? (t = +e, r) : t;
          }, r.y = function (t) {
            return arguments.length ? (e = +t, r) : e;
          }, r;
        }

        function As(t) {
          return function () {
            return t;
          };
        }

        function Ms() {
          return 1e-6 * (Math.random() - .5);
        }

        function Ns(t, e, n, r) {
          if (isNaN(e) || isNaN(n)) return t;
          var i,
              a,
              o,
              s,
              c,
              u,
              l,
              h,
              f,
              d = t._root,
              p = {
            data: r
          },
              y = t._x0,
              g = t._y0,
              m = t._x1,
              v = t._y1;
          if (!d) return t._root = p, t;

          for (; d.length;) {
            if ((u = e >= (a = (y + m) / 2)) ? y = a : m = a, (l = n >= (o = (g + v) / 2)) ? g = o : v = o, i = d, !(d = d[h = l << 1 | u])) return i[h] = p, t;
          }

          if (s = +t._x.call(null, d.data), c = +t._y.call(null, d.data), e === s && n === c) return p.next = d, i ? i[h] = p : t._root = p, t;

          do {
            i = i ? i[h] = new Array(4) : t._root = new Array(4), (u = e >= (a = (y + m) / 2)) ? y = a : m = a, (l = n >= (o = (g + v) / 2)) ? g = o : v = o;
          } while ((h = l << 1 | u) == (f = (c >= o) << 1 | s >= a));

          return i[f] = d, i[h] = p, t;
        }

        function Ds(t, e, n, r, i) {
          this.node = t, this.x0 = e, this.y0 = n, this.x1 = r, this.y1 = i;
        }

        function Os(t) {
          return t[0];
        }

        function Bs(t) {
          return t[1];
        }

        function Ls(t, e, n) {
          var r = new Is(null == e ? Os : e, null == n ? Bs : n, NaN, NaN, NaN, NaN);
          return null == t ? r : r.addAll(t);
        }

        function Is(t, e, n, r, i, a) {
          this._x = t, this._y = e, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this._root = void 0;
        }

        function Rs(t) {
          for (var e = {
            data: t.data
          }, n = e; t = t.next;) {
            n = n.next = {
              data: t.data
            };
          }

          return e;
        }

        var Ps = Ls.prototype = Is.prototype;

        function Fs(t) {
          return t.x + t.vx;
        }

        function js(t) {
          return t.y + t.vy;
        }

        function Ys(t) {
          var e,
              n,
              r = 1,
              i = 1;

          function a() {
            for (var t, a, s, c, u, l, h, f = e.length, d = 0; d < i; ++d) {
              for (a = Ls(e, Fs, js).visitAfter(o), t = 0; t < f; ++t) {
                s = e[t], l = n[s.index], h = l * l, c = s.x + s.vx, u = s.y + s.vy, a.visit(p);
              }
            }

            function p(t, e, n, i, a) {
              var o = t.data,
                  f = t.r,
                  d = l + f;
              if (!o) return e > c + d || i < c - d || n > u + d || a < u - d;

              if (o.index > s.index) {
                var p = c - o.x - o.vx,
                    y = u - o.y - o.vy,
                    g = p * p + y * y;
                g < d * d && (0 === p && (g += (p = Ms()) * p), 0 === y && (g += (y = Ms()) * y), g = (d - (g = Math.sqrt(g))) / g * r, s.vx += (p *= g) * (d = (f *= f) / (h + f)), s.vy += (y *= g) * d, o.vx -= p * (d = 1 - d), o.vy -= y * d);
              }
            }
          }

          function o(t) {
            if (t.data) return t.r = n[t.data.index];

            for (var e = t.r = 0; e < 4; ++e) {
              t[e] && t[e].r > t.r && (t.r = t[e].r);
            }
          }

          function s() {
            if (e) {
              var r,
                  i,
                  a = e.length;

              for (n = new Array(a), r = 0; r < a; ++r) {
                i = e[r], n[i.index] = +t(i, r, e);
              }
            }
          }

          return "function" != typeof t && (t = As(null == t ? 1 : +t)), a.initialize = function (t) {
            e = t, s();
          }, a.iterations = function (t) {
            return arguments.length ? (i = +t, a) : i;
          }, a.strength = function (t) {
            return arguments.length ? (r = +t, a) : r;
          }, a.radius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : As(+e), s(), a) : t;
          }, a;
        }

        function Us(t) {
          return t.index;
        }

        function zs(t, e) {
          var n = t.get(e);
          if (!n) throw new Error("missing: " + e);
          return n;
        }

        function qs(t) {
          var e,
              n,
              r,
              i,
              a,
              o = Us,
              s = function s(t) {
            return 1 / Math.min(i[t.source.index], i[t.target.index]);
          },
              c = As(30),
              u = 1;

          function l(r) {
            for (var i = 0, o = t.length; i < u; ++i) {
              for (var s, c, l, h, f, d, p, y = 0; y < o; ++y) {
                c = (s = t[y]).source, h = (l = s.target).x + l.vx - c.x - c.vx || Ms(), f = l.y + l.vy - c.y - c.vy || Ms(), h *= d = ((d = Math.sqrt(h * h + f * f)) - n[y]) / d * r * e[y], f *= d, l.vx -= h * (p = a[y]), l.vy -= f * p, c.vx += h * (p = 1 - p), c.vy += f * p;
              }
            }
          }

          function h() {
            if (r) {
              var s,
                  c,
                  u = r.length,
                  l = t.length,
                  h = ea(r, o);

              for (s = 0, i = new Array(u); s < l; ++s) {
                (c = t[s]).index = s, "object" != typeof c.source && (c.source = zs(h, c.source)), "object" != typeof c.target && (c.target = zs(h, c.target)), i[c.source.index] = (i[c.source.index] || 0) + 1, i[c.target.index] = (i[c.target.index] || 0) + 1;
              }

              for (s = 0, a = new Array(l); s < l; ++s) {
                c = t[s], a[s] = i[c.source.index] / (i[c.source.index] + i[c.target.index]);
              }

              e = new Array(l), f(), n = new Array(l), d();
            }
          }

          function f() {
            if (r) for (var n = 0, i = t.length; n < i; ++n) {
              e[n] = +s(t[n], n, t);
            }
          }

          function d() {
            if (r) for (var e = 0, i = t.length; e < i; ++e) {
              n[e] = +c(t[e], e, t);
            }
          }

          return null == t && (t = []), l.initialize = function (t) {
            r = t, h();
          }, l.links = function (e) {
            return arguments.length ? (t = e, h(), l) : t;
          }, l.id = function (t) {
            return arguments.length ? (o = t, l) : o;
          }, l.iterations = function (t) {
            return arguments.length ? (u = +t, l) : u;
          }, l.strength = function (t) {
            return arguments.length ? (s = "function" == typeof t ? t : As(+t), f(), l) : s;
          }, l.distance = function (t) {
            return arguments.length ? (c = "function" == typeof t ? t : As(+t), d(), l) : c;
          }, l;
        }

        function $s(t) {
          return t.x;
        }

        function Hs(t) {
          return t.y;
        }

        Ps.copy = function () {
          var t,
              e,
              n = new Is(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
              r = this._root;
          if (!r) return n;
          if (!r.length) return n._root = Rs(r), n;

          for (t = [{
            source: r,
            target: n._root = new Array(4)
          }]; r = t.pop();) {
            for (var i = 0; i < 4; ++i) {
              (e = r.source[i]) && (e.length ? t.push({
                source: e,
                target: r.target[i] = new Array(4)
              }) : r.target[i] = Rs(e));
            }
          }

          return n;
        }, Ps.add = function (t) {
          var e = +this._x.call(null, t),
              n = +this._y.call(null, t);
          return Ns(this.cover(e, n), e, n, t);
        }, Ps.addAll = function (t) {
          var e,
              n,
              r,
              i,
              a = t.length,
              o = new Array(a),
              s = new Array(a),
              c = 1 / 0,
              u = 1 / 0,
              l = -1 / 0,
              h = -1 / 0;

          for (n = 0; n < a; ++n) {
            isNaN(r = +this._x.call(null, e = t[n])) || isNaN(i = +this._y.call(null, e)) || (o[n] = r, s[n] = i, r < c && (c = r), r > l && (l = r), i < u && (u = i), i > h && (h = i));
          }

          if (c > l || u > h) return this;

          for (this.cover(c, u).cover(l, h), n = 0; n < a; ++n) {
            Ns(this, o[n], s[n], t[n]);
          }

          return this;
        }, Ps.cover = function (t, e) {
          if (isNaN(t = +t) || isNaN(e = +e)) return this;
          var n = this._x0,
              r = this._y0,
              i = this._x1,
              a = this._y1;
          if (isNaN(n)) i = (n = Math.floor(t)) + 1, a = (r = Math.floor(e)) + 1;else {
            for (var o, s, c = i - n, u = this._root; n > t || t >= i || r > e || e >= a;) {
              switch (s = (e < r) << 1 | t < n, (o = new Array(4))[s] = u, u = o, c *= 2, s) {
                case 0:
                  i = n + c, a = r + c;
                  break;

                case 1:
                  n = i - c, a = r + c;
                  break;

                case 2:
                  i = n + c, r = a - c;
                  break;

                case 3:
                  n = i - c, r = a - c;
              }
            }

            this._root && this._root.length && (this._root = u);
          }
          return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = a, this;
        }, Ps.data = function () {
          var t = [];
          return this.visit(function (e) {
            if (!e.length) do {
              t.push(e.data);
            } while (e = e.next);
          }), t;
        }, Ps.extent = function (t) {
          return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
        }, Ps.find = function (t, e, n) {
          var r,
              i,
              a,
              o,
              s,
              c,
              u,
              l = this._x0,
              h = this._y0,
              f = this._x1,
              d = this._y1,
              p = [],
              y = this._root;

          for (y && p.push(new Ds(y, l, h, f, d)), null == n ? n = 1 / 0 : (l = t - n, h = e - n, f = t + n, d = e + n, n *= n); c = p.pop();) {
            if (!(!(y = c.node) || (i = c.x0) > f || (a = c.y0) > d || (o = c.x1) < l || (s = c.y1) < h)) if (y.length) {
              var g = (i + o) / 2,
                  m = (a + s) / 2;
              p.push(new Ds(y[3], g, m, o, s), new Ds(y[2], i, m, g, s), new Ds(y[1], g, a, o, m), new Ds(y[0], i, a, g, m)), (u = (e >= m) << 1 | t >= g) && (c = p[p.length - 1], p[p.length - 1] = p[p.length - 1 - u], p[p.length - 1 - u] = c);
            } else {
              var v = t - +this._x.call(null, y.data),
                  b = e - +this._y.call(null, y.data),
                  _ = v * v + b * b;

              if (_ < n) {
                var x = Math.sqrt(n = _);
                l = t - x, h = e - x, f = t + x, d = e + x, r = y.data;
              }
            }
          }

          return r;
        }, Ps.remove = function (t) {
          if (isNaN(a = +this._x.call(null, t)) || isNaN(o = +this._y.call(null, t))) return this;
          var e,
              n,
              r,
              i,
              a,
              o,
              s,
              c,
              u,
              l,
              h,
              f,
              d = this._root,
              p = this._x0,
              y = this._y0,
              g = this._x1,
              m = this._y1;
          if (!d) return this;
          if (d.length) for (;;) {
            if ((u = a >= (s = (p + g) / 2)) ? p = s : g = s, (l = o >= (c = (y + m) / 2)) ? y = c : m = c, e = d, !(d = d[h = l << 1 | u])) return this;
            if (!d.length) break;
            (e[h + 1 & 3] || e[h + 2 & 3] || e[h + 3 & 3]) && (n = e, f = h);
          }

          for (; d.data !== t;) {
            if (r = d, !(d = d.next)) return this;
          }

          return (i = d.next) && delete d.next, r ? (i ? r.next = i : delete r.next, this) : e ? (i ? e[h] = i : delete e[h], (d = e[0] || e[1] || e[2] || e[3]) && d === (e[3] || e[2] || e[1] || e[0]) && !d.length && (n ? n[f] = d : this._root = d), this) : (this._root = i, this);
        }, Ps.removeAll = function (t) {
          for (var e = 0, n = t.length; e < n; ++e) {
            this.remove(t[e]);
          }

          return this;
        }, Ps.root = function () {
          return this._root;
        }, Ps.size = function () {
          var t = 0;
          return this.visit(function (e) {
            if (!e.length) do {
              ++t;
            } while (e = e.next);
          }), t;
        }, Ps.visit = function (t) {
          var e,
              n,
              r,
              i,
              a,
              o,
              s = [],
              c = this._root;

          for (c && s.push(new Ds(c, this._x0, this._y0, this._x1, this._y1)); e = s.pop();) {
            if (!t(c = e.node, r = e.x0, i = e.y0, a = e.x1, o = e.y1) && c.length) {
              var u = (r + a) / 2,
                  l = (i + o) / 2;
              (n = c[3]) && s.push(new Ds(n, u, l, a, o)), (n = c[2]) && s.push(new Ds(n, r, l, u, o)), (n = c[1]) && s.push(new Ds(n, u, i, a, l)), (n = c[0]) && s.push(new Ds(n, r, i, u, l));
            }
          }

          return this;
        }, Ps.visitAfter = function (t) {
          var e,
              n = [],
              r = [];

          for (this._root && n.push(new Ds(this._root, this._x0, this._y0, this._x1, this._y1)); e = n.pop();) {
            var i = e.node;

            if (i.length) {
              var a,
                  o = e.x0,
                  s = e.y0,
                  c = e.x1,
                  u = e.y1,
                  l = (o + c) / 2,
                  h = (s + u) / 2;
              (a = i[0]) && n.push(new Ds(a, o, s, l, h)), (a = i[1]) && n.push(new Ds(a, l, s, c, h)), (a = i[2]) && n.push(new Ds(a, o, h, l, u)), (a = i[3]) && n.push(new Ds(a, l, h, c, u));
            }

            r.push(e);
          }

          for (; e = r.pop();) {
            t(e.node, e.x0, e.y0, e.x1, e.y1);
          }

          return this;
        }, Ps.x = function (t) {
          return arguments.length ? (this._x = t, this) : this._x;
        }, Ps.y = function (t) {
          return arguments.length ? (this._y = t, this) : this._y;
        };
        var Ws = Math.PI * (3 - Math.sqrt(5));

        function Vs(t) {
          var e,
              n = 1,
              r = .001,
              i = 1 - Math.pow(r, 1 / 300),
              a = 0,
              o = .6,
              s = ea(),
              c = Wn(l),
              u = ft("tick", "end");

          function l() {
            h(), u.call("tick", e), n < r && (c.stop(), u.call("end", e));
          }

          function h(r) {
            var c,
                u,
                l = t.length;
            void 0 === r && (r = 1);

            for (var h = 0; h < r; ++h) {
              for (n += (a - n) * i, s.each(function (t) {
                t(n);
              }), c = 0; c < l; ++c) {
                null == (u = t[c]).fx ? u.x += u.vx *= o : (u.x = u.fx, u.vx = 0), null == u.fy ? u.y += u.vy *= o : (u.y = u.fy, u.vy = 0);
              }
            }

            return e;
          }

          function f() {
            for (var e, n = 0, r = t.length; n < r; ++n) {
              if ((e = t[n]).index = n, null != e.fx && (e.x = e.fx), null != e.fy && (e.y = e.fy), isNaN(e.x) || isNaN(e.y)) {
                var i = 10 * Math.sqrt(n),
                    a = n * Ws;
                e.x = i * Math.cos(a), e.y = i * Math.sin(a);
              }

              (isNaN(e.vx) || isNaN(e.vy)) && (e.vx = e.vy = 0);
            }
          }

          function d(e) {
            return e.initialize && e.initialize(t), e;
          }

          return null == t && (t = []), f(), e = {
            tick: h,
            restart: function restart() {
              return c.restart(l), e;
            },
            stop: function stop() {
              return c.stop(), e;
            },
            nodes: function nodes(n) {
              return arguments.length ? (t = n, f(), s.each(d), e) : t;
            },
            alpha: function alpha(t) {
              return arguments.length ? (n = +t, e) : n;
            },
            alphaMin: function alphaMin(t) {
              return arguments.length ? (r = +t, e) : r;
            },
            alphaDecay: function alphaDecay(t) {
              return arguments.length ? (i = +t, e) : +i;
            },
            alphaTarget: function alphaTarget(t) {
              return arguments.length ? (a = +t, e) : a;
            },
            velocityDecay: function velocityDecay(t) {
              return arguments.length ? (o = 1 - t, e) : 1 - o;
            },
            force: function force(t, n) {
              return arguments.length > 1 ? (null == n ? s.remove(t) : s.set(t, d(n)), e) : s.get(t);
            },
            find: function find(e, n, r) {
              var i,
                  a,
                  o,
                  s,
                  c,
                  u = 0,
                  l = t.length;

              for (null == r ? r = 1 / 0 : r *= r, u = 0; u < l; ++u) {
                (o = (i = e - (s = t[u]).x) * i + (a = n - s.y) * a) < r && (c = s, r = o);
              }

              return c;
            },
            on: function on(t, n) {
              return arguments.length > 1 ? (u.on(t, n), e) : u.on(t);
            }
          };
        }

        function Gs() {
          var t,
              e,
              n,
              r,
              i = As(-30),
              a = 1,
              o = 1 / 0,
              s = .81;

          function c(r) {
            var i,
                a = t.length,
                o = Ls(t, $s, Hs).visitAfter(l);

            for (n = r, i = 0; i < a; ++i) {
              e = t[i], o.visit(h);
            }
          }

          function u() {
            if (t) {
              var e,
                  n,
                  a = t.length;

              for (r = new Array(a), e = 0; e < a; ++e) {
                n = t[e], r[n.index] = +i(n, e, t);
              }
            }
          }

          function l(t) {
            var e,
                n,
                i,
                a,
                o,
                s = 0,
                c = 0;

            if (t.length) {
              for (i = a = o = 0; o < 4; ++o) {
                (e = t[o]) && (n = Math.abs(e.value)) && (s += e.value, c += n, i += n * e.x, a += n * e.y);
              }

              t.x = i / c, t.y = a / c;
            } else {
              (e = t).x = e.data.x, e.y = e.data.y;

              do {
                s += r[e.data.index];
              } while (e = e.next);
            }

            t.value = s;
          }

          function h(t, i, c, u) {
            if (!t.value) return !0;
            var l = t.x - e.x,
                h = t.y - e.y,
                f = u - i,
                d = l * l + h * h;
            if (f * f / s < d) return d < o && (0 === l && (d += (l = Ms()) * l), 0 === h && (d += (h = Ms()) * h), d < a && (d = Math.sqrt(a * d)), e.vx += l * t.value * n / d, e.vy += h * t.value * n / d), !0;

            if (!(t.length || d >= o)) {
              (t.data !== e || t.next) && (0 === l && (d += (l = Ms()) * l), 0 === h && (d += (h = Ms()) * h), d < a && (d = Math.sqrt(a * d)));

              do {
                t.data !== e && (f = r[t.data.index] * n / d, e.vx += l * f, e.vy += h * f);
              } while (t = t.next);
            }
          }

          return c.initialize = function (e) {
            t = e, u();
          }, c.strength = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : As(+t), u(), c) : i;
          }, c.distanceMin = function (t) {
            return arguments.length ? (a = t * t, c) : Math.sqrt(a);
          }, c.distanceMax = function (t) {
            return arguments.length ? (o = t * t, c) : Math.sqrt(o);
          }, c.theta = function (t) {
            return arguments.length ? (s = t * t, c) : Math.sqrt(s);
          }, c;
        }

        function Xs(t, e, n) {
          var r,
              i,
              a,
              o = As(.1);

          function s(t) {
            for (var o = 0, s = r.length; o < s; ++o) {
              var c = r[o],
                  u = c.x - e || 1e-6,
                  l = c.y - n || 1e-6,
                  h = Math.sqrt(u * u + l * l),
                  f = (a[o] - h) * i[o] * t / h;
              c.vx += u * f, c.vy += l * f;
            }
          }

          function c() {
            if (r) {
              var e,
                  n = r.length;

              for (i = new Array(n), a = new Array(n), e = 0; e < n; ++e) {
                a[e] = +t(r[e], e, r), i[e] = isNaN(a[e]) ? 0 : +o(r[e], e, r);
              }
            }
          }

          return "function" != typeof t && (t = As(+t)), null == e && (e = 0), null == n && (n = 0), s.initialize = function (t) {
            r = t, c();
          }, s.strength = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : As(+t), c(), s) : o;
          }, s.radius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : As(+e), c(), s) : t;
          }, s.x = function (t) {
            return arguments.length ? (e = +t, s) : e;
          }, s.y = function (t) {
            return arguments.length ? (n = +t, s) : n;
          }, s;
        }

        function Zs(t) {
          var e,
              n,
              r,
              i = As(.1);

          function a(t) {
            for (var i, a = 0, o = e.length; a < o; ++a) {
              (i = e[a]).vx += (r[a] - i.x) * n[a] * t;
            }
          }

          function o() {
            if (e) {
              var a,
                  o = e.length;

              for (n = new Array(o), r = new Array(o), a = 0; a < o; ++a) {
                n[a] = isNaN(r[a] = +t(e[a], a, e)) ? 0 : +i(e[a], a, e);
              }
            }
          }

          return "function" != typeof t && (t = As(null == t ? 0 : +t)), a.initialize = function (t) {
            e = t, o();
          }, a.strength = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : As(+t), o(), a) : i;
          }, a.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : As(+e), o(), a) : t;
          }, a;
        }

        function Ks(t) {
          var e,
              n,
              r,
              i = As(.1);

          function a(t) {
            for (var i, a = 0, o = e.length; a < o; ++a) {
              (i = e[a]).vy += (r[a] - i.y) * n[a] * t;
            }
          }

          function o() {
            if (e) {
              var a,
                  o = e.length;

              for (n = new Array(o), r = new Array(o), a = 0; a < o; ++a) {
                n[a] = isNaN(r[a] = +t(e[a], a, e)) ? 0 : +i(e[a], a, e);
              }
            }
          }

          return "function" != typeof t && (t = As(null == t ? 0 : +t)), a.initialize = function (t) {
            e = t, o();
          }, a.strength = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : As(+t), o(), a) : i;
          }, a.y = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : As(+e), o(), a) : t;
          }, a;
        }

        function Qs(t, e) {
          if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
          var n,
              r = t.slice(0, n);
          return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
        }

        function Js(t) {
          return (t = Qs(Math.abs(t))) ? t[1] : NaN;
        }

        var tc,
            ec = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

        function nc(t) {
          if (!(e = ec.exec(t))) throw new Error("invalid format: " + t);
          var e;
          return new rc({
            fill: e[1],
            align: e[2],
            sign: e[3],
            symbol: e[4],
            zero: e[5],
            width: e[6],
            comma: e[7],
            precision: e[8] && e[8].slice(1),
            trim: e[9],
            type: e[10]
          });
        }

        function rc(t) {
          this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
        }

        function ic(t, e) {
          var n = Qs(t, e);
          if (!n) return t + "";
          var r = n[0],
              i = n[1];
          return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
        }

        nc.prototype = rc.prototype, rc.prototype.toString = function () {
          return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
        };
        var ac = {
          "%": function _(t, e) {
            return (100 * t).toFixed(e);
          },
          b: function b(t) {
            return Math.round(t).toString(2);
          },
          c: function c(t) {
            return t + "";
          },
          d: function d(t) {
            return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
          },
          e: function e(t, _e10) {
            return t.toExponential(_e10);
          },
          f: function f(t, e) {
            return t.toFixed(e);
          },
          g: function g(t, e) {
            return t.toPrecision(e);
          },
          o: function o(t) {
            return Math.round(t).toString(8);
          },
          p: function p(t, e) {
            return ic(100 * t, e);
          },
          r: ic,
          s: function s(t, e) {
            var n = Qs(t, e);
            if (!n) return t + "";
            var r = n[0],
                i = n[1],
                a = i - (tc = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
                o = r.length;
            return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + Qs(t, Math.max(0, e + a - 1))[0];
          },
          X: function X(t) {
            return Math.round(t).toString(16).toUpperCase();
          },
          x: function x(t) {
            return Math.round(t).toString(16);
          }
        };

        function oc(t) {
          return t;
        }

        var sc,
            cc,
            uc,
            lc = Array.prototype.map,
            hc = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

        function fc(t) {
          var e,
              n,
              r = void 0 === t.grouping || void 0 === t.thousands ? oc : (e = lc.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
            for (var i = t.length, a = [], o = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(t.substring(i -= s, i + s)), !((c += s + 1) > r));) {
              s = e[o = (o + 1) % e.length];
            }

            return a.reverse().join(n);
          }),
              i = void 0 === t.currency ? "" : t.currency[0] + "",
              a = void 0 === t.currency ? "" : t.currency[1] + "",
              o = void 0 === t.decimal ? "." : t.decimal + "",
              s = void 0 === t.numerals ? oc : function (t) {
            return function (e) {
              return e.replace(/[0-9]/g, function (e) {
                return t[+e];
              });
            };
          }(lc.call(t.numerals, String)),
              c = void 0 === t.percent ? "%" : t.percent + "",
              u = void 0 === t.minus ? "-" : t.minus + "",
              l = void 0 === t.nan ? "NaN" : t.nan + "";

          function h(t) {
            var e = (t = nc(t)).fill,
                n = t.align,
                h = t.sign,
                f = t.symbol,
                d = t.zero,
                p = t.width,
                y = t.comma,
                g = t.precision,
                m = t.trim,
                v = t.type;
            "n" === v ? (y = !0, v = "g") : ac[v] || (void 0 === g && (g = 12), m = !0, v = "g"), (d || "0" === e && "=" === n) && (d = !0, e = "0", n = "=");

            var b = "$" === f ? i : "#" === f && /[boxX]/.test(v) ? "0" + v.toLowerCase() : "",
                _ = "$" === f ? a : /[%p]/.test(v) ? c : "",
                x = ac[v],
                w = /[defgprs%]/.test(v);

            function k(t) {
              var i,
                  a,
                  c,
                  f = b,
                  k = _;
              if ("c" === v) k = x(t) + k, t = "";else {
                var T = (t = +t) < 0 || 1 / t < 0;
                if (t = isNaN(t) ? l : x(Math.abs(t), g), m && (t = function (t) {
                  t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
                    switch (t[r]) {
                      case ".":
                        i = e = r;
                        break;

                      case "0":
                        0 === i && (i = r), e = r;
                        break;

                      default:
                        if (!+t[r]) break t;
                        i > 0 && (i = 0);
                    }
                  }

                  return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
                }(t)), T && 0 == +t && "+" !== h && (T = !1), f = (T ? "(" === h ? h : u : "-" === h || "(" === h ? "" : h) + f, k = ("s" === v ? hc[8 + tc / 3] : "") + k + (T && "(" === h ? ")" : ""), w) for (i = -1, a = t.length; ++i < a;) {
                  if (48 > (c = t.charCodeAt(i)) || c > 57) {
                    k = (46 === c ? o + t.slice(i + 1) : t.slice(i)) + k, t = t.slice(0, i);
                    break;
                  }
                }
              }
              y && !d && (t = r(t, 1 / 0));
              var E = f.length + t.length + k.length,
                  C = E < p ? new Array(p - E + 1).join(e) : "";

              switch (y && d && (t = r(C + t, C.length ? p - k.length : 1 / 0), C = ""), n) {
                case "<":
                  t = f + t + k + C;
                  break;

                case "=":
                  t = f + C + t + k;
                  break;

                case "^":
                  t = C.slice(0, E = C.length >> 1) + f + t + k + C.slice(E);
                  break;

                default:
                  t = C + f + t + k;
              }

              return s(t);
            }

            return g = void 0 === g ? 6 : /[gprs]/.test(v) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), k.toString = function () {
              return t + "";
            }, k;
          }

          return {
            format: h,
            formatPrefix: function formatPrefix(t, e) {
              var n = h(((t = nc(t)).type = "f", t)),
                  r = 3 * Math.max(-8, Math.min(8, Math.floor(Js(e) / 3))),
                  i = Math.pow(10, -r),
                  a = hc[8 + r / 3];
              return function (t) {
                return n(i * t) + a;
              };
            }
          };
        }

        function dc(t) {
          return sc = fc(t), cc = sc.format, uc = sc.formatPrefix, sc;
        }

        function pc(t) {
          return Math.max(0, -Js(Math.abs(t)));
        }

        function yc(t, e) {
          return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(Js(e) / 3))) - Js(Math.abs(t)));
        }

        function gc(t, e) {
          return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Js(e) - Js(t)) + 1;
        }

        function mc() {
          return new vc();
        }

        function vc() {
          this.reset();
        }

        dc({
          decimal: ".",
          thousands: ",",
          grouping: [3],
          currency: ["$", ""],
          minus: "-"
        }), vc.prototype = {
          constructor: vc,
          reset: function reset() {
            this.s = this.t = 0;
          },
          add: function add(t) {
            _c(bc, t, this.t), _c(this, bc.s, this.s), this.s ? this.t += bc.t : this.s = bc.t;
          },
          valueOf: function valueOf() {
            return this.s;
          }
        };
        var bc = new vc();

        function _c(t, e, n) {
          var r = t.s = e + n,
              i = r - e,
              a = r - i;
          t.t = e - a + (n - i);
        }

        var xc = 1e-6,
            wc = 1e-12,
            kc = Math.PI,
            Tc = kc / 2,
            Ec = kc / 4,
            Cc = 2 * kc,
            Sc = 180 / kc,
            Ac = kc / 180,
            Mc = Math.abs,
            Nc = Math.atan,
            Dc = Math.atan2,
            Oc = Math.cos,
            Bc = Math.ceil,
            Lc = Math.exp,
            Ic = (Math.floor, Math.log),
            Rc = Math.pow,
            Pc = Math.sin,
            Fc = Math.sign || function (t) {
          return t > 0 ? 1 : t < 0 ? -1 : 0;
        },
            jc = Math.sqrt,
            Yc = Math.tan;

        function Uc(t) {
          return t > 1 ? 0 : t < -1 ? kc : Math.acos(t);
        }

        function zc(t) {
          return t > 1 ? Tc : t < -1 ? -Tc : Math.asin(t);
        }

        function qc(t) {
          return (t = Pc(t / 2)) * t;
        }

        function $c() {}

        function Hc(t, e) {
          t && Vc.hasOwnProperty(t.type) && Vc[t.type](t, e);
        }

        var Wc = {
          Feature: function Feature(t, e) {
            Hc(t.geometry, e);
          },
          FeatureCollection: function FeatureCollection(t, e) {
            for (var n = t.features, r = -1, i = n.length; ++r < i;) {
              Hc(n[r].geometry, e);
            }
          }
        },
            Vc = {
          Sphere: function Sphere(t, e) {
            e.sphere();
          },
          Point: function Point(t, e) {
            t = t.coordinates, e.point(t[0], t[1], t[2]);
          },
          MultiPoint: function MultiPoint(t, e) {
            for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
              t = n[r], e.point(t[0], t[1], t[2]);
            }
          },
          LineString: function LineString(t, e) {
            Gc(t.coordinates, e, 0);
          },
          MultiLineString: function MultiLineString(t, e) {
            for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
              Gc(n[r], e, 0);
            }
          },
          Polygon: function Polygon(t, e) {
            Xc(t.coordinates, e);
          },
          MultiPolygon: function MultiPolygon(t, e) {
            for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
              Xc(n[r], e);
            }
          },
          GeometryCollection: function GeometryCollection(t, e) {
            for (var n = t.geometries, r = -1, i = n.length; ++r < i;) {
              Hc(n[r], e);
            }
          }
        };

        function Gc(t, e, n) {
          var r,
              i = -1,
              a = t.length - n;

          for (e.lineStart(); ++i < a;) {
            r = t[i], e.point(r[0], r[1], r[2]);
          }

          e.lineEnd();
        }

        function Xc(t, e) {
          var n = -1,
              r = t.length;

          for (e.polygonStart(); ++n < r;) {
            Gc(t[n], e, 1);
          }

          e.polygonEnd();
        }

        function Zc(t, e) {
          t && Wc.hasOwnProperty(t.type) ? Wc[t.type](t, e) : Hc(t, e);
        }

        var Kc,
            Qc,
            Jc,
            tu,
            eu,
            nu = mc(),
            ru = mc(),
            iu = {
          point: $c,
          lineStart: $c,
          lineEnd: $c,
          polygonStart: function polygonStart() {
            nu.reset(), iu.lineStart = au, iu.lineEnd = ou;
          },
          polygonEnd: function polygonEnd() {
            var t = +nu;
            ru.add(t < 0 ? Cc + t : t), this.lineStart = this.lineEnd = this.point = $c;
          },
          sphere: function sphere() {
            ru.add(Cc);
          }
        };

        function au() {
          iu.point = su;
        }

        function ou() {
          cu(Kc, Qc);
        }

        function su(t, e) {
          iu.point = cu, Kc = t, Qc = e, Jc = t *= Ac, tu = Oc(e = (e *= Ac) / 2 + Ec), eu = Pc(e);
        }

        function cu(t, e) {
          var n = (t *= Ac) - Jc,
              r = n >= 0 ? 1 : -1,
              i = r * n,
              a = Oc(e = (e *= Ac) / 2 + Ec),
              o = Pc(e),
              s = eu * o,
              c = tu * a + s * Oc(i),
              u = s * r * Pc(i);
          nu.add(Dc(u, c)), Jc = t, tu = a, eu = o;
        }

        function uu(t) {
          return ru.reset(), Zc(t, iu), 2 * ru;
        }

        function lu(t) {
          return [Dc(t[1], t[0]), zc(t[2])];
        }

        function hu(t) {
          var e = t[0],
              n = t[1],
              r = Oc(n);
          return [r * Oc(e), r * Pc(e), Pc(n)];
        }

        function fu(t, e) {
          return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
        }

        function du(t, e) {
          return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
        }

        function pu(t, e) {
          t[0] += e[0], t[1] += e[1], t[2] += e[2];
        }

        function yu(t, e) {
          return [t[0] * e, t[1] * e, t[2] * e];
        }

        function gu(t) {
          var e = jc(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
          t[0] /= e, t[1] /= e, t[2] /= e;
        }

        var mu,
            vu,
            bu,
            _u,
            xu,
            wu,
            ku,
            Tu,
            Eu,
            Cu,
            Su,
            Au,
            Mu,
            Nu,
            Du,
            Ou,
            Bu,
            Lu,
            Iu,
            Ru,
            Pu,
            Fu,
            ju,
            Yu,
            Uu,
            zu,
            qu = mc(),
            $u = {
          point: Hu,
          lineStart: Vu,
          lineEnd: Gu,
          polygonStart: function polygonStart() {
            $u.point = Xu, $u.lineStart = Zu, $u.lineEnd = Ku, qu.reset(), iu.polygonStart();
          },
          polygonEnd: function polygonEnd() {
            iu.polygonEnd(), $u.point = Hu, $u.lineStart = Vu, $u.lineEnd = Gu, nu < 0 ? (mu = -(bu = 180), vu = -(_u = 90)) : qu > xc ? _u = 90 : qu < -1e-6 && (vu = -90), Cu[0] = mu, Cu[1] = bu;
          },
          sphere: function sphere() {
            mu = -(bu = 180), vu = -(_u = 90);
          }
        };

        function Hu(t, e) {
          Eu.push(Cu = [mu = t, bu = t]), e < vu && (vu = e), e > _u && (_u = e);
        }

        function Wu(t, e) {
          var n = hu([t * Ac, e * Ac]);

          if (Tu) {
            var r = du(Tu, n),
                i = du([r[1], -r[0], 0], r);
            gu(i), i = lu(i);
            var a,
                o = t - xu,
                s = o > 0 ? 1 : -1,
                c = i[0] * Sc * s,
                u = Mc(o) > 180;
            u ^ (s * xu < c && c < s * t) ? (a = i[1] * Sc) > _u && (_u = a) : u ^ (s * xu < (c = (c + 360) % 360 - 180) && c < s * t) ? (a = -i[1] * Sc) < vu && (vu = a) : (e < vu && (vu = e), e > _u && (_u = e)), u ? t < xu ? Qu(mu, t) > Qu(mu, bu) && (bu = t) : Qu(t, bu) > Qu(mu, bu) && (mu = t) : bu >= mu ? (t < mu && (mu = t), t > bu && (bu = t)) : t > xu ? Qu(mu, t) > Qu(mu, bu) && (bu = t) : Qu(t, bu) > Qu(mu, bu) && (mu = t);
          } else Eu.push(Cu = [mu = t, bu = t]);

          e < vu && (vu = e), e > _u && (_u = e), Tu = n, xu = t;
        }

        function Vu() {
          $u.point = Wu;
        }

        function Gu() {
          Cu[0] = mu, Cu[1] = bu, $u.point = Hu, Tu = null;
        }

        function Xu(t, e) {
          if (Tu) {
            var n = t - xu;
            qu.add(Mc(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
          } else wu = t, ku = e;

          iu.point(t, e), Wu(t, e);
        }

        function Zu() {
          iu.lineStart();
        }

        function Ku() {
          Xu(wu, ku), iu.lineEnd(), Mc(qu) > xc && (mu = -(bu = 180)), Cu[0] = mu, Cu[1] = bu, Tu = null;
        }

        function Qu(t, e) {
          return (e -= t) < 0 ? e + 360 : e;
        }

        function Ju(t, e) {
          return t[0] - e[0];
        }

        function tl(t, e) {
          return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
        }

        function el(t) {
          var e, n, r, i, a, o, s;

          if (_u = bu = -(mu = vu = 1 / 0), Eu = [], Zc(t, $u), n = Eu.length) {
            for (Eu.sort(Ju), e = 1, a = [r = Eu[0]]; e < n; ++e) {
              tl(r, (i = Eu[e])[0]) || tl(r, i[1]) ? (Qu(r[0], i[1]) > Qu(r[0], r[1]) && (r[1] = i[1]), Qu(i[0], r[1]) > Qu(r[0], r[1]) && (r[0] = i[0])) : a.push(r = i);
            }

            for (o = -1 / 0, e = 0, r = a[n = a.length - 1]; e <= n; r = i, ++e) {
              i = a[e], (s = Qu(r[1], i[0])) > o && (o = s, mu = i[0], bu = r[1]);
            }
          }

          return Eu = Cu = null, mu === 1 / 0 || vu === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[mu, vu], [bu, _u]];
        }

        var nl = {
          sphere: $c,
          point: rl,
          lineStart: al,
          lineEnd: cl,
          polygonStart: function polygonStart() {
            nl.lineStart = ul, nl.lineEnd = ll;
          },
          polygonEnd: function polygonEnd() {
            nl.lineStart = al, nl.lineEnd = cl;
          }
        };

        function rl(t, e) {
          t *= Ac;
          var n = Oc(e *= Ac);
          il(n * Oc(t), n * Pc(t), Pc(e));
        }

        function il(t, e, n) {
          ++Su, Mu += (t - Mu) / Su, Nu += (e - Nu) / Su, Du += (n - Du) / Su;
        }

        function al() {
          nl.point = ol;
        }

        function ol(t, e) {
          t *= Ac;
          var n = Oc(e *= Ac);
          Yu = n * Oc(t), Uu = n * Pc(t), zu = Pc(e), nl.point = sl, il(Yu, Uu, zu);
        }

        function sl(t, e) {
          t *= Ac;
          var n = Oc(e *= Ac),
              r = n * Oc(t),
              i = n * Pc(t),
              a = Pc(e),
              o = Dc(jc((o = Uu * a - zu * i) * o + (o = zu * r - Yu * a) * o + (o = Yu * i - Uu * r) * o), Yu * r + Uu * i + zu * a);
          Au += o, Ou += o * (Yu + (Yu = r)), Bu += o * (Uu + (Uu = i)), Lu += o * (zu + (zu = a)), il(Yu, Uu, zu);
        }

        function cl() {
          nl.point = rl;
        }

        function ul() {
          nl.point = hl;
        }

        function ll() {
          fl(Fu, ju), nl.point = rl;
        }

        function hl(t, e) {
          Fu = t, ju = e, t *= Ac, e *= Ac, nl.point = fl;
          var n = Oc(e);
          Yu = n * Oc(t), Uu = n * Pc(t), zu = Pc(e), il(Yu, Uu, zu);
        }

        function fl(t, e) {
          t *= Ac;
          var n = Oc(e *= Ac),
              r = n * Oc(t),
              i = n * Pc(t),
              a = Pc(e),
              o = Uu * a - zu * i,
              s = zu * r - Yu * a,
              c = Yu * i - Uu * r,
              u = jc(o * o + s * s + c * c),
              l = zc(u),
              h = u && -l / u;
          Iu += h * o, Ru += h * s, Pu += h * c, Au += l, Ou += l * (Yu + (Yu = r)), Bu += l * (Uu + (Uu = i)), Lu += l * (zu + (zu = a)), il(Yu, Uu, zu);
        }

        function dl(t) {
          Su = Au = Mu = Nu = Du = Ou = Bu = Lu = Iu = Ru = Pu = 0, Zc(t, nl);
          var e = Iu,
              n = Ru,
              r = Pu,
              i = e * e + n * n + r * r;
          return i < wc && (e = Ou, n = Bu, r = Lu, Au < xc && (e = Mu, n = Nu, r = Du), (i = e * e + n * n + r * r) < wc) ? [NaN, NaN] : [Dc(n, e) * Sc, zc(r / jc(i)) * Sc];
        }

        function pl(t) {
          return function () {
            return t;
          };
        }

        function yl(t, e) {
          function n(n, r) {
            return n = t(n, r), e(n[0], n[1]);
          }

          return t.invert && e.invert && (n.invert = function (n, r) {
            return (n = e.invert(n, r)) && t.invert(n[0], n[1]);
          }), n;
        }

        function gl(t, e) {
          return [Mc(t) > kc ? t + Math.round(-t / Cc) * Cc : t, e];
        }

        function ml(t, e, n) {
          return (t %= Cc) ? e || n ? yl(bl(t), _l(e, n)) : bl(t) : e || n ? _l(e, n) : gl;
        }

        function vl(t) {
          return function (e, n) {
            return [(e += t) > kc ? e - Cc : e < -kc ? e + Cc : e, n];
          };
        }

        function bl(t) {
          var e = vl(t);
          return e.invert = vl(-t), e;
        }

        function _l(t, e) {
          var n = Oc(t),
              r = Pc(t),
              i = Oc(e),
              a = Pc(e);

          function o(t, e) {
            var o = Oc(e),
                s = Oc(t) * o,
                c = Pc(t) * o,
                u = Pc(e),
                l = u * n + s * r;
            return [Dc(c * i - l * a, s * n - u * r), zc(l * i + c * a)];
          }

          return o.invert = function (t, e) {
            var o = Oc(e),
                s = Oc(t) * o,
                c = Pc(t) * o,
                u = Pc(e),
                l = u * i - c * a;
            return [Dc(c * i + u * a, s * n + l * r), zc(l * n - s * r)];
          }, o;
        }

        function xl(t) {
          function e(e) {
            return (e = t(e[0] * Ac, e[1] * Ac))[0] *= Sc, e[1] *= Sc, e;
          }

          return t = ml(t[0] * Ac, t[1] * Ac, t.length > 2 ? t[2] * Ac : 0), e.invert = function (e) {
            return (e = t.invert(e[0] * Ac, e[1] * Ac))[0] *= Sc, e[1] *= Sc, e;
          }, e;
        }

        function wl(t, e, n, r, i, a) {
          if (n) {
            var o = Oc(e),
                s = Pc(e),
                c = r * n;
            null == i ? (i = e + r * Cc, a = e - c / 2) : (i = kl(o, i), a = kl(o, a), (r > 0 ? i < a : i > a) && (i += r * Cc));

            for (var u, l = i; r > 0 ? l > a : l < a; l -= c) {
              u = lu([o, -s * Oc(l), -s * Pc(l)]), t.point(u[0], u[1]);
            }
          }
        }

        function kl(t, e) {
          (e = hu(e))[0] -= t, gu(e);
          var n = Uc(-e[1]);
          return ((-e[2] < 0 ? -n : n) + Cc - xc) % Cc;
        }

        function Tl() {
          var t,
              e,
              n = pl([0, 0]),
              r = pl(90),
              i = pl(6),
              a = {
            point: function point(n, r) {
              t.push(n = e(n, r)), n[0] *= Sc, n[1] *= Sc;
            }
          };

          function o() {
            var o = n.apply(this, arguments),
                s = r.apply(this, arguments) * Ac,
                c = i.apply(this, arguments) * Ac;
            return t = [], e = ml(-o[0] * Ac, -o[1] * Ac, 0).invert, wl(a, s, c, 1), o = {
              type: "Polygon",
              coordinates: [t]
            }, t = e = null, o;
          }

          return o.center = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : pl([+t[0], +t[1]]), o) : n;
          }, o.radius = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : pl(+t), o) : r;
          }, o.precision = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : pl(+t), o) : i;
          }, o;
        }

        function El() {
          var t,
              e = [];
          return {
            point: function point(e, n, r) {
              t.push([e, n, r]);
            },
            lineStart: function lineStart() {
              e.push(t = []);
            },
            lineEnd: $c,
            rejoin: function rejoin() {
              e.length > 1 && e.push(e.pop().concat(e.shift()));
            },
            result: function result() {
              var n = e;
              return e = [], t = null, n;
            }
          };
        }

        function Cl(t, e) {
          return Mc(t[0] - e[0]) < xc && Mc(t[1] - e[1]) < xc;
        }

        function Sl(t, e, n, r) {
          this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
        }

        function Al(t, e, n, r, i) {
          var a,
              o,
              s = [],
              c = [];

          if (t.forEach(function (t) {
            if (!((e = t.length - 1) <= 0)) {
              var e,
                  n,
                  r = t[0],
                  o = t[e];

              if (Cl(r, o)) {
                if (!r[2] && !o[2]) {
                  for (i.lineStart(), a = 0; a < e; ++a) {
                    i.point((r = t[a])[0], r[1]);
                  }

                  return void i.lineEnd();
                }

                o[0] += 2e-6;
              }

              s.push(n = new Sl(r, t, null, !0)), c.push(n.o = new Sl(r, null, n, !1)), s.push(n = new Sl(o, t, null, !1)), c.push(n.o = new Sl(o, null, n, !0));
            }
          }), s.length) {
            for (c.sort(e), Ml(s), Ml(c), a = 0, o = c.length; a < o; ++a) {
              c[a].e = n = !n;
            }

            for (var u, l, h = s[0];;) {
              for (var f = h, d = !0; f.v;) {
                if ((f = f.n) === h) return;
              }

              u = f.z, i.lineStart();

              do {
                if (f.v = f.o.v = !0, f.e) {
                  if (d) for (a = 0, o = u.length; a < o; ++a) {
                    i.point((l = u[a])[0], l[1]);
                  } else r(f.x, f.n.x, 1, i);
                  f = f.n;
                } else {
                  if (d) for (u = f.p.z, a = u.length - 1; a >= 0; --a) {
                    i.point((l = u[a])[0], l[1]);
                  } else r(f.x, f.p.x, -1, i);
                  f = f.p;
                }

                u = (f = f.o).z, d = !d;
              } while (!f.v);

              i.lineEnd();
            }
          }
        }

        function Ml(t) {
          if (e = t.length) {
            for (var e, n, r = 0, i = t[0]; ++r < e;) {
              i.n = n = t[r], n.p = i, i = n;
            }

            i.n = n = t[0], n.p = i;
          }
        }

        gl.invert = gl;
        var Nl = mc();

        function Dl(t) {
          return Mc(t[0]) <= kc ? t[0] : Fc(t[0]) * ((Mc(t[0]) + kc) % Cc - kc);
        }

        function Ol(t, e) {
          var n = Dl(e),
              r = e[1],
              i = Pc(r),
              a = [Pc(n), -Oc(n), 0],
              o = 0,
              s = 0;
          Nl.reset(), 1 === i ? r = Tc + xc : -1 === i && (r = -Tc - xc);

          for (var c = 0, u = t.length; c < u; ++c) {
            if (h = (l = t[c]).length) for (var l, h, f = l[h - 1], d = Dl(f), p = f[1] / 2 + Ec, y = Pc(p), g = Oc(p), m = 0; m < h; ++m, d = b, y = x, g = w, f = v) {
              var v = l[m],
                  b = Dl(v),
                  _ = v[1] / 2 + Ec,
                  x = Pc(_),
                  w = Oc(_),
                  k = b - d,
                  T = k >= 0 ? 1 : -1,
                  E = T * k,
                  C = E > kc,
                  S = y * x;

              if (Nl.add(Dc(S * T * Pc(E), g * w + S * Oc(E))), o += C ? k + T * Cc : k, C ^ d >= n ^ b >= n) {
                var A = du(hu(f), hu(v));
                gu(A);
                var M = du(a, A);
                gu(M);
                var N = (C ^ k >= 0 ? -1 : 1) * zc(M[2]);
                (r > N || r === N && (A[0] || A[1])) && (s += C ^ k >= 0 ? 1 : -1);
              }
            }
          }

          return (o < -1e-6 || o < xc && Nl < -1e-6) ^ 1 & s;
        }

        function Bl(t, e, n, r) {
          return function (i) {
            var a,
                o,
                s,
                c = e(i),
                u = El(),
                l = e(u),
                h = !1,
                f = {
              point: d,
              lineStart: y,
              lineEnd: g,
              polygonStart: function polygonStart() {
                f.point = m, f.lineStart = v, f.lineEnd = b, o = [], a = [];
              },
              polygonEnd: function polygonEnd() {
                f.point = d, f.lineStart = y, f.lineEnd = g, o = F(o);
                var t = Ol(a, r);
                o.length ? (h || (i.polygonStart(), h = !0), Al(o, Il, t, n, i)) : t && (h || (i.polygonStart(), h = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), h && (i.polygonEnd(), h = !1), o = a = null;
              },
              sphere: function sphere() {
                i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
              }
            };

            function d(e, n) {
              t(e, n) && i.point(e, n);
            }

            function p(t, e) {
              c.point(t, e);
            }

            function y() {
              f.point = p, c.lineStart();
            }

            function g() {
              f.point = d, c.lineEnd();
            }

            function m(t, e) {
              s.push([t, e]), l.point(t, e);
            }

            function v() {
              l.lineStart(), s = [];
            }

            function b() {
              m(s[0][0], s[0][1]), l.lineEnd();
              var t,
                  e,
                  n,
                  r,
                  c = l.clean(),
                  f = u.result(),
                  d = f.length;
              if (s.pop(), a.push(s), s = null, d) if (1 & c) {
                if ((e = (n = f[0]).length - 1) > 0) {
                  for (h || (i.polygonStart(), h = !0), i.lineStart(), t = 0; t < e; ++t) {
                    i.point((r = n[t])[0], r[1]);
                  }

                  i.lineEnd();
                }
              } else d > 1 && 2 & c && f.push(f.pop().concat(f.shift())), o.push(f.filter(Ll));
            }

            return f;
          };
        }

        function Ll(t) {
          return t.length > 1;
        }

        function Il(t, e) {
          return ((t = t.x)[0] < 0 ? t[1] - Tc - xc : Tc - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Tc - xc : Tc - e[1]);
        }

        var Rl = Bl(function () {
          return !0;
        }, function (t) {
          var e,
              n = NaN,
              r = NaN,
              i = NaN;
          return {
            lineStart: function lineStart() {
              t.lineStart(), e = 1;
            },
            point: function point(a, o) {
              var s = a > 0 ? kc : -kc,
                  c = Mc(a - n);
              Mc(c - kc) < xc ? (t.point(n, r = (r + o) / 2 > 0 ? Tc : -Tc), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(s, r), t.point(a, r), e = 0) : i !== s && c >= kc && (Mc(n - i) < xc && (n -= i * xc), Mc(a - s) < xc && (a -= s * xc), r = function (t, e, n, r) {
                var i,
                    a,
                    o = Pc(t - n);
                return Mc(o) > xc ? Nc((Pc(e) * (a = Oc(r)) * Pc(n) - Pc(r) * (i = Oc(e)) * Pc(t)) / (i * a * o)) : (e + r) / 2;
              }(n, r, a, o), t.point(i, r), t.lineEnd(), t.lineStart(), t.point(s, r), e = 0), t.point(n = a, r = o), i = s;
            },
            lineEnd: function lineEnd() {
              t.lineEnd(), n = r = NaN;
            },
            clean: function clean() {
              return 2 - e;
            }
          };
        }, function (t, e, n, r) {
          var i;
          if (null == t) i = n * Tc, r.point(-kc, i), r.point(0, i), r.point(kc, i), r.point(kc, 0), r.point(kc, -i), r.point(0, -i), r.point(-kc, -i), r.point(-kc, 0), r.point(-kc, i);else if (Mc(t[0] - e[0]) > xc) {
            var a = t[0] < e[0] ? kc : -kc;
            i = n * a / 2, r.point(-a, i), r.point(0, i), r.point(a, i);
          } else r.point(e[0], e[1]);
        }, [-kc, -Tc]);

        function Pl(t) {
          var e = Oc(t),
              n = 6 * Ac,
              r = e > 0,
              i = Mc(e) > xc;

          function a(t, n) {
            return Oc(t) * Oc(n) > e;
          }

          function o(t, n, r) {
            var i = [1, 0, 0],
                a = du(hu(t), hu(n)),
                o = fu(a, a),
                s = a[0],
                c = o - s * s;
            if (!c) return !r && t;
            var u = e * o / c,
                l = -e * s / c,
                h = du(i, a),
                f = yu(i, u);
            pu(f, yu(a, l));
            var d = h,
                p = fu(f, d),
                y = fu(d, d),
                g = p * p - y * (fu(f, f) - 1);

            if (!(g < 0)) {
              var m = jc(g),
                  v = yu(d, (-p - m) / y);
              if (pu(v, f), v = lu(v), !r) return v;
              var b,
                  _ = t[0],
                  x = n[0],
                  w = t[1],
                  k = n[1];
              x < _ && (b = _, _ = x, x = b);
              var T = x - _,
                  E = Mc(T - kc) < xc;

              if (!E && k < w && (b = w, w = k, k = b), E || T < xc ? E ? w + k > 0 ^ v[1] < (Mc(v[0] - _) < xc ? w : k) : w <= v[1] && v[1] <= k : T > kc ^ (_ <= v[0] && v[0] <= x)) {
                var C = yu(d, (-p + m) / y);
                return pu(C, f), [v, lu(C)];
              }
            }
          }

          function s(e, n) {
            var i = r ? t : kc - t,
                a = 0;
            return e < -i ? a |= 1 : e > i && (a |= 2), n < -i ? a |= 4 : n > i && (a |= 8), a;
          }

          return Bl(a, function (t) {
            var e, n, c, u, l;
            return {
              lineStart: function lineStart() {
                u = c = !1, l = 1;
              },
              point: function point(h, f) {
                var d,
                    p = [h, f],
                    y = a(h, f),
                    g = r ? y ? 0 : s(h, f) : y ? s(h + (h < 0 ? kc : -kc), f) : 0;
                if (!e && (u = c = y) && t.lineStart(), y !== c && (!(d = o(e, p)) || Cl(e, d) || Cl(p, d)) && (p[2] = 1), y !== c) l = 0, y ? (t.lineStart(), d = o(p, e), t.point(d[0], d[1])) : (d = o(e, p), t.point(d[0], d[1], 2), t.lineEnd()), e = d;else if (i && e && r ^ y) {
                  var m;
                  g & n || !(m = o(p, e, !0)) || (l = 0, r ? (t.lineStart(), t.point(m[0][0], m[0][1]), t.point(m[1][0], m[1][1]), t.lineEnd()) : (t.point(m[1][0], m[1][1]), t.lineEnd(), t.lineStart(), t.point(m[0][0], m[0][1], 3)));
                }
                !y || e && Cl(e, p) || t.point(p[0], p[1]), e = p, c = y, n = g;
              },
              lineEnd: function lineEnd() {
                c && t.lineEnd(), e = null;
              },
              clean: function clean() {
                return l | (u && c) << 1;
              }
            };
          }, function (e, r, i, a) {
            wl(a, t, n, i, e, r);
          }, r ? [0, -t] : [-kc, t - kc]);
        }

        var Fl = 1e9,
            jl = -Fl;

        function Yl(t, e, n, r) {
          function i(i, a) {
            return t <= i && i <= n && e <= a && a <= r;
          }

          function a(i, a, s, u) {
            var l = 0,
                h = 0;
            if (null == i || (l = o(i, s)) !== (h = o(a, s)) || c(i, a) < 0 ^ s > 0) do {
              u.point(0 === l || 3 === l ? t : n, l > 1 ? r : e);
            } while ((l = (l + s + 4) % 4) !== h);else u.point(a[0], a[1]);
          }

          function o(r, i) {
            return Mc(r[0] - t) < xc ? i > 0 ? 0 : 3 : Mc(r[0] - n) < xc ? i > 0 ? 2 : 1 : Mc(r[1] - e) < xc ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
          }

          function s(t, e) {
            return c(t.x, e.x);
          }

          function c(t, e) {
            var n = o(t, 1),
                r = o(e, 1);
            return n !== r ? n - r : 0 === n ? e[1] - t[1] : 1 === n ? t[0] - e[0] : 2 === n ? t[1] - e[1] : e[0] - t[0];
          }

          return function (o) {
            var c,
                u,
                l,
                h,
                f,
                d,
                p,
                y,
                g,
                m,
                v,
                b = o,
                _ = El(),
                x = {
              point: w,
              lineStart: function lineStart() {
                x.point = k, u && u.push(l = []), m = !0, g = !1, p = y = NaN;
              },
              lineEnd: function lineEnd() {
                c && (k(h, f), d && g && _.rejoin(), c.push(_.result())), x.point = w, g && b.lineEnd();
              },
              polygonStart: function polygonStart() {
                b = _, c = [], u = [], v = !0;
              },
              polygonEnd: function polygonEnd() {
                var e = function () {
                  for (var e = 0, n = 0, i = u.length; n < i; ++n) {
                    for (var a, o, s = u[n], c = 1, l = s.length, h = s[0], f = h[0], d = h[1]; c < l; ++c) {
                      a = f, o = d, f = (h = s[c])[0], d = h[1], o <= r ? d > r && (f - a) * (r - o) > (d - o) * (t - a) && ++e : d <= r && (f - a) * (r - o) < (d - o) * (t - a) && --e;
                    }
                  }

                  return e;
                }(),
                    n = v && e,
                    i = (c = F(c)).length;

                (n || i) && (o.polygonStart(), n && (o.lineStart(), a(null, null, 1, o), o.lineEnd()), i && Al(c, s, e, a, o), o.polygonEnd()), b = o, c = u = l = null;
              }
            };

            function w(t, e) {
              i(t, e) && b.point(t, e);
            }

            function k(a, o) {
              var s = i(a, o);
              if (u && l.push([a, o]), m) h = a, f = o, d = s, m = !1, s && (b.lineStart(), b.point(a, o));else if (s && g) b.point(a, o);else {
                var c = [p = Math.max(jl, Math.min(Fl, p)), y = Math.max(jl, Math.min(Fl, y))],
                    _ = [a = Math.max(jl, Math.min(Fl, a)), o = Math.max(jl, Math.min(Fl, o))];
                !function (t, e, n, r, i, a) {
                  var o,
                      s = t[0],
                      c = t[1],
                      u = 0,
                      l = 1,
                      h = e[0] - s,
                      f = e[1] - c;

                  if (o = n - s, h || !(o > 0)) {
                    if (o /= h, h < 0) {
                      if (o < u) return;
                      o < l && (l = o);
                    } else if (h > 0) {
                      if (o > l) return;
                      o > u && (u = o);
                    }

                    if (o = i - s, h || !(o < 0)) {
                      if (o /= h, h < 0) {
                        if (o > l) return;
                        o > u && (u = o);
                      } else if (h > 0) {
                        if (o < u) return;
                        o < l && (l = o);
                      }

                      if (o = r - c, f || !(o > 0)) {
                        if (o /= f, f < 0) {
                          if (o < u) return;
                          o < l && (l = o);
                        } else if (f > 0) {
                          if (o > l) return;
                          o > u && (u = o);
                        }

                        if (o = a - c, f || !(o < 0)) {
                          if (o /= f, f < 0) {
                            if (o > l) return;
                            o > u && (u = o);
                          } else if (f > 0) {
                            if (o < u) return;
                            o < l && (l = o);
                          }

                          return u > 0 && (t[0] = s + u * h, t[1] = c + u * f), l < 1 && (e[0] = s + l * h, e[1] = c + l * f), !0;
                        }
                      }
                    }
                  }
                }(c, _, t, e, n, r) ? s && (b.lineStart(), b.point(a, o), v = !1) : (g || (b.lineStart(), b.point(c[0], c[1])), b.point(_[0], _[1]), s || b.lineEnd(), v = !1);
              }
              p = a, y = o, g = s;
            }

            return x;
          };
        }

        function Ul() {
          var t,
              e,
              n,
              r = 0,
              i = 0,
              a = 960,
              o = 500;
          return n = {
            stream: function stream(n) {
              return t && e === n ? t : t = Yl(r, i, a, o)(e = n);
            },
            extent: function extent(s) {
              return arguments.length ? (r = +s[0][0], i = +s[0][1], a = +s[1][0], o = +s[1][1], t = e = null, n) : [[r, i], [a, o]];
            }
          };
        }

        var zl,
            ql,
            $l,
            Hl = mc(),
            Wl = {
          sphere: $c,
          point: $c,
          lineStart: function lineStart() {
            Wl.point = Gl, Wl.lineEnd = Vl;
          },
          lineEnd: $c,
          polygonStart: $c,
          polygonEnd: $c
        };

        function Vl() {
          Wl.point = Wl.lineEnd = $c;
        }

        function Gl(t, e) {
          zl = t *= Ac, ql = Pc(e *= Ac), $l = Oc(e), Wl.point = Xl;
        }

        function Xl(t, e) {
          t *= Ac;
          var n = Pc(e *= Ac),
              r = Oc(e),
              i = Mc(t - zl),
              a = Oc(i),
              o = r * Pc(i),
              s = $l * n - ql * r * a,
              c = ql * n + $l * r * a;
          Hl.add(Dc(jc(o * o + s * s), c)), zl = t, ql = n, $l = r;
        }

        function Zl(t) {
          return Hl.reset(), Zc(t, Wl), +Hl;
        }

        var Kl = [null, null],
            Ql = {
          type: "LineString",
          coordinates: Kl
        };

        function Jl(t, e) {
          return Kl[0] = t, Kl[1] = e, Zl(Ql);
        }

        var th = {
          Feature: function Feature(t, e) {
            return nh(t.geometry, e);
          },
          FeatureCollection: function FeatureCollection(t, e) {
            for (var n = t.features, r = -1, i = n.length; ++r < i;) {
              if (nh(n[r].geometry, e)) return !0;
            }

            return !1;
          }
        },
            eh = {
          Sphere: function Sphere() {
            return !0;
          },
          Point: function Point(t, e) {
            return rh(t.coordinates, e);
          },
          MultiPoint: function MultiPoint(t, e) {
            for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
              if (rh(n[r], e)) return !0;
            }

            return !1;
          },
          LineString: function LineString(t, e) {
            return ih(t.coordinates, e);
          },
          MultiLineString: function MultiLineString(t, e) {
            for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
              if (ih(n[r], e)) return !0;
            }

            return !1;
          },
          Polygon: function Polygon(t, e) {
            return ah(t.coordinates, e);
          },
          MultiPolygon: function MultiPolygon(t, e) {
            for (var n = t.coordinates, r = -1, i = n.length; ++r < i;) {
              if (ah(n[r], e)) return !0;
            }

            return !1;
          },
          GeometryCollection: function GeometryCollection(t, e) {
            for (var n = t.geometries, r = -1, i = n.length; ++r < i;) {
              if (nh(n[r], e)) return !0;
            }

            return !1;
          }
        };

        function nh(t, e) {
          return !(!t || !eh.hasOwnProperty(t.type)) && eh[t.type](t, e);
        }

        function rh(t, e) {
          return 0 === Jl(t, e);
        }

        function ih(t, e) {
          for (var n, r, i, a = 0, o = t.length; a < o; a++) {
            if (0 === (r = Jl(t[a], e))) return !0;
            if (a > 0 && (i = Jl(t[a], t[a - 1])) > 0 && n <= i && r <= i && (n + r - i) * (1 - Math.pow((n - r) / i, 2)) < wc * i) return !0;
            n = r;
          }

          return !1;
        }

        function ah(t, e) {
          return !!Ol(t.map(oh), sh(e));
        }

        function oh(t) {
          return (t = t.map(sh)).pop(), t;
        }

        function sh(t) {
          return [t[0] * Ac, t[1] * Ac];
        }

        function ch(t, e) {
          return (t && th.hasOwnProperty(t.type) ? th[t.type] : nh)(t, e);
        }

        function uh(t, e, n) {
          var r = k(t, e - xc, n).concat(e);
          return function (t) {
            return r.map(function (e) {
              return [t, e];
            });
          };
        }

        function lh(t, e, n) {
          var r = k(t, e - xc, n).concat(e);
          return function (t) {
            return r.map(function (e) {
              return [e, t];
            });
          };
        }

        function hh() {
          var t,
              e,
              n,
              r,
              i,
              a,
              o,
              s,
              c,
              u,
              l,
              h,
              f = 10,
              d = f,
              p = 90,
              y = 360,
              g = 2.5;

          function m() {
            return {
              type: "MultiLineString",
              coordinates: v()
            };
          }

          function v() {
            return k(Bc(r / p) * p, n, p).map(l).concat(k(Bc(s / y) * y, o, y).map(h)).concat(k(Bc(e / f) * f, t, f).filter(function (t) {
              return Mc(t % p) > xc;
            }).map(c)).concat(k(Bc(a / d) * d, i, d).filter(function (t) {
              return Mc(t % y) > xc;
            }).map(u));
          }

          return m.lines = function () {
            return v().map(function (t) {
              return {
                type: "LineString",
                coordinates: t
              };
            });
          }, m.outline = function () {
            return {
              type: "Polygon",
              coordinates: [l(r).concat(h(o).slice(1), l(n).reverse().slice(1), h(s).reverse().slice(1))]
            };
          }, m.extent = function (t) {
            return arguments.length ? m.extentMajor(t).extentMinor(t) : m.extentMinor();
          }, m.extentMajor = function (t) {
            return arguments.length ? (r = +t[0][0], n = +t[1][0], s = +t[0][1], o = +t[1][1], r > n && (t = r, r = n, n = t), s > o && (t = s, s = o, o = t), m.precision(g)) : [[r, s], [n, o]];
          }, m.extentMinor = function (n) {
            return arguments.length ? (e = +n[0][0], t = +n[1][0], a = +n[0][1], i = +n[1][1], e > t && (n = e, e = t, t = n), a > i && (n = a, a = i, i = n), m.precision(g)) : [[e, a], [t, i]];
          }, m.step = function (t) {
            return arguments.length ? m.stepMajor(t).stepMinor(t) : m.stepMinor();
          }, m.stepMajor = function (t) {
            return arguments.length ? (p = +t[0], y = +t[1], m) : [p, y];
          }, m.stepMinor = function (t) {
            return arguments.length ? (f = +t[0], d = +t[1], m) : [f, d];
          }, m.precision = function (f) {
            return arguments.length ? (g = +f, c = uh(a, i, 90), u = lh(e, t, g), l = uh(s, o, 90), h = lh(r, n, g), m) : g;
          }, m.extentMajor([[-180, -89.999999], [180, 89.999999]]).extentMinor([[-180, -80.000001], [180, 80.000001]]);
        }

        function fh() {
          return hh()();
        }

        function dh(t, e) {
          var n = t[0] * Ac,
              r = t[1] * Ac,
              i = e[0] * Ac,
              a = e[1] * Ac,
              o = Oc(r),
              s = Pc(r),
              c = Oc(a),
              u = Pc(a),
              l = o * Oc(n),
              h = o * Pc(n),
              f = c * Oc(i),
              d = c * Pc(i),
              p = 2 * zc(jc(qc(a - r) + o * c * qc(i - n))),
              y = Pc(p),
              g = p ? function (t) {
            var e = Pc(t *= p) / y,
                n = Pc(p - t) / y,
                r = n * l + e * f,
                i = n * h + e * d,
                a = n * s + e * u;
            return [Dc(i, r) * Sc, Dc(a, jc(r * r + i * i)) * Sc];
          } : function () {
            return [n * Sc, r * Sc];
          };
          return g.distance = p, g;
        }

        function ph(t) {
          return t;
        }

        var yh,
            gh,
            mh,
            vh,
            bh = mc(),
            _h = mc(),
            xh = {
          point: $c,
          lineStart: $c,
          lineEnd: $c,
          polygonStart: function polygonStart() {
            xh.lineStart = wh, xh.lineEnd = Eh;
          },
          polygonEnd: function polygonEnd() {
            xh.lineStart = xh.lineEnd = xh.point = $c, bh.add(Mc(_h)), _h.reset();
          },
          result: function result() {
            var t = bh / 2;
            return bh.reset(), t;
          }
        };

        function wh() {
          xh.point = kh;
        }

        function kh(t, e) {
          xh.point = Th, yh = mh = t, gh = vh = e;
        }

        function Th(t, e) {
          _h.add(vh * t - mh * e), mh = t, vh = e;
        }

        function Eh() {
          Th(yh, gh);
        }

        var Ch = xh;
        var Sh = 1 / 0,
            Ah = Sh,
            Mh = -Sh,
            Nh = Mh;
        var Dh = {
          point: function point(t, e) {
            t < Sh && (Sh = t), t > Mh && (Mh = t), e < Ah && (Ah = e), e > Nh && (Nh = e);
          },
          lineStart: $c,
          lineEnd: $c,
          polygonStart: $c,
          polygonEnd: $c,
          result: function result() {
            var t = [[Sh, Ah], [Mh, Nh]];
            return Mh = Nh = -(Ah = Sh = 1 / 0), t;
          }
        };
        var Oh,
            Bh,
            Lh,
            Ih,
            Rh = 0,
            Ph = 0,
            Fh = 0,
            jh = 0,
            Yh = 0,
            Uh = 0,
            zh = 0,
            qh = 0,
            $h = 0,
            Hh = {
          point: Wh,
          lineStart: Vh,
          lineEnd: Zh,
          polygonStart: function polygonStart() {
            Hh.lineStart = Kh, Hh.lineEnd = Qh;
          },
          polygonEnd: function polygonEnd() {
            Hh.point = Wh, Hh.lineStart = Vh, Hh.lineEnd = Zh;
          },
          result: function result() {
            var t = $h ? [zh / $h, qh / $h] : Uh ? [jh / Uh, Yh / Uh] : Fh ? [Rh / Fh, Ph / Fh] : [NaN, NaN];
            return Rh = Ph = Fh = jh = Yh = Uh = zh = qh = $h = 0, t;
          }
        };

        function Wh(t, e) {
          Rh += t, Ph += e, ++Fh;
        }

        function Vh() {
          Hh.point = Gh;
        }

        function Gh(t, e) {
          Hh.point = Xh, Wh(Lh = t, Ih = e);
        }

        function Xh(t, e) {
          var n = t - Lh,
              r = e - Ih,
              i = jc(n * n + r * r);
          jh += i * (Lh + t) / 2, Yh += i * (Ih + e) / 2, Uh += i, Wh(Lh = t, Ih = e);
        }

        function Zh() {
          Hh.point = Wh;
        }

        function Kh() {
          Hh.point = Jh;
        }

        function Qh() {
          tf(Oh, Bh);
        }

        function Jh(t, e) {
          Hh.point = tf, Wh(Oh = Lh = t, Bh = Ih = e);
        }

        function tf(t, e) {
          var n = t - Lh,
              r = e - Ih,
              i = jc(n * n + r * r);
          jh += i * (Lh + t) / 2, Yh += i * (Ih + e) / 2, Uh += i, zh += (i = Ih * t - Lh * e) * (Lh + t), qh += i * (Ih + e), $h += 3 * i, Wh(Lh = t, Ih = e);
        }

        var ef = Hh;

        function nf(t) {
          this._context = t;
        }

        nf.prototype = {
          _radius: 4.5,
          pointRadius: function pointRadius(t) {
            return this._radius = t, this;
          },
          polygonStart: function polygonStart() {
            this._line = 0;
          },
          polygonEnd: function polygonEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            0 === this._line && this._context.closePath(), this._point = NaN;
          },
          point: function point(t, e) {
            switch (this._point) {
              case 0:
                this._context.moveTo(t, e), this._point = 1;
                break;

              case 1:
                this._context.lineTo(t, e);

                break;

              default:
                this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Cc);
            }
          },
          result: $c
        };
        var rf,
            af,
            of,
            sf,
            cf,
            uf = mc(),
            lf = {
          point: $c,
          lineStart: function lineStart() {
            lf.point = hf;
          },
          lineEnd: function lineEnd() {
            rf && ff(af, of), lf.point = $c;
          },
          polygonStart: function polygonStart() {
            rf = !0;
          },
          polygonEnd: function polygonEnd() {
            rf = null;
          },
          result: function result() {
            var t = +uf;
            return uf.reset(), t;
          }
        };

        function hf(t, e) {
          lf.point = ff, af = sf = t, of = cf = e;
        }

        function ff(t, e) {
          sf -= t, cf -= e, uf.add(jc(sf * sf + cf * cf)), sf = t, cf = e;
        }

        var df = lf;

        function pf() {
          this._string = [];
        }

        function yf(t) {
          return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
        }

        function gf(t, e) {
          var n,
              r,
              i = 4.5;

          function a(t) {
            return t && ("function" == typeof i && r.pointRadius(+i.apply(this, arguments)), Zc(t, n(r))), r.result();
          }

          return a.area = function (t) {
            return Zc(t, n(Ch)), Ch.result();
          }, a.measure = function (t) {
            return Zc(t, n(df)), df.result();
          }, a.bounds = function (t) {
            return Zc(t, n(Dh)), Dh.result();
          }, a.centroid = function (t) {
            return Zc(t, n(ef)), ef.result();
          }, a.projection = function (e) {
            return arguments.length ? (n = null == e ? (t = null, ph) : (t = e).stream, a) : t;
          }, a.context = function (t) {
            return arguments.length ? (r = null == t ? (e = null, new pf()) : new nf(e = t), "function" != typeof i && r.pointRadius(i), a) : e;
          }, a.pointRadius = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : (r.pointRadius(+t), +t), a) : i;
          }, a.projection(t).context(e);
        }

        function mf(t) {
          return {
            stream: vf(t)
          };
        }

        function vf(t) {
          return function (e) {
            var n = new bf();

            for (var r in t) {
              n[r] = t[r];
            }

            return n.stream = e, n;
          };
        }

        function bf() {}

        function _f(t, e, n) {
          var r = t.clipExtent && t.clipExtent();
          return t.scale(150).translate([0, 0]), null != r && t.clipExtent(null), Zc(n, t.stream(Dh)), e(Dh.result()), null != r && t.clipExtent(r), t;
        }

        function xf(t, e, n) {
          return _f(t, function (n) {
            var r = e[1][0] - e[0][0],
                i = e[1][1] - e[0][1],
                a = Math.min(r / (n[1][0] - n[0][0]), i / (n[1][1] - n[0][1])),
                o = +e[0][0] + (r - a * (n[1][0] + n[0][0])) / 2,
                s = +e[0][1] + (i - a * (n[1][1] + n[0][1])) / 2;
            t.scale(150 * a).translate([o, s]);
          }, n);
        }

        function wf(t, e, n) {
          return xf(t, [[0, 0], e], n);
        }

        function kf(t, e, n) {
          return _f(t, function (n) {
            var r = +e,
                i = r / (n[1][0] - n[0][0]),
                a = (r - i * (n[1][0] + n[0][0])) / 2,
                o = -i * n[0][1];
            t.scale(150 * i).translate([a, o]);
          }, n);
        }

        function Tf(t, e, n) {
          return _f(t, function (n) {
            var r = +e,
                i = r / (n[1][1] - n[0][1]),
                a = -i * n[0][0],
                o = (r - i * (n[1][1] + n[0][1])) / 2;
            t.scale(150 * i).translate([a, o]);
          }, n);
        }

        pf.prototype = {
          _radius: 4.5,
          _circle: yf(4.5),
          pointRadius: function pointRadius(t) {
            return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
          },
          polygonStart: function polygonStart() {
            this._line = 0;
          },
          polygonEnd: function polygonEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            0 === this._line && this._string.push("Z"), this._point = NaN;
          },
          point: function point(t, e) {
            switch (this._point) {
              case 0:
                this._string.push("M", t, ",", e), this._point = 1;
                break;

              case 1:
                this._string.push("L", t, ",", e);

                break;

              default:
                null == this._circle && (this._circle = yf(this._radius)), this._string.push("M", t, ",", e, this._circle);
            }
          },
          result: function result() {
            if (this._string.length) {
              var t = this._string.join("");

              return this._string = [], t;
            }

            return null;
          }
        }, bf.prototype = {
          constructor: bf,
          point: function point(t, e) {
            this.stream.point(t, e);
          },
          sphere: function sphere() {
            this.stream.sphere();
          },
          lineStart: function lineStart() {
            this.stream.lineStart();
          },
          lineEnd: function lineEnd() {
            this.stream.lineEnd();
          },
          polygonStart: function polygonStart() {
            this.stream.polygonStart();
          },
          polygonEnd: function polygonEnd() {
            this.stream.polygonEnd();
          }
        };
        var Ef = Oc(30 * Ac);

        function Cf(t, e) {
          return +e ? function (t, e) {
            function n(r, i, a, o, s, c, u, l, h, f, d, p, y, g) {
              var m = u - r,
                  v = l - i,
                  b = m * m + v * v;

              if (b > 4 * e && y--) {
                var _ = o + f,
                    x = s + d,
                    w = c + p,
                    k = jc(_ * _ + x * x + w * w),
                    T = zc(w /= k),
                    E = Mc(Mc(w) - 1) < xc || Mc(a - h) < xc ? (a + h) / 2 : Dc(x, _),
                    C = t(E, T),
                    S = C[0],
                    A = C[1],
                    M = S - r,
                    N = A - i,
                    D = v * M - m * N;

                (D * D / b > e || Mc((m * M + v * N) / b - .5) > .3 || o * f + s * d + c * p < Ef) && (n(r, i, a, o, s, c, S, A, E, _ /= k, x /= k, w, y, g), g.point(S, A), n(S, A, E, _, x, w, u, l, h, f, d, p, y, g));
              }
            }

            return function (e) {
              var r,
                  i,
                  a,
                  o,
                  s,
                  c,
                  u,
                  l,
                  h,
                  f,
                  d,
                  p,
                  y = {
                point: g,
                lineStart: m,
                lineEnd: b,
                polygonStart: function polygonStart() {
                  e.polygonStart(), y.lineStart = _;
                },
                polygonEnd: function polygonEnd() {
                  e.polygonEnd(), y.lineStart = m;
                }
              };

              function g(n, r) {
                n = t(n, r), e.point(n[0], n[1]);
              }

              function m() {
                l = NaN, y.point = v, e.lineStart();
              }

              function v(r, i) {
                var a = hu([r, i]),
                    o = t(r, i);
                n(l, h, u, f, d, p, l = o[0], h = o[1], u = r, f = a[0], d = a[1], p = a[2], 16, e), e.point(l, h);
              }

              function b() {
                y.point = g, e.lineEnd();
              }

              function _() {
                m(), y.point = x, y.lineEnd = w;
              }

              function x(t, e) {
                v(r = t, e), i = l, a = h, o = f, s = d, c = p, y.point = v;
              }

              function w() {
                n(l, h, u, f, d, p, i, a, r, o, s, c, 16, e), y.lineEnd = b, b();
              }

              return y;
            };
          }(t, e) : function (t) {
            return vf({
              point: function point(e, n) {
                e = t(e, n), this.stream.point(e[0], e[1]);
              }
            });
          }(t);
        }

        var Sf = vf({
          point: function point(t, e) {
            this.stream.point(t * Ac, e * Ac);
          }
        });

        function Af(t, e, n, r, i) {
          function a(a, o) {
            return [e + t * (a *= r), n - t * (o *= i)];
          }

          return a.invert = function (a, o) {
            return [(a - e) / t * r, (n - o) / t * i];
          }, a;
        }

        function Mf(t, e, n, r, i, a) {
          var o = Oc(a),
              s = Pc(a),
              c = o * t,
              u = s * t,
              l = o / t,
              h = s / t,
              f = (s * n - o * e) / t,
              d = (s * e + o * n) / t;

          function p(t, a) {
            return [c * (t *= r) - u * (a *= i) + e, n - u * t - c * a];
          }

          return p.invert = function (t, e) {
            return [r * (l * t - h * e + f), i * (d - h * t - l * e)];
          }, p;
        }

        function Nf(t) {
          return Df(function () {
            return t;
          })();
        }

        function Df(t) {
          var e,
              n,
              r,
              i,
              a,
              o,
              s,
              c,
              u,
              l,
              h = 150,
              f = 480,
              d = 250,
              p = 0,
              y = 0,
              g = 0,
              m = 0,
              v = 0,
              b = 0,
              _ = 1,
              x = 1,
              w = null,
              k = Rl,
              T = null,
              E = ph,
              C = .5;

          function S(t) {
            return c(t[0] * Ac, t[1] * Ac);
          }

          function A(t) {
            return (t = c.invert(t[0], t[1])) && [t[0] * Sc, t[1] * Sc];
          }

          function M() {
            var t = Mf(h, 0, 0, _, x, b).apply(null, e(p, y)),
                r = (b ? Mf : Af)(h, f - t[0], d - t[1], _, x, b);
            return n = ml(g, m, v), s = yl(e, r), c = yl(n, s), o = Cf(s, C), N();
          }

          function N() {
            return u = l = null, S;
          }

          return S.stream = function (t) {
            return u && l === t ? u : u = Sf(function (t) {
              return vf({
                point: function point(e, n) {
                  var r = t(e, n);
                  return this.stream.point(r[0], r[1]);
                }
              });
            }(n)(k(o(E(l = t)))));
          }, S.preclip = function (t) {
            return arguments.length ? (k = t, w = void 0, N()) : k;
          }, S.postclip = function (t) {
            return arguments.length ? (E = t, T = r = i = a = null, N()) : E;
          }, S.clipAngle = function (t) {
            return arguments.length ? (k = +t ? Pl(w = t * Ac) : (w = null, Rl), N()) : w * Sc;
          }, S.clipExtent = function (t) {
            return arguments.length ? (E = null == t ? (T = r = i = a = null, ph) : Yl(T = +t[0][0], r = +t[0][1], i = +t[1][0], a = +t[1][1]), N()) : null == T ? null : [[T, r], [i, a]];
          }, S.scale = function (t) {
            return arguments.length ? (h = +t, M()) : h;
          }, S.translate = function (t) {
            return arguments.length ? (f = +t[0], d = +t[1], M()) : [f, d];
          }, S.center = function (t) {
            return arguments.length ? (p = t[0] % 360 * Ac, y = t[1] % 360 * Ac, M()) : [p * Sc, y * Sc];
          }, S.rotate = function (t) {
            return arguments.length ? (g = t[0] % 360 * Ac, m = t[1] % 360 * Ac, v = t.length > 2 ? t[2] % 360 * Ac : 0, M()) : [g * Sc, m * Sc, v * Sc];
          }, S.angle = function (t) {
            return arguments.length ? (b = t % 360 * Ac, M()) : b * Sc;
          }, S.reflectX = function (t) {
            return arguments.length ? (_ = t ? -1 : 1, M()) : _ < 0;
          }, S.reflectY = function (t) {
            return arguments.length ? (x = t ? -1 : 1, M()) : x < 0;
          }, S.precision = function (t) {
            return arguments.length ? (o = Cf(s, C = t * t), N()) : jc(C);
          }, S.fitExtent = function (t, e) {
            return xf(S, t, e);
          }, S.fitSize = function (t, e) {
            return wf(S, t, e);
          }, S.fitWidth = function (t, e) {
            return kf(S, t, e);
          }, S.fitHeight = function (t, e) {
            return Tf(S, t, e);
          }, function () {
            return e = t.apply(this, arguments), S.invert = e.invert && A, M();
          };
        }

        function Of(t) {
          var e = 0,
              n = kc / 3,
              r = Df(t),
              i = r(e, n);
          return i.parallels = function (t) {
            return arguments.length ? r(e = t[0] * Ac, n = t[1] * Ac) : [e * Sc, n * Sc];
          }, i;
        }

        function Bf(t, e) {
          var n = Pc(t),
              r = (n + Pc(e)) / 2;
          if (Mc(r) < xc) return function (t) {
            var e = Oc(t);

            function n(t, n) {
              return [t * e, Pc(n) / e];
            }

            return n.invert = function (t, n) {
              return [t / e, zc(n * e)];
            }, n;
          }(t);
          var i = 1 + n * (2 * r - n),
              a = jc(i) / r;

          function o(t, e) {
            var n = jc(i - 2 * r * Pc(e)) / r;
            return [n * Pc(t *= r), a - n * Oc(t)];
          }

          return o.invert = function (t, e) {
            var n = a - e,
                o = Dc(t, Mc(n)) * Fc(n);
            return n * r < 0 && (o -= kc * Fc(t) * Fc(n)), [o / r, zc((i - (t * t + n * n) * r * r) / (2 * r))];
          }, o;
        }

        function Lf() {
          return Of(Bf).scale(155.424).center([0, 33.6442]);
        }

        function If() {
          return Lf().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-.6, 38.7]);
        }

        function Rf() {
          var t,
              e,
              n,
              r,
              i,
              a,
              o = If(),
              s = Lf().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
              c = Lf().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
              u = {
            point: function point(t, e) {
              a = [t, e];
            }
          };

          function l(t) {
            var e = t[0],
                o = t[1];
            return a = null, n.point(e, o), a || (r.point(e, o), a) || (i.point(e, o), a);
          }

          function h() {
            return t = e = null, l;
          }

          return l.invert = function (t) {
            var e = o.scale(),
                n = o.translate(),
                r = (t[0] - n[0]) / e,
                i = (t[1] - n[1]) / e;
            return (i >= .12 && i < .234 && r >= -.425 && r < -.214 ? s : i >= .166 && i < .234 && r >= -.214 && r < -.115 ? c : o).invert(t);
          }, l.stream = function (n) {
            return t && e === n ? t : (r = [o.stream(e = n), s.stream(n), c.stream(n)], i = r.length, t = {
              point: function point(t, e) {
                for (var n = -1; ++n < i;) {
                  r[n].point(t, e);
                }
              },
              sphere: function sphere() {
                for (var t = -1; ++t < i;) {
                  r[t].sphere();
                }
              },
              lineStart: function lineStart() {
                for (var t = -1; ++t < i;) {
                  r[t].lineStart();
                }
              },
              lineEnd: function lineEnd() {
                for (var t = -1; ++t < i;) {
                  r[t].lineEnd();
                }
              },
              polygonStart: function polygonStart() {
                for (var t = -1; ++t < i;) {
                  r[t].polygonStart();
                }
              },
              polygonEnd: function polygonEnd() {
                for (var t = -1; ++t < i;) {
                  r[t].polygonEnd();
                }
              }
            });
            var r, i;
          }, l.precision = function (t) {
            return arguments.length ? (o.precision(t), s.precision(t), c.precision(t), h()) : o.precision();
          }, l.scale = function (t) {
            return arguments.length ? (o.scale(t), s.scale(.35 * t), c.scale(t), l.translate(o.translate())) : o.scale();
          }, l.translate = function (t) {
            if (!arguments.length) return o.translate();
            var e = o.scale(),
                a = +t[0],
                l = +t[1];
            return n = o.translate(t).clipExtent([[a - .455 * e, l - .238 * e], [a + .455 * e, l + .238 * e]]).stream(u), r = s.translate([a - .307 * e, l + .201 * e]).clipExtent([[a - .425 * e + xc, l + .12 * e + xc], [a - .214 * e - xc, l + .234 * e - xc]]).stream(u), i = c.translate([a - .205 * e, l + .212 * e]).clipExtent([[a - .214 * e + xc, l + .166 * e + xc], [a - .115 * e - xc, l + .234 * e - xc]]).stream(u), h();
          }, l.fitExtent = function (t, e) {
            return xf(l, t, e);
          }, l.fitSize = function (t, e) {
            return wf(l, t, e);
          }, l.fitWidth = function (t, e) {
            return kf(l, t, e);
          }, l.fitHeight = function (t, e) {
            return Tf(l, t, e);
          }, l.scale(1070);
        }

        function Pf(t) {
          return function (e, n) {
            var r = Oc(e),
                i = Oc(n),
                a = t(r * i);
            return [a * i * Pc(e), a * Pc(n)];
          };
        }

        function Ff(t) {
          return function (e, n) {
            var r = jc(e * e + n * n),
                i = t(r),
                a = Pc(i),
                o = Oc(i);
            return [Dc(e * a, r * o), zc(r && n * a / r)];
          };
        }

        var jf = Pf(function (t) {
          return jc(2 / (1 + t));
        });

        function Yf() {
          return Nf(jf).scale(124.75).clipAngle(179.999);
        }

        jf.invert = Ff(function (t) {
          return 2 * zc(t / 2);
        });
        var Uf = Pf(function (t) {
          return (t = Uc(t)) && t / Pc(t);
        });

        function zf() {
          return Nf(Uf).scale(79.4188).clipAngle(179.999);
        }

        function qf(t, e) {
          return [t, Ic(Yc((Tc + e) / 2))];
        }

        function $f() {
          return Hf(qf).scale(961 / Cc);
        }

        function Hf(t) {
          var e,
              n,
              r,
              i = Nf(t),
              a = i.center,
              o = i.scale,
              s = i.translate,
              c = i.clipExtent,
              u = null;

          function l() {
            var a = kc * o(),
                s = i(xl(i.rotate()).invert([0, 0]));
            return c(null == u ? [[s[0] - a, s[1] - a], [s[0] + a, s[1] + a]] : t === qf ? [[Math.max(s[0] - a, u), e], [Math.min(s[0] + a, n), r]] : [[u, Math.max(s[1] - a, e)], [n, Math.min(s[1] + a, r)]]);
          }

          return i.scale = function (t) {
            return arguments.length ? (o(t), l()) : o();
          }, i.translate = function (t) {
            return arguments.length ? (s(t), l()) : s();
          }, i.center = function (t) {
            return arguments.length ? (a(t), l()) : a();
          }, i.clipExtent = function (t) {
            return arguments.length ? (null == t ? u = e = n = r = null : (u = +t[0][0], e = +t[0][1], n = +t[1][0], r = +t[1][1]), l()) : null == u ? null : [[u, e], [n, r]];
          }, l();
        }

        function Wf(t) {
          return Yc((Tc + t) / 2);
        }

        function Vf(t, e) {
          var n = Oc(t),
              r = t === e ? Pc(t) : Ic(n / Oc(e)) / Ic(Wf(e) / Wf(t)),
              i = n * Rc(Wf(t), r) / r;
          if (!r) return qf;

          function a(t, e) {
            i > 0 ? e < -Tc + xc && (e = -Tc + xc) : e > Tc - xc && (e = Tc - xc);
            var n = i / Rc(Wf(e), r);
            return [n * Pc(r * t), i - n * Oc(r * t)];
          }

          return a.invert = function (t, e) {
            var n = i - e,
                a = Fc(r) * jc(t * t + n * n),
                o = Dc(t, Mc(n)) * Fc(n);
            return n * r < 0 && (o -= kc * Fc(t) * Fc(n)), [o / r, 2 * Nc(Rc(i / a, 1 / r)) - Tc];
          }, a;
        }

        function Gf() {
          return Of(Vf).scale(109.5).parallels([30, 30]);
        }

        function Xf(t, e) {
          return [t, e];
        }

        function Zf() {
          return Nf(Xf).scale(152.63);
        }

        function Kf(t, e) {
          var n = Oc(t),
              r = t === e ? Pc(t) : (n - Oc(e)) / (e - t),
              i = n / r + t;
          if (Mc(r) < xc) return Xf;

          function a(t, e) {
            var n = i - e,
                a = r * t;
            return [n * Pc(a), i - n * Oc(a)];
          }

          return a.invert = function (t, e) {
            var n = i - e,
                a = Dc(t, Mc(n)) * Fc(n);
            return n * r < 0 && (a -= kc * Fc(t) * Fc(n)), [a / r, i - Fc(r) * jc(t * t + n * n)];
          }, a;
        }

        function Qf() {
          return Of(Kf).scale(131.154).center([0, 13.9389]);
        }

        Uf.invert = Ff(function (t) {
          return t;
        }), qf.invert = function (t, e) {
          return [t, 2 * Nc(Lc(e)) - Tc];
        }, Xf.invert = Xf;
        var Jf = 1.340264,
            td = -.081106,
            ed = 893e-6,
            nd = .003796,
            rd = jc(3) / 2;

        function id(t, e) {
          var n = zc(rd * Pc(e)),
              r = n * n,
              i = r * r * r;
          return [t * Oc(n) / (rd * (Jf + 3 * td * r + i * (7 * ed + 9 * nd * r))), n * (Jf + td * r + i * (ed + nd * r))];
        }

        function ad() {
          return Nf(id).scale(177.158);
        }

        function od(t, e) {
          var n = Oc(e),
              r = Oc(t) * n;
          return [n * Pc(t) / r, Pc(e) / r];
        }

        function sd() {
          return Nf(od).scale(144.049).clipAngle(60);
        }

        function cd() {
          var t,
              e,
              n,
              r,
              i,
              a,
              o,
              s = 1,
              c = 0,
              u = 0,
              l = 1,
              h = 1,
              f = 0,
              d = null,
              p = 1,
              y = 1,
              g = vf({
            point: function point(t, e) {
              var n = b([t, e]);
              this.stream.point(n[0], n[1]);
            }
          }),
              m = ph;

          function v() {
            return p = s * l, y = s * h, a = o = null, b;
          }

          function b(n) {
            var r = n[0] * p,
                i = n[1] * y;

            if (f) {
              var a = i * t - r * e;
              r = r * t + i * e, i = a;
            }

            return [r + c, i + u];
          }

          return b.invert = function (n) {
            var r = n[0] - c,
                i = n[1] - u;

            if (f) {
              var a = i * t + r * e;
              r = r * t - i * e, i = a;
            }

            return [r / p, i / y];
          }, b.stream = function (t) {
            return a && o === t ? a : a = g(m(o = t));
          }, b.postclip = function (t) {
            return arguments.length ? (m = t, d = n = r = i = null, v()) : m;
          }, b.clipExtent = function (t) {
            return arguments.length ? (m = null == t ? (d = n = r = i = null, ph) : Yl(d = +t[0][0], n = +t[0][1], r = +t[1][0], i = +t[1][1]), v()) : null == d ? null : [[d, n], [r, i]];
          }, b.scale = function (t) {
            return arguments.length ? (s = +t, v()) : s;
          }, b.translate = function (t) {
            return arguments.length ? (c = +t[0], u = +t[1], v()) : [c, u];
          }, b.angle = function (n) {
            return arguments.length ? (e = Pc(f = n % 360 * Ac), t = Oc(f), v()) : f * Sc;
          }, b.reflectX = function (t) {
            return arguments.length ? (l = t ? -1 : 1, v()) : l < 0;
          }, b.reflectY = function (t) {
            return arguments.length ? (h = t ? -1 : 1, v()) : h < 0;
          }, b.fitExtent = function (t, e) {
            return xf(b, t, e);
          }, b.fitSize = function (t, e) {
            return wf(b, t, e);
          }, b.fitWidth = function (t, e) {
            return kf(b, t, e);
          }, b.fitHeight = function (t, e) {
            return Tf(b, t, e);
          }, b;
        }

        function ud(t, e) {
          var n = e * e,
              r = n * n;
          return [t * (.8707 - .131979 * n + r * (r * (.003971 * n - .001529 * r) - .013791)), e * (1.007226 + n * (.015085 + r * (.028874 * n - .044475 - .005916 * r)))];
        }

        function ld() {
          return Nf(ud).scale(175.295);
        }

        function hd(t, e) {
          return [Oc(e) * Pc(t), Pc(e)];
        }

        function fd() {
          return Nf(hd).scale(249.5).clipAngle(90.000001);
        }

        function dd(t, e) {
          var n = Oc(e),
              r = 1 + Oc(t) * n;
          return [n * Pc(t) / r, Pc(e) / r];
        }

        function pd() {
          return Nf(dd).scale(250).clipAngle(142);
        }

        function yd(t, e) {
          return [Ic(Yc((Tc + e) / 2)), -t];
        }

        function gd() {
          var t = Hf(yd),
              e = t.center,
              n = t.rotate;
          return t.center = function (t) {
            return arguments.length ? e([-t[1], t[0]]) : [(t = e())[1], -t[0]];
          }, t.rotate = function (t) {
            return arguments.length ? n([t[0], t[1], t.length > 2 ? t[2] + 90 : 90]) : [(t = n())[0], t[1], t[2] - 90];
          }, n([0, 0, 90]).scale(159.155);
        }

        function md(t, e) {
          return t.parent === e.parent ? 1 : 2;
        }

        function vd(t, e) {
          return t + e.x;
        }

        function bd(t, e) {
          return Math.max(t, e.y);
        }

        function _d() {
          var t = md,
              e = 1,
              n = 1,
              r = !1;

          function i(i) {
            var a,
                o = 0;
            i.eachAfter(function (e) {
              var n = e.children;
              n ? (e.x = function (t) {
                return t.reduce(vd, 0) / t.length;
              }(n), e.y = function (t) {
                return 1 + t.reduce(bd, 0);
              }(n)) : (e.x = a ? o += t(e, a) : 0, e.y = 0, a = e);
            });

            var s = function (t) {
              for (var e; e = t.children;) {
                t = e[0];
              }

              return t;
            }(i),
                c = function (t) {
              for (var e; e = t.children;) {
                t = e[e.length - 1];
              }

              return t;
            }(i),
                u = s.x - t(s, c) / 2,
                l = c.x + t(c, s) / 2;

            return i.eachAfter(r ? function (t) {
              t.x = (t.x - i.x) * e, t.y = (i.y - t.y) * n;
            } : function (t) {
              t.x = (t.x - u) / (l - u) * e, t.y = (1 - (i.y ? t.y / i.y : 1)) * n;
            });
          }

          return i.separation = function (e) {
            return arguments.length ? (t = e, i) : t;
          }, i.size = function (t) {
            return arguments.length ? (r = !1, e = +t[0], n = +t[1], i) : r ? null : [e, n];
          }, i.nodeSize = function (t) {
            return arguments.length ? (r = !0, e = +t[0], n = +t[1], i) : r ? [e, n] : null;
          }, i;
        }

        function xd(t) {
          var e = 0,
              n = t.children,
              r = n && n.length;
          if (r) for (; --r >= 0;) {
            e += n[r].value;
          } else e = 1;
          t.value = e;
        }

        function wd(t, e) {
          var n,
              r,
              i,
              a,
              o,
              s = new Cd(t),
              c = +t.value && (s.value = t.value),
              u = [s];

          for (null == e && (e = kd); n = u.pop();) {
            if (c && (n.value = +n.data.value), (i = e(n.data)) && (o = i.length)) for (n.children = new Array(o), a = o - 1; a >= 0; --a) {
              u.push(r = n.children[a] = new Cd(i[a])), r.parent = n, r.depth = n.depth + 1;
            }
          }

          return s.eachBefore(Ed);
        }

        function kd(t) {
          return t.children;
        }

        function Td(t) {
          t.data = t.data.data;
        }

        function Ed(t) {
          var e = 0;

          do {
            t.height = e;
          } while ((t = t.parent) && t.height < ++e);
        }

        function Cd(t) {
          this.data = t, this.depth = this.height = 0, this.parent = null;
        }

        id.invert = function (t, e) {
          for (var n, r = e, i = r * r, a = i * i * i, o = 0; o < 12 && (a = (i = (r -= n = (r * (Jf + td * i + a * (ed + nd * i)) - e) / (Jf + 3 * td * i + a * (7 * ed + 9 * nd * i))) * r) * i * i, !(Mc(n) < wc)); ++o) {
            ;
          }

          return [rd * t * (Jf + 3 * td * i + a * (7 * ed + 9 * nd * i)) / Oc(r), zc(Pc(r) / rd)];
        }, od.invert = Ff(Nc), ud.invert = function (t, e) {
          var n,
              r = e,
              i = 25;

          do {
            var a = r * r,
                o = a * a;
            r -= n = (r * (1.007226 + a * (.015085 + o * (.028874 * a - .044475 - .005916 * o))) - e) / (1.007226 + a * (.045255 + o * (.259866 * a - .311325 - .005916 * 11 * o)));
          } while (Mc(n) > xc && --i > 0);

          return [t / (.8707 + (a = r * r) * (a * (a * a * a * (.003971 - .001529 * a) - .013791) - .131979)), r];
        }, hd.invert = Ff(zc), dd.invert = Ff(function (t) {
          return 2 * Nc(t);
        }), yd.invert = function (t, e) {
          return [-e, 2 * Nc(Lc(t)) - Tc];
        }, Cd.prototype = wd.prototype = {
          constructor: Cd,
          count: function count() {
            return this.eachAfter(xd);
          },
          each: function each(t) {
            var e,
                n,
                r,
                i,
                a = this,
                o = [a];

            do {
              for (e = o.reverse(), o = []; a = e.pop();) {
                if (t(a), n = a.children) for (r = 0, i = n.length; r < i; ++r) {
                  o.push(n[r]);
                }
              }
            } while (o.length);

            return this;
          },
          eachAfter: function eachAfter(t) {
            for (var e, n, r, i = this, a = [i], o = []; i = a.pop();) {
              if (o.push(i), e = i.children) for (n = 0, r = e.length; n < r; ++n) {
                a.push(e[n]);
              }
            }

            for (; i = o.pop();) {
              t(i);
            }

            return this;
          },
          eachBefore: function eachBefore(t) {
            for (var e, n, r = this, i = [r]; r = i.pop();) {
              if (t(r), e = r.children) for (n = e.length - 1; n >= 0; --n) {
                i.push(e[n]);
              }
            }

            return this;
          },
          sum: function sum(t) {
            return this.eachAfter(function (e) {
              for (var n = +t(e.data) || 0, r = e.children, i = r && r.length; --i >= 0;) {
                n += r[i].value;
              }

              e.value = n;
            });
          },
          sort: function sort(t) {
            return this.eachBefore(function (e) {
              e.children && e.children.sort(t);
            });
          },
          path: function path(t) {
            for (var e = this, n = function (t, e) {
              if (t === e) return t;
              var n = t.ancestors(),
                  r = e.ancestors(),
                  i = null;

              for (t = n.pop(), e = r.pop(); t === e;) {
                i = t, t = n.pop(), e = r.pop();
              }

              return i;
            }(e, t), r = [e]; e !== n;) {
              e = e.parent, r.push(e);
            }

            for (var i = r.length; t !== n;) {
              r.splice(i, 0, t), t = t.parent;
            }

            return r;
          },
          ancestors: function ancestors() {
            for (var t = this, e = [t]; t = t.parent;) {
              e.push(t);
            }

            return e;
          },
          descendants: function descendants() {
            var t = [];
            return this.each(function (e) {
              t.push(e);
            }), t;
          },
          leaves: function leaves() {
            var t = [];
            return this.eachBefore(function (e) {
              e.children || t.push(e);
            }), t;
          },
          links: function links() {
            var t = this,
                e = [];
            return t.each(function (n) {
              n !== t && e.push({
                source: n.parent,
                target: n
              });
            }), e;
          },
          copy: function copy() {
            return wd(this).eachBefore(Td);
          }
        };
        var Sd = Array.prototype.slice;

        function Ad(t) {
          for (var e, n, r = 0, i = (t = function (t) {
            for (var e, n, r = t.length; r;) {
              n = Math.random() * r-- | 0, e = t[r], t[r] = t[n], t[n] = e;
            }

            return t;
          }(Sd.call(t))).length, a = []; r < i;) {
            e = t[r], n && Dd(n, e) ? ++r : (n = Bd(a = Md(a, e)), r = 0);
          }

          return n;
        }

        function Md(t, e) {
          var n, r;
          if (Od(e, t)) return [e];

          for (n = 0; n < t.length; ++n) {
            if (Nd(e, t[n]) && Od(Ld(t[n], e), t)) return [t[n], e];
          }

          for (n = 0; n < t.length - 1; ++n) {
            for (r = n + 1; r < t.length; ++r) {
              if (Nd(Ld(t[n], t[r]), e) && Nd(Ld(t[n], e), t[r]) && Nd(Ld(t[r], e), t[n]) && Od(Id(t[n], t[r], e), t)) return [t[n], t[r], e];
            }
          }

          throw new Error();
        }

        function Nd(t, e) {
          var n = t.r - e.r,
              r = e.x - t.x,
              i = e.y - t.y;
          return n < 0 || n * n < r * r + i * i;
        }

        function Dd(t, e) {
          var n = t.r - e.r + 1e-6,
              r = e.x - t.x,
              i = e.y - t.y;
          return n > 0 && n * n > r * r + i * i;
        }

        function Od(t, e) {
          for (var n = 0; n < e.length; ++n) {
            if (!Dd(t, e[n])) return !1;
          }

          return !0;
        }

        function Bd(t) {
          switch (t.length) {
            case 1:
              return function (t) {
                return {
                  x: t.x,
                  y: t.y,
                  r: t.r
                };
              }(t[0]);

            case 2:
              return Ld(t[0], t[1]);

            case 3:
              return Id(t[0], t[1], t[2]);
          }
        }

        function Ld(t, e) {
          var n = t.x,
              r = t.y,
              i = t.r,
              a = e.x,
              o = e.y,
              s = e.r,
              c = a - n,
              u = o - r,
              l = s - i,
              h = Math.sqrt(c * c + u * u);
          return {
            x: (n + a + c / h * l) / 2,
            y: (r + o + u / h * l) / 2,
            r: (h + i + s) / 2
          };
        }

        function Id(t, e, n) {
          var r = t.x,
              i = t.y,
              a = t.r,
              o = e.x,
              s = e.y,
              c = e.r,
              u = n.x,
              l = n.y,
              h = n.r,
              f = r - o,
              d = r - u,
              p = i - s,
              y = i - l,
              g = c - a,
              m = h - a,
              v = r * r + i * i - a * a,
              b = v - o * o - s * s + c * c,
              _ = v - u * u - l * l + h * h,
              x = d * p - f * y,
              w = (p * _ - y * b) / (2 * x) - r,
              k = (y * g - p * m) / x,
              T = (d * b - f * _) / (2 * x) - i,
              E = (f * m - d * g) / x,
              C = k * k + E * E - 1,
              S = 2 * (a + w * k + T * E),
              A = w * w + T * T - a * a,
              M = -(C ? (S + Math.sqrt(S * S - 4 * C * A)) / (2 * C) : A / S);

          return {
            x: r + w + k * M,
            y: i + T + E * M,
            r: M
          };
        }

        function Rd(t, e, n) {
          var r,
              i,
              a,
              o,
              s = t.x - e.x,
              c = t.y - e.y,
              u = s * s + c * c;
          u ? (i = e.r + n.r, i *= i, o = t.r + n.r, i > (o *= o) ? (r = (u + o - i) / (2 * u), a = Math.sqrt(Math.max(0, o / u - r * r)), n.x = t.x - r * s - a * c, n.y = t.y - r * c + a * s) : (r = (u + i - o) / (2 * u), a = Math.sqrt(Math.max(0, i / u - r * r)), n.x = e.x + r * s - a * c, n.y = e.y + r * c + a * s)) : (n.x = e.x + n.r, n.y = e.y);
        }

        function Pd(t, e) {
          var n = t.r + e.r - 1e-6,
              r = e.x - t.x,
              i = e.y - t.y;
          return n > 0 && n * n > r * r + i * i;
        }

        function Fd(t) {
          var e = t._,
              n = t.next._,
              r = e.r + n.r,
              i = (e.x * n.r + n.x * e.r) / r,
              a = (e.y * n.r + n.y * e.r) / r;
          return i * i + a * a;
        }

        function jd(t) {
          this._ = t, this.next = null, this.previous = null;
        }

        function Yd(t) {
          if (!(i = t.length)) return 0;
          var e, n, r, i, a, o, s, c, u, l, h;
          if ((e = t[0]).x = 0, e.y = 0, !(i > 1)) return e.r;
          if (n = t[1], e.x = -n.r, n.x = e.r, n.y = 0, !(i > 2)) return e.r + n.r;
          Rd(n, e, r = t[2]), e = new jd(e), n = new jd(n), r = new jd(r), e.next = r.previous = n, n.next = e.previous = r, r.next = n.previous = e;

          t: for (s = 3; s < i; ++s) {
            Rd(e._, n._, r = t[s]), r = new jd(r), c = n.next, u = e.previous, l = n._.r, h = e._.r;

            do {
              if (l <= h) {
                if (Pd(c._, r._)) {
                  n = c, e.next = n, n.previous = e, --s;
                  continue t;
                }

                l += c._.r, c = c.next;
              } else {
                if (Pd(u._, r._)) {
                  (e = u).next = n, n.previous = e, --s;
                  continue t;
                }

                h += u._.r, u = u.previous;
              }
            } while (c !== u.next);

            for (r.previous = e, r.next = n, e.next = n.previous = n = r, a = Fd(e); (r = r.next) !== n;) {
              (o = Fd(r)) < a && (e = r, a = o);
            }

            n = e.next;
          }

          for (e = [n._], r = n; (r = r.next) !== n;) {
            e.push(r._);
          }

          for (r = Ad(e), s = 0; s < i; ++s) {
            (e = t[s]).x -= r.x, e.y -= r.y;
          }

          return r.r;
        }

        function Ud(t) {
          return Yd(t), t;
        }

        function zd(t) {
          return null == t ? null : qd(t);
        }

        function qd(t) {
          if ("function" != typeof t) throw new Error();
          return t;
        }

        function $d() {
          return 0;
        }

        function Hd(t) {
          return function () {
            return t;
          };
        }

        function Wd(t) {
          return Math.sqrt(t.value);
        }

        function Vd() {
          var t = null,
              e = 1,
              n = 1,
              r = $d;

          function i(i) {
            return i.x = e / 2, i.y = n / 2, t ? i.eachBefore(Gd(t)).eachAfter(Xd(r, .5)).eachBefore(Zd(1)) : i.eachBefore(Gd(Wd)).eachAfter(Xd($d, 1)).eachAfter(Xd(r, i.r / Math.min(e, n))).eachBefore(Zd(Math.min(e, n) / (2 * i.r))), i;
          }

          return i.radius = function (e) {
            return arguments.length ? (t = zd(e), i) : t;
          }, i.size = function (t) {
            return arguments.length ? (e = +t[0], n = +t[1], i) : [e, n];
          }, i.padding = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : Hd(+t), i) : r;
          }, i;
        }

        function Gd(t) {
          return function (e) {
            e.children || (e.r = Math.max(0, +t(e) || 0));
          };
        }

        function Xd(t, e) {
          return function (n) {
            if (r = n.children) {
              var r,
                  i,
                  a,
                  o = r.length,
                  s = t(n) * e || 0;
              if (s) for (i = 0; i < o; ++i) {
                r[i].r += s;
              }
              if (a = Yd(r), s) for (i = 0; i < o; ++i) {
                r[i].r -= s;
              }
              n.r = a + s;
            }
          };
        }

        function Zd(t) {
          return function (e) {
            var n = e.parent;
            e.r *= t, n && (e.x = n.x + t * e.x, e.y = n.y + t * e.y);
          };
        }

        function Kd(t) {
          t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
        }

        function Qd(t, e, n, r, i) {
          for (var a, o = t.children, s = -1, c = o.length, u = t.value && (r - e) / t.value; ++s < c;) {
            (a = o[s]).y0 = n, a.y1 = i, a.x0 = e, a.x1 = e += a.value * u;
          }
        }

        function Jd() {
          var t = 1,
              e = 1,
              n = 0,
              r = !1;

          function i(i) {
            var a = i.height + 1;
            return i.x0 = i.y0 = n, i.x1 = t, i.y1 = e / a, i.eachBefore(function (t, e) {
              return function (r) {
                r.children && Qd(r, r.x0, t * (r.depth + 1) / e, r.x1, t * (r.depth + 2) / e);
                var i = r.x0,
                    a = r.y0,
                    o = r.x1 - n,
                    s = r.y1 - n;
                o < i && (i = o = (i + o) / 2), s < a && (a = s = (a + s) / 2), r.x0 = i, r.y0 = a, r.x1 = o, r.y1 = s;
              };
            }(e, a)), r && i.eachBefore(Kd), i;
          }

          return i.round = function (t) {
            return arguments.length ? (r = !!t, i) : r;
          }, i.size = function (n) {
            return arguments.length ? (t = +n[0], e = +n[1], i) : [t, e];
          }, i.padding = function (t) {
            return arguments.length ? (n = +t, i) : n;
          }, i;
        }

        var tp = {
          depth: -1
        },
            ep = {};

        function np(t) {
          return t.id;
        }

        function rp(t) {
          return t.parentId;
        }

        function ip() {
          var t = np,
              e = rp;

          function n(n) {
            var r,
                i,
                a,
                o,
                s,
                c,
                u,
                l = n.length,
                h = new Array(l),
                f = {};

            for (i = 0; i < l; ++i) {
              r = n[i], s = h[i] = new Cd(r), null != (c = t(r, i, n)) && (c += "") && (f[u = "$" + (s.id = c)] = u in f ? ep : s);
            }

            for (i = 0; i < l; ++i) {
              if (s = h[i], null != (c = e(n[i], i, n)) && (c += "")) {
                if (!(o = f["$" + c])) throw new Error("missing: " + c);
                if (o === ep) throw new Error("ambiguous: " + c);
                o.children ? o.children.push(s) : o.children = [s], s.parent = o;
              } else {
                if (a) throw new Error("multiple roots");
                a = s;
              }
            }

            if (!a) throw new Error("no root");
            if (a.parent = tp, a.eachBefore(function (t) {
              t.depth = t.parent.depth + 1, --l;
            }).eachBefore(Ed), a.parent = null, l > 0) throw new Error("cycle");
            return a;
          }

          return n.id = function (e) {
            return arguments.length ? (t = qd(e), n) : t;
          }, n.parentId = function (t) {
            return arguments.length ? (e = qd(t), n) : e;
          }, n;
        }

        function ap(t, e) {
          return t.parent === e.parent ? 1 : 2;
        }

        function op(t) {
          var e = t.children;
          return e ? e[0] : t.t;
        }

        function sp(t) {
          var e = t.children;
          return e ? e[e.length - 1] : t.t;
        }

        function cp(t, e, n) {
          var r = n / (e.i - t.i);
          e.c -= r, e.s += n, t.c += r, e.z += n, e.m += n;
        }

        function up(t, e, n) {
          return t.a.parent === e.parent ? t.a : n;
        }

        function lp(t, e) {
          this._ = t, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
        }

        function hp() {
          var t = ap,
              e = 1,
              n = 1,
              r = null;

          function i(i) {
            var c = function (t) {
              for (var e, n, r, i, a, o = new lp(t, 0), s = [o]; e = s.pop();) {
                if (r = e._.children) for (e.children = new Array(a = r.length), i = a - 1; i >= 0; --i) {
                  s.push(n = e.children[i] = new lp(r[i], i)), n.parent = e;
                }
              }

              return (o.parent = new lp(null, 0)).children = [o], o;
            }(i);

            if (c.eachAfter(a), c.parent.m = -c.z, c.eachBefore(o), r) i.eachBefore(s);else {
              var u = i,
                  l = i,
                  h = i;
              i.eachBefore(function (t) {
                t.x < u.x && (u = t), t.x > l.x && (l = t), t.depth > h.depth && (h = t);
              });
              var f = u === l ? 1 : t(u, l) / 2,
                  d = f - u.x,
                  p = e / (l.x + f + d),
                  y = n / (h.depth || 1);
              i.eachBefore(function (t) {
                t.x = (t.x + d) * p, t.y = t.depth * y;
              });
            }
            return i;
          }

          function a(e) {
            var n = e.children,
                r = e.parent.children,
                i = e.i ? r[e.i - 1] : null;

            if (n) {
              !function (t) {
                for (var e, n = 0, r = 0, i = t.children, a = i.length; --a >= 0;) {
                  (e = i[a]).z += n, e.m += n, n += e.s + (r += e.c);
                }
              }(e);
              var a = (n[0].z + n[n.length - 1].z) / 2;
              i ? (e.z = i.z + t(e._, i._), e.m = e.z - a) : e.z = a;
            } else i && (e.z = i.z + t(e._, i._));

            e.parent.A = function (e, n, r) {
              if (n) {
                for (var i, a = e, o = e, s = n, c = a.parent.children[0], u = a.m, l = o.m, h = s.m, f = c.m; s = sp(s), a = op(a), s && a;) {
                  c = op(c), (o = sp(o)).a = e, (i = s.z + h - a.z - u + t(s._, a._)) > 0 && (cp(up(s, e, r), e, i), u += i, l += i), h += s.m, u += a.m, f += c.m, l += o.m;
                }

                s && !sp(o) && (o.t = s, o.m += h - l), a && !op(c) && (c.t = a, c.m += u - f, r = e);
              }

              return r;
            }(e, i, e.parent.A || r[0]);
          }

          function o(t) {
            t._.x = t.z + t.parent.m, t.m += t.parent.m;
          }

          function s(t) {
            t.x *= e, t.y = t.depth * n;
          }

          return i.separation = function (e) {
            return arguments.length ? (t = e, i) : t;
          }, i.size = function (t) {
            return arguments.length ? (r = !1, e = +t[0], n = +t[1], i) : r ? null : [e, n];
          }, i.nodeSize = function (t) {
            return arguments.length ? (r = !0, e = +t[0], n = +t[1], i) : r ? [e, n] : null;
          }, i;
        }

        function fp(t, e, n, r, i) {
          for (var a, o = t.children, s = -1, c = o.length, u = t.value && (i - n) / t.value; ++s < c;) {
            (a = o[s]).x0 = e, a.x1 = r, a.y0 = n, a.y1 = n += a.value * u;
          }
        }

        lp.prototype = Object.create(Cd.prototype);
        var dp = (1 + Math.sqrt(5)) / 2;

        function pp(t, e, n, r, i, a) {
          for (var o, s, c, u, l, h, f, d, p, y, g, m = [], v = e.children, b = 0, _ = 0, x = v.length, w = e.value; b < x;) {
            c = i - n, u = a - r;

            do {
              l = v[_++].value;
            } while (!l && _ < x);

            for (h = f = l, g = l * l * (y = Math.max(u / c, c / u) / (w * t)), p = Math.max(f / g, g / h); _ < x; ++_) {
              if (l += s = v[_].value, s < h && (h = s), s > f && (f = s), g = l * l * y, (d = Math.max(f / g, g / h)) > p) {
                l -= s;
                break;
              }

              p = d;
            }

            m.push(o = {
              value: l,
              dice: c < u,
              children: v.slice(b, _)
            }), o.dice ? Qd(o, n, r, i, w ? r += u * l / w : a) : fp(o, n, r, w ? n += c * l / w : i, a), w -= l, b = _;
          }

          return m;
        }

        var yp = function t(e) {
          function n(t, n, r, i, a) {
            pp(e, t, n, r, i, a);
          }

          return n.ratio = function (e) {
            return t((e = +e) > 1 ? e : 1);
          }, n;
        }(dp);

        function gp() {
          var t = yp,
              e = !1,
              n = 1,
              r = 1,
              i = [0],
              a = $d,
              o = $d,
              s = $d,
              c = $d,
              u = $d;

          function l(t) {
            return t.x0 = t.y0 = 0, t.x1 = n, t.y1 = r, t.eachBefore(h), i = [0], e && t.eachBefore(Kd), t;
          }

          function h(e) {
            var n = i[e.depth],
                r = e.x0 + n,
                l = e.y0 + n,
                h = e.x1 - n,
                f = e.y1 - n;
            h < r && (r = h = (r + h) / 2), f < l && (l = f = (l + f) / 2), e.x0 = r, e.y0 = l, e.x1 = h, e.y1 = f, e.children && (n = i[e.depth + 1] = a(e) / 2, r += u(e) - n, l += o(e) - n, (h -= s(e) - n) < r && (r = h = (r + h) / 2), (f -= c(e) - n) < l && (l = f = (l + f) / 2), t(e, r, l, h, f));
          }

          return l.round = function (t) {
            return arguments.length ? (e = !!t, l) : e;
          }, l.size = function (t) {
            return arguments.length ? (n = +t[0], r = +t[1], l) : [n, r];
          }, l.tile = function (e) {
            return arguments.length ? (t = qd(e), l) : t;
          }, l.padding = function (t) {
            return arguments.length ? l.paddingInner(t).paddingOuter(t) : l.paddingInner();
          }, l.paddingInner = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : Hd(+t), l) : a;
          }, l.paddingOuter = function (t) {
            return arguments.length ? l.paddingTop(t).paddingRight(t).paddingBottom(t).paddingLeft(t) : l.paddingTop();
          }, l.paddingTop = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : Hd(+t), l) : o;
          }, l.paddingRight = function (t) {
            return arguments.length ? (s = "function" == typeof t ? t : Hd(+t), l) : s;
          }, l.paddingBottom = function (t) {
            return arguments.length ? (c = "function" == typeof t ? t : Hd(+t), l) : c;
          }, l.paddingLeft = function (t) {
            return arguments.length ? (u = "function" == typeof t ? t : Hd(+t), l) : u;
          }, l;
        }

        function mp(t, e, n, r, i) {
          var a,
              o,
              s = t.children,
              c = s.length,
              u = new Array(c + 1);

          for (u[0] = o = a = 0; a < c; ++a) {
            u[a + 1] = o += s[a].value;
          }

          !function t(e, n, r, i, a, o, c) {
            if (e >= n - 1) {
              var l = s[e];
              return l.x0 = i, l.y0 = a, l.x1 = o, void (l.y1 = c);
            }

            for (var h = u[e], f = r / 2 + h, d = e + 1, p = n - 1; d < p;) {
              var y = d + p >>> 1;
              u[y] < f ? d = y + 1 : p = y;
            }

            f - u[d - 1] < u[d] - f && e + 1 < d && --d;
            var g = u[d] - h,
                m = r - g;

            if (o - i > c - a) {
              var v = (i * m + o * g) / r;
              t(e, d, g, i, a, v, c), t(d, n, m, v, a, o, c);
            } else {
              var b = (a * m + c * g) / r;
              t(e, d, g, i, a, o, b), t(d, n, m, i, b, o, c);
            }
          }(0, c, t.value, e, n, r, i);
        }

        function vp(t, e, n, r, i) {
          (1 & t.depth ? fp : Qd)(t, e, n, r, i);
        }

        var bp = function t(e) {
          function n(t, n, r, i, a) {
            if ((o = t._squarify) && o.ratio === e) for (var o, s, c, u, l, h = -1, f = o.length, d = t.value; ++h < f;) {
              for (c = (s = o[h]).children, u = s.value = 0, l = c.length; u < l; ++u) {
                s.value += c[u].value;
              }

              s.dice ? Qd(s, n, r, i, r += (a - r) * s.value / d) : fp(s, n, r, n += (i - n) * s.value / d, a), d -= s.value;
            } else t._squarify = o = pp(e, t, n, r, i, a), o.ratio = e;
          }

          return n.ratio = function (e) {
            return t((e = +e) > 1 ? e : 1);
          }, n;
        }(dp);

        function _p(t) {
          var e = t.length;
          return function (n) {
            return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
          };
        }

        function xp(t, e) {
          var n = fn(+t, +e);
          return function (t) {
            var e = n(t);
            return e - 360 * Math.floor(e / 360);
          };
        }

        function wp(t, e) {
          return t = +t, e = +e, function (n) {
            return Math.round(t * (1 - n) + e * n);
          };
        }

        var kp = Math.SQRT2;

        function Tp(t) {
          return ((t = Math.exp(t)) + 1 / t) / 2;
        }

        function Ep(t, e) {
          var n,
              r,
              i = t[0],
              a = t[1],
              o = t[2],
              s = e[0],
              c = e[1],
              u = e[2],
              l = s - i,
              h = c - a,
              f = l * l + h * h;
          if (f < 1e-12) r = Math.log(u / o) / kp, n = function n(t) {
            return [i + t * l, a + t * h, o * Math.exp(kp * t * r)];
          };else {
            var d = Math.sqrt(f),
                p = (u * u - o * o + 4 * f) / (2 * o * 2 * d),
                y = (u * u - o * o - 4 * f) / (2 * u * 2 * d),
                g = Math.log(Math.sqrt(p * p + 1) - p),
                m = Math.log(Math.sqrt(y * y + 1) - y);
            r = (m - g) / kp, n = function n(t) {
              var e,
                  n = t * r,
                  s = Tp(g),
                  c = o / (2 * d) * (s * (e = kp * n + g, ((e = Math.exp(2 * e)) - 1) / (e + 1)) - function (t) {
                return ((t = Math.exp(t)) - 1 / t) / 2;
              }(g));

              return [i + c * l, a + c * h, o * s / Tp(kp * n + g)];
            };
          }
          return n.duration = 1e3 * r, n;
        }

        function Cp(t) {
          return function (e, n) {
            var r = t((e = rn(e)).h, (n = rn(n)).h),
                i = dn(e.s, n.s),
                a = dn(e.l, n.l),
                o = dn(e.opacity, n.opacity);
            return function (t) {
              return e.h = r(t), e.s = i(t), e.l = a(t), e.opacity = o(t), e + "";
            };
          };
        }

        var Sp = Cp(fn);
        var Ap = Cp(dn);

        function Mp(t, e) {
          var n = dn((t = ba(t)).l, (e = ba(e)).l),
              r = dn(t.a, e.a),
              i = dn(t.b, e.b),
              a = dn(t.opacity, e.opacity);
          return function (e) {
            return t.l = n(e), t.a = r(e), t.b = i(e), t.opacity = a(e), t + "";
          };
        }

        function Np(t) {
          return function (e, n) {
            var r = t((e = Sa(e)).h, (n = Sa(n)).h),
                i = dn(e.c, n.c),
                a = dn(e.l, n.l),
                o = dn(e.opacity, n.opacity);
            return function (t) {
              return e.h = r(t), e.c = i(t), e.l = a(t), e.opacity = o(t), e + "";
            };
          };
        }

        var Dp = Np(fn);
        var Op = Np(dn);

        function Bp(t) {
          return function e(n) {
            function r(e, r) {
              var i = t((e = Fa(e)).h, (r = Fa(r)).h),
                  a = dn(e.s, r.s),
                  o = dn(e.l, r.l),
                  s = dn(e.opacity, r.opacity);
              return function (t) {
                return e.h = i(t), e.s = a(t), e.l = o(Math.pow(t, n)), e.opacity = s(t), e + "";
              };
            }

            return n = +n, r.gamma = e, r;
          }(1);
        }

        var Lp = Bp(fn);
        var Ip = Bp(dn);

        function Rp(t, e) {
          for (var n = 0, r = e.length - 1, i = e[0], a = new Array(r < 0 ? 0 : r); n < r;) {
            a[n] = t(i, i = e[++n]);
          }

          return function (t) {
            var e = Math.max(0, Math.min(r - 1, Math.floor(t *= r)));
            return a[e](t - e);
          };
        }

        function Pp(t, e) {
          for (var n = new Array(e), r = 0; r < e; ++r) {
            n[r] = t(r / (e - 1));
          }

          return n;
        }

        function Fp(t) {
          for (var e, n = -1, r = t.length, i = t[r - 1], a = 0; ++n < r;) {
            e = i, i = t[n], a += e[1] * i[0] - e[0] * i[1];
          }

          return a / 2;
        }

        function jp(t) {
          for (var e, n, r = -1, i = t.length, a = 0, o = 0, s = t[i - 1], c = 0; ++r < i;) {
            e = s, s = t[r], c += n = e[0] * s[1] - s[0] * e[1], a += (e[0] + s[0]) * n, o += (e[1] + s[1]) * n;
          }

          return [a / (c *= 3), o / c];
        }

        function Yp(t, e, n) {
          return (e[0] - t[0]) * (n[1] - t[1]) - (e[1] - t[1]) * (n[0] - t[0]);
        }

        function Up(t, e) {
          return t[0] - e[0] || t[1] - e[1];
        }

        function zp(t) {
          for (var e = t.length, n = [0, 1], r = 2, i = 2; i < e; ++i) {
            for (; r > 1 && Yp(t[n[r - 2]], t[n[r - 1]], t[i]) <= 0;) {
              --r;
            }

            n[r++] = i;
          }

          return n.slice(0, r);
        }

        function qp(t) {
          if ((n = t.length) < 3) return null;
          var e,
              n,
              r = new Array(n),
              i = new Array(n);

          for (e = 0; e < n; ++e) {
            r[e] = [+t[e][0], +t[e][1], e];
          }

          for (r.sort(Up), e = 0; e < n; ++e) {
            i[e] = [r[e][0], -r[e][1]];
          }

          var a = zp(r),
              o = zp(i),
              s = o[0] === a[0],
              c = o[o.length - 1] === a[a.length - 1],
              u = [];

          for (e = a.length - 1; e >= 0; --e) {
            u.push(t[r[a[e]][2]]);
          }

          for (e = +s; e < o.length - c; ++e) {
            u.push(t[r[o[e]][2]]);
          }

          return u;
        }

        function $p(t, e) {
          for (var n, r, i = t.length, a = t[i - 1], o = e[0], s = e[1], c = a[0], u = a[1], l = !1, h = 0; h < i; ++h) {
            n = (a = t[h])[0], (r = a[1]) > s != u > s && o < (c - n) * (s - r) / (u - r) + n && (l = !l), c = n, u = r;
          }

          return l;
        }

        function Hp(t) {
          for (var e, n, r = -1, i = t.length, a = t[i - 1], o = a[0], s = a[1], c = 0; ++r < i;) {
            e = o, n = s, e -= o = (a = t[r])[0], n -= s = a[1], c += Math.sqrt(e * e + n * n);
          }

          return c;
        }

        function Wp() {
          return Math.random();
        }

        var Vp = function t(e) {
          function n(t, n) {
            return t = null == t ? 0 : +t, n = null == n ? 1 : +n, 1 === arguments.length ? (n = t, t = 0) : n -= t, function () {
              return e() * n + t;
            };
          }

          return n.source = t, n;
        }(Wp),
            Gp = function t(e) {
          function n(t, n) {
            var r, i;
            return t = null == t ? 0 : +t, n = null == n ? 1 : +n, function () {
              var a;
              if (null != r) a = r, r = null;else do {
                r = 2 * e() - 1, a = 2 * e() - 1, i = r * r + a * a;
              } while (!i || i > 1);
              return t + n * a * Math.sqrt(-2 * Math.log(i) / i);
            };
          }

          return n.source = t, n;
        }(Wp),
            Xp = function t(e) {
          function n() {
            var t = Gp.source(e).apply(this, arguments);
            return function () {
              return Math.exp(t());
            };
          }

          return n.source = t, n;
        }(Wp),
            Zp = function t(e) {
          function n(t) {
            return function () {
              for (var n = 0, r = 0; r < t; ++r) {
                n += e();
              }

              return n;
            };
          }

          return n.source = t, n;
        }(Wp),
            Kp = function t(e) {
          function n(t) {
            var n = Zp.source(e)(t);
            return function () {
              return n() / t;
            };
          }

          return n.source = t, n;
        }(Wp),
            Qp = function t(e) {
          function n(t) {
            return function () {
              return -Math.log(1 - e()) / t;
            };
          }

          return n.source = t, n;
        }(Wp);

        function Jp(t, e) {
          switch (arguments.length) {
            case 0:
              break;

            case 1:
              this.range(t);
              break;

            default:
              this.range(e).domain(t);
          }

          return this;
        }

        function ty(t, e) {
          switch (arguments.length) {
            case 0:
              break;

            case 1:
              this.interpolator(t);
              break;

            default:
              this.interpolator(e).domain(t);
          }

          return this;
        }

        var ey = Array.prototype,
            ny = ey.map,
            ry = ey.slice,
            iy = {
          name: "implicit"
        };

        function ay() {
          var t = ea(),
              e = [],
              n = [],
              r = iy;

          function i(i) {
            var a = i + "",
                o = t.get(a);

            if (!o) {
              if (r !== iy) return r;
              t.set(a, o = e.push(i));
            }

            return n[(o - 1) % n.length];
          }

          return i.domain = function (n) {
            if (!arguments.length) return e.slice();
            e = [], t = ea();

            for (var r, a, o = -1, s = n.length; ++o < s;) {
              t.has(a = (r = n[o]) + "") || t.set(a, e.push(r));
            }

            return i;
          }, i.range = function (t) {
            return arguments.length ? (n = ry.call(t), i) : n.slice();
          }, i.unknown = function (t) {
            return arguments.length ? (r = t, i) : r;
          }, i.copy = function () {
            return ay(e, n).unknown(r);
          }, Jp.apply(i, arguments), i;
        }

        function oy() {
          var t,
              e,
              n = ay().unknown(void 0),
              r = n.domain,
              i = n.range,
              a = [0, 1],
              o = !1,
              s = 0,
              c = 0,
              u = .5;

          function l() {
            var n = r().length,
                l = a[1] < a[0],
                h = a[l - 0],
                f = a[1 - l];
            t = (f - h) / Math.max(1, n - s + 2 * c), o && (t = Math.floor(t)), h += (f - h - t * (n - s)) * u, e = t * (1 - s), o && (h = Math.round(h), e = Math.round(e));
            var d = k(n).map(function (e) {
              return h + t * e;
            });
            return i(l ? d.reverse() : d);
          }

          return delete n.unknown, n.domain = function (t) {
            return arguments.length ? (r(t), l()) : r();
          }, n.range = function (t) {
            return arguments.length ? (a = [+t[0], +t[1]], l()) : a.slice();
          }, n.rangeRound = function (t) {
            return a = [+t[0], +t[1]], o = !0, l();
          }, n.bandwidth = function () {
            return e;
          }, n.step = function () {
            return t;
          }, n.round = function (t) {
            return arguments.length ? (o = !!t, l()) : o;
          }, n.padding = function (t) {
            return arguments.length ? (s = Math.min(1, c = +t), l()) : s;
          }, n.paddingInner = function (t) {
            return arguments.length ? (s = Math.min(1, t), l()) : s;
          }, n.paddingOuter = function (t) {
            return arguments.length ? (c = +t, l()) : c;
          }, n.align = function (t) {
            return arguments.length ? (u = Math.max(0, Math.min(1, t)), l()) : u;
          }, n.copy = function () {
            return oy(r(), a).round(o).paddingInner(s).paddingOuter(c).align(u);
          }, Jp.apply(l(), arguments);
        }

        function sy(t) {
          var e = t.copy;
          return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function () {
            return sy(e());
          }, t;
        }

        function cy() {
          return sy(oy.apply(null, arguments).paddingInner(1));
        }

        function uy(t) {
          return +t;
        }

        var ly = [0, 1];

        function hy(t) {
          return t;
        }

        function fy(t, e) {
          return (e -= t = +t) ? function (n) {
            return (n - t) / e;
          } : (n = isNaN(e) ? NaN : .5, function () {
            return n;
          });
          var n;
        }

        function dy(t) {
          var e,
              n = t[0],
              r = t[t.length - 1];
          return n > r && (e = n, n = r, r = e), function (t) {
            return Math.max(n, Math.min(r, t));
          };
        }

        function py(t, e, n) {
          var r = t[0],
              i = t[1],
              a = e[0],
              o = e[1];
          return i < r ? (r = fy(i, r), a = n(o, a)) : (r = fy(r, i), a = n(a, o)), function (t) {
            return a(r(t));
          };
        }

        function yy(t, e, n) {
          var r = Math.min(t.length, e.length) - 1,
              i = new Array(r),
              a = new Array(r),
              o = -1;

          for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r;) {
            i[o] = fy(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
          }

          return function (e) {
            var n = u(t, e, 1, r) - 1;
            return a[n](i[n](e));
          };
        }

        function gy(t, e) {
          return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
        }

        function my() {
          var t,
              e,
              n,
              r,
              i,
              a,
              o = ly,
              s = ly,
              c = An,
              u = hy;

          function l() {
            return r = Math.min(o.length, s.length) > 2 ? yy : py, i = a = null, h;
          }

          function h(e) {
            return isNaN(e = +e) ? n : (i || (i = r(o.map(t), s, c)))(t(u(e)));
          }

          return h.invert = function (n) {
            return u(e((a || (a = r(s, o.map(t), kn)))(n)));
          }, h.domain = function (t) {
            return arguments.length ? (o = ny.call(t, uy), u === hy || (u = dy(o)), l()) : o.slice();
          }, h.range = function (t) {
            return arguments.length ? (s = ry.call(t), l()) : s.slice();
          }, h.rangeRound = function (t) {
            return s = ry.call(t), c = wp, l();
          }, h.clamp = function (t) {
            return arguments.length ? (u = t ? dy(o) : hy, h) : u !== hy;
          }, h.interpolate = function (t) {
            return arguments.length ? (c = t, l()) : c;
          }, h.unknown = function (t) {
            return arguments.length ? (n = t, h) : n;
          }, function (n, r) {
            return t = n, e = r, l();
          };
        }

        function vy(t, e) {
          return my()(t, e);
        }

        function by(t, e, n, r) {
          var i,
              a = M(t, e, n);

          switch ((r = nc(null == r ? ",f" : r)).type) {
            case "s":
              var o = Math.max(Math.abs(t), Math.abs(e));
              return null != r.precision || isNaN(i = yc(a, o)) || (r.precision = i), uc(r, o);

            case "":
            case "e":
            case "g":
            case "p":
            case "r":
              null != r.precision || isNaN(i = gc(a, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
              break;

            case "f":
            case "%":
              null != r.precision || isNaN(i = pc(a)) || (r.precision = i - 2 * ("%" === r.type));
          }

          return cc(r);
        }

        function _y(t) {
          var e = t.domain;
          return t.ticks = function (t) {
            var n = e();
            return S(n[0], n[n.length - 1], null == t ? 10 : t);
          }, t.tickFormat = function (t, n) {
            var r = e();
            return by(r[0], r[r.length - 1], null == t ? 10 : t, n);
          }, t.nice = function (n) {
            null == n && (n = 10);
            var r,
                i = e(),
                a = 0,
                o = i.length - 1,
                s = i[a],
                c = i[o];
            return c < s && (r = s, s = c, c = r, r = a, a = o, o = r), (r = A(s, c, n)) > 0 ? r = A(s = Math.floor(s / r) * r, c = Math.ceil(c / r) * r, n) : r < 0 && (r = A(s = Math.ceil(s * r) / r, c = Math.floor(c * r) / r, n)), r > 0 ? (i[a] = Math.floor(s / r) * r, i[o] = Math.ceil(c / r) * r, e(i)) : r < 0 && (i[a] = Math.ceil(s * r) / r, i[o] = Math.floor(c * r) / r, e(i)), t;
          }, t;
        }

        function xy() {
          var t = vy(hy, hy);
          return t.copy = function () {
            return gy(t, xy());
          }, Jp.apply(t, arguments), _y(t);
        }

        function wy(t) {
          var e;

          function n(t) {
            return isNaN(t = +t) ? e : t;
          }

          return n.invert = n, n.domain = n.range = function (e) {
            return arguments.length ? (t = ny.call(e, uy), n) : t.slice();
          }, n.unknown = function (t) {
            return arguments.length ? (e = t, n) : e;
          }, n.copy = function () {
            return wy(t).unknown(e);
          }, t = arguments.length ? ny.call(t, uy) : [0, 1], _y(n);
        }

        function ky(t, e) {
          var n,
              r = 0,
              i = (t = t.slice()).length - 1,
              a = t[r],
              o = t[i];
          return o < a && (n = r, r = i, i = n, n = a, a = o, o = n), t[r] = e.floor(a), t[i] = e.ceil(o), t;
        }

        function Ty(t) {
          return Math.log(t);
        }

        function Ey(t) {
          return Math.exp(t);
        }

        function Cy(t) {
          return -Math.log(-t);
        }

        function Sy(t) {
          return -Math.exp(-t);
        }

        function Ay(t) {
          return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
        }

        function My(t) {
          return function (e) {
            return -t(-e);
          };
        }

        function Ny(t) {
          var e,
              n,
              r = t(Ty, Ey),
              i = r.domain,
              a = 10;

          function o() {
            return e = function (t) {
              return t === Math.E ? Math.log : 10 === t && Math.log10 || 2 === t && Math.log2 || (t = Math.log(t), function (e) {
                return Math.log(e) / t;
              });
            }(a), n = function (t) {
              return 10 === t ? Ay : t === Math.E ? Math.exp : function (e) {
                return Math.pow(t, e);
              };
            }(a), i()[0] < 0 ? (e = My(e), n = My(n), t(Cy, Sy)) : t(Ty, Ey), r;
          }

          return r.base = function (t) {
            return arguments.length ? (a = +t, o()) : a;
          }, r.domain = function (t) {
            return arguments.length ? (i(t), o()) : i();
          }, r.ticks = function (t) {
            var r,
                o = i(),
                s = o[0],
                c = o[o.length - 1];
            (r = c < s) && (f = s, s = c, c = f);
            var u,
                l,
                h,
                f = e(s),
                d = e(c),
                p = null == t ? 10 : +t,
                y = [];

            if (!(a % 1) && d - f < p) {
              if (f = Math.round(f) - 1, d = Math.round(d) + 1, s > 0) {
                for (; f < d; ++f) {
                  for (l = 1, u = n(f); l < a; ++l) {
                    if (!((h = u * l) < s)) {
                      if (h > c) break;
                      y.push(h);
                    }
                  }
                }
              } else for (; f < d; ++f) {
                for (l = a - 1, u = n(f); l >= 1; --l) {
                  if (!((h = u * l) < s)) {
                    if (h > c) break;
                    y.push(h);
                  }
                }
              }
            } else y = S(f, d, Math.min(d - f, p)).map(n);

            return r ? y.reverse() : y;
          }, r.tickFormat = function (t, i) {
            if (null == i && (i = 10 === a ? ".0e" : ","), "function" != typeof i && (i = cc(i)), t === 1 / 0) return i;
            null == t && (t = 10);
            var o = Math.max(1, a * t / r.ticks().length);
            return function (t) {
              var r = t / n(Math.round(e(t)));
              return r * a < a - .5 && (r *= a), r <= o ? i(t) : "";
            };
          }, r.nice = function () {
            return i(ky(i(), {
              floor: function floor(t) {
                return n(Math.floor(e(t)));
              },
              ceil: function ceil(t) {
                return n(Math.ceil(e(t)));
              }
            }));
          }, r;
        }

        function Dy() {
          var t = Ny(my()).domain([1, 10]);
          return t.copy = function () {
            return gy(t, Dy()).base(t.base());
          }, Jp.apply(t, arguments), t;
        }

        function Oy(t) {
          return function (e) {
            return Math.sign(e) * Math.log1p(Math.abs(e / t));
          };
        }

        function By(t) {
          return function (e) {
            return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
          };
        }

        function Ly(t) {
          var e = 1,
              n = t(Oy(e), By(e));
          return n.constant = function (n) {
            return arguments.length ? t(Oy(e = +n), By(e)) : e;
          }, _y(n);
        }

        function Iy() {
          var t = Ly(my());
          return t.copy = function () {
            return gy(t, Iy()).constant(t.constant());
          }, Jp.apply(t, arguments);
        }

        function Ry(t) {
          return function (e) {
            return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
          };
        }

        function Py(t) {
          return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
        }

        function Fy(t) {
          return t < 0 ? -t * t : t * t;
        }

        function jy(t) {
          var e = t(hy, hy),
              n = 1;

          function r() {
            return 1 === n ? t(hy, hy) : .5 === n ? t(Py, Fy) : t(Ry(n), Ry(1 / n));
          }

          return e.exponent = function (t) {
            return arguments.length ? (n = +t, r()) : n;
          }, _y(e);
        }

        function Yy() {
          var t = jy(my());
          return t.copy = function () {
            return gy(t, Yy()).exponent(t.exponent());
          }, Jp.apply(t, arguments), t;
        }

        function Uy() {
          return Yy.apply(null, arguments).exponent(.5);
        }

        function zy() {
          var t,
              e = [],
              n = [],
              r = [];

          function a() {
            var t = 0,
                i = Math.max(1, n.length);

            for (r = new Array(i - 1); ++t < i;) {
              r[t - 1] = O(e, t / i);
            }

            return o;
          }

          function o(e) {
            return isNaN(e = +e) ? t : n[u(r, e)];
          }

          return o.invertExtent = function (t) {
            var i = n.indexOf(t);
            return i < 0 ? [NaN, NaN] : [i > 0 ? r[i - 1] : e[0], i < r.length ? r[i] : e[e.length - 1]];
          }, o.domain = function (t) {
            if (!arguments.length) return e.slice();
            e = [];

            for (var n, r = 0, o = t.length; r < o; ++r) {
              null == (n = t[r]) || isNaN(n = +n) || e.push(n);
            }

            return e.sort(i), a();
          }, o.range = function (t) {
            return arguments.length ? (n = ry.call(t), a()) : n.slice();
          }, o.unknown = function (e) {
            return arguments.length ? (t = e, o) : t;
          }, o.quantiles = function () {
            return r.slice();
          }, o.copy = function () {
            return zy().domain(e).range(n).unknown(t);
          }, Jp.apply(o, arguments);
        }

        function qy() {
          var t,
              e = 0,
              n = 1,
              r = 1,
              i = [.5],
              a = [0, 1];

          function o(e) {
            return e <= e ? a[u(i, e, 0, r)] : t;
          }

          function s() {
            var t = -1;

            for (i = new Array(r); ++t < r;) {
              i[t] = ((t + 1) * n - (t - r) * e) / (r + 1);
            }

            return o;
          }

          return o.domain = function (t) {
            return arguments.length ? (e = +t[0], n = +t[1], s()) : [e, n];
          }, o.range = function (t) {
            return arguments.length ? (r = (a = ry.call(t)).length - 1, s()) : a.slice();
          }, o.invertExtent = function (t) {
            var o = a.indexOf(t);
            return o < 0 ? [NaN, NaN] : o < 1 ? [e, i[0]] : o >= r ? [i[r - 1], n] : [i[o - 1], i[o]];
          }, o.unknown = function (e) {
            return arguments.length ? (t = e, o) : o;
          }, o.thresholds = function () {
            return i.slice();
          }, o.copy = function () {
            return qy().domain([e, n]).range(a).unknown(t);
          }, Jp.apply(_y(o), arguments);
        }

        function $y() {
          var t,
              e = [.5],
              n = [0, 1],
              r = 1;

          function i(i) {
            return i <= i ? n[u(e, i, 0, r)] : t;
          }

          return i.domain = function (t) {
            return arguments.length ? (e = ry.call(t), r = Math.min(e.length, n.length - 1), i) : e.slice();
          }, i.range = function (t) {
            return arguments.length ? (n = ry.call(t), r = Math.min(e.length, n.length - 1), i) : n.slice();
          }, i.invertExtent = function (t) {
            var r = n.indexOf(t);
            return [e[r - 1], e[r]];
          }, i.unknown = function (e) {
            return arguments.length ? (t = e, i) : t;
          }, i.copy = function () {
            return $y().domain(e).range(n).unknown(t);
          }, Jp.apply(i, arguments);
        }

        var Hy = new Date(),
            Wy = new Date();

        function Vy(t, e, n, r) {
          function i(e) {
            return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
          }

          return i.floor = function (e) {
            return t(e = new Date(+e)), e;
          }, i.ceil = function (n) {
            return t(n = new Date(n - 1)), e(n, 1), t(n), n;
          }, i.round = function (t) {
            var e = i(t),
                n = i.ceil(t);
            return t - e < n - t ? e : n;
          }, i.offset = function (t, n) {
            return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
          }, i.range = function (n, r, a) {
            var o,
                s = [];
            if (n = i.ceil(n), a = null == a ? 1 : Math.floor(a), !(n < r && a > 0)) return s;

            do {
              s.push(o = new Date(+n)), e(n, a), t(n);
            } while (o < n && n < r);

            return s;
          }, i.filter = function (n) {
            return Vy(function (e) {
              if (e >= e) for (; t(e), !n(e);) {
                e.setTime(e - 1);
              }
            }, function (t, r) {
              if (t >= t) if (r < 0) for (; ++r <= 0;) {
                for (; e(t, -1), !n(t);) {
                  ;
                }
              } else for (; --r >= 0;) {
                for (; e(t, 1), !n(t);) {
                  ;
                }
              }
            });
          }, n && (i.count = function (e, r) {
            return Hy.setTime(+e), Wy.setTime(+r), t(Hy), t(Wy), Math.floor(n(Hy, Wy));
          }, i.every = function (t) {
            return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
              return r(e) % t == 0;
            } : function (e) {
              return i.count(0, e) % t == 0;
            }) : i : null;
          }), i;
        }

        var Gy = Vy(function (t) {
          t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setFullYear(t.getFullYear() + e);
        }, function (t, e) {
          return e.getFullYear() - t.getFullYear();
        }, function (t) {
          return t.getFullYear();
        });

        Gy.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? Vy(function (e) {
            e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
          }, function (e, n) {
            e.setFullYear(e.getFullYear() + n * t);
          }) : null;
        };

        var Xy = Gy;
        var Zy = Gy.range,
            Ky = Vy(function (t) {
          t.setDate(1), t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setMonth(t.getMonth() + e);
        }, function (t, e) {
          return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
        }, function (t) {
          return t.getMonth();
        });
        var Qy = Ky;
        var Jy = Ky.range,
            tg = 6e4,
            eg = 36e5,
            ng = 6048e5;

        function rg(t) {
          return Vy(function (e) {
            e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setDate(t.getDate() + 7 * e);
          }, function (t, e) {
            return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * tg) / ng;
          });
        }

        var ig = rg(0),
            ag = rg(1),
            og = rg(2),
            sg = rg(3),
            cg = rg(4),
            ug = rg(5),
            lg = rg(6),
            hg = ig.range,
            fg = ag.range,
            dg = og.range,
            pg = sg.range,
            yg = cg.range,
            gg = ug.range,
            mg = lg.range,
            vg = Vy(function (t) {
          t.setHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setDate(t.getDate() + e);
        }, function (t, e) {
          return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * tg) / 864e5;
        }, function (t) {
          return t.getDate() - 1;
        });
        var bg = vg;
        var _g = vg.range,
            xg = Vy(function (t) {
          t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds() - t.getMinutes() * tg);
        }, function (t, e) {
          t.setTime(+t + e * eg);
        }, function (t, e) {
          return (e - t) / eg;
        }, function (t) {
          return t.getHours();
        });
        var wg = xg;
        var kg = xg.range,
            Tg = Vy(function (t) {
          t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds());
        }, function (t, e) {
          t.setTime(+t + e * tg);
        }, function (t, e) {
          return (e - t) / tg;
        }, function (t) {
          return t.getMinutes();
        });
        var Eg = Tg;
        var Cg = Tg.range,
            Sg = Vy(function (t) {
          t.setTime(t - t.getMilliseconds());
        }, function (t, e) {
          t.setTime(+t + 1e3 * e);
        }, function (t, e) {
          return (e - t) / 1e3;
        }, function (t) {
          return t.getUTCSeconds();
        });
        var Ag = Sg;
        var Mg = Sg.range,
            Ng = Vy(function () {}, function (t, e) {
          t.setTime(+t + e);
        }, function (t, e) {
          return e - t;
        });

        Ng.every = function (t) {
          return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? Vy(function (e) {
            e.setTime(Math.floor(e / t) * t);
          }, function (e, n) {
            e.setTime(+e + n * t);
          }, function (e, n) {
            return (n - e) / t;
          }) : Ng : null;
        };

        var Dg = Ng;
        var Og = Ng.range;

        function Bg(t) {
          return Vy(function (e) {
            e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
          }, function (t, e) {
            t.setUTCDate(t.getUTCDate() + 7 * e);
          }, function (t, e) {
            return (e - t) / ng;
          });
        }

        var Lg = Bg(0),
            Ig = Bg(1),
            Rg = Bg(2),
            Pg = Bg(3),
            Fg = Bg(4),
            jg = Bg(5),
            Yg = Bg(6),
            Ug = Lg.range,
            zg = Ig.range,
            qg = Rg.range,
            $g = Pg.range,
            Hg = Fg.range,
            Wg = jg.range,
            Vg = Yg.range,
            Gg = Vy(function (t) {
          t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCDate(t.getUTCDate() + e);
        }, function (t, e) {
          return (e - t) / 864e5;
        }, function (t) {
          return t.getUTCDate() - 1;
        });
        var Xg = Gg;
        var Zg = Gg.range,
            Kg = Vy(function (t) {
          t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCFullYear(t.getUTCFullYear() + e);
        }, function (t, e) {
          return e.getUTCFullYear() - t.getUTCFullYear();
        }, function (t) {
          return t.getUTCFullYear();
        });

        Kg.every = function (t) {
          return isFinite(t = Math.floor(t)) && t > 0 ? Vy(function (e) {
            e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
          }, function (e, n) {
            e.setUTCFullYear(e.getUTCFullYear() + n * t);
          }) : null;
        };

        var Qg = Kg;
        var Jg = Kg.range;

        function tm(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
            return e.setFullYear(t.y), e;
          }

          return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
        }

        function em(t) {
          if (0 <= t.y && t.y < 100) {
            var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
            return e.setUTCFullYear(t.y), e;
          }

          return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
        }

        function nm(t, e, n) {
          return {
            y: t,
            m: e,
            d: n,
            H: 0,
            M: 0,
            S: 0,
            L: 0
          };
        }

        function rm(t) {
          var e = t.dateTime,
              n = t.date,
              r = t.time,
              i = t.periods,
              a = t.days,
              o = t.shortDays,
              s = t.months,
              c = t.shortMonths,
              u = ym(i),
              l = gm(i),
              h = ym(a),
              f = gm(a),
              d = ym(o),
              p = gm(o),
              y = ym(s),
              g = gm(s),
              m = ym(c),
              v = gm(c),
              b = {
            a: function a(t) {
              return o[t.getDay()];
            },
            A: function A(t) {
              return a[t.getDay()];
            },
            b: function b(t) {
              return c[t.getMonth()];
            },
            B: function B(t) {
              return s[t.getMonth()];
            },
            c: null,
            d: Pm,
            e: Pm,
            f: zm,
            g: Jm,
            G: ev,
            H: Fm,
            I: jm,
            j: Ym,
            L: Um,
            m: qm,
            M: $m,
            p: function p(t) {
              return i[+(t.getHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getMonth() / 3);
            },
            Q: Tv,
            s: Ev,
            S: Hm,
            u: Wm,
            U: Vm,
            V: Xm,
            w: Zm,
            W: Km,
            x: null,
            X: null,
            y: Qm,
            Y: tv,
            Z: nv,
            "%": kv
          },
              _ = {
            a: function a(t) {
              return o[t.getUTCDay()];
            },
            A: function A(t) {
              return a[t.getUTCDay()];
            },
            b: function b(t) {
              return c[t.getUTCMonth()];
            },
            B: function B(t) {
              return s[t.getUTCMonth()];
            },
            c: null,
            d: rv,
            e: rv,
            f: cv,
            g: bv,
            G: xv,
            H: iv,
            I: av,
            j: ov,
            L: sv,
            m: uv,
            M: lv,
            p: function p(t) {
              return i[+(t.getUTCHours() >= 12)];
            },
            q: function q(t) {
              return 1 + ~~(t.getUTCMonth() / 3);
            },
            Q: Tv,
            s: Ev,
            S: hv,
            u: fv,
            U: dv,
            V: yv,
            w: gv,
            W: mv,
            x: null,
            X: null,
            y: vv,
            Y: _v,
            Z: wv,
            "%": kv
          },
              x = {
            a: function a(t, e, n) {
              var r = d.exec(e.slice(n));
              return r ? (t.w = p[r[0].toLowerCase()], n + r[0].length) : -1;
            },
            A: function A(t, e, n) {
              var r = h.exec(e.slice(n));
              return r ? (t.w = f[r[0].toLowerCase()], n + r[0].length) : -1;
            },
            b: function b(t, e, n) {
              var r = m.exec(e.slice(n));
              return r ? (t.m = v[r[0].toLowerCase()], n + r[0].length) : -1;
            },
            B: function B(t, e, n) {
              var r = y.exec(e.slice(n));
              return r ? (t.m = g[r[0].toLowerCase()], n + r[0].length) : -1;
            },
            c: function c(t, n, r) {
              return T(t, e, n, r);
            },
            d: Sm,
            e: Sm,
            f: Bm,
            g: km,
            G: wm,
            H: Mm,
            I: Mm,
            j: Am,
            L: Om,
            m: Cm,
            M: Nm,
            p: function p(t, e, n) {
              var r = u.exec(e.slice(n));
              return r ? (t.p = l[r[0].toLowerCase()], n + r[0].length) : -1;
            },
            q: Em,
            Q: Im,
            s: Rm,
            S: Dm,
            u: vm,
            U: bm,
            V: _m,
            w: mm,
            W: xm,
            x: function x(t, e, r) {
              return T(t, n, e, r);
            },
            X: function X(t, e, n) {
              return T(t, r, e, n);
            },
            y: km,
            Y: wm,
            Z: Tm,
            "%": Lm
          };

          function w(t, e) {
            return function (n) {
              var r,
                  i,
                  a,
                  o = [],
                  s = -1,
                  c = 0,
                  u = t.length;

              for (n instanceof Date || (n = new Date(+n)); ++s < u;) {
                37 === t.charCodeAt(s) && (o.push(t.slice(c, s)), null != (i = um[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (a = e[r]) && (r = a(n, i)), o.push(r), c = s + 1);
              }

              return o.push(t.slice(c, s)), o.join("");
            };
          }

          function k(t, e) {
            return function (n) {
              var r,
                  i,
                  a = nm(1900, void 0, 1);
              if (T(a, t, n += "", 0) != n.length) return null;
              if ("Q" in a) return new Date(a.Q);
              if ("s" in a) return new Date(1e3 * a.s + ("L" in a ? a.L : 0));

              if (e && !("Z" in a) && (a.Z = 0), "p" in a && (a.H = a.H % 12 + 12 * a.p), void 0 === a.m && (a.m = "q" in a ? a.q : 0), "V" in a) {
                if (a.V < 1 || a.V > 53) return null;
                "w" in a || (a.w = 1), "Z" in a ? (i = (r = em(nm(a.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? Ig.ceil(r) : Ig(r), r = Xg.offset(r, 7 * (a.V - 1)), a.y = r.getUTCFullYear(), a.m = r.getUTCMonth(), a.d = r.getUTCDate() + (a.w + 6) % 7) : (i = (r = tm(nm(a.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? ag.ceil(r) : ag(r), r = bg.offset(r, 7 * (a.V - 1)), a.y = r.getFullYear(), a.m = r.getMonth(), a.d = r.getDate() + (a.w + 6) % 7);
              } else ("W" in a || "U" in a) && ("w" in a || (a.w = "u" in a ? a.u % 7 : "W" in a ? 1 : 0), i = "Z" in a ? em(nm(a.y, 0, 1)).getUTCDay() : tm(nm(a.y, 0, 1)).getDay(), a.m = 0, a.d = "W" in a ? (a.w + 6) % 7 + 7 * a.W - (i + 5) % 7 : a.w + 7 * a.U - (i + 6) % 7);

              return "Z" in a ? (a.H += a.Z / 100 | 0, a.M += a.Z % 100, em(a)) : tm(a);
            };
          }

          function T(t, e, n, r) {
            for (var i, a, o = 0, s = e.length, c = n.length; o < s;) {
              if (r >= c) return -1;

              if (37 === (i = e.charCodeAt(o++))) {
                if (i = e.charAt(o++), !(a = x[i in um ? e.charAt(o++) : i]) || (r = a(t, n, r)) < 0) return -1;
              } else if (i != n.charCodeAt(r++)) return -1;
            }

            return r;
          }

          return b.x = w(n, b), b.X = w(r, b), b.c = w(e, b), _.x = w(n, _), _.X = w(r, _), _.c = w(e, _), {
            format: function format(t) {
              var e = w(t += "", b);
              return e.toString = function () {
                return t;
              }, e;
            },
            parse: function parse(t) {
              var e = k(t += "", !1);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcFormat: function utcFormat(t) {
              var e = w(t += "", _);
              return e.toString = function () {
                return t;
              }, e;
            },
            utcParse: function utcParse(t) {
              var e = k(t += "", !0);
              return e.toString = function () {
                return t;
              }, e;
            }
          };
        }

        var im,
            am,
            om,
            sm,
            cm,
            um = {
          "-": "",
          _: " ",
          0: "0"
        },
            lm = /^\s*\d+/,
            hm = /^%/,
            fm = /[\\^$*+?|[\]().{}]/g;

        function dm(t, e, n) {
          var r = t < 0 ? "-" : "",
              i = (r ? -t : t) + "",
              a = i.length;
          return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
        }

        function pm(t) {
          return t.replace(fm, "\\$&");
        }

        function ym(t) {
          return new RegExp("^(?:" + t.map(pm).join("|") + ")", "i");
        }

        function gm(t) {
          for (var e = {}, n = -1, r = t.length; ++n < r;) {
            e[t[n].toLowerCase()] = n;
          }

          return e;
        }

        function mm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 1));
          return r ? (t.w = +r[0], n + r[0].length) : -1;
        }

        function vm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 1));
          return r ? (t.u = +r[0], n + r[0].length) : -1;
        }

        function bm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.U = +r[0], n + r[0].length) : -1;
        }

        function _m(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.V = +r[0], n + r[0].length) : -1;
        }

        function xm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.W = +r[0], n + r[0].length) : -1;
        }

        function wm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 4));
          return r ? (t.y = +r[0], n + r[0].length) : -1;
        }

        function km(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
        }

        function Tm(t, e, n) {
          var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
          return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
        }

        function Em(t, e, n) {
          var r = lm.exec(e.slice(n, n + 1));
          return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
        }

        function Cm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
        }

        function Sm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.d = +r[0], n + r[0].length) : -1;
        }

        function Am(t, e, n) {
          var r = lm.exec(e.slice(n, n + 3));
          return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
        }

        function Mm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.H = +r[0], n + r[0].length) : -1;
        }

        function Nm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.M = +r[0], n + r[0].length) : -1;
        }

        function Dm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 2));
          return r ? (t.S = +r[0], n + r[0].length) : -1;
        }

        function Om(t, e, n) {
          var r = lm.exec(e.slice(n, n + 3));
          return r ? (t.L = +r[0], n + r[0].length) : -1;
        }

        function Bm(t, e, n) {
          var r = lm.exec(e.slice(n, n + 6));
          return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
        }

        function Lm(t, e, n) {
          var r = hm.exec(e.slice(n, n + 1));
          return r ? n + r[0].length : -1;
        }

        function Im(t, e, n) {
          var r = lm.exec(e.slice(n));
          return r ? (t.Q = +r[0], n + r[0].length) : -1;
        }

        function Rm(t, e, n) {
          var r = lm.exec(e.slice(n));
          return r ? (t.s = +r[0], n + r[0].length) : -1;
        }

        function Pm(t, e) {
          return dm(t.getDate(), e, 2);
        }

        function Fm(t, e) {
          return dm(t.getHours(), e, 2);
        }

        function jm(t, e) {
          return dm(t.getHours() % 12 || 12, e, 2);
        }

        function Ym(t, e) {
          return dm(1 + bg.count(Xy(t), t), e, 3);
        }

        function Um(t, e) {
          return dm(t.getMilliseconds(), e, 3);
        }

        function zm(t, e) {
          return Um(t, e) + "000";
        }

        function qm(t, e) {
          return dm(t.getMonth() + 1, e, 2);
        }

        function $m(t, e) {
          return dm(t.getMinutes(), e, 2);
        }

        function Hm(t, e) {
          return dm(t.getSeconds(), e, 2);
        }

        function Wm(t) {
          var e = t.getDay();
          return 0 === e ? 7 : e;
        }

        function Vm(t, e) {
          return dm(ig.count(Xy(t) - 1, t), e, 2);
        }

        function Gm(t) {
          var e = t.getDay();
          return e >= 4 || 0 === e ? cg(t) : cg.ceil(t);
        }

        function Xm(t, e) {
          return t = Gm(t), dm(cg.count(Xy(t), t) + (4 === Xy(t).getDay()), e, 2);
        }

        function Zm(t) {
          return t.getDay();
        }

        function Km(t, e) {
          return dm(ag.count(Xy(t) - 1, t), e, 2);
        }

        function Qm(t, e) {
          return dm(t.getFullYear() % 100, e, 2);
        }

        function Jm(t, e) {
          return dm((t = Gm(t)).getFullYear() % 100, e, 2);
        }

        function tv(t, e) {
          return dm(t.getFullYear() % 1e4, e, 4);
        }

        function ev(t, e) {
          var n = t.getDay();
          return dm((t = n >= 4 || 0 === n ? cg(t) : cg.ceil(t)).getFullYear() % 1e4, e, 4);
        }

        function nv(t) {
          var e = t.getTimezoneOffset();
          return (e > 0 ? "-" : (e *= -1, "+")) + dm(e / 60 | 0, "0", 2) + dm(e % 60, "0", 2);
        }

        function rv(t, e) {
          return dm(t.getUTCDate(), e, 2);
        }

        function iv(t, e) {
          return dm(t.getUTCHours(), e, 2);
        }

        function av(t, e) {
          return dm(t.getUTCHours() % 12 || 12, e, 2);
        }

        function ov(t, e) {
          return dm(1 + Xg.count(Qg(t), t), e, 3);
        }

        function sv(t, e) {
          return dm(t.getUTCMilliseconds(), e, 3);
        }

        function cv(t, e) {
          return sv(t, e) + "000";
        }

        function uv(t, e) {
          return dm(t.getUTCMonth() + 1, e, 2);
        }

        function lv(t, e) {
          return dm(t.getUTCMinutes(), e, 2);
        }

        function hv(t, e) {
          return dm(t.getUTCSeconds(), e, 2);
        }

        function fv(t) {
          var e = t.getUTCDay();
          return 0 === e ? 7 : e;
        }

        function dv(t, e) {
          return dm(Lg.count(Qg(t) - 1, t), e, 2);
        }

        function pv(t) {
          var e = t.getUTCDay();
          return e >= 4 || 0 === e ? Fg(t) : Fg.ceil(t);
        }

        function yv(t, e) {
          return t = pv(t), dm(Fg.count(Qg(t), t) + (4 === Qg(t).getUTCDay()), e, 2);
        }

        function gv(t) {
          return t.getUTCDay();
        }

        function mv(t, e) {
          return dm(Ig.count(Qg(t) - 1, t), e, 2);
        }

        function vv(t, e) {
          return dm(t.getUTCFullYear() % 100, e, 2);
        }

        function bv(t, e) {
          return dm((t = pv(t)).getUTCFullYear() % 100, e, 2);
        }

        function _v(t, e) {
          return dm(t.getUTCFullYear() % 1e4, e, 4);
        }

        function xv(t, e) {
          var n = t.getUTCDay();
          return dm((t = n >= 4 || 0 === n ? Fg(t) : Fg.ceil(t)).getUTCFullYear() % 1e4, e, 4);
        }

        function wv() {
          return "+0000";
        }

        function kv() {
          return "%";
        }

        function Tv(t) {
          return +t;
        }

        function Ev(t) {
          return Math.floor(+t / 1e3);
        }

        function Cv(t) {
          return im = rm(t), am = im.format, om = im.parse, sm = im.utcFormat, cm = im.utcParse, im;
        }

        Cv({
          dateTime: "%x, %X",
          date: "%-m/%-d/%Y",
          time: "%-I:%M:%S %p",
          periods: ["AM", "PM"],
          days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        });
        var Sv = 31536e6;

        function Av(t) {
          return new Date(t);
        }

        function Mv(t) {
          return t instanceof Date ? +t : +new Date(+t);
        }

        function Nv(t, e, n, r, i, o, s, c, u) {
          var l = vy(hy, hy),
              h = l.invert,
              f = l.domain,
              d = u(".%L"),
              p = u(":%S"),
              y = u("%I:%M"),
              g = u("%I %p"),
              m = u("%a %d"),
              v = u("%b %d"),
              b = u("%B"),
              _ = u("%Y"),
              x = [[s, 1, 1e3], [s, 5, 5e3], [s, 15, 15e3], [s, 30, 3e4], [o, 1, 6e4], [o, 5, 3e5], [o, 15, 9e5], [o, 30, 18e5], [i, 1, 36e5], [i, 3, 108e5], [i, 6, 216e5], [i, 12, 432e5], [r, 1, 864e5], [r, 2, 1728e5], [n, 1, 6048e5], [e, 1, 2592e6], [e, 3, 7776e6], [t, 1, Sv]];

          function w(a) {
            return (s(a) < a ? d : o(a) < a ? p : i(a) < a ? y : r(a) < a ? g : e(a) < a ? n(a) < a ? m : v : t(a) < a ? b : _)(a);
          }

          function k(e, n, r, i) {
            if (null == e && (e = 10), "number" == typeof e) {
              var o = Math.abs(r - n) / e,
                  s = a(function (t) {
                return t[2];
              }).right(x, o);
              s === x.length ? (i = M(n / Sv, r / Sv, e), e = t) : s ? (i = (s = x[o / x[s - 1][2] < x[s][2] / o ? s - 1 : s])[1], e = s[0]) : (i = Math.max(M(n, r, e), 1), e = c);
            }

            return null == i ? e : e.every(i);
          }

          return l.invert = function (t) {
            return new Date(h(t));
          }, l.domain = function (t) {
            return arguments.length ? f(ny.call(t, Mv)) : f().map(Av);
          }, l.ticks = function (t, e) {
            var n,
                r = f(),
                i = r[0],
                a = r[r.length - 1],
                o = a < i;
            return o && (n = i, i = a, a = n), n = (n = k(t, i, a, e)) ? n.range(i, a + 1) : [], o ? n.reverse() : n;
          }, l.tickFormat = function (t, e) {
            return null == e ? w : u(e);
          }, l.nice = function (t, e) {
            var n = f();
            return (t = k(t, n[0], n[n.length - 1], e)) ? f(ky(n, t)) : l;
          }, l.copy = function () {
            return gy(l, Nv(t, e, n, r, i, o, s, c, u));
          }, l;
        }

        function Dv() {
          return Jp.apply(Nv(Xy, Qy, ig, bg, wg, Eg, Ag, Dg, am).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
        }

        var Ov = Vy(function (t) {
          t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
        }, function (t, e) {
          t.setUTCMonth(t.getUTCMonth() + e);
        }, function (t, e) {
          return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
        }, function (t) {
          return t.getUTCMonth();
        });
        var Bv = Ov;
        var Lv = Ov.range,
            Iv = Vy(function (t) {
          t.setUTCMinutes(0, 0, 0);
        }, function (t, e) {
          t.setTime(+t + e * eg);
        }, function (t, e) {
          return (e - t) / eg;
        }, function (t) {
          return t.getUTCHours();
        });
        var Rv = Iv;
        var Pv = Iv.range,
            Fv = Vy(function (t) {
          t.setUTCSeconds(0, 0);
        }, function (t, e) {
          t.setTime(+t + e * tg);
        }, function (t, e) {
          return (e - t) / tg;
        }, function (t) {
          return t.getUTCMinutes();
        });
        var jv = Fv;
        var Yv = Fv.range;

        function Uv() {
          return Jp.apply(Nv(Qg, Bv, Lg, Xg, Rv, jv, Ag, Dg, sm).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
        }

        function zv() {
          var t,
              e,
              n,
              r,
              i,
              a = 0,
              o = 1,
              s = hy,
              c = !1;

          function u(e) {
            return isNaN(e = +e) ? i : s(0 === n ? .5 : (e = (r(e) - t) * n, c ? Math.max(0, Math.min(1, e)) : e));
          }

          return u.domain = function (i) {
            return arguments.length ? (t = r(a = +i[0]), e = r(o = +i[1]), n = t === e ? 0 : 1 / (e - t), u) : [a, o];
          }, u.clamp = function (t) {
            return arguments.length ? (c = !!t, u) : c;
          }, u.interpolator = function (t) {
            return arguments.length ? (s = t, u) : s;
          }, u.unknown = function (t) {
            return arguments.length ? (i = t, u) : i;
          }, function (i) {
            return r = i, t = i(a), e = i(o), n = t === e ? 0 : 1 / (e - t), u;
          };
        }

        function qv(t, e) {
          return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
        }

        function $v() {
          var t = _y(zv()(hy));

          return t.copy = function () {
            return qv(t, $v());
          }, ty.apply(t, arguments);
        }

        function Hv() {
          var t = Ny(zv()).domain([1, 10]);
          return t.copy = function () {
            return qv(t, Hv()).base(t.base());
          }, ty.apply(t, arguments);
        }

        function Wv() {
          var t = Ly(zv());
          return t.copy = function () {
            return qv(t, Wv()).constant(t.constant());
          }, ty.apply(t, arguments);
        }

        function Vv() {
          var t = jy(zv());
          return t.copy = function () {
            return qv(t, Vv()).exponent(t.exponent());
          }, ty.apply(t, arguments);
        }

        function Gv() {
          return Vv.apply(null, arguments).exponent(.5);
        }

        function Xv() {
          var t = [],
              e = hy;

          function n(n) {
            if (!isNaN(n = +n)) return e((u(t, n) - 1) / (t.length - 1));
          }

          return n.domain = function (e) {
            if (!arguments.length) return t.slice();
            t = [];

            for (var r, a = 0, o = e.length; a < o; ++a) {
              null == (r = e[a]) || isNaN(r = +r) || t.push(r);
            }

            return t.sort(i), n;
          }, n.interpolator = function (t) {
            return arguments.length ? (e = t, n) : e;
          }, n.copy = function () {
            return Xv(e).domain(t);
          }, ty.apply(n, arguments);
        }

        function Zv() {
          var t,
              e,
              n,
              r,
              i,
              a,
              o,
              s = 0,
              c = .5,
              u = 1,
              l = hy,
              h = !1;

          function f(t) {
            return isNaN(t = +t) ? o : (t = .5 + ((t = +a(t)) - e) * (t < e ? r : i), l(h ? Math.max(0, Math.min(1, t)) : t));
          }

          return f.domain = function (o) {
            return arguments.length ? (t = a(s = +o[0]), e = a(c = +o[1]), n = a(u = +o[2]), r = t === e ? 0 : .5 / (e - t), i = e === n ? 0 : .5 / (n - e), f) : [s, c, u];
          }, f.clamp = function (t) {
            return arguments.length ? (h = !!t, f) : h;
          }, f.interpolator = function (t) {
            return arguments.length ? (l = t, f) : l;
          }, f.unknown = function (t) {
            return arguments.length ? (o = t, f) : o;
          }, function (o) {
            return a = o, t = o(s), e = o(c), n = o(u), r = t === e ? 0 : .5 / (e - t), i = e === n ? 0 : .5 / (n - e), f;
          };
        }

        function Kv() {
          var t = _y(Zv()(hy));

          return t.copy = function () {
            return qv(t, Kv());
          }, ty.apply(t, arguments);
        }

        function Qv() {
          var t = Ny(Zv()).domain([.1, 1, 10]);
          return t.copy = function () {
            return qv(t, Qv()).base(t.base());
          }, ty.apply(t, arguments);
        }

        function Jv() {
          var t = Ly(Zv());
          return t.copy = function () {
            return qv(t, Jv()).constant(t.constant());
          }, ty.apply(t, arguments);
        }

        function tb() {
          var t = jy(Zv());
          return t.copy = function () {
            return qv(t, tb()).exponent(t.exponent());
          }, ty.apply(t, arguments);
        }

        function eb() {
          return tb.apply(null, arguments).exponent(.5);
        }

        function nb(t) {
          for (var e = t.length / 6 | 0, n = new Array(e), r = 0; r < e;) {
            n[r] = "#" + t.slice(6 * r, 6 * ++r);
          }

          return n;
        }

        var rb = nb("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"),
            ib = nb("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"),
            ab = nb("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"),
            ob = nb("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"),
            sb = nb("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"),
            cb = nb("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"),
            ub = nb("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"),
            lb = nb("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"),
            hb = nb("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"),
            fb = nb("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

        function db(t) {
          return gn(t[t.length - 1]);
        }

        var pb = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(nb);
        var yb = db(pb);
        var gb = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(nb);
        var mb = db(gb);
        var vb = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(nb);
        var bb = db(vb);

        var _b = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(nb);

        var xb = db(_b);
        var wb = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(nb);
        var kb = db(wb);
        var Tb = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(nb);
        var Eb = db(Tb);
        var Cb = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(nb);
        var Sb = db(Cb);
        var Ab = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(nb);
        var Mb = db(Ab);
        var Nb = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(nb);
        var Db = db(Nb);
        var Ob = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(nb);
        var Bb = db(Ob);
        var Lb = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(nb);
        var Ib = db(Lb);
        var Rb = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(nb);
        var Pb = db(Rb);
        var Fb = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(nb);
        var jb = db(Fb);
        var Yb = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(nb);
        var Ub = db(Yb);
        var zb = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(nb);
        var qb = db(zb);
        var $b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(nb);
        var Hb = db($b);
        var Wb = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(nb);
        var Vb = db(Wb);
        var Gb = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(nb);
        var Xb = db(Gb);
        var Zb = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(nb);
        var Kb = db(Zb);
        var Qb = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(nb);
        var Jb = db(Qb);
        var t_ = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(nb);
        var e_ = db(t_);
        var n_ = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(nb);
        var r_ = db(n_);
        var i_ = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(nb);
        var a_ = db(i_);
        var o_ = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(nb);
        var s_ = db(o_);
        var c_ = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(nb);
        var u_ = db(c_);
        var l_ = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(nb);
        var h_ = db(l_);
        var f_ = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(nb);
        var d_ = db(f_);

        function p_(t) {
          return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - 2710.57 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - 67.37 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - 2475.67 * t))))))) + ")";
        }

        var y_ = Ip(Fa(300, .5, 0), Fa(-240, .5, 1));
        var g_ = Ip(Fa(-100, .75, .35), Fa(80, 1.5, .8)),
            m_ = Ip(Fa(260, .75, .35), Fa(80, 1.5, .8)),
            v_ = Fa();

        function b_(t) {
          (t < 0 || t > 1) && (t -= Math.floor(t));
          var e = Math.abs(t - .5);
          return v_.h = 360 * t - 100, v_.s = 1.5 - 1.5 * e, v_.l = .8 - .9 * e, v_ + "";
        }

        var __ = Ze(),
            x_ = Math.PI / 3,
            w_ = 2 * Math.PI / 3;

        function k_(t) {
          var e;
          return t = (.5 - t) * Math.PI, __.r = 255 * (e = Math.sin(t)) * e, __.g = 255 * (e = Math.sin(t + x_)) * e, __.b = 255 * (e = Math.sin(t + w_)) * e, __ + "";
        }

        function T_(t) {
          return t = Math.max(0, Math.min(1, t)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - 14825.05 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + 707.56 * t))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - 6838.66 * t))))))) + ")";
        }

        function E_(t) {
          var e = t.length;
          return function (n) {
            return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
          };
        }

        var C_ = E_(nb("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
        var S_ = E_(nb("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),
            A_ = E_(nb("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),
            M_ = E_(nb("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

        function N_(t) {
          return Te(ie(t).call(document.documentElement));
        }

        var D_ = 0;

        function O_() {
          return new B_();
        }

        function B_() {
          this._ = "@" + (++D_).toString(36);
        }

        function L_(t) {
          return "string" == typeof t ? new xe([document.querySelectorAll(t)], [document.documentElement]) : new xe([null == t ? [] : t], _e);
        }

        function I_(t, e) {
          null == e && (e = Mn().touches);

          for (var n = 0, r = e ? e.length : 0, i = new Array(r); n < r; ++n) {
            i[n] = Nn(t, e[n]);
          }

          return i;
        }

        function R_(t) {
          return function () {
            return t;
          };
        }

        B_.prototype = O_.prototype = {
          constructor: B_,
          get: function get(t) {
            for (var e = this._; !(e in t);) {
              if (!(t = t.parentNode)) return;
            }

            return t[e];
          },
          set: function set(t, e) {
            return t[this._] = e;
          },
          remove: function remove(t) {
            return this._ in t && delete t[this._];
          },
          toString: function toString() {
            return this._;
          }
        };
        var P_ = Math.abs,
            F_ = Math.atan2,
            j_ = Math.cos,
            Y_ = Math.max,
            U_ = Math.min,
            z_ = Math.sin,
            q_ = Math.sqrt,
            $_ = 1e-12,
            H_ = Math.PI,
            W_ = H_ / 2,
            V_ = 2 * H_;

        function G_(t) {
          return t > 1 ? 0 : t < -1 ? H_ : Math.acos(t);
        }

        function X_(t) {
          return t >= 1 ? W_ : t <= -1 ? -W_ : Math.asin(t);
        }

        function Z_(t) {
          return t.innerRadius;
        }

        function K_(t) {
          return t.outerRadius;
        }

        function Q_(t) {
          return t.startAngle;
        }

        function J_(t) {
          return t.endAngle;
        }

        function tx(t) {
          return t && t.padAngle;
        }

        function ex(t, e, n, r, i, a, o, s) {
          var c = n - t,
              u = r - e,
              l = o - i,
              h = s - a,
              f = h * c - l * u;
          if (!(f * f < $_)) return [t + (f = (l * (e - a) - h * (t - i)) / f) * c, e + f * u];
        }

        function nx(t, e, n, r, i, a, o) {
          var s = t - n,
              c = e - r,
              u = (o ? a : -a) / q_(s * s + c * c),
              l = u * c,
              h = -u * s,
              f = t + l,
              d = e + h,
              p = n + l,
              y = r + h,
              g = (f + p) / 2,
              m = (d + y) / 2,
              v = p - f,
              b = y - d,
              _ = v * v + b * b,
              x = i - a,
              w = f * y - p * d,
              k = (b < 0 ? -1 : 1) * q_(Y_(0, x * x * _ - w * w)),
              T = (w * b - v * k) / _,
              E = (-w * v - b * k) / _,
              C = (w * b + v * k) / _,
              S = (-w * v + b * k) / _,
              A = T - g,
              M = E - m,
              N = C - g,
              D = S - m;

          return A * A + M * M > N * N + D * D && (T = C, E = S), {
            cx: T,
            cy: E,
            x01: -l,
            y01: -h,
            x11: T * (i / x - 1),
            y11: E * (i / x - 1)
          };
        }

        function rx() {
          var t = Z_,
              e = K_,
              n = R_(0),
              r = null,
              i = Q_,
              a = J_,
              o = tx,
              s = null;

          function c() {
            var c,
                u,
                l = +t.apply(this, arguments),
                h = +e.apply(this, arguments),
                f = i.apply(this, arguments) - W_,
                d = a.apply(this, arguments) - W_,
                p = P_(d - f),
                y = d > f;
            if (s || (s = c = Hi()), h < l && (u = h, h = l, l = u), h > $_) {
              if (p > V_ - $_) s.moveTo(h * j_(f), h * z_(f)), s.arc(0, 0, h, f, d, !y), l > $_ && (s.moveTo(l * j_(d), l * z_(d)), s.arc(0, 0, l, d, f, y));else {
                var g,
                    m,
                    v = f,
                    b = d,
                    _ = f,
                    x = d,
                    w = p,
                    k = p,
                    T = o.apply(this, arguments) / 2,
                    E = T > $_ && (r ? +r.apply(this, arguments) : q_(l * l + h * h)),
                    C = U_(P_(h - l) / 2, +n.apply(this, arguments)),
                    S = C,
                    A = C;

                if (E > $_) {
                  var M = X_(E / l * z_(T)),
                      N = X_(E / h * z_(T));
                  (w -= 2 * M) > $_ ? (_ += M *= y ? 1 : -1, x -= M) : (w = 0, _ = x = (f + d) / 2), (k -= 2 * N) > $_ ? (v += N *= y ? 1 : -1, b -= N) : (k = 0, v = b = (f + d) / 2);
                }

                var D = h * j_(v),
                    O = h * z_(v),
                    B = l * j_(x),
                    L = l * z_(x);

                if (C > $_) {
                  var I,
                      R = h * j_(b),
                      P = h * z_(b),
                      F = l * j_(_),
                      j = l * z_(_);

                  if (p < H_ && (I = ex(D, O, F, j, R, P, B, L))) {
                    var Y = D - I[0],
                        U = O - I[1],
                        z = R - I[0],
                        q = P - I[1],
                        $ = 1 / z_(G_((Y * z + U * q) / (q_(Y * Y + U * U) * q_(z * z + q * q))) / 2),
                        H = q_(I[0] * I[0] + I[1] * I[1]);
                    S = U_(C, (l - H) / ($ - 1)), A = U_(C, (h - H) / ($ + 1));
                  }
                }

                k > $_ ? A > $_ ? (g = nx(F, j, D, O, h, A, y), m = nx(R, P, B, L, h, A, y), s.moveTo(g.cx + g.x01, g.cy + g.y01), A < C ? s.arc(g.cx, g.cy, A, F_(g.y01, g.x01), F_(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, A, F_(g.y01, g.x01), F_(g.y11, g.x11), !y), s.arc(0, 0, h, F_(g.cy + g.y11, g.cx + g.x11), F_(m.cy + m.y11, m.cx + m.x11), !y), s.arc(m.cx, m.cy, A, F_(m.y11, m.x11), F_(m.y01, m.x01), !y))) : (s.moveTo(D, O), s.arc(0, 0, h, v, b, !y)) : s.moveTo(D, O), l > $_ && w > $_ ? S > $_ ? (g = nx(B, L, R, P, l, -S, y), m = nx(D, O, F, j, l, -S, y), s.lineTo(g.cx + g.x01, g.cy + g.y01), S < C ? s.arc(g.cx, g.cy, S, F_(g.y01, g.x01), F_(m.y01, m.x01), !y) : (s.arc(g.cx, g.cy, S, F_(g.y01, g.x01), F_(g.y11, g.x11), !y), s.arc(0, 0, l, F_(g.cy + g.y11, g.cx + g.x11), F_(m.cy + m.y11, m.cx + m.x11), y), s.arc(m.cx, m.cy, S, F_(m.y11, m.x11), F_(m.y01, m.x01), !y))) : s.arc(0, 0, l, x, _, y) : s.lineTo(B, L);
              }
            } else s.moveTo(0, 0);
            if (s.closePath(), c) return s = null, c + "" || null;
          }

          return c.centroid = function () {
            var n = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2,
                r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - H_ / 2;
            return [j_(r) * n, z_(r) * n];
          }, c.innerRadius = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : R_(+e), c) : t;
          }, c.outerRadius = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : R_(+t), c) : e;
          }, c.cornerRadius = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : R_(+t), c) : n;
          }, c.padRadius = function (t) {
            return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : R_(+t), c) : r;
          }, c.startAngle = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : R_(+t), c) : i;
          }, c.endAngle = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : R_(+t), c) : a;
          }, c.padAngle = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : R_(+t), c) : o;
          }, c.context = function (t) {
            return arguments.length ? (s = null == t ? null : t, c) : s;
          }, c;
        }

        function ix(t) {
          this._context = t;
        }

        function ax(t) {
          return new ix(t);
        }

        function ox(t) {
          return t[0];
        }

        function sx(t) {
          return t[1];
        }

        function cx() {
          var t = ox,
              e = sx,
              n = R_(!0),
              r = null,
              i = ax,
              a = null;

          function o(o) {
            var s,
                c,
                u,
                l = o.length,
                h = !1;

            for (null == r && (a = i(u = Hi())), s = 0; s <= l; ++s) {
              !(s < l && n(c = o[s], s, o)) === h && ((h = !h) ? a.lineStart() : a.lineEnd()), h && a.point(+t(c, s, o), +e(c, s, o));
            }

            if (u) return a = null, u + "" || null;
          }

          return o.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : R_(+e), o) : t;
          }, o.y = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : R_(+t), o) : e;
          }, o.defined = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : R_(!!t), o) : n;
          }, o.curve = function (t) {
            return arguments.length ? (i = t, null != r && (a = i(r)), o) : i;
          }, o.context = function (t) {
            return arguments.length ? (null == t ? r = a = null : a = i(r = t), o) : r;
          }, o;
        }

        function ux() {
          var t = ox,
              e = null,
              n = R_(0),
              r = sx,
              i = R_(!0),
              a = null,
              o = ax,
              s = null;

          function c(c) {
            var u,
                l,
                h,
                f,
                d,
                p = c.length,
                y = !1,
                g = new Array(p),
                m = new Array(p);

            for (null == a && (s = o(d = Hi())), u = 0; u <= p; ++u) {
              if (!(u < p && i(f = c[u], u, c)) === y) if (y = !y) l = u, s.areaStart(), s.lineStart();else {
                for (s.lineEnd(), s.lineStart(), h = u - 1; h >= l; --h) {
                  s.point(g[h], m[h]);
                }

                s.lineEnd(), s.areaEnd();
              }
              y && (g[u] = +t(f, u, c), m[u] = +n(f, u, c), s.point(e ? +e(f, u, c) : g[u], r ? +r(f, u, c) : m[u]));
            }

            if (d) return s = null, d + "" || null;
          }

          function u() {
            return cx().defined(i).curve(o).context(a);
          }

          return c.x = function (n) {
            return arguments.length ? (t = "function" == typeof n ? n : R_(+n), e = null, c) : t;
          }, c.x0 = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : R_(+e), c) : t;
          }, c.x1 = function (t) {
            return arguments.length ? (e = null == t ? null : "function" == typeof t ? t : R_(+t), c) : e;
          }, c.y = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : R_(+t), r = null, c) : n;
          }, c.y0 = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : R_(+t), c) : n;
          }, c.y1 = function (t) {
            return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : R_(+t), c) : r;
          }, c.lineX0 = c.lineY0 = function () {
            return u().x(t).y(n);
          }, c.lineY1 = function () {
            return u().x(t).y(r);
          }, c.lineX1 = function () {
            return u().x(e).y(n);
          }, c.defined = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : R_(!!t), c) : i;
          }, c.curve = function (t) {
            return arguments.length ? (o = t, null != a && (s = o(a)), c) : o;
          }, c.context = function (t) {
            return arguments.length ? (null == t ? a = s = null : s = o(a = t), c) : a;
          }, c;
        }

        function lx(t, e) {
          return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
        }

        function hx(t) {
          return t;
        }

        function fx() {
          var t = hx,
              e = lx,
              n = null,
              r = R_(0),
              i = R_(V_),
              a = R_(0);

          function o(o) {
            var s,
                c,
                u,
                l,
                h,
                f = o.length,
                d = 0,
                p = new Array(f),
                y = new Array(f),
                g = +r.apply(this, arguments),
                m = Math.min(V_, Math.max(-V_, i.apply(this, arguments) - g)),
                v = Math.min(Math.abs(m) / f, a.apply(this, arguments)),
                b = v * (m < 0 ? -1 : 1);

            for (s = 0; s < f; ++s) {
              (h = y[p[s] = s] = +t(o[s], s, o)) > 0 && (d += h);
            }

            for (null != e ? p.sort(function (t, n) {
              return e(y[t], y[n]);
            }) : null != n && p.sort(function (t, e) {
              return n(o[t], o[e]);
            }), s = 0, u = d ? (m - f * b) / d : 0; s < f; ++s, g = l) {
              c = p[s], l = g + ((h = y[c]) > 0 ? h * u : 0) + b, y[c] = {
                data: o[c],
                index: s,
                value: h,
                startAngle: g,
                endAngle: l,
                padAngle: v
              };
            }

            return y;
          }

          return o.value = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : R_(+e), o) : t;
          }, o.sortValues = function (t) {
            return arguments.length ? (e = t, n = null, o) : e;
          }, o.sort = function (t) {
            return arguments.length ? (n = t, e = null, o) : n;
          }, o.startAngle = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : R_(+t), o) : r;
          }, o.endAngle = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : R_(+t), o) : i;
          }, o.padAngle = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : R_(+t), o) : a;
          }, o;
        }

        ix.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;

              default:
                this._context.lineTo(t, e);

            }
          }
        };
        var dx = yx(ax);

        function px(t) {
          this._curve = t;
        }

        function yx(t) {
          function e(e) {
            return new px(t(e));
          }

          return e._curve = t, e;
        }

        function gx(t) {
          var e = t.curve;
          return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t.curve = function (t) {
            return arguments.length ? e(yx(t)) : e()._curve;
          }, t;
        }

        function mx() {
          return gx(cx().curve(dx));
        }

        function vx() {
          var t = ux().curve(dx),
              e = t.curve,
              n = t.lineX0,
              r = t.lineX1,
              i = t.lineY0,
              a = t.lineY1;
          return t.angle = t.x, delete t.x, t.startAngle = t.x0, delete t.x0, t.endAngle = t.x1, delete t.x1, t.radius = t.y, delete t.y, t.innerRadius = t.y0, delete t.y0, t.outerRadius = t.y1, delete t.y1, t.lineStartAngle = function () {
            return gx(n());
          }, delete t.lineX0, t.lineEndAngle = function () {
            return gx(r());
          }, delete t.lineX1, t.lineInnerRadius = function () {
            return gx(i());
          }, delete t.lineY0, t.lineOuterRadius = function () {
            return gx(a());
          }, delete t.lineY1, t.curve = function (t) {
            return arguments.length ? e(yx(t)) : e()._curve;
          }, t;
        }

        function bx(t, e) {
          return [(e = +e) * Math.cos(t -= Math.PI / 2), e * Math.sin(t)];
        }

        px.prototype = {
          areaStart: function areaStart() {
            this._curve.areaStart();
          },
          areaEnd: function areaEnd() {
            this._curve.areaEnd();
          },
          lineStart: function lineStart() {
            this._curve.lineStart();
          },
          lineEnd: function lineEnd() {
            this._curve.lineEnd();
          },
          point: function point(t, e) {
            this._curve.point(e * Math.sin(t), e * -Math.cos(t));
          }
        };
        var _x = Array.prototype.slice;

        function xx(t) {
          return t.source;
        }

        function wx(t) {
          return t.target;
        }

        function kx(t) {
          var e = xx,
              n = wx,
              r = ox,
              i = sx,
              a = null;

          function o() {
            var o,
                s = _x.call(arguments),
                c = e.apply(this, s),
                u = n.apply(this, s);

            if (a || (a = o = Hi()), t(a, +r.apply(this, (s[0] = c, s)), +i.apply(this, s), +r.apply(this, (s[0] = u, s)), +i.apply(this, s)), o) return a = null, o + "" || null;
          }

          return o.source = function (t) {
            return arguments.length ? (e = t, o) : e;
          }, o.target = function (t) {
            return arguments.length ? (n = t, o) : n;
          }, o.x = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : R_(+t), o) : r;
          }, o.y = function (t) {
            return arguments.length ? (i = "function" == typeof t ? t : R_(+t), o) : i;
          }, o.context = function (t) {
            return arguments.length ? (a = null == t ? null : t, o) : a;
          }, o;
        }

        function Tx(t, e, n, r, i) {
          t.moveTo(e, n), t.bezierCurveTo(e = (e + r) / 2, n, e, i, r, i);
        }

        function Ex(t, e, n, r, i) {
          t.moveTo(e, n), t.bezierCurveTo(e, n = (n + i) / 2, r, n, r, i);
        }

        function Cx(t, e, n, r, i) {
          var a = bx(e, n),
              o = bx(e, n = (n + i) / 2),
              s = bx(r, n),
              c = bx(r, i);
          t.moveTo(a[0], a[1]), t.bezierCurveTo(o[0], o[1], s[0], s[1], c[0], c[1]);
        }

        function Sx() {
          return kx(Tx);
        }

        function Ax() {
          return kx(Ex);
        }

        function Mx() {
          var t = kx(Cx);
          return t.angle = t.x, delete t.x, t.radius = t.y, delete t.y, t;
        }

        var Nx = {
          draw: function draw(t, e) {
            var n = Math.sqrt(e / H_);
            t.moveTo(n, 0), t.arc(0, 0, n, 0, V_);
          }
        },
            Dx = {
          draw: function draw(t, e) {
            var n = Math.sqrt(e / 5) / 2;
            t.moveTo(-3 * n, -n), t.lineTo(-n, -n), t.lineTo(-n, -3 * n), t.lineTo(n, -3 * n), t.lineTo(n, -n), t.lineTo(3 * n, -n), t.lineTo(3 * n, n), t.lineTo(n, n), t.lineTo(n, 3 * n), t.lineTo(-n, 3 * n), t.lineTo(-n, n), t.lineTo(-3 * n, n), t.closePath();
          }
        };
        var Ox = Math.sqrt(1 / 3),
            Bx = 2 * Ox;
        var Lx = {
          draw: function draw(t, e) {
            var n = Math.sqrt(e / Bx),
                r = n * Ox;
            t.moveTo(0, -n), t.lineTo(r, 0), t.lineTo(0, n), t.lineTo(-r, 0), t.closePath();
          }
        };
        var Ix = Math.sin(H_ / 10) / Math.sin(7 * H_ / 10),
            Rx = Math.sin(V_ / 10) * Ix,
            Px = -Math.cos(V_ / 10) * Ix;
        var Fx = {
          draw: function draw(t, e) {
            var n = Math.sqrt(.8908130915292852 * e),
                r = Rx * n,
                i = Px * n;
            t.moveTo(0, -n), t.lineTo(r, i);

            for (var a = 1; a < 5; ++a) {
              var o = V_ * a / 5,
                  s = Math.cos(o),
                  c = Math.sin(o);
              t.lineTo(c * n, -s * n), t.lineTo(s * r - c * i, c * r + s * i);
            }

            t.closePath();
          }
        },
            jx = {
          draw: function draw(t, e) {
            var n = Math.sqrt(e),
                r = -n / 2;
            t.rect(r, r, n, n);
          }
        };
        var Yx = Math.sqrt(3);
        var Ux = {
          draw: function draw(t, e) {
            var n = -Math.sqrt(e / (3 * Yx));
            t.moveTo(0, 2 * n), t.lineTo(-Yx * n, -n), t.lineTo(Yx * n, -n), t.closePath();
          }
        };
        var zx = -.5,
            qx = Math.sqrt(3) / 2,
            $x = 1 / Math.sqrt(12),
            Hx = 3 * ($x / 2 + 1);
        var Wx = {
          draw: function draw(t, e) {
            var n = Math.sqrt(e / Hx),
                r = n / 2,
                i = n * $x,
                a = r,
                o = n * $x + n,
                s = -a,
                c = o;
            t.moveTo(r, i), t.lineTo(a, o), t.lineTo(s, c), t.lineTo(zx * r - qx * i, qx * r + zx * i), t.lineTo(zx * a - qx * o, qx * a + zx * o), t.lineTo(zx * s - qx * c, qx * s + zx * c), t.lineTo(zx * r + qx * i, zx * i - qx * r), t.lineTo(zx * a + qx * o, zx * o - qx * a), t.lineTo(zx * s + qx * c, zx * c - qx * s), t.closePath();
          }
        };
        var Vx = [Nx, Dx, Lx, jx, Fx, Ux, Wx];

        function Gx() {
          var t = R_(Nx),
              e = R_(64),
              n = null;

          function r() {
            var r;
            if (n || (n = r = Hi()), t.apply(this, arguments).draw(n, +e.apply(this, arguments)), r) return n = null, r + "" || null;
          }

          return r.type = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : R_(e), r) : t;
          }, r.size = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : R_(+t), r) : e;
          }, r.context = function (t) {
            return arguments.length ? (n = null == t ? null : t, r) : n;
          }, r;
        }

        function Xx() {}

        function Zx(t, e, n) {
          t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + n) / 6);
        }

        function Kx(t) {
          this._context = t;
        }

        function Qx(t) {
          return new Kx(t);
        }

        function Jx(t) {
          this._context = t;
        }

        function tw(t) {
          return new Jx(t);
        }

        function ew(t) {
          this._context = t;
        }

        function nw(t) {
          return new ew(t);
        }

        function rw(t, e) {
          this._basis = new Kx(t), this._beta = e;
        }

        Kx.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 3:
                Zx(this, this._x1, this._y1);

              case 2:
                this._context.lineTo(this._x1, this._y1);

            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

              default:
                Zx(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, Jx.prototype = {
          areaStart: Xx,
          areaEnd: Xx,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x2, this._y2), this._context.closePath();
                break;

              case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
                break;

              case 3:
                this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
            }
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._x2 = t, this._y2 = e;
                break;

              case 1:
                this._point = 2, this._x3 = t, this._y3 = e;
                break;

              case 2:
                this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
                break;

              default:
                Zx(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, ew.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3;
                var n = (this._x0 + 4 * this._x1 + t) / 6,
                    r = (this._y0 + 4 * this._y1 + e) / 6;
                this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
                break;

              case 3:
                this._point = 4;

              default:
                Zx(this, t, e);
            }

            this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
          }
        }, rw.prototype = {
          lineStart: function lineStart() {
            this._x = [], this._y = [], this._basis.lineStart();
          },
          lineEnd: function lineEnd() {
            var t = this._x,
                e = this._y,
                n = t.length - 1;
            if (n > 0) for (var r, i = t[0], a = e[0], o = t[n] - i, s = e[n] - a, c = -1; ++c <= n;) {
              r = c / n, this._basis.point(this._beta * t[c] + (1 - this._beta) * (i + r * o), this._beta * e[c] + (1 - this._beta) * (a + r * s));
            }
            this._x = this._y = null, this._basis.lineEnd();
          },
          point: function point(t, e) {
            this._x.push(+t), this._y.push(+e);
          }
        };

        var iw = function t(e) {
          function n(t) {
            return 1 === e ? new Kx(t) : new rw(t, e);
          }

          return n.beta = function (e) {
            return t(+e);
          }, n;
        }(.85);

        function aw(t, e, n) {
          t._context.bezierCurveTo(t._x1 + t._k * (t._x2 - t._x0), t._y1 + t._k * (t._y2 - t._y0), t._x2 + t._k * (t._x1 - e), t._y2 + t._k * (t._y1 - n), t._x2, t._y2);
        }

        function ow(t, e) {
          this._context = t, this._k = (1 - e) / 6;
        }

        ow.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x2, this._y2);

                break;

              case 3:
                aw(this, this._x1, this._y1);
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2, this._x1 = t, this._y1 = e;
                break;

              case 2:
                this._point = 3;

              default:
                aw(this, t, e);
            }

            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var sw = function t(e) {
          function n(t) {
            return new ow(t, e);
          }

          return n.tension = function (e) {
            return t(+e);
          }, n;
        }(0);

        function cw(t, e) {
          this._context = t, this._k = (1 - e) / 6;
        }

        cw.prototype = {
          areaStart: Xx,
          areaEnd: Xx,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x3, this._y3), this._context.closePath();
                break;

              case 2:
                this._context.lineTo(this._x3, this._y3), this._context.closePath();
                break;

              case 3:
                this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
            }
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._x3 = t, this._y3 = e;
                break;

              case 1:
                this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
                break;

              case 2:
                this._point = 3, this._x5 = t, this._y5 = e;
                break;

              default:
                aw(this, t, e);
            }

            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var uw = function t(e) {
          function n(t) {
            return new cw(t, e);
          }

          return n.tension = function (e) {
            return t(+e);
          }, n;
        }(0);

        function lw(t, e) {
          this._context = t, this._k = (1 - e) / 6;
        }

        lw.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;

              case 3:
                this._point = 4;

              default:
                aw(this, t, e);
            }

            this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var hw = function t(e) {
          function n(t) {
            return new lw(t, e);
          }

          return n.tension = function (e) {
            return t(+e);
          }, n;
        }(0);

        function fw(t, e, n) {
          var r = t._x1,
              i = t._y1,
              a = t._x2,
              o = t._y2;

          if (t._l01_a > $_) {
            var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a,
                c = 3 * t._l01_a * (t._l01_a + t._l12_a);
            r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / c, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / c;
          }

          if (t._l23_a > $_) {
            var u = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a,
                l = 3 * t._l23_a * (t._l23_a + t._l12_a);
            a = (a * u + t._x1 * t._l23_2a - e * t._l12_2a) / l, o = (o * u + t._y1 * t._l23_2a - n * t._l12_2a) / l;
          }

          t._context.bezierCurveTo(r, i, a, o, t._x2, t._y2);
        }

        function dw(t, e) {
          this._context = t, this._alpha = e;
        }

        dw.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x2, this._y2);

                break;

              case 3:
                this.point(this._x2, this._y2);
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            if (t = +t, e = +e, this._point) {
              var n = this._x2 - t,
                  r = this._y2 - e;
              this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
            }

            switch (this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3;

              default:
                fw(this, t, e);
            }

            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var pw = function t(e) {
          function n(t) {
            return e ? new dw(t, e) : new ow(t, 0);
          }

          return n.alpha = function (e) {
            return t(+e);
          }, n;
        }(.5);

        function yw(t, e) {
          this._context = t, this._alpha = e;
        }

        yw.prototype = {
          areaStart: Xx,
          areaEnd: Xx,
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 1:
                this._context.moveTo(this._x3, this._y3), this._context.closePath();
                break;

              case 2:
                this._context.lineTo(this._x3, this._y3), this._context.closePath();
                break;

              case 3:
                this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
            }
          },
          point: function point(t, e) {
            if (t = +t, e = +e, this._point) {
              var n = this._x2 - t,
                  r = this._y2 - e;
              this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
            }

            switch (this._point) {
              case 0:
                this._point = 1, this._x3 = t, this._y3 = e;
                break;

              case 1:
                this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
                break;

              case 2:
                this._point = 3, this._x5 = t, this._y5 = e;
                break;

              default:
                fw(this, t, e);
            }

            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var gw = function t(e) {
          function n(t) {
            return e ? new yw(t, e) : new cw(t, 0);
          }

          return n.alpha = function (e) {
            return t(+e);
          }, n;
        }(.5);

        function mw(t, e) {
          this._context = t, this._alpha = e;
        }

        mw.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
          },
          lineEnd: function lineEnd() {
            (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            if (t = +t, e = +e, this._point) {
              var n = this._x2 - t,
                  r = this._y2 - e;
              this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
            }

            switch (this._point) {
              case 0:
                this._point = 1;
                break;

              case 1:
                this._point = 2;
                break;

              case 2:
                this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;

              case 3:
                this._point = 4;

              default:
                fw(this, t, e);
            }

            this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
          }
        };

        var vw = function t(e) {
          function n(t) {
            return e ? new mw(t, e) : new lw(t, 0);
          }

          return n.alpha = function (e) {
            return t(+e);
          }, n;
        }(.5);

        function bw(t) {
          this._context = t;
        }

        function _w(t) {
          return new bw(t);
        }

        function xw(t) {
          return t < 0 ? -1 : 1;
        }

        function ww(t, e, n) {
          var r = t._x1 - t._x0,
              i = e - t._x1,
              a = (t._y1 - t._y0) / (r || i < 0 && -0),
              o = (n - t._y1) / (i || r < 0 && -0),
              s = (a * i + o * r) / (r + i);
          return (xw(a) + xw(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
        }

        function kw(t, e) {
          var n = t._x1 - t._x0;
          return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
        }

        function Tw(t, e, n) {
          var r = t._x0,
              i = t._y0,
              a = t._x1,
              o = t._y1,
              s = (a - r) / 3;

          t._context.bezierCurveTo(r + s, i + s * e, a - s, o - s * n, a, o);
        }

        function Ew(t) {
          this._context = t;
        }

        function Cw(t) {
          this._context = new Sw(t);
        }

        function Sw(t) {
          this._context = t;
        }

        function Aw(t) {
          return new Ew(t);
        }

        function Mw(t) {
          return new Cw(t);
        }

        function Nw(t) {
          this._context = t;
        }

        function Dw(t) {
          var e,
              n,
              r = t.length - 1,
              i = new Array(r),
              a = new Array(r),
              o = new Array(r);

          for (i[0] = 0, a[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) {
            i[e] = 1, a[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
          }

          for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) {
            n = i[e] / a[e - 1], a[e] -= n, o[e] -= n * o[e - 1];
          }

          for (i[r - 1] = o[r - 1] / a[r - 1], e = r - 2; e >= 0; --e) {
            i[e] = (o[e] - i[e + 1]) / a[e];
          }

          for (a[r - 1] = (t[r] + i[r - 1]) / 2, e = 0; e < r - 1; ++e) {
            a[e] = 2 * t[e + 1] - i[e + 1];
          }

          return [i, a];
        }

        function Ow(t) {
          return new Nw(t);
        }

        function Bw(t, e) {
          this._context = t, this._t = e;
        }

        function Lw(t) {
          return new Bw(t, .5);
        }

        function Iw(t) {
          return new Bw(t, 0);
        }

        function Rw(t) {
          return new Bw(t, 1);
        }

        function Pw(t, e) {
          if ((i = t.length) > 1) for (var n, r, i, a = 1, o = t[e[0]], s = o.length; a < i; ++a) {
            for (r = o, o = t[e[a]], n = 0; n < s; ++n) {
              o[n][1] += o[n][0] = isNaN(r[n][1]) ? r[n][0] : r[n][1];
            }
          }
        }

        function Fw(t) {
          for (var e = t.length, n = new Array(e); --e >= 0;) {
            n[e] = e;
          }

          return n;
        }

        function jw(t, e) {
          return t[e];
        }

        function Yw() {
          var t = R_([]),
              e = Fw,
              n = Pw,
              r = jw;

          function i(i) {
            var a,
                o,
                s = t.apply(this, arguments),
                c = i.length,
                u = s.length,
                l = new Array(u);

            for (a = 0; a < u; ++a) {
              for (var h, f = s[a], d = l[a] = new Array(c), p = 0; p < c; ++p) {
                d[p] = h = [0, +r(i[p], f, p, i)], h.data = i[p];
              }

              d.key = f;
            }

            for (a = 0, o = e(l); a < u; ++a) {
              l[o[a]].index = a;
            }

            return n(l, o), l;
          }

          return i.keys = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : R_(_x.call(e)), i) : t;
          }, i.value = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : R_(+t), i) : r;
          }, i.order = function (t) {
            return arguments.length ? (e = null == t ? Fw : "function" == typeof t ? t : R_(_x.call(t)), i) : e;
          }, i.offset = function (t) {
            return arguments.length ? (n = null == t ? Pw : t, i) : n;
          }, i;
        }

        function Uw(t, e) {
          if ((r = t.length) > 0) {
            for (var n, r, i, a = 0, o = t[0].length; a < o; ++a) {
              for (i = n = 0; n < r; ++n) {
                i += t[n][a][1] || 0;
              }

              if (i) for (n = 0; n < r; ++n) {
                t[n][a][1] /= i;
              }
            }

            Pw(t, e);
          }
        }

        function zw(t, e) {
          if ((s = t.length) > 0) for (var n, r, i, a, o, s, c = 0, u = t[e[0]].length; c < u; ++c) {
            for (a = o = 0, n = 0; n < s; ++n) {
              (i = (r = t[e[n]][c])[1] - r[0]) > 0 ? (r[0] = a, r[1] = a += i) : i < 0 ? (r[1] = o, r[0] = o += i) : (r[0] = 0, r[1] = i);
            }
          }
        }

        function qw(t, e) {
          if ((n = t.length) > 0) {
            for (var n, r = 0, i = t[e[0]], a = i.length; r < a; ++r) {
              for (var o = 0, s = 0; o < n; ++o) {
                s += t[o][r][1] || 0;
              }

              i[r][1] += i[r][0] = -s / 2;
            }

            Pw(t, e);
          }
        }

        function $w(t, e) {
          if ((i = t.length) > 0 && (r = (n = t[e[0]]).length) > 0) {
            for (var n, r, i, a = 0, o = 1; o < r; ++o) {
              for (var s = 0, c = 0, u = 0; s < i; ++s) {
                for (var l = t[e[s]], h = l[o][1] || 0, f = (h - (l[o - 1][1] || 0)) / 2, d = 0; d < s; ++d) {
                  var p = t[e[d]];
                  f += (p[o][1] || 0) - (p[o - 1][1] || 0);
                }

                c += h, u += f * h;
              }

              n[o - 1][1] += n[o - 1][0] = a, c && (a -= u / c);
            }

            n[o - 1][1] += n[o - 1][0] = a, Pw(t, e);
          }
        }

        function Hw(t) {
          var e = t.map(Ww);
          return Fw(t).sort(function (t, n) {
            return e[t] - e[n];
          });
        }

        function Ww(t) {
          for (var e, n = -1, r = 0, i = t.length, a = -1 / 0; ++n < i;) {
            (e = +t[n][1]) > a && (a = e, r = n);
          }

          return r;
        }

        function Vw(t) {
          var e = t.map(Gw);
          return Fw(t).sort(function (t, n) {
            return e[t] - e[n];
          });
        }

        function Gw(t) {
          for (var e, n = 0, r = -1, i = t.length; ++r < i;) {
            (e = +t[r][1]) && (n += e);
          }

          return n;
        }

        function Xw(t) {
          return Vw(t).reverse();
        }

        function Zw(t) {
          var e,
              n,
              r = t.length,
              i = t.map(Gw),
              a = Hw(t),
              o = 0,
              s = 0,
              c = [],
              u = [];

          for (e = 0; e < r; ++e) {
            n = a[e], o < s ? (o += i[n], c.push(n)) : (s += i[n], u.push(n));
          }

          return u.reverse().concat(c);
        }

        function Kw(t) {
          return Fw(t).reverse();
        }

        bw.prototype = {
          areaStart: Xx,
          areaEnd: Xx,
          lineStart: function lineStart() {
            this._point = 0;
          },
          lineEnd: function lineEnd() {
            this._point && this._context.closePath();
          },
          point: function point(t, e) {
            t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
          }
        }, Ew.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            switch (this._point) {
              case 2:
                this._context.lineTo(this._x1, this._y1);

                break;

              case 3:
                Tw(this, this._t0, kw(this, this._t0));
            }

            (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
          },
          point: function point(t, e) {
            var n = NaN;

            if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
              switch (this._point) {
                case 0:
                  this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                  break;

                case 1:
                  this._point = 2;
                  break;

                case 2:
                  this._point = 3, Tw(this, kw(this, n = ww(this, t, e)), n);
                  break;

                default:
                  Tw(this, this._t0, n = ww(this, t, e));
              }

              this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
            }
          }
        }, (Cw.prototype = Object.create(Ew.prototype)).point = function (t, e) {
          Ew.prototype.point.call(this, e, t);
        }, Sw.prototype = {
          moveTo: function moveTo(t, e) {
            this._context.moveTo(e, t);
          },
          closePath: function closePath() {
            this._context.closePath();
          },
          lineTo: function lineTo(t, e) {
            this._context.lineTo(e, t);
          },
          bezierCurveTo: function bezierCurveTo(t, e, n, r, i, a) {
            this._context.bezierCurveTo(e, t, r, n, a, i);
          }
        }, Nw.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x = [], this._y = [];
          },
          lineEnd: function lineEnd() {
            var t = this._x,
                e = this._y,
                n = t.length;
            if (n) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === n) this._context.lineTo(t[1], e[1]);else for (var r = Dw(t), i = Dw(e), a = 0, o = 1; o < n; ++a, ++o) {
              this._context.bezierCurveTo(r[0][a], i[0][a], r[1][a], i[1][a], t[o], e[o]);
            }
            (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
          },
          point: function point(t, e) {
            this._x.push(+t), this._y.push(+e);
          }
        }, Bw.prototype = {
          areaStart: function areaStart() {
            this._line = 0;
          },
          areaEnd: function areaEnd() {
            this._line = NaN;
          },
          lineStart: function lineStart() {
            this._x = this._y = NaN, this._point = 0;
          },
          lineEnd: function lineEnd() {
            0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
          },
          point: function point(t, e) {
            switch (t = +t, e = +e, this._point) {
              case 0:
                this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
                break;

              case 1:
                this._point = 2;

              default:
                if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
                  var n = this._x * (1 - this._t) + t * this._t;
                  this._context.lineTo(n, this._y), this._context.lineTo(n, e);
                }
            }

            this._x = t, this._y = e;
          }
        };
        var Qw = "%Y-%m-%dT%H:%M:%S.%LZ";
        var Jw = Date.prototype.toISOString ? function (t) {
          return t.toISOString();
        } : sm(Qw);
        var tk = +new Date("2000-01-01T00:00:00.000Z") ? function (t) {
          var e = new Date(t);
          return isNaN(e) ? null : e;
        } : cm(Qw);

        function ek(t, e, n) {
          var r = new Hn(),
              i = e;
          return null == e ? (r.restart(t, e, n), r) : (e = +e, n = null == n ? qn() : +n, r.restart(function a(o) {
            o += i, r.restart(a, i += e, n), t(o);
          }, e, n), r);
        }

        function nk(t) {
          return function () {
            return t;
          };
        }

        function rk(t) {
          return t[0];
        }

        function ik(t) {
          return t[1];
        }

        function ak() {
          this._ = null;
        }

        function ok(t) {
          t.U = t.C = t.L = t.R = t.P = t.N = null;
        }

        function sk(t, e) {
          var n = e,
              r = e.R,
              i = n.U;
          i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
        }

        function ck(t, e) {
          var n = e,
              r = e.L,
              i = n.U;
          i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
        }

        function uk(t) {
          for (; t.L;) {
            t = t.L;
          }

          return t;
        }

        ak.prototype = {
          constructor: ak,
          insert: function insert(t, e) {
            var n, r, i;

            if (t) {
              if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
                for (t = t.R; t.L;) {
                  t = t.L;
                }

                t.L = e;
              } else t.R = e;

              n = t;
            } else this._ ? (t = uk(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);

            for (e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;) {
              n === (r = n.U).L ? (i = r.R) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.R && (sk(this, n), n = (t = n).U), n.C = !1, r.C = !0, ck(this, r)) : (i = r.L) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.L && (ck(this, n), n = (t = n).U), n.C = !1, r.C = !0, sk(this, r)), n = t.U;
            }

            this._.C = !1;
          },
          remove: function remove(t) {
            t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
            var e,
                n,
                r,
                i = t.U,
                a = t.L,
                o = t.R;
            if (n = a ? o ? uk(o) : a : o, i ? i.L === t ? i.L = n : i.R = n : this._ = n, a && o ? (r = n.C, n.C = t.C, n.L = a, a.U = n, n !== o ? (i = n.U, n.U = t.U, t = n.R, i.L = t, n.R = o, o.U = n) : (n.U = i, i = n, t = n.R)) : (r = t.C, t = n), t && (t.U = i), !r) if (t && t.C) t.C = !1;else {
              do {
                if (t === this._) break;

                if (t === i.L) {
                  if ((e = i.R).C && (e.C = !1, i.C = !0, sk(this, i), e = i.R), e.L && e.L.C || e.R && e.R.C) {
                    e.R && e.R.C || (e.L.C = !1, e.C = !0, ck(this, e), e = i.R), e.C = i.C, i.C = e.R.C = !1, sk(this, i), t = this._;
                    break;
                  }
                } else if ((e = i.L).C && (e.C = !1, i.C = !0, ck(this, i), e = i.L), e.L && e.L.C || e.R && e.R.C) {
                  e.L && e.L.C || (e.R.C = !1, e.C = !0, sk(this, e), e = i.L), e.C = i.C, i.C = e.L.C = !1, ck(this, i), t = this._;
                  break;
                }

                e.C = !0, t = i, i = i.U;
              } while (!t.C);

              t && (t.C = !1);
            }
          }
        };
        var lk = ak;

        function hk(t, e, n, r) {
          var i = [null, null],
              a = Ik.push(i) - 1;
          return i.left = t, i.right = e, n && dk(i, t, e, n), r && dk(i, e, t, r), Bk[t.index].halfedges.push(a), Bk[e.index].halfedges.push(a), i;
        }

        function fk(t, e, n) {
          var r = [e, n];
          return r.left = t, r;
        }

        function dk(t, e, n, r) {
          t[0] || t[1] ? t.left === n ? t[1] = r : t[0] = r : (t[0] = r, t.left = e, t.right = n);
        }

        function pk(t, e, n, r, i) {
          var a,
              o = t[0],
              s = t[1],
              c = o[0],
              u = o[1],
              l = 0,
              h = 1,
              f = s[0] - c,
              d = s[1] - u;

          if (a = e - c, f || !(a > 0)) {
            if (a /= f, f < 0) {
              if (a < l) return;
              a < h && (h = a);
            } else if (f > 0) {
              if (a > h) return;
              a > l && (l = a);
            }

            if (a = r - c, f || !(a < 0)) {
              if (a /= f, f < 0) {
                if (a > h) return;
                a > l && (l = a);
              } else if (f > 0) {
                if (a < l) return;
                a < h && (h = a);
              }

              if (a = n - u, d || !(a > 0)) {
                if (a /= d, d < 0) {
                  if (a < l) return;
                  a < h && (h = a);
                } else if (d > 0) {
                  if (a > h) return;
                  a > l && (l = a);
                }

                if (a = i - u, d || !(a < 0)) {
                  if (a /= d, d < 0) {
                    if (a > h) return;
                    a > l && (l = a);
                  } else if (d > 0) {
                    if (a < l) return;
                    a < h && (h = a);
                  }

                  return !(l > 0 || h < 1) || (l > 0 && (t[0] = [c + l * f, u + l * d]), h < 1 && (t[1] = [c + h * f, u + h * d]), !0);
                }
              }
            }
          }
        }

        function yk(t, e, n, r, i) {
          var a = t[1];
          if (a) return !0;
          var o,
              s,
              c = t[0],
              u = t.left,
              l = t.right,
              h = u[0],
              f = u[1],
              d = l[0],
              p = l[1],
              y = (h + d) / 2,
              g = (f + p) / 2;

          if (p === f) {
            if (y < e || y >= r) return;

            if (h > d) {
              if (c) {
                if (c[1] >= i) return;
              } else c = [y, n];

              a = [y, i];
            } else {
              if (c) {
                if (c[1] < n) return;
              } else c = [y, i];

              a = [y, n];
            }
          } else if (s = g - (o = (h - d) / (p - f)) * y, o < -1 || o > 1) {
            if (h > d) {
              if (c) {
                if (c[1] >= i) return;
              } else c = [(n - s) / o, n];

              a = [(i - s) / o, i];
            } else {
              if (c) {
                if (c[1] < n) return;
              } else c = [(i - s) / o, i];

              a = [(n - s) / o, n];
            }
          } else if (f < p) {
            if (c) {
              if (c[0] >= r) return;
            } else c = [e, o * e + s];

            a = [r, o * r + s];
          } else {
            if (c) {
              if (c[0] < e) return;
            } else c = [r, o * r + s];

            a = [e, o * e + s];
          }

          return t[0] = c, t[1] = a, !0;
        }

        function gk(t, e) {
          var n = t.site,
              r = e.left,
              i = e.right;
          return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = e[1], i = e[0]) : (r = e[0], i = e[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
        }

        function mk(t, e) {
          return e[+(e.left !== t.site)];
        }

        function vk(t, e) {
          return e[+(e.left === t.site)];
        }

        var bk,
            _k = [];

        function xk() {
          ok(this), this.x = this.y = this.arc = this.site = this.cy = null;
        }

        function wk(t) {
          var e = t.P,
              n = t.N;

          if (e && n) {
            var r = e.site,
                i = t.site,
                a = n.site;

            if (r !== a) {
              var o = i[0],
                  s = i[1],
                  c = r[0] - o,
                  u = r[1] - s,
                  l = a[0] - o,
                  h = a[1] - s,
                  f = 2 * (c * h - u * l);

              if (!(f >= -Pk)) {
                var d = c * c + u * u,
                    p = l * l + h * h,
                    y = (h * d - u * p) / f,
                    g = (c * p - l * d) / f,
                    m = _k.pop() || new xk();
                m.arc = t, m.site = i, m.x = y + o, m.y = (m.cy = g + s) + Math.sqrt(y * y + g * g), t.circle = m;

                for (var v = null, b = Lk._; b;) {
                  if (m.y < b.y || m.y === b.y && m.x <= b.x) {
                    if (!b.L) {
                      v = b.P;
                      break;
                    }

                    b = b.L;
                  } else {
                    if (!b.R) {
                      v = b;
                      break;
                    }

                    b = b.R;
                  }
                }

                Lk.insert(v, m), v || (bk = m);
              }
            }
          }
        }

        function kk(t) {
          var e = t.circle;
          e && (e.P || (bk = e.N), Lk.remove(e), _k.push(e), ok(e), t.circle = null);
        }

        var Tk = [];

        function Ek() {
          ok(this), this.edge = this.site = this.circle = null;
        }

        function Ck(t) {
          var e = Tk.pop() || new Ek();
          return e.site = t, e;
        }

        function Sk(t) {
          kk(t), Ok.remove(t), Tk.push(t), ok(t);
        }

        function Ak(t) {
          var e = t.circle,
              n = e.x,
              r = e.cy,
              i = [n, r],
              a = t.P,
              o = t.N,
              s = [t];
          Sk(t);

          for (var c = a; c.circle && Math.abs(n - c.circle.x) < Rk && Math.abs(r - c.circle.cy) < Rk;) {
            a = c.P, s.unshift(c), Sk(c), c = a;
          }

          s.unshift(c), kk(c);

          for (var u = o; u.circle && Math.abs(n - u.circle.x) < Rk && Math.abs(r - u.circle.cy) < Rk;) {
            o = u.N, s.push(u), Sk(u), u = o;
          }

          s.push(u), kk(u);
          var l,
              h = s.length;

          for (l = 1; l < h; ++l) {
            u = s[l], c = s[l - 1], dk(u.edge, c.site, u.site, i);
          }

          c = s[0], (u = s[h - 1]).edge = hk(c.site, u.site, null, i), wk(c), wk(u);
        }

        function Mk(t) {
          for (var e, n, r, i, a = t[0], o = t[1], s = Ok._; s;) {
            if ((r = Nk(s, o) - a) > Rk) s = s.L;else {
              if (!((i = a - Dk(s, o)) > Rk)) {
                r > -Rk ? (e = s.P, n = s) : i > -Rk ? (e = s, n = s.N) : e = n = s;
                break;
              }

              if (!s.R) {
                e = s;
                break;
              }

              s = s.R;
            }
          }

          !function (t) {
            Bk[t.index] = {
              site: t,
              halfedges: []
            };
          }(t);
          var c = Ck(t);

          if (Ok.insert(e, c), e || n) {
            if (e === n) return kk(e), n = Ck(e.site), Ok.insert(c, n), c.edge = n.edge = hk(e.site, c.site), wk(e), void wk(n);

            if (n) {
              kk(e), kk(n);
              var u = e.site,
                  l = u[0],
                  h = u[1],
                  f = t[0] - l,
                  d = t[1] - h,
                  p = n.site,
                  y = p[0] - l,
                  g = p[1] - h,
                  m = 2 * (f * g - d * y),
                  v = f * f + d * d,
                  b = y * y + g * g,
                  _ = [(g * v - d * b) / m + l, (f * b - y * v) / m + h];
              dk(n.edge, u, p, _), c.edge = hk(u, t, null, _), n.edge = hk(t, p, null, _), wk(e), wk(n);
            } else c.edge = hk(e.site, c.site);
          }
        }

        function Nk(t, e) {
          var n = t.site,
              r = n[0],
              i = n[1],
              a = i - e;
          if (!a) return r;
          var o = t.P;
          if (!o) return -1 / 0;
          var s = (n = o.site)[0],
              c = n[1],
              u = c - e;
          if (!u) return s;
          var l = s - r,
              h = 1 / a - 1 / u,
              f = l / u;
          return h ? (-f + Math.sqrt(f * f - 2 * h * (l * l / (-2 * u) - c + u / 2 + i - a / 2))) / h + r : (r + s) / 2;
        }

        function Dk(t, e) {
          var n = t.N;
          if (n) return Nk(n, e);
          var r = t.site;
          return r[1] === e ? r[0] : 1 / 0;
        }

        var Ok,
            Bk,
            Lk,
            Ik,
            Rk = 1e-6,
            Pk = 1e-12;

        function Fk(t, e, n) {
          return (t[0] - n[0]) * (e[1] - t[1]) - (t[0] - e[0]) * (n[1] - t[1]);
        }

        function jk(t, e) {
          return e[1] - t[1] || e[0] - t[0];
        }

        function Yk(t, e) {
          var n,
              r,
              i,
              a = t.sort(jk).pop();

          for (Ik = [], Bk = new Array(t.length), Ok = new lk(), Lk = new lk();;) {
            if (i = bk, a && (!i || a[1] < i.y || a[1] === i.y && a[0] < i.x)) a[0] === n && a[1] === r || (Mk(a), n = a[0], r = a[1]), a = t.pop();else {
              if (!i) break;
              Ak(i.arc);
            }
          }

          if (function () {
            for (var t, e, n, r, i = 0, a = Bk.length; i < a; ++i) {
              if ((t = Bk[i]) && (r = (e = t.halfedges).length)) {
                var o = new Array(r),
                    s = new Array(r);

                for (n = 0; n < r; ++n) {
                  o[n] = n, s[n] = gk(t, Ik[e[n]]);
                }

                for (o.sort(function (t, e) {
                  return s[e] - s[t];
                }), n = 0; n < r; ++n) {
                  s[n] = e[o[n]];
                }

                for (n = 0; n < r; ++n) {
                  e[n] = s[n];
                }
              }
            }
          }(), e) {
            var o = +e[0][0],
                s = +e[0][1],
                c = +e[1][0],
                u = +e[1][1];
            !function (t, e, n, r) {
              for (var i, a = Ik.length; a--;) {
                yk(i = Ik[a], t, e, n, r) && pk(i, t, e, n, r) && (Math.abs(i[0][0] - i[1][0]) > Rk || Math.abs(i[0][1] - i[1][1]) > Rk) || delete Ik[a];
              }
            }(o, s, c, u), function (t, e, n, r) {
              var i,
                  a,
                  o,
                  s,
                  c,
                  u,
                  l,
                  h,
                  f,
                  d,
                  p,
                  y,
                  g = Bk.length,
                  m = !0;

              for (i = 0; i < g; ++i) {
                if (a = Bk[i]) {
                  for (o = a.site, s = (c = a.halfedges).length; s--;) {
                    Ik[c[s]] || c.splice(s, 1);
                  }

                  for (s = 0, u = c.length; s < u;) {
                    p = (d = vk(a, Ik[c[s]]))[0], y = d[1], h = (l = mk(a, Ik[c[++s % u]]))[0], f = l[1], (Math.abs(p - h) > Rk || Math.abs(y - f) > Rk) && (c.splice(s, 0, Ik.push(fk(o, d, Math.abs(p - t) < Rk && r - y > Rk ? [t, Math.abs(h - t) < Rk ? f : r] : Math.abs(y - r) < Rk && n - p > Rk ? [Math.abs(f - r) < Rk ? h : n, r] : Math.abs(p - n) < Rk && y - e > Rk ? [n, Math.abs(h - n) < Rk ? f : e] : Math.abs(y - e) < Rk && p - t > Rk ? [Math.abs(f - e) < Rk ? h : t, e] : null)) - 1), ++u);
                  }

                  u && (m = !1);
                }
              }

              if (m) {
                var v,
                    b,
                    _,
                    x = 1 / 0;

                for (i = 0, m = null; i < g; ++i) {
                  (a = Bk[i]) && (_ = (v = (o = a.site)[0] - t) * v + (b = o[1] - e) * b) < x && (x = _, m = a);
                }

                if (m) {
                  var w = [t, e],
                      k = [t, r],
                      T = [n, r],
                      E = [n, e];
                  m.halfedges.push(Ik.push(fk(o = m.site, w, k)) - 1, Ik.push(fk(o, k, T)) - 1, Ik.push(fk(o, T, E)) - 1, Ik.push(fk(o, E, w)) - 1);
                }
              }

              for (i = 0; i < g; ++i) {
                (a = Bk[i]) && (a.halfedges.length || delete Bk[i]);
              }
            }(o, s, c, u);
          }

          this.edges = Ik, this.cells = Bk, Ok = Lk = Ik = Bk = null;
        }

        function Uk() {
          var t = rk,
              e = ik,
              n = null;

          function r(r) {
            return new Yk(r.map(function (n, i) {
              var a = [Math.round(t(n, i, r) / Rk) * Rk, Math.round(e(n, i, r) / Rk) * Rk];
              return a.index = i, a.data = n, a;
            }), n);
          }

          return r.polygons = function (t) {
            return r(t).polygons();
          }, r.links = function (t) {
            return r(t).links();
          }, r.triangles = function (t) {
            return r(t).triangles();
          }, r.x = function (e) {
            return arguments.length ? (t = "function" == typeof e ? e : nk(+e), r) : t;
          }, r.y = function (t) {
            return arguments.length ? (e = "function" == typeof t ? t : nk(+t), r) : e;
          }, r.extent = function (t) {
            return arguments.length ? (n = null == t ? null : [[+t[0][0], +t[0][1]], [+t[1][0], +t[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
          }, r.size = function (t) {
            return arguments.length ? (n = null == t ? null : [[0, 0], [+t[0], +t[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
          }, r;
        }

        function zk(t) {
          return function () {
            return t;
          };
        }

        function qk(t, e, n) {
          this.target = t, this.type = e, this.transform = n;
        }

        function $k(t, e, n) {
          this.k = t, this.x = e, this.y = n;
        }

        Yk.prototype = {
          constructor: Yk,
          polygons: function polygons() {
            var t = this.edges;
            return this.cells.map(function (e) {
              var n = e.halfedges.map(function (n) {
                return mk(e, t[n]);
              });
              return n.data = e.site.data, n;
            });
          },
          triangles: function triangles() {
            var t = [],
                e = this.edges;
            return this.cells.forEach(function (n, r) {
              if (a = (i = n.halfedges).length) for (var i, a, o, s = n.site, c = -1, u = e[i[a - 1]], l = u.left === s ? u.right : u.left; ++c < a;) {
                o = l, l = (u = e[i[c]]).left === s ? u.right : u.left, o && l && r < o.index && r < l.index && Fk(s, o, l) < 0 && t.push([s.data, o.data, l.data]);
              }
            }), t;
          },
          links: function links() {
            return this.edges.filter(function (t) {
              return t.right;
            }).map(function (t) {
              return {
                source: t.left.data,
                target: t.right.data
              };
            });
          },
          find: function find(t, e, n) {
            for (var r, i, a = this, o = a._found || 0, s = a.cells.length; !(i = a.cells[o]);) {
              if (++o >= s) return null;
            }

            var c = t - i.site[0],
                u = e - i.site[1],
                l = c * c + u * u;

            do {
              i = a.cells[r = o], o = null, i.halfedges.forEach(function (n) {
                var r = a.edges[n],
                    s = r.left;

                if (s !== i.site && s || (s = r.right)) {
                  var c = t - s[0],
                      u = e - s[1],
                      h = c * c + u * u;
                  h < l && (l = h, o = s.index);
                }
              });
            } while (null !== o);

            return a._found = r, null == n || l <= n * n ? i.site : null;
          }
        }, $k.prototype = {
          constructor: $k,
          scale: function scale(t) {
            return 1 === t ? this : new $k(this.k * t, this.x, this.y);
          },
          translate: function translate(t, e) {
            return 0 === t & 0 === e ? this : new $k(this.k, this.x + this.k * t, this.y + this.k * e);
          },
          apply: function apply(t) {
            return [t[0] * this.k + this.x, t[1] * this.k + this.y];
          },
          applyX: function applyX(t) {
            return t * this.k + this.x;
          },
          applyY: function applyY(t) {
            return t * this.k + this.y;
          },
          invert: function invert(t) {
            return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
          },
          invertX: function invertX(t) {
            return (t - this.x) / this.k;
          },
          invertY: function invertY(t) {
            return (t - this.y) / this.k;
          },
          rescaleX: function rescaleX(t) {
            return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
          },
          rescaleY: function rescaleY(t) {
            return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
          },
          toString: function toString() {
            return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
          }
        };
        var Hk = new $k(1, 0, 0);

        function Wk(t) {
          for (; !t.__zoom;) {
            if (!(t = t.parentNode)) return Hk;
          }

          return t.__zoom;
        }

        function Vk() {
          le.stopImmediatePropagation();
        }

        function Gk() {
          le.preventDefault(), le.stopImmediatePropagation();
        }

        function Xk() {
          return !le.ctrlKey && !le.button;
        }

        function Zk() {
          var t = this;
          return t instanceof SVGElement ? (t = t.ownerSVGElement || t).hasAttribute("viewBox") ? [[(t = t.viewBox.baseVal).x, t.y], [t.x + t.width, t.y + t.height]] : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]] : [[0, 0], [t.clientWidth, t.clientHeight]];
        }

        function Kk() {
          return this.__zoom || Hk;
        }

        function Qk() {
          return -le.deltaY * (1 === le.deltaMode ? .05 : le.deltaMode ? 1 : .002);
        }

        function Jk() {
          return navigator.maxTouchPoints || "ontouchstart" in this;
        }

        function tT(t, e, n) {
          var r = t.invertX(e[0][0]) - n[0][0],
              i = t.invertX(e[1][0]) - n[1][0],
              a = t.invertY(e[0][1]) - n[0][1],
              o = t.invertY(e[1][1]) - n[1][1];
          return t.translate(i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i), o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o));
        }

        function eT() {
          var t,
              e,
              n = Xk,
              r = Zk,
              i = tT,
              a = Qk,
              o = Jk,
              s = [0, 1 / 0],
              c = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]],
              u = 250,
              l = Ep,
              h = ft("start", "zoom", "end"),
              f = 500,
              d = 0;

          function p(t) {
            t.property("__zoom", Kk).on("wheel.zoom", x).on("mousedown.zoom", w).on("dblclick.zoom", k).filter(o).on("touchstart.zoom", T).on("touchmove.zoom", E).on("touchend.zoom touchcancel.zoom", C).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
          }

          function y(t, e) {
            return (e = Math.max(s[0], Math.min(s[1], e))) === t.k ? t : new $k(e, t.x, t.y);
          }

          function g(t, e, n) {
            var r = e[0] - n[0] * t.k,
                i = e[1] - n[1] * t.k;
            return r === t.x && i === t.y ? t : new $k(t.k, r, i);
          }

          function m(t) {
            return [(+t[0][0] + +t[1][0]) / 2, (+t[0][1] + +t[1][1]) / 2];
          }

          function v(t, e, n) {
            t.on("start.zoom", function () {
              b(this, arguments).start();
            }).on("interrupt.zoom end.zoom", function () {
              b(this, arguments).end();
            }).tween("zoom", function () {
              var t = this,
                  i = arguments,
                  a = b(t, i),
                  o = r.apply(t, i),
                  s = null == n ? m(o) : "function" == typeof n ? n.apply(t, i) : n,
                  c = Math.max(o[1][0] - o[0][0], o[1][1] - o[0][1]),
                  u = t.__zoom,
                  h = "function" == typeof e ? e.apply(t, i) : e,
                  f = l(u.invert(s).concat(c / u.k), h.invert(s).concat(c / h.k));
              return function (t) {
                if (1 === t) t = h;else {
                  var e = f(t),
                      n = c / e[2];
                  t = new $k(n, s[0] - e[0] * n, s[1] - e[1] * n);
                }
                a.zoom(null, t);
              };
            });
          }

          function b(t, e, n) {
            return !n && t.__zooming || new _(t, e);
          }

          function _(t, e) {
            this.that = t, this.args = e, this.active = 0, this.extent = r.apply(t, e), this.taps = 0;
          }

          function x() {
            if (n.apply(this, arguments)) {
              var t = b(this, arguments),
                  e = this.__zoom,
                  r = Math.max(s[0], Math.min(s[1], e.k * Math.pow(2, a.apply(this, arguments)))),
                  o = On(this);
              if (t.wheel) t.mouse[0][0] === o[0] && t.mouse[0][1] === o[1] || (t.mouse[1] = e.invert(t.mouse[0] = o)), clearTimeout(t.wheel);else {
                if (e.k === r) return;
                t.mouse = [o, e.invert(o)], ir(this), t.start();
              }
              Gk(), t.wheel = setTimeout(u, 150), t.zoom("mouse", i(g(y(e, r), t.mouse[0], t.mouse[1]), t.extent, c));
            }

            function u() {
              t.wheel = null, t.end();
            }
          }

          function w() {
            if (!e && n.apply(this, arguments)) {
              var t = b(this, arguments, !0),
                  r = Te(le.view).on("mousemove.zoom", u, !0).on("mouseup.zoom", l, !0),
                  a = On(this),
                  o = le.clientX,
                  s = le.clientY;
              Se(le.view), Vk(), t.mouse = [a, this.__zoom.invert(a)], ir(this), t.start();
            }

            function u() {
              if (Gk(), !t.moved) {
                var e = le.clientX - o,
                    n = le.clientY - s;
                t.moved = e * e + n * n > d;
              }

              t.zoom("mouse", i(g(t.that.__zoom, t.mouse[0] = On(t.that), t.mouse[1]), t.extent, c));
            }

            function l() {
              r.on("mousemove.zoom mouseup.zoom", null), Ae(le.view, t.moved), Gk(), t.end();
            }
          }

          function k() {
            if (n.apply(this, arguments)) {
              var t = this.__zoom,
                  e = On(this),
                  a = t.invert(e),
                  o = t.k * (le.shiftKey ? .5 : 2),
                  s = i(g(y(t, o), e, a), r.apply(this, arguments), c);
              Gk(), u > 0 ? Te(this).transition().duration(u).call(v, s, e) : Te(this).call(p.transform, s);
            }
          }

          function T() {
            if (n.apply(this, arguments)) {
              var e,
                  r,
                  i,
                  a,
                  o = le.touches,
                  s = o.length,
                  c = b(this, arguments, le.changedTouches.length === s);

              for (Vk(), r = 0; r < s; ++r) {
                a = [a = Dn(this, o, (i = o[r]).identifier), this.__zoom.invert(a), i.identifier], c.touch0 ? c.touch1 || c.touch0[2] === a[2] || (c.touch1 = a, c.taps = 0) : (c.touch0 = a, e = !0, c.taps = 1 + !!t);
              }

              t && (t = clearTimeout(t)), e && (c.taps < 2 && (t = setTimeout(function () {
                t = null;
              }, f)), ir(this), c.start());
            }
          }

          function E() {
            if (this.__zooming) {
              var e,
                  n,
                  r,
                  a,
                  o = b(this, arguments),
                  s = le.changedTouches,
                  u = s.length;

              for (Gk(), t && (t = clearTimeout(t)), o.taps = 0, e = 0; e < u; ++e) {
                r = Dn(this, s, (n = s[e]).identifier), o.touch0 && o.touch0[2] === n.identifier ? o.touch0[0] = r : o.touch1 && o.touch1[2] === n.identifier && (o.touch1[0] = r);
              }

              if (n = o.that.__zoom, o.touch1) {
                var l = o.touch0[0],
                    h = o.touch0[1],
                    f = o.touch1[0],
                    d = o.touch1[1],
                    p = (p = f[0] - l[0]) * p + (p = f[1] - l[1]) * p,
                    m = (m = d[0] - h[0]) * m + (m = d[1] - h[1]) * m;
                n = y(n, Math.sqrt(p / m)), r = [(l[0] + f[0]) / 2, (l[1] + f[1]) / 2], a = [(h[0] + d[0]) / 2, (h[1] + d[1]) / 2];
              } else {
                if (!o.touch0) return;
                r = o.touch0[0], a = o.touch0[1];
              }

              o.zoom("touch", i(g(n, r, a), o.extent, c));
            }
          }

          function C() {
            if (this.__zooming) {
              var t,
                  n,
                  r = b(this, arguments),
                  i = le.changedTouches,
                  a = i.length;

              for (Vk(), e && clearTimeout(e), e = setTimeout(function () {
                e = null;
              }, f), t = 0; t < a; ++t) {
                n = i[t], r.touch0 && r.touch0[2] === n.identifier ? delete r.touch0 : r.touch1 && r.touch1[2] === n.identifier && delete r.touch1;
              }

              if (r.touch1 && !r.touch0 && (r.touch0 = r.touch1, delete r.touch1), r.touch0) r.touch0[1] = this.__zoom.invert(r.touch0[0]);else if (r.end(), 2 === r.taps) {
                var o = Te(this).on("dblclick.zoom");
                o && o.apply(this, arguments);
              }
            }
          }

          return p.transform = function (t, e, n) {
            var r = t.selection ? t.selection() : t;
            r.property("__zoom", Kk), t !== r ? v(t, e, n) : r.interrupt().each(function () {
              b(this, arguments).start().zoom(null, "function" == typeof e ? e.apply(this, arguments) : e).end();
            });
          }, p.scaleBy = function (t, e, n) {
            p.scaleTo(t, function () {
              var t = this.__zoom.k,
                  n = "function" == typeof e ? e.apply(this, arguments) : e;
              return t * n;
            }, n);
          }, p.scaleTo = function (t, e, n) {
            p.transform(t, function () {
              var t = r.apply(this, arguments),
                  a = this.__zoom,
                  o = null == n ? m(t) : "function" == typeof n ? n.apply(this, arguments) : n,
                  s = a.invert(o),
                  u = "function" == typeof e ? e.apply(this, arguments) : e;
              return i(g(y(a, u), o, s), t, c);
            }, n);
          }, p.translateBy = function (t, e, n) {
            p.transform(t, function () {
              return i(this.__zoom.translate("function" == typeof e ? e.apply(this, arguments) : e, "function" == typeof n ? n.apply(this, arguments) : n), r.apply(this, arguments), c);
            });
          }, p.translateTo = function (t, e, n, a) {
            p.transform(t, function () {
              var t = r.apply(this, arguments),
                  o = this.__zoom,
                  s = null == a ? m(t) : "function" == typeof a ? a.apply(this, arguments) : a;
              return i(Hk.translate(s[0], s[1]).scale(o.k).translate("function" == typeof e ? -e.apply(this, arguments) : -e, "function" == typeof n ? -n.apply(this, arguments) : -n), t, c);
            }, a);
          }, _.prototype = {
            start: function start() {
              return 1 == ++this.active && (this.that.__zooming = this, this.emit("start")), this;
            },
            zoom: function zoom(t, e) {
              return this.mouse && "mouse" !== t && (this.mouse[1] = e.invert(this.mouse[0])), this.touch0 && "touch" !== t && (this.touch0[1] = e.invert(this.touch0[0])), this.touch1 && "touch" !== t && (this.touch1[1] = e.invert(this.touch1[0])), this.that.__zoom = e, this.emit("zoom"), this;
            },
            end: function end() {
              return 0 == --this.active && (delete this.that.__zooming, this.emit("end")), this;
            },
            emit: function emit(t) {
              ge(new qk(p, t, this.that.__zoom), h.apply, h, [t, this.that, this.args]);
            }
          }, p.wheelDelta = function (t) {
            return arguments.length ? (a = "function" == typeof t ? t : zk(+t), p) : a;
          }, p.filter = function (t) {
            return arguments.length ? (n = "function" == typeof t ? t : zk(!!t), p) : n;
          }, p.touchable = function (t) {
            return arguments.length ? (o = "function" == typeof t ? t : zk(!!t), p) : o;
          }, p.extent = function (t) {
            return arguments.length ? (r = "function" == typeof t ? t : zk([[+t[0][0], +t[0][1]], [+t[1][0], +t[1][1]]]), p) : r;
          }, p.scaleExtent = function (t) {
            return arguments.length ? (s[0] = +t[0], s[1] = +t[1], p) : [s[0], s[1]];
          }, p.translateExtent = function (t) {
            return arguments.length ? (c[0][0] = +t[0][0], c[1][0] = +t[1][0], c[0][1] = +t[0][1], c[1][1] = +t[1][1], p) : [[c[0][0], c[0][1]], [c[1][0], c[1][1]]];
          }, p.constrain = function (t) {
            return arguments.length ? (i = t, p) : i;
          }, p.duration = function (t) {
            return arguments.length ? (u = +t, p) : u;
          }, p.interpolate = function (t) {
            return arguments.length ? (l = t, p) : l;
          }, p.on = function () {
            var t = h.on.apply(h, arguments);
            return t === h ? p : t;
          }, p.clickDistance = function (t) {
            return arguments.length ? (d = (t = +t) * t, p) : Math.sqrt(d);
          }, p;
        }

        Wk.prototype = $k.prototype;
      },
      681: function _(t, e, n) {
        t.exports = {
          graphlib: n(574),
          layout: n(8123),
          debug: n(7570),
          util: {
            time: n(1138).time,
            notime: n(1138).notime
          },
          version: n(8177)
        };
      },
      2188: function _(t, e, n) {
        var r = n(8436),
            i = n(4079);
        t.exports = {
          run: function run(t) {
            var e = "greedy" === t.graph().acyclicer ? i(t, function (t) {
              return function (e) {
                return t.edge(e).weight;
              };
            }(t)) : function (t) {
              var e = [],
                  n = {},
                  i = {};
              return r.forEach(t.nodes(), function a(o) {
                r.has(i, o) || (i[o] = !0, n[o] = !0, r.forEach(t.outEdges(o), function (t) {
                  r.has(n, t.w) ? e.push(t) : a(t.w);
                }), delete n[o]);
              }), e;
            }(t);
            r.forEach(e, function (e) {
              var n = t.edge(e);
              t.removeEdge(e), n.forwardName = e.name, n.reversed = !0, t.setEdge(e.w, e.v, n, r.uniqueId("rev"));
            });
          },
          undo: function undo(t) {
            r.forEach(t.edges(), function (e) {
              var n = t.edge(e);

              if (n.reversed) {
                t.removeEdge(e);
                var r = n.forwardName;
                delete n.reversed, delete n.forwardName, t.setEdge(e.w, e.v, n, r);
              }
            });
          }
        };
      },
      1133: function _(t, e, n) {
        var r = n(8436),
            i = n(1138);

        function a(t, e, n, r, a, o) {
          var s = {
            width: 0,
            height: 0,
            rank: o,
            borderType: e
          },
              c = a[e][o - 1],
              u = i.addDummyNode(t, "border", s, n);
          a[e][o] = u, t.setParent(u, r), c && t.setEdge(c, u, {
            weight: 1
          });
        }

        t.exports = function (t) {
          r.forEach(t.children(), function e(n) {
            var i = t.children(n),
                o = t.node(n);

            if (i.length && r.forEach(i, e), r.has(o, "minRank")) {
              o.borderLeft = [], o.borderRight = [];

              for (var s = o.minRank, c = o.maxRank + 1; s < c; ++s) {
                a(t, "borderLeft", "_bl", n, o, s), a(t, "borderRight", "_br", n, o, s);
              }
            }
          });
        };
      },
      3258: function _(t, e, n) {
        var r = n(8436);

        function i(t) {
          r.forEach(t.nodes(), function (e) {
            a(t.node(e));
          }), r.forEach(t.edges(), function (e) {
            a(t.edge(e));
          });
        }

        function a(t) {
          var e = t.width;
          t.width = t.height, t.height = e;
        }

        function o(t) {
          t.y = -t.y;
        }

        function s(t) {
          var e = t.x;
          t.x = t.y, t.y = e;
        }

        t.exports = {
          adjust: function adjust(t) {
            var e = t.graph().rankdir.toLowerCase();
            "lr" !== e && "rl" !== e || i(t);
          },
          undo: function undo(t) {
            var e = t.graph().rankdir.toLowerCase();
            "bt" !== e && "rl" !== e || function (t) {
              r.forEach(t.nodes(), function (e) {
                o(t.node(e));
              }), r.forEach(t.edges(), function (e) {
                var n = t.edge(e);
                r.forEach(n.points, o), r.has(n, "y") && o(n);
              });
            }(t), "lr" !== e && "rl" !== e || (function (t) {
              r.forEach(t.nodes(), function (e) {
                s(t.node(e));
              }), r.forEach(t.edges(), function (e) {
                var n = t.edge(e);
                r.forEach(n.points, s), r.has(n, "x") && s(n);
              });
            }(t), i(t));
          }
        };
      },
      7822: function _(t) {
        function e() {
          var t = {};
          t._next = t._prev = t, this._sentinel = t;
        }

        function n(t) {
          t._prev._next = t._next, t._next._prev = t._prev, delete t._next, delete t._prev;
        }

        function r(t, e) {
          if ("_next" !== t && "_prev" !== t) return e;
        }

        t.exports = e, e.prototype.dequeue = function () {
          var t = this._sentinel,
              e = t._prev;
          if (e !== t) return n(e), e;
        }, e.prototype.enqueue = function (t) {
          var e = this._sentinel;
          t._prev && t._next && n(t), t._next = e._next, e._next._prev = t, e._next = t, t._prev = e;
        }, e.prototype.toString = function () {
          for (var t = [], e = this._sentinel, n = e._prev; n !== e;) {
            t.push(JSON.stringify(n, r)), n = n._prev;
          }

          return "[" + t.join(", ") + "]";
        };
      },
      7570: function _(t, e, n) {
        var r = n(8436),
            i = n(1138),
            a = n(574).Graph;
        t.exports = {
          debugOrdering: function debugOrdering(t) {
            var e = i.buildLayerMatrix(t),
                n = new a({
              compound: !0,
              multigraph: !0
            }).setGraph({});
            return r.forEach(t.nodes(), function (e) {
              n.setNode(e, {
                label: e
              }), n.setParent(e, "layer" + t.node(e).rank);
            }), r.forEach(t.edges(), function (t) {
              n.setEdge(t.v, t.w, {}, t.name);
            }), r.forEach(e, function (t, e) {
              var i = "layer" + e;
              n.setNode(i, {
                rank: "same"
              }), r.reduce(t, function (t, e) {
                return n.setEdge(t, e, {
                  style: "invis"
                }), e;
              });
            }), n;
          }
        };
      },
      574: function _(t, e, n) {
        var r;

        try {
          r = n(8282);
        } catch (t) {}

        r || (r = window.graphlib), t.exports = r;
      },
      4079: function _(t, e, n) {
        var r = n(8436),
            i = n(574).Graph,
            a = n(7822);

        t.exports = function (t, e) {
          if (t.nodeCount() <= 1) return [];

          var n = function (t, e) {
            var n = new i(),
                o = 0,
                s = 0;
            r.forEach(t.nodes(), function (t) {
              n.setNode(t, {
                v: t,
                in: 0,
                out: 0
              });
            }), r.forEach(t.edges(), function (t) {
              var r = n.edge(t.v, t.w) || 0,
                  i = e(t),
                  a = r + i;
              n.setEdge(t.v, t.w, a), s = Math.max(s, n.node(t.v).out += i), o = Math.max(o, n.node(t.w).in += i);
            });
            var u = r.range(s + o + 3).map(function () {
              return new a();
            }),
                l = o + 1;
            return r.forEach(n.nodes(), function (t) {
              c(u, l, n.node(t));
            }), {
              graph: n,
              buckets: u,
              zeroIdx: l
            };
          }(t, e || o),
              u = function (t, e, n) {
            for (var r, i = [], a = e[e.length - 1], o = e[0]; t.nodeCount();) {
              for (; r = o.dequeue();) {
                s(t, e, n, r);
              }

              for (; r = a.dequeue();) {
                s(t, e, n, r);
              }

              if (t.nodeCount()) for (var c = e.length - 2; c > 0; --c) {
                if (r = e[c].dequeue()) {
                  i = i.concat(s(t, e, n, r, !0));
                  break;
                }
              }
            }

            return i;
          }(n.graph, n.buckets, n.zeroIdx);

          return r.flatten(r.map(u, function (e) {
            return t.outEdges(e.v, e.w);
          }), !0);
        };

        var o = r.constant(1);

        function s(t, e, n, i, a) {
          var o = a ? [] : void 0;
          return r.forEach(t.inEdges(i.v), function (r) {
            var i = t.edge(r),
                s = t.node(r.v);
            a && o.push({
              v: r.v,
              w: r.w
            }), s.out -= i, c(e, n, s);
          }), r.forEach(t.outEdges(i.v), function (r) {
            var i = t.edge(r),
                a = r.w,
                o = t.node(a);
            o.in -= i, c(e, n, o);
          }), t.removeNode(i.v), o;
        }

        function c(t, e, n) {
          n.out ? n.in ? t[n.out - n.in + e].enqueue(n) : t[t.length - 1].enqueue(n) : t[0].enqueue(n);
        }
      },
      8123: function _(t, e, n) {
        var r = n(8436),
            i = n(2188),
            a = n(5995),
            o = n(8093),
            s = n(1138).normalizeRanks,
            c = n(4219),
            u = n(1138).removeEmptyRanks,
            l = n(2981),
            h = n(1133),
            f = n(3258),
            d = n(3408),
            p = n(7873),
            y = n(1138),
            g = n(574).Graph;

        t.exports = function (t, e) {
          var n = e && e.debugTiming ? y.time : y.notime;
          n("layout", function () {
            var e = n("  buildLayoutGraph", function () {
              return function (t) {
                var e = new g({
                  multigraph: !0,
                  compound: !0
                }),
                    n = C(t.graph());
                return e.setGraph(r.merge({}, v, E(n, m), r.pick(n, b))), r.forEach(t.nodes(), function (n) {
                  var i = C(t.node(n));
                  e.setNode(n, r.defaults(E(i, _), x)), e.setParent(n, t.parent(n));
                }), r.forEach(t.edges(), function (n) {
                  var i = C(t.edge(n));
                  e.setEdge(n, r.merge({}, k, E(i, w), r.pick(i, T)));
                }), e;
              }(t);
            });
            n("  runLayout", function () {
              !function (t, e) {
                e("    makeSpaceForEdgeLabels", function () {
                  !function (t) {
                    var e = t.graph();
                    e.ranksep /= 2, r.forEach(t.edges(), function (n) {
                      var r = t.edge(n);
                      r.minlen *= 2, "c" !== r.labelpos.toLowerCase() && ("TB" === e.rankdir || "BT" === e.rankdir ? r.width += r.labeloffset : r.height += r.labeloffset);
                    });
                  }(t);
                }), e("    removeSelfEdges", function () {
                  !function (t) {
                    r.forEach(t.edges(), function (e) {
                      if (e.v === e.w) {
                        var n = t.node(e.v);
                        n.selfEdges || (n.selfEdges = []), n.selfEdges.push({
                          e: e,
                          label: t.edge(e)
                        }), t.removeEdge(e);
                      }
                    });
                  }(t);
                }), e("    acyclic", function () {
                  i.run(t);
                }), e("    nestingGraph.run", function () {
                  l.run(t);
                }), e("    rank", function () {
                  o(y.asNonCompoundGraph(t));
                }), e("    injectEdgeLabelProxies", function () {
                  !function (t) {
                    r.forEach(t.edges(), function (e) {
                      var n = t.edge(e);

                      if (n.width && n.height) {
                        var r = t.node(e.v),
                            i = {
                          rank: (t.node(e.w).rank - r.rank) / 2 + r.rank,
                          e: e
                        };
                        y.addDummyNode(t, "edge-proxy", i, "_ep");
                      }
                    });
                  }(t);
                }), e("    removeEmptyRanks", function () {
                  u(t);
                }), e("    nestingGraph.cleanup", function () {
                  l.cleanup(t);
                }), e("    normalizeRanks", function () {
                  s(t);
                }), e("    assignRankMinMax", function () {
                  !function (t) {
                    var e = 0;
                    r.forEach(t.nodes(), function (n) {
                      var i = t.node(n);
                      i.borderTop && (i.minRank = t.node(i.borderTop).rank, i.maxRank = t.node(i.borderBottom).rank, e = r.max(e, i.maxRank));
                    }), t.graph().maxRank = e;
                  }(t);
                }), e("    removeEdgeLabelProxies", function () {
                  !function (t) {
                    r.forEach(t.nodes(), function (e) {
                      var n = t.node(e);
                      "edge-proxy" === n.dummy && (t.edge(n.e).labelRank = n.rank, t.removeNode(e));
                    });
                  }(t);
                }), e("    normalize.run", function () {
                  a.run(t);
                }), e("    parentDummyChains", function () {
                  c(t);
                }), e("    addBorderSegments", function () {
                  h(t);
                }), e("    order", function () {
                  d(t);
                }), e("    insertSelfEdges", function () {
                  !function (t) {
                    var e = y.buildLayerMatrix(t);
                    r.forEach(e, function (e) {
                      var n = 0;
                      r.forEach(e, function (e, i) {
                        var a = t.node(e);
                        a.order = i + n, r.forEach(a.selfEdges, function (e) {
                          y.addDummyNode(t, "selfedge", {
                            width: e.label.width,
                            height: e.label.height,
                            rank: a.rank,
                            order: i + ++n,
                            e: e.e,
                            label: e.label
                          }, "_se");
                        }), delete a.selfEdges;
                      });
                    });
                  }(t);
                }), e("    adjustCoordinateSystem", function () {
                  f.adjust(t);
                }), e("    position", function () {
                  p(t);
                }), e("    positionSelfEdges", function () {
                  !function (t) {
                    r.forEach(t.nodes(), function (e) {
                      var n = t.node(e);

                      if ("selfedge" === n.dummy) {
                        var r = t.node(n.e.v),
                            i = r.x + r.width / 2,
                            a = r.y,
                            o = n.x - i,
                            s = r.height / 2;
                        t.setEdge(n.e, n.label), t.removeNode(e), n.label.points = [{
                          x: i + 2 * o / 3,
                          y: a - s
                        }, {
                          x: i + 5 * o / 6,
                          y: a - s
                        }, {
                          x: i + o,
                          y: a
                        }, {
                          x: i + 5 * o / 6,
                          y: a + s
                        }, {
                          x: i + 2 * o / 3,
                          y: a + s
                        }], n.label.x = n.x, n.label.y = n.y;
                      }
                    });
                  }(t);
                }), e("    removeBorderNodes", function () {
                  !function (t) {
                    r.forEach(t.nodes(), function (e) {
                      if (t.children(e).length) {
                        var n = t.node(e),
                            i = t.node(n.borderTop),
                            a = t.node(n.borderBottom),
                            o = t.node(r.last(n.borderLeft)),
                            s = t.node(r.last(n.borderRight));
                        n.width = Math.abs(s.x - o.x), n.height = Math.abs(a.y - i.y), n.x = o.x + n.width / 2, n.y = i.y + n.height / 2;
                      }
                    }), r.forEach(t.nodes(), function (e) {
                      "border" === t.node(e).dummy && t.removeNode(e);
                    });
                  }(t);
                }), e("    normalize.undo", function () {
                  a.undo(t);
                }), e("    fixupEdgeLabelCoords", function () {
                  !function (t) {
                    r.forEach(t.edges(), function (e) {
                      var n = t.edge(e);
                      if (r.has(n, "x")) switch ("l" !== n.labelpos && "r" !== n.labelpos || (n.width -= n.labeloffset), n.labelpos) {
                        case "l":
                          n.x -= n.width / 2 + n.labeloffset;
                          break;

                        case "r":
                          n.x += n.width / 2 + n.labeloffset;
                      }
                    });
                  }(t);
                }), e("    undoCoordinateSystem", function () {
                  f.undo(t);
                }), e("    translateGraph", function () {
                  !function (t) {
                    var e = Number.POSITIVE_INFINITY,
                        n = 0,
                        i = Number.POSITIVE_INFINITY,
                        a = 0,
                        o = t.graph(),
                        s = o.marginx || 0,
                        c = o.marginy || 0;

                    function u(t) {
                      var r = t.x,
                          o = t.y,
                          s = t.width,
                          c = t.height;
                      e = Math.min(e, r - s / 2), n = Math.max(n, r + s / 2), i = Math.min(i, o - c / 2), a = Math.max(a, o + c / 2);
                    }

                    r.forEach(t.nodes(), function (e) {
                      u(t.node(e));
                    }), r.forEach(t.edges(), function (e) {
                      var n = t.edge(e);
                      r.has(n, "x") && u(n);
                    }), e -= s, i -= c, r.forEach(t.nodes(), function (n) {
                      var r = t.node(n);
                      r.x -= e, r.y -= i;
                    }), r.forEach(t.edges(), function (n) {
                      var a = t.edge(n);
                      r.forEach(a.points, function (t) {
                        t.x -= e, t.y -= i;
                      }), r.has(a, "x") && (a.x -= e), r.has(a, "y") && (a.y -= i);
                    }), o.width = n - e + s, o.height = a - i + c;
                  }(t);
                }), e("    assignNodeIntersects", function () {
                  !function (t) {
                    r.forEach(t.edges(), function (e) {
                      var n,
                          r,
                          i = t.edge(e),
                          a = t.node(e.v),
                          o = t.node(e.w);
                      i.points ? (n = i.points[0], r = i.points[i.points.length - 1]) : (i.points = [], n = o, r = a), i.points.unshift(y.intersectRect(a, n)), i.points.push(y.intersectRect(o, r));
                    });
                  }(t);
                }), e("    reversePoints", function () {
                  !function (t) {
                    r.forEach(t.edges(), function (e) {
                      var n = t.edge(e);
                      n.reversed && n.points.reverse();
                    });
                  }(t);
                }), e("    acyclic.undo", function () {
                  i.undo(t);
                });
              }(e, n);
            }), n("  updateInputGraph", function () {
              !function (t, e) {
                r.forEach(t.nodes(), function (n) {
                  var r = t.node(n),
                      i = e.node(n);
                  r && (r.x = i.x, r.y = i.y, e.children(n).length && (r.width = i.width, r.height = i.height));
                }), r.forEach(t.edges(), function (n) {
                  var i = t.edge(n),
                      a = e.edge(n);
                  i.points = a.points, r.has(a, "x") && (i.x = a.x, i.y = a.y);
                }), t.graph().width = e.graph().width, t.graph().height = e.graph().height;
              }(t, e);
            });
          });
        };

        var m = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"],
            v = {
          ranksep: 50,
          edgesep: 20,
          nodesep: 50,
          rankdir: "tb"
        },
            b = ["acyclicer", "ranker", "rankdir", "align"],
            _ = ["width", "height"],
            x = {
          width: 0,
          height: 0
        },
            w = ["minlen", "weight", "width", "height", "labeloffset"],
            k = {
          minlen: 1,
          weight: 1,
          width: 0,
          height: 0,
          labeloffset: 10,
          labelpos: "r"
        },
            T = ["labelpos"];

        function E(t, e) {
          return r.mapValues(r.pick(t, e), Number);
        }

        function C(t) {
          var e = {};
          return r.forEach(t, function (t, n) {
            e[n.toLowerCase()] = t;
          }), e;
        }
      },
      8436: function _(t, e, n) {
        var r;

        try {
          r = {
            cloneDeep: n(361),
            constant: n(5703),
            defaults: n(1747),
            each: n(6073),
            filter: n(3105),
            find: n(3311),
            flatten: n(5564),
            forEach: n(4486),
            forIn: n(2620),
            has: n(8721),
            isUndefined: n(2353),
            last: n(928),
            map: n(5161),
            mapValues: n(6604),
            max: n(6162),
            merge: n(3857),
            min: n(3632),
            minBy: n(2762),
            now: n(7771),
            pick: n(9722),
            range: n(6026),
            reduce: n(4061),
            sortBy: n(9734),
            uniqueId: n(3955),
            values: n(2628),
            zipObject: n(7287)
          };
        } catch (t) {}

        r || (r = window._), t.exports = r;
      },
      2981: function _(t, e, n) {
        var r = n(8436),
            i = n(1138);

        function a(t, e, n, o, s, c, u) {
          var l = t.children(u);

          if (l.length) {
            var h = i.addBorderNode(t, "_bt"),
                f = i.addBorderNode(t, "_bb"),
                d = t.node(u);
            t.setParent(h, u), d.borderTop = h, t.setParent(f, u), d.borderBottom = f, r.forEach(l, function (r) {
              a(t, e, n, o, s, c, r);
              var i = t.node(r),
                  l = i.borderTop ? i.borderTop : r,
                  d = i.borderBottom ? i.borderBottom : r,
                  p = i.borderTop ? o : 2 * o,
                  y = l !== d ? 1 : s - c[u] + 1;
              t.setEdge(h, l, {
                weight: p,
                minlen: y,
                nestingEdge: !0
              }), t.setEdge(d, f, {
                weight: p,
                minlen: y,
                nestingEdge: !0
              });
            }), t.parent(u) || t.setEdge(e, h, {
              weight: 0,
              minlen: s + c[u]
            });
          } else u !== e && t.setEdge(e, u, {
            weight: 0,
            minlen: n
          });
        }

        t.exports = {
          run: function run(t) {
            var e = i.addDummyNode(t, "root", {}, "_root"),
                n = function (t) {
              var e = {};

              function n(i, a) {
                var o = t.children(i);
                o && o.length && r.forEach(o, function (t) {
                  n(t, a + 1);
                }), e[i] = a;
              }

              return r.forEach(t.children(), function (t) {
                n(t, 1);
              }), e;
            }(t),
                o = r.max(r.values(n)) - 1,
                s = 2 * o + 1;

            t.graph().nestingRoot = e, r.forEach(t.edges(), function (e) {
              t.edge(e).minlen *= s;
            });

            var c = function (t) {
              return r.reduce(t.edges(), function (e, n) {
                return e + t.edge(n).weight;
              }, 0);
            }(t) + 1;

            r.forEach(t.children(), function (r) {
              a(t, e, s, c, o, n, r);
            }), t.graph().nodeRankFactor = s;
          },
          cleanup: function cleanup(t) {
            var e = t.graph();
            t.removeNode(e.nestingRoot), delete e.nestingRoot, r.forEach(t.edges(), function (e) {
              t.edge(e).nestingEdge && t.removeEdge(e);
            });
          }
        };
      },
      5995: function _(t, e, n) {
        var r = n(8436),
            i = n(1138);
        t.exports = {
          run: function run(t) {
            t.graph().dummyChains = [], r.forEach(t.edges(), function (e) {
              !function (t, e) {
                var n,
                    r,
                    a,
                    o = e.v,
                    s = t.node(o).rank,
                    c = e.w,
                    u = t.node(c).rank,
                    l = e.name,
                    h = t.edge(e),
                    f = h.labelRank;

                if (u !== s + 1) {
                  for (t.removeEdge(e), a = 0, ++s; s < u; ++a, ++s) {
                    h.points = [], r = {
                      width: 0,
                      height: 0,
                      edgeLabel: h,
                      edgeObj: e,
                      rank: s
                    }, n = i.addDummyNode(t, "edge", r, "_d"), s === f && (r.width = h.width, r.height = h.height, r.dummy = "edge-label", r.labelpos = h.labelpos), t.setEdge(o, n, {
                      weight: h.weight
                    }, l), 0 === a && t.graph().dummyChains.push(n), o = n;
                  }

                  t.setEdge(o, c, {
                    weight: h.weight
                  }, l);
                }
              }(t, e);
            });
          },
          undo: function undo(t) {
            r.forEach(t.graph().dummyChains, function (e) {
              var n,
                  r = t.node(e),
                  i = r.edgeLabel;

              for (t.setEdge(r.edgeObj, i); r.dummy;) {
                n = t.successors(e)[0], t.removeNode(e), i.points.push({
                  x: r.x,
                  y: r.y
                }), "edge-label" === r.dummy && (i.x = r.x, i.y = r.y, i.width = r.width, i.height = r.height), e = n, r = t.node(e);
              }
            });
          }
        };
      },
      5093: function _(t, e, n) {
        var r = n(8436);

        t.exports = function (t, e, n) {
          var i,
              a = {};
          r.forEach(n, function (n) {
            for (var r, o, s = t.parent(n); s;) {
              if ((r = t.parent(s)) ? (o = a[r], a[r] = s) : (o = i, i = s), o && o !== s) return void e.setEdge(o, s);
              s = r;
            }
          });
        };
      },
      5439: function _(t, e, n) {
        var r = n(8436);

        t.exports = function (t, e) {
          return r.map(e, function (e) {
            var n = t.inEdges(e);

            if (n.length) {
              var i = r.reduce(n, function (e, n) {
                var r = t.edge(n),
                    i = t.node(n.v);
                return {
                  sum: e.sum + r.weight * i.order,
                  weight: e.weight + r.weight
                };
              }, {
                sum: 0,
                weight: 0
              });
              return {
                v: e,
                barycenter: i.sum / i.weight,
                weight: i.weight
              };
            }

            return {
              v: e
            };
          });
        };
      },
      3128: function _(t, e, n) {
        var r = n(8436),
            i = n(574).Graph;

        t.exports = function (t, e, n) {
          var a = function (t) {
            for (var e; t.hasNode(e = r.uniqueId("_root"));) {
              ;
            }

            return e;
          }(t),
              o = new i({
            compound: !0
          }).setGraph({
            root: a
          }).setDefaultNodeLabel(function (e) {
            return t.node(e);
          });

          return r.forEach(t.nodes(), function (i) {
            var s = t.node(i),
                c = t.parent(i);
            (s.rank === e || s.minRank <= e && e <= s.maxRank) && (o.setNode(i), o.setParent(i, c || a), r.forEach(t[n](i), function (e) {
              var n = e.v === i ? e.w : e.v,
                  a = o.edge(n, i),
                  s = r.isUndefined(a) ? 0 : a.weight;
              o.setEdge(n, i, {
                weight: t.edge(e).weight + s
              });
            }), r.has(s, "minRank") && o.setNode(i, {
              borderLeft: s.borderLeft[e],
              borderRight: s.borderRight[e]
            }));
          }), o;
        };
      },
      6630: function _(t, e, n) {
        var r = n(8436);

        function i(t, e, n) {
          for (var i = r.zipObject(n, r.map(n, function (t, e) {
            return e;
          })), a = r.flatten(r.map(e, function (e) {
            return r.sortBy(r.map(t.outEdges(e), function (e) {
              return {
                pos: i[e.w],
                weight: t.edge(e).weight
              };
            }), "pos");
          }), !0), o = 1; o < n.length;) {
            o <<= 1;
          }

          var s = 2 * o - 1;
          o -= 1;
          var c = r.map(new Array(s), function () {
            return 0;
          }),
              u = 0;
          return r.forEach(a.forEach(function (t) {
            var e = t.pos + o;
            c[e] += t.weight;

            for (var n = 0; e > 0;) {
              e % 2 && (n += c[e + 1]), c[e = e - 1 >> 1] += t.weight;
            }

            u += t.weight * n;
          })), u;
        }

        t.exports = function (t, e) {
          for (var n = 0, r = 1; r < e.length; ++r) {
            n += i(t, e[r - 1], e[r]);
          }

          return n;
        };
      },
      3408: function _(t, e, n) {
        var r = n(8436),
            i = n(2588),
            a = n(6630),
            o = n(1026),
            s = n(3128),
            c = n(5093),
            u = n(574).Graph,
            l = n(1138);

        function h(t, e, n) {
          return r.map(e, function (e) {
            return s(t, e, n);
          });
        }

        function f(t, e) {
          var n = new u();
          r.forEach(t, function (t) {
            var i = t.graph().root,
                a = o(t, i, n, e);
            r.forEach(a.vs, function (e, n) {
              t.node(e).order = n;
            }), c(t, n, a.vs);
          });
        }

        function d(t, e) {
          r.forEach(e, function (e) {
            r.forEach(e, function (e, n) {
              t.node(e).order = n;
            });
          });
        }

        t.exports = function (t) {
          var e = l.maxRank(t),
              n = h(t, r.range(1, e + 1), "inEdges"),
              o = h(t, r.range(e - 1, -1, -1), "outEdges"),
              s = i(t);
          d(t, s);

          for (var c, u = Number.POSITIVE_INFINITY, p = 0, y = 0; y < 4; ++p, ++y) {
            f(p % 2 ? n : o, p % 4 >= 2), s = l.buildLayerMatrix(t);
            var g = a(t, s);
            g < u && (y = 0, c = r.cloneDeep(s), u = g);
          }

          d(t, c);
        };
      },
      2588: function _(t, e, n) {
        var r = n(8436);

        t.exports = function (t) {
          var e = {},
              n = r.filter(t.nodes(), function (e) {
            return !t.children(e).length;
          }),
              i = r.max(r.map(n, function (e) {
            return t.node(e).rank;
          })),
              a = r.map(r.range(i + 1), function () {
            return [];
          }),
              o = r.sortBy(n, function (e) {
            return t.node(e).rank;
          });
          return r.forEach(o, function n(i) {
            if (!r.has(e, i)) {
              e[i] = !0;
              var o = t.node(i);
              a[o.rank].push(i), r.forEach(t.successors(i), n);
            }
          }), a;
        };
      },
      9567: function _(t, e, n) {
        var r = n(8436);

        t.exports = function (t, e) {
          var n = {};
          return r.forEach(t, function (t, e) {
            var i = n[t.v] = {
              indegree: 0,
              in: [],
              out: [],
              vs: [t.v],
              i: e
            };
            r.isUndefined(t.barycenter) || (i.barycenter = t.barycenter, i.weight = t.weight);
          }), r.forEach(e.edges(), function (t) {
            var e = n[t.v],
                i = n[t.w];
            r.isUndefined(e) || r.isUndefined(i) || (i.indegree++, e.out.push(n[t.w]));
          }), function (t) {
            var e = [];

            function n(t) {
              return function (e) {
                var n, i, a, o;
                e.merged || (r.isUndefined(e.barycenter) || r.isUndefined(t.barycenter) || e.barycenter >= t.barycenter) && (i = e, a = 0, o = 0, (n = t).weight && (a += n.barycenter * n.weight, o += n.weight), i.weight && (a += i.barycenter * i.weight, o += i.weight), n.vs = i.vs.concat(n.vs), n.barycenter = a / o, n.weight = o, n.i = Math.min(i.i, n.i), i.merged = !0);
              };
            }

            function i(e) {
              return function (n) {
                n.in.push(e), 0 == --n.indegree && t.push(n);
              };
            }

            for (; t.length;) {
              var a = t.pop();
              e.push(a), r.forEach(a.in.reverse(), n(a)), r.forEach(a.out, i(a));
            }

            return r.map(r.filter(e, function (t) {
              return !t.merged;
            }), function (t) {
              return r.pick(t, ["vs", "i", "barycenter", "weight"]);
            });
          }(r.filter(n, function (t) {
            return !t.indegree;
          }));
        };
      },
      1026: function _(t, e, n) {
        var r = n(8436),
            i = n(5439),
            a = n(9567),
            o = n(7304);

        t.exports = function t(e, n, s, c) {
          var u = e.children(n),
              l = e.node(n),
              h = l ? l.borderLeft : void 0,
              f = l ? l.borderRight : void 0,
              d = {};
          h && (u = r.filter(u, function (t) {
            return t !== h && t !== f;
          }));
          var p = i(e, u);
          r.forEach(p, function (n) {
            if (e.children(n.v).length) {
              var i = t(e, n.v, s, c);
              d[n.v] = i, r.has(i, "barycenter") && (a = n, o = i, r.isUndefined(a.barycenter) ? (a.barycenter = o.barycenter, a.weight = o.weight) : (a.barycenter = (a.barycenter * a.weight + o.barycenter * o.weight) / (a.weight + o.weight), a.weight += o.weight));
            }

            var a, o;
          });
          var y = a(p, s);
          !function (t, e) {
            r.forEach(t, function (t) {
              t.vs = r.flatten(t.vs.map(function (t) {
                return e[t] ? e[t].vs : t;
              }), !0);
            });
          }(y, d);
          var g = o(y, c);

          if (h && (g.vs = r.flatten([h, g.vs, f], !0), e.predecessors(h).length)) {
            var m = e.node(e.predecessors(h)[0]),
                v = e.node(e.predecessors(f)[0]);
            r.has(g, "barycenter") || (g.barycenter = 0, g.weight = 0), g.barycenter = (g.barycenter * g.weight + m.order + v.order) / (g.weight + 2), g.weight += 2;
          }

          return g;
        };
      },
      7304: function _(t, e, n) {
        var r = n(8436),
            i = n(1138);

        function a(t, e, n) {
          for (var i; e.length && (i = r.last(e)).i <= n;) {
            e.pop(), t.push(i.vs), n++;
          }

          return n;
        }

        t.exports = function (t, e) {
          var n,
              o = i.partition(t, function (t) {
            return r.has(t, "barycenter");
          }),
              s = o.lhs,
              c = r.sortBy(o.rhs, function (t) {
            return -t.i;
          }),
              u = [],
              l = 0,
              h = 0,
              f = 0;
          s.sort((n = !!e, function (t, e) {
            return t.barycenter < e.barycenter ? -1 : t.barycenter > e.barycenter ? 1 : n ? e.i - t.i : t.i - e.i;
          })), f = a(u, c, f), r.forEach(s, function (t) {
            f += t.vs.length, u.push(t.vs), l += t.barycenter * t.weight, h += t.weight, f = a(u, c, f);
          });
          var d = {
            vs: r.flatten(u, !0)
          };
          return h && (d.barycenter = l / h, d.weight = h), d;
        };
      },
      4219: function _(t, e, n) {
        var r = n(8436);

        t.exports = function (t) {
          var e = function (t) {
            var e = {},
                n = 0;
            return r.forEach(t.children(), function i(a) {
              var o = n;
              r.forEach(t.children(a), i), e[a] = {
                low: o,
                lim: n++
              };
            }), e;
          }(t);

          r.forEach(t.graph().dummyChains, function (n) {
            for (var r = t.node(n), i = r.edgeObj, a = function (t, e, n, r) {
              var i,
                  a,
                  o = [],
                  s = [],
                  c = Math.min(e[n].low, e[r].low),
                  u = Math.max(e[n].lim, e[r].lim);
              i = n;

              do {
                i = t.parent(i), o.push(i);
              } while (i && (e[i].low > c || u > e[i].lim));

              for (a = i, i = r; (i = t.parent(i)) !== a;) {
                s.push(i);
              }

              return {
                path: o.concat(s.reverse()),
                lca: a
              };
            }(t, e, i.v, i.w), o = a.path, s = a.lca, c = 0, u = o[c], l = !0; n !== i.w;) {
              if (r = t.node(n), l) {
                for (; (u = o[c]) !== s && t.node(u).maxRank < r.rank;) {
                  c++;
                }

                u === s && (l = !1);
              }

              if (!l) {
                for (; c < o.length - 1 && t.node(u = o[c + 1]).minRank <= r.rank;) {
                  c++;
                }

                u = o[c];
              }

              t.setParent(n, u), n = t.successors(n)[0];
            }
          });
        };
      },
      3573: function _(t, e, n) {
        var r = n(8436),
            i = n(574).Graph,
            a = n(1138);

        function o(t, e) {
          var n = {};
          return r.reduce(e, function (e, i) {
            var a = 0,
                o = 0,
                s = e.length,
                u = r.last(i);
            return r.forEach(i, function (e, l) {
              var h = function (t, e) {
                if (t.node(e).dummy) return r.find(t.predecessors(e), function (e) {
                  return t.node(e).dummy;
                });
              }(t, e),
                  f = h ? t.node(h).order : s;

              (h || e === u) && (r.forEach(i.slice(o, l + 1), function (e) {
                r.forEach(t.predecessors(e), function (r) {
                  var i = t.node(r),
                      o = i.order;
                  !(o < a || f < o) || i.dummy && t.node(e).dummy || c(n, r, e);
                });
              }), o = l + 1, a = f);
            }), i;
          }), n;
        }

        function s(t, e) {
          var n = {};

          function i(e, i, a, o, s) {
            var u;
            r.forEach(r.range(i, a), function (i) {
              u = e[i], t.node(u).dummy && r.forEach(t.predecessors(u), function (e) {
                var r = t.node(e);
                r.dummy && (r.order < o || r.order > s) && c(n, e, u);
              });
            });
          }

          return r.reduce(e, function (e, n) {
            var a,
                o = -1,
                s = 0;
            return r.forEach(n, function (r, c) {
              if ("border" === t.node(r).dummy) {
                var u = t.predecessors(r);
                u.length && (a = t.node(u[0]).order, i(n, s, c, o, a), s = c, o = a);
              }

              i(n, s, n.length, a, e.length);
            }), n;
          }), n;
        }

        function c(t, e, n) {
          if (e > n) {
            var r = e;
            e = n, n = r;
          }

          var i = t[e];
          i || (t[e] = i = {}), i[n] = !0;
        }

        function u(t, e, n) {
          if (e > n) {
            var i = e;
            e = n, n = i;
          }

          return r.has(t[e], n);
        }

        function l(t, e, n, i) {
          var a = {},
              o = {},
              s = {};
          return r.forEach(e, function (t) {
            r.forEach(t, function (t, e) {
              a[t] = t, o[t] = t, s[t] = e;
            });
          }), r.forEach(e, function (t) {
            var e = -1;
            r.forEach(t, function (t) {
              var c = i(t);
              if (c.length) for (var l = ((c = r.sortBy(c, function (t) {
                return s[t];
              })).length - 1) / 2, h = Math.floor(l), f = Math.ceil(l); h <= f; ++h) {
                var d = c[h];
                o[t] === t && e < s[d] && !u(n, t, d) && (o[d] = t, o[t] = a[t] = a[d], e = s[d]);
              }
            });
          }), {
            root: a,
            align: o
          };
        }

        function h(t, e, n, a, o) {
          var s = {},
              c = function (t, e, n, a) {
            var o = new i(),
                s = t.graph(),
                c = function (t, e, n) {
              return function (i, a, o) {
                var s,
                    c = i.node(a),
                    u = i.node(o),
                    l = 0;
                if (l += c.width / 2, r.has(c, "labelpos")) switch (c.labelpos.toLowerCase()) {
                  case "l":
                    s = -c.width / 2;
                    break;

                  case "r":
                    s = c.width / 2;
                }
                if (s && (l += n ? s : -s), s = 0, l += (c.dummy ? e : t) / 2, l += (u.dummy ? e : t) / 2, l += u.width / 2, r.has(u, "labelpos")) switch (u.labelpos.toLowerCase()) {
                  case "l":
                    s = u.width / 2;
                    break;

                  case "r":
                    s = -u.width / 2;
                }
                return s && (l += n ? s : -s), s = 0, l;
              };
            }(s.nodesep, s.edgesep, a);

            return r.forEach(e, function (e) {
              var i;
              r.forEach(e, function (e) {
                var r = n[e];

                if (o.setNode(r), i) {
                  var a = n[i],
                      s = o.edge(a, r);
                  o.setEdge(a, r, Math.max(c(t, e, i), s || 0));
                }

                i = e;
              });
            }), o;
          }(t, e, n, o),
              u = o ? "borderLeft" : "borderRight";

          function l(t, e) {
            for (var n = c.nodes(), r = n.pop(), i = {}; r;) {
              i[r] ? t(r) : (i[r] = !0, n.push(r), n = n.concat(e(r))), r = n.pop();
            }
          }

          return l(function (t) {
            s[t] = c.inEdges(t).reduce(function (t, e) {
              return Math.max(t, s[e.v] + c.edge(e));
            }, 0);
          }, c.predecessors.bind(c)), l(function (e) {
            var n = c.outEdges(e).reduce(function (t, e) {
              return Math.min(t, s[e.w] - c.edge(e));
            }, Number.POSITIVE_INFINITY),
                r = t.node(e);
            n !== Number.POSITIVE_INFINITY && r.borderType !== u && (s[e] = Math.max(s[e], n));
          }, c.successors.bind(c)), r.forEach(a, function (t) {
            s[t] = s[n[t]];
          }), s;
        }

        function f(t, e) {
          return r.minBy(r.values(e), function (e) {
            var n = Number.NEGATIVE_INFINITY,
                i = Number.POSITIVE_INFINITY;
            return r.forIn(e, function (e, r) {
              var a = function (t, e) {
                return t.node(e).width;
              }(t, r) / 2;

              n = Math.max(e + a, n), i = Math.min(e - a, i);
            }), n - i;
          });
        }

        function d(t, e) {
          var n = r.values(e),
              i = r.min(n),
              a = r.max(n);
          r.forEach(["u", "d"], function (n) {
            r.forEach(["l", "r"], function (o) {
              var s,
                  c = n + o,
                  u = t[c];

              if (u !== e) {
                var l = r.values(u);
                (s = "l" === o ? i - r.min(l) : a - r.max(l)) && (t[c] = r.mapValues(u, function (t) {
                  return t + s;
                }));
              }
            });
          });
        }

        function p(t, e) {
          return r.mapValues(t.ul, function (n, i) {
            if (e) return t[e.toLowerCase()][i];
            var a = r.sortBy(r.map(t, i));
            return (a[1] + a[2]) / 2;
          });
        }

        t.exports = {
          positionX: function positionX(t) {
            var e,
                n = a.buildLayerMatrix(t),
                i = r.merge(o(t, n), s(t, n)),
                c = {};
            r.forEach(["u", "d"], function (a) {
              e = "u" === a ? n : r.values(n).reverse(), r.forEach(["l", "r"], function (n) {
                "r" === n && (e = r.map(e, function (t) {
                  return r.values(t).reverse();
                }));
                var o = ("u" === a ? t.predecessors : t.successors).bind(t),
                    s = l(0, e, i, o),
                    u = h(t, e, s.root, s.align, "r" === n);
                "r" === n && (u = r.mapValues(u, function (t) {
                  return -t;
                })), c[a + n] = u;
              });
            });
            var u = f(t, c);
            return d(c, u), p(c, t.graph().align);
          },
          findType1Conflicts: o,
          findType2Conflicts: s,
          addConflict: c,
          hasConflict: u,
          verticalAlignment: l,
          horizontalCompaction: h,
          alignCoordinates: d,
          findSmallestWidthAlignment: f,
          balance: p
        };
      },
      7873: function _(t, e, n) {
        var r = n(8436),
            i = n(1138),
            a = n(3573).positionX;

        t.exports = function (t) {
          (function (t) {
            var e = i.buildLayerMatrix(t),
                n = t.graph().ranksep,
                a = 0;
            r.forEach(e, function (e) {
              var i = r.max(r.map(e, function (e) {
                return t.node(e).height;
              }));
              r.forEach(e, function (e) {
                t.node(e).y = a + i / 2;
              }), a += i + n;
            });
          })(t = i.asNonCompoundGraph(t)), r.forEach(a(t), function (e, n) {
            t.node(n).x = e;
          });
        };
      },
      300: function _(t, e, n) {
        var r = n(8436),
            i = n(574).Graph,
            a = n(6681).slack;

        function o(t, e) {
          return r.forEach(t.nodes(), function n(i) {
            r.forEach(e.nodeEdges(i), function (r) {
              var o = r.v,
                  s = i === o ? r.w : o;
              t.hasNode(s) || a(e, r) || (t.setNode(s, {}), t.setEdge(i, s, {}), n(s));
            });
          }), t.nodeCount();
        }

        function s(t, e) {
          return r.minBy(e.edges(), function (n) {
            if (t.hasNode(n.v) !== t.hasNode(n.w)) return a(e, n);
          });
        }

        function c(t, e, n) {
          r.forEach(t.nodes(), function (t) {
            e.node(t).rank += n;
          });
        }

        t.exports = function (t) {
          var e,
              n,
              r = new i({
            directed: !1
          }),
              u = t.nodes()[0],
              l = t.nodeCount();

          for (r.setNode(u, {}); o(r, t) < l;) {
            e = s(r, t), n = r.hasNode(e.v) ? a(t, e) : -a(t, e), c(r, t, n);
          }

          return r;
        };
      },
      8093: function _(t, e, n) {
        var r = n(6681).longestPath,
            i = n(300),
            a = n(2472);

        t.exports = function (t) {
          switch (t.graph().ranker) {
            case "network-simplex":
              s(t);
              break;

            case "tight-tree":
              !function (t) {
                r(t), i(t);
              }(t);
              break;

            case "longest-path":
              o(t);
              break;

            default:
              s(t);
          }
        };

        var o = r;

        function s(t) {
          a(t);
        }
      },
      2472: function _(t, e, n) {
        var r = n(8436),
            i = n(300),
            a = n(6681).slack,
            o = n(6681).longestPath,
            s = n(574).alg.preorder,
            c = n(574).alg.postorder,
            u = n(1138).simplify;

        function l(t) {
          t = u(t), o(t);
          var e,
              n = i(t);

          for (d(n), h(n, t); e = y(n);) {
            m(n, t, e, g(n, t, e));
          }
        }

        function h(t, e) {
          var n = c(t, t.nodes());
          n = n.slice(0, n.length - 1), r.forEach(n, function (n) {
            !function (t, e, n) {
              var r = t.node(n).parent;
              t.edge(n, r).cutvalue = f(t, e, n);
            }(t, e, n);
          });
        }

        function f(t, e, n) {
          var i = t.node(n).parent,
              a = !0,
              o = e.edge(n, i),
              s = 0;
          return o || (a = !1, o = e.edge(i, n)), s = o.weight, r.forEach(e.nodeEdges(n), function (r) {
            var o,
                c,
                u = r.v === n,
                l = u ? r.w : r.v;

            if (l !== i) {
              var h = u === a,
                  f = e.edge(r).weight;

              if (s += h ? f : -f, o = n, c = l, t.hasEdge(o, c)) {
                var d = t.edge(n, l).cutvalue;
                s += h ? -d : d;
              }
            }
          }), s;
        }

        function d(t, e) {
          arguments.length < 2 && (e = t.nodes()[0]), p(t, {}, 1, e);
        }

        function p(t, e, n, i, a) {
          var o = n,
              s = t.node(i);
          return e[i] = !0, r.forEach(t.neighbors(i), function (a) {
            r.has(e, a) || (n = p(t, e, n, a, i));
          }), s.low = o, s.lim = n++, a ? s.parent = a : delete s.parent, n;
        }

        function y(t) {
          return r.find(t.edges(), function (e) {
            return t.edge(e).cutvalue < 0;
          });
        }

        function g(t, e, n) {
          var i = n.v,
              o = n.w;
          e.hasEdge(i, o) || (i = n.w, o = n.v);
          var s = t.node(i),
              c = t.node(o),
              u = s,
              l = !1;
          s.lim > c.lim && (u = c, l = !0);
          var h = r.filter(e.edges(), function (e) {
            return l === v(0, t.node(e.v), u) && l !== v(0, t.node(e.w), u);
          });
          return r.minBy(h, function (t) {
            return a(e, t);
          });
        }

        function m(t, e, n, i) {
          var a = n.v,
              o = n.w;
          t.removeEdge(a, o), t.setEdge(i.v, i.w, {}), d(t), h(t, e), function (t, e) {
            var n = r.find(t.nodes(), function (t) {
              return !e.node(t).parent;
            }),
                i = s(t, n);
            i = i.slice(1), r.forEach(i, function (n) {
              var r = t.node(n).parent,
                  i = e.edge(n, r),
                  a = !1;
              i || (i = e.edge(r, n), a = !0), e.node(n).rank = e.node(r).rank + (a ? i.minlen : -i.minlen);
            });
          }(t, e);
        }

        function v(t, e, n) {
          return n.low <= e.lim && e.lim <= n.lim;
        }

        t.exports = l, l.initLowLimValues = d, l.initCutValues = h, l.calcCutValue = f, l.leaveEdge = y, l.enterEdge = g, l.exchangeEdges = m;
      },
      6681: function _(t, e, n) {
        var r = n(8436);
        t.exports = {
          longestPath: function longestPath(t) {
            var e = {};
            r.forEach(t.sources(), function n(i) {
              var a = t.node(i);
              if (r.has(e, i)) return a.rank;
              e[i] = !0;
              var o = r.min(r.map(t.outEdges(i), function (e) {
                return n(e.w) - t.edge(e).minlen;
              }));
              return o !== Number.POSITIVE_INFINITY && null != o || (o = 0), a.rank = o;
            });
          },
          slack: function slack(t, e) {
            return t.node(e.w).rank - t.node(e.v).rank - t.edge(e).minlen;
          }
        };
      },
      1138: function _(t, e, n) {
        var r = n(8436),
            i = n(574).Graph;

        function a(t, e, n, i) {
          var a;

          do {
            a = r.uniqueId(i);
          } while (t.hasNode(a));

          return n.dummy = e, t.setNode(a, n), a;
        }

        function o(t) {
          return r.max(r.map(t.nodes(), function (e) {
            var n = t.node(e).rank;
            if (!r.isUndefined(n)) return n;
          }));
        }

        t.exports = {
          addDummyNode: a,
          simplify: function simplify(t) {
            var e = new i().setGraph(t.graph());
            return r.forEach(t.nodes(), function (n) {
              e.setNode(n, t.node(n));
            }), r.forEach(t.edges(), function (n) {
              var r = e.edge(n.v, n.w) || {
                weight: 0,
                minlen: 1
              },
                  i = t.edge(n);
              e.setEdge(n.v, n.w, {
                weight: r.weight + i.weight,
                minlen: Math.max(r.minlen, i.minlen)
              });
            }), e;
          },
          asNonCompoundGraph: function asNonCompoundGraph(t) {
            var e = new i({
              multigraph: t.isMultigraph()
            }).setGraph(t.graph());
            return r.forEach(t.nodes(), function (n) {
              t.children(n).length || e.setNode(n, t.node(n));
            }), r.forEach(t.edges(), function (n) {
              e.setEdge(n, t.edge(n));
            }), e;
          },
          successorWeights: function successorWeights(t) {
            var e = r.map(t.nodes(), function (e) {
              var n = {};
              return r.forEach(t.outEdges(e), function (e) {
                n[e.w] = (n[e.w] || 0) + t.edge(e).weight;
              }), n;
            });
            return r.zipObject(t.nodes(), e);
          },
          predecessorWeights: function predecessorWeights(t) {
            var e = r.map(t.nodes(), function (e) {
              var n = {};
              return r.forEach(t.inEdges(e), function (e) {
                n[e.v] = (n[e.v] || 0) + t.edge(e).weight;
              }), n;
            });
            return r.zipObject(t.nodes(), e);
          },
          intersectRect: function intersectRect(t, e) {
            var n,
                r,
                i = t.x,
                a = t.y,
                o = e.x - i,
                s = e.y - a,
                c = t.width / 2,
                u = t.height / 2;
            if (!o && !s) throw new Error("Not possible to find intersection inside of the rectangle");
            return Math.abs(s) * c > Math.abs(o) * u ? (s < 0 && (u = -u), n = u * o / s, r = u) : (o < 0 && (c = -c), n = c, r = c * s / o), {
              x: i + n,
              y: a + r
            };
          },
          buildLayerMatrix: function buildLayerMatrix(t) {
            var e = r.map(r.range(o(t) + 1), function () {
              return [];
            });
            return r.forEach(t.nodes(), function (n) {
              var i = t.node(n),
                  a = i.rank;
              r.isUndefined(a) || (e[a][i.order] = n);
            }), e;
          },
          normalizeRanks: function normalizeRanks(t) {
            var e = r.min(r.map(t.nodes(), function (e) {
              return t.node(e).rank;
            }));
            r.forEach(t.nodes(), function (n) {
              var i = t.node(n);
              r.has(i, "rank") && (i.rank -= e);
            });
          },
          removeEmptyRanks: function removeEmptyRanks(t) {
            var e = r.min(r.map(t.nodes(), function (e) {
              return t.node(e).rank;
            })),
                n = [];
            r.forEach(t.nodes(), function (r) {
              var i = t.node(r).rank - e;
              n[i] || (n[i] = []), n[i].push(r);
            });
            var i = 0,
                a = t.graph().nodeRankFactor;
            r.forEach(n, function (e, n) {
              r.isUndefined(e) && n % a != 0 ? --i : i && r.forEach(e, function (e) {
                t.node(e).rank += i;
              });
            });
          },
          addBorderNode: function addBorderNode(t, e, n, r) {
            var i = {
              width: 0,
              height: 0
            };
            return arguments.length >= 4 && (i.rank = n, i.order = r), a(t, "border", i, e);
          },
          maxRank: o,
          partition: function partition(t, e) {
            var n = {
              lhs: [],
              rhs: []
            };
            return r.forEach(t, function (t) {
              e(t) ? n.lhs.push(t) : n.rhs.push(t);
            }), n;
          },
          time: function time(t, e) {
            var n = r.now();

            try {
              return e();
            } finally {
              console.log(t + " time: " + (r.now() - n) + "ms");
            }
          },
          notime: function notime(t, e) {
            return e();
          }
        };
      },
      8177: function _(t) {
        t.exports = "0.8.5";
      },
      7856: function _(t) {
        t.exports = function () {
          var t = Object.hasOwnProperty,
              e = Object.setPrototypeOf,
              n = Object.isFrozen,
              r = Object.getPrototypeOf,
              i = Object.getOwnPropertyDescriptor,
              a = Object.freeze,
              o = Object.seal,
              s = Object.create,
              c = "undefined" != typeof Reflect && Reflect,
              u = c.apply,
              l = c.construct;
          u || (u = function u(t, e, n) {
            return t.apply(e, n);
          }), a || (a = function a(t) {
            return t;
          }), o || (o = function o(t) {
            return t;
          }), l || (l = function l(t, e) {
            return new (Function.prototype.bind.apply(t, [null].concat(function (t) {
              if (Array.isArray(t)) {
                for (var e = 0, n = Array(t.length); e < t.length; e++) {
                  n[e] = t[e];
                }

                return n;
              }

              return Array.from(t);
            }(e))))();
          });

          var h,
              f = w(Array.prototype.forEach),
              d = w(Array.prototype.pop),
              p = w(Array.prototype.push),
              y = w(String.prototype.toLowerCase),
              g = w(String.prototype.match),
              m = w(String.prototype.replace),
              v = w(String.prototype.indexOf),
              b = w(String.prototype.trim),
              _ = w(RegExp.prototype.test),
              x = (h = TypeError, function () {
            for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) {
              e[n] = arguments[n];
            }

            return l(h, e);
          });

          function w(t) {
            return function (e) {
              for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
                r[i - 1] = arguments[i];
              }

              return u(t, e, r);
            };
          }

          function k(t, r) {
            e && e(t, null);

            for (var i = r.length; i--;) {
              var a = r[i];

              if ("string" == typeof a) {
                var o = y(a);
                o !== a && (n(r) || (r[i] = o), a = o);
              }

              t[a] = !0;
            }

            return t;
          }

          function T(e) {
            var n = s(null),
                r = void 0;

            for (r in e) {
              u(t, e, [r]) && (n[r] = e[r]);
            }

            return n;
          }

          function E(t, e) {
            for (; null !== t;) {
              var n = i(t, e);

              if (n) {
                if (n.get) return w(n.get);
                if ("function" == typeof n.value) return w(n.value);
              }

              t = r(t);
            }

            return function (t) {
              return console.warn("fallback value for", t), null;
            };
          }

          var C = a(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
              S = a(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
              A = a(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
              M = a(["animate", "color-profile", "cursor", "discard", "fedropshadow", "feimage", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
              N = a(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]),
              D = a(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
              O = a(["#text"]),
              B = a(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
              L = a(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
              I = a(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
              R = a(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
              P = o(/\{\{[\s\S]*|[\s\S]*\}\}/gm),
              F = o(/<%[\s\S]*|[\s\S]*%>/gm),
              j = o(/^data-[\-\w.\u00B7-\uFFFF]/),
              Y = o(/^aria-[\-\w]+$/),
              U = o(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
              z = o(/^(?:\w+script|data):/i),
              q = o(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
              $ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          };

          function H(t) {
            if (Array.isArray(t)) {
              for (var e = 0, n = Array(t.length); e < t.length; e++) {
                n[e] = t[e];
              }

              return n;
            }

            return Array.from(t);
          }

          var W = function W() {
            return "undefined" == typeof window ? null : window;
          },
              V = function V(t, e) {
            if ("object" !== (void 0 === t ? "undefined" : $(t)) || "function" != typeof t.createPolicy) return null;
            var n = null,
                r = "data-tt-policy-suffix";
            e.currentScript && e.currentScript.hasAttribute(r) && (n = e.currentScript.getAttribute(r));
            var i = "dompurify" + (n ? "#" + n : "");

            try {
              return t.createPolicy(i, {
                createHTML: function createHTML(t) {
                  return t;
                }
              });
            } catch (t) {
              return console.warn("TrustedTypes policy " + i + " could not be created."), null;
            }
          };

          return function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : W(),
                n = function n(e) {
              return t(e);
            };

            if (n.version = "2.3.3", n.removed = [], !e || !e.document || 9 !== e.document.nodeType) return n.isSupported = !1, n;
            var r = e.document,
                i = e.document,
                o = e.DocumentFragment,
                s = e.HTMLTemplateElement,
                c = e.Node,
                u = e.Element,
                l = e.NodeFilter,
                h = e.NamedNodeMap,
                w = void 0 === h ? e.NamedNodeMap || e.MozNamedAttrMap : h,
                G = e.Text,
                X = e.Comment,
                Z = e.DOMParser,
                K = e.trustedTypes,
                Q = u.prototype,
                J = E(Q, "cloneNode"),
                tt = E(Q, "nextSibling"),
                et = E(Q, "childNodes"),
                nt = E(Q, "parentNode");

            if ("function" == typeof s) {
              var rt = i.createElement("template");
              rt.content && rt.content.ownerDocument && (i = rt.content.ownerDocument);
            }

            var it = V(K, r),
                at = it && Pt ? it.createHTML("") : "",
                ot = i,
                st = ot.implementation,
                ct = ot.createNodeIterator,
                ut = ot.createDocumentFragment,
                lt = ot.getElementsByTagName,
                ht = r.importNode,
                ft = {};

            try {
              ft = T(i).documentMode ? i.documentMode : {};
            } catch (t) {}

            var dt = {};
            n.isSupported = "function" == typeof nt && st && void 0 !== st.createHTMLDocument && 9 !== ft;

            var pt = P,
                yt = F,
                gt = j,
                mt = Y,
                vt = z,
                bt = q,
                _t = U,
                xt = null,
                wt = k({}, [].concat(H(C), H(S), H(A), H(N), H(O))),
                kt = null,
                Tt = k({}, [].concat(H(B), H(L), H(I), H(R))),
                Et = null,
                Ct = null,
                St = !0,
                At = !0,
                Mt = !1,
                Nt = !1,
                Dt = !1,
                Ot = !1,
                Bt = !1,
                Lt = !1,
                It = !1,
                Rt = !0,
                Pt = !1,
                Ft = !0,
                jt = !0,
                Yt = !1,
                Ut = {},
                zt = null,
                qt = k({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]),
                $t = null,
                Ht = k({}, ["audio", "video", "img", "source", "image", "track"]),
                Wt = null,
                Vt = k({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
                Gt = "http://www.w3.org/1998/Math/MathML",
                Xt = "http://www.w3.org/2000/svg",
                Zt = "http://www.w3.org/1999/xhtml",
                Kt = Zt,
                Qt = !1,
                Jt = void 0,
                te = ["application/xhtml+xml", "text/html"],
                ee = "text/html",
                ne = void 0,
                re = null,
                ie = i.createElement("form"),
                ae = function ae(t) {
              re && re === t || (t && "object" === (void 0 === t ? "undefined" : $(t)) || (t = {}), t = T(t), xt = "ALLOWED_TAGS" in t ? k({}, t.ALLOWED_TAGS) : wt, kt = "ALLOWED_ATTR" in t ? k({}, t.ALLOWED_ATTR) : Tt, Wt = "ADD_URI_SAFE_ATTR" in t ? k(T(Vt), t.ADD_URI_SAFE_ATTR) : Vt, $t = "ADD_DATA_URI_TAGS" in t ? k(T(Ht), t.ADD_DATA_URI_TAGS) : Ht, zt = "FORBID_CONTENTS" in t ? k({}, t.FORBID_CONTENTS) : qt, Et = "FORBID_TAGS" in t ? k({}, t.FORBID_TAGS) : {}, Ct = "FORBID_ATTR" in t ? k({}, t.FORBID_ATTR) : {}, Ut = "USE_PROFILES" in t && t.USE_PROFILES, St = !1 !== t.ALLOW_ARIA_ATTR, At = !1 !== t.ALLOW_DATA_ATTR, Mt = t.ALLOW_UNKNOWN_PROTOCOLS || !1, Nt = t.SAFE_FOR_TEMPLATES || !1, Dt = t.WHOLE_DOCUMENT || !1, Lt = t.RETURN_DOM || !1, It = t.RETURN_DOM_FRAGMENT || !1, Rt = !1 !== t.RETURN_DOM_IMPORT, Pt = t.RETURN_TRUSTED_TYPE || !1, Bt = t.FORCE_BODY || !1, Ft = !1 !== t.SANITIZE_DOM, jt = !1 !== t.KEEP_CONTENT, Yt = t.IN_PLACE || !1, _t = t.ALLOWED_URI_REGEXP || _t, Kt = t.NAMESPACE || Zt, Jt = Jt = -1 === te.indexOf(t.PARSER_MEDIA_TYPE) ? ee : t.PARSER_MEDIA_TYPE, ne = "application/xhtml+xml" === Jt ? function (t) {
                return t;
              } : y, Nt && (At = !1), It && (Lt = !0), Ut && (xt = k({}, [].concat(H(O))), kt = [], !0 === Ut.html && (k(xt, C), k(kt, B)), !0 === Ut.svg && (k(xt, S), k(kt, L), k(kt, R)), !0 === Ut.svgFilters && (k(xt, A), k(kt, L), k(kt, R)), !0 === Ut.mathMl && (k(xt, N), k(kt, I), k(kt, R))), t.ADD_TAGS && (xt === wt && (xt = T(xt)), k(xt, t.ADD_TAGS)), t.ADD_ATTR && (kt === Tt && (kt = T(kt)), k(kt, t.ADD_ATTR)), t.ADD_URI_SAFE_ATTR && k(Wt, t.ADD_URI_SAFE_ATTR), t.FORBID_CONTENTS && (zt === qt && (zt = T(zt)), k(zt, t.FORBID_CONTENTS)), jt && (xt["#text"] = !0), Dt && k(xt, ["html", "head", "body"]), xt.table && (k(xt, ["tbody"]), delete Et.tbody), a && a(t), re = t);
            },
                oe = k({}, ["mi", "mo", "mn", "ms", "mtext"]),
                se = k({}, ["foreignobject", "desc", "title", "annotation-xml"]),
                ce = k({}, S);

            k(ce, A), k(ce, M);
            var ue = k({}, N);
            k(ue, D);

            var le = function le(t) {
              var e = nt(t);
              e && e.tagName || (e = {
                namespaceURI: Zt,
                tagName: "template"
              });
              var n = y(t.tagName),
                  r = y(e.tagName);
              if (t.namespaceURI === Xt) return e.namespaceURI === Zt ? "svg" === n : e.namespaceURI === Gt ? "svg" === n && ("annotation-xml" === r || oe[r]) : Boolean(ce[n]);
              if (t.namespaceURI === Gt) return e.namespaceURI === Zt ? "math" === n : e.namespaceURI === Xt ? "math" === n && se[r] : Boolean(ue[n]);

              if (t.namespaceURI === Zt) {
                if (e.namespaceURI === Xt && !se[r]) return !1;
                if (e.namespaceURI === Gt && !oe[r]) return !1;
                var i = k({}, ["title", "style", "font", "a", "script"]);
                return !ue[n] && (i[n] || !ce[n]);
              }

              return !1;
            },
                he = function he(t) {
              p(n.removed, {
                element: t
              });

              try {
                t.parentNode.removeChild(t);
              } catch (e) {
                try {
                  t.outerHTML = at;
                } catch (e) {
                  t.remove();
                }
              }
            },
                fe = function fe(t, e) {
              try {
                p(n.removed, {
                  attribute: e.getAttributeNode(t),
                  from: e
                });
              } catch (t) {
                p(n.removed, {
                  attribute: null,
                  from: e
                });
              }

              if (e.removeAttribute(t), "is" === t && !kt[t]) if (Lt || It) try {
                he(e);
              } catch (t) {} else try {
                e.setAttribute(t, "");
              } catch (t) {}
            },
                de = function de(t) {
              var e = void 0,
                  n = void 0;
              if (Bt) t = "<remove></remove>" + t;else {
                var r = g(t, /^[\r\n\t ]+/);
                n = r && r[0];
              }
              "application/xhtml+xml" === Jt && (t = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + t + "</body></html>");
              var a = it ? it.createHTML(t) : t;
              if (Kt === Zt) try {
                e = new Z().parseFromString(a, Jt);
              } catch (t) {}

              if (!e || !e.documentElement) {
                e = st.createDocument(Kt, "template", null);

                try {
                  e.documentElement.innerHTML = Qt ? "" : a;
                } catch (t) {}
              }

              var o = e.body || e.documentElement;
              return t && n && o.insertBefore(i.createTextNode(n), o.childNodes[0] || null), Kt === Zt ? lt.call(e, Dt ? "html" : "body")[0] : Dt ? e.documentElement : o;
            },
                pe = function pe(t) {
              return ct.call(t.ownerDocument || t, t, l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT, null, !1);
            },
                ye = function ye(t) {
              return !(t instanceof G || t instanceof X || "string" == typeof t.nodeName && "string" == typeof t.textContent && "function" == typeof t.removeChild && t.attributes instanceof w && "function" == typeof t.removeAttribute && "function" == typeof t.setAttribute && "string" == typeof t.namespaceURI && "function" == typeof t.insertBefore);
            },
                ge = function ge(t) {
              return "object" === (void 0 === c ? "undefined" : $(c)) ? t instanceof c : t && "object" === (void 0 === t ? "undefined" : $(t)) && "number" == typeof t.nodeType && "string" == typeof t.nodeName;
            },
                me = function me(t, e, r) {
              dt[t] && f(dt[t], function (t) {
                t.call(n, e, r, re);
              });
            },
                ve = function ve(t) {
              var e = void 0;
              if (me("beforeSanitizeElements", t, null), ye(t)) return he(t), !0;
              if (g(t.nodeName, /[\u0080-\uFFFF]/)) return he(t), !0;
              var r = ne(t.nodeName);
              if (me("uponSanitizeElement", t, {
                tagName: r,
                allowedTags: xt
              }), !ge(t.firstElementChild) && (!ge(t.content) || !ge(t.content.firstElementChild)) && _(/<[/\w]/g, t.innerHTML) && _(/<[/\w]/g, t.textContent)) return he(t), !0;
              if ("select" === r && _(/<template/i, t.innerHTML)) return he(t), !0;

              if (!xt[r] || Et[r]) {
                if (jt && !zt[r]) {
                  var i = nt(t) || t.parentNode,
                      a = et(t) || t.childNodes;
                  if (a && i) for (var o = a.length - 1; o >= 0; --o) {
                    i.insertBefore(J(a[o], !0), tt(t));
                  }
                }

                return he(t), !0;
              }

              return t instanceof u && !le(t) ? (he(t), !0) : "noscript" !== r && "noembed" !== r || !_(/<\/no(script|embed)/i, t.innerHTML) ? (Nt && 3 === t.nodeType && (e = t.textContent, e = m(e, pt, " "), e = m(e, yt, " "), t.textContent !== e && (p(n.removed, {
                element: t.cloneNode()
              }), t.textContent = e)), me("afterSanitizeElements", t, null), !1) : (he(t), !0);
            },
                be = function be(t, e, n) {
              if (Ft && ("id" === e || "name" === e) && (n in i || n in ie)) return !1;
              if (At && !Ct[e] && _(gt, e)) ;else if (St && _(mt, e)) ;else {
                if (!kt[e] || Ct[e]) return !1;
                if (Wt[e]) ;else if (_(_t, m(n, bt, ""))) ;else if ("src" !== e && "xlink:href" !== e && "href" !== e || "script" === t || 0 !== v(n, "data:") || !$t[t]) if (Mt && !_(vt, m(n, bt, ""))) ;else if (n) return !1;
              }
              return !0;
            },
                _e = function _e(t) {
              var e = void 0,
                  r = void 0,
                  i = void 0,
                  a = void 0;
              me("beforeSanitizeAttributes", t, null);
              var o = t.attributes;

              if (o) {
                var s = {
                  attrName: "",
                  attrValue: "",
                  keepAttr: !0,
                  allowedAttributes: kt
                };

                for (a = o.length; a--;) {
                  var c = e = o[a],
                      u = c.name,
                      l = c.namespaceURI;
                  if (r = b(e.value), i = ne(u), s.attrName = i, s.attrValue = r, s.keepAttr = !0, s.forceKeepAttr = void 0, me("uponSanitizeAttribute", t, s), r = s.attrValue, !s.forceKeepAttr && (fe(u, t), s.keepAttr)) if (_(/\/>/i, r)) fe(u, t);else {
                    Nt && (r = m(r, pt, " "), r = m(r, yt, " "));
                    var h = ne(t.nodeName);
                    if (be(h, i, r)) try {
                      l ? t.setAttributeNS(l, u, r) : t.setAttribute(u, r), d(n.removed);
                    } catch (t) {}
                  }
                }

                me("afterSanitizeAttributes", t, null);
              }
            },
                xe = function t(e) {
              var n = void 0,
                  r = pe(e);

              for (me("beforeSanitizeShadowDOM", e, null); n = r.nextNode();) {
                me("uponSanitizeShadowNode", n, null), ve(n) || (n.content instanceof o && t(n.content), _e(n));
              }

              me("afterSanitizeShadowDOM", e, null);
            };

            return n.sanitize = function (t, i) {
              var a = void 0,
                  s = void 0,
                  u = void 0,
                  l = void 0,
                  h = void 0;

              if ((Qt = !t) && (t = "\x3c!--\x3e"), "string" != typeof t && !ge(t)) {
                if ("function" != typeof t.toString) throw x("toString is not a function");
                if ("string" != typeof (t = t.toString())) throw x("dirty is not a string, aborting");
              }

              if (!n.isSupported) {
                if ("object" === $(e.toStaticHTML) || "function" == typeof e.toStaticHTML) {
                  if ("string" == typeof t) return e.toStaticHTML(t);
                  if (ge(t)) return e.toStaticHTML(t.outerHTML);
                }

                return t;
              }

              if (Ot || ae(i), n.removed = [], "string" == typeof t && (Yt = !1), Yt) ;else if (t instanceof c) 1 === (s = (a = de("\x3c!----\x3e")).ownerDocument.importNode(t, !0)).nodeType && "BODY" === s.nodeName || "HTML" === s.nodeName ? a = s : a.appendChild(s);else {
                if (!Lt && !Nt && !Dt && -1 === t.indexOf("<")) return it && Pt ? it.createHTML(t) : t;
                if (!(a = de(t))) return Lt ? null : at;
              }
              a && Bt && he(a.firstChild);

              for (var f = pe(Yt ? t : a); u = f.nextNode();) {
                3 === u.nodeType && u === l || ve(u) || (u.content instanceof o && xe(u.content), _e(u), l = u);
              }

              if (l = null, Yt) return t;

              if (Lt) {
                if (It) for (h = ut.call(a.ownerDocument); a.firstChild;) {
                  h.appendChild(a.firstChild);
                } else h = a;
                return Rt && (h = ht.call(r, h, !0)), h;
              }

              var d = Dt ? a.outerHTML : a.innerHTML;
              return Nt && (d = m(d, pt, " "), d = m(d, yt, " ")), it && Pt ? it.createHTML(d) : d;
            }, n.setConfig = function (t) {
              ae(t), Ot = !0;
            }, n.clearConfig = function () {
              re = null, Ot = !1;
            }, n.isValidAttribute = function (t, e, n) {
              re || ae({});
              var r = ne(t),
                  i = ne(e);
              return be(r, i, n);
            }, n.addHook = function (t, e) {
              "function" == typeof e && (dt[t] = dt[t] || [], p(dt[t], e));
            }, n.removeHook = function (t) {
              dt[t] && d(dt[t]);
            }, n.removeHooks = function (t) {
              dt[t] && (dt[t] = []);
            }, n.removeAllHooks = function () {
              dt = {};
            }, n;
          }();
        }();
      },
      8282: function _(t, e, n) {
        var r = n(2354);
        t.exports = {
          Graph: r.Graph,
          json: n(8974),
          alg: n(2440),
          version: r.version
        };
      },
      2842: function _(t, e, n) {
        var r = n(9126);

        t.exports = function (t) {
          var e,
              n = {},
              i = [];

          function a(i) {
            r.has(n, i) || (n[i] = !0, e.push(i), r.each(t.successors(i), a), r.each(t.predecessors(i), a));
          }

          return r.each(t.nodes(), function (t) {
            e = [], a(t), e.length && i.push(e);
          }), i;
        };
      },
      3984: function _(t, e, n) {
        var r = n(9126);

        t.exports = function (t, e, n) {
          r.isArray(e) || (e = [e]);
          var i = (t.isDirected() ? t.successors : t.neighbors).bind(t),
              a = [],
              o = {};
          return r.each(e, function (e) {
            if (!t.hasNode(e)) throw new Error("Graph does not have node: " + e);
            !function t(e, n, i, a, o, s) {
              r.has(a, n) || (a[n] = !0, i || s.push(n), r.each(o(n), function (n) {
                t(e, n, i, a, o, s);
              }), i && s.push(n));
            }(t, e, "post" === n, o, i, a);
          }), a;
        };
      },
      4847: function _(t, e, n) {
        var r = n(3763),
            i = n(9126);

        t.exports = function (t, e, n) {
          return i.transform(t.nodes(), function (i, a) {
            i[a] = r(t, a, e, n);
          }, {});
        };
      },
      3763: function _(t, e, n) {
        var r = n(9126),
            i = n(9675);

        t.exports = function (t, e, n, r) {
          return function (t, e, n, r) {
            var a,
                o,
                s = {},
                c = new i(),
                u = function u(t) {
              var e = t.v !== a ? t.v : t.w,
                  r = s[e],
                  i = n(t),
                  u = o.distance + i;
              if (i < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + t + " Weight: " + i);
              u < r.distance && (r.distance = u, r.predecessor = a, c.decrease(e, u));
            };

            for (t.nodes().forEach(function (t) {
              var n = t === e ? 0 : Number.POSITIVE_INFINITY;
              s[t] = {
                distance: n
              }, c.add(t, n);
            }); c.size() > 0 && (a = c.removeMin(), (o = s[a]).distance !== Number.POSITIVE_INFINITY);) {
              r(a).forEach(u);
            }

            return s;
          }(t, String(e), n || a, r || function (e) {
            return t.outEdges(e);
          });
        };

        var a = r.constant(1);
      },
      9096: function _(t, e, n) {
        var r = n(9126),
            i = n(5023);

        t.exports = function (t) {
          return r.filter(i(t), function (e) {
            return e.length > 1 || 1 === e.length && t.hasEdge(e[0], e[0]);
          });
        };
      },
      8924: function _(t, e, n) {
        var r = n(9126);

        t.exports = function (t, e, n) {
          return function (t, e, n) {
            var r = {},
                i = t.nodes();
            return i.forEach(function (t) {
              r[t] = {}, r[t][t] = {
                distance: 0
              }, i.forEach(function (e) {
                t !== e && (r[t][e] = {
                  distance: Number.POSITIVE_INFINITY
                });
              }), n(t).forEach(function (n) {
                var i = n.v === t ? n.w : n.v,
                    a = e(n);
                r[t][i] = {
                  distance: a,
                  predecessor: t
                };
              });
            }), i.forEach(function (t) {
              var e = r[t];
              i.forEach(function (n) {
                var a = r[n];
                i.forEach(function (n) {
                  var r = a[t],
                      i = e[n],
                      o = a[n],
                      s = r.distance + i.distance;
                  s < o.distance && (o.distance = s, o.predecessor = i.predecessor);
                });
              });
            }), r;
          }(t, e || i, n || function (e) {
            return t.outEdges(e);
          });
        };

        var i = r.constant(1);
      },
      2440: function _(t, e, n) {
        t.exports = {
          components: n(2842),
          dijkstra: n(3763),
          dijkstraAll: n(4847),
          findCycles: n(9096),
          floydWarshall: n(8924),
          isAcyclic: n(2707),
          postorder: n(8828),
          preorder: n(2648),
          prim: n(514),
          tarjan: n(5023),
          topsort: n(2166)
        };
      },
      2707: function _(t, e, n) {
        var r = n(2166);

        t.exports = function (t) {
          try {
            r(t);
          } catch (t) {
            if (t instanceof r.CycleException) return !1;
            throw t;
          }

          return !0;
        };
      },
      8828: function _(t, e, n) {
        var r = n(3984);

        t.exports = function (t, e) {
          return r(t, e, "post");
        };
      },
      2648: function _(t, e, n) {
        var r = n(3984);

        t.exports = function (t, e) {
          return r(t, e, "pre");
        };
      },
      514: function _(t, e, n) {
        var r = n(9126),
            i = n(771),
            a = n(9675);

        t.exports = function (t, e) {
          var n,
              o = new i(),
              s = {},
              c = new a();

          function u(t) {
            var r = t.v === n ? t.w : t.v,
                i = c.priority(r);

            if (void 0 !== i) {
              var a = e(t);
              a < i && (s[r] = n, c.decrease(r, a));
            }
          }

          if (0 === t.nodeCount()) return o;
          r.each(t.nodes(), function (t) {
            c.add(t, Number.POSITIVE_INFINITY), o.setNode(t);
          }), c.decrease(t.nodes()[0], 0);

          for (var l = !1; c.size() > 0;) {
            if (n = c.removeMin(), r.has(s, n)) o.setEdge(n, s[n]);else {
              if (l) throw new Error("Input graph is not connected: " + t);
              l = !0;
            }
            t.nodeEdges(n).forEach(u);
          }

          return o;
        };
      },
      5023: function _(t, e, n) {
        var r = n(9126);

        t.exports = function (t) {
          var e = 0,
              n = [],
              i = {},
              a = [];

          function o(s) {
            var c = i[s] = {
              onStack: !0,
              lowlink: e,
              index: e++
            };

            if (n.push(s), t.successors(s).forEach(function (t) {
              r.has(i, t) ? i[t].onStack && (c.lowlink = Math.min(c.lowlink, i[t].index)) : (o(t), c.lowlink = Math.min(c.lowlink, i[t].lowlink));
            }), c.lowlink === c.index) {
              var u,
                  l = [];

              do {
                u = n.pop(), i[u].onStack = !1, l.push(u);
              } while (s !== u);

              a.push(l);
            }
          }

          return t.nodes().forEach(function (t) {
            r.has(i, t) || o(t);
          }), a;
        };
      },
      2166: function _(t, e, n) {
        var r = n(9126);

        function i(t) {
          var e = {},
              n = {},
              i = [];
          if (r.each(t.sinks(), function o(s) {
            if (r.has(n, s)) throw new a();
            r.has(e, s) || (n[s] = !0, e[s] = !0, r.each(t.predecessors(s), o), delete n[s], i.push(s));
          }), r.size(e) !== t.nodeCount()) throw new a();
          return i;
        }

        function a() {}

        t.exports = i, i.CycleException = a, a.prototype = new Error();
      },
      9675: function _(t, e, n) {
        var r = n(9126);

        function i() {
          this._arr = [], this._keyIndices = {};
        }

        t.exports = i, i.prototype.size = function () {
          return this._arr.length;
        }, i.prototype.keys = function () {
          return this._arr.map(function (t) {
            return t.key;
          });
        }, i.prototype.has = function (t) {
          return r.has(this._keyIndices, t);
        }, i.prototype.priority = function (t) {
          var e = this._keyIndices[t];
          if (void 0 !== e) return this._arr[e].priority;
        }, i.prototype.min = function () {
          if (0 === this.size()) throw new Error("Queue underflow");
          return this._arr[0].key;
        }, i.prototype.add = function (t, e) {
          var n = this._keyIndices;

          if (t = String(t), !r.has(n, t)) {
            var i = this._arr,
                a = i.length;
            return n[t] = a, i.push({
              key: t,
              priority: e
            }), this._decrease(a), !0;
          }

          return !1;
        }, i.prototype.removeMin = function () {
          this._swap(0, this._arr.length - 1);

          var t = this._arr.pop();

          return delete this._keyIndices[t.key], this._heapify(0), t.key;
        }, i.prototype.decrease = function (t, e) {
          var n = this._keyIndices[t];
          if (e > this._arr[n].priority) throw new Error("New priority is greater than current priority. Key: " + t + " Old: " + this._arr[n].priority + " New: " + e);
          this._arr[n].priority = e, this._decrease(n);
        }, i.prototype._heapify = function (t) {
          var e = this._arr,
              n = 2 * t,
              r = n + 1,
              i = t;
          n < e.length && (i = e[n].priority < e[i].priority ? n : i, r < e.length && (i = e[r].priority < e[i].priority ? r : i), i !== t && (this._swap(t, i), this._heapify(i)));
        }, i.prototype._decrease = function (t) {
          for (var e, n = this._arr, r = n[t].priority; 0 !== t && !(n[e = t >> 1].priority < r);) {
            this._swap(t, e), t = e;
          }
        }, i.prototype._swap = function (t, e) {
          var n = this._arr,
              r = this._keyIndices,
              i = n[t],
              a = n[e];
          n[t] = a, n[e] = i, r[a.key] = t, r[i.key] = e;
        };
      },
      771: function _(t, e, n) {
        var r = n(9126);
        t.exports = a;
        var i = "\0";

        function a(t) {
          this._isDirected = !r.has(t, "directed") || t.directed, this._isMultigraph = !!r.has(t, "multigraph") && t.multigraph, this._isCompound = !!r.has(t, "compound") && t.compound, this._label = void 0, this._defaultNodeLabelFn = r.constant(void 0), this._defaultEdgeLabelFn = r.constant(void 0), this._nodes = {}, this._isCompound && (this._parent = {}, this._children = {}, this._children["\0"] = {}), this._in = {}, this._preds = {}, this._out = {}, this._sucs = {}, this._edgeObjs = {}, this._edgeLabels = {};
        }

        function o(t, e) {
          t[e] ? t[e]++ : t[e] = 1;
        }

        function s(t, e) {
          --t[e] || delete t[e];
        }

        function c(t, e, n, i) {
          var a = "" + e,
              o = "" + n;

          if (!t && a > o) {
            var s = a;
            a = o, o = s;
          }

          return a + "" + o + "" + (r.isUndefined(i) ? "\0" : i);
        }

        function u(t, e, n, r) {
          var i = "" + e,
              a = "" + n;

          if (!t && i > a) {
            var o = i;
            i = a, a = o;
          }

          var s = {
            v: i,
            w: a
          };
          return r && (s.name = r), s;
        }

        function l(t, e) {
          return c(t, e.v, e.w, e.name);
        }

        a.prototype._nodeCount = 0, a.prototype._edgeCount = 0, a.prototype.isDirected = function () {
          return this._isDirected;
        }, a.prototype.isMultigraph = function () {
          return this._isMultigraph;
        }, a.prototype.isCompound = function () {
          return this._isCompound;
        }, a.prototype.setGraph = function (t) {
          return this._label = t, this;
        }, a.prototype.graph = function () {
          return this._label;
        }, a.prototype.setDefaultNodeLabel = function (t) {
          return r.isFunction(t) || (t = r.constant(t)), this._defaultNodeLabelFn = t, this;
        }, a.prototype.nodeCount = function () {
          return this._nodeCount;
        }, a.prototype.nodes = function () {
          return r.keys(this._nodes);
        }, a.prototype.sources = function () {
          var t = this;
          return r.filter(this.nodes(), function (e) {
            return r.isEmpty(t._in[e]);
          });
        }, a.prototype.sinks = function () {
          var t = this;
          return r.filter(this.nodes(), function (e) {
            return r.isEmpty(t._out[e]);
          });
        }, a.prototype.setNodes = function (t, e) {
          var n = arguments,
              i = this;
          return r.each(t, function (t) {
            n.length > 1 ? i.setNode(t, e) : i.setNode(t);
          }), this;
        }, a.prototype.setNode = function (t, e) {
          return r.has(this._nodes, t) ? (arguments.length > 1 && (this._nodes[t] = e), this) : (this._nodes[t] = arguments.length > 1 ? e : this._defaultNodeLabelFn(t), this._isCompound && (this._parent[t] = i, this._children[t] = {}, this._children["\0"][t] = !0), this._in[t] = {}, this._preds[t] = {}, this._out[t] = {}, this._sucs[t] = {}, ++this._nodeCount, this);
        }, a.prototype.node = function (t) {
          return this._nodes[t];
        }, a.prototype.hasNode = function (t) {
          return r.has(this._nodes, t);
        }, a.prototype.removeNode = function (t) {
          var e = this;

          if (r.has(this._nodes, t)) {
            var n = function n(t) {
              e.removeEdge(e._edgeObjs[t]);
            };

            delete this._nodes[t], this._isCompound && (this._removeFromParentsChildList(t), delete this._parent[t], r.each(this.children(t), function (t) {
              e.setParent(t);
            }), delete this._children[t]), r.each(r.keys(this._in[t]), n), delete this._in[t], delete this._preds[t], r.each(r.keys(this._out[t]), n), delete this._out[t], delete this._sucs[t], --this._nodeCount;
          }

          return this;
        }, a.prototype.setParent = function (t, e) {
          if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
          if (r.isUndefined(e)) e = i;else {
            for (var n = e += ""; !r.isUndefined(n); n = this.parent(n)) {
              if (n === t) throw new Error("Setting " + e + " as parent of " + t + " would create a cycle");
            }

            this.setNode(e);
          }
          return this.setNode(t), this._removeFromParentsChildList(t), this._parent[t] = e, this._children[e][t] = !0, this;
        }, a.prototype._removeFromParentsChildList = function (t) {
          delete this._children[this._parent[t]][t];
        }, a.prototype.parent = function (t) {
          if (this._isCompound) {
            var e = this._parent[t];
            if (e !== i) return e;
          }
        }, a.prototype.children = function (t) {
          if (r.isUndefined(t) && (t = i), this._isCompound) {
            var e = this._children[t];
            if (e) return r.keys(e);
          } else {
            if (t === i) return this.nodes();
            if (this.hasNode(t)) return [];
          }
        }, a.prototype.predecessors = function (t) {
          var e = this._preds[t];
          if (e) return r.keys(e);
        }, a.prototype.successors = function (t) {
          var e = this._sucs[t];
          if (e) return r.keys(e);
        }, a.prototype.neighbors = function (t) {
          var e = this.predecessors(t);
          if (e) return r.union(e, this.successors(t));
        }, a.prototype.isLeaf = function (t) {
          return 0 === (this.isDirected() ? this.successors(t) : this.neighbors(t)).length;
        }, a.prototype.filterNodes = function (t) {
          var e = new this.constructor({
            directed: this._isDirected,
            multigraph: this._isMultigraph,
            compound: this._isCompound
          });
          e.setGraph(this.graph());
          var n = this;
          r.each(this._nodes, function (n, r) {
            t(r) && e.setNode(r, n);
          }), r.each(this._edgeObjs, function (t) {
            e.hasNode(t.v) && e.hasNode(t.w) && e.setEdge(t, n.edge(t));
          });
          var i = {};
          return this._isCompound && r.each(e.nodes(), function (t) {
            e.setParent(t, function t(r) {
              var a = n.parent(r);
              return void 0 === a || e.hasNode(a) ? (i[r] = a, a) : a in i ? i[a] : t(a);
            }(t));
          }), e;
        }, a.prototype.setDefaultEdgeLabel = function (t) {
          return r.isFunction(t) || (t = r.constant(t)), this._defaultEdgeLabelFn = t, this;
        }, a.prototype.edgeCount = function () {
          return this._edgeCount;
        }, a.prototype.edges = function () {
          return r.values(this._edgeObjs);
        }, a.prototype.setPath = function (t, e) {
          var n = this,
              i = arguments;
          return r.reduce(t, function (t, r) {
            return i.length > 1 ? n.setEdge(t, r, e) : n.setEdge(t, r), r;
          }), this;
        }, a.prototype.setEdge = function () {
          var t,
              e,
              n,
              i,
              a = !1,
              s = arguments[0];
          "object" == typeof s && null !== s && "v" in s ? (t = s.v, e = s.w, n = s.name, 2 === arguments.length && (i = arguments[1], a = !0)) : (t = s, e = arguments[1], n = arguments[3], arguments.length > 2 && (i = arguments[2], a = !0)), t = "" + t, e = "" + e, r.isUndefined(n) || (n = "" + n);
          var l = c(this._isDirected, t, e, n);
          if (r.has(this._edgeLabels, l)) return a && (this._edgeLabels[l] = i), this;
          if (!r.isUndefined(n) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
          this.setNode(t), this.setNode(e), this._edgeLabels[l] = a ? i : this._defaultEdgeLabelFn(t, e, n);
          var h = u(this._isDirected, t, e, n);
          return t = h.v, e = h.w, Object.freeze(h), this._edgeObjs[l] = h, o(this._preds[e], t), o(this._sucs[t], e), this._in[e][l] = h, this._out[t][l] = h, this._edgeCount++, this;
        }, a.prototype.edge = function (t, e, n) {
          var r = 1 === arguments.length ? l(this._isDirected, arguments[0]) : c(this._isDirected, t, e, n);
          return this._edgeLabels[r];
        }, a.prototype.hasEdge = function (t, e, n) {
          var i = 1 === arguments.length ? l(this._isDirected, arguments[0]) : c(this._isDirected, t, e, n);
          return r.has(this._edgeLabels, i);
        }, a.prototype.removeEdge = function (t, e, n) {
          var r = 1 === arguments.length ? l(this._isDirected, arguments[0]) : c(this._isDirected, t, e, n),
              i = this._edgeObjs[r];
          return i && (t = i.v, e = i.w, delete this._edgeLabels[r], delete this._edgeObjs[r], s(this._preds[e], t), s(this._sucs[t], e), delete this._in[e][r], delete this._out[t][r], this._edgeCount--), this;
        }, a.prototype.inEdges = function (t, e) {
          var n = this._in[t];

          if (n) {
            var i = r.values(n);
            return e ? r.filter(i, function (t) {
              return t.v === e;
            }) : i;
          }
        }, a.prototype.outEdges = function (t, e) {
          var n = this._out[t];

          if (n) {
            var i = r.values(n);
            return e ? r.filter(i, function (t) {
              return t.w === e;
            }) : i;
          }
        }, a.prototype.nodeEdges = function (t, e) {
          var n = this.inEdges(t, e);
          if (n) return n.concat(this.outEdges(t, e));
        };
      },
      2354: function _(t, e, n) {
        t.exports = {
          Graph: n(771),
          version: n(9631)
        };
      },
      8974: function _(t, e, n) {
        var r = n(9126),
            i = n(771);

        function a(t) {
          return r.map(t.nodes(), function (e) {
            var n = t.node(e),
                i = t.parent(e),
                a = {
              v: e
            };
            return r.isUndefined(n) || (a.value = n), r.isUndefined(i) || (a.parent = i), a;
          });
        }

        function o(t) {
          return r.map(t.edges(), function (e) {
            var n = t.edge(e),
                i = {
              v: e.v,
              w: e.w
            };
            return r.isUndefined(e.name) || (i.name = e.name), r.isUndefined(n) || (i.value = n), i;
          });
        }

        t.exports = {
          write: function write(t) {
            var e = {
              options: {
                directed: t.isDirected(),
                multigraph: t.isMultigraph(),
                compound: t.isCompound()
              },
              nodes: a(t),
              edges: o(t)
            };
            return r.isUndefined(t.graph()) || (e.value = r.clone(t.graph())), e;
          },
          read: function read(t) {
            var e = new i(t.options).setGraph(t.value);
            return r.each(t.nodes, function (t) {
              e.setNode(t.v, t.value), t.parent && e.setParent(t.v, t.parent);
            }), r.each(t.edges, function (t) {
              e.setEdge({
                v: t.v,
                w: t.w,
                name: t.name
              }, t.value);
            }), e;
          }
        };
      },
      9126: function _(t, e, n) {
        var r;

        try {
          r = {
            clone: n(6678),
            constant: n(5703),
            each: n(6073),
            filter: n(3105),
            has: n(8721),
            isArray: n(1469),
            isEmpty: n(1609),
            isFunction: n(3560),
            isUndefined: n(2353),
            keys: n(3674),
            map: n(5161),
            reduce: n(4061),
            size: n(4238),
            transform: n(8718),
            union: n(3386),
            values: n(2628)
          };
        } catch (t) {}

        r || (r = window._), t.exports = r;
      },
      9631: function _(t) {
        t.exports = "2.1.8";
      },
      1773: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var r = n(1083),
            i = n(7628),
            a = function () {
          function t(t, e) {
            this.color = e, this.changed = !1, this.data = t, this.type = new i.default();
          }

          return t.prototype.set = function (t, e) {
            return this.color = e, this.changed = !1, this.data = t, this.type.type = 0, this;
          }, t.prototype._ensureHSL = function () {
            var t = this.data,
                e = t.h,
                n = t.s,
                i = t.l;
            void 0 === e && (t.h = r.default.channel.rgb2hsl(t, "h")), void 0 === n && (t.s = r.default.channel.rgb2hsl(t, "s")), void 0 === i && (t.l = r.default.channel.rgb2hsl(t, "l"));
          }, t.prototype._ensureRGB = function () {
            var t = this.data,
                e = t.r,
                n = t.g,
                i = t.b;
            void 0 === e && (t.r = r.default.channel.hsl2rgb(t, "r")), void 0 === n && (t.g = r.default.channel.hsl2rgb(t, "g")), void 0 === i && (t.b = r.default.channel.hsl2rgb(t, "b"));
          }, Object.defineProperty(t.prototype, "r", {
            get: function get() {
              var t = this.data,
                  e = t.r;
              return this.type.is(2) || void 0 === e ? (this._ensureHSL(), r.default.channel.hsl2rgb(t, "r")) : e;
            },
            set: function set(t) {
              this.type.set(1), this.changed = !0, this.data.r = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "g", {
            get: function get() {
              var t = this.data,
                  e = t.g;
              return this.type.is(2) || void 0 === e ? (this._ensureHSL(), r.default.channel.hsl2rgb(t, "g")) : e;
            },
            set: function set(t) {
              this.type.set(1), this.changed = !0, this.data.g = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "b", {
            get: function get() {
              var t = this.data,
                  e = t.b;
              return this.type.is(2) || void 0 === e ? (this._ensureHSL(), r.default.channel.hsl2rgb(t, "b")) : e;
            },
            set: function set(t) {
              this.type.set(1), this.changed = !0, this.data.b = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "h", {
            get: function get() {
              var t = this.data,
                  e = t.h;
              return this.type.is(1) || void 0 === e ? (this._ensureRGB(), r.default.channel.rgb2hsl(t, "h")) : e;
            },
            set: function set(t) {
              this.type.set(2), this.changed = !0, this.data.h = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "s", {
            get: function get() {
              var t = this.data,
                  e = t.s;
              return this.type.is(1) || void 0 === e ? (this._ensureRGB(), r.default.channel.rgb2hsl(t, "s")) : e;
            },
            set: function set(t) {
              this.type.set(2), this.changed = !0, this.data.s = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "l", {
            get: function get() {
              var t = this.data,
                  e = t.l;
              return this.type.is(1) || void 0 === e ? (this._ensureRGB(), r.default.channel.rgb2hsl(t, "l")) : e;
            },
            set: function set(t) {
              this.type.set(2), this.changed = !0, this.data.l = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "a", {
            get: function get() {
              return this.data.a;
            },
            set: function set(t) {
              this.changed = !0, this.data.a = t;
            },
            enumerable: !0,
            configurable: !0
          }), t;
        }();

        e.default = a;
      },
      8167: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = new (n(1773).default)({
          r: 0,
          g: 0,
          b: 0,
          a: 0
        }, "transparent");
        e.default = r;
      },
      7628: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });

        var n = function () {
          function t() {
            this.type = 0;
          }

          return t.prototype.get = function () {
            return this.type;
          }, t.prototype.set = function (t) {
            if (this.type && this.type !== t) throw new Error("Cannot change both RGB and HSL channels at the same time");
            this.type = t;
          }, t.prototype.reset = function () {
            this.type = 0;
          }, t.prototype.is = function (t) {
            return this.type === t;
          }, t;
        }();

        e.default = n;
      },
      1655: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(8167),
            i = n(6061),
            a = {
          re: /^#((?:[a-f0-9]{2}){2,4}|[a-f0-9]{3})$/i,
          parse: function parse(t) {
            if (35 === t.charCodeAt(0)) {
              var e = t.match(a.re);

              if (e) {
                var n = e[1],
                    i = parseInt(n, 16),
                    o = n.length,
                    s = o % 4 == 0,
                    c = o > 4,
                    u = c ? 1 : 17,
                    l = c ? 8 : 4,
                    h = s ? 0 : -1,
                    f = c ? 255 : 15;
                return r.default.set({
                  r: (i >> l * (h + 3) & f) * u,
                  g: (i >> l * (h + 2) & f) * u,
                  b: (i >> l * (h + 1) & f) * u,
                  a: s ? (i & f) * u / 255 : 1
                }, t);
              }
            }
          },
          stringify: function stringify(t) {
            var e = t.r,
                n = t.g,
                r = t.b,
                a = t.a;
            return a < 1 ? "#" + i.DEC2HEX[Math.round(e)] + i.DEC2HEX[Math.round(n)] + i.DEC2HEX[Math.round(r)] + i.DEC2HEX[Math.round(255 * a)] : "#" + i.DEC2HEX[Math.round(e)] + i.DEC2HEX[Math.round(n)] + i.DEC2HEX[Math.round(r)];
          }
        };
        e.default = a;
      },
      8589: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(8167),
            a = {
          re: /^hsla?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(?:deg|grad|rad|turn)?)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?%)(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e-?\d+)?(%)?))?\s*?\)$/i,
          hueRe: /^(.+?)(deg|grad|rad|turn)$/i,
          _hue2deg: function _hue2deg(t) {
            var e = t.match(a.hueRe);

            if (e) {
              var n = e[1];

              switch (e[2]) {
                case "grad":
                  return r.default.channel.clamp.h(.9 * parseFloat(n));

                case "rad":
                  return r.default.channel.clamp.h(180 * parseFloat(n) / Math.PI);

                case "turn":
                  return r.default.channel.clamp.h(360 * parseFloat(n));
              }
            }

            return r.default.channel.clamp.h(parseFloat(t));
          },
          parse: function parse(t) {
            var e = t.charCodeAt(0);

            if (104 === e || 72 === e) {
              var n = t.match(a.re);

              if (n) {
                var o = n[1],
                    s = n[2],
                    c = n[3],
                    u = n[4],
                    l = n[5];
                return i.default.set({
                  h: a._hue2deg(o),
                  s: r.default.channel.clamp.s(parseFloat(s)),
                  l: r.default.channel.clamp.l(parseFloat(c)),
                  a: u ? r.default.channel.clamp.a(l ? parseFloat(u) / 100 : parseFloat(u)) : 1
                }, t);
              }
            }
          },
          stringify: function stringify(t) {
            var e = t.h,
                n = t.s,
                i = t.l,
                a = t.a;
            return a < 1 ? "hsla(" + r.default.lang.round(e) + ", " + r.default.lang.round(n) + "%, " + r.default.lang.round(i) + "%, " + a + ")" : "hsl(" + r.default.lang.round(e) + ", " + r.default.lang.round(n) + "%, " + r.default.lang.round(i) + "%)";
          }
        };
        e.default = a;
      },
      2191: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1655),
            i = n(7538),
            a = n(6762),
            o = n(8589),
            s = {
          format: {
            keyword: i.default,
            hex: r.default,
            rgb: a.default,
            rgba: a.default,
            hsl: o.default,
            hsla: o.default
          },
          parse: function parse(t) {
            if ("string" != typeof t) return t;
            var e = r.default.parse(t) || a.default.parse(t) || o.default.parse(t) || i.default.parse(t);
            if (e) return e;
            throw new Error('Unsupported color format: "' + t + '"');
          },
          stringify: function stringify(t) {
            return !t.changed && t.color ? t.color : t.type.is(2) || void 0 === t.data.r ? o.default.stringify(t) : t.a < 1 || !Number.isInteger(t.r) || !Number.isInteger(t.g) || !Number.isInteger(t.b) ? a.default.stringify(t) : r.default.stringify(t);
          }
        };
        e.default = s;
      },
      7538: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1655),
            i = {
          colors: {
            aliceblue: "#f0f8ff",
            antiquewhite: "#faebd7",
            aqua: "#00ffff",
            aquamarine: "#7fffd4",
            azure: "#f0ffff",
            beige: "#f5f5dc",
            bisque: "#ffe4c4",
            black: "#000000",
            blanchedalmond: "#ffebcd",
            blue: "#0000ff",
            blueviolet: "#8a2be2",
            brown: "#a52a2a",
            burlywood: "#deb887",
            cadetblue: "#5f9ea0",
            chartreuse: "#7fff00",
            chocolate: "#d2691e",
            coral: "#ff7f50",
            cornflowerblue: "#6495ed",
            cornsilk: "#fff8dc",
            crimson: "#dc143c",
            cyanaqua: "#00ffff",
            darkblue: "#00008b",
            darkcyan: "#008b8b",
            darkgoldenrod: "#b8860b",
            darkgray: "#a9a9a9",
            darkgreen: "#006400",
            darkgrey: "#a9a9a9",
            darkkhaki: "#bdb76b",
            darkmagenta: "#8b008b",
            darkolivegreen: "#556b2f",
            darkorange: "#ff8c00",
            darkorchid: "#9932cc",
            darkred: "#8b0000",
            darksalmon: "#e9967a",
            darkseagreen: "#8fbc8f",
            darkslateblue: "#483d8b",
            darkslategray: "#2f4f4f",
            darkslategrey: "#2f4f4f",
            darkturquoise: "#00ced1",
            darkviolet: "#9400d3",
            deeppink: "#ff1493",
            deepskyblue: "#00bfff",
            dimgray: "#696969",
            dimgrey: "#696969",
            dodgerblue: "#1e90ff",
            firebrick: "#b22222",
            floralwhite: "#fffaf0",
            forestgreen: "#228b22",
            fuchsia: "#ff00ff",
            gainsboro: "#dcdcdc",
            ghostwhite: "#f8f8ff",
            gold: "#ffd700",
            goldenrod: "#daa520",
            gray: "#808080",
            green: "#008000",
            greenyellow: "#adff2f",
            grey: "#808080",
            honeydew: "#f0fff0",
            hotpink: "#ff69b4",
            indianred: "#cd5c5c",
            indigo: "#4b0082",
            ivory: "#fffff0",
            khaki: "#f0e68c",
            lavender: "#e6e6fa",
            lavenderblush: "#fff0f5",
            lawngreen: "#7cfc00",
            lemonchiffon: "#fffacd",
            lightblue: "#add8e6",
            lightcoral: "#f08080",
            lightcyan: "#e0ffff",
            lightgoldenrodyellow: "#fafad2",
            lightgray: "#d3d3d3",
            lightgreen: "#90ee90",
            lightgrey: "#d3d3d3",
            lightpink: "#ffb6c1",
            lightsalmon: "#ffa07a",
            lightseagreen: "#20b2aa",
            lightskyblue: "#87cefa",
            lightslategray: "#778899",
            lightslategrey: "#778899",
            lightsteelblue: "#b0c4de",
            lightyellow: "#ffffe0",
            lime: "#00ff00",
            limegreen: "#32cd32",
            linen: "#faf0e6",
            magenta: "#ff00ff",
            maroon: "#800000",
            mediumaquamarine: "#66cdaa",
            mediumblue: "#0000cd",
            mediumorchid: "#ba55d3",
            mediumpurple: "#9370db",
            mediumseagreen: "#3cb371",
            mediumslateblue: "#7b68ee",
            mediumspringgreen: "#00fa9a",
            mediumturquoise: "#48d1cc",
            mediumvioletred: "#c71585",
            midnightblue: "#191970",
            mintcream: "#f5fffa",
            mistyrose: "#ffe4e1",
            moccasin: "#ffe4b5",
            navajowhite: "#ffdead",
            navy: "#000080",
            oldlace: "#fdf5e6",
            olive: "#808000",
            olivedrab: "#6b8e23",
            orange: "#ffa500",
            orangered: "#ff4500",
            orchid: "#da70d6",
            palegoldenrod: "#eee8aa",
            palegreen: "#98fb98",
            paleturquoise: "#afeeee",
            palevioletred: "#db7093",
            papayawhip: "#ffefd5",
            peachpuff: "#ffdab9",
            peru: "#cd853f",
            pink: "#ffc0cb",
            plum: "#dda0dd",
            powderblue: "#b0e0e6",
            purple: "#800080",
            rebeccapurple: "#663399",
            red: "#ff0000",
            rosybrown: "#bc8f8f",
            royalblue: "#4169e1",
            saddlebrown: "#8b4513",
            salmon: "#fa8072",
            sandybrown: "#f4a460",
            seagreen: "#2e8b57",
            seashell: "#fff5ee",
            sienna: "#a0522d",
            silver: "#c0c0c0",
            skyblue: "#87ceeb",
            slateblue: "#6a5acd",
            slategray: "#708090",
            slategrey: "#708090",
            snow: "#fffafa",
            springgreen: "#00ff7f",
            tan: "#d2b48c",
            teal: "#008080",
            thistle: "#d8bfd8",
            transparent: "#00000000",
            turquoise: "#40e0d0",
            violet: "#ee82ee",
            wheat: "#f5deb3",
            white: "#ffffff",
            whitesmoke: "#f5f5f5",
            yellow: "#ffff00",
            yellowgreen: "#9acd32"
          },
          parse: function parse(t) {
            t = t.toLowerCase();
            var e = i.colors[t];
            if (e) return r.default.parse(e);
          },
          stringify: function stringify(t) {
            var e = r.default.stringify(t);

            for (var n in i.colors) {
              if (i.colors[n] === e) return n;
            }
          }
        };
        e.default = i;
      },
      6762: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(8167),
            a = {
          re: /^rgba?\(\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))\s*?(?:,|\s)\s*?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?))(?:\s*?(?:,|\/)\s*?\+?(-?(?:\d+(?:\.\d+)?|(?:\.\d+))(?:e\d+)?(%?)))?\s*?\)$/i,
          parse: function parse(t) {
            var e = t.charCodeAt(0);

            if (114 === e || 82 === e) {
              var n = t.match(a.re);

              if (n) {
                var o = n[1],
                    s = n[2],
                    c = n[3],
                    u = n[4],
                    l = n[5],
                    h = n[6],
                    f = n[7],
                    d = n[8];
                return i.default.set({
                  r: r.default.channel.clamp.r(s ? 2.55 * parseFloat(o) : parseFloat(o)),
                  g: r.default.channel.clamp.g(u ? 2.55 * parseFloat(c) : parseFloat(c)),
                  b: r.default.channel.clamp.b(h ? 2.55 * parseFloat(l) : parseFloat(l)),
                  a: f ? r.default.channel.clamp.a(d ? parseFloat(f) / 100 : parseFloat(f)) : 1
                }, t);
              }
            }
          },
          stringify: function stringify(t) {
            var e = t.r,
                n = t.g,
                i = t.b,
                a = t.a;
            return a < 1 ? "rgba(" + r.default.lang.round(e) + ", " + r.default.lang.round(n) + ", " + r.default.lang.round(i) + ", " + r.default.lang.round(a) + ")" : "rgb(" + r.default.lang.round(e) + ", " + r.default.lang.round(n) + ", " + r.default.lang.round(i) + ")";
          }
        };
        e.default = a;
      },
      6061: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = {};
        e.DEC2HEX = i;

        for (var a = 0; a <= 255; a++) {
          i[a] = r.default.unit.dec2hex(a);
        }
      },
      8613: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), function (t) {
          for (var n in t) {
            e.hasOwnProperty(n) || (e[n] = t[n]);
          }
        }(n(1203));
      },
      5371: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191),
            i = n(418);

        e.default = function (t, e) {
          var n = r.default.parse(t),
              a = {};

          for (var o in e) {
            e[o] && (a[o] = n[o] + e[o]);
          }

          return i.default(t, a);
        };
      },
      1416: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(2191);

        e.default = function (t, e, n) {
          var a = i.default.parse(t),
              o = a[e],
              s = r.default.channel.clamp[e](o + n);
          return o !== s && (a[e] = s), i.default.stringify(a);
        };
      },
      9353: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "a");
        };
      },
      3394: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "b");
        };
      },
      418: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(2191);

        e.default = function (t, e) {
          var n = i.default.parse(t);

          for (var a in e) {
            n[a] = r.default.channel.clamp[a](e[a]);
          }

          return i.default.stringify(n);
        };
      },
      6197: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(2191);

        e.default = function (t, e) {
          return r.default.lang.round(i.default.parse(t)[e]);
        };
      },
      7361: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t) {
          return r.default(t, "h", 180);
        };
      },
      3042: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(8346);

        e.default = function (t, e) {
          var n = i.default(t),
              a = i.default(e),
              o = Math.max(n, a),
              s = Math.min(n, a),
              c = (o + Number.EPSILON) / (s + Number.EPSILON);
          return r.default.lang.round(r.default.lang.clamp(c, 1, 10));
        };
      },
      1364: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t, e) {
          return r.default(t, "l", -e);
        };
      },
      9610: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t, e) {
          return r.default(t, "s", -e);
        };
      },
      572: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(418);

        e.default = function (t) {
          return r.default(t, {
            s: 0
          });
        };
      },
      2299: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "g");
        };
      },
      3116: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(8167),
            a = n(2191);

        e.default = function (t, e, n, o) {
          void 0 === o && (o = 1);
          var s = i.default.set({
            h: r.default.channel.clamp.h(t),
            s: r.default.channel.clamp.s(e),
            l: r.default.channel.clamp.l(n),
            a: r.default.channel.clamp.a(o)
          });
          return a.default.stringify(s);
        };
      },
      3008: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "h");
        };
      },
      1203: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6538);
        e.hex = r.default;
        var i = n(6538);
        e.rgb = i.default;
        var a = n(6538);
        e.rgba = a.default;
        var o = n(3116);
        e.hsl = o.default;
        var s = n(3116);
        e.hsla = s.default;
        var c = n(2619);
        e.toKeyword = c.default;
        var u = n(4307);
        e.toHex = u.default;
        var l = n(4125);
        e.toRgba = l.default;
        var h = n(7329);
        e.toHsla = h.default;
        var f = n(6197);
        e.channel = f.default;
        var d = n(9640);
        e.red = d.default;
        var p = n(2299);
        e.green = p.default;
        var y = n(3394);
        e.blue = y.default;
        var g = n(3008);
        e.hue = g.default;
        var m = n(6451);
        e.saturation = m.default;
        var v = n(9235);
        e.lightness = v.default;
        var b = n(9353);
        e.alpha = b.default;

        var _ = n(9353);

        e.opacity = _.default;
        var x = n(3042);
        e.contrast = x.default;
        var w = n(8346);
        e.luminance = w.default;
        var k = n(4117);
        e.isDark = k.default;
        var T = n(2224);
        e.isLight = T.default;
        var E = n(585);
        e.isValid = E.default;
        var C = n(1080);
        e.saturate = C.default;
        var S = n(9610);
        e.desaturate = S.default;
        var A = n(3235);
        e.lighten = A.default;
        var M = n(1364);
        e.darken = M.default;
        var N = n(7189);
        e.opacify = N.default;
        var D = n(7189);
        e.fadeIn = D.default;
        var O = n(4989);
        e.transparentize = O.default;
        var B = n(4989);
        e.fadeOut = B.default;
        var L = n(7361);
        e.complement = L.default;
        var I = n(572);
        e.grayscale = I.default;
        var R = n(5371);
        e.adjust = R.default;
        var P = n(418);
        e.change = P.default;
        var F = n(566);
        e.invert = F.default;
        var j = n(1861);
        e.mix = j.default;
        var Y = n(7081);
        e.scale = Y.default;
      },
      566: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191),
            i = n(1861);

        e.default = function (t, e) {
          void 0 === e && (e = 100);
          var n = r.default.parse(t);
          return n.r = 255 - n.r, n.g = 255 - n.g, n.b = 255 - n.b, i.default(n, t, e);
        };
      },
      4117: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2224);

        e.default = function (t) {
          return !r.default(t);
        };
      },
      2224: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(8346);

        e.default = function (t) {
          return r.default(t) >= .5;
        };
      },
      585: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191);

        e.default = function (t) {
          try {
            return r.default.parse(t), !0;
          } catch (t) {
            return !1;
          }
        };
      },
      3235: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t, e) {
          return r.default(t, "l", e);
        };
      },
      9235: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "l");
        };
      },
      8346: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(2191);

        e.default = function (t) {
          var e = i.default.parse(t),
              n = e.r,
              a = e.g,
              o = e.b,
              s = .2126 * r.default.channel.toLinear(n) + .7152 * r.default.channel.toLinear(a) + .0722 * r.default.channel.toLinear(o);
          return r.default.lang.round(s);
        };
      },
      1861: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191),
            i = n(6538);

        e.default = function (t, e, n) {
          void 0 === n && (n = 50);

          var a = r.default.parse(t),
              o = a.r,
              s = a.g,
              c = a.b,
              u = a.a,
              l = r.default.parse(e),
              h = l.r,
              f = l.g,
              d = l.b,
              p = l.a,
              y = n / 100,
              g = 2 * y - 1,
              m = u - p,
              v = ((g * m == -1 ? g : (g + m) / (1 + g * m)) + 1) / 2,
              b = 1 - v,
              _ = o * v + h * b,
              x = s * v + f * b,
              w = c * v + d * b,
              k = u * y + p * (1 - y);

          return i.default(_, x, w, k);
        };
      },
      7189: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t, e) {
          return r.default(t, "a", e);
        };
      },
      9640: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "r");
        };
      },
      6538: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(8167),
            a = n(2191),
            o = n(418);

        e.default = function (t, e, n, s) {
          if (void 0 === n && (n = 0), void 0 === s && (s = 1), "number" != typeof t) return o.default(t, {
            a: e
          });
          var c = i.default.set({
            r: r.default.channel.clamp.r(t),
            g: r.default.channel.clamp.g(e),
            b: r.default.channel.clamp.b(n),
            a: r.default.channel.clamp.a(s)
          });
          return a.default.stringify(c);
        };
      },
      1080: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t, e) {
          return r.default(t, "s", e);
        };
      },
      6451: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(6197);

        e.default = function (t) {
          return r.default(t, "s");
        };
      },
      7081: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1083),
            i = n(2191),
            a = n(5371);

        e.default = function (t, e) {
          var n,
              o,
              s,
              c = i.default.parse(t),
              u = {};

          for (var l in e) {
            u[l] = (n = c[l], o = e[l], s = r.default.channel.max[l], o > 0 ? (s - n) * o / 100 : n * o / 100);
          }

          return a.default(t, u);
        };
      },
      4307: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191);

        e.default = function (t) {
          return r.default.format.hex.stringify(r.default.parse(t));
        };
      },
      7329: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191);

        e.default = function (t) {
          return r.default.format.hsla.stringify(r.default.parse(t));
        };
      },
      2619: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191);

        e.default = function (t) {
          return r.default.format.keyword.stringify(r.default.parse(t));
        };
      },
      4125: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(2191);

        e.default = function (t) {
          return r.default.format.rgba.stringify(r.default.parse(t));
        };
      },
      4989: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(1416);

        e.default = function (t, e) {
          return r.default(t, "a", -e);
        };
      },
      7994: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = {
          min: {
            r: 0,
            g: 0,
            b: 0,
            s: 0,
            l: 0,
            a: 0
          },
          max: {
            r: 255,
            g: 255,
            b: 255,
            h: 360,
            s: 100,
            l: 100,
            a: 1
          },
          clamp: {
            r: function r(t) {
              return t >= 255 ? 255 : t < 0 ? 0 : t;
            },
            g: function g(t) {
              return t >= 255 ? 255 : t < 0 ? 0 : t;
            },
            b: function b(t) {
              return t >= 255 ? 255 : t < 0 ? 0 : t;
            },
            h: function h(t) {
              return t % 360;
            },
            s: function s(t) {
              return t >= 100 ? 100 : t < 0 ? 0 : t;
            },
            l: function l(t) {
              return t >= 100 ? 100 : t < 0 ? 0 : t;
            },
            a: function a(t) {
              return t >= 1 ? 1 : t < 0 ? 0 : t;
            }
          },
          toLinear: function toLinear(t) {
            var e = t / 255;
            return t > .03928 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92;
          },
          hue2rgb: function hue2rgb(t, e, n) {
            return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
          },
          hsl2rgb: function hsl2rgb(t, e) {
            var r = t.h,
                i = t.s,
                a = t.l;
            if (!i) return 2.55 * a;
            r /= 360, i /= 100;
            var o = (a /= 100) < .5 ? a * (1 + i) : a + i - a * i,
                s = 2 * a - o;

            switch (e) {
              case "r":
                return 255 * n.hue2rgb(s, o, r + 1 / 3);

              case "g":
                return 255 * n.hue2rgb(s, o, r);

              case "b":
                return 255 * n.hue2rgb(s, o, r - 1 / 3);
            }
          },
          rgb2hsl: function rgb2hsl(t, e) {
            var n = t.r,
                r = t.g,
                i = t.b;
            n /= 255, r /= 255, i /= 255;
            var a = Math.max(n, r, i),
                o = Math.min(n, r, i),
                s = (a + o) / 2;
            if ("l" === e) return 100 * s;
            if (a === o) return 0;
            var c = a - o;
            if ("s" === e) return 100 * (s > .5 ? c / (2 - a - o) : c / (a + o));

            switch (a) {
              case n:
                return 60 * ((r - i) / c + (r < i ? 6 : 0));

              case r:
                return 60 * ((i - n) / c + 2);

              case i:
                return 60 * ((n - r) / c + 4);

              default:
                return -1;
            }
          }
        };
        e.default = n;
      },
      1083: function _(t, e, n) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = n(7994),
            i = n(4027),
            a = n(318),
            o = {
          channel: r.default,
          lang: i.default,
          unit: a.default
        };
        e.default = o;
      },
      4027: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = {
          clamp: function clamp(t, e, n) {
            return e > n ? Math.min(e, Math.max(n, t)) : Math.min(n, Math.max(e, t));
          },
          round: function round(t) {
            return Math.round(1e10 * t) / 1e10;
          }
        };
        e.default = n;
      },
      318: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = {
          dec2hex: function dec2hex(t) {
            var e = Math.round(t).toString(16);
            return e.length > 1 ? e : "0" + e;
          }
        };
        e.default = n;
      },
      8552: function _(t, e, n) {
        var r = n(852)(n(5639), "DataView");
        t.exports = r;
      },
      1989: function _(t, e, n) {
        var r = n(1789),
            i = n(401),
            a = n(7667),
            o = n(1327),
            s = n(1866);

        function c(t) {
          var e = -1,
              n = null == t ? 0 : t.length;

          for (this.clear(); ++e < n;) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }

        c.prototype.clear = r, c.prototype.delete = i, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, t.exports = c;
      },
      8407: function _(t, e, n) {
        var r = n(7040),
            i = n(1362),
            a = n(2117),
            o = n(7518),
            s = n(4705);

        function c(t) {
          var e = -1,
              n = null == t ? 0 : t.length;

          for (this.clear(); ++e < n;) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }

        c.prototype.clear = r, c.prototype.delete = i, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, t.exports = c;
      },
      7071: function _(t, e, n) {
        var r = n(852)(n(5639), "Map");
        t.exports = r;
      },
      3369: function _(t, e, n) {
        var r = n(4785),
            i = n(1285),
            a = n(6e3),
            o = n(9916),
            s = n(5265);

        function c(t) {
          var e = -1,
              n = null == t ? 0 : t.length;

          for (this.clear(); ++e < n;) {
            var r = t[e];
            this.set(r[0], r[1]);
          }
        }

        c.prototype.clear = r, c.prototype.delete = i, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, t.exports = c;
      },
      3818: function _(t, e, n) {
        var r = n(852)(n(5639), "Promise");
        t.exports = r;
      },
      8525: function _(t, e, n) {
        var r = n(852)(n(5639), "Set");
        t.exports = r;
      },
      8668: function _(t, e, n) {
        var r = n(3369),
            i = n(619),
            a = n(2385);

        function o(t) {
          var e = -1,
              n = null == t ? 0 : t.length;

          for (this.__data__ = new r(); ++e < n;) {
            this.add(t[e]);
          }
        }

        o.prototype.add = o.prototype.push = i, o.prototype.has = a, t.exports = o;
      },
      6384: function _(t, e, n) {
        var r = n(8407),
            i = n(7465),
            a = n(3779),
            o = n(7599),
            s = n(4758),
            c = n(4309);

        function u(t) {
          var e = this.__data__ = new r(t);
          this.size = e.size;
        }

        u.prototype.clear = i, u.prototype.delete = a, u.prototype.get = o, u.prototype.has = s, u.prototype.set = c, t.exports = u;
      },
      2705: function _(t, e, n) {
        var r = n(5639).Symbol;
        t.exports = r;
      },
      1149: function _(t, e, n) {
        var r = n(5639).Uint8Array;
        t.exports = r;
      },
      577: function _(t, e, n) {
        var r = n(852)(n(5639), "WeakMap");
        t.exports = r;
      },
      6874: function _(t) {
        t.exports = function (t, e, n) {
          switch (n.length) {
            case 0:
              return t.call(e);

            case 1:
              return t.call(e, n[0]);

            case 2:
              return t.call(e, n[0], n[1]);

            case 3:
              return t.call(e, n[0], n[1], n[2]);
          }

          return t.apply(e, n);
        };
      },
      7412: function _(t) {
        t.exports = function (t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
            ;
          }

          return t;
        };
      },
      4963: function _(t) {
        t.exports = function (t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, i = 0, a = []; ++n < r;) {
            var o = t[n];
            e(o, n, t) && (a[i++] = o);
          }

          return a;
        };
      },
      7443: function _(t, e, n) {
        var r = n(2118);

        t.exports = function (t, e) {
          return !(null == t || !t.length) && r(t, e, 0) > -1;
        };
      },
      1196: function _(t) {
        t.exports = function (t, e, n) {
          for (var r = -1, i = null == t ? 0 : t.length; ++r < i;) {
            if (n(e, t[r])) return !0;
          }

          return !1;
        };
      },
      4636: function _(t, e, n) {
        var r = n(2545),
            i = n(5694),
            a = n(1469),
            o = n(4144),
            s = n(5776),
            c = n(6719),
            u = Object.prototype.hasOwnProperty;

        t.exports = function (t, e) {
          var n = a(t),
              l = !n && i(t),
              h = !n && !l && o(t),
              f = !n && !l && !h && c(t),
              d = n || l || h || f,
              p = d ? r(t.length, String) : [],
              y = p.length;

          for (var g in t) {
            !e && !u.call(t, g) || d && ("length" == g || h && ("offset" == g || "parent" == g) || f && ("buffer" == g || "byteLength" == g || "byteOffset" == g) || s(g, y)) || p.push(g);
          }

          return p;
        };
      },
      9932: function _(t) {
        t.exports = function (t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) {
            i[n] = e(t[n], n, t);
          }

          return i;
        };
      },
      2488: function _(t) {
        t.exports = function (t, e) {
          for (var n = -1, r = e.length, i = t.length; ++n < r;) {
            t[i + n] = e[n];
          }

          return t;
        };
      },
      2663: function _(t) {
        t.exports = function (t, e, n, r) {
          var i = -1,
              a = null == t ? 0 : t.length;

          for (r && a && (n = t[++i]); ++i < a;) {
            n = e(n, t[i], i, t);
          }

          return n;
        };
      },
      2908: function _(t) {
        t.exports = function (t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
            if (e(t[n], n, t)) return !0;
          }

          return !1;
        };
      },
      8983: function _(t, e, n) {
        var r = n(371)("length");
        t.exports = r;
      },
      6556: function _(t, e, n) {
        var r = n(9465),
            i = n(7813);

        t.exports = function (t, e, n) {
          (void 0 !== n && !i(t[e], n) || void 0 === n && !(e in t)) && r(t, e, n);
        };
      },
      4865: function _(t, e, n) {
        var r = n(9465),
            i = n(7813),
            a = Object.prototype.hasOwnProperty;

        t.exports = function (t, e, n) {
          var o = t[e];
          a.call(t, e) && i(o, n) && (void 0 !== n || e in t) || r(t, e, n);
        };
      },
      8470: function _(t, e, n) {
        var r = n(7813);

        t.exports = function (t, e) {
          for (var n = t.length; n--;) {
            if (r(t[n][0], e)) return n;
          }

          return -1;
        };
      },
      4037: function _(t, e, n) {
        var r = n(8363),
            i = n(3674);

        t.exports = function (t, e) {
          return t && r(e, i(e), t);
        };
      },
      3886: function _(t, e, n) {
        var r = n(8363),
            i = n(1704);

        t.exports = function (t, e) {
          return t && r(e, i(e), t);
        };
      },
      9465: function _(t, e, n) {
        var r = n(8777);

        t.exports = function (t, e, n) {
          "__proto__" == e && r ? r(t, e, {
            configurable: !0,
            enumerable: !0,
            value: n,
            writable: !0
          }) : t[e] = n;
        };
      },
      5990: function _(t, e, n) {
        var r = n(6384),
            i = n(7412),
            a = n(4865),
            o = n(4037),
            s = n(3886),
            c = n(4626),
            u = n(278),
            l = n(8805),
            h = n(1911),
            f = n(8234),
            d = n(6904),
            p = n(4160),
            y = n(3824),
            g = n(9148),
            m = n(8517),
            v = n(1469),
            b = n(4144),
            _ = n(6688),
            x = n(3218),
            w = n(2928),
            k = n(3674),
            T = n(1704),
            E = "[object Arguments]",
            C = "[object Function]",
            S = "[object Object]",
            A = {};

        A[E] = A["[object Array]"] = A["[object ArrayBuffer]"] = A["[object DataView]"] = A["[object Boolean]"] = A["[object Date]"] = A["[object Float32Array]"] = A["[object Float64Array]"] = A["[object Int8Array]"] = A["[object Int16Array]"] = A["[object Int32Array]"] = A["[object Map]"] = A["[object Number]"] = A[S] = A["[object RegExp]"] = A["[object Set]"] = A["[object String]"] = A["[object Symbol]"] = A["[object Uint8Array]"] = A["[object Uint8ClampedArray]"] = A["[object Uint16Array]"] = A["[object Uint32Array]"] = !0, A["[object Error]"] = A[C] = A["[object WeakMap]"] = !1, t.exports = function t(e, n, M, N, D, O) {
          var B,
              L = 1 & n,
              I = 2 & n,
              R = 4 & n;
          if (M && (B = D ? M(e, N, D, O) : M(e)), void 0 !== B) return B;
          if (!x(e)) return e;
          var P = v(e);

          if (P) {
            if (B = y(e), !L) return u(e, B);
          } else {
            var F = p(e),
                j = F == C || "[object GeneratorFunction]" == F;
            if (b(e)) return c(e, L);

            if (F == S || F == E || j && !D) {
              if (B = I || j ? {} : m(e), !L) return I ? h(e, s(B, e)) : l(e, o(B, e));
            } else {
              if (!A[F]) return D ? e : {};
              B = g(e, F, L);
            }
          }

          O || (O = new r());
          var Y = O.get(e);
          if (Y) return Y;
          O.set(e, B), w(e) ? e.forEach(function (r) {
            B.add(t(r, n, M, r, e, O));
          }) : _(e) && e.forEach(function (r, i) {
            B.set(i, t(r, n, M, i, e, O));
          });
          var U = P ? void 0 : (R ? I ? d : f : I ? T : k)(e);
          return i(U || e, function (r, i) {
            U && (r = e[i = r]), a(B, i, t(r, n, M, i, e, O));
          }), B;
        };
      },
      3118: function _(t, e, n) {
        var r = n(3218),
            i = Object.create,
            a = function () {
          function t() {}

          return function (e) {
            if (!r(e)) return {};
            if (i) return i(e);
            t.prototype = e;
            var n = new t();
            return t.prototype = void 0, n;
          };
        }();

        t.exports = a;
      },
      9881: function _(t, e, n) {
        var r = n(7816),
            i = n(9291)(r);
        t.exports = i;
      },
      6029: function _(t, e, n) {
        var r = n(3448);

        t.exports = function (t, e, n) {
          for (var i = -1, a = t.length; ++i < a;) {
            var o = t[i],
                s = e(o);
            if (null != s && (void 0 === c ? s == s && !r(s) : n(s, c))) var c = s,
                u = o;
          }

          return u;
        };
      },
      760: function _(t, e, n) {
        var r = n(9881);

        t.exports = function (t, e) {
          var n = [];
          return r(t, function (t, r, i) {
            e(t, r, i) && n.push(t);
          }), n;
        };
      },
      1848: function _(t) {
        t.exports = function (t, e, n, r) {
          for (var i = t.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) {
            if (e(t[a], a, t)) return a;
          }

          return -1;
        };
      },
      1078: function _(t, e, n) {
        var r = n(2488),
            i = n(7285);

        t.exports = function t(e, n, a, o, s) {
          var c = -1,
              u = e.length;

          for (a || (a = i), s || (s = []); ++c < u;) {
            var l = e[c];
            n > 0 && a(l) ? n > 1 ? t(l, n - 1, a, o, s) : r(s, l) : o || (s[s.length] = l);
          }

          return s;
        };
      },
      8483: function _(t, e, n) {
        var r = n(5063)();
        t.exports = r;
      },
      7816: function _(t, e, n) {
        var r = n(8483),
            i = n(3674);

        t.exports = function (t, e) {
          return t && r(t, e, i);
        };
      },
      7786: function _(t, e, n) {
        var r = n(1811),
            i = n(327);

        t.exports = function (t, e) {
          for (var n = 0, a = (e = r(e, t)).length; null != t && n < a;) {
            t = t[i(e[n++])];
          }

          return n && n == a ? t : void 0;
        };
      },
      8866: function _(t, e, n) {
        var r = n(2488),
            i = n(1469);

        t.exports = function (t, e, n) {
          var a = e(t);
          return i(t) ? a : r(a, n(t));
        };
      },
      4239: function _(t, e, n) {
        var r = n(2705),
            i = n(9607),
            a = n(2333),
            o = r ? r.toStringTag : void 0;

        t.exports = function (t) {
          return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : o && o in Object(t) ? i(t) : a(t);
        };
      },
      3325: function _(t) {
        t.exports = function (t, e) {
          return t > e;
        };
      },
      8565: function _(t) {
        var e = Object.prototype.hasOwnProperty;

        t.exports = function (t, n) {
          return null != t && e.call(t, n);
        };
      },
      13: function _(t) {
        t.exports = function (t, e) {
          return null != t && e in Object(t);
        };
      },
      2118: function _(t, e, n) {
        var r = n(1848),
            i = n(2722),
            a = n(2351);

        t.exports = function (t, e, n) {
          return e == e ? a(t, e, n) : r(t, i, n);
        };
      },
      9454: function _(t, e, n) {
        var r = n(4239),
            i = n(7005);

        t.exports = function (t) {
          return i(t) && "[object Arguments]" == r(t);
        };
      },
      939: function _(t, e, n) {
        var r = n(2492),
            i = n(7005);

        t.exports = function t(e, n, a, o, s) {
          return e === n || (null == e || null == n || !i(e) && !i(n) ? e != e && n != n : r(e, n, a, o, t, s));
        };
      },
      2492: function _(t, e, n) {
        var r = n(6384),
            i = n(7114),
            a = n(8351),
            o = n(6096),
            s = n(4160),
            c = n(1469),
            u = n(4144),
            l = n(6719),
            h = "[object Arguments]",
            f = "[object Array]",
            d = "[object Object]",
            p = Object.prototype.hasOwnProperty;

        t.exports = function (t, e, n, y, g, m) {
          var v = c(t),
              b = c(e),
              _ = v ? f : s(t),
              x = b ? f : s(e),
              w = (_ = _ == h ? d : _) == d,
              k = (x = x == h ? d : x) == d,
              T = _ == x;

          if (T && u(t)) {
            if (!u(e)) return !1;
            v = !0, w = !1;
          }

          if (T && !w) return m || (m = new r()), v || l(t) ? i(t, e, n, y, g, m) : a(t, e, _, n, y, g, m);

          if (!(1 & n)) {
            var E = w && p.call(t, "__wrapped__"),
                C = k && p.call(e, "__wrapped__");

            if (E || C) {
              var S = E ? t.value() : t,
                  A = C ? e.value() : e;
              return m || (m = new r()), g(S, A, n, y, m);
            }
          }

          return !!T && (m || (m = new r()), o(t, e, n, y, g, m));
        };
      },
      5588: function _(t, e, n) {
        var r = n(4160),
            i = n(7005);

        t.exports = function (t) {
          return i(t) && "[object Map]" == r(t);
        };
      },
      2958: function _(t, e, n) {
        var r = n(6384),
            i = n(939);

        t.exports = function (t, e, n, a) {
          var o = n.length,
              s = o,
              c = !a;
          if (null == t) return !s;

          for (t = Object(t); o--;) {
            var u = n[o];
            if (c && u[2] ? u[1] !== t[u[0]] : !(u[0] in t)) return !1;
          }

          for (; ++o < s;) {
            var l = (u = n[o])[0],
                h = t[l],
                f = u[1];

            if (c && u[2]) {
              if (void 0 === h && !(l in t)) return !1;
            } else {
              var d = new r();
              if (a) var p = a(h, f, l, t, e, d);
              if (!(void 0 === p ? i(f, h, 3, a, d) : p)) return !1;
            }
          }

          return !0;
        };
      },
      2722: function _(t) {
        t.exports = function (t) {
          return t != t;
        };
      },
      8458: function _(t, e, n) {
        var r = n(3560),
            i = n(5346),
            a = n(3218),
            o = n(346),
            s = /^\[object .+?Constructor\]$/,
            c = Function.prototype,
            u = Object.prototype,
            l = c.toString,
            h = u.hasOwnProperty,
            f = RegExp("^" + l.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

        t.exports = function (t) {
          return !(!a(t) || i(t)) && (r(t) ? f : s).test(o(t));
        };
      },
      9221: function _(t, e, n) {
        var r = n(4160),
            i = n(7005);

        t.exports = function (t) {
          return i(t) && "[object Set]" == r(t);
        };
      },
      8749: function _(t, e, n) {
        var r = n(4239),
            i = n(1780),
            a = n(7005),
            o = {};
        o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object DataView]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1, t.exports = function (t) {
          return a(t) && i(t.length) && !!o[r(t)];
        };
      },
      7206: function _(t, e, n) {
        var r = n(1573),
            i = n(6432),
            a = n(6557),
            o = n(1469),
            s = n(9601);

        t.exports = function (t) {
          return "function" == typeof t ? t : null == t ? a : "object" == typeof t ? o(t) ? i(t[0], t[1]) : r(t) : s(t);
        };
      },
      280: function _(t, e, n) {
        var r = n(5726),
            i = n(6916),
            a = Object.prototype.hasOwnProperty;

        t.exports = function (t) {
          if (!r(t)) return i(t);
          var e = [];

          for (var n in Object(t)) {
            a.call(t, n) && "constructor" != n && e.push(n);
          }

          return e;
        };
      },
      313: function _(t, e, n) {
        var r = n(3218),
            i = n(5726),
            a = n(3498),
            o = Object.prototype.hasOwnProperty;

        t.exports = function (t) {
          if (!r(t)) return a(t);
          var e = i(t),
              n = [];

          for (var s in t) {
            ("constructor" != s || !e && o.call(t, s)) && n.push(s);
          }

          return n;
        };
      },
      433: function _(t) {
        t.exports = function (t, e) {
          return t < e;
        };
      },
      9199: function _(t, e, n) {
        var r = n(9881),
            i = n(8612);

        t.exports = function (t, e) {
          var n = -1,
              a = i(t) ? Array(t.length) : [];
          return r(t, function (t, r, i) {
            a[++n] = e(t, r, i);
          }), a;
        };
      },
      1573: function _(t, e, n) {
        var r = n(2958),
            i = n(1499),
            a = n(2634);

        t.exports = function (t) {
          var e = i(t);
          return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (n) {
            return n === t || r(n, t, e);
          };
        };
      },
      6432: function _(t, e, n) {
        var r = n(939),
            i = n(1917),
            a = n(9095),
            o = n(5403),
            s = n(9162),
            c = n(2634),
            u = n(327);

        t.exports = function (t, e) {
          return o(t) && s(e) ? c(u(t), e) : function (n) {
            var o = i(n, t);
            return void 0 === o && o === e ? a(n, t) : r(e, o, 3);
          };
        };
      },
      2980: function _(t, e, n) {
        var r = n(6384),
            i = n(6556),
            a = n(8483),
            o = n(9783),
            s = n(3218),
            c = n(1704),
            u = n(6390);

        t.exports = function t(e, n, l, h, f) {
          e !== n && a(n, function (a, c) {
            if (f || (f = new r()), s(a)) o(e, n, c, l, t, h, f);else {
              var d = h ? h(u(e, c), a, c + "", e, n, f) : void 0;
              void 0 === d && (d = a), i(e, c, d);
            }
          }, c);
        };
      },
      9783: function _(t, e, n) {
        var r = n(6556),
            i = n(4626),
            a = n(7133),
            o = n(278),
            s = n(8517),
            c = n(5694),
            u = n(1469),
            l = n(9246),
            h = n(4144),
            f = n(3560),
            d = n(3218),
            p = n(8630),
            y = n(6719),
            g = n(6390),
            m = n(3678);

        t.exports = function (t, e, n, v, b, _, x) {
          var w = g(t, n),
              k = g(e, n),
              T = x.get(k);
          if (T) r(t, n, T);else {
            var E = _ ? _(w, k, n + "", t, e, x) : void 0,
                C = void 0 === E;

            if (C) {
              var S = u(k),
                  A = !S && h(k),
                  M = !S && !A && y(k);
              E = k, S || A || M ? u(w) ? E = w : l(w) ? E = o(w) : A ? (C = !1, E = i(k, !0)) : M ? (C = !1, E = a(k, !0)) : E = [] : p(k) || c(k) ? (E = w, c(w) ? E = m(w) : d(w) && !f(w) || (E = s(k))) : C = !1;
            }

            C && (x.set(k, E), b(E, k, v, _, x), x.delete(k)), r(t, n, E);
          }
        };
      },
      9556: function _(t, e, n) {
        var r = n(9932),
            i = n(7786),
            a = n(7206),
            o = n(9199),
            s = n(1131),
            c = n(1717),
            u = n(5022),
            l = n(6557),
            h = n(1469);

        t.exports = function (t, e, n) {
          e = e.length ? r(e, function (t) {
            return h(t) ? function (e) {
              return i(e, 1 === t.length ? t[0] : t);
            } : t;
          }) : [l];
          var f = -1;
          e = r(e, c(a));
          var d = o(t, function (t, n, i) {
            return {
              criteria: r(e, function (e) {
                return e(t);
              }),
              index: ++f,
              value: t
            };
          });
          return s(d, function (t, e) {
            return u(t, e, n);
          });
        };
      },
      5970: function _(t, e, n) {
        var r = n(3012),
            i = n(9095);

        t.exports = function (t, e) {
          return r(t, e, function (e, n) {
            return i(t, n);
          });
        };
      },
      3012: function _(t, e, n) {
        var r = n(7786),
            i = n(611),
            a = n(1811);

        t.exports = function (t, e, n) {
          for (var o = -1, s = e.length, c = {}; ++o < s;) {
            var u = e[o],
                l = r(t, u);
            n(l, u) && i(c, a(u, t), l);
          }

          return c;
        };
      },
      371: function _(t) {
        t.exports = function (t) {
          return function (e) {
            return null == e ? void 0 : e[t];
          };
        };
      },
      9152: function _(t, e, n) {
        var r = n(7786);

        t.exports = function (t) {
          return function (e) {
            return r(e, t);
          };
        };
      },
      98: function _(t) {
        var e = Math.ceil,
            n = Math.max;

        t.exports = function (t, r, i, a) {
          for (var o = -1, s = n(e((r - t) / (i || 1)), 0), c = Array(s); s--;) {
            c[a ? s : ++o] = t, t += i;
          }

          return c;
        };
      },
      107: function _(t) {
        t.exports = function (t, e, n, r, i) {
          return i(t, function (t, i, a) {
            n = r ? (r = !1, t) : e(n, t, i, a);
          }), n;
        };
      },
      5976: function _(t, e, n) {
        var r = n(6557),
            i = n(5357),
            a = n(61);

        t.exports = function (t, e) {
          return a(i(t, e, r), t + "");
        };
      },
      611: function _(t, e, n) {
        var r = n(4865),
            i = n(1811),
            a = n(5776),
            o = n(3218),
            s = n(327);

        t.exports = function (t, e, n, c) {
          if (!o(t)) return t;

          for (var u = -1, l = (e = i(e, t)).length, h = l - 1, f = t; null != f && ++u < l;) {
            var d = s(e[u]),
                p = n;
            if ("__proto__" === d || "constructor" === d || "prototype" === d) return t;

            if (u != h) {
              var y = f[d];
              void 0 === (p = c ? c(y, d, f) : void 0) && (p = o(y) ? y : a(e[u + 1]) ? [] : {});
            }

            r(f, d, p), f = f[d];
          }

          return t;
        };
      },
      6560: function _(t, e, n) {
        var r = n(5703),
            i = n(8777),
            a = n(6557),
            o = i ? function (t, e) {
          return i(t, "toString", {
            configurable: !0,
            enumerable: !1,
            value: r(e),
            writable: !0
          });
        } : a;
        t.exports = o;
      },
      1131: function _(t) {
        t.exports = function (t, e) {
          var n = t.length;

          for (t.sort(e); n--;) {
            t[n] = t[n].value;
          }

          return t;
        };
      },
      2545: function _(t) {
        t.exports = function (t, e) {
          for (var n = -1, r = Array(t); ++n < t;) {
            r[n] = e(n);
          }

          return r;
        };
      },
      531: function _(t, e, n) {
        var r = n(2705),
            i = n(9932),
            a = n(1469),
            o = n(3448),
            s = r ? r.prototype : void 0,
            c = s ? s.toString : void 0;

        t.exports = function t(e) {
          if ("string" == typeof e) return e;
          if (a(e)) return i(e, t) + "";
          if (o(e)) return c ? c.call(e) : "";
          var n = e + "";
          return "0" == n && 1 / e == -1 / 0 ? "-0" : n;
        };
      },
      7561: function _(t, e, n) {
        var r = n(7990),
            i = /^\s+/;

        t.exports = function (t) {
          return t ? t.slice(0, r(t) + 1).replace(i, "") : t;
        };
      },
      1717: function _(t) {
        t.exports = function (t) {
          return function (e) {
            return t(e);
          };
        };
      },
      5652: function _(t, e, n) {
        var r = n(8668),
            i = n(7443),
            a = n(1196),
            o = n(4757),
            s = n(3593),
            c = n(1814);

        t.exports = function (t, e, n) {
          var u = -1,
              l = i,
              h = t.length,
              f = !0,
              d = [],
              p = d;
          if (n) f = !1, l = a;else if (h >= 200) {
            var y = e ? null : s(t);
            if (y) return c(y);
            f = !1, l = o, p = new r();
          } else p = e ? [] : d;

          t: for (; ++u < h;) {
            var g = t[u],
                m = e ? e(g) : g;

            if (g = n || 0 !== g ? g : 0, f && m == m) {
              for (var v = p.length; v--;) {
                if (p[v] === m) continue t;
              }

              e && p.push(m), d.push(g);
            } else l(p, m, n) || (p !== d && p.push(m), d.push(g));
          }

          return d;
        };
      },
      7415: function _(t, e, n) {
        var r = n(9932);

        t.exports = function (t, e) {
          return r(e, function (e) {
            return t[e];
          });
        };
      },
      1757: function _(t) {
        t.exports = function (t, e, n) {
          for (var r = -1, i = t.length, a = e.length, o = {}; ++r < i;) {
            var s = r < a ? e[r] : void 0;
            n(o, t[r], s);
          }

          return o;
        };
      },
      4757: function _(t) {
        t.exports = function (t, e) {
          return t.has(e);
        };
      },
      4290: function _(t, e, n) {
        var r = n(6557);

        t.exports = function (t) {
          return "function" == typeof t ? t : r;
        };
      },
      1811: function _(t, e, n) {
        var r = n(1469),
            i = n(5403),
            a = n(5514),
            o = n(9833);

        t.exports = function (t, e) {
          return r(t) ? t : i(t, e) ? [t] : a(o(t));
        };
      },
      4318: function _(t, e, n) {
        var r = n(1149);

        t.exports = function (t) {
          var e = new t.constructor(t.byteLength);
          return new r(e).set(new r(t)), e;
        };
      },
      4626: function _(t, e, n) {
        t = n.nmd(t);
        var r = n(5639),
            i = e && !e.nodeType && e,
            a = i && t && !t.nodeType && t,
            o = a && a.exports === i ? r.Buffer : void 0,
            s = o ? o.allocUnsafe : void 0;

        t.exports = function (t, e) {
          if (e) return t.slice();
          var n = t.length,
              r = s ? s(n) : new t.constructor(n);
          return t.copy(r), r;
        };
      },
      7157: function _(t, e, n) {
        var r = n(4318);

        t.exports = function (t, e) {
          var n = e ? r(t.buffer) : t.buffer;
          return new t.constructor(n, t.byteOffset, t.byteLength);
        };
      },
      3147: function _(t) {
        var e = /\w*$/;

        t.exports = function (t) {
          var n = new t.constructor(t.source, e.exec(t));
          return n.lastIndex = t.lastIndex, n;
        };
      },
      419: function _(t, e, n) {
        var r = n(2705),
            i = r ? r.prototype : void 0,
            a = i ? i.valueOf : void 0;

        t.exports = function (t) {
          return a ? Object(a.call(t)) : {};
        };
      },
      7133: function _(t, e, n) {
        var r = n(4318);

        t.exports = function (t, e) {
          var n = e ? r(t.buffer) : t.buffer;
          return new t.constructor(n, t.byteOffset, t.length);
        };
      },
      6393: function _(t, e, n) {
        var r = n(3448);

        t.exports = function (t, e) {
          if (t !== e) {
            var n = void 0 !== t,
                i = null === t,
                a = t == t,
                o = r(t),
                s = void 0 !== e,
                c = null === e,
                u = e == e,
                l = r(e);
            if (!c && !l && !o && t > e || o && s && u && !c && !l || i && s && u || !n && u || !a) return 1;
            if (!i && !o && !l && t < e || l && n && a && !i && !o || c && n && a || !s && a || !u) return -1;
          }

          return 0;
        };
      },
      5022: function _(t, e, n) {
        var r = n(6393);

        t.exports = function (t, e, n) {
          for (var i = -1, a = t.criteria, o = e.criteria, s = a.length, c = n.length; ++i < s;) {
            var u = r(a[i], o[i]);
            if (u) return i >= c ? u : u * ("desc" == n[i] ? -1 : 1);
          }

          return t.index - e.index;
        };
      },
      278: function _(t) {
        t.exports = function (t, e) {
          var n = -1,
              r = t.length;

          for (e || (e = Array(r)); ++n < r;) {
            e[n] = t[n];
          }

          return e;
        };
      },
      8363: function _(t, e, n) {
        var r = n(4865),
            i = n(9465);

        t.exports = function (t, e, n, a) {
          var o = !n;
          n || (n = {});

          for (var s = -1, c = e.length; ++s < c;) {
            var u = e[s],
                l = a ? a(n[u], t[u], u, n, t) : void 0;
            void 0 === l && (l = t[u]), o ? i(n, u, l) : r(n, u, l);
          }

          return n;
        };
      },
      8805: function _(t, e, n) {
        var r = n(8363),
            i = n(9551);

        t.exports = function (t, e) {
          return r(t, i(t), e);
        };
      },
      1911: function _(t, e, n) {
        var r = n(8363),
            i = n(1442);

        t.exports = function (t, e) {
          return r(t, i(t), e);
        };
      },
      4429: function _(t, e, n) {
        var r = n(5639)["__core-js_shared__"];
        t.exports = r;
      },
      1750: function _(t, e, n) {
        var r = n(5976),
            i = n(6612);

        t.exports = function (t) {
          return r(function (e, n) {
            var r = -1,
                a = n.length,
                o = a > 1 ? n[a - 1] : void 0,
                s = a > 2 ? n[2] : void 0;

            for (o = t.length > 3 && "function" == typeof o ? (a--, o) : void 0, s && i(n[0], n[1], s) && (o = a < 3 ? void 0 : o, a = 1), e = Object(e); ++r < a;) {
              var c = n[r];
              c && t(e, c, r, o);
            }

            return e;
          });
        };
      },
      9291: function _(t, e, n) {
        var r = n(8612);

        t.exports = function (t, e) {
          return function (n, i) {
            if (null == n) return n;
            if (!r(n)) return t(n, i);

            for (var a = n.length, o = e ? a : -1, s = Object(n); (e ? o-- : ++o < a) && !1 !== i(s[o], o, s);) {
              ;
            }

            return n;
          };
        };
      },
      5063: function _(t) {
        t.exports = function (t) {
          return function (e, n, r) {
            for (var i = -1, a = Object(e), o = r(e), s = o.length; s--;) {
              var c = o[t ? s : ++i];
              if (!1 === n(a[c], c, a)) break;
            }

            return e;
          };
        };
      },
      7740: function _(t, e, n) {
        var r = n(7206),
            i = n(8612),
            a = n(3674);

        t.exports = function (t) {
          return function (e, n, o) {
            var s = Object(e);

            if (!i(e)) {
              var c = r(n, 3);
              e = a(e), n = function n(t) {
                return c(s[t], t, s);
              };
            }

            var u = t(e, n, o);
            return u > -1 ? s[c ? e[u] : u] : void 0;
          };
        };
      },
      7445: function _(t, e, n) {
        var r = n(98),
            i = n(6612),
            a = n(8601);

        t.exports = function (t) {
          return function (e, n, o) {
            return o && "number" != typeof o && i(e, n, o) && (n = o = void 0), e = a(e), void 0 === n ? (n = e, e = 0) : n = a(n), o = void 0 === o ? e < n ? 1 : -1 : a(o), r(e, n, o, t);
          };
        };
      },
      3593: function _(t, e, n) {
        var r = n(8525),
            i = n(308),
            a = n(1814),
            o = r && 1 / a(new r([, -0]))[1] == 1 / 0 ? function (t) {
          return new r(t);
        } : i;
        t.exports = o;
      },
      8777: function _(t, e, n) {
        var r = n(852),
            i = function () {
          try {
            var t = r(Object, "defineProperty");
            return t({}, "", {}), t;
          } catch (t) {}
        }();

        t.exports = i;
      },
      7114: function _(t, e, n) {
        var r = n(8668),
            i = n(2908),
            a = n(4757);

        t.exports = function (t, e, n, o, s, c) {
          var u = 1 & n,
              l = t.length,
              h = e.length;
          if (l != h && !(u && h > l)) return !1;
          var f = c.get(t),
              d = c.get(e);
          if (f && d) return f == e && d == t;
          var p = -1,
              y = !0,
              g = 2 & n ? new r() : void 0;

          for (c.set(t, e), c.set(e, t); ++p < l;) {
            var m = t[p],
                v = e[p];
            if (o) var b = u ? o(v, m, p, e, t, c) : o(m, v, p, t, e, c);

            if (void 0 !== b) {
              if (b) continue;
              y = !1;
              break;
            }

            if (g) {
              if (!i(e, function (t, e) {
                if (!a(g, e) && (m === t || s(m, t, n, o, c))) return g.push(e);
              })) {
                y = !1;
                break;
              }
            } else if (m !== v && !s(m, v, n, o, c)) {
              y = !1;
              break;
            }
          }

          return c.delete(t), c.delete(e), y;
        };
      },
      8351: function _(t, e, n) {
        var r = n(2705),
            i = n(1149),
            a = n(7813),
            o = n(7114),
            s = n(8776),
            c = n(1814),
            u = r ? r.prototype : void 0,
            l = u ? u.valueOf : void 0;

        t.exports = function (t, e, n, r, u, h, f) {
          switch (n) {
            case "[object DataView]":
              if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
              t = t.buffer, e = e.buffer;

            case "[object ArrayBuffer]":
              return !(t.byteLength != e.byteLength || !h(new i(t), new i(e)));

            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
              return a(+t, +e);

            case "[object Error]":
              return t.name == e.name && t.message == e.message;

            case "[object RegExp]":
            case "[object String]":
              return t == e + "";

            case "[object Map]":
              var d = s;

            case "[object Set]":
              var p = 1 & r;
              if (d || (d = c), t.size != e.size && !p) return !1;
              var y = f.get(t);
              if (y) return y == e;
              r |= 2, f.set(t, e);
              var g = o(d(t), d(e), r, u, h, f);
              return f.delete(t), g;

            case "[object Symbol]":
              if (l) return l.call(t) == l.call(e);
          }

          return !1;
        };
      },
      6096: function _(t, e, n) {
        var r = n(8234),
            i = Object.prototype.hasOwnProperty;

        t.exports = function (t, e, n, a, o, s) {
          var c = 1 & n,
              u = r(t),
              l = u.length;
          if (l != r(e).length && !c) return !1;

          for (var h = l; h--;) {
            var f = u[h];
            if (!(c ? f in e : i.call(e, f))) return !1;
          }

          var d = s.get(t),
              p = s.get(e);
          if (d && p) return d == e && p == t;
          var y = !0;
          s.set(t, e), s.set(e, t);

          for (var g = c; ++h < l;) {
            var m = t[f = u[h]],
                v = e[f];
            if (a) var b = c ? a(v, m, f, e, t, s) : a(m, v, f, t, e, s);

            if (!(void 0 === b ? m === v || o(m, v, n, a, s) : b)) {
              y = !1;
              break;
            }

            g || (g = "constructor" == f);
          }

          if (y && !g) {
            var _ = t.constructor,
                x = e.constructor;
            _ == x || !("constructor" in t) || !("constructor" in e) || "function" == typeof _ && _ instanceof _ && "function" == typeof x && x instanceof x || (y = !1);
          }

          return s.delete(t), s.delete(e), y;
        };
      },
      9021: function _(t, e, n) {
        var r = n(5564),
            i = n(5357),
            a = n(61);

        t.exports = function (t) {
          return a(i(t, void 0, r), t + "");
        };
      },
      1957: function _(t, e, n) {
        var r = "object" == typeof n.g && n.g && n.g.Object === Object && n.g;
        t.exports = r;
      },
      8234: function _(t, e, n) {
        var r = n(8866),
            i = n(9551),
            a = n(3674);

        t.exports = function (t) {
          return r(t, a, i);
        };
      },
      6904: function _(t, e, n) {
        var r = n(8866),
            i = n(1442),
            a = n(1704);

        t.exports = function (t) {
          return r(t, a, i);
        };
      },
      5050: function _(t, e, n) {
        var r = n(7019);

        t.exports = function (t, e) {
          var n = t.__data__;
          return r(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
        };
      },
      1499: function _(t, e, n) {
        var r = n(9162),
            i = n(3674);

        t.exports = function (t) {
          for (var e = i(t), n = e.length; n--;) {
            var a = e[n],
                o = t[a];
            e[n] = [a, o, r(o)];
          }

          return e;
        };
      },
      852: function _(t, e, n) {
        var r = n(8458),
            i = n(7801);

        t.exports = function (t, e) {
          var n = i(t, e);
          return r(n) ? n : void 0;
        };
      },
      5924: function _(t, e, n) {
        var r = n(5569)(Object.getPrototypeOf, Object);
        t.exports = r;
      },
      9607: function _(t, e, n) {
        var r = n(2705),
            i = Object.prototype,
            a = i.hasOwnProperty,
            o = i.toString,
            s = r ? r.toStringTag : void 0;

        t.exports = function (t) {
          var e = a.call(t, s),
              n = t[s];

          try {
            t[s] = void 0;
            var r = !0;
          } catch (t) {}

          var i = o.call(t);
          return r && (e ? t[s] = n : delete t[s]), i;
        };
      },
      9551: function _(t, e, n) {
        var r = n(4963),
            i = n(479),
            a = Object.prototype.propertyIsEnumerable,
            o = Object.getOwnPropertySymbols,
            s = o ? function (t) {
          return null == t ? [] : (t = Object(t), r(o(t), function (e) {
            return a.call(t, e);
          }));
        } : i;
        t.exports = s;
      },
      1442: function _(t, e, n) {
        var r = n(2488),
            i = n(5924),
            a = n(9551),
            o = n(479),
            s = Object.getOwnPropertySymbols ? function (t) {
          for (var e = []; t;) {
            r(e, a(t)), t = i(t);
          }

          return e;
        } : o;
        t.exports = s;
      },
      4160: function _(t, e, n) {
        var r = n(8552),
            i = n(7071),
            a = n(3818),
            o = n(8525),
            s = n(577),
            c = n(4239),
            u = n(346),
            l = "[object Map]",
            h = "[object Promise]",
            f = "[object Set]",
            d = "[object WeakMap]",
            p = "[object DataView]",
            y = u(r),
            g = u(i),
            m = u(a),
            v = u(o),
            b = u(s),
            _ = c;
        (r && _(new r(new ArrayBuffer(1))) != p || i && _(new i()) != l || a && _(a.resolve()) != h || o && _(new o()) != f || s && _(new s()) != d) && (_ = function _(t) {
          var e = c(t),
              n = "[object Object]" == e ? t.constructor : void 0,
              r = n ? u(n) : "";
          if (r) switch (r) {
            case y:
              return p;

            case g:
              return l;

            case m:
              return h;

            case v:
              return f;

            case b:
              return d;
          }
          return e;
        }), t.exports = _;
      },
      7801: function _(t) {
        t.exports = function (t, e) {
          return null == t ? void 0 : t[e];
        };
      },
      222: function _(t, e, n) {
        var r = n(1811),
            i = n(5694),
            a = n(1469),
            o = n(5776),
            s = n(1780),
            c = n(327);

        t.exports = function (t, e, n) {
          for (var u = -1, l = (e = r(e, t)).length, h = !1; ++u < l;) {
            var f = c(e[u]);
            if (!(h = null != t && n(t, f))) break;
            t = t[f];
          }

          return h || ++u != l ? h : !!(l = null == t ? 0 : t.length) && s(l) && o(f, l) && (a(t) || i(t));
        };
      },
      2689: function _(t) {
        var e = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

        t.exports = function (t) {
          return e.test(t);
        };
      },
      1789: function _(t, e, n) {
        var r = n(4536);

        t.exports = function () {
          this.__data__ = r ? r(null) : {}, this.size = 0;
        };
      },
      401: function _(t) {
        t.exports = function (t) {
          var e = this.has(t) && delete this.__data__[t];
          return this.size -= e ? 1 : 0, e;
        };
      },
      7667: function _(t, e, n) {
        var r = n(4536),
            i = Object.prototype.hasOwnProperty;

        t.exports = function (t) {
          var e = this.__data__;

          if (r) {
            var n = e[t];
            return "__lodash_hash_undefined__" === n ? void 0 : n;
          }

          return i.call(e, t) ? e[t] : void 0;
        };
      },
      1327: function _(t, e, n) {
        var r = n(4536),
            i = Object.prototype.hasOwnProperty;

        t.exports = function (t) {
          var e = this.__data__;
          return r ? void 0 !== e[t] : i.call(e, t);
        };
      },
      1866: function _(t, e, n) {
        var r = n(4536);

        t.exports = function (t, e) {
          var n = this.__data__;
          return this.size += this.has(t) ? 0 : 1, n[t] = r && void 0 === e ? "__lodash_hash_undefined__" : e, this;
        };
      },
      3824: function _(t) {
        var e = Object.prototype.hasOwnProperty;

        t.exports = function (t) {
          var n = t.length,
              r = new t.constructor(n);
          return n && "string" == typeof t[0] && e.call(t, "index") && (r.index = t.index, r.input = t.input), r;
        };
      },
      9148: function _(t, e, n) {
        var r = n(4318),
            i = n(7157),
            a = n(3147),
            o = n(419),
            s = n(7133);

        t.exports = function (t, e, n) {
          var c = t.constructor;

          switch (e) {
            case "[object ArrayBuffer]":
              return r(t);

            case "[object Boolean]":
            case "[object Date]":
              return new c(+t);

            case "[object DataView]":
              return i(t, n);

            case "[object Float32Array]":
            case "[object Float64Array]":
            case "[object Int8Array]":
            case "[object Int16Array]":
            case "[object Int32Array]":
            case "[object Uint8Array]":
            case "[object Uint8ClampedArray]":
            case "[object Uint16Array]":
            case "[object Uint32Array]":
              return s(t, n);

            case "[object Map]":
              return new c();

            case "[object Number]":
            case "[object String]":
              return new c(t);

            case "[object RegExp]":
              return a(t);

            case "[object Set]":
              return new c();

            case "[object Symbol]":
              return o(t);
          }
        };
      },
      8517: function _(t, e, n) {
        var r = n(3118),
            i = n(5924),
            a = n(5726);

        t.exports = function (t) {
          return "function" != typeof t.constructor || a(t) ? {} : r(i(t));
        };
      },
      7285: function _(t, e, n) {
        var r = n(2705),
            i = n(5694),
            a = n(1469),
            o = r ? r.isConcatSpreadable : void 0;

        t.exports = function (t) {
          return a(t) || i(t) || !!(o && t && t[o]);
        };
      },
      5776: function _(t) {
        var e = /^(?:0|[1-9]\d*)$/;

        t.exports = function (t, n) {
          var r = typeof t;
          return !!(n = null == n ? 9007199254740991 : n) && ("number" == r || "symbol" != r && e.test(t)) && t > -1 && t % 1 == 0 && t < n;
        };
      },
      6612: function _(t, e, n) {
        var r = n(7813),
            i = n(8612),
            a = n(5776),
            o = n(3218);

        t.exports = function (t, e, n) {
          if (!o(n)) return !1;
          var s = typeof e;
          return !!("number" == s ? i(n) && a(e, n.length) : "string" == s && e in n) && r(n[e], t);
        };
      },
      5403: function _(t, e, n) {
        var r = n(1469),
            i = n(3448),
            a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            o = /^\w*$/;

        t.exports = function (t, e) {
          if (r(t)) return !1;
          var n = typeof t;
          return !("number" != n && "symbol" != n && "boolean" != n && null != t && !i(t)) || o.test(t) || !a.test(t) || null != e && t in Object(e);
        };
      },
      7019: function _(t) {
        t.exports = function (t) {
          var e = typeof t;
          return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
        };
      },
      5346: function _(t, e, n) {
        var r,
            i = n(4429),
            a = (r = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

        t.exports = function (t) {
          return !!a && a in t;
        };
      },
      5726: function _(t) {
        var e = Object.prototype;

        t.exports = function (t) {
          var n = t && t.constructor;
          return t === ("function" == typeof n && n.prototype || e);
        };
      },
      9162: function _(t, e, n) {
        var r = n(3218);

        t.exports = function (t) {
          return t == t && !r(t);
        };
      },
      7040: function _(t) {
        t.exports = function () {
          this.__data__ = [], this.size = 0;
        };
      },
      1362: function _(t, e, n) {
        var r = n(8470),
            i = Array.prototype.splice;

        t.exports = function (t) {
          var e = this.__data__,
              n = r(e, t);
          return !(n < 0 || (n == e.length - 1 ? e.pop() : i.call(e, n, 1), --this.size, 0));
        };
      },
      2117: function _(t, e, n) {
        var r = n(8470);

        t.exports = function (t) {
          var e = this.__data__,
              n = r(e, t);
          return n < 0 ? void 0 : e[n][1];
        };
      },
      7518: function _(t, e, n) {
        var r = n(8470);

        t.exports = function (t) {
          return r(this.__data__, t) > -1;
        };
      },
      4705: function _(t, e, n) {
        var r = n(8470);

        t.exports = function (t, e) {
          var n = this.__data__,
              i = r(n, t);
          return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
        };
      },
      4785: function _(t, e, n) {
        var r = n(1989),
            i = n(8407),
            a = n(7071);

        t.exports = function () {
          this.size = 0, this.__data__ = {
            hash: new r(),
            map: new (a || i)(),
            string: new r()
          };
        };
      },
      1285: function _(t, e, n) {
        var r = n(5050);

        t.exports = function (t) {
          var e = r(this, t).delete(t);
          return this.size -= e ? 1 : 0, e;
        };
      },
      6e3: function _(t, e, n) {
        var r = n(5050);

        t.exports = function (t) {
          return r(this, t).get(t);
        };
      },
      9916: function _(t, e, n) {
        var r = n(5050);

        t.exports = function (t) {
          return r(this, t).has(t);
        };
      },
      5265: function _(t, e, n) {
        var r = n(5050);

        t.exports = function (t, e) {
          var n = r(this, t),
              i = n.size;
          return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
        };
      },
      8776: function _(t) {
        t.exports = function (t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t, r) {
            n[++e] = [r, t];
          }), n;
        };
      },
      2634: function _(t) {
        t.exports = function (t, e) {
          return function (n) {
            return null != n && n[t] === e && (void 0 !== e || t in Object(n));
          };
        };
      },
      4523: function _(t, e, n) {
        var r = n(8306);

        t.exports = function (t) {
          var e = r(t, function (t) {
            return 500 === n.size && n.clear(), t;
          }),
              n = e.cache;
          return e;
        };
      },
      4536: function _(t, e, n) {
        var r = n(852)(Object, "create");
        t.exports = r;
      },
      6916: function _(t, e, n) {
        var r = n(5569)(Object.keys, Object);
        t.exports = r;
      },
      3498: function _(t) {
        t.exports = function (t) {
          var e = [];
          if (null != t) for (var n in Object(t)) {
            e.push(n);
          }
          return e;
        };
      },
      1167: function _(t, e, n) {
        t = n.nmd(t);

        var r = n(1957),
            i = e && !e.nodeType && e,
            a = i && t && !t.nodeType && t,
            o = a && a.exports === i && r.process,
            s = function () {
          try {
            return a && a.require && a.require("util").types || o && o.binding && o.binding("util");
          } catch (t) {}
        }();

        t.exports = s;
      },
      2333: function _(t) {
        var e = Object.prototype.toString;

        t.exports = function (t) {
          return e.call(t);
        };
      },
      5569: function _(t) {
        t.exports = function (t, e) {
          return function (n) {
            return t(e(n));
          };
        };
      },
      5357: function _(t, e, n) {
        var r = n(6874),
            i = Math.max;

        t.exports = function (t, e, n) {
          return e = i(void 0 === e ? t.length - 1 : e, 0), function () {
            for (var a = arguments, o = -1, s = i(a.length - e, 0), c = Array(s); ++o < s;) {
              c[o] = a[e + o];
            }

            o = -1;

            for (var u = Array(e + 1); ++o < e;) {
              u[o] = a[o];
            }

            return u[e] = n(c), r(t, this, u);
          };
        };
      },
      5639: function _(t, e, n) {
        var r = n(1957),
            i = "object" == typeof self && self && self.Object === Object && self,
            a = r || i || Function("return this")();
        t.exports = a;
      },
      6390: function _(t) {
        t.exports = function (t, e) {
          if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
        };
      },
      619: function _(t) {
        t.exports = function (t) {
          return this.__data__.set(t, "__lodash_hash_undefined__"), this;
        };
      },
      2385: function _(t) {
        t.exports = function (t) {
          return this.__data__.has(t);
        };
      },
      1814: function _(t) {
        t.exports = function (t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t) {
            n[++e] = t;
          }), n;
        };
      },
      61: function _(t, e, n) {
        var r = n(6560),
            i = n(1275)(r);
        t.exports = i;
      },
      1275: function _(t) {
        var e = Date.now;

        t.exports = function (t) {
          var n = 0,
              r = 0;
          return function () {
            var i = e(),
                a = 16 - (i - r);

            if (r = i, a > 0) {
              if (++n >= 800) return arguments[0];
            } else n = 0;

            return t.apply(void 0, arguments);
          };
        };
      },
      7465: function _(t, e, n) {
        var r = n(8407);

        t.exports = function () {
          this.__data__ = new r(), this.size = 0;
        };
      },
      3779: function _(t) {
        t.exports = function (t) {
          var e = this.__data__,
              n = e.delete(t);
          return this.size = e.size, n;
        };
      },
      7599: function _(t) {
        t.exports = function (t) {
          return this.__data__.get(t);
        };
      },
      4758: function _(t) {
        t.exports = function (t) {
          return this.__data__.has(t);
        };
      },
      4309: function _(t, e, n) {
        var r = n(8407),
            i = n(7071),
            a = n(3369);

        t.exports = function (t, e) {
          var n = this.__data__;

          if (n instanceof r) {
            var o = n.__data__;
            if (!i || o.length < 199) return o.push([t, e]), this.size = ++n.size, this;
            n = this.__data__ = new a(o);
          }

          return n.set(t, e), this.size = n.size, this;
        };
      },
      2351: function _(t) {
        t.exports = function (t, e, n) {
          for (var r = n - 1, i = t.length; ++r < i;) {
            if (t[r] === e) return r;
          }

          return -1;
        };
      },
      8016: function _(t, e, n) {
        var r = n(8983),
            i = n(2689),
            a = n(1903);

        t.exports = function (t) {
          return i(t) ? a(t) : r(t);
        };
      },
      5514: function _(t, e, n) {
        var r = n(4523),
            i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            a = /\\(\\)?/g,
            o = r(function (t) {
          var e = [];
          return 46 === t.charCodeAt(0) && e.push(""), t.replace(i, function (t, n, r, i) {
            e.push(r ? i.replace(a, "$1") : n || t);
          }), e;
        });
        t.exports = o;
      },
      327: function _(t, e, n) {
        var r = n(3448);

        t.exports = function (t) {
          if ("string" == typeof t || r(t)) return t;
          var e = t + "";
          return "0" == e && 1 / t == -1 / 0 ? "-0" : e;
        };
      },
      346: function _(t) {
        var e = Function.prototype.toString;

        t.exports = function (t) {
          if (null != t) {
            try {
              return e.call(t);
            } catch (t) {}

            try {
              return t + "";
            } catch (t) {}
          }

          return "";
        };
      },
      7990: function _(t) {
        var e = /\s/;

        t.exports = function (t) {
          for (var n = t.length; n-- && e.test(t.charAt(n));) {
            ;
          }

          return n;
        };
      },
      1903: function _(t) {
        var e = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
            n = "\\ud83c[\\udffb-\\udfff]",
            r = "[^\\ud800-\\udfff]",
            i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            a = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            o = "(?:" + e + "|" + n + ")?",
            s = "[\\ufe0e\\ufe0f]?",
            c = s + o + "(?:\\u200d(?:" + [r, i, a].join("|") + ")" + s + o + ")*",
            u = "(?:" + [r + e + "?", e, i, a, "[\\ud800-\\udfff]"].join("|") + ")",
            l = RegExp(n + "(?=" + n + ")|" + u + c, "g");

        t.exports = function (t) {
          for (var e = l.lastIndex = 0; l.test(t);) {
            ++e;
          }

          return e;
        };
      },
      6678: function _(t, e, n) {
        var r = n(5990);

        t.exports = function (t) {
          return r(t, 4);
        };
      },
      361: function _(t, e, n) {
        var r = n(5990);

        t.exports = function (t) {
          return r(t, 5);
        };
      },
      5703: function _(t) {
        t.exports = function (t) {
          return function () {
            return t;
          };
        };
      },
      1747: function _(t, e, n) {
        var r = n(5976),
            i = n(7813),
            a = n(6612),
            o = n(1704),
            s = Object.prototype,
            c = s.hasOwnProperty,
            u = r(function (t, e) {
          t = Object(t);
          var n = -1,
              r = e.length,
              u = r > 2 ? e[2] : void 0;

          for (u && a(e[0], e[1], u) && (r = 1); ++n < r;) {
            for (var l = e[n], h = o(l), f = -1, d = h.length; ++f < d;) {
              var p = h[f],
                  y = t[p];
              (void 0 === y || i(y, s[p]) && !c.call(t, p)) && (t[p] = l[p]);
            }
          }

          return t;
        });
        t.exports = u;
      },
      6073: function _(t, e, n) {
        t.exports = n(4486);
      },
      7813: function _(t) {
        t.exports = function (t, e) {
          return t === e || t != t && e != e;
        };
      },
      3105: function _(t, e, n) {
        var r = n(4963),
            i = n(760),
            a = n(7206),
            o = n(1469);

        t.exports = function (t, e) {
          return (o(t) ? r : i)(t, a(e, 3));
        };
      },
      3311: function _(t, e, n) {
        var r = n(7740)(n(998));
        t.exports = r;
      },
      998: function _(t, e, n) {
        var r = n(1848),
            i = n(7206),
            a = n(554),
            o = Math.max;

        t.exports = function (t, e, n) {
          var s = null == t ? 0 : t.length;
          if (!s) return -1;
          var c = null == n ? 0 : a(n);
          return c < 0 && (c = o(s + c, 0)), r(t, i(e, 3), c);
        };
      },
      5564: function _(t, e, n) {
        var r = n(1078);

        t.exports = function (t) {
          return null != t && t.length ? r(t, 1) : [];
        };
      },
      4486: function _(t, e, n) {
        var r = n(7412),
            i = n(9881),
            a = n(4290),
            o = n(1469);

        t.exports = function (t, e) {
          return (o(t) ? r : i)(t, a(e));
        };
      },
      2620: function _(t, e, n) {
        var r = n(8483),
            i = n(4290),
            a = n(1704);

        t.exports = function (t, e) {
          return null == t ? t : r(t, i(e), a);
        };
      },
      1917: function _(t, e, n) {
        var r = n(7786);

        t.exports = function (t, e, n) {
          var i = null == t ? void 0 : r(t, e);
          return void 0 === i ? n : i;
        };
      },
      8721: function _(t, e, n) {
        var r = n(8565),
            i = n(222);

        t.exports = function (t, e) {
          return null != t && i(t, e, r);
        };
      },
      9095: function _(t, e, n) {
        var r = n(13),
            i = n(222);

        t.exports = function (t, e) {
          return null != t && i(t, e, r);
        };
      },
      6557: function _(t) {
        t.exports = function (t) {
          return t;
        };
      },
      5694: function _(t, e, n) {
        var r = n(9454),
            i = n(7005),
            a = Object.prototype,
            o = a.hasOwnProperty,
            s = a.propertyIsEnumerable,
            c = r(function () {
          return arguments;
        }()) ? r : function (t) {
          return i(t) && o.call(t, "callee") && !s.call(t, "callee");
        };
        t.exports = c;
      },
      1469: function _(t) {
        var e = Array.isArray;
        t.exports = e;
      },
      8612: function _(t, e, n) {
        var r = n(3560),
            i = n(1780);

        t.exports = function (t) {
          return null != t && i(t.length) && !r(t);
        };
      },
      9246: function _(t, e, n) {
        var r = n(8612),
            i = n(7005);

        t.exports = function (t) {
          return i(t) && r(t);
        };
      },
      4144: function _(t, e, n) {
        t = n.nmd(t);
        var r = n(5639),
            i = n(5062),
            a = e && !e.nodeType && e,
            o = a && t && !t.nodeType && t,
            s = o && o.exports === a ? r.Buffer : void 0,
            c = (s ? s.isBuffer : void 0) || i;
        t.exports = c;
      },
      1609: function _(t, e, n) {
        var r = n(280),
            i = n(4160),
            a = n(5694),
            o = n(1469),
            s = n(8612),
            c = n(4144),
            u = n(5726),
            l = n(6719),
            h = Object.prototype.hasOwnProperty;

        t.exports = function (t) {
          if (null == t) return !0;
          if (s(t) && (o(t) || "string" == typeof t || "function" == typeof t.splice || c(t) || l(t) || a(t))) return !t.length;
          var e = i(t);
          if ("[object Map]" == e || "[object Set]" == e) return !t.size;
          if (u(t)) return !r(t).length;

          for (var n in t) {
            if (h.call(t, n)) return !1;
          }

          return !0;
        };
      },
      3560: function _(t, e, n) {
        var r = n(4239),
            i = n(3218);

        t.exports = function (t) {
          if (!i(t)) return !1;
          var e = r(t);
          return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
        };
      },
      1780: function _(t) {
        t.exports = function (t) {
          return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
        };
      },
      6688: function _(t, e, n) {
        var r = n(5588),
            i = n(1717),
            a = n(1167),
            o = a && a.isMap,
            s = o ? i(o) : r;
        t.exports = s;
      },
      3218: function _(t) {
        t.exports = function (t) {
          var e = typeof t;
          return null != t && ("object" == e || "function" == e);
        };
      },
      7005: function _(t) {
        t.exports = function (t) {
          return null != t && "object" == typeof t;
        };
      },
      8630: function _(t, e, n) {
        var r = n(4239),
            i = n(5924),
            a = n(7005),
            o = Function.prototype,
            s = Object.prototype,
            c = o.toString,
            u = s.hasOwnProperty,
            l = c.call(Object);

        t.exports = function (t) {
          if (!a(t) || "[object Object]" != r(t)) return !1;
          var e = i(t);
          if (null === e) return !0;
          var n = u.call(e, "constructor") && e.constructor;
          return "function" == typeof n && n instanceof n && c.call(n) == l;
        };
      },
      2928: function _(t, e, n) {
        var r = n(9221),
            i = n(1717),
            a = n(1167),
            o = a && a.isSet,
            s = o ? i(o) : r;
        t.exports = s;
      },
      7037: function _(t, e, n) {
        var r = n(4239),
            i = n(1469),
            a = n(7005);

        t.exports = function (t) {
          return "string" == typeof t || !i(t) && a(t) && "[object String]" == r(t);
        };
      },
      3448: function _(t, e, n) {
        var r = n(4239),
            i = n(7005);

        t.exports = function (t) {
          return "symbol" == typeof t || i(t) && "[object Symbol]" == r(t);
        };
      },
      6719: function _(t, e, n) {
        var r = n(8749),
            i = n(1717),
            a = n(1167),
            o = a && a.isTypedArray,
            s = o ? i(o) : r;
        t.exports = s;
      },
      2353: function _(t) {
        t.exports = function (t) {
          return void 0 === t;
        };
      },
      3674: function _(t, e, n) {
        var r = n(4636),
            i = n(280),
            a = n(8612);

        t.exports = function (t) {
          return a(t) ? r(t) : i(t);
        };
      },
      1704: function _(t, e, n) {
        var r = n(4636),
            i = n(313),
            a = n(8612);

        t.exports = function (t) {
          return a(t) ? r(t, !0) : i(t);
        };
      },
      928: function _(t) {
        t.exports = function (t) {
          var e = null == t ? 0 : t.length;
          return e ? t[e - 1] : void 0;
        };
      },
      5161: function _(t, e, n) {
        var r = n(9932),
            i = n(7206),
            a = n(9199),
            o = n(1469);

        t.exports = function (t, e) {
          return (o(t) ? r : a)(t, i(e, 3));
        };
      },
      6604: function _(t, e, n) {
        var r = n(9465),
            i = n(7816),
            a = n(7206);

        t.exports = function (t, e) {
          var n = {};
          return e = a(e, 3), i(t, function (t, i, a) {
            r(n, i, e(t, i, a));
          }), n;
        };
      },
      6162: function _(t, e, n) {
        var r = n(6029),
            i = n(3325),
            a = n(6557);

        t.exports = function (t) {
          return t && t.length ? r(t, a, i) : void 0;
        };
      },
      8306: function _(t, e, n) {
        var r = n(3369);

        function i(t, e) {
          if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");

          var n = function n() {
            var r = arguments,
                i = e ? e.apply(this, r) : r[0],
                a = n.cache;
            if (a.has(i)) return a.get(i);
            var o = t.apply(this, r);
            return n.cache = a.set(i, o) || a, o;
          };

          return n.cache = new (i.Cache || r)(), n;
        }

        i.Cache = r, t.exports = i;
      },
      3857: function _(t, e, n) {
        var r = n(2980),
            i = n(1750)(function (t, e, n) {
          r(t, e, n);
        });
        t.exports = i;
      },
      3632: function _(t, e, n) {
        var r = n(6029),
            i = n(433),
            a = n(6557);

        t.exports = function (t) {
          return t && t.length ? r(t, a, i) : void 0;
        };
      },
      2762: function _(t, e, n) {
        var r = n(6029),
            i = n(7206),
            a = n(433);

        t.exports = function (t, e) {
          return t && t.length ? r(t, i(e, 2), a) : void 0;
        };
      },
      308: function _(t) {
        t.exports = function () {};
      },
      7771: function _(t, e, n) {
        var r = n(5639);

        t.exports = function () {
          return r.Date.now();
        };
      },
      9722: function _(t, e, n) {
        var r = n(5970),
            i = n(9021)(function (t, e) {
          return null == t ? {} : r(t, e);
        });
        t.exports = i;
      },
      9601: function _(t, e, n) {
        var r = n(371),
            i = n(9152),
            a = n(5403),
            o = n(327);

        t.exports = function (t) {
          return a(t) ? r(o(t)) : i(t);
        };
      },
      6026: function _(t, e, n) {
        var r = n(7445)();
        t.exports = r;
      },
      4061: function _(t, e, n) {
        var r = n(2663),
            i = n(9881),
            a = n(7206),
            o = n(107),
            s = n(1469);

        t.exports = function (t, e, n) {
          var c = s(t) ? r : o,
              u = arguments.length < 3;
          return c(t, a(e, 4), n, u, i);
        };
      },
      4238: function _(t, e, n) {
        var r = n(280),
            i = n(4160),
            a = n(8612),
            o = n(7037),
            s = n(8016);

        t.exports = function (t) {
          if (null == t) return 0;
          if (a(t)) return o(t) ? s(t) : t.length;
          var e = i(t);
          return "[object Map]" == e || "[object Set]" == e ? t.size : r(t).length;
        };
      },
      9734: function _(t, e, n) {
        var r = n(1078),
            i = n(9556),
            a = n(5976),
            o = n(6612),
            s = a(function (t, e) {
          if (null == t) return [];
          var n = e.length;
          return n > 1 && o(t, e[0], e[1]) ? e = [] : n > 2 && o(e[0], e[1], e[2]) && (e = [e[0]]), i(t, r(e, 1), []);
        });
        t.exports = s;
      },
      479: function _(t) {
        t.exports = function () {
          return [];
        };
      },
      5062: function _(t) {
        t.exports = function () {
          return !1;
        };
      },
      8601: function _(t, e, n) {
        var r = n(4841);

        t.exports = function (t) {
          return t ? 1 / 0 === (t = r(t)) || t === -1 / 0 ? 17976931348623157e292 * (t < 0 ? -1 : 1) : t == t ? t : 0 : 0 === t ? t : 0;
        };
      },
      554: function _(t, e, n) {
        var r = n(8601);

        t.exports = function (t) {
          var e = r(t),
              n = e % 1;
          return e == e ? n ? e - n : e : 0;
        };
      },
      4841: function _(t, e, n) {
        var r = n(7561),
            i = n(3218),
            a = n(3448),
            o = /^[-+]0x[0-9a-f]+$/i,
            s = /^0b[01]+$/i,
            c = /^0o[0-7]+$/i,
            u = parseInt;

        t.exports = function (t) {
          if ("number" == typeof t) return t;
          if (a(t)) return NaN;

          if (i(t)) {
            var e = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = i(e) ? e + "" : e;
          }

          if ("string" != typeof t) return 0 === t ? t : +t;
          t = r(t);
          var n = s.test(t);
          return n || c.test(t) ? u(t.slice(2), n ? 2 : 8) : o.test(t) ? NaN : +t;
        };
      },
      3678: function _(t, e, n) {
        var r = n(8363),
            i = n(1704);

        t.exports = function (t) {
          return r(t, i(t));
        };
      },
      9833: function _(t, e, n) {
        var r = n(531);

        t.exports = function (t) {
          return null == t ? "" : r(t);
        };
      },
      8718: function _(t, e, n) {
        var r = n(7412),
            i = n(3118),
            a = n(7816),
            o = n(7206),
            s = n(5924),
            c = n(1469),
            u = n(4144),
            l = n(3560),
            h = n(3218),
            f = n(6719);

        t.exports = function (t, e, n) {
          var d = c(t),
              p = d || u(t) || f(t);

          if (e = o(e, 4), null == n) {
            var y = t && t.constructor;
            n = p ? d ? new y() : [] : h(t) && l(y) ? i(s(t)) : {};
          }

          return (p ? r : a)(t, function (t, r, i) {
            return e(n, t, r, i);
          }), n;
        };
      },
      3386: function _(t, e, n) {
        var r = n(1078),
            i = n(5976),
            a = n(5652),
            o = n(9246),
            s = i(function (t) {
          return a(r(t, 1, o, !0));
        });
        t.exports = s;
      },
      3955: function _(t, e, n) {
        var r = n(9833),
            i = 0;

        t.exports = function (t) {
          var e = ++i;
          return r(t) + e;
        };
      },
      2628: function _(t, e, n) {
        var r = n(7415),
            i = n(3674);

        t.exports = function (t) {
          return null == t ? [] : r(t, i(t));
        };
      },
      7287: function _(t, e, n) {
        var r = n(4865),
            i = n(1757);

        t.exports = function (t, e) {
          return i(t || [], e || [], r);
        };
      },
      9234: function _() {},
      1748: function _(t, e, n) {
        var r = {
          "./locale": 9234,
          "./locale.js": 9234
        };

        function i(t) {
          var e = a(t);
          return n(e);
        }

        function a(t) {
          if (!n.o(r, t)) {
            var e = new Error("Cannot find module '" + t + "'");
            throw e.code = "MODULE_NOT_FOUND", e;
          }

          return r[t];
        }

        i.keys = function () {
          return Object.keys(r);
        }, i.resolve = a, t.exports = i, i.id = 1748;
      },
      1941: function _(t, e, n) {
        (t = n.nmd(t)).exports = function () {
          var e, r;

          function i() {
            return e.apply(null, arguments);
          }

          function a(t) {
            return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t);
          }

          function o(t) {
            return null != t && "[object Object]" === Object.prototype.toString.call(t);
          }

          function s(t) {
            return void 0 === t;
          }

          function c(t) {
            return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t);
          }

          function u(t) {
            return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t);
          }

          function l(t, e) {
            var n,
                r = [];

            for (n = 0; n < t.length; ++n) {
              r.push(e(t[n], n));
            }

            return r;
          }

          function h(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }

          function f(t, e) {
            for (var n in e) {
              h(e, n) && (t[n] = e[n]);
            }

            return h(e, "toString") && (t.toString = e.toString), h(e, "valueOf") && (t.valueOf = e.valueOf), t;
          }

          function d(t, e, n, r) {
            return be(t, e, n, r, !0).utc();
          }

          function p(t) {
            return null == t._pf && (t._pf = {
              empty: !1,
              unusedTokens: [],
              unusedInput: [],
              overflow: -2,
              charsLeftOver: 0,
              nullInput: !1,
              invalidMonth: null,
              invalidFormat: !1,
              userInvalidated: !1,
              iso: !1,
              parsedDateParts: [],
              meridiem: null,
              rfc2822: !1,
              weekdayMismatch: !1
            }), t._pf;
          }

          function y(t) {
            if (null == t._isValid) {
              var e = p(t),
                  n = r.call(e.parsedDateParts, function (t) {
                return null != t;
              }),
                  i = !isNaN(t._d.getTime()) && e.overflow < 0 && !e.empty && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && n);
              if (t._strict && (i = i && 0 === e.charsLeftOver && 0 === e.unusedTokens.length && void 0 === e.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return i;
              t._isValid = i;
            }

            return t._isValid;
          }

          function g(t) {
            var e = d(NaN);
            return null != t ? f(p(e), t) : p(e).userInvalidated = !0, e;
          }

          r = Array.prototype.some ? Array.prototype.some : function (t) {
            for (var e = Object(this), n = e.length >>> 0, r = 0; r < n; r++) {
              if (r in e && t.call(this, e[r], r, e)) return !0;
            }

            return !1;
          };
          var m = i.momentProperties = [];

          function v(t, e) {
            var n, r, i;
            if (s(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), s(e._i) || (t._i = e._i), s(e._f) || (t._f = e._f), s(e._l) || (t._l = e._l), s(e._strict) || (t._strict = e._strict), s(e._tzm) || (t._tzm = e._tzm), s(e._isUTC) || (t._isUTC = e._isUTC), s(e._offset) || (t._offset = e._offset), s(e._pf) || (t._pf = p(e)), s(e._locale) || (t._locale = e._locale), 0 < m.length) for (n = 0; n < m.length; n++) {
              s(i = e[r = m[n]]) || (t[r] = i);
            }
            return t;
          }

          var b = !1;

          function _(t) {
            v(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === b && (b = !0, i.updateOffset(this), b = !1);
          }

          function x(t) {
            return t instanceof _ || null != t && null != t._isAMomentObject;
          }

          function w(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
          }

          function k(t) {
            var e = +t,
                n = 0;
            return 0 !== e && isFinite(e) && (n = w(e)), n;
          }

          function T(t, e, n) {
            var r,
                i = Math.min(t.length, e.length),
                a = Math.abs(t.length - e.length),
                o = 0;

            for (r = 0; r < i; r++) {
              (n && t[r] !== e[r] || !n && k(t[r]) !== k(e[r])) && o++;
            }

            return o + a;
          }

          function E(t) {
            !1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t);
          }

          function C(t, e) {
            var n = !0;
            return f(function () {
              if (null != i.deprecationHandler && i.deprecationHandler(null, t), n) {
                for (var r, a = [], o = 0; o < arguments.length; o++) {
                  if (r = "", "object" == typeof arguments[o]) {
                    for (var s in r += "\n[" + o + "] ", arguments[0]) {
                      r += s + ": " + arguments[0][s] + ", ";
                    }

                    r = r.slice(0, -2);
                  } else r = arguments[o];

                  a.push(r);
                }

                E(t + "\nArguments: " + Array.prototype.slice.call(a).join("") + "\n" + new Error().stack), n = !1;
              }

              return e.apply(this, arguments);
            }, e);
          }

          var S,
              A = {};

          function M(t, e) {
            null != i.deprecationHandler && i.deprecationHandler(t, e), A[t] || (E(e), A[t] = !0);
          }

          function N(t) {
            return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t);
          }

          function D(t, e) {
            var n,
                r = f({}, t);

            for (n in e) {
              h(e, n) && (o(t[n]) && o(e[n]) ? (r[n] = {}, f(r[n], t[n]), f(r[n], e[n])) : null != e[n] ? r[n] = e[n] : delete r[n]);
            }

            for (n in t) {
              h(t, n) && !h(e, n) && o(t[n]) && (r[n] = f({}, r[n]));
            }

            return r;
          }

          function O(t) {
            null != t && this.set(t);
          }

          i.suppressDeprecationWarnings = !1, i.deprecationHandler = null, S = Object.keys ? Object.keys : function (t) {
            var e,
                n = [];

            for (e in t) {
              h(t, e) && n.push(e);
            }

            return n;
          };
          var B = {};

          function L(t, e) {
            var n = t.toLowerCase();
            B[n] = B[n + "s"] = B[e] = t;
          }

          function I(t) {
            return "string" == typeof t ? B[t] || B[t.toLowerCase()] : void 0;
          }

          function R(t) {
            var e,
                n,
                r = {};

            for (n in t) {
              h(t, n) && (e = I(n)) && (r[e] = t[n]);
            }

            return r;
          }

          var P = {};

          function F(t, e) {
            P[t] = e;
          }

          function j(t, e, n) {
            var r = "" + Math.abs(t),
                i = e - r.length;
            return (0 <= t ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, i)).toString().substr(1) + r;
          }

          var Y = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
              U = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
              z = {},
              q = {};

          function $(t, e, n, r) {
            var i = r;
            "string" == typeof r && (i = function i() {
              return this[r]();
            }), t && (q[t] = i), e && (q[e[0]] = function () {
              return j(i.apply(this, arguments), e[1], e[2]);
            }), n && (q[n] = function () {
              return this.localeData().ordinal(i.apply(this, arguments), t);
            });
          }

          function H(t, e) {
            return t.isValid() ? (e = W(e, t.localeData()), z[e] = z[e] || function (t) {
              var e,
                  n,
                  r,
                  i = t.match(Y);

              for (e = 0, n = i.length; e < n; e++) {
                q[i[e]] ? i[e] = q[i[e]] : i[e] = (r = i[e]).match(/\[[\s\S]/) ? r.replace(/^\[|\]$/g, "") : r.replace(/\\/g, "");
              }

              return function (e) {
                var r,
                    a = "";

                for (r = 0; r < n; r++) {
                  a += N(i[r]) ? i[r].call(e, t) : i[r];
                }

                return a;
              };
            }(e), z[e](t)) : t.localeData().invalidDate();
          }

          function W(t, e) {
            var n = 5;

            function r(t) {
              return e.longDateFormat(t) || t;
            }

            for (U.lastIndex = 0; 0 <= n && U.test(t);) {
              t = t.replace(U, r), U.lastIndex = 0, n -= 1;
            }

            return t;
          }

          var V = /\d/,
              G = /\d\d/,
              X = /\d{3}/,
              Z = /\d{4}/,
              K = /[+-]?\d{6}/,
              Q = /\d\d?/,
              J = /\d\d\d\d?/,
              tt = /\d\d\d\d\d\d?/,
              et = /\d{1,3}/,
              nt = /\d{1,4}/,
              rt = /[+-]?\d{1,6}/,
              it = /\d+/,
              at = /[+-]?\d+/,
              ot = /Z|[+-]\d\d:?\d\d/gi,
              st = /Z|[+-]\d\d(?::?\d\d)?/gi,
              ct = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
              ut = {};

          function lt(t, e, n) {
            ut[t] = N(e) ? e : function (t, r) {
              return t && n ? n : e;
            };
          }

          function ht(t, e) {
            return h(ut, t) ? ut[t](e._strict, e._locale) : new RegExp(ft(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (t, e, n, r, i) {
              return e || n || r || i;
            })));
          }

          function ft(t) {
            return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
          }

          var dt = {};

          function pt(t, e) {
            var n,
                r = e;

            for ("string" == typeof t && (t = [t]), c(e) && (r = function r(t, n) {
              n[e] = k(t);
            }), n = 0; n < t.length; n++) {
              dt[t[n]] = r;
            }
          }

          function yt(t, e) {
            pt(t, function (t, n, r, i) {
              r._w = r._w || {}, e(t, r._w, r, i);
            });
          }

          function gt(t) {
            return mt(t) ? 366 : 365;
          }

          function mt(t) {
            return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
          }

          $("Y", 0, 0, function () {
            var t = this.year();
            return t <= 9999 ? "" + t : "+" + t;
          }), $(0, ["YY", 2], 0, function () {
            return this.year() % 100;
          }), $(0, ["YYYY", 4], 0, "year"), $(0, ["YYYYY", 5], 0, "year"), $(0, ["YYYYYY", 6, !0], 0, "year"), L("year", "y"), F("year", 1), lt("Y", at), lt("YY", Q, G), lt("YYYY", nt, Z), lt("YYYYY", rt, K), lt("YYYYYY", rt, K), pt(["YYYYY", "YYYYYY"], 0), pt("YYYY", function (t, e) {
            e[0] = 2 === t.length ? i.parseTwoDigitYear(t) : k(t);
          }), pt("YY", function (t, e) {
            e[0] = i.parseTwoDigitYear(t);
          }), pt("Y", function (t, e) {
            e[0] = parseInt(t, 10);
          }), i.parseTwoDigitYear = function (t) {
            return k(t) + (68 < k(t) ? 1900 : 2e3);
          };

          var vt,
              bt = _t("FullYear", !0);

          function _t(t, e) {
            return function (n) {
              return null != n ? (wt(this, t, n), i.updateOffset(this, e), this) : xt(this, t);
            };
          }

          function xt(t, e) {
            return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN;
          }

          function wt(t, e, n) {
            t.isValid() && !isNaN(n) && ("FullYear" === e && mt(t.year()) && 1 === t.month() && 29 === t.date() ? t._d["set" + (t._isUTC ? "UTC" : "") + e](n, t.month(), kt(n, t.month())) : t._d["set" + (t._isUTC ? "UTC" : "") + e](n));
          }

          function kt(t, e) {
            if (isNaN(t) || isNaN(e)) return NaN;
            var n = (e % 12 + 12) % 12;
            return t += (e - n) / 12, 1 === n ? mt(t) ? 29 : 28 : 31 - n % 7 % 2;
          }

          vt = Array.prototype.indexOf ? Array.prototype.indexOf : function (t) {
            var e;

            for (e = 0; e < this.length; ++e) {
              if (this[e] === t) return e;
            }

            return -1;
          }, $("M", ["MM", 2], "Mo", function () {
            return this.month() + 1;
          }), $("MMM", 0, 0, function (t) {
            return this.localeData().monthsShort(this, t);
          }), $("MMMM", 0, 0, function (t) {
            return this.localeData().months(this, t);
          }), L("month", "M"), F("month", 8), lt("M", Q), lt("MM", Q, G), lt("MMM", function (t, e) {
            return e.monthsShortRegex(t);
          }), lt("MMMM", function (t, e) {
            return e.monthsRegex(t);
          }), pt(["M", "MM"], function (t, e) {
            e[1] = k(t) - 1;
          }), pt(["MMM", "MMMM"], function (t, e, n, r) {
            var i = n._locale.monthsParse(t, r, n._strict);

            null != i ? e[1] = i : p(n).invalidMonth = t;
          });
          var Tt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
              Et = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
              Ct = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

          function St(t, e) {
            var n;
            if (!t.isValid()) return t;
            if ("string" == typeof e) if (/^\d+$/.test(e)) e = k(e);else if (!c(e = t.localeData().monthsParse(e))) return t;
            return n = Math.min(t.date(), kt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, n), t;
          }

          function At(t) {
            return null != t ? (St(this, t), i.updateOffset(this, !0), this) : xt(this, "Month");
          }

          var Mt = ct,
              Nt = ct;

          function Dt() {
            function t(t, e) {
              return e.length - t.length;
            }

            var e,
                n,
                r = [],
                i = [],
                a = [];

            for (e = 0; e < 12; e++) {
              n = d([2e3, e]), r.push(this.monthsShort(n, "")), i.push(this.months(n, "")), a.push(this.months(n, "")), a.push(this.monthsShort(n, ""));
            }

            for (r.sort(t), i.sort(t), a.sort(t), e = 0; e < 12; e++) {
              r[e] = ft(r[e]), i[e] = ft(i[e]);
            }

            for (e = 0; e < 24; e++) {
              a[e] = ft(a[e]);
            }

            this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i");
          }

          function Ot(t) {
            var e;

            if (t < 100 && 0 <= t) {
              var n = Array.prototype.slice.call(arguments);
              n[0] = t + 400, e = new Date(Date.UTC.apply(null, n)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t);
            } else e = new Date(Date.UTC.apply(null, arguments));

            return e;
          }

          function Bt(t, e, n) {
            var r = 7 + e - n;
            return -(7 + Ot(t, 0, r).getUTCDay() - e) % 7 + r - 1;
          }

          function Lt(t, e, n, r, i) {
            var a,
                o,
                s = 1 + 7 * (e - 1) + (7 + n - r) % 7 + Bt(t, r, i);
            return o = s <= 0 ? gt(a = t - 1) + s : s > gt(t) ? (a = t + 1, s - gt(t)) : (a = t, s), {
              year: a,
              dayOfYear: o
            };
          }

          function It(t, e, n) {
            var r,
                i,
                a = Bt(t.year(), e, n),
                o = Math.floor((t.dayOfYear() - a - 1) / 7) + 1;
            return o < 1 ? r = o + Rt(i = t.year() - 1, e, n) : o > Rt(t.year(), e, n) ? (r = o - Rt(t.year(), e, n), i = t.year() + 1) : (i = t.year(), r = o), {
              week: r,
              year: i
            };
          }

          function Rt(t, e, n) {
            var r = Bt(t, e, n),
                i = Bt(t + 1, e, n);
            return (gt(t) - r + i) / 7;
          }

          function Pt(t, e) {
            return t.slice(e, 7).concat(t.slice(0, e));
          }

          $("w", ["ww", 2], "wo", "week"), $("W", ["WW", 2], "Wo", "isoWeek"), L("week", "w"), L("isoWeek", "W"), F("week", 5), F("isoWeek", 5), lt("w", Q), lt("ww", Q, G), lt("W", Q), lt("WW", Q, G), yt(["w", "ww", "W", "WW"], function (t, e, n, r) {
            e[r.substr(0, 1)] = k(t);
          }), $("d", 0, "do", "day"), $("dd", 0, 0, function (t) {
            return this.localeData().weekdaysMin(this, t);
          }), $("ddd", 0, 0, function (t) {
            return this.localeData().weekdaysShort(this, t);
          }), $("dddd", 0, 0, function (t) {
            return this.localeData().weekdays(this, t);
          }), $("e", 0, 0, "weekday"), $("E", 0, 0, "isoWeekday"), L("day", "d"), L("weekday", "e"), L("isoWeekday", "E"), F("day", 11), F("weekday", 11), F("isoWeekday", 11), lt("d", Q), lt("e", Q), lt("E", Q), lt("dd", function (t, e) {
            return e.weekdaysMinRegex(t);
          }), lt("ddd", function (t, e) {
            return e.weekdaysShortRegex(t);
          }), lt("dddd", function (t, e) {
            return e.weekdaysRegex(t);
          }), yt(["dd", "ddd", "dddd"], function (t, e, n, r) {
            var i = n._locale.weekdaysParse(t, r, n._strict);

            null != i ? e.d = i : p(n).invalidWeekday = t;
          }), yt(["d", "e", "E"], function (t, e, n, r) {
            e[r] = k(t);
          });
          var Ft = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
              jt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
              Yt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
              Ut = ct,
              zt = ct,
              qt = ct;

          function $t() {
            function t(t, e) {
              return e.length - t.length;
            }

            var e,
                n,
                r,
                i,
                a,
                o = [],
                s = [],
                c = [],
                u = [];

            for (e = 0; e < 7; e++) {
              n = d([2e3, 1]).day(e), r = this.weekdaysMin(n, ""), i = this.weekdaysShort(n, ""), a = this.weekdays(n, ""), o.push(r), s.push(i), c.push(a), u.push(r), u.push(i), u.push(a);
            }

            for (o.sort(t), s.sort(t), c.sort(t), u.sort(t), e = 0; e < 7; e++) {
              s[e] = ft(s[e]), c[e] = ft(c[e]), u[e] = ft(u[e]);
            }

            this._weekdaysRegex = new RegExp("^(" + u.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i");
          }

          function Ht() {
            return this.hours() % 12 || 12;
          }

          function Wt(t, e) {
            $(t, 0, 0, function () {
              return this.localeData().meridiem(this.hours(), this.minutes(), e);
            });
          }

          function Vt(t, e) {
            return e._meridiemParse;
          }

          $("H", ["HH", 2], 0, "hour"), $("h", ["hh", 2], 0, Ht), $("k", ["kk", 2], 0, function () {
            return this.hours() || 24;
          }), $("hmm", 0, 0, function () {
            return "" + Ht.apply(this) + j(this.minutes(), 2);
          }), $("hmmss", 0, 0, function () {
            return "" + Ht.apply(this) + j(this.minutes(), 2) + j(this.seconds(), 2);
          }), $("Hmm", 0, 0, function () {
            return "" + this.hours() + j(this.minutes(), 2);
          }), $("Hmmss", 0, 0, function () {
            return "" + this.hours() + j(this.minutes(), 2) + j(this.seconds(), 2);
          }), Wt("a", !0), Wt("A", !1), L("hour", "h"), F("hour", 13), lt("a", Vt), lt("A", Vt), lt("H", Q), lt("h", Q), lt("k", Q), lt("HH", Q, G), lt("hh", Q, G), lt("kk", Q, G), lt("hmm", J), lt("hmmss", tt), lt("Hmm", J), lt("Hmmss", tt), pt(["H", "HH"], 3), pt(["k", "kk"], function (t, e, n) {
            var r = k(t);
            e[3] = 24 === r ? 0 : r;
          }), pt(["a", "A"], function (t, e, n) {
            n._isPm = n._locale.isPM(t), n._meridiem = t;
          }), pt(["h", "hh"], function (t, e, n) {
            e[3] = k(t), p(n).bigHour = !0;
          }), pt("hmm", function (t, e, n) {
            var r = t.length - 2;
            e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r)), p(n).bigHour = !0;
          }), pt("hmmss", function (t, e, n) {
            var r = t.length - 4,
                i = t.length - 2;
            e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r, 2)), e[5] = k(t.substr(i)), p(n).bigHour = !0;
          }), pt("Hmm", function (t, e, n) {
            var r = t.length - 2;
            e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r));
          }), pt("Hmmss", function (t, e, n) {
            var r = t.length - 4,
                i = t.length - 2;
            e[3] = k(t.substr(0, r)), e[4] = k(t.substr(r, 2)), e[5] = k(t.substr(i));
          });

          var Gt,
              Xt = _t("Hours", !0),
              Zt = {
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L"
            },
            longDateFormat: {
              LTS: "h:mm:ss A",
              LT: "h:mm A",
              L: "MM/DD/YYYY",
              LL: "MMMM D, YYYY",
              LLL: "MMMM D, YYYY h:mm A",
              LLLL: "dddd, MMMM D, YYYY h:mm A"
            },
            invalidDate: "Invalid date",
            ordinal: "%d",
            dayOfMonthOrdinalParse: /\d{1,2}/,
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years"
            },
            months: Et,
            monthsShort: Ct,
            week: {
              dow: 0,
              doy: 6
            },
            weekdays: Ft,
            weekdaysMin: Yt,
            weekdaysShort: jt,
            meridiemParse: /[ap]\.?m?\.?/i
          },
              Kt = {},
              Qt = {};

          function Jt(t) {
            return t ? t.toLowerCase().replace("_", "-") : t;
          }

          function te(e) {
            var r = null;
            if (!Kt[e] && t && t.exports) try {
              r = Gt._abbr, n(1748)("./" + e), ee(r);
            } catch (e) {}
            return Kt[e];
          }

          function ee(t, e) {
            var n;
            return t && ((n = s(e) ? re(t) : ne(t, e)) ? Gt = n : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), Gt._abbr;
          }

          function ne(t, e) {
            if (null === e) return delete Kt[t], null;
            var n,
                r = Zt;
            if (e.abbr = t, null != Kt[t]) M("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = Kt[t]._config;else if (null != e.parentLocale) if (null != Kt[e.parentLocale]) r = Kt[e.parentLocale]._config;else {
              if (null == (n = te(e.parentLocale))) return Qt[e.parentLocale] || (Qt[e.parentLocale] = []), Qt[e.parentLocale].push({
                name: t,
                config: e
              }), null;
              r = n._config;
            }
            return Kt[t] = new O(D(r, e)), Qt[t] && Qt[t].forEach(function (t) {
              ne(t.name, t.config);
            }), ee(t), Kt[t];
          }

          function re(t) {
            var e;
            if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return Gt;

            if (!a(t)) {
              if (e = te(t)) return e;
              t = [t];
            }

            return function (t) {
              for (var e, n, r, i, a = 0; a < t.length;) {
                for (e = (i = Jt(t[a]).split("-")).length, n = (n = Jt(t[a + 1])) ? n.split("-") : null; 0 < e;) {
                  if (r = te(i.slice(0, e).join("-"))) return r;
                  if (n && n.length >= e && T(i, n, !0) >= e - 1) break;
                  e--;
                }

                a++;
              }

              return Gt;
            }(t);
          }

          function ie(t) {
            var e,
                n = t._a;
            return n && -2 === p(t).overflow && (e = n[1] < 0 || 11 < n[1] ? 1 : n[2] < 1 || n[2] > kt(n[0], n[1]) ? 2 : n[3] < 0 || 24 < n[3] || 24 === n[3] && (0 !== n[4] || 0 !== n[5] || 0 !== n[6]) ? 3 : n[4] < 0 || 59 < n[4] ? 4 : n[5] < 0 || 59 < n[5] ? 5 : n[6] < 0 || 999 < n[6] ? 6 : -1, p(t)._overflowDayOfYear && (e < 0 || 2 < e) && (e = 2), p(t)._overflowWeeks && -1 === e && (e = 7), p(t)._overflowWeekday && -1 === e && (e = 8), p(t).overflow = e), t;
          }

          function ae(t, e, n) {
            return null != t ? t : null != e ? e : n;
          }

          function oe(t) {
            var e,
                n,
                r,
                a,
                o,
                s = [];

            if (!t._d) {
              var c, u;

              for (c = t, u = new Date(i.now()), r = c._useUTC ? [u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()] : [u.getFullYear(), u.getMonth(), u.getDate()], t._w && null == t._a[2] && null == t._a[1] && function (t) {
                var e, n, r, i, a, o, s, c;
                if (null != (e = t._w).GG || null != e.W || null != e.E) a = 1, o = 4, n = ae(e.GG, t._a[0], It(_e(), 1, 4).year), r = ae(e.W, 1), ((i = ae(e.E, 1)) < 1 || 7 < i) && (c = !0);else {
                  a = t._locale._week.dow, o = t._locale._week.doy;
                  var u = It(_e(), a, o);
                  n = ae(e.gg, t._a[0], u.year), r = ae(e.w, u.week), null != e.d ? ((i = e.d) < 0 || 6 < i) && (c = !0) : null != e.e ? (i = e.e + a, (e.e < 0 || 6 < e.e) && (c = !0)) : i = a;
                }
                r < 1 || r > Rt(n, a, o) ? p(t)._overflowWeeks = !0 : null != c ? p(t)._overflowWeekday = !0 : (s = Lt(n, r, i, a, o), t._a[0] = s.year, t._dayOfYear = s.dayOfYear);
              }(t), null != t._dayOfYear && (o = ae(t._a[0], r[0]), (t._dayOfYear > gt(o) || 0 === t._dayOfYear) && (p(t)._overflowDayOfYear = !0), n = Ot(o, 0, t._dayOfYear), t._a[1] = n.getUTCMonth(), t._a[2] = n.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) {
                t._a[e] = s[e] = r[e];
              }

              for (; e < 7; e++) {
                t._a[e] = s[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
              }

              24 === t._a[3] && 0 === t._a[4] && 0 === t._a[5] && 0 === t._a[6] && (t._nextDay = !0, t._a[3] = 0), t._d = (t._useUTC ? Ot : function (t, e, n, r, i, a, o) {
                var s;
                return t < 100 && 0 <= t ? (s = new Date(t + 400, e, n, r, i, a, o), isFinite(s.getFullYear()) && s.setFullYear(t)) : s = new Date(t, e, n, r, i, a, o), s;
              }).apply(null, s), a = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[3] = 24), t._w && void 0 !== t._w.d && t._w.d !== a && (p(t).weekdayMismatch = !0);
            }
          }

          var se = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
              ce = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
              ue = /Z|[+-]\d\d(?::?\d\d)?/,
              le = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/]],
              he = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
              fe = /^\/?Date\((\-?\d+)/i;

          function de(t) {
            var e,
                n,
                r,
                i,
                a,
                o,
                s = t._i,
                c = se.exec(s) || ce.exec(s);

            if (c) {
              for (p(t).iso = !0, e = 0, n = le.length; e < n; e++) {
                if (le[e][1].exec(c[1])) {
                  i = le[e][0], r = !1 !== le[e][2];
                  break;
                }
              }

              if (null == i) return void (t._isValid = !1);

              if (c[3]) {
                for (e = 0, n = he.length; e < n; e++) {
                  if (he[e][1].exec(c[3])) {
                    a = (c[2] || " ") + he[e][0];
                    break;
                  }
                }

                if (null == a) return void (t._isValid = !1);
              }

              if (!r && null != a) return void (t._isValid = !1);

              if (c[4]) {
                if (!ue.exec(c[4])) return void (t._isValid = !1);
                o = "Z";
              }

              t._f = i + (a || "") + (o || ""), me(t);
            } else t._isValid = !1;
          }

          var pe = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
              ye = {
            UT: 0,
            GMT: 0,
            EDT: -240,
            EST: -300,
            CDT: -300,
            CST: -360,
            MDT: -360,
            MST: -420,
            PDT: -420,
            PST: -480
          };

          function ge(t) {
            var e,
                n,
                r,
                i = pe.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));

            if (i) {
              var a = function (t, e, n, r, i, a) {
                var o = [function (t) {
                  var e = parseInt(t, 10);
                  return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
                }(t), Ct.indexOf(e), parseInt(n, 10), parseInt(r, 10), parseInt(i, 10)];
                return a && o.push(parseInt(a, 10)), o;
              }(i[4], i[3], i[2], i[5], i[6], i[7]);

              if (n = a, r = t, (e = i[1]) && jt.indexOf(e) !== new Date(n[0], n[1], n[2]).getDay() && (p(r).weekdayMismatch = !0, !(r._isValid = !1))) return;
              t._a = a, t._tzm = function (t, e, n) {
                if (t) return ye[t];
                if (e) return 0;
                var r = parseInt(n, 10),
                    i = r % 100;
                return (r - i) / 100 * 60 + i;
              }(i[8], i[9], i[10]), t._d = Ot.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), p(t).rfc2822 = !0;
            } else t._isValid = !1;
          }

          function me(t) {
            if (t._f !== i.ISO_8601) {
              if (t._f !== i.RFC_2822) {
                t._a = [], p(t).empty = !0;
                var e,
                    n,
                    r,
                    a,
                    o,
                    s,
                    c,
                    u,
                    l = "" + t._i,
                    f = l.length,
                    d = 0;

                for (r = W(t._f, t._locale).match(Y) || [], e = 0; e < r.length; e++) {
                  a = r[e], (n = (l.match(ht(a, t)) || [])[0]) && (0 < (o = l.substr(0, l.indexOf(n))).length && p(t).unusedInput.push(o), l = l.slice(l.indexOf(n) + n.length), d += n.length), q[a] ? (n ? p(t).empty = !1 : p(t).unusedTokens.push(a), s = a, u = t, null != (c = n) && h(dt, s) && dt[s](c, u._a, u, s)) : t._strict && !n && p(t).unusedTokens.push(a);
                }

                p(t).charsLeftOver = f - d, 0 < l.length && p(t).unusedInput.push(l), t._a[3] <= 12 && !0 === p(t).bigHour && 0 < t._a[3] && (p(t).bigHour = void 0), p(t).parsedDateParts = t._a.slice(0), p(t).meridiem = t._meridiem, t._a[3] = function (t, e, n) {
                  var r;
                  return null == n ? e : null != t.meridiemHour ? t.meridiemHour(e, n) : (null != t.isPM && ((r = t.isPM(n)) && e < 12 && (e += 12), r || 12 !== e || (e = 0)), e);
                }(t._locale, t._a[3], t._meridiem), oe(t), ie(t);
              } else ge(t);
            } else de(t);
          }

          function ve(t) {
            var e,
                n,
                r,
                h,
                d = t._i,
                m = t._f;
            return t._locale = t._locale || re(t._l), null === d || void 0 === m && "" === d ? g({
              nullInput: !0
            }) : ("string" == typeof d && (t._i = d = t._locale.preparse(d)), x(d) ? new _(ie(d)) : (u(d) ? t._d = d : a(m) ? function (t) {
              var e, n, r, i, a;
              if (0 === t._f.length) return p(t).invalidFormat = !0, t._d = new Date(NaN);

              for (i = 0; i < t._f.length; i++) {
                a = 0, e = v({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[i], me(e), y(e) && (a += p(e).charsLeftOver, a += 10 * p(e).unusedTokens.length, p(e).score = a, (null == r || a < r) && (r = a, n = e));
              }

              f(t, n || e);
            }(t) : m ? me(t) : s(n = (e = t)._i) ? e._d = new Date(i.now()) : u(n) ? e._d = new Date(n.valueOf()) : "string" == typeof n ? (r = e, null === (h = fe.exec(r._i)) ? (de(r), !1 === r._isValid && (delete r._isValid, ge(r), !1 === r._isValid && (delete r._isValid, i.createFromInputFallback(r)))) : r._d = new Date(+h[1])) : a(n) ? (e._a = l(n.slice(0), function (t) {
              return parseInt(t, 10);
            }), oe(e)) : o(n) ? function (t) {
              if (!t._d) {
                var e = R(t._i);
                t._a = l([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function (t) {
                  return t && parseInt(t, 10);
                }), oe(t);
              }
            }(e) : c(n) ? e._d = new Date(n) : i.createFromInputFallback(e), y(t) || (t._d = null), t));
          }

          function be(t, e, n, r, i) {
            var s,
                c = {};
            return !0 !== n && !1 !== n || (r = n, n = void 0), (o(t) && function (t) {
              if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
              var e;

              for (e in t) {
                if (t.hasOwnProperty(e)) return !1;
              }

              return !0;
            }(t) || a(t) && 0 === t.length) && (t = void 0), c._isAMomentObject = !0, c._useUTC = c._isUTC = i, c._l = n, c._i = t, c._f = e, c._strict = r, (s = new _(ie(ve(c))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s;
          }

          function _e(t, e, n, r) {
            return be(t, e, n, r, !1);
          }

          i.createFromInputFallback = C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (t) {
            t._d = new Date(t._i + (t._useUTC ? " UTC" : ""));
          }), i.ISO_8601 = function () {}, i.RFC_2822 = function () {};
          var xe = C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
            var t = _e.apply(null, arguments);

            return this.isValid() && t.isValid() ? t < this ? this : t : g();
          }),
              we = C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
            var t = _e.apply(null, arguments);

            return this.isValid() && t.isValid() ? this < t ? this : t : g();
          });

          function ke(t, e) {
            var n, r;
            if (1 === e.length && a(e[0]) && (e = e[0]), !e.length) return _e();

            for (n = e[0], r = 1; r < e.length; ++r) {
              e[r].isValid() && !e[r][t](n) || (n = e[r]);
            }

            return n;
          }

          var Te = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

          function Ee(t) {
            var e = R(t),
                n = e.year || 0,
                r = e.quarter || 0,
                i = e.month || 0,
                a = e.week || e.isoWeek || 0,
                o = e.day || 0,
                s = e.hour || 0,
                c = e.minute || 0,
                u = e.second || 0,
                l = e.millisecond || 0;
            this._isValid = function (t) {
              for (var e in t) {
                if (-1 === vt.call(Te, e) || null != t[e] && isNaN(t[e])) return !1;
              }

              for (var n = !1, r = 0; r < Te.length; ++r) {
                if (t[Te[r]]) {
                  if (n) return !1;
                  parseFloat(t[Te[r]]) !== k(t[Te[r]]) && (n = !0);
                }
              }

              return !0;
            }(e), this._milliseconds = +l + 1e3 * u + 6e4 * c + 1e3 * s * 60 * 60, this._days = +o + 7 * a, this._months = +i + 3 * r + 12 * n, this._data = {}, this._locale = re(), this._bubble();
          }

          function Ce(t) {
            return t instanceof Ee;
          }

          function Se(t) {
            return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t);
          }

          function Ae(t, e) {
            $(t, 0, 0, function () {
              var t = this.utcOffset(),
                  n = "+";
              return t < 0 && (t = -t, n = "-"), n + j(~~(t / 60), 2) + e + j(~~t % 60, 2);
            });
          }

          Ae("Z", ":"), Ae("ZZ", ""), lt("Z", st), lt("ZZ", st), pt(["Z", "ZZ"], function (t, e, n) {
            n._useUTC = !0, n._tzm = Ne(st, t);
          });
          var Me = /([\+\-]|\d\d)/gi;

          function Ne(t, e) {
            var n = (e || "").match(t);
            if (null === n) return null;
            var r = ((n[n.length - 1] || []) + "").match(Me) || ["-", 0, 0],
                i = 60 * r[1] + k(r[2]);
            return 0 === i ? 0 : "+" === r[0] ? i : -i;
          }

          function De(t, e) {
            var n, r;
            return e._isUTC ? (n = e.clone(), r = (x(t) || u(t) ? t.valueOf() : _e(t).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), i.updateOffset(n, !1), n) : _e(t).local();
          }

          function Oe(t) {
            return 15 * -Math.round(t._d.getTimezoneOffset() / 15);
          }

          function Be() {
            return !!this.isValid() && this._isUTC && 0 === this._offset;
          }

          i.updateOffset = function () {};

          var Le = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
              Ie = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

          function Re(t, e) {
            var n,
                r,
                i,
                a = t,
                o = null;
            return Ce(t) ? a = {
              ms: t._milliseconds,
              d: t._days,
              M: t._months
            } : c(t) ? (a = {}, e ? a[e] = t : a.milliseconds = t) : (o = Le.exec(t)) ? (n = "-" === o[1] ? -1 : 1, a = {
              y: 0,
              d: k(o[2]) * n,
              h: k(o[3]) * n,
              m: k(o[4]) * n,
              s: k(o[5]) * n,
              ms: k(Se(1e3 * o[6])) * n
            }) : (o = Ie.exec(t)) ? (n = "-" === o[1] ? -1 : 1, a = {
              y: Pe(o[2], n),
              M: Pe(o[3], n),
              w: Pe(o[4], n),
              d: Pe(o[5], n),
              h: Pe(o[6], n),
              m: Pe(o[7], n),
              s: Pe(o[8], n)
            }) : null == a ? a = {} : "object" == typeof a && ("from" in a || "to" in a) && (i = function (t, e) {
              var n;
              return t.isValid() && e.isValid() ? (e = De(e, t), t.isBefore(e) ? n = Fe(t, e) : ((n = Fe(e, t)).milliseconds = -n.milliseconds, n.months = -n.months), n) : {
                milliseconds: 0,
                months: 0
              };
            }(_e(a.from), _e(a.to)), (a = {}).ms = i.milliseconds, a.M = i.months), r = new Ee(a), Ce(t) && h(t, "_locale") && (r._locale = t._locale), r;
          }

          function Pe(t, e) {
            var n = t && parseFloat(t.replace(",", "."));
            return (isNaN(n) ? 0 : n) * e;
          }

          function Fe(t, e) {
            var n = {};
            return n.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(n.months, "M").isAfter(e) && --n.months, n.milliseconds = +e - +t.clone().add(n.months, "M"), n;
          }

          function je(t, e) {
            return function (n, r) {
              var i;
              return null === r || isNaN(+r) || (M(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), i = n, n = r, r = i), Ye(this, Re(n = "string" == typeof n ? +n : n, r), t), this;
            };
          }

          function Ye(t, e, n, r) {
            var a = e._milliseconds,
                o = Se(e._days),
                s = Se(e._months);
            t.isValid() && (r = null == r || r, s && St(t, xt(t, "Month") + s * n), o && wt(t, "Date", xt(t, "Date") + o * n), a && t._d.setTime(t._d.valueOf() + a * n), r && i.updateOffset(t, o || s));
          }

          Re.fn = Ee.prototype, Re.invalid = function () {
            return Re(NaN);
          };
          var Ue = je(1, "add"),
              ze = je(-1, "subtract");

          function qe(t, e) {
            var n = 12 * (e.year() - t.year()) + (e.month() - t.month()),
                r = t.clone().add(n, "months");
            return -(n + (e - r < 0 ? (e - r) / (r - t.clone().add(n - 1, "months")) : (e - r) / (t.clone().add(n + 1, "months") - r))) || 0;
          }

          function $e(t) {
            var e;
            return void 0 === t ? this._locale._abbr : (null != (e = re(t)) && (this._locale = e), this);
          }

          i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
          var He = C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (t) {
            return void 0 === t ? this.localeData() : this.locale(t);
          });

          function We() {
            return this._locale;
          }

          var Ve = 126227808e5;

          function Ge(t, e) {
            return (t % e + e) % e;
          }

          function Xe(t, e, n) {
            return t < 100 && 0 <= t ? new Date(t + 400, e, n) - Ve : new Date(t, e, n).valueOf();
          }

          function Ze(t, e, n) {
            return t < 100 && 0 <= t ? Date.UTC(t + 400, e, n) - Ve : Date.UTC(t, e, n);
          }

          function Ke(t, e) {
            $(0, [t, t.length], 0, e);
          }

          function Qe(t, e, n, r, i) {
            var a;
            return null == t ? It(this, r, i).year : ((a = Rt(t, r, i)) < e && (e = a), function (t, e, n, r, i) {
              var a = Lt(t, e, n, r, i),
                  o = Ot(a.year, 0, a.dayOfYear);
              return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
            }.call(this, t, e, n, r, i));
          }

          $(0, ["gg", 2], 0, function () {
            return this.weekYear() % 100;
          }), $(0, ["GG", 2], 0, function () {
            return this.isoWeekYear() % 100;
          }), Ke("gggg", "weekYear"), Ke("ggggg", "weekYear"), Ke("GGGG", "isoWeekYear"), Ke("GGGGG", "isoWeekYear"), L("weekYear", "gg"), L("isoWeekYear", "GG"), F("weekYear", 1), F("isoWeekYear", 1), lt("G", at), lt("g", at), lt("GG", Q, G), lt("gg", Q, G), lt("GGGG", nt, Z), lt("gggg", nt, Z), lt("GGGGG", rt, K), lt("ggggg", rt, K), yt(["gggg", "ggggg", "GGGG", "GGGGG"], function (t, e, n, r) {
            e[r.substr(0, 2)] = k(t);
          }), yt(["gg", "GG"], function (t, e, n, r) {
            e[r] = i.parseTwoDigitYear(t);
          }), $("Q", 0, "Qo", "quarter"), L("quarter", "Q"), F("quarter", 7), lt("Q", V), pt("Q", function (t, e) {
            e[1] = 3 * (k(t) - 1);
          }), $("D", ["DD", 2], "Do", "date"), L("date", "D"), F("date", 9), lt("D", Q), lt("DD", Q, G), lt("Do", function (t, e) {
            return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
          }), pt(["D", "DD"], 2), pt("Do", function (t, e) {
            e[2] = k(t.match(Q)[0]);
          });

          var Je = _t("Date", !0);

          $("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), L("dayOfYear", "DDD"), F("dayOfYear", 4), lt("DDD", et), lt("DDDD", X), pt(["DDD", "DDDD"], function (t, e, n) {
            n._dayOfYear = k(t);
          }), $("m", ["mm", 2], 0, "minute"), L("minute", "m"), F("minute", 14), lt("m", Q), lt("mm", Q, G), pt(["m", "mm"], 4);

          var tn = _t("Minutes", !1);

          $("s", ["ss", 2], 0, "second"), L("second", "s"), F("second", 15), lt("s", Q), lt("ss", Q, G), pt(["s", "ss"], 5);

          var en,
              nn = _t("Seconds", !1);

          for ($("S", 0, 0, function () {
            return ~~(this.millisecond() / 100);
          }), $(0, ["SS", 2], 0, function () {
            return ~~(this.millisecond() / 10);
          }), $(0, ["SSS", 3], 0, "millisecond"), $(0, ["SSSS", 4], 0, function () {
            return 10 * this.millisecond();
          }), $(0, ["SSSSS", 5], 0, function () {
            return 100 * this.millisecond();
          }), $(0, ["SSSSSS", 6], 0, function () {
            return 1e3 * this.millisecond();
          }), $(0, ["SSSSSSS", 7], 0, function () {
            return 1e4 * this.millisecond();
          }), $(0, ["SSSSSSSS", 8], 0, function () {
            return 1e5 * this.millisecond();
          }), $(0, ["SSSSSSSSS", 9], 0, function () {
            return 1e6 * this.millisecond();
          }), L("millisecond", "ms"), F("millisecond", 16), lt("S", et, V), lt("SS", et, G), lt("SSS", et, X), en = "SSSS"; en.length <= 9; en += "S") {
            lt(en, it);
          }

          function rn(t, e) {
            e[6] = k(1e3 * ("0." + t));
          }

          for (en = "S"; en.length <= 9; en += "S") {
            pt(en, rn);
          }

          var an = _t("Milliseconds", !1);

          $("z", 0, 0, "zoneAbbr"), $("zz", 0, 0, "zoneName");
          var on = _.prototype;

          function sn(t) {
            return t;
          }

          on.add = Ue, on.calendar = function (t, e) {
            var n = t || _e(),
                r = De(n, this).startOf("day"),
                a = i.calendarFormat(this, r) || "sameElse",
                o = e && (N(e[a]) ? e[a].call(this, n) : e[a]);

            return this.format(o || this.localeData().calendar(a, this, _e(n)));
          }, on.clone = function () {
            return new _(this);
          }, on.diff = function (t, e, n) {
            var r, i, a;
            if (!this.isValid()) return NaN;
            if (!(r = De(t, this)).isValid()) return NaN;

            switch (i = 6e4 * (r.utcOffset() - this.utcOffset()), e = I(e)) {
              case "year":
                a = qe(this, r) / 12;
                break;

              case "month":
                a = qe(this, r);
                break;

              case "quarter":
                a = qe(this, r) / 3;
                break;

              case "second":
                a = (this - r) / 1e3;
                break;

              case "minute":
                a = (this - r) / 6e4;
                break;

              case "hour":
                a = (this - r) / 36e5;
                break;

              case "day":
                a = (this - r - i) / 864e5;
                break;

              case "week":
                a = (this - r - i) / 6048e5;
                break;

              default:
                a = this - r;
            }

            return n ? a : w(a);
          }, on.endOf = function (t) {
            var e;
            if (void 0 === (t = I(t)) || "millisecond" === t || !this.isValid()) return this;
            var n = this._isUTC ? Ze : Xe;

            switch (t) {
              case "year":
                e = n(this.year() + 1, 0, 1) - 1;
                break;

              case "quarter":
                e = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;

              case "month":
                e = n(this.year(), this.month() + 1, 1) - 1;
                break;

              case "week":
                e = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;

              case "isoWeek":
                e = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;

              case "day":
              case "date":
                e = n(this.year(), this.month(), this.date() + 1) - 1;
                break;

              case "hour":
                e = this._d.valueOf(), e += 36e5 - Ge(e + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1;
                break;

              case "minute":
                e = this._d.valueOf(), e += 6e4 - Ge(e, 6e4) - 1;
                break;

              case "second":
                e = this._d.valueOf(), e += 1e3 - Ge(e, 1e3) - 1;
            }

            return this._d.setTime(e), i.updateOffset(this, !0), this;
          }, on.format = function (t) {
            t || (t = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
            var e = H(this, t);
            return this.localeData().postformat(e);
          }, on.from = function (t, e) {
            return this.isValid() && (x(t) && t.isValid() || _e(t).isValid()) ? Re({
              to: this,
              from: t
            }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
          }, on.fromNow = function (t) {
            return this.from(_e(), t);
          }, on.to = function (t, e) {
            return this.isValid() && (x(t) && t.isValid() || _e(t).isValid()) ? Re({
              from: this,
              to: t
            }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
          }, on.toNow = function (t) {
            return this.to(_e(), t);
          }, on.get = function (t) {
            return N(this[t = I(t)]) ? this[t]() : this;
          }, on.invalidAt = function () {
            return p(this).overflow;
          }, on.isAfter = function (t, e) {
            var n = x(t) ? t : _e(t);
            return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = I(e) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(e).valueOf());
          }, on.isBefore = function (t, e) {
            var n = x(t) ? t : _e(t);
            return !(!this.isValid() || !n.isValid()) && ("millisecond" === (e = I(e) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(e).valueOf() < n.valueOf());
          }, on.isBetween = function (t, e, n, r) {
            var i = x(t) ? t : _e(t),
                a = x(e) ? e : _e(e);
            return !!(this.isValid() && i.isValid() && a.isValid()) && ("(" === (r = r || "()")[0] ? this.isAfter(i, n) : !this.isBefore(i, n)) && (")" === r[1] ? this.isBefore(a, n) : !this.isAfter(a, n));
          }, on.isSame = function (t, e) {
            var n,
                r = x(t) ? t : _e(t);
            return !(!this.isValid() || !r.isValid()) && ("millisecond" === (e = I(e) || "millisecond") ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(e).valueOf() <= n && n <= this.clone().endOf(e).valueOf()));
          }, on.isSameOrAfter = function (t, e) {
            return this.isSame(t, e) || this.isAfter(t, e);
          }, on.isSameOrBefore = function (t, e) {
            return this.isSame(t, e) || this.isBefore(t, e);
          }, on.isValid = function () {
            return y(this);
          }, on.lang = He, on.locale = $e, on.localeData = We, on.max = we, on.min = xe, on.parsingFlags = function () {
            return f({}, p(this));
          }, on.set = function (t, e) {
            if ("object" == typeof t) for (var n = function (t) {
              var e = [];

              for (var n in t) {
                e.push({
                  unit: n,
                  priority: P[n]
                });
              }

              return e.sort(function (t, e) {
                return t.priority - e.priority;
              }), e;
            }(t = R(t)), r = 0; r < n.length; r++) {
              this[n[r].unit](t[n[r].unit]);
            } else if (N(this[t = I(t)])) return this[t](e);
            return this;
          }, on.startOf = function (t) {
            var e;
            if (void 0 === (t = I(t)) || "millisecond" === t || !this.isValid()) return this;
            var n = this._isUTC ? Ze : Xe;

            switch (t) {
              case "year":
                e = n(this.year(), 0, 1);
                break;

              case "quarter":
                e = n(this.year(), this.month() - this.month() % 3, 1);
                break;

              case "month":
                e = n(this.year(), this.month(), 1);
                break;

              case "week":
                e = n(this.year(), this.month(), this.date() - this.weekday());
                break;

              case "isoWeek":
                e = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;

              case "day":
              case "date":
                e = n(this.year(), this.month(), this.date());
                break;

              case "hour":
                e = this._d.valueOf(), e -= Ge(e + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5);
                break;

              case "minute":
                e = this._d.valueOf(), e -= Ge(e, 6e4);
                break;

              case "second":
                e = this._d.valueOf(), e -= Ge(e, 1e3);
            }

            return this._d.setTime(e), i.updateOffset(this, !0), this;
          }, on.subtract = ze, on.toArray = function () {
            var t = this;
            return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()];
          }, on.toObject = function () {
            var t = this;
            return {
              years: t.year(),
              months: t.month(),
              date: t.date(),
              hours: t.hours(),
              minutes: t.minutes(),
              seconds: t.seconds(),
              milliseconds: t.milliseconds()
            };
          }, on.toDate = function () {
            return new Date(this.valueOf());
          }, on.toISOString = function (t) {
            if (!this.isValid()) return null;
            var e = !0 !== t,
                n = e ? this.clone().utc() : this;
            return n.year() < 0 || 9999 < n.year() ? H(n, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : N(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", H(n, "Z")) : H(n, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
          }, on.inspect = function () {
            if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
            var t = "moment",
                e = "";
            this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z");
            var n = "[" + t + '("]',
                r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
                i = e + '[")]';
            return this.format(n + r + "-MM-DD[T]HH:mm:ss.SSS" + i);
          }, on.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
          }, on.toString = function () {
            return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
          }, on.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
          }, on.valueOf = function () {
            return this._d.valueOf() - 6e4 * (this._offset || 0);
          }, on.creationData = function () {
            return {
              input: this._i,
              format: this._f,
              locale: this._locale,
              isUTC: this._isUTC,
              strict: this._strict
            };
          }, on.year = bt, on.isLeapYear = function () {
            return mt(this.year());
          }, on.weekYear = function (t) {
            return Qe.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
          }, on.isoWeekYear = function (t) {
            return Qe.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4);
          }, on.quarter = on.quarters = function (t) {
            return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3);
          }, on.month = At, on.daysInMonth = function () {
            return kt(this.year(), this.month());
          }, on.week = on.weeks = function (t) {
            var e = this.localeData().week(this);
            return null == t ? e : this.add(7 * (t - e), "d");
          }, on.isoWeek = on.isoWeeks = function (t) {
            var e = It(this, 1, 4).week;
            return null == t ? e : this.add(7 * (t - e), "d");
          }, on.weeksInYear = function () {
            var t = this.localeData()._week;

            return Rt(this.year(), t.dow, t.doy);
          }, on.isoWeeksInYear = function () {
            return Rt(this.year(), 1, 4);
          }, on.date = Je, on.day = on.days = function (t) {
            if (!this.isValid()) return null != t ? this : NaN;
            var e,
                n,
                r = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            return null != t ? (e = t, n = this.localeData(), t = "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = n.weekdaysParse(e)) ? e : null : parseInt(e, 10), this.add(t - r, "d")) : r;
          }, on.weekday = function (t) {
            if (!this.isValid()) return null != t ? this : NaN;
            var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return null == t ? e : this.add(t - e, "d");
          }, on.isoWeekday = function (t) {
            if (!this.isValid()) return null != t ? this : NaN;
            if (null == t) return this.day() || 7;
            var e,
                n,
                r = (e = t, n = this.localeData(), "string" == typeof e ? n.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e);
            return this.day(this.day() % 7 ? r : r - 7);
          }, on.dayOfYear = function (t) {
            var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
            return null == t ? e : this.add(t - e, "d");
          }, on.hour = on.hours = Xt, on.minute = on.minutes = tn, on.second = on.seconds = nn, on.millisecond = on.milliseconds = an, on.utcOffset = function (t, e, n) {
            var r,
                a = this._offset || 0;
            if (!this.isValid()) return null != t ? this : NaN;
            if (null == t) return this._isUTC ? a : Oe(this);

            if ("string" == typeof t) {
              if (null === (t = Ne(st, t))) return this;
            } else Math.abs(t) < 16 && !n && (t *= 60);

            return !this._isUTC && e && (r = Oe(this)), this._offset = t, this._isUTC = !0, null != r && this.add(r, "m"), a !== t && (!e || this._changeInProgress ? Ye(this, Re(t - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, i.updateOffset(this, !0), this._changeInProgress = null)), this;
          }, on.utc = function (t) {
            return this.utcOffset(0, t);
          }, on.local = function (t) {
            return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(Oe(this), "m")), this;
          }, on.parseZone = function () {
            if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
              var t = Ne(ot, this._i);
              null != t ? this.utcOffset(t) : this.utcOffset(0, !0);
            }
            return this;
          }, on.hasAlignedHourOffset = function (t) {
            return !!this.isValid() && (t = t ? _e(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0);
          }, on.isDST = function () {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
          }, on.isLocal = function () {
            return !!this.isValid() && !this._isUTC;
          }, on.isUtcOffset = function () {
            return !!this.isValid() && this._isUTC;
          }, on.isUtc = Be, on.isUTC = Be, on.zoneAbbr = function () {
            return this._isUTC ? "UTC" : "";
          }, on.zoneName = function () {
            return this._isUTC ? "Coordinated Universal Time" : "";
          }, on.dates = C("dates accessor is deprecated. Use date instead.", Je), on.months = C("months accessor is deprecated. Use month instead", At), on.years = C("years accessor is deprecated. Use year instead", bt), on.zone = C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (t, e) {
            return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset();
          }), on.isDSTShifted = C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
            if (!s(this._isDSTShifted)) return this._isDSTShifted;
            var t = {};

            if (v(t, this), (t = ve(t))._a) {
              var e = t._isUTC ? d(t._a) : _e(t._a);
              this._isDSTShifted = this.isValid() && 0 < T(t._a, e.toArray());
            } else this._isDSTShifted = !1;

            return this._isDSTShifted;
          });
          var cn = O.prototype;

          function un(t, e, n, r) {
            var i = re(),
                a = d().set(r, e);
            return i[n](a, t);
          }

          function ln(t, e, n) {
            if (c(t) && (e = t, t = void 0), t = t || "", null != e) return un(t, e, n, "month");
            var r,
                i = [];

            for (r = 0; r < 12; r++) {
              i[r] = un(t, r, n, "month");
            }

            return i;
          }

          function hn(t, e, n, r) {
            "boolean" == typeof t ? c(e) && (n = e, e = void 0) : (e = t, t = !1, c(n = e) && (n = e, e = void 0)), e = e || "";
            var i,
                a = re(),
                o = t ? a._week.dow : 0;
            if (null != n) return un(e, (n + o) % 7, r, "day");
            var s = [];

            for (i = 0; i < 7; i++) {
              s[i] = un(e, (i + o) % 7, r, "day");
            }

            return s;
          }

          cn.calendar = function (t, e, n) {
            var r = this._calendar[t] || this._calendar.sameElse;
            return N(r) ? r.call(e, n) : r;
          }, cn.longDateFormat = function (t) {
            var e = this._longDateFormat[t],
                n = this._longDateFormat[t.toUpperCase()];

            return e || !n ? e : (this._longDateFormat[t] = n.replace(/MMMM|MM|DD|dddd/g, function (t) {
              return t.slice(1);
            }), this._longDateFormat[t]);
          }, cn.invalidDate = function () {
            return this._invalidDate;
          }, cn.ordinal = function (t) {
            return this._ordinal.replace("%d", t);
          }, cn.preparse = sn, cn.postformat = sn, cn.relativeTime = function (t, e, n, r) {
            var i = this._relativeTime[n];
            return N(i) ? i(t, e, n, r) : i.replace(/%d/i, t);
          }, cn.pastFuture = function (t, e) {
            var n = this._relativeTime[0 < t ? "future" : "past"];
            return N(n) ? n(e) : n.replace(/%s/i, e);
          }, cn.set = function (t) {
            var e, n;

            for (n in t) {
              N(e = t[n]) ? this[n] = e : this["_" + n] = e;
            }

            this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
          }, cn.months = function (t, e) {
            return t ? a(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Tt).test(e) ? "format" : "standalone"][t.month()] : a(this._months) ? this._months : this._months.standalone;
          }, cn.monthsShort = function (t, e) {
            return t ? a(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Tt.test(e) ? "format" : "standalone"][t.month()] : a(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
          }, cn.monthsParse = function (t, e, n) {
            var r, i, a;
            if (this._monthsParseExact) return function (t, e, n) {
              var r,
                  i,
                  a,
                  o = t.toLocaleLowerCase();
              if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r) {
                a = d([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
              }
              return n ? "MMM" === e ? -1 !== (i = vt.call(this._shortMonthsParse, o)) ? i : null : -1 !== (i = vt.call(this._longMonthsParse, o)) ? i : null : "MMM" === e ? -1 !== (i = vt.call(this._shortMonthsParse, o)) || -1 !== (i = vt.call(this._longMonthsParse, o)) ? i : null : -1 !== (i = vt.call(this._longMonthsParse, o)) || -1 !== (i = vt.call(this._shortMonthsParse, o)) ? i : null;
            }.call(this, t, e, n);

            for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
              if (i = d([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(i, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(i, "").replace(".", "") + "$", "i")), n || this._monthsParse[r] || (a = "^" + this.months(i, "") + "|^" + this.monthsShort(i, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), n && "MMMM" === e && this._longMonthsParse[r].test(t)) return r;
              if (n && "MMM" === e && this._shortMonthsParse[r].test(t)) return r;
              if (!n && this._monthsParse[r].test(t)) return r;
            }
          }, cn.monthsRegex = function (t) {
            return this._monthsParseExact ? (h(this, "_monthsRegex") || Dt.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (h(this, "_monthsRegex") || (this._monthsRegex = Nt), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
          }, cn.monthsShortRegex = function (t) {
            return this._monthsParseExact ? (h(this, "_monthsRegex") || Dt.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (h(this, "_monthsShortRegex") || (this._monthsShortRegex = Mt), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
          }, cn.week = function (t) {
            return It(t, this._week.dow, this._week.doy).week;
          }, cn.firstDayOfYear = function () {
            return this._week.doy;
          }, cn.firstDayOfWeek = function () {
            return this._week.dow;
          }, cn.weekdays = function (t, e) {
            var n = a(this._weekdays) ? this._weekdays : this._weekdays[t && !0 !== t && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
            return !0 === t ? Pt(n, this._week.dow) : t ? n[t.day()] : n;
          }, cn.weekdaysMin = function (t) {
            return !0 === t ? Pt(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
          }, cn.weekdaysShort = function (t) {
            return !0 === t ? Pt(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
          }, cn.weekdaysParse = function (t, e, n) {
            var r, i, a;
            if (this._weekdaysParseExact) return function (t, e, n) {
              var r,
                  i,
                  a,
                  o = t.toLocaleLowerCase();
              if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r) {
                a = d([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
              }
              return n ? "dddd" === e ? -1 !== (i = vt.call(this._weekdaysParse, o)) ? i : null : "ddd" === e ? -1 !== (i = vt.call(this._shortWeekdaysParse, o)) ? i : null : -1 !== (i = vt.call(this._minWeekdaysParse, o)) ? i : null : "dddd" === e ? -1 !== (i = vt.call(this._weekdaysParse, o)) || -1 !== (i = vt.call(this._shortWeekdaysParse, o)) || -1 !== (i = vt.call(this._minWeekdaysParse, o)) ? i : null : "ddd" === e ? -1 !== (i = vt.call(this._shortWeekdaysParse, o)) || -1 !== (i = vt.call(this._weekdaysParse, o)) || -1 !== (i = vt.call(this._minWeekdaysParse, o)) ? i : null : -1 !== (i = vt.call(this._minWeekdaysParse, o)) || -1 !== (i = vt.call(this._weekdaysParse, o)) || -1 !== (i = vt.call(this._shortWeekdaysParse, o)) ? i : null;
            }.call(this, t, e, n);

            for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
              if (i = d([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(i, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(i, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(i, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (a = "^" + this.weekdays(i, "") + "|^" + this.weekdaysShort(i, "") + "|^" + this.weekdaysMin(i, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), n && "dddd" === e && this._fullWeekdaysParse[r].test(t)) return r;
              if (n && "ddd" === e && this._shortWeekdaysParse[r].test(t)) return r;
              if (n && "dd" === e && this._minWeekdaysParse[r].test(t)) return r;
              if (!n && this._weekdaysParse[r].test(t)) return r;
            }
          }, cn.weekdaysRegex = function (t) {
            return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || $t.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (h(this, "_weekdaysRegex") || (this._weekdaysRegex = Ut), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
          }, cn.weekdaysShortRegex = function (t) {
            return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || $t.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (h(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = zt), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
          }, cn.weekdaysMinRegex = function (t) {
            return this._weekdaysParseExact ? (h(this, "_weekdaysRegex") || $t.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (h(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = qt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
          }, cn.isPM = function (t) {
            return "p" === (t + "").toLowerCase().charAt(0);
          }, cn.meridiem = function (t, e, n) {
            return 11 < t ? n ? "pm" : "PM" : n ? "am" : "AM";
          }, ee("en", {
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function ordinal(t) {
              var e = t % 10;
              return t + (1 === k(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th");
            }
          }), i.lang = C("moment.lang is deprecated. Use moment.locale instead.", ee), i.langData = C("moment.langData is deprecated. Use moment.localeData instead.", re);
          var fn = Math.abs;

          function dn(t, e, n, r) {
            var i = Re(e, n);
            return t._milliseconds += r * i._milliseconds, t._days += r * i._days, t._months += r * i._months, t._bubble();
          }

          function pn(t) {
            return t < 0 ? Math.floor(t) : Math.ceil(t);
          }

          function yn(t) {
            return 4800 * t / 146097;
          }

          function gn(t) {
            return 146097 * t / 4800;
          }

          function mn(t) {
            return function () {
              return this.as(t);
            };
          }

          var vn = mn("ms"),
              bn = mn("s"),
              _n = mn("m"),
              xn = mn("h"),
              wn = mn("d"),
              kn = mn("w"),
              Tn = mn("M"),
              En = mn("Q"),
              Cn = mn("y");

          function Sn(t) {
            return function () {
              return this.isValid() ? this._data[t] : NaN;
            };
          }

          var An = Sn("milliseconds"),
              Mn = Sn("seconds"),
              Nn = Sn("minutes"),
              Dn = Sn("hours"),
              On = Sn("days"),
              Bn = Sn("months"),
              Ln = Sn("years"),
              In = Math.round,
              Rn = {
            ss: 44,
            s: 45,
            m: 45,
            h: 22,
            d: 26,
            M: 11
          },
              Pn = Math.abs;

          function Fn(t) {
            return (0 < t) - (t < 0) || +t;
          }

          function jn() {
            if (!this.isValid()) return this.localeData().invalidDate();
            var t,
                e,
                n = Pn(this._milliseconds) / 1e3,
                r = Pn(this._days),
                i = Pn(this._months);
            e = w((t = w(n / 60)) / 60), n %= 60, t %= 60;
            var a = w(i / 12),
                o = i %= 12,
                s = r,
                c = e,
                u = t,
                l = n ? n.toFixed(3).replace(/\.?0+$/, "") : "",
                h = this.asSeconds();
            if (!h) return "P0D";
            var f = h < 0 ? "-" : "",
                d = Fn(this._months) !== Fn(h) ? "-" : "",
                p = Fn(this._days) !== Fn(h) ? "-" : "",
                y = Fn(this._milliseconds) !== Fn(h) ? "-" : "";
            return f + "P" + (a ? d + a + "Y" : "") + (o ? d + o + "M" : "") + (s ? p + s + "D" : "") + (c || u || l ? "T" : "") + (c ? y + c + "H" : "") + (u ? y + u + "M" : "") + (l ? y + l + "S" : "");
          }

          var Yn = Ee.prototype;
          return Yn.isValid = function () {
            return this._isValid;
          }, Yn.abs = function () {
            var t = this._data;
            return this._milliseconds = fn(this._milliseconds), this._days = fn(this._days), this._months = fn(this._months), t.milliseconds = fn(t.milliseconds), t.seconds = fn(t.seconds), t.minutes = fn(t.minutes), t.hours = fn(t.hours), t.months = fn(t.months), t.years = fn(t.years), this;
          }, Yn.add = function (t, e) {
            return dn(this, t, e, 1);
          }, Yn.subtract = function (t, e) {
            return dn(this, t, e, -1);
          }, Yn.as = function (t) {
            if (!this.isValid()) return NaN;
            var e,
                n,
                r = this._milliseconds;
            if ("month" === (t = I(t)) || "quarter" === t || "year" === t) switch (e = this._days + r / 864e5, n = this._months + yn(e), t) {
              case "month":
                return n;

              case "quarter":
                return n / 3;

              case "year":
                return n / 12;
            } else switch (e = this._days + Math.round(gn(this._months)), t) {
              case "week":
                return e / 7 + r / 6048e5;

              case "day":
                return e + r / 864e5;

              case "hour":
                return 24 * e + r / 36e5;

              case "minute":
                return 1440 * e + r / 6e4;

              case "second":
                return 86400 * e + r / 1e3;

              case "millisecond":
                return Math.floor(864e5 * e) + r;

              default:
                throw new Error("Unknown unit " + t);
            }
          }, Yn.asMilliseconds = vn, Yn.asSeconds = bn, Yn.asMinutes = _n, Yn.asHours = xn, Yn.asDays = wn, Yn.asWeeks = kn, Yn.asMonths = Tn, Yn.asQuarters = En, Yn.asYears = Cn, Yn.valueOf = function () {
            return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * k(this._months / 12) : NaN;
          }, Yn._bubble = function () {
            var t,
                e,
                n,
                r,
                i,
                a = this._milliseconds,
                o = this._days,
                s = this._months,
                c = this._data;
            return 0 <= a && 0 <= o && 0 <= s || a <= 0 && o <= 0 && s <= 0 || (a += 864e5 * pn(gn(s) + o), s = o = 0), c.milliseconds = a % 1e3, t = w(a / 1e3), c.seconds = t % 60, e = w(t / 60), c.minutes = e % 60, n = w(e / 60), c.hours = n % 24, s += i = w(yn(o += w(n / 24))), o -= pn(gn(i)), r = w(s / 12), s %= 12, c.days = o, c.months = s, c.years = r, this;
          }, Yn.clone = function () {
            return Re(this);
          }, Yn.get = function (t) {
            return t = I(t), this.isValid() ? this[t + "s"]() : NaN;
          }, Yn.milliseconds = An, Yn.seconds = Mn, Yn.minutes = Nn, Yn.hours = Dn, Yn.days = On, Yn.weeks = function () {
            return w(this.days() / 7);
          }, Yn.months = Bn, Yn.years = Ln, Yn.humanize = function (t) {
            if (!this.isValid()) return this.localeData().invalidDate();
            var e,
                n,
                r,
                i,
                a,
                o,
                s,
                c,
                u,
                l,
                h = this.localeData(),
                f = (e = !t, n = h, r = Re(this).abs(), i = In(r.as("s")), a = In(r.as("m")), o = In(r.as("h")), s = In(r.as("d")), c = In(r.as("M")), u = In(r.as("y")), (l = i <= Rn.ss && ["s", i] || i < Rn.s && ["ss", i] || a <= 1 && ["m"] || a < Rn.m && ["mm", a] || o <= 1 && ["h"] || o < Rn.h && ["hh", o] || s <= 1 && ["d"] || s < Rn.d && ["dd", s] || c <= 1 && ["M"] || c < Rn.M && ["MM", c] || u <= 1 && ["y"] || ["yy", u])[2] = e, l[3] = 0 < +this, l[4] = n, function (t, e, n, r, i) {
              return i.relativeTime(e || 1, !!n, t, r);
            }.apply(null, l));
            return t && (f = h.pastFuture(+this, f)), h.postformat(f);
          }, Yn.toISOString = jn, Yn.toString = jn, Yn.toJSON = jn, Yn.locale = $e, Yn.localeData = We, Yn.toIsoString = C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", jn), Yn.lang = He, $("X", 0, 0, "unix"), $("x", 0, 0, "valueOf"), lt("x", at), lt("X", /[+-]?\d+(\.\d{1,3})?/), pt("X", function (t, e, n) {
            n._d = new Date(1e3 * parseFloat(t, 10));
          }), pt("x", function (t, e, n) {
            n._d = new Date(k(t));
          }), i.version = "2.24.0", e = _e, i.fn = on, i.min = function () {
            return ke("isBefore", [].slice.call(arguments, 0));
          }, i.max = function () {
            return ke("isAfter", [].slice.call(arguments, 0));
          }, i.now = function () {
            return Date.now ? Date.now() : +new Date();
          }, i.utc = d, i.unix = function (t) {
            return _e(1e3 * t);
          }, i.months = function (t, e) {
            return ln(t, e, "months");
          }, i.isDate = u, i.locale = ee, i.invalid = g, i.duration = Re, i.isMoment = x, i.weekdays = function (t, e, n) {
            return hn(t, e, n, "weekdays");
          }, i.parseZone = function () {
            return _e.apply(null, arguments).parseZone();
          }, i.localeData = re, i.isDuration = Ce, i.monthsShort = function (t, e) {
            return ln(t, e, "monthsShort");
          }, i.weekdaysMin = function (t, e, n) {
            return hn(t, e, n, "weekdaysMin");
          }, i.defineLocale = ne, i.updateLocale = function (t, e) {
            if (null != e) {
              var n,
                  r,
                  i = Zt;
              null != (r = te(t)) && (i = r._config), (n = new O(e = D(i, e))).parentLocale = Kt[t], Kt[t] = n, ee(t);
            } else null != Kt[t] && (null != Kt[t].parentLocale ? Kt[t] = Kt[t].parentLocale : null != Kt[t] && delete Kt[t]);

            return Kt[t];
          }, i.locales = function () {
            return S(Kt);
          }, i.weekdaysShort = function (t, e, n) {
            return hn(t, e, n, "weekdaysShort");
          }, i.normalizeUnits = I, i.relativeTimeRounding = function (t) {
            return void 0 === t ? In : "function" == typeof t && (In = t, !0);
          }, i.relativeTimeThreshold = function (t, e) {
            return void 0 !== Rn[t] && (void 0 === e ? Rn[t] : (Rn[t] = e, "s" === t && (Rn.ss = e - 1), !0));
          }, i.calendarFormat = function (t, e) {
            var n = t.diff(e, "days", !0);
            return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
          }, i.prototype = on, i.HTML5_FMT = {
            DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
            DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
            DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
            DATE: "YYYY-MM-DD",
            TIME: "HH:mm",
            TIME_SECONDS: "HH:mm:ss",
            TIME_MS: "HH:mm:ss.SSS",
            WEEK: "GGGG-[W]WW",
            MONTH: "YYYY-MM"
          }, i;
        }();
      },
      6470: function _(t) {
        function e(t) {
          if ("string" != typeof t) throw new TypeError("Path must be a string. Received " + JSON.stringify(t));
        }

        function n(t, e) {
          for (var n, r = "", i = 0, a = -1, o = 0, s = 0; s <= t.length; ++s) {
            if (s < t.length) n = t.charCodeAt(s);else {
              if (47 === n) break;
              n = 47;
            }

            if (47 === n) {
              if (a === s - 1 || 1 === o) ;else if (a !== s - 1 && 2 === o) {
                if (r.length < 2 || 2 !== i || 46 !== r.charCodeAt(r.length - 1) || 46 !== r.charCodeAt(r.length - 2)) if (r.length > 2) {
                  var c = r.lastIndexOf("/");

                  if (c !== r.length - 1) {
                    -1 === c ? (r = "", i = 0) : i = (r = r.slice(0, c)).length - 1 - r.lastIndexOf("/"), a = s, o = 0;
                    continue;
                  }
                } else if (2 === r.length || 1 === r.length) {
                  r = "", i = 0, a = s, o = 0;
                  continue;
                }
                e && (r.length > 0 ? r += "/.." : r = "..", i = 2);
              } else r.length > 0 ? r += "/" + t.slice(a + 1, s) : r = t.slice(a + 1, s), i = s - a - 1;
              a = s, o = 0;
            } else 46 === n && -1 !== o ? ++o : o = -1;
          }

          return r;
        }

        var r = {
          resolve: function resolve() {
            for (var t, r = "", i = !1, a = arguments.length - 1; a >= -1 && !i; a--) {
              var o;
              a >= 0 ? o = arguments[a] : (void 0 === t && (t = process.cwd()), o = t), e(o), 0 !== o.length && (r = o + "/" + r, i = 47 === o.charCodeAt(0));
            }

            return r = n(r, !i), i ? r.length > 0 ? "/" + r : "/" : r.length > 0 ? r : ".";
          },
          normalize: function normalize(t) {
            if (e(t), 0 === t.length) return ".";
            var r = 47 === t.charCodeAt(0),
                i = 47 === t.charCodeAt(t.length - 1);
            return 0 !== (t = n(t, !r)).length || r || (t = "."), t.length > 0 && i && (t += "/"), r ? "/" + t : t;
          },
          isAbsolute: function isAbsolute(t) {
            return e(t), t.length > 0 && 47 === t.charCodeAt(0);
          },
          join: function join() {
            if (0 === arguments.length) return ".";

            for (var t, n = 0; n < arguments.length; ++n) {
              var i = arguments[n];
              e(i), i.length > 0 && (void 0 === t ? t = i : t += "/" + i);
            }

            return void 0 === t ? "." : r.normalize(t);
          },
          relative: function relative(t, n) {
            if (e(t), e(n), t === n) return "";
            if ((t = r.resolve(t)) === (n = r.resolve(n))) return "";

            for (var i = 1; i < t.length && 47 === t.charCodeAt(i); ++i) {
              ;
            }

            for (var a = t.length, o = a - i, s = 1; s < n.length && 47 === n.charCodeAt(s); ++s) {
              ;
            }

            for (var c = n.length - s, u = o < c ? o : c, l = -1, h = 0; h <= u; ++h) {
              if (h === u) {
                if (c > u) {
                  if (47 === n.charCodeAt(s + h)) return n.slice(s + h + 1);
                  if (0 === h) return n.slice(s + h);
                } else o > u && (47 === t.charCodeAt(i + h) ? l = h : 0 === h && (l = 0));

                break;
              }

              var f = t.charCodeAt(i + h);
              if (f !== n.charCodeAt(s + h)) break;
              47 === f && (l = h);
            }

            var d = "";

            for (h = i + l + 1; h <= a; ++h) {
              h !== a && 47 !== t.charCodeAt(h) || (0 === d.length ? d += ".." : d += "/..");
            }

            return d.length > 0 ? d + n.slice(s + l) : (s += l, 47 === n.charCodeAt(s) && ++s, n.slice(s));
          },
          _makeLong: function _makeLong(t) {
            return t;
          },
          dirname: function dirname(t) {
            if (e(t), 0 === t.length) return ".";

            for (var n = t.charCodeAt(0), r = 47 === n, i = -1, a = !0, o = t.length - 1; o >= 1; --o) {
              if (47 === (n = t.charCodeAt(o))) {
                if (!a) {
                  i = o;
                  break;
                }
              } else a = !1;
            }

            return -1 === i ? r ? "/" : "." : r && 1 === i ? "//" : t.slice(0, i);
          },
          basename: function basename(t, n) {
            if (void 0 !== n && "string" != typeof n) throw new TypeError('"ext" argument must be a string');
            e(t);
            var r,
                i = 0,
                a = -1,
                o = !0;

            if (void 0 !== n && n.length > 0 && n.length <= t.length) {
              if (n.length === t.length && n === t) return "";
              var s = n.length - 1,
                  c = -1;

              for (r = t.length - 1; r >= 0; --r) {
                var u = t.charCodeAt(r);

                if (47 === u) {
                  if (!o) {
                    i = r + 1;
                    break;
                  }
                } else -1 === c && (o = !1, c = r + 1), s >= 0 && (u === n.charCodeAt(s) ? -1 == --s && (a = r) : (s = -1, a = c));
              }

              return i === a ? a = c : -1 === a && (a = t.length), t.slice(i, a);
            }

            for (r = t.length - 1; r >= 0; --r) {
              if (47 === t.charCodeAt(r)) {
                if (!o) {
                  i = r + 1;
                  break;
                }
              } else -1 === a && (o = !1, a = r + 1);
            }

            return -1 === a ? "" : t.slice(i, a);
          },
          extname: function extname(t) {
            e(t);

            for (var n = -1, r = 0, i = -1, a = !0, o = 0, s = t.length - 1; s >= 0; --s) {
              var c = t.charCodeAt(s);
              if (47 !== c) -1 === i && (a = !1, i = s + 1), 46 === c ? -1 === n ? n = s : 1 !== o && (o = 1) : -1 !== n && (o = -1);else if (!a) {
                r = s + 1;
                break;
              }
            }

            return -1 === n || -1 === i || 0 === o || 1 === o && n === i - 1 && n === r + 1 ? "" : t.slice(n, i);
          },
          format: function format(t) {
            if (null === t || "object" != typeof t) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof t);
            return function (t, e) {
              var n = e.dir || e.root,
                  r = e.base || (e.name || "") + (e.ext || "");
              return n ? n === e.root ? n + r : n + "/" + r : r;
            }(0, t);
          },
          parse: function parse(t) {
            e(t);
            var n = {
              root: "",
              dir: "",
              base: "",
              ext: "",
              name: ""
            };
            if (0 === t.length) return n;
            var r,
                i = t.charCodeAt(0),
                a = 47 === i;
            a ? (n.root = "/", r = 1) : r = 0;

            for (var o = -1, s = 0, c = -1, u = !0, l = t.length - 1, h = 0; l >= r; --l) {
              if (47 !== (i = t.charCodeAt(l))) -1 === c && (u = !1, c = l + 1), 46 === i ? -1 === o ? o = l : 1 !== h && (h = 1) : -1 !== o && (h = -1);else if (!u) {
                s = l + 1;
                break;
              }
            }

            return -1 === o || -1 === c || 0 === h || 1 === h && o === c - 1 && o === s + 1 ? -1 !== c && (n.base = n.name = 0 === s && a ? t.slice(1, c) : t.slice(s, c)) : (0 === s && a ? (n.name = t.slice(1, o), n.base = t.slice(1, c)) : (n.name = t.slice(s, o), n.base = t.slice(s, c)), n.ext = t.slice(o, c)), s > 0 ? n.dir = t.slice(0, s - 1) : a && (n.dir = "/"), n;
          },
          sep: "/",
          delimiter: ":",
          win32: null,
          posix: null
        };
        r.posix = r, t.exports = r;
      },
      8218: function _() {},
      8009: function _() {},
      5354: function _() {},
      6878: function _() {},
      8183: function _() {},
      1428: function _() {},
      4551: function _() {},
      8800: function _() {},
      1993: function _() {},
      3069: function _() {},
      9143: function _() {}
    },
        i = {};

    function a(t) {
      var e = i[t];
      if (void 0 !== e) return e.exports;
      var n = i[t] = {
        id: t,
        loaded: !1,
        exports: {}
      };
      return r[t].call(n.exports, n, n.exports, a), n.loaded = !0, n.exports;
    }

    a.c = i, a.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return a.d(e, {
        a: e
      }), e;
    }, a.d = function (t, e) {
      for (var n in e) {
        a.o(e, n) && !a.o(t, n) && Object.defineProperty(t, n, {
          enumerable: !0,
          get: e[n]
        });
      }
    }, a.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), a.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, a.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, a.nmd = function (t) {
      return t.paths = [], t.children || (t.children = []), t;
    };
    var o = a(a.s = 7458).Z;
  }, function (t, e, n) {
    "use strict";

    t.exports = n(9);
  }, function (t, e, n) {
    "use strict";
    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var r = "function" == typeof Symbol && Symbol.for,
        i = r ? Symbol.for("react.element") : 60103,
        a = r ? Symbol.for("react.portal") : 60106,
        o = r ? Symbol.for("react.fragment") : 60107,
        s = r ? Symbol.for("react.strict_mode") : 60108,
        c = r ? Symbol.for("react.profiler") : 60114,
        u = r ? Symbol.for("react.provider") : 60109,
        l = r ? Symbol.for("react.context") : 60110,
        h = r ? Symbol.for("react.async_mode") : 60111,
        f = r ? Symbol.for("react.concurrent_mode") : 60111,
        d = r ? Symbol.for("react.forward_ref") : 60112,
        p = r ? Symbol.for("react.suspense") : 60113,
        y = r ? Symbol.for("react.suspense_list") : 60120,
        g = r ? Symbol.for("react.memo") : 60115,
        m = r ? Symbol.for("react.lazy") : 60116,
        v = r ? Symbol.for("react.block") : 60121,
        b = r ? Symbol.for("react.fundamental") : 60117,
        _ = r ? Symbol.for("react.responder") : 60118,
        x = r ? Symbol.for("react.scope") : 60119;

    function w(t) {
      if ("object" == typeof t && null !== t) {
        var e = t.$$typeof;

        switch (e) {
          case i:
            switch (t = t.type) {
              case h:
              case f:
              case o:
              case c:
              case s:
              case p:
                return t;

              default:
                switch (t = t && t.$$typeof) {
                  case l:
                  case d:
                  case m:
                  case g:
                  case u:
                    return t;

                  default:
                    return e;
                }

            }

          case a:
            return e;
        }
      }
    }

    function k(t) {
      return w(t) === f;
    }

    e.AsyncMode = h, e.ConcurrentMode = f, e.ContextConsumer = l, e.ContextProvider = u, e.Element = i, e.ForwardRef = d, e.Fragment = o, e.Lazy = m, e.Memo = g, e.Portal = a, e.Profiler = c, e.StrictMode = s, e.Suspense = p, e.isAsyncMode = function (t) {
      return k(t) || w(t) === h;
    }, e.isConcurrentMode = k, e.isContextConsumer = function (t) {
      return w(t) === l;
    }, e.isContextProvider = function (t) {
      return w(t) === u;
    }, e.isElement = function (t) {
      return "object" == typeof t && null !== t && t.$$typeof === i;
    }, e.isForwardRef = function (t) {
      return w(t) === d;
    }, e.isFragment = function (t) {
      return w(t) === o;
    }, e.isLazy = function (t) {
      return w(t) === m;
    }, e.isMemo = function (t) {
      return w(t) === g;
    }, e.isPortal = function (t) {
      return w(t) === a;
    }, e.isProfiler = function (t) {
      return w(t) === c;
    }, e.isStrictMode = function (t) {
      return w(t) === s;
    }, e.isSuspense = function (t) {
      return w(t) === p;
    }, e.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === o || t === f || t === c || t === s || t === p || t === y || "object" == typeof t && null !== t && (t.$$typeof === m || t.$$typeof === g || t.$$typeof === u || t.$$typeof === l || t.$$typeof === d || t.$$typeof === b || t.$$typeof === _ || t.$$typeof === x || t.$$typeof === v);
    }, e.typeOf = w;
  }, function (t, e, n) {
    "use strict";

    var r = n(11);

    function i() {}

    function a() {}

    a.resetWarningCache = i, t.exports = function () {
      function t(t, e, n, i, a, o) {
        if (o !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: i
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = {
      currentComponent: null,
      isBatchUpdating: !1,
      isInBrowser: "undefined" != typeof window,
      listeners: new Map(),
      manualListeners: [],
      nextVersionMap: new WeakMap(),
      proxyIsMuted: !1,
      redirectToNext: !0,
      store: {}
    };

    var i = Symbol("PATH"),
        a = Symbol("ORIGINAL"),
        o = "RR_DEBUG",
        s = function s(t) {
      return !!t && "object" == typeof t && t.constructor === Object;
    },
        c = function c(t) {
      return Array.isArray(t);
    },
        u = function u(t) {
      return t instanceof Map;
    },
        l = function l(t) {
      return t instanceof Set;
    },
        h = function h(t) {
      return s(t) || c(t) || u(t) || l(t);
    },
        f = function f(t) {
      return t === i || "constructor" === t || "toJSON" === t || "@@toStringTag" === t || t === Symbol.toStringTag;
    },
        d = function d(t) {
      return "function" == typeof t;
    },
        p = function p(t) {
      return s(t) ? Object.assign({}, t) : c(t) ? t.slice() : u(t) ? new Map(t) : l(t) ? new Set(t) : t;
    },
        y = function y(t, e) {
      return u(t) ? t.get(e) : l(t) ? e : (c(t), t[e]);
    },
        g = function g(t, e, n) {
      if (s(t)) t[e] = n;else if (c(t)) t[e] = n;else if (u(t)) t.set(e, n);else {
        if (!l(t)) throw Error("Unexpected type");
        t.add(n);
      }
    },
        m = function m(t) {
      if (s(t)) return Object.keys(t).length;
      if (c(t)) return t.length;
      if (u(t) || l(t)) return t.size;
      throw Error("Unexpected type");
    },
        v = function v(t, e) {
      var n = [],
          r = function r(t) {
        var i = e(t, n.slice()),
            a = void 0 !== i ? i : t,
            o = function o(t, e) {
          n.push(t);
          var i = r(e);
          n.pop(), g(a, t, i);
        };

        if (s(a)) Object.entries(a).forEach(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
              t = _ref8[0],
              e = _ref8[1];

          o(t, e);
        });else if (c(a) || u(a)) a.forEach(function (t, e) {
          o(e, t);
        });else if (l(a)) {
          var _t15 = Array.from(a);

          a.clear(), _t15.forEach(function (t) {
            o(t, t);
          });
        }
        return a;
      };

      return r(t);
    },
        b = function b(t) {
      r.proxyIsMuted = !0;
      var e = t();
      return r.proxyIsMuted = !1, e;
    },
        _ = function _(t) {
      t.includes(0);
    },
        x = function x(t, e) {
      return t.map(function (t) {
        return t.toString();
      }).join(e);
    },
        w = function w(t) {
      return x(t, ".");
    },
        k = function k(t) {
      return x(t, "~~~");
    },
        T = function T(t, e) {
      var n = t[i] || [];
      return void 0 === e ? n : n.concat(e);
    },
        E = function E(t, e) {
      return w(T(t, e));
    },
        C = function C(t, e) {
      t && Object.defineProperty(t, i, {
        value: e,
        writable: !0
      });
    },
        S = function S(t) {
      return t[i] || [];
    },
        A = "undefined" != typeof window && !!window.localStorage,
        M = function M(t, e) {
      if (A) try {
        var _n7 = "string" == typeof e ? e : JSON.stringify(e);

        return localStorage.setItem(t, _n7);
      } catch (t) {
        return;
      }
    };

    var N = function (t) {
      if (!A) return;
      var e = localStorage.getItem(t);
      if (!e) return e;

      try {
        return JSON.parse(e);
      } catch (t) {
        return e;
      }
    }(o) || "off";

    "on" === N && console.info("Recollect debugging is enabled. Type __RR__.debugOff() to turn it off.");

    var D = function D() {
      N = "on", M(o, "on");
    },
        O = function O() {
      N = "off", M(o, "off");
    },
        B = function B(t) {
      "on" === N && t();
    },
        L = function L(t, e, n) {
      B(function () {
        console.groupCollapsed("GET: " + E(t, e)), console.info("Component: <".concat(r.currentComponent._name, ">")), void 0 !== n && console.info("Value:", n), console.groupEnd();
      });
    },
        I = function I(t, e, n) {
      B(function () {
        console.groupCollapsed("SET: " + E(t, e)), console.info("From:", y(t, e)), console.info("To:  ", n), console.groupEnd();
      });
    },
        R = {},
        P = function P(t) {
      return R.UpdateNextStore(t);
    },
        F = function F(t) {
      r.manualListeners.push(t);
    },
        j = function j(t) {
      if (!r.currentComponent) return;
      var e = k(t),
          n = r.listeners.get(e) || new Set();
      n.add(r.currentComponent), r.listeners.set(e, n);
    },
        Y = function Y(t) {
      return u(t) || l(t) ? {
        get: function get(t, e) {
          if (e === a) return t;
          var n = Reflect.get(t, e);
          if (d(n) && (n = n.bind(t)), r.proxyIsMuted || f(e)) return n;

          if (!r.currentComponent && r.redirectToNext) {
            var _n8 = r.nextVersionMap.get(t);

            if (_n8) return Reflect.get(_n8, e);
          }

          if ("set" === e) {
            return new Proxy(n, {
              apply: function apply(n, r, _ref9) {
                var _ref10 = _slicedToArray(_ref9, 2),
                    i = _ref10[0],
                    a = _ref10[1];

                return r.get(i) === a || P({
                  target: r,
                  prop: i,
                  value: a,
                  updater: function updater(n, r) {
                    return I(t, e, r), Reflect.apply(n[e], n, [i, r]);
                  }
                });
              }
            });
          }

          if ("add" === e) {
            return new Proxy(n, {
              apply: function apply(n, r, _ref11) {
                var _ref12 = _slicedToArray(_ref11, 1),
                    i = _ref12[0];

                return !!r.has(i) || P({
                  target: r,
                  notifyTarget: !0,
                  value: i,
                  updater: function updater(n, r) {
                    return I(t, e, r), Reflect.apply(n[e], n, [r]);
                  }
                });
              }
            });
          }

          if ("clear" === e || "delete" === e) {
            return new Proxy(n, {
              apply: function apply(n, r, _ref13) {
                var _ref14 = _slicedToArray(_ref13, 1),
                    i = _ref14[0];

                return !(!r.size || "delete" === e && !r.has(i)) && P({
                  target: r,
                  notifyTarget: !0,
                  updater: function updater(n) {
                    return I(t, e), Reflect.apply(n[e], n, [i]);
                  }
                });
              }
            });
          }

          if (!r.currentComponent) return n;

          if (u(t) && "get" === e) {
            return new Proxy(n, {
              apply: function apply(e, n, r) {
                return j(T(t, r[0])), Reflect.apply(e, n, r);
              }
            });
          }

          return n;
        }
      } : {
        get: function get(t, e) {
          if (e === a) return t;
          var n = Reflect.get(t, e);
          if (r.proxyIsMuted || f(e)) return n;

          if (function (t, e) {
            return c(t) && ["copyWithin", "fill", "pop", "push", "reverse", "shift", "sort", "splice", "unshift"].includes(e);
          }(t, e)) {
            return new Proxy(n, {
              apply: function apply(n, r, i) {
                return P({
                  target: r,
                  notifyTarget: !0,
                  value: i,
                  updater: function updater(n, r) {
                    I(t, e, r);
                    var i = Reflect.apply(n[e], n, r),
                        a = S(t);
                    return v(n, function (t, e) {
                      h(t) && C(t, [].concat(_toConsumableArray(a), _toConsumableArray(e)));
                    }), i;
                  }
                });
              }
            });
          }

          if (d(t[e])) return n;
          if (r.currentComponent) c(t) && "length" === e || (L(t, e, n), j(T(t, e)));else if (r.redirectToNext) {
            var _n9 = r.nextVersionMap.get(t);

            if (_n9) return Reflect.get(_n9, e);
          }
          return n;
        },
        has: function has(t, e) {
          var n = Reflect.has(t, e);
          if (r.proxyIsMuted || f(e)) return n;
          if (r.currentComponent) c(t) || (L(t, e), j(T(t, e)));else {
            var _n10 = r.nextVersionMap.get(t);

            if (_n10) return Reflect.has(_n10, e);
          }
          return n;
        },
        ownKeys: function ownKeys(t) {
          var e = Reflect.ownKeys(t);
          if (r.proxyIsMuted) return e;
          if (r.currentComponent) L(t), j(S(t));else {
            var _e11 = r.nextVersionMap.get(t);

            if (_e11) return Reflect.ownKeys(_e11);
          }
          return e;
        },
        set: function set(t, e, n) {
          return r.proxyIsMuted ? Reflect.set(t, e, n) : t[e] === n || P({
            target: t,
            prop: e,
            value: n,
            updater: function updater(n, r) {
              return I(t, e, r), Reflect.set(n, e, r);
            }
          });
        },
        deleteProperty: function deleteProperty(t, e) {
          return r.proxyIsMuted ? Reflect.deleteProperty(t, e) : P({
            target: t,
            prop: e,
            notifyTarget: !0,
            updater: function updater(n) {
              return function (t, e) {
                B(function () {
                  console.groupCollapsed("DELETE: " + E(t, e)), console.info("Property: ", E(t, e)), console.groupEnd();
                });
              }(t, e), Reflect.deleteProperty(n, e);
            }
          });
        }
      };
    },
        U = function U(t) {
      return new Proxy(t, Y(t));
    };

    var z = n(3),
        q = n.n(z).a.unstable_batchedUpdates || function (t) {
      t();
    };

    var $ = {
      components: new Map(),
      changedPaths: new Set()
    },
        H = function H() {
      q(function () {
        $.components.forEach(function (t, e) {
          (function (t, e) {
            B(function () {
              console.groupCollapsed("UPDATE:  <".concat(t._name, ">")), console.info("Changed properties:", e), console.groupEnd();
            });
          })(e, Array.from(t)), e.update();
        });
      }), r.manualListeners.forEach(function (t) {
        return t({
          changedProps: Array.from($.changedPaths),
          renderedComponents: Array.from($.components.keys()),
          store: r.store
        });
      }), $.components.clear(), $.changedPaths.clear();
    };

    r.store = U({});
    var W;
    W = function W(_ref15) {
      var t = _ref15.target,
          e = _ref15.prop,
          n = _ref15.value,
          _ref15$notifyTarget = _ref15.notifyTarget,
          i = _ref15$notifyTarget === void 0 ? !1 : _ref15$notifyTarget,
          o = _ref15.updater;
      return b(function () {
        var s;
        var c = S(t),
            u = T(t, e);
        var l = !1;
        var f = m(t);
        var d = n;
        return h(d) && (d = v(n, function (t, e) {
          if (!h(t)) return t;
          var n = p(t);
          return C(n, [].concat(_toConsumableArray(u), _toConsumableArray(e))), U(n);
        })), c.length ? c.reduce(function (e, n, i) {
          var u = y(e, n);
          var h = p(u);
          return C(h, S(u)), h = U(h), g(e, n, h), i === c.length - 1 && (s = o(h, d), l = m(h) !== f, r.nextVersionMap.set(t[a] || t, h)), h;
        }, r.store) : (s = o(r.store, d), l = m(r.store) !== f), function (t) {
          var e = k(t),
              n = w(t);
          $.changedPaths.add(n), r.listeners.forEach(function (t, r) {
            "" !== e && e !== r || t.forEach(function (t) {
              var e = $.components.get(t) || new Set();
              e.add(n), $.components.set(t, e);
            });
          }), r.isBatchUpdating || H();
        }(i || l ? c : u), s;
      });
    }, R.UpdateNextStore = W;

    var V = function V(t) {
      r.isBatchUpdating = !0, t(), r.isBatchUpdating = !1, H();
    },
        G = function G(t) {
      V(function () {
        var e, n;
        e = r.store, (n = t) ? (Object.entries(n).forEach(function (_ref16) {
          var _ref17 = _slicedToArray(_ref16, 2),
              t = _ref17[0],
              n = _ref17[1];

          e[t] !== n && (e[t] = n);
        }), Object.keys(e).forEach(function (t) {
          t in n || delete e[t];
        })) : Object.keys(e).forEach(function (t) {
          delete e[t];
        });
      });
    };

    var X = n(0),
        Z = n.n(X),
        K = n(4),
        Q = n.n(K);

    var J = [],
        tt = function tt() {
      r.isInBrowser && (B(function () {
        console.groupEnd();
      }), J.pop(), r.currentComponent = J[J.length - 1] || null);
    },
        et = function et() {
      return b(function () {
        var t = Object.assign({}, r.store);
        return r.nextVersionMap.set(t, r.store), U(t);
      });
    };

    var nt = function nt(t) {
      var e = t.displayName || t.name || "NamelessComponent";

      var n = /*#__PURE__*/function (_Z$a$PureComponent) {
        _inherits(n, _Z$a$PureComponent);

        var _super2 = _createSuper(n);

        function n() {
          var _this2;

          _classCallCheck(this, n);

          _this2 = _super2.apply(this, arguments), _this2.state = {
            store: et()
          }, _this2._isMounted = !1, _this2._isMounting = !0, _this2._isRendering = !1, _this2._name = e;
          return _this2;
        }

        _createClass(n, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            this._isMounted = !0, this._isMounting = !1, tt(), this._isRendering = !1;
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            tt(), this._isRendering = !1;
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            var t;
            t = this, r.listeners.forEach(function (e, _n11) {
              var i = Array.from(e).filter(function (e) {
                return e !== t;
              });
              i.length ? r.listeners.set(_n11, new Set(i)) : r.listeners.delete(_n11);
            }), this._isMounted = !1;
          }
        }, {
          key: "update",
          value: function update() {
            (this._isMounted || this._isMounting) && this.setState({
              store: et()
            });
          }
        }, {
          key: "render",
          value: function render() {
            var e;
            this._isRendering || (e = this, r.isInBrowser && (B(function () {
              console.groupCollapsed("RENDER: <".concat(e._name, ">"));
            }), r.currentComponent = e, J.push(r.currentComponent)), this._isRendering = !0);

            var _n12 = Object.assign(Object.assign({}, this.props), {
              store: this.state.store
            });

            return Z.a.createElement(t, Object.assign({}, _n12));
          }
        }]);

        return n;
      }(Z.a.PureComponent);

      return n.displayName = "Collected(".concat(e, ")"), Q()(n, t);
    };

    var rt;
    rt = n(5);
    var it = rt;
    n.d(e, "internals", function () {
      return ot;
    }), n.d(e, "store", function () {
      return at;
    }), n.d(e, "useProps", function () {
      return _;
    }), n.d(e, "afterChange", function () {
      return F;
    }), n.d(e, "batch", function () {
      return V;
    }), n.d(e, "initStore", function () {
      return G;
    }), n.d(e, "collect", function () {
      return nt;
    }), n.d(e, "PropTypes", function () {
      return it;
    });
    var at = r.store,
        ot = r;
    "undefined" != typeof window && ("Proxy" in window ? window.__RR__ = {
      debugOn: D,
      debugOff: O,
      internals: r
    } : console.warn("This browser doesn't support the Proxy object, which react-recollect needs. See https://caniuse.com/#search=proxy to find out which browsers do support it"));
  }]);
});